import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import DealEventsSection from '../../components/DealEventsSection';
import { useAuth } from '../AuthContext';
import { MEDIA_ORIGIN } from '../config';
import { RawDataModal, RawDataModalState, formatRawValue } from '../../components/RawDataViewer';
import { LinkEidPanel } from '../../components/LinkEidPanel';
import FieldMappingsAdmin from './FieldMappingsAdmin';
import RmisAtpConsole from './RmisAtpConsole';
import UatConsole from './UatConsole';
import { ATP_SCREENS } from '../../data/rmisAtp';
import {
  createAnimal as createAnimalApi,
  createDeal as createDealApi,
  createFeedOption,
  createFeedConsumption,
  createCourier,
  deleteCourier,
  AnimalLocationEntry,
  fetchDealSlaughterRaw,
  DealSlaughterRawRow,
  AnimalLocationPerformanceGroup,
  MarginSummary,
  AnimalPerformanceRow,
  fetchAnimalPerformanceBreakdown,
  DealAdminOverviewItem,
  deleteAnimalById,
  deleteFeedConsumption,
  deleteFeedOption,
  FeedOption,
  fetchAnimal,
  fetchAnimalEvents,
  fetchAnimalPerformance,
  fetchAnimalWeightHistory,
  fetchAnimalRawRows,
  fetchSessionRawRows,
  eventCurrentSessionId,
  RawDataRowProvenance,
  AnimalEventRow,
  AnimalPerformance,
  AnimalWeightRecord,
  fetchAnimalLocations,
  fetchAnimalLocationPerformance,
  fetchDealDocumentTypeOptions,
  fetchDealsAdminOverview,
  fetchFeedConsumption,
  fetchFeedOptions,
  fetchCouriers,
  fetchDeals,
  fetchTracking,
  fetchDealEvents,
  createDealFeedRecord,
  createSharedFinance,
  fetchSharedFinanceEvents,
  fetchSharedFinances,
  type SharedFinanceEventOption,
  DEAL_FINANCE_TYPES,
  fetchDocumentTypes,
  createDocumentType,
  updateDocumentType,
  deleteDocumentType,
  fetchDealFinances,
  updateDealFinance,
  fetchDealFeedingDeclarations,
  submitTreatmentInvoice,
  fetchTransportDealEventOptions,
  fetchTransportDispatchEventOptions,
  fetchDealEventLabels,
  updateDealEvent,
  createDealEvent,
  SelectOption,
  updateAnimal as updateAnimalApi,
  updateCourier,
  updateDeal as updateDealApi,
  updateFeedOption,
  uploadDealDocument,
  updateFeedConsumption,
  uploadTransportJourney,
  uploadWoolFinance,
  createGs1Code,
  allocateGln,
  allocateGtin,
  createEntity,
  createEntityContact,
  DealDocumentSummary,
  deleteDealById,
  deleteDealDocument,
  EntitySummary,
  VrzProvisionPlan,
  VrzProvisionResult,
  VrzEntityOnboardingProfile,
  VrzOnboardingRequestResult,
  VrzConnectionTestResult,
  deleteEntity,
  deleteEntityContact,
  deleteTransportJourney,
  deleteWoolFinance,
  fetchEntityContacts,
  fetchEntityDocuments,
  uploadEntityDocument,
  deleteEntityDocument,
  type EntityDocumentSummary,
  fetchDealDocumentsForDeal,
  fetchGs1Codes,
  fetchNextEntityNumber,
  fetchEntities,
  fetchVrzProvisionPlan,
  provisionEntityOnVrz,
  fetchEidAssignments,
  EidAssignment,
  fetchVrzEntityOnboardingProfile,
  requestVrzOnboarding,
  testVrzConnection,
  fetchTransportJourneys,
  fetchProductTypeOptions,
  ProductTypeSummary,
  fetchProductTypes,
  createProductType,
  updateProductType,
  deleteProductType,
  fetchWoolFinances,
  TransportJourneySummary,
  DocumentTypeRecord,
  updateDealDocument,
  updateEntity,
  updateEntityContact,
  updateGs1Code as updateGs1CodeApi,
  updateTransportJourney,
  createWeighbridgeRecord,
  updateWeighbridgeRecord,
  fetchWeighbridgeRecords,
  deleteWeighbridgeRecord,
  WeighbridgeRecordSummary,
  WeighbridgeRecordUpsertInput,
  updateWoolFinance,
  WoolFinanceSummary,
  deleteGs1Code as deleteGs1CodeApi,
  GS1CodeSummary,
  GS1CodeUpsertInput,
  fetchAdminUsers,
  createAdminUser,
  adminSendActivation,
  adminSetUserPassword,
  adminUpdateUser,
  UserSummary,
  BreedSummary,
  fetchBreeds,
  createBreed,
  updateBreed,
  deleteBreed,
  ValueChainSummary,
  FieldCatalogueGroup,
  FieldRequirementState,
  fetchFieldCatalogue,
  fetchValueChains,
  fetchValueChainOptions,
  createValueChain,
  updateValueChain,
  deleteValueChain,
  MedicineSummary,
  fetchMedicines,
  createMedicine,
  updateMedicine,
  deleteMedicine,
  EquipmentSummary,
  fetchEquipmentList,
  createEquipment,
  updateEquipment,
  deleteEquipment,
  WoolClassSummary,
  fetchWoolClasses,
  createWoolClass,
  updateWoolClass,
  deleteWoolClass,
  WoolSessionSummary,
  fetchBalingSessions,
  finishBaling,
  fetchBalePrintSheet,
  WoolBalePrintSheet,
  WoolBaleSummary,
  fetchWoolBales,
  createWoolBale,
  updateWoolBale,
  deleteWoolBale,
  createDataSession,
  createDraftDataSession,
  previewDraftDataSession,
  fetchExpectedReceipts,
  receiveFromDispatch,
  previewReceiveFromDispatch,
  type ExpectedReceiptMatch,
  type ReceiveFromDispatchResult,
  type DispatchReceivePreview,
  confirmDraftDataSession,
  VaccinationEntryInput,
  fetchFieldMappingsMeta,
  fetchRmisAtpConfig,
  fetchUatStatus,
  createFieldMapping,
  relinkDataSession,
  fetchUnprocessedRecords,
  fetchUnlinkedAnimals,
  fetchDealAdminReport,
  fetchDealCostReports,
  fetchDataQualitySummary,
  DataQualitySummary,
  fetchAnimalSummary,
  AnimalSummary,
  fetchAnimals,
  fetchSystemStats,
  fetchMarginSummary,
  SystemStats,
  fetchMortalityTimeseries,
  MortalityTimeseries,
  fetchDealHeadcountSummary,
  checkAnimalEids,
  fetchIntegrationSystems,
  updateIntegrationSystem,
  IntegrationSystemInfo,
  IntegrationSystemPatch,
  IntegrationEnvironment,
  fetchAvailabilityForecast,
  AvailabilityForecast,
  fetchProductionSchedules,
  createProductionSchedule,
  updateProductionSchedule,
  ProductionScheduleTemplate,
  ProductionScheduleUpsertInput,
  fetchWooliesRegistrationNotifications,
  WooliesRegistrationNotifications,
  fetchWooliesStageForecast,
  WooliesStageForecast,
  fetchAbattoirReceipts,
  AbattoirReceiptsResponse,
  AbattoirReceipt,
  markBatchSlaughtered,
  applyBatchLiveMass,
  fetchDocuments,
  DocumentIndexRow,
  DocumentSource,

  fetchDealById,
  fetchDealDocumentRequirements,
  DealDocumentRequirement,
  createDealFinance,
  applyDealPurchasePrices,
  deleteDealMedication,
  captureDealMedication,
  createDealFeedingDeclaration,
  deleteDealFeedingDeclaration,
  replayDealMedication,
  LISTED_DISEASES,
  FEEDING_SYSTEMS,
  ANIMAL_BY_PRODUCTS,} from '../../data/api';
import SearchSelect, { SearchSelectOption } from '../../components/SearchSelect';
import FileDropzone from '../../components/FileDropzone';
import SearchOrType, { type SearchOrTypeOption } from '../../components/SearchOrType';
import { useConfirm, type ConfirmIntent } from '../../components/ConfirmDialog';
import { CostModelView } from '../../components/DealCostModel';
import CostLineItems, { costLineIsComplete, costLinesTotal, newCostLine, splitByHead } from '../../components/CostAllocationPicker';
import type { CostLine } from '../../components/CostAllocationPicker';
import DealOverview from '../../components/DealOverview';
import DealNeedsReview from '../../components/DealNeedsReview';
import SharedFeedlotCosts from '../../components/SharedFeedlotCosts';

function escapeHtml(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function buildBaleSheetHtml(sheet: WoolBalePrintSheet): string {
  const g = sheet.general || {};
  const t = sheet.traceability || {};
  const totals = sheet.totals || { gross_weight: 0, net_weight: 0, bale_count: 0 };
  const genRow = (label: string, value?: string) =>
    `<tr><td class="lbl">${escapeHtml(label)}</td><td>${escapeHtml(value || '—')}</td></tr>`;
  const baleRows = (sheet.bales || []).map((b) => `
    <tr>
      <td class="mono">${escapeHtml(b.bale_number)}</td>
      <td class="num">${b.gross_weight != null ? escapeHtml(b.gross_weight) : '—'}</td>
      <td class="num">${b.net_weight != null ? escapeHtml(b.net_weight) : '—'}</td>
      <td>${escapeHtml(b.wool_class_code || '')}</td>
      <td>${escapeHtml(b.wool_breed || '')}</td>
      <td class="qr"><img src="${b.qr_png_data_uri}" alt="${escapeHtml(b.bale_number)}" width="72" height="72"/></td>
    </tr>`).join('');
  return `
  <style>
    .sheet { font-family: Arial, Helvetica, sans-serif; color: #1a1a1a; padding: 22px 26px; }
    .sheet h1 { font-size: 17px; margin: 0 0 4px; }
    .sheet .sub { font-size: 12px; color: #666; margin: 0 0 16px; }
    .sheet .section-title { font-size: 11px; text-transform: uppercase; letter-spacing: .05em; color: #555; margin: 14px 0 6px; }
    .sheet table { width: 100%; border-collapse: collapse; font-size: 12.5px; }
    .sheet .meta td { padding: 3px 0; }
    .sheet .meta td.lbl { color: #666; width: 42%; }
    .sheet .bales th, .sheet .bales td { border-bottom: .5px solid #d9d9d9; padding: 8px 6px; text-align: left; }
    .sheet .bales th { color: #555; font-weight: 600; font-size: 11px; text-transform: uppercase; }
    .sheet .bales td.num, .sheet .bales th.num { text-align: right; }
    .sheet .bales td.qr, .sheet .bales th.qr { text-align: center; width: 84px; }
    .sheet .bales .mono { font-family: 'Courier New', monospace; }
    .sheet .totals td { padding: 8px 6px; font-weight: 600; }
    .sheet .note { font-size: 11px; color: #777; border-top: .5px solid #d9d9d9; padding-top: 8px; margin-top: 12px; line-height: 1.5; }
  </style>
  <div class="sheet">
    <h1>Wool production data capture</h1>
    <p class="sub">Shearing session${sheet.deal_no ? ` · Deal ${escapeHtml(sheet.deal_no)}` : ''}</p>
    <div class="section-title">General data</div>
    <table class="meta">
      ${genRow('Organisation name', g.organization_name)}
      ${genRow('Organisation GLN', g.organization_gln)}
      ${genRow('Wool GTIN', g.wool_gtin)}
      ${genRow('RWS compliance', g.rws_compliance)}
    </table>
    <div class="section-title">Traceability data</div>
    <table class="meta">
      ${genRow('Shearing session number', t.session_reference)}
      ${genRow('Start date', t.start_date || undefined)}
      ${genRow('End date', t.end_date || undefined)}
    </table>
    <div class="section-title">Wool bales produced in this session</div>
    <table class="bales">
      <thead>
        <tr>
          <th>Bale batch no</th><th class="num">Gross (kg)</th><th class="num">Net (kg)</th>
          <th>Class</th><th>Breed</th><th class="qr">QR</th>
        </tr>
      </thead>
      <tbody>
        ${baleRows || '<tr><td colspan="6">No bales.</td></tr>'}
        <tr class="totals">
          <td>Total · ${escapeHtml(totals.bale_count)} bales</td>
          <td class="num">${escapeHtml(Number(totals.gross_weight).toFixed(2))}</td>
          <td class="num">${escapeHtml(Number(totals.net_weight).toFixed(2))}</td>
          <td></td><td></td><td></td>
        </tr>
      </tbody>
    </table>
    <p class="note">Net weight = gross weight minus the wool bag and metal clips. Each bale's QR code returns its unique bale batch number when scanned.</p>
  </div>`;
}

function printBaleSheetHtml(sheet: WoolBalePrintSheet): void {
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Bale sheet</title></head><body>${buildBaleSheetHtml(sheet)}</body></html>`;
  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);
  const doc = iframe.contentWindow?.document;
  if (!doc) { if (iframe.parentNode) iframe.parentNode.removeChild(iframe); return; }
  doc.open();
  doc.write(html);
  doc.close();
  setTimeout(() => {
    try {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
    } finally {
      setTimeout(() => { if (iframe.parentNode) iframe.parentNode.removeChild(iframe); }, 1000);
    }
  }, 300);
}

// Species the operations dashboard can be scoped to. One dashboard per species
// (goats are intentionally excluded — the client only asked for sheep + cattle).
type DashboardSpecies = 'SHEEP' | 'CATTLE';
const DASHBOARD_SPECIES_LABEL: Record<DashboardSpecies, string> = { SHEEP: 'Sheep', CATTLE: 'Cattle' };
// The dashboard filter bar. Species can be widened to everything; the Supply
// Chain Program filter is 'ALL', the Deal Matrix sentinel, or one chain's id.
type DashboardSpeciesFilter = 'ALL' | DashboardSpecies;
const DASHBOARD_SCP_ALL = 'ALL';
const DASHBOARD_SCP_MATRIX = '__matrix__';

// Shared red/white styling for every destructive (delete/remove) action across
// the admin UI. Pair with requestConfirm() so each one gets a confirm modal.
const DELETE_BTN = 'inline-flex items-center justify-center rounded-lg bg-[#c0392b] px-3 py-1.5 text-sm font-semibold text-white transition hover:bg-[#a93226] disabled:opacity-50';

/**
 * Button labels for the Supply Chain Program field matrix.
 *
 * "Not captured" rather than "Hidden": the operator is deciding what the
 * program collects, and "hidden" reads as a display toggle over data that is
 * still being asked for.
 */
const VC_STATE_LABELS: Record<FieldRequirementState, string> = {
  REQUIRED: 'Required',
  OPTIONAL: 'Optional',
  HIDDEN: 'Not captured',
};

// Capture form for creating a NEW entity inline on the new-deal flow's
// parties step. Selected entities are display-only there (edited on the
// entity screen); this form exists so a brand-new seller/purchaser can be
// captured with its address and contact without leaving the flow.
// NOTE (future): when per-SCP required-field configuration lands on the Supply
// Chain Programs screen, which of these are *required* should come from the
// chosen chain instead of being fixed here.
const BLANK_ND_PARTY_FORM = {
  entityType: 'FARM',
  entityTypeOther: '',
  partyKind: '' as '' | 'INDIVIDUAL' | 'ENTITY',
  entityName: '',
  identityNumber: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  postalCode: '',
  farmName: '',
  district: '',
  province: '',
  vatRegistered: false,
  vatNumber: '',
  glnApplicable: false,
  contactName: '',
  contactCell: '',
  contactEmail: '',
};
type NdPartyForm = typeof BLANK_ND_PARTY_FORM;

type AdminView = 'dashboard' | 'dealList' | 'dealSummary' | 'dealCreate' | 'documentsList' | 'documentUpload' | 'documentSearch' | 'feedCrud' | 'animalList' | 'animalCrud' | 'animalRegister' | 'gs1Gln' | 'gs1Gtin' | 'entityCrud' | 'entityForm' | 'entityContacts' | 'entityContactForm' | 'userManagement' | 'breedCrud' | 'medicineCrud' | 'equipmentAllocation' | 'woolClassCrud' | 'woolBales' | 'dataSessionUpload' | 'eventHistory' | 'unprocessedRecords' | 'unlinkedAnimals' | 'needsReview' | 'transportJourneys' | 'journeyHistory' | 'courierManagement' | 'weighbridgeHistory' | 'weighbridgeNew' | 'costReports' | 'scpAnalysis' | 'performanceReport' | 'availabilityForecast' | 'wooliesStageForecast' | 'productionSchedules' | 'valueChainCrud' | 'productTypeCrud' | 'documentTypeCrud' | 'integrations' | 'fieldMappings' | 'rmisAtpConnect' | 'rmisAtp81' | 'rmisAtp82' | 'rmisAtp83' | 'rmisAtp84' | 'rmisAtp85' | 'rmisAtp86' | 'rmisAtp87' | 'rmisAtp88' | 'rmisAtp89' | 'abattoirSlaughter' | 'sharedCosts' | 'addFeed' | 'addWool' | 'uatConsole';

interface Deal {
  dealId: string;
  title: string;
  dealRefNo?: string;
  counterpart: string;
  primaryProducerId?: string;
  startDate?: string;
  headcount: number;
  status: 'Active' | 'Completed' | 'Cancelled';
  completedUnderOverride?: boolean;
  species?: string | null;
  registrationTotalAnimals?: number;
  registrationAnimalsWithEid?: number;
  registrationAnimalsWithoutEid?: number;
  // Supply Chain Program membership, for the dashboard filter bar. A deal
  // with isScpDeal false sits in the Deal Matrix.
  isScpDeal?: boolean;
  scpName?: string | null;
  valueChainId?: string;
}

interface FeedRecord {
  id: string;
  dealId: string;
  feedId: string;
  feedType: string;
  quantityKg: number;
  date: string;
}

interface AnimalRecord {
  id: string;
  dealId: string;
  species: 'SHEEP' | 'GOAT' | 'CATTLE';
  tag: string;
  eid: string;
  location: string;
  gln: string;
  status: string;
  breed: string;
  dob: string;
  sex: string;
}

interface UploadedDocumentRecord {
  id: string;
  dealId: string;
  dealTitle: string;
  category: string;
  fileName: string;
  documentType: string;
  systemCode?: string;
  referenceNumber?: string;
  dateOfDocument: string;
}

interface CourierOption {
  id: string;
  name: string;
  contactNumber?: string;
  email?: string;
  active?: boolean;
}

interface EntityProfile {
  id: string;
  label: string;
  farmerName: string;
  addressLine1: string;
  addressLine2: string;
  latitude: string;
  longitude: string;
  contacts: Array<{ id: string; userId?: string; username?: string; name: string; email?: string; phoneNo?: string; isPrimary?: boolean }>;
}

type UploadMode = 'Deal' | 'Transport' | 'Wool' | 'GS1';

interface TrackingAnimal {
  animalId?: string;
  eid?: string;
  visualTag?: string;
  healthStatus?: string;
  currentLocation?: {
    name?: string;
    type?: string;
  };
}

type AnimalStatus = 'ACTIVE' | 'SOLD' | 'DECEASED';

const uid = () => `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;


const DOCUMENT_TYPE_OPTIONS = [
  { value: 'transport_waybill', label: 'Transport waybill', category: 'Transport' },
  { value: 'transport_invoice', label: 'Transport invoice', category: 'Transport' },
  { value: 'wool_sale', label: 'Wool sale document', category: 'Wool' },
  { value: 'wool_analysis', label: 'Wool analysis document', category: 'Wool' },
  { value: 'other', label: 'Other document', category: 'Wool' },
];

const COMMON_LOCATION_OPTIONS = ['Farm', 'Feedlot', 'Abattoir', 'In Transit', 'Unknown location'];

// Which value-chain leg an in-transit animal is travelling, decided by where it
// is HEADING (destination) rather than where it left (source). A farm→abattoir
// direct dispatch therefore sits on the abattoir-inbound leg, not farm→feedlot.
// Used for both the value-chain tile counts and the register drill-down filter,
// so the two always agree. Falls back to the source stage when the destination
// wasn't captured.
type InTransitLeg = 'TO_FEEDLOT' | 'TO_ABATTOIR';
const inTransitLeg = (loc: any): InTransitLeg => {
  const destination = (loc?.destination_entity_type || '').toUpperCase();
  const source = (loc?.source_entity_type || '').toUpperCase();
  if (destination === 'ABATTOIR') return 'TO_ABATTOIR';
  if (destination === 'FEEDLOT') return 'TO_FEEDLOT';
  if (source === 'FEEDLOT') return 'TO_ABATTOIR';
  return 'TO_FEEDLOT';
};

// '' means the question was not answered and must be sent as null — sending
// false would record a denial the seller never made.
const toTriState = (value: unknown): '' | 'yes' | 'no' => (value === true ? 'yes' : value === false ? 'no' : '');
const fromTriState = (value: '' | 'yes' | 'no'): boolean | null =>
  value === 'yes' ? true : value === 'no' ? false : null;

const SA_PROVINCES = [
  'Eastern Cape',
  'Free State',
  'Gauteng',
  'KwaZulu-Natal',
  'Limpopo',
  'Mpumalanga',
  'North West',
  'Northern Cape',
  'Western Cape',
];

const blankEntityForm = () => ({
  entityName: '',
  registeredBusinessName: '',
  vatNumber: '',
  // Deal-capture party detail (spec §Seller / §Purchaser). partyKind drives
  // which identity document the deal's completeness gate will require.
  partyKind: '' as '' | 'INDIVIDUAL' | 'ENTITY',
  identityNumber: '',
  entityTypeOther: '',
  farmName: '',
  district: '',
  province: '',
  vatRegistered: false,
  glnApplicable: false,
  entityNo: '',
  entityType: 'FARM',
  valueChainId: '',
  wooliesProducer: false,
  costPerDay: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  postalCode: '',
  country: '',
  latitude: '',
  longitude: '',
});

const fmtDate = (value?: string) => {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleDateString('en-ZA');
};

const EVENT_TYPE_LABELS: Record<string, string> = {
  FARM_DIS: 'Farm dispatch',
  FARM_REC: 'Farm receive',
  FEED_DIS: 'Feedlot dispatch',
  FEED_REC: 'Feedlot receive',
  ABAT_REC: 'Abattoir receive',
  FARM_BIR: 'Farm birth',
  FARM_REG: 'Farm registration',
  FEED_REG: 'Feedlot registration',
  ABAT_REG: 'Abattoir registration',
  FARM_SHE: 'Farm shear',
  FEED_SHE: 'Feedlot shear',
  FARM_MOR: 'Farm mortality',
  FEED_MOR: 'Feedlot mortality',
  ABAT_MOR: 'Abattoir mortality',
  FARM_WEI: 'Farm weigh',
  FEED_WEI: 'Feedlot weigh',
  ABAT_SLA: 'Abattoir slaughter',
  FEED_WOO: 'Wool batch',
  FARM_BAL: 'Farm bale',
  FEED_BAL: 'Feedlot bale',
  ABAT_DIS: 'Abattoir dispatch',
  VACCINATION: 'Vaccination',
  FEED_VAC: 'Feedlot vaccination',
  WOOL_ANA: 'Wool analysis',
};

// Each WeightHistory record carries its own `weight_type` (see the backend
// `WEIGHT_TYPE_BY_EVENT_TYPE` map in ingest/services.py). We reverse-map it to
// the originating event type so the weight chart reuses EVENT_TYPE_LABELS and
// stays consistent with the event-history table — and, crucially, so every
// point is labelled from its OWN type rather than by matching events on the
// same calendar date (which collapsed to one label when two events shared a
// day, e.g. farm registration + dispatch, or feedlot dispatch + abattoir
// receive).
const WEIGHT_TYPE_TO_EVENT_TYPE: Record<string, string> = {
  FARM_REGISTRATION: 'FARM_REG',
  FARM_BIRTH: 'FARM_BIR',
  FARM_RECEIVE: 'FARM_REC',
  FARM_DISPATCH: 'FARM_DIS',
  FARM_MORTALITY: 'FARM_MOR',
  FEEDLOT_REGISTRATION: 'FEED_REG',
  FEEDLOT_RECEIVE: 'FEED_REC',
  FEEDLOT_DISPATCH: 'FEED_DIS',
  FEEDLOT_MORTALITY: 'FEED_MOR',
  ABATTOIR_REGISTRATION: 'ABAT_REG',
  ABATTOIR_RECEIVE: 'ABAT_REC',
  LAST_LIVE: 'ABAT_SLA',
  BIRTH: 'FARM_BIR',
};
// Weight types with no 1:1 event type (CURRENT is deliberately handled
// separately — it comes from both FARM_WEI and FEED_WEI, so it can only be
// disambiguated by the same-day event).
const WEIGHT_TYPE_LABELS: Record<string, string> = {
  WEANING: 'Weaning',
  CURRENT: 'Weigh',
  COLD: 'Cold weight',
  CARCASS: 'Carcass weight',
};

// Canonical value-chain order for events/weights that fall on the SAME date:
// farm → feedlot → abattoir, and within each stage the natural lifecycle
// (registration/birth → receive → weigh/shear/vaccination → mortality →
// dispatch). Used as the tiebreak after date so, e.g., a farm registration,
// farm dispatch and feedlot receive all captured on one day sort in that order
// instead of by insertion order.
const VALUE_CHAIN_EVENT_ORDER = [
  'FARM_REG', 'FARM_BIR', 'FARM_REC', 'FARM_WEI', 'FARM_SHE', 'FARM_VAC', 'FARM_MOR', 'FARM_DIS', 'FARM_BAL',
  'FEED_REG', 'FEED_REC', 'FEED_WEI', 'FEED_SHE', 'FEED_VAC', 'VACCINATION', 'FEED_WOO', 'WOOL_ANA', 'FEED_MOR', 'FEED_DIS', 'FEED_BAL',
  'ABAT_REG', 'ABAT_REC', 'ABAT_MOR', 'ABAT_SLA',
];
const valueChainEventRank = (eventType?: string | null): number => {
  const i = VALUE_CHAIN_EVENT_ORDER.indexOf(String(eventType || '').toUpperCase());
  return i === -1 ? VALUE_CHAIN_EVENT_ORDER.length : i;
};
// Rank a weight record along the same value chain, via its weight_type. CURRENT
// (a generic weigh) sits in the feedlot band; COLD/CARCASS are post-slaughter.
const weightRecordRank = (weightType?: string): number => {
  const wt = String(weightType || '').toUpperCase();
  if (wt === 'CURRENT') return valueChainEventRank('FEED_WEI');
  if (wt === 'COLD' || wt === 'CARCASS') return valueChainEventRank('ABAT_SLA');
  const ev = WEIGHT_TYPE_TO_EVENT_TYPE[wt];
  return ev ? valueChainEventRank(ev) : VALUE_CHAIN_EVENT_ORDER.length;
};

const DATA_SESSION_REGISTRATION_EVENT_TYPES = ['FARM_REG', 'FEED_REG', 'ABAT_REG'];
// Event types whose upload must name a deal. Mirrors the backend's
// DEAL_REQUIRED_EVENT_TYPES (ingest/views.py) — registration, receive and
// slaughter. Each of these can create an Animal the system has not seen before
// (an EID that first appears at the gate or on the kill floor), and with no
// deal on the session that animal is created attached to nothing: absent from
// the deal's headcount with nothing on screen to say it exists.
const DATA_SESSION_DEAL_REQUIRED_EVENT_TYPES = [
  'FARM_BIR', 'FARM_REG', 'FEED_REG', 'ABAT_REG',
  'FARM_REC', 'FEED_REC', 'ABAT_REC',
  'ABAT_SLA',
];
const VACCINATION_EVENT_TYPES = ['VACCINATION', 'FEED_VAC'];

// Columns recognised as vaccination data in the per-row ("long"/health-log)
// layout — a single medicine-name column plus flat detail columns. Mirrors the
// backend's VACCINATION_MEDICINE_COLUMN_NAMES / VACCINATION_ROW_DETAIL_COLUMNS
// so these columns show "vaccination ✓" instead of an unrecognised-field
// dropdown. Compared after normVaxHeader() (BOM-strip, lower, collapse spaces).
const PER_ROW_VACCINATION_COLUMN_NAMES = new Set([
  'vaccine / medicine', 'vaccine/medicine', 'vaccine or medicine',
  'medicine', 'medicine name', 'vaccine', 'vaccine name', 'product', 'remedy', 'treatment',
  'dosage (ml)', 'dosage(ml)', 'dosage ml', 'dosage', 'dose (ml)', 'dose ml', 'dose',
  'batch number', 'batch no', 'batch no.', 'batch_number', 'batch',
  'cost', 'cost (r)', 'against', 'condition', 'ailment',
  'remark', 'remarks', 'note', 'notes', 'comment', 'comments',
]);
const normVaxHeader = (s: string) => s.replace(/^\uFEFF/, '').trim().toLowerCase().replace(/\s+/g, ' ');

// Basic event categories the "New Event" form offers. The concrete
// entity_event_type_code is derived from the governing entity's type (see
// resolveEventTypeCode) — mirrors the backend ingest.services resolver so the
// existing upload endpoints keep receiving a concrete event_type.
const EVENT_CATEGORY_OPTIONS: {
  value: string; label: string; isMovement: boolean; needsDeal: boolean; needsSpecies: boolean;
}[] = [
  { value: 'REGISTER', label: 'Register', isMovement: false, needsDeal: true, needsSpecies: true },
  { value: 'RECEIVE', label: 'Receive', isMovement: true, needsDeal: false, needsSpecies: false },
  { value: 'WEIGH', label: 'Weigh', isMovement: false, needsDeal: false, needsSpecies: false },
  { value: 'VACCINATE', label: 'Vaccinate', isMovement: false, needsDeal: false, needsSpecies: false },
  { value: 'SHEAR', label: 'Shear', isMovement: false, needsDeal: false, needsSpecies: false },
  { value: 'DISPATCH', label: 'Dispatch', isMovement: true, needsDeal: false, needsSpecies: false },
  { value: 'SLAUGHTER', label: 'Slaughter', isMovement: false, needsDeal: false, needsSpecies: false },
  { value: 'MORTALITY', label: 'Mortality', isMovement: false, needsDeal: false, needsSpecies: false },
];
const EVENT_CATEGORY_META = Object.fromEntries(EVENT_CATEGORY_OPTIONS.map((c) => [c.value, c]));

// The stable compliance codes a document type may carry (core.models
// ComplianceDocument). A blank code is an ordinary filing type. Each code may
// belong to exactly one type -- the backend enforces it.
const DOCUMENT_TYPE_CODES: { value: string; label: string }[] = [
  { value: '', label: '— none (ordinary filing type) —' },
  { value: 'ID_COPY', label: 'ID copy (individual)' },
  { value: 'CIPC', label: 'CIPC registration document (entity)' },
  { value: 'VAT_CERT', label: 'VAT registration certificate' },
  { value: 'BANK_LETTER', label: 'Bank confirmation letter' },
  { value: 'GLN_CERT', label: 'GLN certificate' },
  { value: 'PURCHASER_DOCS', label: 'Purchaser-required documents' },
  { value: 'WEIGHT_RECEIPT', label: 'Weight receipt' },
  { value: 'TRACEABILITY', label: 'Traceability documentation' },
  { value: 'CLINICAL_REPORT', label: 'Clinical examinations report' },
  { value: 'REMOVAL_CERT', label: 'Removal certificate' },
  { value: 'INVOICE', label: 'Invoice' },
  { value: 'DECL_EVIDENCE', label: 'Declaration evidence' },
];

// Title and hint of the event-capture modal, by the event code it was opened
// with. Anything not listed falls back to DEFAULT with the code spelled out.
const ND_EVENT_KIND_COPY: Record<string, { title: string; hint: string }> = {
  FARM_REG: { title: 'Capture registration event', hint: "Preset to this deal, Farm → Registration. Confirm the upload — the animal numbers update from the file's sex column." },
  FARM_REC: { title: 'Capture receive event', hint: 'Preset to this deal, Farm → Receive — switch the location/event inside if the animals were received at a feedlot or abattoir. A journey attaches to this event.' },
  FEED_REC: { title: 'Capture feedlot receive', hint: 'Preset to this deal, Feedlot → Receive. If a dispatch for this deal is still in transit, the expected-receipts panel inside can accept it without a file.' },
  ABAT_REC: { title: 'Capture abattoir receive', hint: 'Preset to this deal, Abattoir → Receive. Accept the in-transit dispatch from the expected-receipts panel, or upload the abattoir\'s receive file.' },
  FARM_DIS: { title: 'Capture farm dispatch', hint: 'Preset to this deal, Farm → Dispatch. Upload the load\'s EID list; the animals go in transit until they are received.' },
  FEED_DIS: { title: 'Capture feedlot dispatch', hint: 'Preset to this deal, Feedlot → Dispatch. Upload the load\'s EID list; the animals go in transit until the abattoir receives them.' },
  ABAT_SLA: { title: 'Capture slaughter', hint: 'Preset to this deal, Abattoir → Slaughter. Upload the abattoir\'s slaughter file; you can add the sale invoice straight afterwards.' },
  FARM_SHE: { title: 'Capture farm shearing', hint: 'Preset to this deal, Farm → Shear. Upload the shearing session; baling follows from the outcome.' },
  FEED_SHE: { title: 'Capture feedlot shearing', hint: 'Preset to this deal, Feedlot → Shear. Upload the shearing session; baling follows from the outcome.' },
  VACCINATION: { title: 'Capture medicine / vaccination event', hint: 'Preset to this deal, Vaccination. Upload a data file naming which medicines were administered to which animals — each animal gets its own treatment record.' },
  FEED_VAC: { title: 'Capture feedlot vaccination', hint: 'Preset to this deal, Feedlot → Vaccination. Upload the treatment file; tick Antibiotic per medicine on the confirm step.' },
  ANY: { title: 'Create other event', hint: 'Preset to this deal and to where its animals are now. Pick the location and event type inside — shearing, weigh, wool batch, mortality, slaughter — then upload the data file.' },
  DEFAULT: { title: 'Capture event', hint: 'Preset to this deal. Pick the location and event type inside if they need changing, then upload the data file.' },
};

const EVENT_ENTITY_PREFIX: Record<string, string> = { FARM: 'FARM', FEEDLOT: 'FEED', ABATTOIR: 'ABAT', WOOL_PROCESSOR: 'WOOL' };
const EVENT_CATEGORY_SUFFIX: Record<string, string> = {
  REGISTER: 'REG', RECEIVE: 'REC', WEIGH: 'WEI', VACCINATE: 'VAC', SHEAR: 'SHE', DISPATCH: 'DIS', SLAUGHTER: 'SLA', MORTALITY: 'MOR',
};
// Concrete codes the backend actually records (ENTITY_EVENT_TYPE_DEFINITIONS keys).
const VALID_ENTITY_EVENT_CODES = new Set([
  'FARM_REG', 'FARM_REC', 'FARM_BIR', 'FARM_DIS', 'FARM_MOR', 'FARM_WEI', 'FARM_SHE', 'FARM_BAL',
  'FEED_REG', 'FEED_REC', 'FEED_DIS', 'FEED_MOR', 'FEED_WEI', 'FEED_SHE', 'FEED_WOO', 'FEED_BAL', 'FEED_VAC',
  'ABAT_REG', 'ABAT_REC', 'ABAT_DIS', 'ABAT_MOR', 'ABAT_SLA', 'WOOL_ANA', 'VACCINATION',
]);

// Derive the concrete event_type from a category + the governing entity's type.
// Governing entity = destination for receive/non-movement, source for dispatch.
function resolveEventTypeCode(category: string, entityType?: string | null): { code: string; error: string } {
  if (!category) return { code: '', error: '' };
  const prefix = EVENT_ENTITY_PREFIX[String(entityType || '').toUpperCase()];
  if (!prefix) return { code: '', error: '' }; // entity not chosen yet — no error, just no code
  const code = `${prefix}_${EVENT_CATEGORY_SUFFIX[category]}`;
  if (VALID_ENTITY_EVENT_CODES.has(code)) return { code, error: '' };
  if (category === 'VACCINATE') return { code: 'VACCINATION', error: '' };
  const catLabel = EVENT_CATEGORY_META[category]?.label || category;
  const entLabel = String(entityType || '').replace(/_/g, ' ').toLowerCase();
  return { code: '', error: `${catLabel} is not a recorded event for a ${entLabel}.` };
}

interface VaccinationEntryRow {
  medicineName: string;
  // Per-medicine: remembered on the catalogue product and mirrored to the
  // deal's health declaration ("treated with antibiotics").
  isAntibiotic: boolean;
  dosage: string;
  batchNumber: string;
  cost: string;
  // Carried through silently when pre-populated from the upload file's own
  // vaccination columns; not shown as inputs on the vaccination-details step
  // (which only surfaces medicine/dosage/cost/batch), but still sent through
  // to confirm so real parsed dates aren't lost.
  batchExpiryDate: string;
  withholdingEndDate: string;
  esiDate: string;
}

function blankVaccinationEntryRow(): VaccinationEntryRow {
  return { medicineName: '', isAntibiotic: false, dosage: '', batchNumber: '', cost: '', batchExpiryDate: '', withholdingEndDate: '', esiDate: '' };
}

// Fast-tracks the vaccination-details step: when the uploaded file already
// has grouped vaccination columns (per-row, per medicine), aggregate them
// into one editable row per distinct medicine so the admin reviews/edits
// rather than re-typing everything the file already told us.
function aggregateVaccinationEntriesFromPreview(previewRows: any[]): VaccinationEntryRow[] {
  const byMedicine = new Map<string, VaccinationEntryRow>();
  for (const row of previewRows || []) {
    for (const v of row?.vaccinations ?? []) {
      const name = String(v?.medicine_name || '').trim();
      if (!name) continue;
      const entry = byMedicine.get(name) || { ...blankVaccinationEntryRow(), medicineName: name };
      if (v.dosage && v.dosage !== '-') entry.dosage = String(v.dosage);
      if (v.batch && v.batch !== '-') entry.batchNumber = String(v.batch);
      if (v.cost != null) entry.cost = String(v.cost);
      if (v.batch_expiry_date) entry.batchExpiryDate = String(v.batch_expiry_date);
      if (v.whp_date) entry.withholdingEndDate = String(v.whp_date);
      if (v.esi_date) entry.esiDate = String(v.esi_date);
      if (v.is_antibiotic === true) entry.isAntibiotic = true;
      byMedicine.set(name, entry);
    }
  }
  return Array.from(byMedicine.values());
}

const RMIS_BADGE: Record<string, { label: string; cls: string }> = {
  SENT:    { label: 'Synced', cls: 'bg-[#e7f8ee] text-[#106b38] border-[#b9e7c9]' },
  FAILED:  { label: 'Failed', cls: 'bg-[#f8eae7] text-[#6b1010] border-[#e7bbb9]' },
  SKIPPED: { label: 'Skipped', cls: 'bg-[#fff7ef] text-[#7b4a18] border-[#ecd1b9]' },
  PENDING: { label: 'Pending', cls: 'bg-[#e8f4ff] text-[#0f3b64] border-[#1e6bb833]' },
};

const VIRTUAL_ROUTEZ_BADGE: Record<string, { label: string; cls: string }> = {
  SUCCESS: { label: 'Success', cls: 'bg-[#e7f8ee] text-[#106b38] border-[#b9e7c9]' },
  FAILED:  { label: 'Failed', cls: 'bg-[#f8eae7] text-[#6b1010] border-[#e7bbb9]' },
  TIMEOUT: { label: 'Timeout', cls: 'bg-[#fff7ef] text-[#7b4a18] border-[#ecd1b9]' },
  PENDING: { label: 'Pending', cls: 'bg-[#e8f4ff] text-[#0f3b64] border-[#1e6bb833]' },
};

const DATA_QUALITY_BADGE: Record<string, { label: string; cls: string }> = {
  EXCELLENT: { label: 'Excellent', cls: 'bg-[#e7f8ee] text-[#106b38] border-[#b9e7c9]' },
  GOOD:      { label: 'Good', cls: 'bg-[#e7f8ee] text-[#106b38] border-[#b9e7c9]' },
  FAIR:      { label: 'Fair', cls: 'bg-[#fff7ef] text-[#7b4a18] border-[#ecd1b9]' },
  POOR:      { label: 'Poor', cls: 'bg-[#f8eae7] text-[#6b1010] border-[#e7bbb9]' },
};

const eventTimestamp = (evt: any) => Date.parse(evt?.event_date || evt?.created_at || evt?.updated_at || '') || 0;

const fmtNum = (value: number) => new Intl.NumberFormat('en-ZA').format(Number(value || 0));
/** Parse a typed rand/kg figure the way people type it: "7 180,02", "7,180.02", "R 57 618.30" all read as numbers; blank or junk reads as 0. */
const parseTypedNumber = (raw: string): number => {
  const t = String(raw || '').replace(/[Rr\s]/g, '');
  if (!t) return 0;
  const normalised = t.includes('.') ? t.replace(/,/g, '') : t.replace(',', '.');
  const n = Number(normalised);
  return Number.isFinite(n) ? n : 0;
};
// Whole rand for the dashboard's margin card: the tiles are read at a glance,
// the cents live on the deal's Margin model tab.
const fmtRand = (value: number | null | undefined) =>
  value === null || value === undefined || !Number.isFinite(value)
    ? '—'
    : new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR', maximumFractionDigits: 0 }).format(value);
const fmtDecimal = (value: number | null | undefined, digits: number) =>
  value === null || value === undefined || !Number.isFinite(value) ? '—' : value.toFixed(digits);

const normalizeDocumentUrl = (url?: string) => {
  if (!url) return '';
  if (url.startsWith('https://storage.googleapis.com/')) {
    return url.replace(/https:\/\/storage\.googleapis\.com\/[^\/]+\/media\//, `${MEDIA_ORIGIN}/media/`);
  }
  if (!url.startsWith('http')) {
    return `${MEDIA_ORIGIN}${url}`;
  }
  return url;
};

const NAV_ICONS: Record<string, React.ReactNode> = {
  Overview: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <rect x="1" y="9" width="3" height="6" rx="0.5" opacity="0.55"/>
      <rect x="6" y="5" width="3" height="10" rx="0.5" opacity="0.75"/>
      <rect x="11" y="1" width="3" height="14" rx="0.5"/>
    </svg>
  ),
  Deals: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="1.5" y="5" width="13" height="9" rx="1.5"/>
      <path d="M5 5V3.5A1.5 1.5 0 0 1 6.5 2h3A1.5 1.5 0 0 1 11 3.5V5"/>
      <line x1="1.5" y1="9" x2="14.5" y2="9"/>
    </svg>
  ),
  Documents: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9 1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6z"/>
      <polyline points="9 1 9 6 14 6"/>
      <line x1="5" y1="9" x2="11" y2="9"/>
      <line x1="5" y1="12" x2="9" y2="12"/>
    </svg>
  ),
  'Event Management': (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="8" cy="8" r="6"/>
      <polyline points="8 5 8 8 10.5 9.5"/>
    </svg>
  ),
  Animals: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9 1H3.5L1.5 3v10l2 2h9l2-2V7.5z"/>
      <circle cx="11.5" cy="3.5" r="1"/>
    </svg>
  ),
  Feed: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M13 2c0 0-5 0-8 3S2 13 2 13s5 0 8-3 3-8 3-8z"/>
      <line x1="3" y1="13" x2="8" y2="8"/>
    </svg>
  ),
  Transport: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="1" y="4.5" width="10" height="7" rx="1"/>
      <path d="M11 7h2.5l1.5 3v1.5h-4"/>
      <circle cx="4" cy="13" r="1.5"/>
      <circle cx="12" cy="13" r="1.5"/>
    </svg>
  ),
  Reports: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M2 12l3-4 3 2 3-5 3 3"/>
      <line x1="1" y1="15" x2="15" y2="15"/>
    </svg>
  ),
  Entities: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="5.5" width="12" height="8" rx="1"/>
      <path d="M4.5 5.5V3.8C4.5 2.8 5.3 2 6.3 2h3.4c1 0 1.8.8 1.8 1.8v1.7"/>
      <path d="M5 9h.01M8 9h.01M11 9h.01M5 12h.01M8 12h.01M11 12h.01"/>
    </svg>
  ),
  Administration: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="8" cy="8" r="2"/>
      <path d="M8 1v1.5M8 13.5V15M1 8h1.5M13.5 8H15M3.2 3.2l1.1 1.1M11.7 11.7l1.1 1.1M3.2 12.8l1.1-1.1M11.7 4.3l1.1-1.1"/>
    </svg>
  ),
  UAT: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="2" width="12" height="12" rx="2"/>
      <path d="M5 8.2l2 2 4-4.4"/>
    </svg>
  ),
  'Master Data': (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <ellipse cx="8" cy="4" rx="5.5" ry="2"/>
      <path d="M2.5 4v4c0 1.1 2.5 2 5.5 2s5.5-.9 5.5-2V4"/>
      <path d="M2.5 8v4c0 1.1 2.5 2 5.5 2s5.5-.9 5.5-2V8"/>
    </svg>
  ),
};

const EntityCombobox = React.memo(function EntityCombobox({
  label,
  selectedUnit,
  searchValue,
  onSearchChange,
  results,
  showDropdown,
  onFocus,
  onBlur,
  onSelect,
  onClear,
  showEntityType = false,
  required = true,
}: {
  label: string;
  selectedUnit: any;
  searchValue: string;
  onSearchChange: (v: string) => void;
  results: any[];
  showDropdown: boolean;
  onFocus: () => void;
  onBlur: () => void;
  onSelect: (unit: any) => void;
  onClear: () => void;
  showEntityType?: boolean;
  required?: boolean;
}) {
  const typeBadge = (unit: any) =>
    showEntityType && unit?.entityType ? (
      <span className="ml-2 rounded bg-[#1e6bb814] px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-[#154f89]">
        {unit.entityType}
      </span>
    ) : null;
  return (
    <div className="grid gap-1 text-sm text-avcs-text">
      <span className="font-medium">{label}{required ? ' *' : ''}</span>
      {selectedUnit ? (
        <div className="flex items-center gap-2 rounded-lg border border-[#1e6bb833] bg-[#edf5ff] px-3 py-2">
          <span className="flex-1 font-medium text-[#0f3b64]">
            {selectedUnit.entityName || 'Unknown'}
            {selectedUnit.entityNo && (
              <span className="ml-2 font-mono text-xs font-normal text-avcs-muted">#{selectedUnit.entityNo}</span>
            )}
            {typeBadge(selectedUnit)}
          </span>
          <button type="button" className="text-avcs-muted hover:text-[#6b1010] text-base leading-none" onClick={onClear} aria-label="Clear">×</button>
        </div>
      ) : (
        <div className="relative">
          <input
            className="w-full rounded-lg border border-[#1e6bb833] px-3 py-2"
            placeholder="Type an entity name to search…"
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            onFocus={onFocus}
            onBlur={onBlur}
            autoComplete="off"
          />
          {showDropdown && (
            <div className="absolute z-20 left-0 right-0 top-full mt-1 max-h-52 overflow-auto rounded-lg border border-[#1e6bb833] bg-white shadow-lg">
              {results.length === 0 ? (
                <div className="px-3 py-2 text-xs text-avcs-muted">{searchValue.trim() ? 'No results found.' : 'Start typing to search.'}</div>
              ) : (
                results.map((unit: any, i: number) => {
                  const contact = (unit.contacts || []).find((c: any) => c?.isPrimary) || (unit.contacts || [])[0];
                  const contactName = contact?.name && contact.name !== 'Unnamed contact' ? contact.name : null;
                  return (
                    <button
                      key={unit.id || i}
                      type="button"
                      className="w-full text-left px-3 py-2 text-sm hover:bg-[#edf5ff] text-avcs-text border-b border-[#1e6bb812] last:border-0"
                      onMouseDown={(ev) => ev.preventDefault()}
                      onClick={() => onSelect(unit)}
                    >
                      <div>
                        <span className="font-medium">{unit.entityName || '—'}</span>
                        {unit.entityNo && (
                          <span className="ml-2 font-mono text-xs text-avcs-muted">#{unit.entityNo}</span>
                        )}
                        {typeBadge(unit)}
                      </div>
                      {contactName && (
                        <div className="text-xs text-avcs-muted">{contactName}</div>
                      )}
                    </button>
                  );
                })
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
});

const DealCombobox = React.memo(function DealCombobox({
  label,
  selectedDeal,
  searchValue,
  onSearchChange,
  results,
  showDropdown,
  onFocus,
  onBlur,
  onSelect,
  onClear,
  formatDeal,
}: {
  label: string;
  selectedDeal: Deal | null;
  searchValue: string;
  onSearchChange: (v: string) => void;
  results: Deal[];
  showDropdown: boolean;
  onFocus: () => void;
  onBlur: () => void;
  onSelect: (deal: Deal) => void;
  onClear: () => void;
  formatDeal: (deal: Deal) => string;
}) {
  return (
    <div className="grid gap-1 text-sm text-avcs-text md:col-span-2">
      <span className="font-medium">{label}</span>
      {selectedDeal ? (
        <div className="flex items-center gap-2 rounded-lg border border-[#1e6bb833] bg-[#edf5ff] px-3 py-2">
          <span className="flex-1 font-medium text-[#0f3b64]">{formatDeal(selectedDeal)}</span>
          <button type="button" className="text-avcs-muted hover:text-[#6b1010] text-base leading-none" onClick={onClear} aria-label="Clear deal">×</button>
        </div>
      ) : (
        <div className="relative">
          <input
            className="w-full rounded-lg border border-[#1e6bb833] px-3 py-2"
            placeholder="Type a deal number or contact to search..."
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            onFocus={onFocus}
            onBlur={onBlur}
            autoComplete="off"
          />
          {showDropdown && (
            <div className="absolute z-20 left-0 right-0 top-full mt-1 max-h-56 overflow-auto rounded-lg border border-[#1e6bb833] bg-white shadow-lg">
              {results.length === 0 ? (
                <div className="px-3 py-2 text-xs text-avcs-muted">No deals found.</div>
              ) : (
                results.map((deal) => (
                  <button
                    key={deal.dealId}
                    type="button"
                    className="w-full text-left px-3 py-2 text-sm hover:bg-[#edf5ff] text-avcs-text border-b border-[#1e6bb812] last:border-0"
                    onMouseDown={(ev) => ev.preventDefault()}
                    onClick={() => onSelect(deal)}
                  >
                    <span className="font-medium">{formatDeal(deal)}</span>
                  </button>
                ))
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
});

// Shared deal-option label — deal number, primary producer, and deal date.
// Mirrors `formatUploadDeal` on the event-capture screen so the document-upload
// deal picker reads identically.
const formatDealOption = (deal: Deal) => {
  const dealNo = deal.title || deal.dealRefNo || deal.dealId;
  const parts = [dealNo, deal.counterpart].filter((part) => part && part !== '—');
  const label = parts.join(' ');
  return deal.startDate ? `${label} · ${fmtDate(deal.startDate)}` : label;
};

interface ReceiveEventOption {
  id: string;
  dealId: string;
  label: string;
  dealTitle?: string;
  animalCount?: number;
  /** A receive event carries at most one journey; once it has one it leaves the Add-journey picker. */
  hasJourney?: boolean;
}

const ReceiveEventCombobox = React.memo(function ReceiveEventCombobox({
  selectedLabel,
  searchValue,
  onSearchChange,
  results,
  showDropdown,
  onFocus,
  onBlur,
  onSelect,
  onClear,
}: {
  selectedLabel: string;
  searchValue: string;
  onSearchChange: (v: string) => void;
  results: ReceiveEventOption[];
  showDropdown: boolean;
  onFocus: () => void;
  onBlur: () => void;
  onSelect: (option: ReceiveEventOption) => void;
  onClear: () => void;
}) {
  return (
    <div className="grid gap-1 text-sm text-avcs-text sm:col-span-2">
      <span className="font-medium">Event — receipt of animals (required)</span>
      {selectedLabel ? (
        <div className="flex items-center gap-2 rounded-lg border border-[#1e6bb833] bg-[#edf5ff] px-3 py-2">
          <span className="flex-1 font-medium text-[#0f3b64]">{selectedLabel}</span>
          <button type="button" className="text-avcs-muted hover:text-[#6b1010] text-base leading-none" onClick={onClear} aria-label="Clear event">×</button>
        </div>
      ) : (
        <div className="relative">
          <input
            className="w-full rounded-lg border border-[#1e6bb833] px-3 py-2"
            placeholder="Type an event type, date, or location to search…"
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            onFocus={onFocus}
            onBlur={onBlur}
            autoComplete="off"
          />
          {showDropdown && (
            <div className="absolute z-20 left-0 right-0 top-full mt-1 max-h-56 overflow-auto rounded-lg border border-[#1e6bb833] bg-white shadow-lg">
              {results.length === 0 ? (
                <div className="px-3 py-2 text-xs text-avcs-muted">No receipt events found.</div>
              ) : (
                results.map((option) => (
                  <button
                    key={option.id}
                    type="button"
                    className="w-full text-left px-3 py-2 text-sm hover:bg-[#edf5ff] text-avcs-text border-b border-[#1e6bb812] last:border-0"
                    onMouseDown={(ev) => ev.preventDefault()}
                    onClick={() => onSelect(option)}
                  >
                    <span className="font-medium">{option.label}</span>
                  </button>
                ))
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
});

const ENTITY_HELP_TEXT = 'Farms, Feedlots, Abattoirs, etc...';

// New-entity creation only -- editing an existing entity keeps the single
// flat form. The fields tagged for each step stay in their existing source
// position (harmless: editing renders every step's condition true, so the
// field order an admin already knows is unchanged); only the create flow
// filters down to one step's fields at a time.
const ENTITY_WIZARD_STEPS = ['AVCS details', 'Address', 'Contacts', 'GS1 codes & Integrations'] as const;

// Dependency-free spreadsheet export: writes a UTF-8 CSV (BOM so Excel reads
// accented characters correctly, CRLF + RFC-4180 quoting) and triggers a
// download. Opens directly in Excel/Sheets — no external library needed.
function downloadTableAsCsv(
  filename: string,
  headers: string[],
  rows: Array<Array<string | number | null | undefined>>,
): void {
  const escapeCell = (value: string | number | null | undefined): string => {
    if (value === null || value === undefined) return '';
    const str = String(value);
    return /[",\n\r]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
  };
  const csv = '﻿' + [headers, ...rows].map((row) => row.map(escapeCell).join(',')).join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}

// One raw ingest row shown as a card: source file + the original CSV columns
// it was uploaded with. Used in the animal detail "Source data" section.
const RawRowCard = React.memo(function RawRowCard({ row, showFilename = true, defaultOpen = false }: { row: RawDataRowProvenance; showFilename?: boolean; defaultOpen?: boolean }) {
  const entries = Object.entries(row.raw_data || {});
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="rounded-xl border border-[#1e6bb824] bg-white">
      {/* Collapsed header — filename (+ row/event); click to reveal the columns. */}
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="flex w-full flex-wrap items-center gap-x-3 gap-y-1 rounded-xl px-3 py-2 text-left text-xs hover:bg-[#f8fbff]"
      >
        <span className="text-avcs-muted transition-transform" style={{ transform: open ? 'rotate(90deg)' : 'none' }}>▸</span>
        {showFilename && (
          <span className="font-mono font-semibold text-avcs-text" title={row.original_filename || ''}>
            {row.original_filename || 'Unknown file'}
          </span>
        )}
        <span className="text-avcs-muted">Row {row.row_number ?? '—'}</span>
        {row.event_type && <span className="rounded bg-[#eef5ff] px-1.5 py-0.5 text-[#154f89]">{row.event_type}</span>}
        {/* Which revision of its file this row is. Only shown once a file has
            been revised: `revision_number` is 1 on every unrevised upload and a
            permanent "rev 1" badge would be noise. A superseded row is history
            -- the animal's figures come from the current revision. */}
        {row.is_current_revision === false && (
          <span
            className="rounded bg-[#fdf3e7] px-1.5 py-0.5 font-semibold text-[#8a4b12]"
            title="Superseded by a later re-upload of the same file. Kept as the audit trail; the animal's figures do not come from this row."
          >
            rev {row.revision_number} · superseded
          </span>
        )}
        {row.is_current_revision === true && Number(row.revision_number || 1) > 1 && (
          <span
            className="rounded bg-[#eaf7ee] px-1.5 py-0.5 font-semibold text-[#1c6b32]"
            title="The current revision of this file — the animal's figures come from this row."
          >
            rev {row.revision_number} · current
          </span>
        )}
        {row.is_processed === false && <span className="rounded bg-[#fff3e6] px-1.5 py-0.5 text-[#8a4b12]">Unprocessed</span>}
        {!open && entries.length > 0 && <span className="ml-auto text-avcs-muted">{entries.length} field{entries.length === 1 ? '' : 's'} · view</span>}
      </button>
      {open && (
        <div className="border-t border-[#1e6bb80f] p-3">
          {entries.length === 0 ? (
            <p className="text-xs text-avcs-muted">No raw column data stored for this row.</p>
          ) : (
            <div className="grid gap-x-4 gap-y-1 sm:grid-cols-2 lg:grid-cols-3">
              {entries.map(([key, value]) => (
                <div key={key} className="min-w-0 border-b border-[#1e6bb80f] py-0.5 text-xs">
                  <span className="block truncate font-medium text-avcs-muted" title={key}>{key}</span>
                  <span className="block truncate text-avcs-text" title={formatRawValue(value)}>{formatRawValue(value)}</span>
                </div>
              ))}
            </div>
          )}
          {row.processing_errors && (
            <p className="mt-2 rounded bg-[#f8eae7] px-2 py-1 text-xs text-[#6b1010]">{row.processing_errors}</p>
          )}
        </div>
      )}
    </div>
  );
});

function InfoHint({ text }: { text: string }) {
  const [open, setOpen] = useState(false);

  return (
    <span
      className={`info-hint${open ? ' is-open' : ''}`}
      role="button"
      tabIndex={0}
      title={text}
      aria-label={text}
      onClick={(event) => {
        event.stopPropagation();
        setOpen((prev) => !prev);
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          setOpen((prev) => !prev);
        }
        if (event.key === 'Escape') {
          setOpen(false);
        }
      }}
      onBlur={() => setOpen(false)}
    >
      <span aria-hidden="true">i</span>
      <span className="info-hint-text" role="tooltip">{text}</span>
    </span>
  );
}

export const AdminHome: React.FC = () => {
  const { logout, user } = useAuth();
  const [view, setView] = useState<AdminView>('dashboard');
  const [activeMenuItemId, setActiveMenuItemId] = useState('overview-dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // --- Availability forecast (predict when meat is available downstream) ---
  const [forecast, setForecast] = useState<AvailabilityForecast | null>(null);
  const [forecastLoading, setForecastLoading] = useState(false);
  const [forecastError, setForecastError] = useState('');
  const [forecastFilters, setForecastFilters] = useState<{
    species: string;
    valueChainId: string;
    dealId: string;
    bufferDays: string;
    includeSlaughtered: boolean;
  }>({ species: '', valueChainId: '', dealId: '', bufferDays: '', includeSlaughtered: false });
  const [forecastShowAnimals, setForecastShowAnimals] = useState(false);
  const [schedules, setSchedules] = useState<ProductionScheduleTemplate[]>([]);
  const [scheduleDrafts, setScheduleDrafts] = useState<Record<string, Partial<ProductionScheduleUpsertInput>>>({});
  const [scheduleMsg, setScheduleMsg] = useState('');
  const [scheduleErr, setScheduleErr] = useState('');

  // --- Abattoir batch-slaughter reconciliation (by receipt) ---
  const [abattoirReceipts, setAbattoirReceipts] = useState<AbattoirReceiptsResponse | null>(null);
  const [abattoirLoading, setAbattoirLoading] = useState(false);
  const [abattoirError, setAbattoirError] = useState('');
  const [abattoirDrafts, setAbattoirDrafts] = useState<Record<string, { batch: string; ccm: string; date: string; dressing: string }>>({});
  // "Correct a batch's live mass": re-derive dressing from the abattoir's sheet figure.
  const [liveMassForm, setLiveMassForm] = useState<{ batch: string; dressing: string; liveMass: string; carcassMass: string }>({ batch: '', dressing: '', liveMass: '', carcassMass: '' });
  const [liveMassBusy, setLiveMassBusy] = useState(false);
  const [abattoirSubmitting, setAbattoirSubmitting] = useState<string | null>(null);
  const [abattoirMsg, setAbattoirMsg] = useState('');

  // --- Woolies: dashboard registration notifications + monthly stage report ---
  const [wooliesNotifications, setWooliesNotifications] = useState<WooliesRegistrationNotifications | null>(null);
  const [showNotifications, setShowNotifications] = useState(false);
  const [wooliesStage, setWooliesStage] = useState<WooliesStageForecast | null>(null);
  const [wooliesStageLoading, setWooliesStageLoading] = useState(false);
  const [wooliesStageError, setWooliesStageError] = useState('');
  const [wooliesStageMonths, setWooliesStageMonths] = useState(12);
  const [wooliesStageSpecies, setWooliesStageSpecies] = useState('');
  const [wooliesStageShowAnimals, setWooliesStageShowAnimals] = useState(false);
  const [wooliesAnimalsPage, setWooliesAnimalsPage] = useState(1);
  const WOOLIES_ANIMALS_PAGE_SIZE = 25;
  const [openGroups, setOpenGroups] = useState<Set<string>>(
    () => new Set(['Overview', 'Deals', 'Documents', 'Event Management', 'Animals', 'Feed', 'Transport', 'Reports', 'Entities', 'Administration', 'UAT', 'Master Data'])
  );
  const [deals, setDeals] = useState<Deal[]>([]);
  const [selectedDealId, setSelectedDealId] = useState<string>('');
  // Set when an animal was opened from a deal's tab: Back returns to that deal and tab, not the animal list.
  const [animalReturnDealTab, setAnimalReturnDealTab] = useState<string | null>(null);
  useEffect(() => {
    if (view !== 'animalCrud' && view !== 'dealSummary') setAnimalReturnDealTab(null);
  }, [view]);
  const [dataSessionDealId, setDataSessionDealId] = useState<string>('');
  const [feedRecords, setFeedRecords] = useState<FeedRecord[]>([]);
  const [animalSummaryByDeal, setAnimalSummaryByDeal] = useState<AnimalSummary['by_deal']>({});
  const [animalSummaryLoadError, setAnimalSummaryLoadError] = useState(false);
  const [systemStats, setSystemStats] = useState<SystemStats | null>(null);
  const [animalRegister, setAnimalRegister] = useState<AnimalLocationEntry[]>([]);
  // Full animal set for the "Animal list" view — every animal (incl. those not
  // linked to a deal), unlike `animalRegister` which only holds live/located
  // animals resolved from events. Location columns are enriched from
  // `animalRegister` where a match exists.
  const [allAnimals, setAllAnimals] = useState<any[]>([]);
  const [allAnimalsLoading, setAllAnimalsLoading] = useState(false);
  const [allAnimalsError, setAllAnimalsError] = useState<string | null>(null);
  const [animalListPage, setAnimalListPage] = useState(1);
  const ANIMAL_LIST_PAGE_SIZE = 50;
  // Animal list view mode: 'standard' shows the usual columns; 'slaughter'
  // swaps in a wide landscape table of the animals' raw abattoir-slaughter
  // upload rows — every raw CSV field as a column, fetched on demand.
  const [animalListMode, setAnimalListMode] = useState<'standard' | 'slaughter'>('standard');
  const [slaughterRawColumns, setSlaughterRawColumns] = useState<string[]>([]);
  const [slaughterRawRows, setSlaughterRawRows] = useState<DealSlaughterRawRow[]>([]);
  const [slaughterRawLoading, setSlaughterRawLoading] = useState(false);
  const [slaughterRawError, setSlaughterRawError] = useState<string | null>(null);
  const [animalRegisterSearch, setAnimalRegisterSearch] = useState('');
  const [animalRegisterStageFilter, setAnimalRegisterStageFilter] = useState<{
    entityType: string;
    label: string;
    sourceEntityType?: string;
    destinationEntityType?: string;
    inTransitLeg?: InTransitLeg;
    species?: string;
  } | null>(null);
  const [loadingDeals, setLoadingDeals] = useState(true);
  const [dealSummaryTracking, setDealSummaryTracking] = useState<any | null>(null);
  const [loadingDealSummaryTracking, setLoadingDealSummaryTracking] = useState(false);
  const [dealSummaryTrackingError, setDealSummaryTrackingError] = useState('');
  // Cache tracking results by dealId to avoid redundant API calls when switching views
  const trackingCacheRef = React.useRef<Record<string, any>>({});
  const selectedDealIdRef = React.useRef(selectedDealId);
  const dataSessionDealIdRef = React.useRef(dataSessionDealId);
  // Tracks which deal IDs have been fetched (even if 0 animals), preventing perpetual re-fetching
  // Prevents redundant re-fetches when navigating back to already-loaded views
  const hasLoadedGs1CodesRef = React.useRef(false);
  const hasLoadedEntityDirectoryRef = React.useRef(false);
  const hasLoadedAdminUsersRef = React.useRef(false);
  const hasLoadedValueChainOptionsRef = React.useRef(false);
  const valueChainNameRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    document.body.classList.add('admin-body');
    return () => {
      document.body.classList.remove('admin-body');
    };
  }, []);

  const [dealSearch, setDealSearch] = useState('');
  const [dealListPage, setDealListPage] = useState(1);
  const DEAL_LIST_PAGE_SIZE = 25;
  const [dealCrudError, setDealCrudError] = useState('');
  const [dealCrudSuccess, setDealCrudSuccess] = useState('');
  // --- New deal flow (step 1 — deal details) ---
  const [ndProducerMode, setNdProducerMode] = useState<'existing' | 'new'>('existing');
  const [ndProducerId, setNdProducerId] = useState('');
  const [ndProducerSearch, setNdProducerSearch] = useState('');
  const [ndShowProducerDropdown, setNdShowProducerDropdown] = useState(false);
  const [ndNewProducerName, setNdNewProducerName] = useState('');
  const [ndNewProducerType, setNdNewProducerType] = useState('FARM');
  const [ndAddContact, setNdAddContact] = useState(false);
  const [ndContactForm, setNdContactForm] = useState({ firstName: '', lastName: '', email: '', phoneNo: '' });
  // '' is the Deal Matrix — the default: no Supply Chain Program at all.
  const [ndValueChainId, setNdValueChainId] = useState('');
  const [ndDealDate, setNdDealDate] = useState(() => new Date().toISOString().slice(0, 10));
  const [ndError, setNdError] = useState('');
  const [ndSaving, setNdSaving] = useState(false);
  const [ndCreatedDeal, setNdCreatedDeal] = useState<{ id: string; label: string } | null>(null);
  // Step 2 — seller & purchaser. Each side is an entity picked via search
  // (details shown display-only; edited on the entity screen) or created
  // inline via the capture form; agents are deal-level and typed here.
  const [ndStep, setNdStep] = useState<1 | 2 | 3 | 4 | 5 | 6 | 7 | 'done'>(1);
  const [ndSellerMode, setNdSellerMode] = useState<'select' | 'create'>('select');
  const [ndPurchaserMode, setNdPurchaserMode] = useState<'select' | 'create'>('select');
  const [ndSellerForm, setNdSellerForm] = useState<NdPartyForm>({ ...BLANK_ND_PARTY_FORM });
  const [ndPurchaserForm, setNdPurchaserForm] = useState<NdPartyForm>({ ...BLANK_ND_PARTY_FORM, entityType: 'AGENT' });
  const [ndSellerSearch, setNdSellerSearch] = useState('');
  const [ndShowSellerDropdown, setNdShowSellerDropdown] = useState(false);
  const [ndPurchaserId, setNdPurchaserId] = useState('');
  const [ndPurchaserSearch, setNdPurchaserSearch] = useState('');
  const [ndShowPurchaserDropdown, setNdShowPurchaserDropdown] = useState(false);
  const [ndSellerAgent, setNdSellerAgent] = useState({ enabled: false, name: '', contact: '' });
  const [ndPurchaserAgent, setNdPurchaserAgent] = useState({ enabled: false, name: '', contact: '' });
  const [ndCreatingEntity, setNdCreatingEntity] = useState<'' | 'SELLER' | 'PURCHASER'>('');
  const [ndRequirements, setNdRequirements] = useState<DealDocumentRequirement[]>([]);
  const [ndUploadingKey, setNdUploadingKey] = useState('');
  const [ndStep2Error, setNdStep2Error] = useState('');
  const [ndStep2Success, setNdStep2Success] = useState('');
  const [ndStep7Error, setNdStep7Error] = useState('');
  // Step 2 is two small screens: who is the seller, then who is the purchaser.
  const [ndPartyStage, setNdPartyStage] = useState<'seller' | 'purchaser'>('seller');
  const [ndSavingParties, setNdSavingParties] = useState(false);
  // Step 3 — animals & pricing. Counts split male/female/unknown with a
  // per-kg purchase price beside each; the registration event capture opens
  // in a modal and the loaded animals are reflected back here.
  const [ndAnimalsForm, setNdAnimalsForm] = useState({
    totalMale: '', totalFemale: '', totalUnknown: '',
    pricePerKgMale: '', pricePerKgFemale: '', pricePerKgUnknown: '',
    totalWeightKg: '',
    totalPriceExVat: '', totalPriceInclVat: '', penaltyTerms: '',
    // Origin & traceability moved here from the health step on 2026-08-30.
    // Where the animals came from is a fact about the animals, and the
    // catalogue has always grouped these under ANIMALS — the health step was
    // the odd one out, asking about provenance between two disease questions.
    origin: '', purchaseChannel: '', traceabilityDocumented: false,
  });
  const [ndStep3Error, setNdStep3Error] = useState('');
  const [ndStep3Success, setNdStep3Success] = useState('');
  // Step 3 is two small screens: the animals, then the pricing.
  const [ndAnimalsStage, setNdAnimalsStage] = useState<'animals' | 'register' | 'details'>('animals');
  // What the operator has typed on the animals screen. A missing key means
  // "show what the deal already holds", so nothing needs copying in.
  const [ndBasics, setNdBasics] = useState<{ species?: string; breedId?: string; total?: string }>({});
  // The capture form can open as a screen of the wizard instead of an overlay.
  const [ndEventInline, setNdEventInline] = useState(false);
  // After a slaughter is captured: the screen asking for its sale invoice and value.
  const [ndSlaughterSale, setNdSlaughterSale] = useState(false);
  const [ndSaleForm, setNdSaleForm] = useState<{ value: string; date: string; file: File | null }>({ value: '', date: '', file: null });
  const [ndSavingSale, setNdSavingSale] = useState(false);
  const [ndSaleError, setNdSaleError] = useState('');
  // Each wizard screen's button bar renders into this slot, below the scrolling
  // area, so content can never slide underneath it.
  const [ndFooterSlot, setNdFooterSlot] = useState<HTMLDivElement | null>(null);
  const wizardFooter = (node: React.ReactNode) => (ndFooterSlot ? createPortal(node, ndFooterSlot) : null);
  const [ndSavingAnimals, setNdSavingAnimals] = useState(false);
  // The created deal's live detail (headcount, sex split, average weight) —
  // refreshed after saves and after the registration modal closes.
  const [ndDealStats, setNdDealStats] = useState<any>(null);
  // Which event-capture modal is open: registration (step 3) or a medicine/
  // vaccination data file (step 4). '' = closed.
  // Any entity-event code (FARM_REG, FEED_REC, FEED_SHE, VACCINATION …); '' = closed.
  const [ndEventModalKind, setNdEventModalKind] = useState<string>('');
  // Shown on the host screen after the capture modal closes itself on success.
  const [captureNotice, setCaptureNotice] = useState('');
  // uploadCompletedCount when the modal opened — a later bump means an event
  // was created inside it, and the modal closes on its own.
  const captureOpenedAtCountRef = useRef(0);
  // Step 4 (Movement & Events): the wizard deal's events so far.
  const [ndDealEvents, setNdDealEvents] = useState<any[]>([]);
  // After a vaccination upload confirms: the invoice-and-cost step, which
  // holds the capture modal open until it is saved or skipped.
  const [treatmentInvoiceStep, setTreatmentInvoiceStep] = useState<{ sessionId: string; animals: number; medicines: string[] } | null>(null);
  const [treatmentInvoiceForm, setTreatmentInvoiceForm] = useState<{ costPerAnimal: string; referenceNumber: string; invoiceDate: string; file: File | null }>({ costPerAnimal: '', referenceNumber: '', invoiceDate: '', file: null });
  const [savingTreatmentInvoice, setSavingTreatmentInvoice] = useState(false);
  const [treatmentInvoiceError, setTreatmentInvoiceError] = useState('');
  // Which deal the event-capture / journey modal is currently open for. The
  // wizard's own deal by default; the View-deal screen passes its deal in.
  const [captureModalDeal, setCaptureModalDeal] = useState<{ id: string; label: string } | null>(null);
  // Bumped when a modal opened from the View-deal screen closes, so that
  // screen re-reads events / vaccinations / journeys without a full reload.
  const [dealOverviewRefreshToken, setDealOverviewRefreshToken] = useState(0);
  // Pending EID claims across every deal -- the "Needs review" menu badge and
  // the default deal the review screen opens on.
  const [pendingReviewClaims, setPendingReviewClaims] = useState<EidAssignment[]>([]);
  const [needsReviewDealId, setNeedsReviewDealId] = useState('');
  const loadPendingReviewClaims = useCallback(async () => {
    try {
      setPendingReviewClaims(await fetchEidAssignments({ status: 'PENDING' }));
    } catch {
      setPendingReviewClaims([]);
    }
  }, []);
  useEffect(() => { loadPendingReviewClaims(); }, [loadPendingReviewClaims]);
  // The PURCHASE ledger row the wizard maintains for this deal, so re-typing
  // the total updates it instead of adding a second one.
  const [ndPurchaseFinanceId, setNdPurchaseFinanceId] = useState('');
  const [ndPurchaseSyncing, setNdPurchaseSyncing] = useState(false);
  const [ndPurchaseApplied, setNdPurchaseApplied] = useState('');
  // The R/kg the wizard last wrote into the three price-per-kg boxes, so a
  // recalculation replaces its own figure but never one the operator typed.
  const [ndAutoPricePerKg, setNdAutoPricePerKg] = useState('');
  // The invoice's own date: the PURCHASE row and the filed document carry it,
  // not the day the operator typed it in. Defaults to the deal date.
  const [ndPurchaseInvoiceDate, setNdPurchaseInvoiceDate] = useState('');
  // The purchase total the wizard last wrote into "Total price (ex VAT)".
  const [ndAutoTotalExVat, setNdAutoTotalExVat] = useState('');
  // Purchase invoice capture: the invoice file plus its ex-VAT total, which
  // becomes a PURCHASE finance record and is applied straight to the animals.
  const [ndPurchaseInvoiceAmount, setNdPurchaseInvoiceAmount] = useState('');
  const [ndPurchaseInvoiceDone, setNdPurchaseInvoiceDone] = useState(false);
  // Penalty capture: a monetary value with its terms, recorded on the ledger.
  const [ndPenaltyAmount, setNdPenaltyAmount] = useState('');
  const [ndRecordingPenalty, setNdRecordingPenalty] = useState(false);
  // Step 4 — origin, health declaration and feeding declaration. Tri-states
  // follow the house rule: '' is "not asked yet", never a silent "no".
  // `treatedWithMedications` / `treatedWithAntibiotics` were asked here until
  // 2026-08-30. They sat directly above the medication list that answers them,
  // so an operator could add a medication and leave the question reading "No".
  // The backend derives both columns from the rows now.
  const [ndHealthForm, setNdHealthForm] = useState({
    examinedBeforeAndOnLoading: '' as '' | 'yes' | 'no',
    freeOfListedDiseases: '' as '' | 'yes' | 'no',
    diseasesPresent: [] as string[], diseasesOther: '',
    clinicalReportAvailable: '' as '' | 'yes' | 'no',
    withdrawalPeriodsAdhered: '' as '' | 'yes' | 'no',
    purchaserDocumentsRequired: '' as '' | 'yes' | 'no',
    purchaserDocumentsCompleted: '' as '' | 'yes' | 'no',
    feedingSystem: '', feedingSystemOther: '',
    animalByProductsFed: '' as '' | 'yes' | 'no',
    animalByProducts: [] as string[], animalByProductsOther: '',
  });
  const [ndStep4Error, setNdStep4Error] = useState('');
  const [ndStep4Success, setNdStep4Success] = useState('');
  const [ndSavingHealth, setNdSavingHealth] = useState(false);
  // Step 4 is a sub-wizard: the declaration questions, then the medications
  // they refer to, then the feeding declaration. One decision per screen —
  // the single scrolling form asked twenty questions at once, and the two
  // medication boxes at the bottom asked several of them twice.
  type NdStep4Sub = 'declaration' | 'medications' | 'feeding';
  const [ndStep4Sub, setNdStep4Sub] = useState<NdStep4Sub>('declaration');
  // The merged medication capture. One form now writes the declaration row,
  // the per-animal treatment records and the VETERINARY cost.
  const [ndMedCapture, setNdMedCapture] = useState({
    medicineId: '', lastTreatmentDate: '', withdrawalDays: '',
    dosage: '', totalCost: '', isAntibiotic: false,
  });
  const [ndCapturingMed, setNdCapturingMed] = useState(false);
  // Where the medication was given. Blank means the deal's current location.
  const [ndMedLocationId, setNdMedLocationId] = useState('');
  const [ndMedLocationSearch, setNdMedLocationSearch] = useState('');
  const [ndShowMedLocationDropdown, setNdShowMedLocationDropdown] = useState(false);
  // One row per declared feed — a declaration routinely lists several, each
  // with its own description, nutritional value and introduction date.
  const [ndFeedCapture, setNdFeedCapture] = useState({
    feedName: '', description: '', nutritionalValue: '', introducedDate: '',
  });
  const [ndCapturingFeed, setNdCapturingFeed] = useState(false);
  // Feed picker: what can be chosen instead of typed — the feed catalogue plus
  // every feed already declared on some deal, one suggestion per distinct name.
  type NdFeedSuggestion = { key: string; name: string; nutritionalValue: string; description: string; source: 'catalogue' | 'declared'; uses: number };
  const [ndFeedSuggestions, setNdFeedSuggestions] = useState<NdFeedSuggestion[]>([]);
  const [ndFeedSuggestionsLoaded, setNdFeedSuggestionsLoaded] = useState(false);
  const [ndFeedSuggestionsFailed, setNdFeedSuggestionsFailed] = useState(false);
  const [ndFeedPickerOpen, setNdFeedPickerOpen] = useState(false);
  // Event Management → Add feed: one bill across deals, split by head.
  const [addFeedDealIds, setAddFeedDealIds] = useState<string[]>([]);
  const [addFeedDealSearch, setAddFeedDealSearch] = useState('');
  const [addFeedShowDeals, setAddFeedShowDeals] = useState(false);
  const [addFeedForm, setAddFeedForm] = useState({ entityId: '', feedName: '', quantityKg: '', cost: '', invoiceDate: new Date().toISOString().slice(0, 10), referenceNumber: '', docMode: 'upload' as 'upload' | 'existing', existingDocId: '', file: null as File | null });
  const [addFeedExistingDocs, setAddFeedExistingDocs] = useState<DealDocumentSummary[]>([]);
  const [addFeedSaving, setAddFeedSaving] = useState(false);
  const [addFeedError, setAddFeedError] = useState('');
  const [addFeedSuccess, setAddFeedSuccess] = useState('');
  // Event Management → Add wool: the clip and its money, divided by sheep shorn.
  type WoolLine = { amount: string; date: string; reference: string; file: File | null };
  const blankWoolLine = (): WoolLine => ({ amount: '', date: '', reference: '', file: null });
  const [woolEvents, setWoolEvents] = useState<SharedFinanceEventOption[]>([]);
  /** Per shear event: which wool money is already booked on it (shared records split over it). */
  const [woolBooked, setWoolBooked] = useState<Record<string, { sale: boolean; shearing: boolean; packs: boolean; broker: boolean }>>({});
  const [showSoldWool, setShowSoldWool] = useState(false);
  const [woolEventsLoading, setWoolEventsLoading] = useState(false);
  const [woolEventIds, setWoolEventIds] = useState<string[]>([]);
  const [woolKg, setWoolKg] = useState('');
  const [woolShearing, setWoolShearing] = useState<WoolLine>(blankWoolLine());
  const [woolPacks, setWoolPacks] = useState<WoolLine>(blankWoolLine());
  const [woolSale, setWoolSale] = useState<WoolLine>(blankWoolLine());
  const [woolBroker, setWoolBroker] = useState('');
  const [woolSaving, setWoolSaving] = useState(false);
  const [woolError, setWoolError] = useState('');
  const [woolSuccess, setWoolSuccess] = useState('');
  const resetAddWool = () => {
    setWoolEventIds(woolEvents.filter((e) => !woolBooked[e.id]?.sale).map((e) => e.id));
    setWoolKg(''); setWoolShearing(blankWoolLine()); setWoolPacks(blankWoolLine()); setWoolSale(blankWoolLine()); setWoolBroker('');
    setWoolError(''); setWoolSuccess('');
  };
  useEffect(() => {
    if (view !== 'addWool') return;
    let cancelled = false;
    setWoolEventsLoading(true);
    Promise.all([fetchSharedFinanceEvents({ codes: ['FEED_SHE', 'FARM_SHE'] }), fetchSharedFinances().catch(() => [])])
      .then(([rows, records]) => {
        if (cancelled) return;
        const booked: Record<string, { sale: boolean; shearing: boolean; packs: boolean; broker: boolean }> = {};
        records.forEach((rec) => {
          const desc = (rec.description || '').toLowerCase();
          const key = rec.recordType === 'WOOL_SALE' ? 'sale' : rec.recordType === 'SHEARING' ? 'shearing' : rec.recordType === 'OTHER_COST' && desc.startsWith('wool broker') ? 'broker' : rec.recordType === 'OTHER_COST' && desc.startsWith('wool pack') ? 'packs' : null;
          if (!key) return;
          rec.basisEvents.forEach((ev) => { booked[ev.id] = { ...(booked[ev.id] || { sale: false, shearing: false, packs: false, broker: false }), [key]: true }; });
        });
        setWoolBooked(booked);
        setShowSoldWool(false);
        setWoolEvents(rows);
        setWoolEventIds(rows.filter((r) => !booked[r.id]?.sale).map((r) => r.id));
      })
      .catch(() => { if (!cancelled) setWoolEvents([]); })
      .finally(() => { if (!cancelled) setWoolEventsLoading(false); });
    return () => { cancelled = true; };
  }, [view]);

  const resetAddFeed = () => {
    setAddFeedDealIds([]);
    setAddFeedDealSearch('');
    setAddFeedForm({ entityId: '', feedName: '', quantityKg: '', cost: '', invoiceDate: new Date().toISOString().slice(0, 10), referenceNumber: '', docMode: 'upload', existingDocId: '', file: null });
    setAddFeedExistingDocs([]);
    setAddFeedError('');
    setAddFeedSuccess('');
  };
  // Default the feedlot from the first selected deal's latest receive event,
  // and offer that deal's filed documents when it is the only one.
  useEffect(() => {
    if (view !== 'addFeed' || addFeedDealIds.length === 0) return;
    let cancelled = false;
    const first = addFeedDealIds[0];
    fetchDealEvents(first).then((events) => {
      if (cancelled || addFeedForm.entityId) return;
      const sorted = [...(events || [])].filter((e: any) => !e?.is_voided).sort((a: any, b: any) => String(a?.event_date || '').localeCompare(String(b?.event_date || '')));
      const rec = [...sorted].reverse().find((e: any) => String(e?.entity_event_type_code || '') === 'FEED_REC')
        || [...sorted].reverse().find((e: any) => String(e?.entity_event_type_code || '').endsWith('_REC'));
      const entity = rec ? entityDirectory.find((en) => en.entityName === (rec.destination_entity_name || rec.location_entity_name)) : null;
      if (entity) setAddFeedForm((prev) => (prev.entityId ? prev : { ...prev, entityId: entity.id }));
    }).catch(() => {});
    if (addFeedDealIds.length === 1) {
      fetchDealDocumentsForDeal(first).then((docs) => { if (!cancelled) setAddFeedExistingDocs(docs); }).catch(() => { if (!cancelled) setAddFeedExistingDocs([]); });
    } else {
      setAddFeedExistingDocs([]);
      setAddFeedForm((prev) => (prev.docMode === 'existing' ? { ...prev, docMode: 'upload', existingDocId: '' } : prev));
    }
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [view, addFeedDealIds]);
  const loadNdFeedSuggestions = useCallback(async () => {
    setNdFeedSuggestionsFailed(false);
    setNdFeedSuggestionsLoaded(false);
    try {
      // The catalogue is the list that matters; declarations only enrich it.
      // A swallowed catalogue error used to leave an empty picker that looked
      // like an empty catalogue, so its failure is now reported.
      const [catalogue, declared] = await Promise.all([
        fetchFeedOptions().catch(() => { setNdFeedSuggestionsFailed(true); return [] as FeedOption[]; }),
        fetchDealFeedingDeclarations().catch(() => [] as any[]),
      ]);
      const byName = new Map<string, NdFeedSuggestion>();
      const norm = (value: string) => value.trim().toLowerCase();
      // Declared feeds first: they carry the nutritional value and the wording
      // an operator actually used; the catalogue fills in names nobody has
      // declared yet.
      declared.forEach((row: any) => {
        const name = String(row?.feed_name || '').trim();
        if (!name) return;
        const existing = byName.get(norm(name));
        if (existing) {
          existing.uses += 1;
          if (!existing.nutritionalValue && row.nutritional_value) existing.nutritionalValue = String(row.nutritional_value);
          if (!existing.description && row.description) existing.description = String(row.description);
          return;
        }
        byName.set(norm(name), {
          key: `declared:${norm(name)}`, name,
          nutritionalValue: String(row.nutritional_value || ''), description: String(row.description || ''),
          source: 'declared', uses: 1,
        });
      });
      catalogue.forEach((feed) => {
        const name = String(feed?.name || '').trim();
        if (!name || byName.has(norm(name))) return;
        byName.set(norm(name), { key: `catalogue:${feed.id}`, name, nutritionalValue: '', description: String(feed.description || ''), source: 'catalogue', uses: 0 });
      });
      setNdFeedSuggestions(Array.from(byName.values()).sort((a, b) => b.uses - a.uses || a.name.localeCompare(b.name)));
    } finally {
      setNdFeedSuggestionsLoaded(true);
    }
  }, []);
  const [ndMedCaptureFile, setNdMedCaptureFile] = useState<File | null>(null);
  const [ndReplayingMedId, setNdReplayingMedId] = useState('');
  // Adding a medicine to the catalogue without leaving the capture — the
  // alternative was abandoning a half-filled deal step to go to Medicines.
  const [ndShowAddMedicine, setNdShowAddMedicine] = useState(false);
  const [ndNewMedicine, setNdNewMedicine] = useState({
    name: '', brandName: '', producer: '', withholdingPeriod: '',
  });
  const [ndSavingNewMedicine, setNdSavingNewMedicine] = useState(false);
  // Evidence uploaded against a single declaration answer, keyed by the
  // answer's own field name. Holds the uploaded filename for the chip.
  const [ndDeclEvidence, setNdDeclEvidence] = useState<Record<string, string>>({});
  const [ndDeclUploadingKey, setNdDeclUploadingKey] = useState('');
  // Medicine paperwork filed as an ordinary deal document (vet letters,
  // treatment registers) — the operator picks which document type it is.
  const [ndMedDocTypeId, setNdMedDocTypeId] = useState('');
  const [ndMedDocUploaded, setNdMedDocUploaded] = useState(false);
  // Step 5 — transportation: the deal's journeys, and the Add Journey tool
  // opened in a modal.
  const [ndDealJourneys, setNdDealJourneys] = useState<TransportJourneySummary[]>([]);
  const [ndShowJourneyModal, setNdShowJourneyModal] = useState(false);
  // The journey form can open as a screen of the wizard instead of an overlay.
  const [ndJourneyInline, setNdJourneyInline] = useState(false);
  // Which part of the journey wizard is showing (0 = which delivery … 4 = paperwork).
  const [ndJourneyStage, setNdJourneyStage] = useState(0);
  const [dealOverviewById, setDealOverviewById] = useState<Record<string, DealAdminOverviewItem>>({});
  // Keep refs in sync every render so async callbacks always read the latest values
  const dealOverviewByIdRef = React.useRef(dealOverviewById);
  selectedDealIdRef.current = selectedDealId;
  dataSessionDealIdRef.current = dataSessionDealId;
  dealOverviewByIdRef.current = dealOverviewById;

  const [primaryProducerOptions, setPrimaryProducerOptions] = useState<SelectOption[]>([]);
  const [entityProfilesById, setEntityProfilesById] = useState<Record<string, EntityProfile>>({});
  const [valueChainOptions, setValueChainOptions] = useState<SelectOption[]>([]);
  const [dealDocumentTypeOptions, setDealDocumentTypeOptions] = useState<Array<SelectOption & { code?: string; financeRecordType?: string }>>([]);
  const [loadingDocumentTypes, setLoadingDocumentTypes] = useState(true);
  const [transportDealEventOptions, setTransportDealEventOptions] = useState<SelectOption[]>([]);
  const [transportDispatchEventOptions, setTransportDispatchEventOptions] = useState<SelectOption[]>([]);
  const [dealEventLabelsById, setDealEventLabelsById] = useState<Record<string, string>>({});
  const [uploadCompletedCount, setUploadCompletedCount] = useState(0);
  const [useManualDealEventId, setUseManualDealEventId] = useState(false);
  const [useManualAnimalLocation, setUseManualAnimalLocation] = useState(false);

  const [feedForm, setFeedForm] = useState<Omit<FeedRecord, 'id'>>({
    dealId: '',
    feedId: '',
    feedType: '',
    quantityKg: 0,
    date: '',
  });
  const [feedOptions, setFeedOptions] = useState<FeedOption[]>([]);
  const [loadingFeedData, setLoadingFeedData] = useState(false);
  const [feedCrudError, setFeedCrudError] = useState('');
  const [feedCrudSuccess, setFeedCrudSuccess] = useState('');
  const [creatingFeedType, setCreatingFeedType] = useState(false);
  const [editingFeedTypeId, setEditingFeedTypeId] = useState<string>('');
  const [newFeedType, setNewFeedType] = useState({
    name: '',
    description: '',
    costPerKg: '',
    stockQty: '',
  });

  const [editingFeedId, setEditingFeedId] = useState<string>('');

  const [animalForm, setAnimalForm] = useState<Omit<AnimalRecord, 'id' | 'gln'>>({
    dealId: '',
    species: 'SHEEP',
    tag: '',
    eid: '',
    location: '',
    status: 'ACTIVE',
    breed: '',
    dob: '',
    sex: '',
  });

  const [editingAnimalId, setEditingAnimalId] = useState<string>('');
  const [animalSearch, setAnimalSearch] = useState('');
  // When set (via a deal's "View animals"), the Animal list is scoped to this deal.
  const [animalListDealFilter, setAnimalListDealFilter] = useState<string | null>(null);
  const [animalCrudError, setAnimalCrudError] = useState('');
  const [animalCrudSuccess, setAnimalCrudSuccess] = useState('');
  // Animal detail (profile) view state.
  const [animalDetail, setAnimalDetail] = useState<any | null>(null);
  const [animalDetailEvents, setAnimalDetailEvents] = useState<AnimalEventRow[]>([]);
  const [animalDetailPerformance, setAnimalDetailPerformance] = useState<AnimalPerformance | null>(null);
  const [animalDetailWeights, setAnimalDetailWeights] = useState<AnimalWeightRecord[]>([]);
  const [animalDetailRawRows, setAnimalDetailRawRows] = useState<RawDataRowProvenance[]>([]);
  const [animalDetailTab, setAnimalDetailTab] = useState<'weight' | 'events' | 'source'>('events');
  // When set, the Source data tab focuses on the raw row(s) of this data session
  // (used by the per-event-row "View raw data" button in the Event history tab).
  const [animalRawFocusKey, setAnimalRawFocusKey] = useState<string | null>(null);
  // Source data lists the current revision of each file by default; the
  // superseded ones are still there (the endpoint returns every revision) and
  // this reveals them.
  const [showSupersededRawRows, setShowSupersededRawRows] = useState(false);
  const [loadingAnimalDetail, setLoadingAnimalDetail] = useState(false);
  const [eventRawData, setEventRawData] = useState<RawDataModalState | null>(null);
  const [eventRawDataEvent, setEventRawDataEvent] = useState<any>(null);
  // Unprocessed-records screen: the row currently being reconciled to an animal.
  const [linkingUnprocessedRow, setLinkingUnprocessedRow] = useState<any>(null);
  const [showAnimalEditForm, setShowAnimalEditForm] = useState(false);
  const animalFormRef = useRef<HTMLDivElement>(null);
  const [deletingAnimalId, setDeletingAnimalId] = useState('');
  const [isSavingDeal, setIsSavingDeal] = useState(false);
  const [isSavingAnimal, setIsSavingAnimal] = useState(false);
  const [uploadingDocument, setUploadingDocument] = useState(false);
  const [documentUploadError, setDocumentUploadError] = useState('');
  const [documentUploadSuccess, setDocumentUploadSuccess] = useState('');
  const [fileInputKey, setFileInputKey] = useState(0);
  const [uploadedDocuments, setUploadedDocuments] = useState<UploadedDocumentRecord[]>([]);
  const [dealDocumentRows, setDealDocumentRows] = useState<DealDocumentSummary[]>([]);
  const [transportJourneyRows, setTransportJourneyRows] = useState<TransportJourneySummary[]>([]);
  const [transportJourneyDocFile, setTransportJourneyDocFile] = useState<File | null>(null);
  const [transportJourneyDocType, setTransportJourneyDocType] = useState<'waybill' | 'invoice' | ''>('');
  const [allReceiveEvents, setAllReceiveEvents] = useState<ReceiveEventOption[]>([]);
  // One truck, several deals: the receive events beyond the first one the
  // journey covers. Each gets its own Journey (deal_event is one-to-one) with
  // the same trip details; the cost is split equally per animal.
  const [journeyExtraEvents, setJourneyExtraEvents] = useState<ReceiveEventOption[]>([]);
  const [loadingReceiveEvents, setLoadingReceiveEvents] = useState(false);
  const [receiveEventSearch, setReceiveEventSearch] = useState('');
  const [showReceiveEventDropdown, setShowReceiveEventDropdown] = useState(false);
  const [dashboardFeedlotId, setDashboardFeedlotId] = useState('');
  const [dashboardFeedlotPerformance, setDashboardFeedlotPerformance] = useState<AnimalLocationPerformanceGroup | null>(null);
  // Margin card: the cost model pooled over the filter bar's deals. Active
  // deals by default, like the performance card; the toggle pulls closed
  // deals back in so a finished programme can still be read.
  // Species-scoped system stats for the per-species operations dashboards,
  // keyed by species (e.g. { SHEEP: {...}, CATTLE: {...} }). Kept separate from
  // any all-species stats so other screens that need system-wide totals are
  // unaffected.
  const [dashboardStats, setDashboardStats] = useState<SystemStats | null>(null);
  // The dashboard filter bar: species, Supply Chain Program, and single deal.
  // All three default to "everything".
  const [dashboardSpecies, setDashboardSpecies] = useState<DashboardSpeciesFilter>('ALL');
  // Every programme by default: the dashboard is the whole operation at a glance,
  // and the Deal Matrix is the exception an operator narrows to.
  const [dashboardScp, setDashboardScp] = useState<string>(DASHBOARD_SCP_ALL);
  // Supply Chain Programme Analysis report: the dashboard's margin block,
  // moved off the dashboard and given a start-date window. Closed deals are
  // always in scope here -- a period report that dropped finished deals would
  // report a programme's margin on the deals that had not yet earned it.
  const [scpAnalysisScp, setScpAnalysisScp] = useState<string>(DASHBOARD_SCP_ALL);
  const [scpAnalysisFrom, setScpAnalysisFrom] = useState<string>(new Date(new Date().getFullYear(), 0, 1).toISOString().slice(0, 10));
  const [scpAnalysisTo, setScpAnalysisTo] = useState<string>(new Date().toISOString().slice(0, 10));
  const [scpAnalysisTab, setScpAnalysisTab] = useState<'overview' | 'margin'>('overview');
  const [scpAnalysis, setScpAnalysis] = useState<MarginSummary | null>(null);
  const [scpAnalysisLoading, setScpAnalysisLoading] = useState(false);
  const [scpAnalysisError, setScpAnalysisError] = useState('');
  const [dashboardDealFilter, setDashboardDealFilter] = useState('');
  const [dashboardDealSearch, setDashboardDealSearch] = useState('');
  const [dashboardDealListOpen, setDashboardDealListOpen] = useState(false);
  const [dashboardDataQuality, setDashboardDataQuality] = useState<DataQualitySummary | null>(null);
  const transportJourneyRowsRef = React.useRef<TransportJourneySummary[]>([]);
  transportJourneyRowsRef.current = transportJourneyRows;
  const [woolFinanceRows, setWoolFinanceRows] = useState<WoolFinanceSummary[]>([]);
  const [loadingExistingDocuments, setLoadingExistingDocuments] = useState(false);
  const [editingDealDocumentId, setEditingDealDocumentId] = useState('');
  const [editingTransportJourneyId, setEditingTransportJourneyId] = useState('');
  const [editingWoolFinanceId, setEditingWoolFinanceId] = useState('');
  const [editingWeighbridgeRecordId, setEditingWeighbridgeRecordId] = useState('');
  const [weighbridgeForm, setWeighbridgeForm] = useState({ grossWeightKg: '', tareWeightKg: '', recordedAt: '', notes: '' });
  const [couriers, setCouriers] = useState<CourierOption[]>([]);
  const [loadingCouriers, setLoadingCouriers] = useState(false);
  const [courierFormError, setCourierFormError] = useState('');
  const [creatingCourier, setCreatingCourier] = useState(false);
  const [editingCourierId, setEditingCourierId] = useState('');
  const [showAddCourierForm, setShowAddCourierForm] = useState(false);
  const [newCourier, setNewCourier] = useState({
    name: '',
    contactNumber: '',
    email: '',
  });
  const [documentForm, setDocumentForm] = useState({
    dealId: '',
    category: 'Wool' as UploadMode,
    documentType: '',
    systemCode: '',
    referenceNumber: '',
    saleValue: '',
    dealEventId: '',
    dispatchEventId: '',
    courierId: '',
    vehicleRegistration: '',
    startKm: '',
    endKm: '',
    totalCost: '',
    dateOfDocument: '',
    offloadingDate: '',
    // Transportation detail (deal capture spec §Transportation).
    loadingTime: '',
    loadingPoint: '',
    offloadingPoint: '',
    driverName: '',
    driverContact: '',
    animalsDown: '',
    animalsDownReason: '',
    notes: '',
    visibility: 'ALL' as 'ALL' | 'ADMIN',
    sharedWithProducer: false,
    file: null as File | null,
  });
  // The Stock Theft Act removal certificate scan, attached to the journey.
  const [journeyRemovalCertFile, setJourneyRemovalCertFile] = useState<File | null>(null);
  // Document-upload deal picker (type/search/select, matches event capture).
  const [documentDealSearch, setDocumentDealSearch] = useState('');
  const [showDocumentDealDropdown, setShowDocumentDealDropdown] = useState(false);
  // One document, several deals (a slaughter sheet or settlement covering
  // three deals' loads): the deals beyond the first the file is filed against.
  // Each gets its own DealDocument; a sale value is split by head across them.
  const [documentExtraDealIds, setDocumentExtraDealIds] = useState<string[]>([]);
  // A cost-type document's value: booked whole to the deal, or split across
  // animals / events (a shared record, one ledger row per deal it reaches).
  const [documentCostMode, setDocumentCostMode] = useState<'deal' | 'split'>('deal');
  const [documentCostLines, setDocumentCostLines] = useState<CostLine[]>([]);
  // New Document — pagination for the selected deal's existing documents table.
  const [newDocDealDocsPage, setNewDocDealDocsPage] = useState(1);
  const NEW_DOC_DEAL_DOCS_PAGE_SIZE = 8;

  // Documents list screen (GET /api/documents/, excludes data-session files).
  const DOCUMENTS_LIST_PAGE_SIZE = 25;
  const [documentsList, setDocumentsList] = useState<DocumentIndexRow[]>([]);
  const [documentsListLoading, setDocumentsListLoading] = useState(false);
  const [documentsListError, setDocumentsListError] = useState('');
  const [documentsListCount, setDocumentsListCount] = useState(0);
  const [documentsListNumPages, setDocumentsListNumPages] = useState(1);
  const [documentsListPage, setDocumentsListPage] = useState(1);
  const [documentsListSearch, setDocumentsListSearch] = useState('');
  const [documentsListSource, setDocumentsListSource] = useState<DocumentSource | 'all'>('all');

  // Document search screen (GET /api/documents/, all sources incl. data-session).
  const DOC_SEARCH_PAGE_SIZE = 25;
  const [docSearchQuery, setDocSearchQuery] = useState('');
  const [docSearchSources, setDocSearchSources] = useState<Record<DocumentSource, boolean>>({
    deal: true, transport: true, wool: true, feedlot: true, data_session: true,
  });
  const [docSearchDealId, setDocSearchDealId] = useState('');
  const [docSearchDealSearch, setDocSearchDealSearch] = useState('');
  const [showDocSearchDealDropdown, setShowDocSearchDealDropdown] = useState(false);
  const [docSearchDateFrom, setDocSearchDateFrom] = useState('');
  const [docSearchDateTo, setDocSearchDateTo] = useState('');
  const [docSearchResults, setDocSearchResults] = useState<DocumentIndexRow[]>([]);
  const [docSearchLoading, setDocSearchLoading] = useState(false);
  const [docSearchError, setDocSearchError] = useState('');
  const [docSearchCount, setDocSearchCount] = useState(0);
  const [docSearchNumPages, setDocSearchNumPages] = useState(1);
  const [docSearchPage, setDocSearchPage] = useState(1);
  const [docSearchHasSearched, setDocSearchHasSearched] = useState(false);

  const [gs1Codes, setGs1Codes] = useState<GS1CodeSummary[]>([]);
  const [entityDirectory, setEntityDirectory] = useState<EntitySummary[]>([]);
  const [loadingEntityDirectory, setLoadingEntityDirectory] = useState(false);
  const [entitySearch, setEntitySearch] = useState('');
  const [entityDirectoryPage, setEntityDirectoryPage] = useState(1);
  const [productTypeOptions, setProductTypeOptions] = useState<SelectOption[]>([]);
  const [loadingGs1Codes, setLoadingGs1Codes] = useState(false);
  const [gs1CodesError, setGs1CodesError] = useState('');
  const [gs1Search, setGs1Search] = useState('');
  const [showGs1AllocationForm, setShowGs1AllocationForm] = useState(false);
  const [gs1EntitySearch, setGs1EntitySearch] = useState('');
  const [showGs1EntityDropdown, setShowGs1EntityDropdown] = useState(false);
  const [gs1Form, setGs1Form] = useState<GS1CodeUpsertInput>({
    gs1Code: '',
    gs1Type: 'GLN',
    entityId: '',
    productTypeId: '',
    associatedGlnId: '',
  });
  const [editingGs1Id, setEditingGs1Id] = useState<string>('');
  const [gs1CrudError, setGs1CrudError] = useState('');
  const [gs1CrudSuccess, setGs1CrudSuccess] = useState('');
  const [selectedEntityContactId, setSelectedEntityContactId] = useState('');
  const [showCreateContactModal, setShowCreateContactModal] = useState(false);
  const [creatingEntity, setCreatingEntity] = useState(false);
  const [creatingContact, setCreatingContact] = useState(false);
  const [entityModalError, setEntityModalError] = useState('');
  const [contactModalError, setContactModalError] = useState('');
  const [editingEntityId, setEditingEntityId] = useState('');
  const [editingContactId, setEditingContactId] = useState('');

  // The app's one message box, from ConfirmProvider. This screen used to carry
  // its own copy of the same promise-based modal -- which is why every other
  // screen fell back to window.confirm. `requestConfirm` is kept as a thin
  // adapter so the call sites here did not have to change shape.
  //
  // Nothing about the action is defaulted: `tone` and `confirmLabel` are
  // required (see ConfirmIntent). This screen defaulted `tone` to 'danger' for
  // a while, on the reasoning that most of its confirms really are deletes --
  // and then a red "Delete" button turned up on "Request new organisation",
  // which sends an email, because nobody adding that call site knew there was
  // a default to opt out of. A default cannot distinguish a delete from a
  // send; the author can, and now has to.
  const confirmDialog = useConfirm();
  const requestConfirm = useCallback(
    (opts: ConfirmIntent) =>
      confirmDialog({
        title: opts.title || 'Please confirm',
        message: opts.message,
        confirmLabel: opts.confirmLabel,
        tone: opts.tone,
      }),
    [confirmDialog],
  );

  // Entity view (edit) tabs: history / details / contacts / animals.
  const [entityTab, setEntityTab] = useState<'history' | 'details' | 'contacts' | 'animals' | 'documents' | 'gs1' | 'integration'>('history');
  // Documents that belong to the entity being viewed (see the Documents tab).
  const [entityDocs, setEntityDocs] = useState<EntityDocumentSummary[]>([]);
  const [entityDocsLoading, setEntityDocsLoading] = useState(false);
  const [entityDocsError, setEntityDocsError] = useState('');
  const [entityDocForm, setEntityDocForm] = useState<{ documentType: string; date: string; reference: string; file: File | null }>({
    documentType: '', date: new Date().toISOString().slice(0, 10), reference: '', file: null,
  });
  const [entityDocUploading, setEntityDocUploading] = useState(false);
  // Virtual Routez provisioning. The plan is fetched on demand rather than with
  // the entity, because it is only meaningful on this one tab.
  const [vrzPlan, setVrzPlan] = useState<VrzProvisionPlan | null>(null);
  const [vrzPlanLoading, setVrzPlanLoading] = useState(false);
  const [vrzPlanError, setVrzPlanError] = useState('');
  const [vrzProvisioning, setVrzProvisioning] = useState(false);
  const [vrzResult, setVrzResult] = useState<VrzProvisionResult | null>(null);
  const [vrzApiKey, setVrzApiKey] = useState('');
  const [vrzOverwriteKey, setVrzOverwriteKey] = useState(false);
  // Onboarding handshake: Virtual Routez org creation and key issuing is a
  // manual, partner-staff process, so this is tracking + a request email +
  // the test-connection check, not an automation of the partner's own step.
  const [vrzOnboardingProfile, setVrzOnboardingProfile] = useState<VrzEntityOnboardingProfile | null>(null);
  const [vrzOnboardingProfileLoading, setVrzOnboardingProfileLoading] = useState(false);
  const [vrzOnboardingRequesting, setVrzOnboardingRequesting] = useState(false);
  const [vrzOnboardingError, setVrzOnboardingError] = useState('');
  const [vrzOnboardingResult, setVrzOnboardingResult] = useState<VrzOnboardingRequestResult | null>(null);
  const [vrzRecipientEmail, setVrzRecipientEmail] = useState('');
  const [vrzTesting, setVrzTesting] = useState(false);
  const [vrzTestResult, setVrzTestResult] = useState<VrzConnectionTestResult | null>(null);
  const [entityAnimalsSearch, setEntityAnimalsSearch] = useState('');
  const [entityAnimalsPage, setEntityAnimalsPage] = useState(1);
  const [openEntityDealIds, setOpenEntityDealIds] = useState<Set<string>>(() => new Set());
  // Animals tab standard/slaughter toggle (mirrors the main animal list). The
  // slaughter-raw endpoint is deal- or all-scoped, so we fetch all once and
  // filter client-side to this entity's deals.
  const [entityAnimalsMode, setEntityAnimalsMode] = useState<'standard' | 'slaughter'>('standard');
  const [entitySlaughterRows, setEntitySlaughterRows] = useState<DealSlaughterRawRow[]>([]);
  const [entitySlaughterColumns, setEntitySlaughterColumns] = useState<string[]>([]);
  const [entitySlaughterLoading, setEntitySlaughterLoading] = useState(false);
  const [entitySlaughterError, setEntitySlaughterError] = useState<string | null>(null);
  const [entitySlaughterLoadedFor, setEntitySlaughterLoadedFor] = useState('');

  // Integrations (activity control) state
  const [integrationSystems, setIntegrationSystems] = useState<IntegrationSystemInfo[]>([]);
  const [loadingIntegrations, setLoadingIntegrations] = useState(false);
  const [integrationsError, setIntegrationsError] = useState('');
  const [integrationsSuccess, setIntegrationsSuccess] = useState('');
  const [integrationSavingId, setIntegrationSavingId] = useState('');
  const [integrationConfigId, setIntegrationConfigId] = useState('');
  const [integrationConfigForm, setIntegrationConfigForm] = useState({
    testBaseUrl: '',
    productionBaseUrl: '',
    testApiKey: '',
    productionApiKey: '',
  });

  // User management state
  const [adminUsers, setAdminUsers] = useState<UserSummary[]>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [userMgmtError, setUserMgmtError] = useState('');
  const [userMgmtSuccess, setUserMgmtSuccess] = useState('');
  const [showNewUserForm, setShowNewUserForm] = useState(false);
  const [newUserForm, setNewUserForm] = useState({ username: '', email: '', firstName: '', lastName: '', isStaff: false, rmisTestToken: '', rmisProductionToken: '' });
  const [newUserSaving, setNewUserSaving] = useState(false);
  const [setPasswordTargetId, setSetPasswordTargetId] = useState<number | null>(null);
  const [setPasswordValue, setSetPasswordValue] = useState('');
  const [setPasswordConfirm, setSetPasswordConfirm] = useState('');
  const [setPasswordSaving, setSetPasswordSaving] = useState(false);
  const [userSearch, setUserSearch] = useState('');
  const [rmisTokenDrafts, setRmisTokenDrafts] = useState<Record<number, { test: string; production: string }>>({});
  const [rmisTokenSavingKey, setRmisTokenSavingKey] = useState('');

  // Breed CRUD state
  const [breeds, setBreeds] = useState<BreedSummary[]>([]);
  const [loadingBreeds, setLoadingBreeds] = useState(false);
  const [breedCrudError, setBreedCrudError] = useState('');
  const [breedCrudSuccess, setBreedCrudSuccess] = useState('');
  const [breedForm, setBreedForm] = useState({ name: '', species: 'SHEEP' as 'SHEEP' | 'GOAT' | 'CATTLE' });
  const [editingBreedId, setEditingBreedId] = useState('');
  const [savingBreed, setSavingBreed] = useState(false);

  // Value Chain CRUD state
  const [valueChains, setValueChains] = useState<ValueChainSummary[]>([]);
  const [loadingValueChains, setLoadingValueChains] = useState(false);
  const [valueChainCrudError, setValueChainCrudError] = useState('');
  const [valueChainCrudSuccess, setValueChainCrudSuccess] = useState('');
  const [valueChainForm, setValueChainForm] = useState({ name: '', isActive: true, description: '', isScp: false, defaultPurchaserId: '' });
  // The field matrix. `vcCatalogue` is the field universe (fetched once — it
  // is backend code, not data); `vcRequirements` is the working copy of the
  // programme being edited, keyed by catalogue key.
  const [vcCatalogue, setVcCatalogue] = useState<FieldCatalogueGroup[]>([]);
  const [vcCatalogueError, setVcCatalogueError] = useState('');
  const [vcRequirements, setVcRequirements] = useState<Record<string, FieldRequirementState>>({});
  const [vcMatrixOpen, setVcMatrixOpen] = useState(false);
  const [editingValueChainId, setEditingValueChainId] = useState('');
  const [savingValueChain, setSavingValueChain] = useState(false);

  // Product Type CRUD state
  const [productTypeList, setProductTypeList] = useState<ProductTypeSummary[]>([]);
  const [loadingProductTypeList, setLoadingProductTypeList] = useState(false);
  const [productTypeCrudError, setProductTypeCrudError] = useState('');
  const [productTypeCrudSuccess, setProductTypeCrudSuccess] = useState('');
  const [productTypeForm, setProductTypeForm] = useState({ name: '' });
  const [editingProductTypeId, setEditingProductTypeId] = useState('');
  const [savingProductType, setSavingProductType] = useState(false);
  const productTypeNameRef = useRef<HTMLInputElement>(null);

  const breedNameRef = useRef<HTMLInputElement>(null);
  const medicineNameRef = useRef<HTMLInputElement>(null);
  const equipmentSerialRef = useRef<HTMLInputElement>(null);
  const woolCodeRef = useRef<HTMLInputElement>(null);
  const sourceSearchTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const destSearchTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Production unit (GLN) search state for event upload
  const [sourceProductionUnits, setSourceProductionUnits] = useState<any[]>([]);
  const [destProductionUnits, setDestProductionUnits] = useState<any[]>([]);
  const [sourceSearching, setSourceSearching] = useState(false);
  const [destSearching, setDestSearching] = useState(false);
  const [sourceSelectedUnit, setSourceSelectedUnit] = useState<any>(null);
  const [destSelectedUnit, setDestSelectedUnit] = useState<any>(null);

  // Medicine CRUD state
  const [medicines, setMedicines] = useState<MedicineSummary[]>([]);
  const [loadingMedicines, setLoadingMedicines] = useState(false);
  const [medicineCrudError, setMedicineCrudError] = useState('');
  const [medicineCrudSuccess, setMedicineCrudSuccess] = useState('');
  const [medicineForm, setMedicineForm] = useState({ name: '', brandName: '', producer: '', withholdingPeriod: '', sku: '', stockQty: '' });
  const [editingMedicineId, setEditingMedicineId] = useState('');
  const [savingMedicine, setSavingMedicine] = useState(false);

  // Equipment CRUD state
  const [equipmentList, setEquipmentList] = useState<EquipmentSummary[]>([]);
  const [loadingEquipment, setLoadingEquipment] = useState(false);
  const [equipmentCrudError, setEquipmentCrudError] = useState('');
  const [equipmentCrudSuccess, setEquipmentCrudSuccess] = useState('');
  const [equipmentForm, setEquipmentForm] = useState({ deviceType: 'XR5000', serialNumber: '', issueDate: '', returnDate: '', notes: '', isActive: true, cost: '', dealId: '' });
  const [editingEquipmentId, setEditingEquipmentId] = useState('');
  const [savingEquipment, setSavingEquipment] = useState(false);

  // Document type CRUD state
  const [documentTypes, setDocumentTypes] = useState<DocumentTypeRecord[]>([]);
  const [loadingDocumentTypeRows, setLoadingDocumentTypeRows] = useState(false);
  const [documentTypeCrudError, setDocumentTypeCrudError] = useState('');
  const [documentTypeCrudSuccess, setDocumentTypeCrudSuccess] = useState('');
  const [documentTypeForm, setDocumentTypeForm] = useState({ name: '', code: '', description: '', allowedExtensions: 'pdf,jpg,jpeg,png', financeRecordType: '' });
  const [editingDocumentTypeId, setEditingDocumentTypeId] = useState('');
  const [savingDocumentType, setSavingDocumentType] = useState(false);

  // Wool Class CRUD state
  const [woolClasses, setWoolClasses] = useState<WoolClassSummary[]>([]);
  const [loadingWoolClasses, setLoadingWoolClasses] = useState(false);
  const [woolClassCrudError, setWoolClassCrudError] = useState('');
  const [woolClassCrudSuccess, setWoolClassCrudSuccess] = useState('');
  const [woolClassForm, setWoolClassForm] = useState({ code: '', name: '', description: '' });
  const [editingWoolClassId, setEditingWoolClassId] = useState('');
  const [savingWoolClass, setSavingWoolClass] = useState(false);

  // Wool Bales state
  const [woolSessionsForDeal, setWoolSessionsForDeal] = useState<WoolSessionSummary[]>([]);
  const [woolBalesSessionId, setWoolBalesSessionId] = useState('');
  const [woolBalesForSession, setWoolBalesForSession] = useState<WoolBaleSummary[]>([]);
  const [loadingWoolBales, setLoadingWoolBales] = useState(false);
  const [woolBaleError, setWoolBaleError] = useState('');
  const [woolBaleSuccess, setWoolBaleSuccess] = useState('');
  const [woolBaleForm, setWoolBaleForm] = useState({ baleWeight: '', cleanedWeight: '', tareWeight: '3', woolClassId: '', woolBreedId: '', notes: '' });
  const [editingWoolBaleId, setEditingWoolBaleId] = useState('');
  const [finishingBaling, setFinishingBaling] = useState(false);
  const [balePrintSheet, setBalePrintSheet] = useState<WoolBalePrintSheet | null>(null);
  const [loadingBalePrint, setLoadingBalePrint] = useState(false);
  const [savingWoolBale, setSavingWoolBale] = useState(false);
  // Session to auto-select when the baling screen opens (set by the
  // "Start baling" hand-off after a shear upload).
  const [pendingBalingSessionId, setPendingBalingSessionId] = useState('');

  // Data Session Upload state
  const [dataSessionLocationFilter, setDataSessionLocationFilter] = useState('');
  const [dataSessionForm, setDataSessionForm] = useState({
    sessionId: '',
    category: '',
    eventType: '',
    delimiter: ',',
    species: 'SHEEP',
    sourceEntityId: '',
    destEntityId: '',
    file: null as File | null,
  });
  // Smart event creation: open ("expected") dispatches matching a receive's
  // destination, and the exception report after accepting one.
  const [expectedDispatches, setExpectedDispatches] = useState<ExpectedReceiptMatch[]>([]);
  const [loadingExpectedDispatches, setLoadingExpectedDispatches] = useState(false);
  const [dispatchAcceptResult, setDispatchAcceptResult] = useState<ReceiveFromDispatchResult | null>(null);
  // Confirm-before-create step for accepting a dispatch: the dry-run preview of
  // what would be received, the match it came from, and in-flight flags.
  const [dispatchReceivePreview, setDispatchReceivePreview] = useState<DispatchReceivePreview | null>(null);
  const [dispatchPreviewMatch, setDispatchPreviewMatch] = useState<ExpectedReceiptMatch | null>(null);
  const [loadingDispatchPreviewId, setLoadingDispatchPreviewId] = useState<string | null>(null);
  const [confirmingDispatchReceive, setConfirmingDispatchReceive] = useState(false);
  const [dataSessionError, setDataSessionError] = useState('');
  const [dataSessionSuccess, setDataSessionSuccess] = useState('');
  const [savingDataSession, setSavingDataSession] = useState(false);
  const [dataSessionResult, setDataSessionResult] = useState<any>(null);
  const [relinkingSession, setRelinkingSession] = useState(false);
  const [relinkResult, setRelinkResult] = useState<any>(null);
  const [uploadAuditEvents, setUploadAuditEvents] = useState<any[]>([]);
  const [eventHistoryRows, setEventHistoryRows] = useState<any[]>([]);
  const [loadingEventHistory, setLoadingEventHistory] = useState(false);
  const [eventHistoryError, setEventHistoryError] = useState('');
  const [eventHistorySearch, setEventHistorySearch] = useState('');
  const [eventHistoryPage, setEventHistoryPage] = useState(1);
  const [editingEventId, setEditingEventId] = useState('');
  const [editingEventDealId, setEditingEventDealId] = useState('');
  const [eventEditForm, setEventEditForm] = useState({ eventDate: '', animalCount: '', sourceEntityId: '', destinationEntityId: '', species: '' });
  const [eventEditSourceUnit, setEventEditSourceUnit] = useState<EntitySummary | null>(null);
  const [eventEditDestUnit, setEventEditDestUnit] = useState<EntitySummary | null>(null);
  const [eventEditSourceSearch, setEventEditSourceSearch] = useState('');
  const [eventEditDestSearch, setEventEditDestSearch] = useState('');
  const [showEventEditSourceDropdown, setShowEventEditSourceDropdown] = useState(false);
  const [showEventEditDestDropdown, setShowEventEditDestDropdown] = useState(false);
  const [savingEventEdit, setSavingEventEdit] = useState(false);
  const [eventActionError, setEventActionError] = useState('');
  const [eventActionSuccess, setEventActionSuccess] = useState('');
  // Retroactively add a missing receive event (e.g. an abattoir-receive for
  // animals only captured at slaughter) so a transport journey has an event to
  // link to. Restricted to receive types by the backend.
  const [showAddEventForm, setShowAddEventForm] = useState(false);
  const [addEventForm, setAddEventForm] = useState({
    dealId: '', eventTypeCode: 'ABAT_REC', eventDate: '', animalCount: '', species: '', sourceEntityId: '', destinationEntityId: '',
  });
  const [addEventSourceUnit, setAddEventSourceUnit] = useState<EntitySummary | null>(null);
  const [addEventDestUnit, setAddEventDestUnit] = useState<EntitySummary | null>(null);
  const [addEventSourceSearch, setAddEventSourceSearch] = useState('');
  const [addEventDestSearch, setAddEventDestSearch] = useState('');
  const [showAddEventSourceDropdown, setShowAddEventSourceDropdown] = useState(false);
  const [showAddEventDestDropdown, setShowAddEventDestDropdown] = useState(false);
  const [savingAddEvent, setSavingAddEvent] = useState(false);
  const [journeyHistoryRows, setJourneyHistoryRows] = useState<any[]>([]);
  const [loadingJourneyHistory, setLoadingJourneyHistory] = useState(false);
  const [journeyHistoryError, setJourneyHistoryError] = useState('');
  const [journeyHistorySearch, setJourneyHistorySearch] = useState('');

  // Weighbridge History (all records, client-side search + pagination)
  const [weighbridgeHistoryRows, setWeighbridgeHistoryRows] = useState<any[]>([]);
  const [loadingWeighbridgeHistory, setLoadingWeighbridgeHistory] = useState(false);
  const [weighbridgeHistoryError, setWeighbridgeHistoryError] = useState('');
  const [weighbridgeHistorySearch, setWeighbridgeHistorySearch] = useState('');
  const [weighbridgeHistoryPage, setWeighbridgeHistoryPage] = useState(1);

  // Standalone "New weighbridge record" form (independent of the Add-Journey flow)
  const emptyWeighbridgeStandaloneForm = { dealId: '', dealEventId: '', journeyId: '', recordedAt: '', grossWeightKg: '', tareWeightKg: '', notes: '' };
  const [wbForm, setWbForm] = useState(emptyWeighbridgeStandaloneForm);
  const [editingWbId, setEditingWbId] = useState('');
  const [wbReceiveSearch, setWbReceiveSearch] = useState('');
  const [wbShowReceiveDropdown, setWbShowReceiveDropdown] = useState(false);
  const [wbJourneyOptions, setWbJourneyOptions] = useState<TransportJourneySummary[]>([]);
  const [wbSaving, setWbSaving] = useState(false);
  const [wbError, setWbError] = useState('');
  const [wbSuccess, setWbSuccess] = useState('');
  const [sourceEntitySearch, setSourceEntitySearch] = useState('');
  const [destEntitySearch, setDestEntitySearch] = useState('');
  const [dataSessionDealSearch, setDataSessionDealSearch] = useState('');
  const [showSourceDropdown, setShowSourceDropdown] = useState(false);
  const [showDestDropdown, setShowDestDropdown] = useState(false);
  const [showDataSessionDealDropdown, setShowDataSessionDealDropdown] = useState(false);
  const [dataSessionFileKey, setDataSessionFileKey] = useState(0);
  const [fileValidation, setFileValidation] = useState<{
    status: 'idle' | 'validating' | 'ok' | 'warning' | 'error';
    totalRows: number;
    detectedDelimiter: string;
    missingRequired: { key: string; description: string; acceptedNames: string }[];
    missingRecommended: { key: string; description: string; acceptedNames: string }[];
    blankIdentifierRows: number;
    parsedHeaders: string[];
    sampleIssues: { row: number; issue: string }[];
    crossDealEids: { eid: string; deal_no: string }[];
    eidCheckPending: boolean;
  } | null>(null);
  const [unprocessedAdminRows, setUnprocessedAdminRows] = useState<any[]>([]);
  const [loadingUnprocessedAdmin, setLoadingUnprocessedAdmin] = useState(false);
  const [unprocessedDealId, setUnprocessedDealId] = useState('');
  const [unlinkedAnimals, setUnlinkedAnimals] = useState<any[]>([]);
  const [loadingUnlinkedAnimals, setLoadingUnlinkedAnimals] = useState(false);
  const [unlinkedAnimalsError, setUnlinkedAnimalsError] = useState(false);
  const [unlinkedOnlyWithEid, setUnlinkedOnlyWithEid] = useState(false);
  const [unlinkedSearch, setUnlinkedSearch] = useState('');
  const [eventHeadcountById, setEventHeadcountById] = useState<Record<string, number>>({});

  // Draft session (upload-as-draft → preview → confirm) state
  const [draftMode] = useState(true);
  const [draftSessionId, setDraftSessionId] = useState<string | null>(null);
  // Set when the just-uploaded file matches an earlier upload (same content or
  // same logical event) — drives the delta prompt before confirming.
  const [duplicateUpload, setDuplicateUpload] = useState<any>(null);
  // Operator's choice for a same-event-key (differing content) match: apply as a
  // delta to the existing event vs. create a separate event (the safe default).
  // Exact re-uploads attach automatically on the backend regardless of this.
  const [applyAsDelta, setApplyAsDelta] = useState(false);
  const [draftPreview, setDraftPreview] = useState<any>(null);
  const [draftPreviewSummary, setDraftPreviewSummary] = useState<any>(null);
  const [loadingDraftPreview, setLoadingDraftPreview] = useState(false);
  const [confirmingDraft, setConfirmingDraft] = useState(false);
  // Final "review before creating" step: after "Confirm & process" the operator
  // sees a clear summary (event type, entities + GLN, file name) and must click
  // "Create event" to actually process the draft.
  const [showCreateEventConfirm, setShowCreateEventConfirm] = useState(false);
  // True while an ingest upload/confirm is in flight creating records. Used to
  // (a) warn before a full page unload and (b) keep the in-flight upload's
  // state from being reset when the user navigates away and back.
  const ingestInFlight = savingDataSession || confirmingDraft;
  const ingestInFlightRef = useRef(false);
  ingestInFlightRef.current = ingestInFlight;
  const [vaccinationEntries, setVaccinationEntries] = useState<VaccinationEntryRow[]>([]);
  const [vaccinationStepOpen, setVaccinationStepOpen] = useState(false);
  const [draftConfirmResult, setDraftConfirmResult] = useState<any>(null);
  const [userMappings, setUserMappings] = useState<Record<string, string>>({});
  const [fieldMappingsMeta, setFieldMappingsMeta] = useState<{ event_types: { value: string; label: string }[]; target_fields: { value: string; label: string }[] } | null>(null);

  // Admin cost-reports state
  const [costReports, setCostReports] = useState<any[]>([]);
  const [loadingCostReports, setLoadingCostReports] = useState(false);
  const [costReportsDealId, setCostReportsDealId] = useState('');
  const [dealAdminReport, setDealAdminReport] = useState<any>(null);
  const [loadingDealAdminReport, setLoadingDealAdminReport] = useState(false);
  // Performance report — completely separate state so it never shares with cost reports
  const [perfReportDealId, setPerfReportDealId] = useState('');
  const [perfReport, setPerfReport] = useState<any>(null);
  const [loadingPerfReport, setLoadingPerfReport] = useState(false);
  const [perfReportDealSearch, setPerfReportDealSearch] = useState('');
  const [showPerfReportDealDropdown, setShowPerfReportDealDropdown] = useState(false);
  const [perfReportAggregate, setPerfReportAggregate] = useState<AnimalLocationPerformanceGroup | null>(null);
  const [loadingPerfReportAggregate, setLoadingPerfReportAggregate] = useState(false);
  const [perfReportValueChainId, setPerfReportValueChainId] = useState('');
  const [perfReportAnimals, setPerfReportAnimals] = useState<AnimalPerformanceRow[]>([]);
  const [loadingPerfReportAnimals, setLoadingPerfReportAnimals] = useState(false);
  const [perfReportAnimalSearch, setPerfReportAnimalSearch] = useState('');
  const [perfReportAnimalPage, setPerfReportAnimalPage] = useState(1);
  const PERF_REPORT_ANIMAL_PAGE_SIZE = 25;
  // Mortality-trend drilldown: when true, the report body hides its usual
  // metrics/animal breakdown and shows the all-time month-on-month chart.
  const [showMortalityTrend, setShowMortalityTrend] = useState(false);
  const [mortalityTrend, setMortalityTrend] = useState<MortalityTimeseries | null>(null);
  const [loadingMortalityTrend, setLoadingMortalityTrend] = useState(false);

  const [newEntityForm, setNewEntityForm] = useState(blankEntityForm);
  // The "New entity" flow only -- editing an existing entity keeps the single
  // flat form (a quick field tweak shouldn't cost four clicks to reach).
  const [entityWizardStep, setEntityWizardStep] = useState<1 | 2 | 3 | 4>(1);
  // Queued on the wizard's last step and fired right after the entity row
  // exists -- the Virtual Routez request needs a saved entity id, same reason
  // GLN allocation and contact linking also run post-create inside submit.
  const [entityRequestVrzOnboarding, setEntityRequestVrzOnboarding] = useState(false);
  // RMIS participant tokens are per *user*, not per entity: the movement code
  // walks Entity -> primary contact -> that user's security profile. So the
  // wizard captures them here but writes them onto the primary contact user it
  // creates or links in the Contacts step -- no entity-level field exists or
  // is needed.
  const [entityRmisEnabled, setEntityRmisEnabled] = useState(false);
  const [entityRmisTestToken, setEntityRmisTestToken] = useState('');
  const [entityRmisProductionToken, setEntityRmisProductionToken] = useState('');
  const [nextEntityNoPreview, setNextEntityNoPreview] = useState('');
  const [loadingNextEntityNo, setLoadingNextEntityNo] = useState(false);
  const [createdEntityContactTargetId, setCreatedEntityContactTargetId] = useState('');
  const [entityContactLinkQuery, setEntityContactLinkQuery] = useState('');
  const [entityContactLinkUserId, setEntityContactLinkUserId] = useState('');
  const [entityContactLinkPrimary, setEntityContactLinkPrimary] = useState(true);
  const [entityContactLinkMode, setEntityContactLinkMode] = useState<'search' | 'create'>('search');
  const [entityNewContactForm, setEntityNewContactForm] = useState({ firstName: '', lastName: '', email: '', phoneNo: '' });
  const [entityNewContactCreateLogin, setEntityNewContactCreateLogin] = useState(false);
  const [entityGlnMode, setEntityGlnMode] = useState<'none' | 'allocate' | 'manual'>('none');
  const [entityManualGlnCode, setEntityManualGlnCode] = useState('');
  const [entityGtinAllocationsToAdd, setEntityGtinAllocationsToAdd] = useState<{ mode: 'allocate' | 'manual'; productTypeId: string; gs1Code: string }[]>([]);
  const [newContactForm, setNewContactForm] = useState({
    userId: '',
    phoneNo: '',
    isPrimary: true,
  });
  const [contactDetailsForm, setContactDetailsForm] = useState({
    name: '',
    phoneNo: '',
    email: '',
    username: '',
  });
  const [contactEntityLinks, setContactEntityLinks] = useState<Array<{ id?: string; entityId: string; isPrimary: boolean }>>([]);
  const [contactAddEntityId, setContactAddEntityId] = useState('');
  const [contactAddEntityPrimary, setContactAddEntityPrimary] = useState(false);
  const [contactDirectorySearch, setContactDirectorySearch] = useState('');
  const [contactEditorEntityId, setContactEditorEntityId] = useState('');
  const [contactEditorMode, setContactEditorMode] = useState<'existing' | 'newUser'>('existing');
  const [newContactUserForm, setNewContactUserForm] = useState({
    username: '',
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: '',
    isStaff: false,
  });

  const entityOptions = useMemo(() => {
    // Keep options aligned with loaded ordering/data.
    if (entityDirectory.length > 0) {
      return entityDirectory.map((entity) => ({ id: entity.id, label: entity.entityName }));
    }
    return primaryProducerOptions;
  }, [entityDirectory, primaryProducerOptions]);

  const loadDeals = async () => {
    setLoadingDeals(true);
    try {
      let animalSummaryFailed = false;
      const [apiDeals, adminOverview, animalSummary, locationAnimals, entityRows, entityContacts, stats] = await Promise.all([
        fetchDeals(),
        fetchDealsAdminOverview().catch(() => []),
        fetchAnimalSummary().catch(() => { animalSummaryFailed = true; return { by_deal: {}, total: 0, eid_count: 0, non_eid_count: 0, species: {} }; }),
        fetchAnimalLocations().catch(() => []),
        fetchEntities().catch(() => []),
        fetchEntityContacts().catch(() => []),
        fetchSystemStats().catch(() => null),
      ]);
      setAnimalSummaryLoadError(animalSummaryFailed);
      setSystemStats(stats);

      setAnimalRegister(locationAnimals);

      const mapped: Deal[] = apiDeals.map((deal) => ({
        dealId: String(deal.dealId),
        title: deal.title || 'Untitled deal',
        dealRefNo: (deal as any).deal_reference_no || '',
        counterpart: deal.counterpart || '—',
        primaryProducerId: deal.primaryProducerId,
        startDate: deal.startDate,
        headcount: Number(deal.headcount || 0),
        status: deal.status === 'Cancelled' ? 'Cancelled' : deal.status === 'Completed' ? 'Completed' : 'Active',
        completedUnderOverride: deal.completedUnderOverride === true,
        species: (deal as any).species ?? null,
        registrationTotalAnimals: deal.registrationTotalAnimals,
        registrationAnimalsWithEid: deal.registrationAnimalsWithEid,
        registrationAnimalsWithoutEid: deal.registrationAnimalsWithoutEid,
        isScpDeal: deal.isScpDeal === true,
        scpName: deal.scpName ?? null,
        valueChainId: deal.valueChainId,
      }));

      const contactsByEntity = new Map<string, EntitySummary['contacts']>();
      entityContacts.forEach((contact) => {
        if (!contact.entityId) return;
        const existing = contactsByEntity.get(contact.entityId) || [];
        existing.push(contact);
        contactsByEntity.set(contact.entityId, existing);
      });
      const entityRowsWithContacts = entityRows.map((entity) => ({
        ...entity,
        contacts: entity.contacts.length > 0 ? entity.contacts : (contactsByEntity.get(entity.id) || []),
      }));
      const entityProfileById = new Map<string, EntityProfile>(
        entityRowsWithContacts.map((entity) => [entity.id, {
          id: entity.id,
          label: entity.entityName,
          farmerName: entity.entityName,
          addressLine1: entity.addressLine1 || '',
          addressLine2: entity.addressLine2 || '',
          latitude: entity.latitude || '',
          longitude: entity.longitude || '',
          contacts: entity.contacts || [],
        }])
      );

      setDeals(mapped);
      setAnimalSummaryByDeal(animalSummary.by_deal);
      setEntityDirectory(entityRowsWithContacts);

      const overviewById: Record<string, DealAdminOverviewItem> = {};
      const producerById = new Map<string, string>();
      const valueChainById = new Map<string, string>();

      for (const row of adminOverview) {
        overviewById[row.id] = row;
        if (row.primary_producer?.id) {
          const producer = row.primary_producer as any;
          const producerLabel = producer?.entity_name || producer?.id || '';
          producerById.set(row.primary_producer.id, producerLabel);
        }
        if (row.value_chain?.id) {
          valueChainById.set(row.value_chain.id, row.value_chain.name || row.value_chain.id);
        }
      }

      setDealOverviewById(overviewById);
      // Merge (don't replace): admin-overview only surfaces producers that
      // already have a deal, so replacing would drop a producer with no deals
      // yet on every reload. Union with prior options so the list never shrinks.
      setPrimaryProducerOptions((prev) => {
        const merged = new Map<string, string>(prev.map((o) => [o.id, o.label]));
        producerById.forEach((label, id) => merged.set(id, label));
        return Array.from(merged.entries()).map(([id, label]) => ({ id, label }));
      });
      setEntityProfilesById(Object.fromEntries(Array.from(entityProfileById.entries())));
      // Merge (don't replace): admin-overview only surfaces value chains that
      // already have a deal, so replacing here would drop any value chain with
      // no deals yet (e.g. a freshly created one) from the new-deal dropdown
      // after every reload. Union with the full list loaded by
      // loadValueChainOptions() so options never shrink on a deal create/reload.
      setValueChainOptions((prev) => {
        const merged = new Map<string, string>(prev.map((o) => [o.id, o.label]));
        valueChainById.forEach((label, id) => merged.set(id, label));
        return Array.from(merged.entries()).map(([id, label]) => ({ id, label }));
      });

      if (mapped.length > 0) {
        const firstDealId = mapped[0].dealId;
        setSelectedDealId((prev) => prev || firstDealId);
        setFeedForm((prev) => ({ ...prev, dealId: prev.dealId || firstDealId }));
        setAnimalForm((prev) => ({ ...prev, dealId: prev.dealId || firstDealId }));
        setDocumentForm((prev) => ({ ...prev, dealId: prev.dealId || firstDealId }));
      }

      // Derive accurate headcounts from deal events — via one server-side
      // aggregate call (GET /api/deals/headcount-summary/) instead of
      // fetching every deal's full event list client-side (previously one
      // GET /api/deals/{id}/events/ per deal, ~90 requests on every load).
      fetchDealHeadcountSummary()
        .then(({ by_deal }) => {
          const results = mapped.map((d) => {
            const totals = by_deal[d.dealId] || {};
            const farmDis = Number(totals['FARM_DIS'] || 0);
            const feedRec = Number(totals['FEED_REC'] || 0);
            const farmReg = Number(totals['FARM_REG'] || 0) + Number(totals['FARM_BIR'] || 0);
            const farmEventTotal = Math.max(farmReg, farmDis);
            return { dealId: d.dealId, headcount: farmEventTotal || feedRec || Number(d.headcount) };
          });
          setEventHeadcountById((prev) => {
            const next = { ...prev };
            results.forEach(({ dealId, headcount }) => { next[dealId] = headcount; });
            return next;
          });
        })
        .catch(() => {});

      return mapped;
    } finally {
      setLoadingDeals(false);
    }
  };

  const refreshDashboardData = async () => {
    await loadDeals();
    if (!selectedDealId) return;
    delete trackingCacheRef.current[selectedDealId];
    setLoadingDealSummaryTracking(true);
    setDealSummaryTrackingError('');
    try {
      const tracking = await fetchTracking(selectedDealId);
      trackingCacheRef.current[selectedDealId] = tracking;
      setDealSummaryTracking(tracking);
    } catch (error: any) {
      setDealSummaryTracking(null);
      setDealSummaryTrackingError(error?.message || 'Could not load deal tracking data.');
    } finally {
      setLoadingDealSummaryTracking(false);
    }
  };

  const loadExistingDocuments = async (dealId: string) => {
    if (!dealId) {
      setDealDocumentRows([]);
      setTransportJourneyRows([]);
      setWoolFinanceRows([]);
      return;
    }
    setLoadingExistingDocuments(true);
    try {
      const [dealDocs, journeys, woolFinances] = await Promise.all([
        fetchDealDocumentsForDeal(dealId).catch(() => []),
        fetchTransportJourneys(dealId).catch(() => []),
        fetchWoolFinances(dealId).catch(() => []),
      ]);
      setDealDocumentRows(dealDocs);
      setTransportJourneyRows(journeys);
      setWoolFinanceRows(woolFinances);
    } finally {
      setLoadingExistingDocuments(false);
    }
  };

  const loadDocumentsList = async (page = 1) => {
    setDocumentsListLoading(true);
    setDocumentsListError('');
    try {
      const sources: DocumentSource[] = documentsListSource === 'all'
        ? ['deal', 'transport', 'wool', 'feedlot']
        : [documentsListSource];
      const res = await fetchDocuments({
        sources,
        q: documentsListSearch.trim() || undefined,
        page,
        pageSize: DOCUMENTS_LIST_PAGE_SIZE,
      });
      setDocumentsList(res.results);
      setDocumentsListCount(res.count);
      setDocumentsListNumPages(res.numPages);
      setDocumentsListPage(res.page);
    } catch (err: any) {
      setDocumentsList([]);
      setDocumentsListError(parseApiError(err?.message) || 'Could not load documents.');
    } finally {
      setDocumentsListLoading(false);
    }
  };

  const runDocumentSearch = async (page = 1) => {
    setDocSearchLoading(true);
    setDocSearchError('');
    setDocSearchHasSearched(true);
    try {
      const sources = (Object.keys(docSearchSources) as DocumentSource[]).filter((s) => docSearchSources[s]);
      if (sources.length === 0) {
        setDocSearchResults([]);
        setDocSearchCount(0);
        setDocSearchNumPages(1);
        setDocSearchError('Select at least one document source to search.');
        return;
      }
      const res = await fetchDocuments({
        sources,
        q: docSearchQuery.trim() || undefined,
        dealId: docSearchDealId || undefined,
        dateFrom: docSearchDateFrom || undefined,
        dateTo: docSearchDateTo || undefined,
        page,
        pageSize: DOC_SEARCH_PAGE_SIZE,
      });
      setDocSearchResults(res.results);
      setDocSearchCount(res.count);
      setDocSearchNumPages(res.numPages);
      setDocSearchPage(res.page);
    } catch (err: any) {
      setDocSearchResults([]);
      setDocSearchError(parseApiError(err?.message) || 'Document search failed.');
    } finally {
      setDocSearchLoading(false);
    }
  };

  useEffect(() => {
    loadDeals();
  }, []);;

  useEffect(() => {
    if (view === 'gs1Gln' || view === 'gs1Gtin') {
      if (!hasLoadedGs1CodesRef.current) loadGs1Codes();
      if (!hasLoadedEntityDirectoryRef.current) loadEntityDirectory();
    } else if (view === 'entityCrud' || view === 'entityForm' || view === 'entityContacts' || view === 'entityContactForm') {
      if (!hasLoadedEntityDirectoryRef.current) loadEntityDirectory();
      if ((view === 'entityCrud' || view === 'entityForm') && !hasLoadedGs1CodesRef.current) loadGs1Codes();
      if ((view === 'entityCrud' || view === 'entityForm') && !hasLoadedValueChainOptionsRef.current) loadValueChainOptions();
      if ((view === 'entityContacts' || view === 'entityContactForm' || view === 'entityForm') && !hasLoadedAdminUsersRef.current) loadAdminUsers();
      // The entity view's History + Animals tabs need the full animal list to
      // compute per-species lifecycle counts and list the entity's animals.
      if (view === 'entityForm' && allAnimals.length === 0 && !allAnimalsLoading) {
        setAllAnimalsLoading(true);
        setAllAnimalsError(null);
        fetchAnimals()
          .then(setAllAnimals)
          .catch((e) => setAllAnimalsError(e?.message || 'Failed to load animals.'))
          .finally(() => setAllAnimalsLoading(false));
      }
    } else if (view === 'scpAnalysis') {
      // The programme filter needs the full SCP list, including programmes
      // with no deals yet, so it does not shrink to whatever the dashboard saw.
      if (!hasLoadedValueChainOptionsRef.current) loadValueChainOptions();
    } else if (view === 'performanceReport') {
      if (!hasLoadedValueChainOptionsRef.current) loadValueChainOptions();
      // Always land on the metrics view, not a lingering mortality drilldown.
      setShowMortalityTrend(false);
    } else if (view === 'userManagement') {
      if (!hasLoadedAdminUsersRef.current) loadAdminUsers();
    } else if (view === 'dealCreate') {
      if (!hasLoadedEntityDirectoryRef.current) loadEntityDirectory();
      // Step 4's medication capture and group treatment pick from the
      // medicine catalogue.
      if (medicines.length === 0 && !loadingMedicines) {
        setLoadingMedicines(true);
        fetchMedicines().then(setMedicines).catch(() => {}).finally(() => setLoadingMedicines(false));
      }
      // The flow needs the full value-chain records (not just id/label
      // options): the SCP flag is inherited from the chain chosen here.
      if (valueChains.length === 0 && !loadingValueChains) {
        setLoadingValueChains(true);
        fetchValueChains().then(setValueChains).catch(() => {}).finally(() => setLoadingValueChains(false));
      }
    } else if (view === 'integrations') {
      loadIntegrationSystems();
    } else if (view === 'abattoirSlaughter') {
      loadAbattoirReceipts();
    } else if (view === 'unlinkedAnimals') {
      setLoadingUnlinkedAnimals(true);
      setUnlinkedAnimalsError(false);
      fetchUnlinkedAnimals({ hasEid: unlinkedOnlyWithEid, search: unlinkedSearch })
        .then((r) => setUnlinkedAnimals(r.results))
        .catch(() => setUnlinkedAnimalsError(true))
        .finally(() => setLoadingUnlinkedAnimals(false));
    } else if (view === 'breedCrud' || view === 'animalCrud') {
      if (view === 'animalCrud' && breeds.length === 0) {
        setLoadingBreeds(true);
        fetchBreeds().then(setBreeds).catch(() => {}).finally(() => setLoadingBreeds(false));
        return;
      }
      if (breeds.length > 0) return;
      setLoadingBreeds(true);
      fetchBreeds().then(setBreeds).catch((e) => setBreedCrudError(e?.message || 'Failed to load breeds.')).finally(() => setLoadingBreeds(false));
    } else if (view === 'animalList') {
      // Location register enriches the current-location / GLN columns for
      // live animals; the full animal list is the row source (so deal-less,
      // EID-only animals still appear).
      if (animalRegister.length === 0) {
        fetchAnimalLocations().then(setAnimalRegister).catch(() => {});
      }
      if (allAnimals.length === 0) {
        setAllAnimalsLoading(true);
        setAllAnimalsError(null);
        fetchAnimals()
          .then(setAllAnimals)
          .catch((e) => setAllAnimalsError(e?.message || 'Failed to load animals.'))
          .finally(() => setAllAnimalsLoading(false));
      }
      setAnimalCrudError('');
      setAnimalCrudSuccess('');
    } else if (view === 'valueChainCrud') {
      // The catalogue is backend code, so it is fetched rather than mirrored
      // here — a capture field added server-side shows up without a frontend
      // release. Fetched independently of the chain list so a catalogue
      // failure degrades the matrix, not the whole screen.
      if (vcCatalogue.length === 0) {
        fetchFieldCatalogue()
          .then(setVcCatalogue)
          .catch((e) => setVcCatalogueError(e?.message || 'Failed to load the field catalogue.'));
      }
      if (valueChains.length > 0) return;
      setLoadingValueChains(true);
      fetchValueChains().then(setValueChains).catch((e) => setValueChainCrudError(e?.message || 'Failed to load supply chain programs.')).finally(() => setLoadingValueChains(false));
    } else if (view === 'productTypeCrud') {
      if (productTypeList.length > 0) return;
      setLoadingProductTypeList(true);
      fetchProductTypes().then(setProductTypeList).catch((e) => setProductTypeCrudError(e?.message || 'Failed to load product types.')).finally(() => setLoadingProductTypeList(false));
    } else if (view === 'medicineCrud') {
      if (medicines.length > 0) return;
      setLoadingMedicines(true);
      fetchMedicines().then(setMedicines).catch((e) => setMedicineCrudError(e?.message || 'Failed to load medicines.')).finally(() => setLoadingMedicines(false));
    } else if (view === 'equipmentAllocation') {
      if (equipmentList.length > 0) return;
      setLoadingEquipment(true);
      fetchEquipmentList().then(setEquipmentList).catch((e) => setEquipmentCrudError(e?.message || 'Failed to load equipment.')).finally(() => setLoadingEquipment(false));
    } else if (view === 'documentTypeCrud') {
      setLoadingDocumentTypeRows(true);
      fetchDocumentTypes().then(setDocumentTypes).catch((e) => setDocumentTypeCrudError(e?.message || 'Failed to load document types.')).finally(() => setLoadingDocumentTypeRows(false));
    } else if (view === 'woolClassCrud') {
      if (woolClasses.length > 0) return;
      setLoadingWoolClasses(true);
      fetchWoolClasses().then(setWoolClasses).catch((e) => setWoolClassCrudError(e?.message || 'Failed to load wool classes.')).finally(() => setLoadingWoolClasses(false));
    } else if (view === 'woolBales') {
      if (woolClasses.length === 0) {
        setLoadingWoolClasses(true);
        fetchWoolClasses().then(setWoolClasses).catch(() => {}).finally(() => setLoadingWoolClasses(false));
      }
      if (breeds.length === 0) {
        setLoadingBreeds(true);
        fetchBreeds().then(setBreeds).catch(() => {}).finally(() => setLoadingBreeds(false));
      }
      fetchBalingSessions().then((sessions) => {
        setWoolSessionsForDeal(sessions);
        // Auto-select the session handed off from a just-completed shear upload.
        if (pendingBalingSessionId) {
          const id = pendingBalingSessionId;
          setWoolBalesSessionId(id);
          fetchWoolBales(id).then(setWoolBalesForSession).catch(() => setWoolBalesForSession([]));
          setPendingBalingSessionId('');
        }
      }).catch(() => {});
      setWoolBaleError('');
      setWoolBaleSuccess('');
    } else if (view === 'dealList') {
      // Clear any leftover delete feedback so it can't be mistaken for the
      // result of an action taken on this visit to the screen.
      setDealCrudError('');
      setDealCrudSuccess('');
    } else if (view === 'dataSessionUpload') {
      // Don't reset the form while an upload/confirm is still creating records:
      // the request keeps running across view switches, so navigating away and
      // back must not wipe the in-flight state or its result panel.
      if (!ingestInFlightRef.current) {
        setDataSessionError('');
        setDataSessionSuccess('');
        setDataSessionResult(null);
        setDraftConfirmResult(null);
        setUploadAuditEvents([]);
      }
    } else if (view === 'transportJourneys') {
      // Skip when we just navigated here to edit an existing row — openJourneyHistoryRowForEdit
      // already populated documentForm/editingTransportJourneyId, and resetting here would
      // immediately wipe that state out from under it.
      if (editingTransportJourneyId) {
        return;
      }
      resetDocumentForm();
      if (selectedDealId) {
        Promise.all([
          fetchTransportJourneys(selectedDealId),
          fetchDealEventLabels(selectedDealId).catch(() => ({})),
        ])
          .then(([journeys, labels]) => {
            setTransportJourneyRows(journeys);
            setDealEventLabelsById(labels);
          })
          .catch(() => setTransportJourneyRows([]));
      }
    } else if (view === 'dashboard') {
      // Refresh the animal register whenever the dashboard is opened so the
      // value-chain card reflects recent uploads/edits (e.g. a dispatch, or a
      // corrected event destination) rather than the snapshot loaded at mount.
      fetchAnimalLocations().then(setAnimalRegister).catch(() => {});
    }
  }, [view]);

  // System stats for the operations dashboard, scoped by the filter bar
  // (species / Supply Chain Program / deal). Refetched when any filter changes.
  useEffect(() => {
    if (view !== 'dashboard') return;
    let cancelled = false;
    fetchSystemStats({
      species: dashboardSpecies === 'ALL' ? undefined : dashboardSpecies,
      valueChainId:
        dashboardScp !== DASHBOARD_SCP_ALL && dashboardScp !== DASHBOARD_SCP_MATRIX
          ? dashboardScp
          : undefined,
      scpMatrix: dashboardScp === DASHBOARD_SCP_MATRIX,
      dealId: dashboardDealFilter || undefined,
    })
      .then((stats) => {
        if (cancelled) return;
        setDashboardStats(stats);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [view, dashboardSpecies, dashboardScp, dashboardDealFilter]);

  // Programme analysis: server-side pooling, so money is summed and divided by
  // the pooled headcount and a small deal cannot pull the programme's
  // per-animal figures the way an average of averages would.
  useEffect(() => {
    if (view !== 'scpAnalysis') return;
    if (scpAnalysisFrom && scpAnalysisTo && scpAnalysisTo < scpAnalysisFrom) {
      setScpAnalysisError('The end of the range is before its start.');
      return;
    }
    let cancelled = false;
    setScpAnalysisLoading(true);
    setScpAnalysisError('');
    fetchMarginSummary({
      valueChainId:
        scpAnalysisScp !== DASHBOARD_SCP_ALL && scpAnalysisScp !== DASHBOARD_SCP_MATRIX
          ? scpAnalysisScp
          : undefined,
      scpMatrix: scpAnalysisScp === DASHBOARD_SCP_MATRIX,
      includeClosed: true,
      startedFrom: scpAnalysisFrom || undefined,
      startedTo: scpAnalysisTo || undefined,
    })
      .then((summary) => { if (!cancelled) setScpAnalysis(summary); })
      .catch((err: any) => {
        if (cancelled) return;
        setScpAnalysis(null);
        setScpAnalysisError(err?.message || 'The programme figures could not be loaded.');
      })
      .finally(() => { if (!cancelled) setScpAnalysisLoading(false); });
    return () => { cancelled = true; };
  }, [view, scpAnalysisScp, scpAnalysisFrom, scpAnalysisTo]);

  // While an ingest upload/confirm is creating records, warn before a full page
  // unload (refresh / tab close / browser back). In-app view switches don't need
  // guarding — this screen stays mounted and the request runs to completion — but
  // a real page unload would abort the request mid-creation.
  useEffect(() => {
    if (!ingestInFlight) return;
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [ingestInFlight]);

  useEffect(() => {
    if (showCreateContactModal && !hasLoadedAdminUsersRef.current) {
      loadAdminUsers();
    }
  }, [showCreateContactModal]);

  useEffect(() => {
    if (view !== 'eventHistory') return;
    setEventHistoryPage(1);
    if (deals.length === 0) {
      setEventHistoryRows([]);
      return;
    }

    let cancelled = false;
    setLoadingEventHistory(true);
    setEventHistoryError('');

    Promise.all(
      deals.map((deal) =>
        fetchDealEvents(deal.dealId)
          .then((events) => events.map((evt: any) => ({ ...evt, deal })))
          .catch(() => [])
      )
    )
      .then((groups) => {
        if (cancelled) return;
        setEventHistoryRows(
          groups.flat().sort(
            (a: any, b: any) =>
              eventTimestamp(b) - eventTimestamp(a) ||
              valueChainEventRank(a.event_type) - valueChainEventRank(b.event_type)
          )
        );
      })
      .catch((error: any) => {
        if (cancelled) return;
        setEventHistoryRows([]);
        setEventHistoryError(error?.message || 'Could not load event history.');
      })
      .finally(() => {
        if (cancelled) return;
        setLoadingEventHistory(false);
      });

    return () => {
      cancelled = true;
    };
  }, [deals, uploadCompletedCount, view]);

  useEffect(() => {
    if (view !== 'journeyHistory') return;
    if (deals.length === 0) {
      setJourneyHistoryRows([]);
      return;
    }

    let cancelled = false;
    setLoadingJourneyHistory(true);
    setJourneyHistoryError('');

    Promise.all([
      fetchTransportJourneys().catch(() => []),
      Promise.all(
        deals.map((deal) =>
          fetchDealEvents(deal.dealId)
            .then((events) => events.map((evt: any) => ({ ...evt, deal })))
            .catch(() => [])
        )
      ),
      couriers.length > 0 ? Promise.resolve(couriers) : fetchCouriers().catch(() => []),
    ])
      .then(([journeys, eventGroups, courierRows]) => {
        if (cancelled) return;
        const eventsById = new Map<string, any>();
        eventGroups.flat().forEach((evt: any) => {
          if (evt?.id != null) eventsById.set(String(evt.id), evt);
        });
        const couriersById = new Map<string, CourierOption>();
        (courierRows as CourierOption[]).forEach((c) => couriersById.set(c.id, c));

        const rows = journeys
          .map((journey: TransportJourneySummary) => {
            const evt = journey.dealEventId ? eventsById.get(journey.dealEventId) : undefined;
            const deal = evt?.deal as Deal | undefined;
            const courier = journey.courierId ? couriersById.get(journey.courierId) : undefined;
            return {
              id: journey.id,
              journey,
              dealId: deal?.dealId || '',
              dealTitle: deal?.title || '',
              dealRefNo: deal?.dealRefNo || '',
              eventType: evt ? (EVENT_TYPE_LABELS[evt.event_type] || evt.event_type) : '',
              eventDate: evt?.event_date || '',
              vehicleRegistration: journey.vehicleRegistration || '',
              courierName: courier?.name || '',
              loadingDate: journey.loadingDate || '',
              offloadingDate: journey.offloadingDate || '',
              startKm: journey.startKm,
              endKm: journey.endKm,
              totalCost: journey.totalCost,
              waybillNo: journey.waybillNo || '',
              waybillUrl: journey.waybillUrl || '',
              invoiceUrl: journey.invoiceUrl || '',
              weighbridgeGrossWeightKg: journey.weighbridgeGrossWeightKg || '',
              weighbridgeTareWeightKg: journey.weighbridgeTareWeightKg || '',
              weighbridgeNetWeightKg: journey.weighbridgeNetWeightKg || '',
            };
          })
          .sort((a, b) => Date.parse(b.loadingDate || '') - Date.parse(a.loadingDate || '') || 0);

        setJourneyHistoryRows(rows);
      })
      .catch((error: any) => {
        if (cancelled) return;
        setJourneyHistoryRows([]);
        setJourneyHistoryError(error?.message || 'Could not load journey history.');
      })
      .finally(() => {
        if (cancelled) return;
        setLoadingJourneyHistory(false);
      });

    return () => {
      cancelled = true;
    };
  }, [deals, uploadCompletedCount, view]);

  // Weighbridge History: load every weighbridge record and resolve each to its
  // deal + receive event (mirrors the Journey History loader). List endpoint is
  // unpaginated, so search + pagination happen client-side in the renderer.
  useEffect(() => {
    if (view !== 'weighbridgeHistory') return;
    if (deals.length === 0) {
      setWeighbridgeHistoryRows([]);
      return;
    }

    let cancelled = false;
    setLoadingWeighbridgeHistory(true);
    setWeighbridgeHistoryError('');

    Promise.all([
      fetchWeighbridgeRecords().catch(() => []),
      Promise.all(
        deals.map((deal) =>
          fetchDealEvents(deal.dealId)
            .then((events) => events.map((evt: any) => ({ ...evt, deal })))
            .catch(() => [])
        )
      ),
    ])
      .then(([records, eventGroups]) => {
        if (cancelled) return;
        const eventsById = new Map<string, any>();
        eventGroups.flat().forEach((evt: any) => {
          if (evt?.id != null) eventsById.set(String(evt.id), evt);
        });

        const rows = (records as WeighbridgeRecordSummary[])
          .map((record) => {
            const evt = record.dealEventId ? eventsById.get(record.dealEventId) : undefined;
            const deal = evt?.deal as Deal | undefined;
            return {
              id: record.id,
              record,
              dealId: deal?.dealId || '',
              dealTitle: deal?.title || '',
              dealRefNo: deal?.dealRefNo || '',
              eventType: evt ? (EVENT_TYPE_LABELS[evt.event_type] || evt.event_type) : '',
              eventDate: evt?.event_date || '',
              recordedAt: record.recordedAt || '',
              grossWeightKg: record.grossWeightKg || '',
              tareWeightKg: record.tareWeightKg || '',
              netWeightKg: record.netWeightKg || '',
              truckNetWeightKg: record.truckNetWeightKg || '',
              sharedGroup: record.sharedGroup || '',
              headCount: record.headCount,
              journeyId: record.journeyId || '',
              journeyLabel: record.journeyVehicleRegistration
                ? [record.journeyVehicleRegistration, record.journeyLoadingDate ? fmtDate(record.journeyLoadingDate) : ''].filter(Boolean).join(' · ')
                : '',
              notes: record.notes || '',
            };
          })
          .sort((a, b) => Date.parse(b.recordedAt || '') - Date.parse(a.recordedAt || '') || 0);

        setWeighbridgeHistoryRows(rows);
        setWeighbridgeHistoryPage(1);
      })
      .catch((error: any) => {
        if (cancelled) return;
        setWeighbridgeHistoryRows([]);
        setWeighbridgeHistoryError(error?.message || 'Could not load weighbridge history.');
      })
      .finally(() => {
        if (cancelled) return;
        setLoadingWeighbridgeHistory(false);
      });

    return () => {
      cancelled = true;
    };
  }, [deals, uploadCompletedCount, view]);

  // Smart event creation: derive the concrete event_type from the chosen
  // category + the governing entity's type (destination for receive/non-movement,
  // source for dispatch) and keep dataSessionForm.eventType in sync so the rest
  // of the upload machinery (validation, deal-required, vaccination) is unchanged.
  useEffect(() => {
    const cat = dataSessionForm.category;
    const governing = cat === 'DISPATCH' ? sourceSelectedUnit : destSelectedUnit;
    const code = cat ? resolveEventTypeCode(cat, governing?.entityType).code : '';
    setDataSessionForm((f) => (f.eventType === code ? f : { ...f, eventType: code }));
  }, [dataSessionForm.category, sourceSelectedUnit, destSelectedUnit]);

  // Receive events: fetch open ("expected") dispatches heading to the chosen
  // destination so the operator can accept them or pre-fill from one.
  useEffect(() => {
    const cat = dataSessionForm.category;
    const destId = dataSessionForm.destEntityId;
    // A change of destination/species invalidates any open receive preview.
    setDispatchReceivePreview(null);
    setDispatchPreviewMatch(null);
    if (cat !== 'RECEIVE' || !destId) {
      setExpectedDispatches([]);
      return;
    }
    let cancelled = false;
    setLoadingExpectedDispatches(true);
    fetchExpectedReceipts({ destinationEntityId: destId, species: dataSessionForm.species })
      .then((matches) => { if (!cancelled) setExpectedDispatches(matches); })
      .catch(() => { if (!cancelled) setExpectedDispatches([]); })
      .finally(() => { if (!cancelled) setLoadingExpectedDispatches(false); });
    return () => { cancelled = true; };
  }, [dataSessionForm.category, dataSessionForm.destEntityId, dataSessionForm.species]);

  // Client-side CSV pre-validation: runs whenever file or event type changes
  useEffect(() => {
    const { file, eventType, delimiter } = dataSessionForm;
    if (!file || !eventType) {
      setFileValidation(null);
      return;
    }
    setFileValidation({ status: 'validating', totalRows: 0, detectedDelimiter: delimiter, missingRequired: [], missingRecommended: [], blankIdentifierRows: 0, parsedHeaders: [], sampleIssues: [], crossDealEids: [], eidCheckPending: false });

    const reader = new FileReader();
    reader.onload = (e) => {
      const text = (e.target?.result as string) || '';
      const lines = text.split(/\r?\n/).filter((l) => l.trim());
      if (lines.length === 0) {
        setFileValidation({ status: 'error', totalRows: 0, detectedDelimiter: delimiter, missingRequired: [{ key: 'file', description: 'File appears to be empty', acceptedNames: '' }], missingRecommended: [], blankIdentifierRows: 0, parsedHeaders: [], sampleIssues: [], crossDealEids: [], eidCheckPending: false });
        return;
      }

      const firstLine = lines[0];
      const commaCount = (firstLine.match(/,/g) || []).length;
      const semicolonCount = (firstLine.match(/;/g) || []).length;
      let detectedDelim: string;
      if (semicolonCount > commaCount) {
        detectedDelim = ';';
      } else if (semicolonCount > 0 && commaCount > 0) {
        // Ambiguous (e.g. file has trailing empty comma-columns): if splitting by comma
        // produces a header that itself contains a semicolon, the real delimiter is semicolon.
        detectedDelim = firstLine.split(',').some((h) => h.includes(';')) ? ';' : ',';
      } else {
        detectedDelim = ',';
      }
      if (detectedDelim !== delimiter) {
        setDataSessionForm((f) => ({ ...f, delimiter: detectedDelim }));
      }

      const parseRow = (line: string, delim: string): string[] => {
        const result: string[] = [];
        let current = '';
        let inQuotes = false;
        for (let i = 0; i < line.length; i++) {
          const ch = line[i];
          if (ch === '"') { inQuotes = !inQuotes; }
          else if (ch === delim && !inQuotes) { result.push(current); current = ''; }
          else { current += ch; }
        }
        result.push(current);
        return result;
      };

      const rawHeaders = parseRow(lines[0], detectedDelim);
      const headers = rawHeaders.map((h) => h.replace(/\ufeff/g, '').trim().toLowerCase());
      const cleanHeaders = rawHeaders.map((h) => h.replace(/\ufeff/g, '').trim());

      const GROUPS: Record<string, { description: string; aliases: string[] }> = {
        eid:     { description: 'EID / tag number',       aliases: ['eid', 'tag_number', 'tagnumber'] },
        eid_seq: { description: 'EID or sequence number', aliases: ['eid', 'tag_number', 'tagnumber', 'sn', 'sequence', 'sequence_number', 'eartag', 'ear_tag', 'ear tag'] },
        date:    { description: 'Date / datetime',        aliases: ['date', 'slaughterdate', 'slaughter_date', 'datetime', 'date_time', 'date/time'] },
        weight:  { description: 'Weight / mass',          aliases: ['weight', 'mass'] },
        sex:     { description: 'Sex / gender',           aliases: ['sex', 'gender'] },
        breed:   { description: 'Breed',                  aliases: ['breed'] },
        dob:     { description: 'Date of birth',          aliases: ['dob', 'date_of_birth', 'dateofbirth', 'birth_date', 'birthdate'] },
        // Keep in step with AUTO_FIELD_ALIASES in the backend's ingest/models.py.
        // A spelling missing here reports "Required columns missing" for a
        // column ingest would in fact have read, and one missing there drops
        // the carcass mass a green preview promised.
        hcm:     { description: 'Warm mass (HCM)',        aliases: ['hcm', 'warm mass', 'warm_mass', 'warmmass', 'hcm_kg', 'hcm kg', 'warm_mass_kg', 'warm mass kg'] },
        ccm:     { description: 'Cold mass (CCM)',        aliases: ['ccm', 'cold mass', 'cold mass 3%', 'coldmass3%', 'cold_mass', 'ccm_kg', 'ccm kg', 'cold_mass_kg', 'cold mass kg'] },
        grade:   { description: 'Grade',                  aliases: ['grade'] },
      };

      const EVENT_SPEC: Record<string, { required: string[]; recommended: string[] }> = {
        FARM_REG:    { required: ['eid', 'date', 'sex', 'breed', 'dob'], recommended: [] },
        FARM_REC:    { required: ['eid', 'date'],           recommended: ['weight', 'sex'] },
        FARM_BIR:    { required: ['date'],                  recommended: ['eid', 'sex', 'breed', 'dob'] },
        FARM_DIS:    { required: ['eid', 'date', 'weight'],        recommended: [] },
        FARM_MOR:    { required: ['eid', 'date'],                 recommended: [] },
        FARM_WEI:    { required: ['eid', 'date', 'weight'],       recommended: [] },
        FARM_SHE:    { required: ['eid', 'date'],                 recommended: [] },
        FARM_BAL:    { required: ['date', 'weight'],              recommended: [] },
        FEED_REG:    { required: ['eid', 'date'],                 recommended: ['sex', 'breed'] },
        FEED_REC:    { required: ['eid', 'date', 'weight'],       recommended: [] },
        FEED_DIS:    { required: ['eid', 'date', 'weight'],       recommended: [] },
        FEED_MOR:    { required: ['eid', 'date'],                 recommended: [] },
        FEED_WEI:    { required: ['eid', 'date', 'weight'],       recommended: [] },
        FEED_SHE:    { required: ['eid', 'date'],                 recommended: [] },
        FEED_WOO:    { required: ['date', 'weight'],              recommended: [] },
        FEED_BAL:    { required: ['date'],                        recommended: ['weight'] },
        ABAT_REG:    { required: ['eid_seq', 'date'],             recommended: [] },
        ABAT_REC:    { required: ['eid_seq', 'date', 'weight'],   recommended: [] },
        ABAT_DIS:    { required: ['eid_seq', 'date'],             recommended: [] },
        ABAT_MOR:    { required: ['eid_seq', 'date'],             recommended: [] },
        ABAT_SLA:    { required: ['eid_seq', 'date', 'ccm'],      recommended: ['hcm', 'grade'] },
        VACCINATION: { required: ['eid', 'date'],           recommended: [] },
        WOOL_ANA:    { required: ['date'],                  recommended: [] },
      };

      const spec = EVENT_SPEC[eventType];
      const hasGroup = (groupKey: string): boolean => {
        const g = GROUPS[groupKey];
        return g ? g.aliases.some((alias) => headers.includes(alias)) : false;
      };

      if (!spec) {
        setFileValidation({ status: 'ok', totalRows: lines.length - 1, detectedDelimiter: detectedDelim, missingRequired: [], missingRecommended: [], blankIdentifierRows: 0, parsedHeaders: cleanHeaders, sampleIssues: [], crossDealEids: [], eidCheckPending: false });
        return;
      }

      const missingRequired = spec.required
        .filter((k) => !hasGroup(k))
        .map((k) => ({ key: k, description: GROUPS[k]?.description || k, acceptedNames: (GROUPS[k]?.aliases || []).join(', ') }));

      const missingRecommended = spec.recommended
        .filter((k) => !hasGroup(k))
        .map((k) => ({ key: k, description: GROUPS[k]?.description || k, acceptedNames: (GROUPS[k]?.aliases || []).join(', ') }));

      // Check all rows for blank identifiers
      const identifierAliases = [...new Set([...GROUPS['eid'].aliases, ...GROUPS['eid_seq'].aliases])];
      const identifierColIndices = headers.reduce<number[]>((acc, h, i) => {
        if (identifierAliases.includes(h)) acc.push(i);
        return acc;
      }, []);
      const dataLines = lines.slice(1);
      let blankIdentifierRows = 0;
      const sampleIssues: { row: number; issue: string }[] = [];
      const collectedEids = new Set<string>();
      for (let i = 0; i < dataLines.length; i++) {
        const cells = parseRow(dataLines[i], detectedDelim);
        if (identifierColIndices.length > 0) {
          const hasId = identifierColIndices.some((ci) => (cells[ci] || '').trim() !== '');
          if (!hasId) {
            blankIdentifierRows++;
            if (sampleIssues.length < 5) sampleIssues.push({ row: i + 2, issue: 'Missing EID / identifier' });
          } else {
            identifierColIndices.forEach((ci) => {
              const val = (cells[ci] || '').trim();
              if (val) collectedEids.add(val.replace(/\s+/g, ''));
            });
          }
        }
      }

      const status = missingRequired.length > 0
        ? 'error'
        : (missingRecommended.length > 0 || blankIdentifierRows > 0 ? 'warning' : 'ok');

      // Use refs so the async callback always gets the current deal, not the stale closure value
      const currentDealId = dataSessionDealIdRef.current;
      const isRegistrationEvent = DATA_SESSION_REGISTRATION_EVENT_TYPES.includes(eventType);
      const hasPendingEidCheck = isRegistrationEvent && currentDealId !== '' && collectedEids.size > 0;

      // Set intermediate result immediately so the UI updates (columns/warnings) while EID check runs
      setFileValidation({ status, totalRows: dataLines.length, detectedDelimiter: detectedDelim, missingRequired, missingRecommended, blankIdentifierRows, parsedHeaders: cleanHeaders, sampleIssues, crossDealEids: [], eidCheckPending: hasPendingEidCheck });

      // Cross-deal EID check: targeted lookup of just the collected EIDs,
      // rather than fetching every animal in the system (that full-table
      // fetch timed out once the Animal table grew large enough).
      if (hasPendingEidCheck) {
        checkAnimalEids([...collectedEids]).then((matches) => {
          const activeDealId = dataSessionDealIdRef.current;
          const normalisedEids = new Set([...collectedEids].map((e) => e.replace(/\s+/g, '').toUpperCase()));
          const seen = new Set<string>();
          const crossDealEids: { eid: string; deal_no: string }[] = [];
          matches.forEach((m) => {
            const eid = String(m.eid || '').trim().toUpperCase();
            const animalDealId = String(m.deal_id ?? '');
            const eidMatch = normalisedEids.has(eid);
            const dealDiffers = animalDealId !== '' && animalDealId !== activeDealId;
            if (eid && eidMatch && dealDiffers && !seen.has(eid)) {
              seen.add(eid);
              const dealNo = (dealOverviewByIdRef.current[animalDealId] as any)?.deal_no || animalDealId;
              crossDealEids.push({ eid, deal_no: dealNo });
            }
          });
          setFileValidation((prev) => prev ? { ...prev, crossDealEids, eidCheckPending: false } : prev);
        }).catch((err) => {
          console.warn('[EID check] checkAnimalEids failed:', err);
          setFileValidation((prev) => prev ? { ...prev, eidCheckPending: false } : prev);
        });
      }
    };
    reader.readAsText(file);
  }, [dataSessionDealId, dataSessionForm.file, dataSessionForm.eventType]); // eslint-disable-line

  useEffect(() => {
    if (view !== 'gs1Gln' && view !== 'gs1Gtin' && view !== 'entityForm') return;
    fetchProductTypeOptions()
      .then(setProductTypeOptions)
      .catch(() => setProductTypeOptions([]));
  }, [view]);

  useEffect(() => {
    if (view === 'gs1Gln') {
      setEditingGs1Id('');
      setGs1Form((prev) => ({ ...prev, gs1Type: 'GLN', productTypeId: '', associatedGlnId: '' }));
    }
    if (view === 'gs1Gtin') {
      setEditingGs1Id('');
      setGs1Form((prev) => ({ ...prev, gs1Type: 'GTIN' }));
    }
  }, [view]);

  // Derived: does the currently selected entity already have a GLN?
  const entityAlreadyHasGln = gs1Codes.some(
    (row) => row.gs1Type === 'GLN' && row.entityId === gs1Form.entityId,
  );

  const isGs1CodeAllocated = (code: GS1CodeSummary) => {
    if (typeof code.isAllocated === 'boolean') return code.isAllocated;
    if (typeof code.isAvailable === 'boolean') return !code.isAvailable;
    if (code.gs1Type === 'GTIN') return Boolean(code.entityId && (code.productTypeId || code.associatedGlnId));
    if (code.gs1Type === 'GLN') {
      const entityName = (code.entityName || '').toLowerCase();
      const looksLikePool = entityName.includes('pool') || entityName.includes('available') || entityName.includes('unallocated');
      return Boolean(code.entityId && !looksLikePool);
    }
    return false;
  };

  const gs1CodesByEntity = useMemo(() => {
    const map = new Map<string, { gln?: GS1CodeSummary; gtinCount: number }>();
    gs1Codes.forEach((code) => {
      if (!code.entityId) return;
      const current = map.get(code.entityId) || { gtinCount: 0 };
      if (code.gs1Type === 'GLN' && isGs1CodeAllocated(code) && !current.gln) {
        current.gln = code;
      }
      if (code.gs1Type === 'GTIN' && isGs1CodeAllocated(code)) {
        current.gtinCount += 1;
      }
      map.set(code.entityId, current);
    });
    return map;
  }, [gs1Codes]);

  useEffect(() => {
    const activeTab = view === 'gs1Gln' || view === 'gs1Gtin'
      ? (gs1Form.gs1Type === 'GTIN' ? 'GTIN' : 'GLN')
      : null;
    if (!activeTab) return;
    if (editingGs1Id) return;
    if (!gs1Form.entityId) {
      setGs1Form((prev) => ({ ...prev, gs1Code: '', associatedGlnId: '' }));
      return;
    }

    if (activeTab === 'GTIN') {
      // Same GS1 model: type GTIN links to a GS1 code with type GLN.
      const entityGln = gs1Codes.find(
        (row) => row.gs1Type === 'GLN' && row.entityId === gs1Form.entityId,
      );
      if (!entityGln) {
        setGs1Form((prev) => ({ ...prev, associatedGlnId: '' }));
        return;
      }

      setGs1Form((prev) => ({ ...prev, associatedGlnId: entityGln.id }));
      return;
    }

    if (activeTab === 'GLN' && entityAlreadyHasGln) {
      setGs1Form((prev) => ({ ...prev, associatedGlnId: '' }));
      return;
    }

    setGs1Form((prev) => ({ ...prev, associatedGlnId: '' }));
  }, [editingGs1Id, entityAlreadyHasGln, gs1Form.entityId, gs1Form.gs1Type, gs1Codes, view]);

  useEffect(() => {
    if (view !== 'entityForm' || editingEntityId) return;
    let cancelled = false;
    setLoadingNextEntityNo(true);
    fetchNextEntityNumber()
      .then((value) => {
        if (!cancelled) setNextEntityNoPreview(value);
      })
      .catch(() => {
        if (!cancelled) setNextEntityNoPreview('');
      })
      .finally(() => {
        if (!cancelled) setLoadingNextEntityNo(false);
      });
    return () => {
      cancelled = true;
    };
  }, [editingEntityId, view]);

  const reloadEntityDocs = async (entityId: string) => {
    setEntityDocsLoading(true);
    setEntityDocsError('');
    try {
      setEntityDocs(await fetchEntityDocuments(entityId));
    } catch (error: any) {
      setEntityDocs([]);
      setEntityDocsError(parseApiError(error?.message) || error?.message || 'Could not load the documents.');
    } finally {
      setEntityDocsLoading(false);
    }
  };

  useEffect(() => {
    if (view === 'entityForm' && editingEntityId) reloadEntityDocs(editingEntityId);
    else setEntityDocs([]);
  }, [view, editingEntityId]);

  useEffect(() => {
    fetchDealDocumentTypeOptions()
      .then(setDealDocumentTypeOptions)
      .catch(() => setDealDocumentTypeOptions([]))
      .finally(() => setLoadingDocumentTypes(false));
  }, []);

  // Reload the Documents list whenever that view is entered or its filters change.
  useEffect(() => {
    if (view !== 'documentsList') return;
    loadDocumentsList(1);
  }, [view, documentsListSource]);

  useEffect(() => {
    const isTransportView =
      view === 'transportJourneys' ||
      (view === 'documentUpload' && documentForm.category === 'Transport');
    if (!isTransportView) {
      return;
    }

    let cancelled = false;

    const loadTransportOptions = async () => {
      setLoadingCouriers(true);
      const activeDealId = (documentForm.dealId || selectedDealId) || '';
      const isKnownDeal = Boolean(activeDealId && deals.some((deal) => deal.dealId === activeDealId));
      const [rows, fetchedEvents, fetchedDispatchEvents, allLabels] = await Promise.all([
        couriers.length > 0 ? Promise.resolve(couriers) : fetchCouriers(),
        isKnownDeal ? fetchTransportDealEventOptions(activeDealId).catch(() => []) : Promise.resolve([]),
        isKnownDeal ? fetchTransportDispatchEventOptions(activeDealId).catch(() => []) : Promise.resolve([]),
        isKnownDeal ? fetchDealEventLabels(activeDealId).catch(() => ({})) : Promise.resolve({}),
      ]);
      if (cancelled) return;
      setDealEventLabelsById(allLabels);
      setTransportDispatchEventOptions(fetchedDispatchEvents);
      setCouriers(rows);

      // Also surface event IDs already used in existing transport journeys for this deal
      // so they appear as options even if /events/ returns nothing.
      const journeyEventIds = transportJourneyRowsRef.current
        .map((j) => j.dealEventId)
        .filter((eid): eid is string => Boolean(eid));
      const extraFromJourneys: SelectOption[] = journeyEventIds
        .filter((eid) => !fetchedEvents.some((o: SelectOption) => o.id === eid))
        .map((eid) => ({ id: eid, label: `Event #${eid}` }));

      // When editing an existing journey, ensure the stored event ID always appears.
      const storedEventId = String(documentForm.dealEventId || '');
      const mergedEvents = [...fetchedEvents, ...extraFromJourneys];
      const alreadyPresent = mergedEvents.some((o: SelectOption) => o.id === storedEventId);
      const finalEvents =
        editingTransportJourneyId && storedEventId && !alreadyPresent
          ? [{ id: storedEventId, label: `Event #${storedEventId} (current)` }, ...mergedEvents]
          : mergedEvents;

      setTransportDealEventOptions(finalEvents);
      setLoadingCouriers(false);
    };

    loadTransportOptions();
    return () => {
      cancelled = true;
    };
  }, [couriers.length, deals, documentForm.category, documentForm.dealId, editingTransportJourneyId, selectedDealId, uploadCompletedCount, view]);

  useEffect(() => {
    // Both the Add-Journey and the standalone New-Weighbridge forms let the user
    // pick a receive event, so load the shared options list for either view.
    if (view !== 'transportJourneys' && view !== 'weighbridgeNew') return;
    if (deals.length === 0) {
      setAllReceiveEvents([]);
      return;
    }

    let cancelled = false;
    setLoadingReceiveEvents(true);

    Promise.all(
      deals.map((deal) =>
        Promise.all([
          fetchTransportDealEventOptions(deal.dealId),
          fetchTransportJourneys(deal.dealId).catch(() => [] as TransportJourneySummary[]),
        ])
          .then(([options, journeys]) => {
            const eventsWithJourney = new Set(journeys.map((j) => String(j.dealEventId || '')).filter(Boolean));
            return options.map((option) => ({
              id: option.id,
              dealId: deal.dealId,
              dealTitle: deal.title,
              animalCount: option.animalCount,
              hasJourney: eventsWithJourney.has(option.id),
              label: [deal.title, option.label, option.location].filter(Boolean).join(' — '),
            }));
          })
          .catch(() => [] as ReceiveEventOption[])
      )
    )
      .then((groups) => {
        if (cancelled) return;
        setAllReceiveEvents(groups.flat());
      })
      .finally(() => {
        if (cancelled) return;
        setLoadingReceiveEvents(false);
      });

    return () => {
      cancelled = true;
    };
  }, [deals, uploadCompletedCount, view]);

  useEffect(() => {
    if ((view !== 'documentUpload' && view !== 'courierManagement' && view !== 'transportJourneys' && view !== 'journeyHistory') || couriers.length > 0) return;
    fetchCouriers()
      .then(setCouriers)
      .catch(() => setCouriers([]));
  }, [couriers.length, view]);

  useEffect(() => {
    if (view !== 'documentUpload') return;
    const dealId = documentForm.dealId || selectedDealId;
    if (!dealId) return;
    loadExistingDocuments(dealId);
  }, [documentForm.dealId, selectedDealId, view]);

  useEffect(() => {
    if ((view !== 'dealSummary' && view !== 'dashboard') || !selectedDealId) return;

    // Serve from cache if already fetched for this deal
    if (trackingCacheRef.current[selectedDealId]) {
      setDealSummaryTracking(trackingCacheRef.current[selectedDealId]);
      setDealSummaryTrackingError('');
      return;
    }

    let cancelled = false;
    setLoadingDealSummaryTracking(true);
    setDealSummaryTrackingError('');

    fetchTracking(selectedDealId)
      .then((tracking) => {
        if (cancelled) return;
        trackingCacheRef.current[selectedDealId] = tracking;
        setDealSummaryTracking(tracking);
      })
      .catch((error: any) => {
        if (cancelled) return;
        setDealSummaryTracking(null);
        setDealSummaryTrackingError(error?.message || 'Could not load deal tracking data.');
      })
      .finally(() => {
        if (cancelled) return;
        setLoadingDealSummaryTracking(false);
      });

    return () => {
      cancelled = true;
    };
  }, [selectedDealId, view]);

  // Woolies dashboard notifications: recent registration sessions for Woolies
  // producers, with the estimated slaughter/availability window per batch.
  useEffect(() => {
    if (view !== 'dashboard') return;
    let cancelled = false;
    fetchWooliesRegistrationNotifications(90)
      .then((data) => { if (!cancelled) setWooliesNotifications(data); })
      .catch(() => { if (!cancelled) setWooliesNotifications(null); });
    return () => { cancelled = true; };
  }, [view]);

  // Auto-load growth schedules when entering the "Animal estimates" page so it
  // isn't empty on first open.
  useEffect(() => {
    if (view !== 'productionSchedules') return;
    if (schedules.length > 0) return;
    loadSchedules();
  }, [view]);

  // Dashboard-wide feedlot performance: aggregated across all feedlots by
  // default, or a single feedlot's own group when one is selected in the
  // dropdown. Sourced from the same per-animal location data as the Animal
  // Register, not the per-deal tracking summary (which is empty unless a
  // specific deal has been opened elsewhere).
  useEffect(() => {
    if (view !== 'dashboard') return;
    let cancelled = false;
    // Reports over active deals, all animals. Dressing percentage is computed
    // server-side from slaughter records only, so it always reflects
    // slaughtered animals regardless of this scope.
    const scopeParams = {
      scope: 'all' as const,
      // A single selected deal reports whatever its status; the aggregate
      // views stay scoped to active deals.
      onlyActiveDeals: !dashboardDealFilter,
      species: dashboardSpecies === 'ALL' ? undefined : dashboardSpecies,
      // The Deal Matrix has no server-side flag on this endpoint, so that
      // selection reports across all chains rather than pretending to filter.
      valueChainId:
        dashboardScp !== DASHBOARD_SCP_ALL && dashboardScp !== DASHBOARD_SCP_MATRIX
          ? dashboardScp
          : undefined,
      dealId: dashboardDealFilter || undefined,
    };
    const request = dashboardFeedlotId
      ? fetchAnimalLocationPerformance({ entityId: dashboardFeedlotId, groupBy: 'entity', ...scopeParams })
      : fetchAnimalLocationPerformance({ entityType: 'FEEDLOT', groupBy: 'entity_type', ...scopeParams });
    request
      .then((groups) => {
        if (cancelled) return;
        setDashboardFeedlotPerformance(groups[0] || null);
      })
      .catch(() => {
        if (cancelled) return;
        setDashboardFeedlotPerformance(null);
      });
    return () => {
      cancelled = true;
    };
  }, [view, dashboardFeedlotId, dashboardSpecies, dashboardScp, dashboardDealFilter]);

  // Performance Report screen: default to an all-deals aggregate (same
  // source as the dashboard's feedlot performance card) until the admin
  // picks a specific deal from the combobox below. The value-chain filter
  // (empty = all chains) narrows the aggregate cards server-side.
  useEffect(() => {
    if (view !== 'performanceReport' || perfReportDealId) return;
    let cancelled = false;
    setLoadingPerfReportAggregate(true);
    fetchAnimalLocationPerformance({
      entityType: 'FEEDLOT',
      groupBy: 'entity_type',
      scope: 'all',
      valueChainId: perfReportValueChainId || undefined,
    })
      .then((groups) => {
        if (cancelled) return;
        setPerfReportAggregate(groups[0] || null);
        setLoadingPerfReportAggregate(false);
      })
      .catch(() => {
        if (cancelled) return;
        setPerfReportAggregate(null);
        setLoadingPerfReportAggregate(false);
      });
    return () => {
      cancelled = true;
    };
  }, [view, perfReportDealId, perfReportValueChainId]);

  // Per-animal breakdown table under the cards: the same membership population
  // the cards aggregate (FEEDLOT lifetime membership), narrowed by the selected
  // deal and/or value chain. Re-fetched whenever either filter changes.
  useEffect(() => {
    if (view !== 'performanceReport') return;
    let cancelled = false;
    setLoadingPerfReportAnimals(true);
    fetchAnimalPerformanceBreakdown({
      entityType: 'FEEDLOT',
      scope: 'all',
      dealId: perfReportDealId || undefined,
      valueChainId: perfReportValueChainId || undefined,
    })
      .then((rows) => {
        if (cancelled) return;
        setPerfReportAnimals(rows);
        setPerfReportAnimalPage(1);
        setLoadingPerfReportAnimals(false);
      })
      .catch(() => {
        if (cancelled) return;
        setPerfReportAnimals([]);
        setLoadingPerfReportAnimals(false);
      });
    return () => {
      cancelled = true;
    };
  }, [view, perfReportDealId, perfReportValueChainId]);

  // Overall data quality: average data_quality_score across every uploaded
  // file (DataSession) that has been scored, system-wide (not scoped to a
  // single deal), for the dashboard summary card.
  useEffect(() => {
    if (view !== 'dashboard') return;
    let cancelled = false;
    fetchDataQualitySummary()
      .then((summary) => {
        if (cancelled) return;
        setDashboardDataQuality(summary);
      })
      .catch(() => {
        if (cancelled) return;
        setDashboardDataQuality(null);
      });
    return () => {
      cancelled = true;
    };
  }, [view]);

  const activeDeals = useMemo(() => deals.filter((deal) => deal.status === 'Active'), [deals]);
  const completedDeals = useMemo(() => deals.filter((deal) => deal.status === 'Completed'), [deals]);

  // The dashboard filter bar's deal scope: Supply Chain Program (everything /
  // Deal Matrix / one programme) narrowed further by an optional single deal.
  // Species is applied downstream, per animal, so a mixed-species deal still
  // contributes its matching animals.
  const dashboardScopedActiveDeals = useMemo(() => {
    // A single selected deal is shown whatever its status — a completed deal
    // must not read as zeros in its own view. The broader scopes stay
    // active-deals-only, matching the cards' "active deals" framing.
    if (dashboardDealFilter) return deals.filter((d) => d.dealId === dashboardDealFilter);
    let list = activeDeals;
    if (dashboardScp === DASHBOARD_SCP_MATRIX) list = list.filter((d) => !d.isScpDeal);
    else if (dashboardScp !== DASHBOARD_SCP_ALL) list = list.filter((d) => d.valueChainId === dashboardScp);
    return list;
  }, [deals, activeDeals, dashboardScp, dashboardDealFilter]);

  // Typeahead suggestions for the dashboard's deal filter, scoped to the
  // current species + Supply Chain Program selection.
  const dashboardDealSuggestions = useMemo(() => {
    const q = dashboardDealSearch.trim().toLowerCase();
    let list = deals;
    if (dashboardScp === DASHBOARD_SCP_MATRIX) list = list.filter((d) => !d.isScpDeal);
    else if (dashboardScp !== DASHBOARD_SCP_ALL) list = list.filter((d) => d.valueChainId === dashboardScp);
    if (dashboardSpecies !== 'ALL') list = list.filter((d) => !d.species || d.species === dashboardSpecies);
    if (q) {
      list = list.filter((d) =>
        [d.title, d.dealRefNo, d.counterpart, d.scpName]
          .filter(Boolean).join(' ').toLowerCase().includes(q)
      );
    }
    return list.slice(0, 8);
  }, [deals, dashboardDealSearch, dashboardScp, dashboardSpecies]);

  // Active/completed deal counts per entity (as the deal's primary producer),
  // for the entity-directory columns.
  const dealCountsByEntity = useMemo(() => {
    const map: Record<string, { active: number; completed: number }> = {};
    deals.forEach((deal) => {
      const producerId = deal.primaryProducerId;
      if (!producerId) return;
      const bucket = map[producerId] || (map[producerId] = { active: 0, completed: 0 });
      if (deal.status === 'Cancelled') return;  // called off — neither active nor completed
      if (deal.status === 'Completed') bucket.completed += 1;
      else bucket.active += 1;
    });
    return map;
  }, [deals]);

  const effectiveHeadcountById = useMemo(() => {
    const map: Record<string, number> = {};
    for (const d of deals) {
      if (eventHeadcountById[d.dealId] != null) {
        map[d.dealId] = eventHeadcountById[d.dealId];
      } else if (d.dealId === selectedDealId && dealSummaryTracking?.headcount != null) {
        map[d.dealId] = Number(dealSummaryTracking.headcount);
      } else {
        map[d.dealId] = Number(d.headcount || 0);
      }
    }
    return map;
  }, [deals, selectedDealId, dealSummaryTracking, eventHeadcountById]);

  const activeAnimalCount = useMemo(
    () => activeDeals.reduce((sum, deal) => sum + (effectiveHeadcountById[deal.dealId] ?? Number(deal.headcount || 0)), 0),
    [activeDeals, effectiveHeadcountById]
  );

  // Per-deal animal total/EID/non-EID stats. Prefers the backend's registration
  // summary (aggregated server-side from RegistrationEventSummary) over the
  // server-side animal summary (GET /api/animals/animals/summary/), because
  // rows with no EID/VID/other_id at all are skipped at ingest and never
  // become an Animal record — so even a correct Animal-table aggregate
  // silently misses them entirely. Falls back to the animal summary only for
  // deals with no registration summary.
  const getDealAnimalStats = useCallback((deal: Deal) => {
    const summary = animalSummaryByDeal[deal.dealId];
    const speciesCounts = summary?.species || {};
    const eidCountFromAnimals = summary?.eid_count || 0;
    const hasRegistrationSummary = deal.registrationTotalAnimals != null;
    const fallbackTotal = effectiveHeadcountById[deal.dealId] ?? Number(deal.headcount || summary?.total || 0);
    const eidCount = hasRegistrationSummary ? Number(deal.registrationAnimalsWithEid || 0) : eidCountFromAnimals;
    const nonEidCount = hasRegistrationSummary
      ? Number(deal.registrationAnimalsWithoutEid || 0)
      : Math.max(fallbackTotal - eidCountFromAnimals, 0);
    const total = hasRegistrationSummary ? Number(deal.registrationTotalAnimals || 0) : fallbackTotal;
    return { total, eidCount, nonEidCount, speciesCounts };
  }, [animalSummaryByDeal, effectiveHeadcountById]);

  // Ground truth for dashboard animal figures: the animal register, scoped to active
  // deals. No scaling/estimation — every count here is a real row from the backend's
  // per-animal location endpoint, so it always matches what the Animal Register shows.
  const activeAnimalRegisterRows = useMemo(() => {
    const activeDealIds = new Set(dashboardScopedActiveDeals.map((d) => d.dealId));
    return animalRegister.filter((a) => a.deal_id && activeDealIds.has(a.deal_id));
  }, [animalRegister, dashboardScopedActiveDeals]);

  // Lifetime headcount — every animal ever part of an active deal, including
  // ones that have since been slaughtered/died and so no longer appear in the
  // animal register's current-location rows. Sourced from the server-side
  // per-deal animal summary (GET /api/animals/animals/summary/) rather than
  // fetching every animal row, which times out once the Animal table is large.
  const allTimeSpeciesStats = useMemo(() => {
    const counts: Record<string, number> = {};
    dashboardScopedActiveDeals.forEach((deal) => {
      const species = animalSummaryByDeal[deal.dealId]?.species || {};
      Object.entries(species).forEach(([name, count]) => {
        counts[name] = (counts[name] || 0) + count;
      });
    });
    return counts;
  }, [animalSummaryByDeal, dashboardScopedActiveDeals]);
  // Per-species lifetime totals ("Value chain total") and the derived "Exited"
  // count are computed inside renderDashboard from allTimeSpeciesStats, so no
  // all-species aggregate is needed here. The Total-animals/Non-EID ingest
  // figures are intentionally not shown on the species dashboards — rows with
  // no identifier never become an Animal and so have no species to attribute.

  const provinceStats = useMemo(() => {
    const entityStateById = new Map(
      entityDirectory.map((e) => [e.id, e.state || ''])
    );
    const stats: Record<string, number> = {};
    activeDeals.forEach((deal) => {
      const overview = dealOverviewById[deal.dealId];
      const producerId = overview?.primary_producer?.id;
      const province = (producerId && entityStateById.get(producerId)) || 'Unknown';
      stats[province] = (stats[province] || 0) + (effectiveHeadcountById[deal.dealId] ?? Number(deal.headcount || 0));
    });
    return stats;
  }, [entityDirectory, activeDeals, dealOverviewById, effectiveHeadcountById]);

  const dashboardFeedlotOptions = useMemo(
    () => entityDirectory
      .filter((entity) => String(entity.entityType || '').toUpperCase() === 'FEEDLOT')
      .map((entity) => ({ id: entity.id, label: entity.entityName || `Feedlot ${entity.id}` }))
      .sort((left, right) => left.label.localeCompare(right.label)),
    [entityDirectory]
  );

  const animalRegisterRows = useMemo(() => {
    const q = animalRegisterSearch.trim().toLowerCase();
    let rows = animalRegister.map((a) => {
      const primaryProducerName = a.deal_id ? dealOverviewById[a.deal_id]?.primary_producer?.entity_name || '' : '';
      return { ...a, primaryProducerName };
    });
    if (animalRegisterStageFilter) {
      if (animalRegisterStageFilter.species) {
        rows = rows.filter((a) => (a.species || '').toUpperCase() === animalRegisterStageFilter.species);
      }
      rows = rows.filter((a) => (a.current_location?.entity_type || '').toUpperCase() === animalRegisterStageFilter.entityType);
      if (animalRegisterStageFilter.sourceEntityType) {
        rows = rows.filter((a) => (a.current_location?.source_entity_type || '').toUpperCase() === animalRegisterStageFilter.sourceEntityType);
      }
      if (animalRegisterStageFilter.destinationEntityType) {
        rows = rows.filter((a) => (a.current_location?.destination_entity_type || '').toUpperCase() === animalRegisterStageFilter.destinationEntityType);
      }
      if (animalRegisterStageFilter.inTransitLeg) {
        // Same predicate as the value-chain tile counts, so the drill-down list
        // matches the number on the tile that opened it.
        rows = rows.filter((a) => inTransitLeg(a.current_location) === animalRegisterStageFilter.inTransitLeg);
      }
    }
    if (!q) return rows;
    return rows.filter((a) => {
      const haystack = [
        a.eid_tag, a.vid, a.species, a.breed_name, a.status, a.deal_no, a.primaryProducerName,
        a.current_location?.entity_name, a.current_location?.gln, a.current_location?.entity_type,
        a.current_location?.value_chain_name, a.current_location?.source_entity_name, a.current_location?.destination_entity_name,
      ].filter(Boolean).join(' ').toLowerCase();
      return haystack.includes(q);
    });
  }, [animalRegister, animalRegisterSearch, animalRegisterStageFilter, dealOverviewById]);

  // Location entries keyed by animal id, so the Animal list can enrich its
  // current-location / GLN columns for live animals while still sourcing every
  // animal from the full animal list.
  const locationByAnimalId = useMemo(() => {
    const map = new Map<string, AnimalLocationEntry>();
    animalRegister.forEach((a) => { if (a.animal_id) map.set(a.animal_id, a); });
    return map;
  }, [animalRegister]);

  // Flat all-animals rows for the Animal list (no per-deal grouping). Sourced
  // from the full animal list so animals with only an EID and no deal linkage
  // still appear; location/GLN columns fall back to the animal record's own
  // current_entity / current_gln when there is no live-location match.
  const flatAnimalRows = useMemo(() => {
    const q = animalSearch.trim().toLowerCase();
    const rows = allAnimals.map((a) => {
      const loc = locationByAnimalId.get(a.id) || null;
      const dealId: string | null = a.deal || null;
      const overview = dealId ? (dealOverviewById[dealId] as any) : undefined;
      const current_location = loc?.current_location
        ?? ((a.current_entity || a.current_gln)
          ? { entity_name: a.current_entity || null, gln: a.current_gln || null }
          : null);
      return {
        animal_id: a.id as string,
        eid_tag: (a.eid_tag as string | null) || null,
        vid: (a.vid as string | null) || null,
        species: (a.species as string | null) || null,
        status: (a.status as string | null) || null,
        deal_id: dealId,
        deal_no: overview?.deal_no || loc?.deal_no || '',
        primaryProducerName: overview?.primary_producer?.entity_name || '',
        current_location: current_location as AnimalLocationEntry['current_location'],
      };
    });
    const scoped = animalListDealFilter ? rows.filter((a) => a.deal_id === animalListDealFilter) : rows;
    if (!q) return scoped;
    return scoped.filter((a) =>
      [
        a.eid_tag, a.vid, a.species, a.status, a.deal_no, a.primaryProducerName,
        a.current_location?.entity_name, a.current_location?.gln, a.current_location?.entity_type,
      ].filter(Boolean).join(' ').toLowerCase().includes(q)
    );
  }, [allAnimals, locationByAnimalId, animalSearch, dealOverviewById, animalListDealFilter]);

  // Reset to the first page whenever the Animal list filter changes.
  React.useEffect(() => { setAnimalListPage(1); }, [animalSearch, animalListDealFilter]);

  // Reset the Deal list to the first page whenever its search changes.
  React.useEffect(() => { setDealListPage(1); }, [dealSearch]);

  // Load the raw abattoir-slaughter rows on demand when the Slaughter data view
  // is active; refetch when the deal scope changes.
  React.useEffect(() => {
    if (animalListMode !== 'slaughter') return;
    let cancelled = false;
    setSlaughterRawLoading(true);
    setSlaughterRawError(null);
    fetchDealSlaughterRaw(animalListDealFilter || undefined)
      .then((data) => {
        if (cancelled) return;
        setSlaughterRawColumns(data.columns);
        setSlaughterRawRows(data.results);
      })
      .catch((err) => {
        if (cancelled) return;
        setSlaughterRawError(err?.message || 'Failed to load slaughter data');
        setSlaughterRawColumns([]);
        setSlaughterRawRows([]);
      })
      .finally(() => { if (!cancelled) setSlaughterRawLoading(false); });
    return () => { cancelled = true; };
  }, [animalListMode, animalListDealFilter]);

  // Entity Animals tab: load all slaughter-raw rows once (per entity) when its
  // Slaughter data view is opened; the render layer filters to this entity's deals.
  React.useEffect(() => {
    if (view !== 'entityForm' || !editingEntityId) return;
    if (entityAnimalsMode !== 'slaughter') return;
    if (entitySlaughterLoadedFor === editingEntityId) return;
    let cancelled = false;
    setEntitySlaughterLoading(true);
    setEntitySlaughterError(null);
    fetchDealSlaughterRaw()
      .then((data) => {
        if (cancelled) return;
        setEntitySlaughterColumns(data.columns);
        setEntitySlaughterRows(data.results);
        setEntitySlaughterLoadedFor(editingEntityId);
      })
      .catch((err) => {
        if (cancelled) return;
        setEntitySlaughterError(err?.message || 'Failed to load slaughter data');
        setEntitySlaughterColumns([]);
        setEntitySlaughterRows([]);
      })
      .finally(() => { if (!cancelled) setEntitySlaughterLoading(false); });
    return () => { cancelled = true; };
  }, [view, editingEntityId, entityAnimalsMode, entitySlaughterLoadedFor]);

  const openAnimalRegister = (stageFilter?: {
    entityType: string;
    label: string;
    sourceEntityType?: string;
    destinationEntityType?: string;
    inTransitLeg?: InTransitLeg;
    species?: string;
  }) => {
    setAnimalRegisterStageFilter(stageFilter || null);
    setView('animalRegister');
  };

  // Per-species value-chain figures for the species-scoped dashboards, derived
  // from the same active animal register so an animal is counted as exactly one
  // of "at a stage" or "in transit between two stages" — never both, and always
  // consistent with what drilling into the register shows. Keyed by species.
  const valueChainBySpecies = useMemo(() => {
    const blank = () => ({
      farm: 0,
      feedlot: 0,
      abattoir: 0,
      farmToFeedlot: 0,
      feedlotToAbattoir: 0,
      activeCount: 0,
    });
    const out: Record<DashboardSpeciesFilter, ReturnType<typeof blank>> = {
      ALL: blank(),
      SHEEP: blank(),
      CATTLE: blank(),
    };
    const tally = (stats: ReturnType<typeof blank>, a: AnimalLocationEntry) => {
      stats.activeCount += 1;
      const loc = a.current_location;
      const type = (loc?.entity_type || '').toUpperCase();
      if (type === 'FARM') stats.farm += 1;
      else if (type === 'FEEDLOT') stats.feedlot += 1;
      else if (type === 'ABATTOIR') stats.abattoir += 1;
      else if (type === 'IN_TRANSIT') {
        // Bucket by where the animal is HEADING, so a farm→abattoir direct
        // dispatch (skipping the feedlot) sits on the abattoir-inbound leg
        // rather than farm→feedlot. Shared with the register drill-down filter
        // via inTransitLeg() so the tile count and the drill-down always agree.
        if (inTransitLeg(loc) === 'TO_ABATTOIR') stats.feedlotToAbattoir += 1;
        else stats.farmToFeedlot += 1;
      }
    };
    activeAnimalRegisterRows.forEach((a) => {
      // The ALL bucket counts every species, goats included; the two named
      // buckets serve the species filter.
      tally(out.ALL, a);
      const species = (a.species || '').toUpperCase();
      if (species === 'SHEEP' || species === 'CATTLE') tally(out[species], a);
    });
    return out;
  }, [activeAnimalRegisterRows]);

  // Active deals that contain at least one animal of the given species, from the
  // per-deal species summary — the species-scoped equivalent of activeDeals.length.
  const activeDealsCountBySpecies = useMemo(() => {
    const out: Record<DashboardSpeciesFilter, number> = {
      ALL: dashboardScopedActiveDeals.length,
      SHEEP: 0,
      CATTLE: 0,
    };
    dashboardScopedActiveDeals.forEach((deal) => {
      const species = animalSummaryByDeal[deal.dealId]?.species || {};
      (['SHEEP', 'CATTLE'] as DashboardSpecies[]).forEach((sp) => {
        if ((species[sp] || 0) > 0) out[sp] += 1;
      });
    });
    return out;
  }, [dashboardScopedActiveDeals, animalSummaryByDeal]);

  const selectedDeal = useMemo(
    () => deals.find((deal) => deal.dealId === selectedDealId) || null,
    [deals, selectedDealId]
  );
  const hasDeals = deals.length > 0;

  const selectedDealFeedRecords = useMemo(
    () => feedRecords.filter((record) => record.dealId === selectedDealId),
    [feedRecords, selectedDealId]
  );

  const dashboardAccessPointGlns = useMemo<Array<{ id: string; label: string }>>(() => {
    const trackingMatchesSelectedDeal = String(dealSummaryTracking?.dealId || '') === String(selectedDealId || '');
    if (!trackingMatchesSelectedDeal) return [] as Array<{ id: string; label: string }>;

    const glns = Array.isArray(dealSummaryTracking?.glns) ? dealSummaryTracking.glns : [];
    return glns
      .map((gln: any, index: number) => ({
        id: String(gln?.id || `${gln?.type || 'gln'}-${index}`),
        label: `${gln?.name || gln?.type || 'Unknown location'}${gln?.gln ? ` · GLN ${gln.gln}` : ''}`,
      }))
      .filter((row: { id: string; label: string }) => row.label.trim().length > 0);
  }, [dealSummaryTracking, selectedDealId]);

  const dealSummaryTotals = useMemo(() => {
    if (!dealSummaryTracking?.glns) {
      return { headcount: 0, alive: 0, mortality: 0 };
    }
    const slaughtered = Number((dealSummaryTracking.glns.find((g: any) => g.type === 'Abattoir')?.events?.slaughtered) || 0);
    const explicitMortality = dealSummaryTracking.glns.reduce((acc: number, gln: any) => acc + Number(gln?.events?.deaths || gln?.events?.mortalityInTransit || 0), 0);
    const headcount = Number(dealSummaryTracking.headcount || 0);
    const mortality = dealSummaryTracking.total_mortalities != null
      ? Number(dealSummaryTracking.total_mortalities || 0)
      : explicitMortality;
    const alive = Math.max(0, headcount - mortality - slaughtered);
    return { headcount, alive, mortality, slaughtered };
  }, [dealSummaryTracking]);

  const dealSummaryCurrentLocations = useMemo(() => {
    const glns = Array.isArray(dealSummaryTracking?.glns) ? dealSummaryTracking.glns : [];
    return glns
      .filter((gln: any) => Number(gln.current || 0) > 0)
      .map((gln: any) => ({
        key: `${gln.type}:${gln.name}`,
        label: `${gln.type} • ${gln.name}${gln.gln ? ` (GLN ${gln.gln})` : ''}`,
        count: Number(gln.current || 0),
      }))
      .sort((a: any, b: any) => b.count - a.count);
  }, [dealSummaryTracking]);

  const dealSummaryValueChain = useMemo(() => {
    const glns = Array.isArray(dealSummaryTracking?.glns) ? dealSummaryTracking.glns : [];
    const stageOrder: Record<string, number> = {
      Farm: 1,
      Feedlot: 2,
      Abattoir: 3,
      Mortality: 4,
    };

    return glns
      .filter((gln: any) => Number(gln.current || 0) > 0 || Object.keys(gln.events || {}).length > 0)
      .sort((left: any, right: any) => {
        const leftOrder = stageOrder[left?.type as string] ?? 99;
        const rightOrder = stageOrder[right?.type as string] ?? 99;
        if (leftOrder !== rightOrder) return leftOrder - rightOrder;
        return String(left?.name || '').localeCompare(String(right?.name || ''));
      });
  }, [dealSummaryTracking]);

  const dealSummaryFeedlotPerformance = useMemo(() => {
    const source = dealSummaryTracking?.feedlotPerformance;
    const parsedFcr = source?.fcr != null ? Number(source.fcr) : NaN;
    const parsedFcrEstimated = source?.fcrEstimated != null ? Number(source.fcrEstimated) : NaN;
    const parsedAdg = source?.avg_adg != null ? Number(source.avg_adg) : NaN;
    const parsedAvgFeedlotDays = source?.avgFeedlotDays != null ? Number(source.avgFeedlotDays) : NaN;
    const parsedFeedlotDaysCount = source?.feedlotDaysCount != null ? Number(source.feedlotDaysCount) : NaN;

    // Both fcr (measured) and fcrEstimated (fallback, from assumed 4.5% of body
    // weight when no feed-consumption data has been captured yet) come straight
    // from the backend — no calculation happens here.
    const fcrActual = Number.isFinite(parsedFcr) && parsedFcr > 0 ? parsedFcr : null;
    const fcrEstimated = Number.isFinite(parsedFcrEstimated) && parsedFcrEstimated > 0 ? parsedFcrEstimated : null;

    return {
      fcr: fcrActual,
      fcrEstimated,
      avgAdg: Number.isFinite(parsedAdg) ? parsedAdg : null,
      avgFeedlotDays: Number.isFinite(parsedAvgFeedlotDays) ? parsedAvgFeedlotDays : null,
      feedlotDaysCount: Number.isFinite(parsedFeedlotDaysCount) ? parsedFeedlotDaysCount : null,
      hasData: fcrActual != null || fcrEstimated != null || Number.isFinite(parsedAdg),
    };
  }, [dealSummaryTracking]);

  const dashboardPerformanceStats = useMemo(() => {
    const group = dashboardFeedlotPerformance;
    return {
      adg: group?.avg_adg ?? null,
      fcr: group?.fcr ?? null,
      fcrEstimated: group?.fcr_estimated ?? null,
      fcrIsEstimated: group?.fcr_is_estimated ?? false,
      avgFeedlotDays: group?.avg_feedlot_days ?? null,
      feedlotDaysCount: group?.feedlot_days_sample_size ?? null,
      slaughterPercentage: group?.dressing_percentage ?? group?.slaughter_percentage ?? null,
      slaughterCount: group?.slaughter_record_count ?? null,
    };
  }, [dashboardFeedlotPerformance]);

  const dealSummaryDocuments = useMemo(() => {
    const docs: Array<{ id: string; label: string; meta: string; href?: string }> = [];

    const dealDocs = Array.isArray(dealSummaryTracking?.documents) ? dealSummaryTracking.documents : [];
    dealDocs.forEach((doc: any, index: number) => {
      const href = normalizeDocumentUrl(doc?.file);
      if (!href) return;
      docs.push({
        id: `deal-${doc?.id || index}`,
        label: doc?.document_type_name || 'Deal document',
        meta: `${doc?.reference_number ? `Ref ${doc.reference_number} · ` : ''}${doc?.date_of_document || ''}`.trim(),
        href,
      });
    });

    const transportDocs = Array.isArray(dealSummaryTracking?.transportDocuments) ? dealSummaryTracking.transportDocuments : [];
    transportDocs.forEach((doc: any, index: number) => {
      const href = normalizeDocumentUrl(doc?.waybill || doc?.invoice) || undefined;
      const hasBasicData = doc?.vehicle_registration && doc?.start_km != null && doc?.end_km != null;
      if (!href && !hasBasicData) return;
      const label = doc?.waybill ? 'Waybill' : doc?.invoice ? 'Transport invoice' : 'Transport journey';
      const loadingDate = doc?.loading_date ? String(doc.loading_date).split('T')[0] : null;
      const meta = [
        doc?.waybill_no ? `Waybill ${doc.waybill_no}` : null,
        doc?.vehicle_registration ? `Vehicle: ${doc.vehicle_registration}` : null,
        doc?.start_km != null && doc?.end_km != null ? `${doc.end_km - doc.start_km} km` : null,
        loadingDate,
      ].filter(Boolean).join(' · ');
      docs.push({
        id: `transport-${doc?.id || index}`,
        label,
        meta,
        href,
      });
    });

    const woolDocs = Array.isArray(dealSummaryTracking?.woolDocuments) ? dealSummaryTracking.woolDocuments : [];
    woolDocs.forEach((doc: any, index: number) => {
      const href = normalizeDocumentUrl(doc?.document_scan);
      if (!href) return;
      docs.push({
        id: `wool-${doc?.id || index}`,
        label: 'Wool sale document',
        meta: doc?.sale_date || '',
        href,
      });
    });

    return docs;
  }, [dealSummaryTracking]);

  const animalLocationOptions = COMMON_LOCATION_OPTIONS;

  const nextDealRefNo = (dealList: Deal[] = deals) => {
    const yy = String(new Date().getFullYear()).slice(-2);
    const prefix = `A${yy}`;
    let maxSeq = 0;
    // Scan the deals visible in the table (title = deal_no, e.g. "A260002").
    dealList.forEach((d) => {
      const ref = (d.title || d.dealRefNo || '').trim().toUpperCase();
      if (ref.startsWith(prefix.toUpperCase())) {
        const seq = parseInt(ref.slice(prefix.length), 10);
        if (!isNaN(seq) && seq > maxSeq) maxSeq = seq;
      }
    });
    return `${prefix}${String(maxSeq + 1).padStart(4, '0')}`;
  };

  // A confirmation belongs to the step it was shown on.
  useEffect(() => { setCaptureNotice(''); }, [ndStep]);

  // Every arrival at step 5 starts on the health declaration.
  useEffect(() => {
    if (ndStep === 5) setNdStep4Sub('declaration');
  }, [ndStep]);

  // Every arrival at step 3 starts on the animals question.
  useEffect(() => {
    if (ndStep === 3) {
      setNdAnimalsStage('animals');
      setNdBasics({});
      if (breeds.length === 0) fetchBreeds().then(setBreeds).catch(() => {});
    }
  }, [ndStep]);

  // Every arrival at step 2 starts on the seller question.
  useEffect(() => {
    if (ndStep === 2) setNdPartyStage('seller');
  }, [ndStep]);

  const resetNewDealFlow = () => {
    setNdProducerMode('existing');
    setNdProducerId('');
    setNdProducerSearch('');
    setNdShowProducerDropdown(false);
    setNdNewProducerName('');
    setNdNewProducerType('FARM');
    setNdAddContact(false);
    setNdContactForm({ firstName: '', lastName: '', email: '', phoneNo: '' });
    setNdValueChainId('');
    setNdDealDate(new Date().toISOString().slice(0, 10));
    setNdError('');
    setNdCreatedDeal(null);
    setNdSlaughterSale(false);
    setNdStep(1);
    setNdSellerMode('select');
    setNdPurchaserMode('select');
    setNdSellerForm({ ...BLANK_ND_PARTY_FORM });
    setNdPurchaserForm({ ...BLANK_ND_PARTY_FORM, entityType: 'AGENT' });
    setNdSellerSearch('');
    setNdShowSellerDropdown(false);
    setNdPurchaserId('');
    setNdPurchaserSearch('');
    setNdShowPurchaserDropdown(false);
    setNdSellerAgent({ enabled: false, name: '', contact: '' });
    setNdPurchaserAgent({ enabled: false, name: '', contact: '' });
    setNdCreatingEntity('');
    setNdRequirements([]);
    setNdUploadingKey('');
    setNdStep2Error('');
    setNdStep2Success('');
    setNdAnimalsForm({
      totalMale: '', totalFemale: '', totalUnknown: '',
      pricePerKgMale: '', pricePerKgFemale: '', pricePerKgUnknown: '',
      totalWeightKg: '',
      totalPriceExVat: '', totalPriceInclVat: '', penaltyTerms: '',
      origin: '', purchaseChannel: '', traceabilityDocumented: false,
    });
    setNdStep3Error('');
    setNdStep3Success('');
    setNdDealStats(null);
    setNdDealEvents([]);
    setCaptureNotice('');
    setNdEventModalKind('');
    setNdPurchaseInvoiceAmount('');
    setNdPurchaseInvoiceDone(false);
    setNdPurchaseFinanceId('');
    setNdPurchaseApplied('');
    setNdAutoPricePerKg('');
    setNdPurchaseInvoiceDate('');
    setNdAutoTotalExVat('');
    setNdPenaltyAmount('');
    setNdHealthForm({
      examinedBeforeAndOnLoading: '', freeOfListedDiseases: '',
      diseasesPresent: [], diseasesOther: '',
      clinicalReportAvailable: '', withdrawalPeriodsAdhered: '',
      purchaserDocumentsRequired: '', purchaserDocumentsCompleted: '',
      feedingSystem: '', feedingSystemOther: '',
      animalByProductsFed: '', animalByProducts: [], animalByProductsOther: '',
    });
    setNdStep4Error('');
    setNdStep4Success('');
    setNdStep4Sub('declaration');
    setNdMedCapture({
      medicineId: '', lastTreatmentDate: '', withdrawalDays: '',
      dosage: '', totalCost: '', isAntibiotic: false,
    });
    setNdMedCaptureFile(null);
    setNdFeedCapture({ feedName: '', description: '', nutritionalValue: '', introducedDate: '' });
    setNdShowAddMedicine(false);
    setNdNewMedicine({ name: '', brandName: '', producer: '', withholdingPeriod: '' });
    setNdDeclEvidence({});
    setNdMedDocTypeId('');
    setNdMedDocUploaded(false);
    setNdDealJourneys([]);
    setNdShowJourneyModal(false);
  };

  // Entity screen → "Create deal": the new-deal flow opens on step 1 with this
  // entity already chosen as the primary producer. The entity's own Supply
  // Chain Program is pre-selected when it has one; a producer with no chain
  // starts on the Deal Matrix exactly as the bare New deal button does.
  const startNewDealForEntity = (entity: { id: string; valueChainId?: string | null }) => {
    resetNewDealFlow();
    setNdProducerMode('existing');
    setNdProducerId(entity.id);
    if (entity.valueChainId && valueChains.some((vc) => vc.id === entity.valueChainId)) {
      setNdValueChainId(entity.valueChainId);
    }
    setView('dealCreate');
  };

  const refreshNdJourneys = async (dealId: string) => {
    try {
      setNdDealJourneys(await fetchTransportJourneys(dealId));
    } catch {
      // Non-fatal — the list keeps its last known rows.
    }
  };

  // The Add Journey tool in a modal. Its own screen loads couriers and the
  // cross-deal receive-event options via view-gated effects that never fire
  // here, so opening the modal loads what it needs for THIS deal directly.
  // The journey and event-capture modals were born in the new-deal wizard and
  // read the wizard's deal. The View-deal screen needs the same two modals for
  // an existing deal, so both openers take the deal explicitly and fall back
  // to the wizard's; `captureModalDeal` is whichever one is open.
  const openNdJourneyCapture = (target?: { id: string; label: string }, inline = false) => {
    const deal = target || ndCreatedDeal;
    if (!deal) return;
    setCaptureModalDeal(deal);
    resetDocumentForm();
    setDocumentForm((prev) => ({ ...prev, category: 'Transport', dealId: deal.id }));
    if (couriers.length === 0) {
      fetchCouriers().then(setCouriers).catch(() => {});
    }
    setLoadingReceiveEvents(true);
    fetchTransportDealEventOptions(deal.id)
      .then((options) => {
        const mapped = options.map((option) => ({
          id: option.id,
          dealId: deal.id,
          label: [option.label, (option as any).location].filter(Boolean).join(' — '),
          animalCount: Number((option as any).animalCount || 0),
        }));
        setAllReceiveEvents(mapped);
        // One receive event on the deal and nothing else to choose: pick it.
        if (inline && mapped.length === 1) {
          setDocumentForm((prev) => ({ ...prev, dealId: deal.id, dealEventId: mapped[0].id }));
        }
      })
      .catch(() => setAllReceiveEvents([]))
      .finally(() => setLoadingReceiveEvents(false));
    fetchTransportDispatchEventOptions(deal.id)
      .then(setTransportDispatchEventOptions)
      .catch(() => setTransportDispatchEventOptions([]));
    setNdJourneyInline(inline);
    setNdJourneyStage(0);
    setNdShowJourneyModal(true);
  };

  const closeNdJourneyCapture = () => {
    setNdShowJourneyModal(false);
    setNdJourneyInline(false);
    if (ndCreatedDeal && captureModalDeal?.id === ndCreatedDeal.id) {
      refreshNdJourneys(ndCreatedDeal.id);
      refreshNdRequirements(ndCreatedDeal.id);
    } else {
      // Opened from the View-deal screen: nudge it to re-read its journeys.
      setDealOverviewRefreshToken((n) => n + 1);
    }
    setCaptureModalDeal(null);
  };

  const uploadNdMedicineDoc = async (file: File | null) => {
    if (!file || !ndCreatedDeal) return;
    if (!ndMedDocTypeId) {
      setNdStep4Error('Pick the document type for the medicine document first.');
      return;
    }
    setNdUploadingKey(':MED_DOC');
    setNdStep4Error('');
    try {
      await uploadDealDocument({
        dealId: ndCreatedDeal.id,
        documentType: ndMedDocTypeId,
        file,
        dateOfDocument: new Date().toISOString().slice(0, 10),
        party: '',
        visibility: 'ALL',
      });
      setNdMedDocUploaded(true);
    } catch (error: any) {
      setNdStep4Error(parseApiError(error?.message) || error?.message || 'Could not upload the document.');
    } finally {
      setNdUploadingKey('');
    }
  };

  // One save writes the seller's declaration, the per-animal treatment records
  // and the VETERINARY cost. This replaced two forms — "Declared medications"
  // and "Apply medicine to the group" — that asked the same product, date and
  // dosage twice, and where filling only one silently produced half a record.
  const captureNdMedication = async () => {
    if (!ndCreatedDeal || ndCapturingMed) return;
    if (!ndMedCapture.medicineId) {
      setNdStep4Error('Choose the medicine, or add it to the catalogue.');
      return;
    }
    setNdStep4Error('');
    setNdStep4Success('');
    setNdCapturingMed(true);
    try {
      const result = await captureDealMedication(ndCreatedDeal.id, {
        medicineId: ndMedCapture.medicineId,
        lastTreatmentDate: ndMedCapture.lastTreatmentDate,
        withdrawalPeriodDays: ndMedCapture.withdrawalDays,
        dosage: ndMedCapture.dosage,
        totalCost: ndMedCapture.totalCost,
        isAntibiotic: ndMedCapture.isAntibiotic,
        entityId: ndMedLocationId || ndProducerId || ndEventPrefill('ANY').destination?.id || undefined,
      });
      // The supporting file is filed after the record exists, so a failed
      // upload leaves a complete medication rather than losing the capture.
      if (ndMedCaptureFile) {
        const evidenceType = dealDocumentTypeOptions.find(
          (option) => option.code === 'DECL_EVIDENCE',
        );
        try {
          await uploadDealDocument({
            dealId: ndCreatedDeal.id,
            documentType: evidenceType?.id || ndMedDocTypeId || undefined,
            file: ndMedCaptureFile,
            dateOfDocument: ndMedCapture.lastTreatmentDate || new Date().toISOString().slice(0, 10),
            party: '',
            visibility: 'ALL',
            notes: `Medication evidence — ${ndMedCapture.dosage || 'no dosage recorded'}`,
          });
        } catch {
          setNdStep4Error('The medication was recorded, but its document did not upload. Attach it again from the deal documents.');
        }
      }
      setNdMedCapture({
        medicineId: '', lastTreatmentDate: '', withdrawalDays: '',
        dosage: '', totalCost: '', isAntibiotic: false,
      });
      setNdMedCaptureFile(null);
      setNdMedLocationId('');
      setNdMedLocationSearch('');
      await refreshNdDealStats(ndCreatedDeal.id);
      setNdStep4Success(result.detail);
    } catch (error: any) {
      setNdStep4Error(parseApiError(error?.message) || error?.message || 'Could not record the medication.');
    } finally {
      setNdCapturingMed(false);
    }
  };

  // A medication captured before the animals were registered has its money and
  // its withdrawal but no per-animal records. This completes it rather than
  // making the operator delete and recapture, which would double the cost.
  const replayNdMedication = async (medicationId: string) => {
    if (!ndCreatedDeal || ndReplayingMedId) return;
    setNdStep4Error('');
    setNdStep4Success('');
    setNdReplayingMedId(medicationId);
    try {
      const result = await replayDealMedication(ndCreatedDeal.id, medicationId);
      await refreshNdDealStats(ndCreatedDeal.id);
      setNdStep4Success(result.detail);
    } catch (error: any) {
      setNdStep4Error(parseApiError(error?.message) || error?.message || 'Could not create the treatment records.');
    } finally {
      setNdReplayingMedId('');
    }
  };

  // Catalogue a medicine from inside the capture. Selecting it immediately is
  // the point — the operator was mid-capture when they found it missing.
  const addNdMedicineToCatalogue = async () => {
    if (ndSavingNewMedicine) return;
    if (!ndNewMedicine.name.trim()) {
      setNdStep4Error('Name the medicine before adding it.');
      return;
    }
    setNdStep4Error('');
    setNdSavingNewMedicine(true);
    try {
      const created = await createMedicine({
        name: ndNewMedicine.name.trim(),
        brandName: ndNewMedicine.brandName.trim(),
        producer: ndNewMedicine.producer.trim(),
        withholdingPeriod: Number(ndNewMedicine.withholdingPeriod) || 0,
        sku: '',
        stockQty: 0,
      });
      setMedicines((prev) => [...prev, created].sort((a, b) => a.name.localeCompare(b.name)));
      setNdMedCapture((prev) => ({
        ...prev,
        medicineId: created.id,
        // The catalogued withholding period is the default withdrawal, so the
        // operator does not retype what they just entered.
        withdrawalDays: created.withholdingPeriod ? String(created.withholdingPeriod) : prev.withdrawalDays,
      }));
      setNdNewMedicine({ name: '', brandName: '', producer: '', withholdingPeriod: '' });
      setNdShowAddMedicine(false);
    } catch (error: any) {
      setNdStep4Error(parseApiError(error?.message) || error?.message || 'Could not add the medicine.');
    } finally {
      setNdSavingNewMedicine(false);
    }
  };

  const removeNdMedication = async (id: string) => {
    if (!ndCreatedDeal) return;
    setNdStep4Error('');
    try {
      await deleteDealMedication(id);
      await refreshNdDealStats(ndCreatedDeal.id);
    } catch (error: any) {
      setNdStep4Error(parseApiError(error?.message) || error?.message || 'Could not remove the medication.');
    }
  };

  const captureNdFeeding = async () => {
    if (!ndCreatedDeal || ndCapturingFeed) return;
    if (!ndFeedCapture.feedName.trim()) {
      setNdStep4Error('Name the feed — the rest of the row is optional.');
      return;
    }
    setNdStep4Error('');
    setNdCapturingFeed(true);
    try {
      await createDealFeedingDeclaration({
        dealId: ndCreatedDeal.id,
        feedName: ndFeedCapture.feedName.trim(),
        description: ndFeedCapture.description.trim(),
        nutritionalValue: ndFeedCapture.nutritionalValue.trim(),
        introducedDate: ndFeedCapture.introducedDate || null,
      });
      setNdFeedCapture({ feedName: '', description: '', nutritionalValue: '', introducedDate: '' });
      setNdFeedPickerOpen(false);
      await refreshNdDealStats(ndCreatedDeal.id);
      await refreshNdRequirements(ndCreatedDeal.id);
      loadNdFeedSuggestions();
    } catch (error: any) {
      setNdStep4Error(parseApiError(error?.message) || error?.message || 'Could not add the feed.');
    } finally {
      setNdCapturingFeed(false);
    }
  };

  const removeNdFeeding = async (id: string) => {
    if (!ndCreatedDeal) return;
    setNdStep4Error('');
    try {
      await deleteDealFeedingDeclaration(id);
      await refreshNdDealStats(ndCreatedDeal.id);
      await refreshNdRequirements(ndCreatedDeal.id);
    } catch (error: any) {
      setNdStep4Error(parseApiError(error?.message) || error?.message || 'Could not remove the feed.');
    }
  };

  // Evidence for one declaration answer. Filed as an ordinary deal document
  // carrying the answer's field name, so it stays traceable to its question
  // instead of landing in an undifferentiated pile.
  const uploadNdDeclarationEvidence = async (field: string, file: File | null) => {
    if (!file || !ndCreatedDeal) return;
    const evidenceType = dealDocumentTypeOptions.find(
      (option) => option.code === 'DECL_EVIDENCE',
    );
    if (!evidenceType) {
      setNdStep4Error(
        'The "Declaration evidence" document type is missing. Run '
        + 'seed_compliance_document_types --apply on this environment.',
      );
      return;
    }
    setNdDeclUploadingKey(field);
    setNdStep4Error('');
    try {
      await uploadDealDocument({
        dealId: ndCreatedDeal.id,
        documentType: evidenceType.id,
        file,
        dateOfDocument: new Date().toISOString().slice(0, 10),
        party: '',
        visibility: 'ALL',
        declarationField: field,
      });
      setNdDeclEvidence((prev) => ({ ...prev, [field]: file.name }));
    } catch (error: any) {
      setNdStep4Error(parseApiError(error?.message) || error?.message || 'Could not upload the evidence.');
    } finally {
      setNdDeclUploadingKey('');
    }
  };

  // Record the penalty as money with its terms: a PENALTY ledger row carrying
  // the amount, and the terms saved onto the deal's penalty_terms.
  const recordNdPenalty = async () => {
    if (!ndCreatedDeal || ndRecordingPenalty) return;
    if (!ndPenaltyAmount || Number(ndPenaltyAmount) <= 0) {
      setNdStep3Error('Enter the penalty amount as a positive value.');
      return;
    }
    if (!ndAnimalsForm.penaltyTerms.trim()) {
      setNdStep3Error('Describe the penalty — the terms are recorded with the amount.');
      return;
    }
    setNdStep3Error('');
    setNdStep3Success('');
    setNdRecordingPenalty(true);
    try {
      await createDealFinance({
        dealId: ndCreatedDeal.id,
        recordType: 'PENALTY',
        amount: ndPenaltyAmount,
        transactionDate: new Date().toISOString().slice(0, 10),
        description: ndAnimalsForm.penaltyTerms.trim(),
      });
      await updateDealApi(ndCreatedDeal.id, { penaltyTerms: ndAnimalsForm.penaltyTerms.trim() });
      setNdPenaltyAmount('');
      await refreshNdDealStats(ndCreatedDeal.id);
      setNdStep3Success('Penalty recorded on the deal finances.');
    } catch (error: any) {
      setNdStep3Error(parseApiError(error?.message) || error?.message || 'Could not record the penalty.');
    } finally {
      setNdRecordingPenalty(false);
    }
  };

  // The deal's existing PURCHASE ledger row, if the wizard is resumed on a
  // deal that already has one: its amount fills the box and later edits
  // update that row.
  const loadNdPurchaseFinance = async (dealId: string) => {
    try {
      const rows = await fetchDealFinances(dealId);
      const purchase = rows.find((row) => row.recordType === 'PURCHASE' && !row.linkedToDocument) || rows.find((row) => row.recordType === 'PURCHASE');
      if (purchase) {
        setNdPurchaseFinanceId(purchase.id);
        setNdPurchaseInvoiceAmount((prev) => prev || String(Math.abs(purchase.amount)));
        setNdPurchaseInvoiceDate((prev) => prev || String(purchase.transactionDate || '').slice(0, 10));
      }
    } catch {
      // Non-fatal — the box simply starts empty.
    }
  };

  // Purchase total + total live weight → the money is recorded and applied to
  // the animals on its own, the moment both are in. No button to remember:
  // the total becomes (or updates) the PURCHASE ledger row, the weight is saved
  // on the deal, and the purchase is apportioned onto the animals — price per
  // kg × weight where the weight is known, the remainder spread as an average.
  const syncNdPurchase = async (override?: { amount?: string; weightKg?: string }) => {
    if (!ndCreatedDeal || ndPurchaseSyncing) return;
    const amountText = (override?.amount ?? ndPurchaseInvoiceAmount).trim();
    const weightText = (override?.weightKg ?? ndAnimalsForm.totalWeightKg).trim();
    const amount = Number(amountText);
    const weight = Number(weightText);
    const invoiceDate = ndPurchaseInvoiceDate || ndDealDate || new Date().toISOString().slice(0, 10);
    if (amount > 0) {
      // The invoice total is the deal's total price ex VAT — shown on the deal
      // header — unless the operator typed a different figure there.
      setNdAnimalsForm((prev) => (!prev.totalPriceExVat || prev.totalPriceExVat === ndAutoTotalExVat ? { ...prev, totalPriceExVat: amountText } : prev));
      setNdAutoTotalExVat(amountText);
    }
    if (amount > 0 && weight > 0) {
      // The average R/kg lands in the per-sex price boxes — blank ones and
      // ones still holding the previous auto figure; a typed price is kept.
      const perKg = (amount / weight).toFixed(2);
      setNdAnimalsForm((prev) => {
        const fill = (value: string) => (!value || value === ndAutoPricePerKg ? perKg : value);
        return { ...prev, pricePerKgMale: fill(prev.pricePerKgMale), pricePerKgFemale: fill(prev.pricePerKgFemale), pricePerKgUnknown: fill(prev.pricePerKgUnknown) };
      });
      setNdAutoPricePerKg(perKg);
    }
    setNdPurchaseSyncing(true);
    setNdStep3Error('');
    try {
      const dealPatch: Record<string, string> = {};
      if (weightText !== '') dealPatch.totalWeightKg = weightText;
      if (amountText !== '' && amount > 0 && (!ndAnimalsForm.totalPriceExVat || ndAnimalsForm.totalPriceExVat === ndAutoTotalExVat)) dealPatch.totalPriceExVat = amountText;
      if (Object.keys(dealPatch).length > 0) {
        await updateDealApi(ndCreatedDeal.id, dealPatch);
      }
      if (amountText !== '' && amount > 0) {
        if (ndPurchaseFinanceId) {
          await updateDealFinance(ndPurchaseFinanceId, { amount: amountText, transactionDate: invoiceDate });
        } else {
          const created = await createDealFinance({
            dealId: ndCreatedDeal.id,
            recordType: 'PURCHASE',
            amount: amountText,
            transactionDate: invoiceDate,
            description: 'Purchase invoice',
          });
          if (created?.id) setNdPurchaseFinanceId(String(created.id));
        }
        const summary = await applyDealPurchasePrices(ndCreatedDeal.id);
        setNdPurchaseApplied(summary.detail || (summary.updated ? `Applied to ${summary.updated} animal(s).` : 'Recorded — applied to the animals once they are registered.'));
      }
      await refreshNdDealStats(ndCreatedDeal.id);
    } catch (error: any) {
      setNdStep3Error(parseApiError(error?.message) || error?.message || 'Could not record the purchase.');
    } finally {
      setNdPurchaseSyncing(false);
    }
  };

  // Purchase invoice: file the document against the deal. The money itself is
  // handled by syncNdPurchase from the total and weight boxes.
  const submitNdPurchaseInvoice = async (file: File | null) => {
    if (!file || !ndCreatedDeal) return;
    const docType = dealDocumentTypeOptions.find((option) => option.code === 'INVOICE');
    if (!docType) {
      setNdStep3Error('No document type carries the code INVOICE — seed the compliance document types first.');
      return;
    }
    setNdStep3Error('');
    setNdStep3Success('');
    setNdUploadingKey(':PURCHASE_INVOICE');
    try {
      await uploadDealDocument({
        dealId: ndCreatedDeal.id,
        documentType: docType.id,
        file,
        dateOfDocument: ndPurchaseInvoiceDate || ndDealDate || new Date().toISOString().slice(0, 10),
        party: 'SELLER',
        visibility: 'ALL',
      });
      setNdPurchaseInvoiceDone(true);
      await refreshNdRequirements(ndCreatedDeal.id);
      setNdStep3Success('Purchase invoice filed against the deal.');
      if (ndPurchaseInvoiceAmount.trim() && !ndPurchaseFinanceId) await syncNdPurchase();
    } catch (error: any) {
      setNdStep3Error(parseApiError(error?.message) || error?.message || 'Could not file the purchase invoice.');
    } finally {
      setNdUploadingKey('');
    }
  };

  // Headcount the purchase was last apportioned over, so a registration that
  // lands after the invoice total triggers one re-apply, not one per refresh.
  const ndPurchaseAppliedForRef = useRef<{ dealId: string; headcount: number } | null>(null);

  const refreshNdDealStats = async (dealId: string) => {
    try {
      const stats = await fetchDealById(dealId);
      setNdDealStats(stats);
      // The backend re-applies a booked purchase when animals arrive; this
      // keeps the wizard's status line honest when it happens under it.
      const headcountNow = Number((stats as any)?.headcount || 0);
      const last = ndPurchaseAppliedForRef.current;
      if (ndPurchaseFinanceId && headcountNow > 0 && (!last || last.dealId !== dealId || last.headcount !== headcountNow)) {
        ndPurchaseAppliedForRef.current = { dealId, headcount: headcountNow };
        applyDealPurchasePrices(dealId)
          .then((summary) => setNdPurchaseApplied(summary.detail || `Applied to ${summary.updated} animal(s).`))
          .catch(() => { /* the backend already applied on ingest; nothing to show */ });
      }
      // Once a registration has put real animals on the deal, carry their
      // sex split into the captured-reference boxes so the admin is not
      // retyping numbers the system already knows. Blank boxes only -- a
      // figure someone typed (e.g. off the invoice) is never overwritten.
      // The deal's saved total live weight fills a blank box (a typed figure
      // is kept), so a resumed wizard shows the weight it already has.
      const savedWeight = (stats as any)?.total_weight_kg;
      if (savedWeight !== null && savedWeight !== undefined && savedWeight !== '') {
        setNdAnimalsForm((prev) => (prev.totalWeightKg ? prev : { ...prev, totalWeightKg: String(savedWeight) }));
      }
      const split = (stats as any)?.sex_split;
      if (split?.source === 'animals' && Number((stats as any)?.headcount || 0) > 0) {
        setNdAnimalsForm((prev) => ({
          ...prev,
          totalMale: prev.totalMale || String(split.male ?? 0),
          totalFemale: prev.totalFemale || String(split.female ?? 0),
          totalUnknown: prev.totalUnknown || String(split.unknown ?? 0),
        }));
      }
    } catch {
      // Non-fatal: the stats card just stays on its last known values.
    }
  };

  const refreshNdRequirements = async (dealId: string) => {
    try {
      const { requirements } = await fetchDealDocumentRequirements(dealId);
      setNdRequirements(requirements);
    } catch {
      // Non-fatal: the checklist re-derives on the next save or on the deal screen.
    }
  };

  // Step 1 of the deal creation workflow: create the deal from its details.
  // Status is not asked here — a new deal always starts Active. The SCP flag
  // is inherited from the chosen chain rather than ticked separately, and the
  // Deal Matrix default means no chain at all.
  const submitNewDeal = async (event: React.FormEvent) => {
    event.preventDefault();
    if (ndSaving) return;
    setNdError('');

    if (ndProducerMode === 'existing' && !ndProducerId) {
      setNdError('Select a primary producer, or switch to creating a new one.');
      return;
    }
    if (ndProducerMode === 'new' && !ndNewProducerName.trim()) {
      setNdError('Enter a name for the new primary producer.');
      return;
    }
    if (ndProducerMode === 'new' && ndAddContact
      && !ndContactForm.firstName.trim() && !ndContactForm.lastName.trim()) {
      setNdError('Enter a name for the new contact, or untick "Add a contact".');
      return;
    }

    setNdSaving(true);
    try {
      let producerId = ndProducerId;
      if (ndProducerMode === 'new') {
        const entity = await createEntity({
          entityName: ndNewProducerName.trim(),
          entityType: ndNewProducerType,
          // A producer joining an SCP inherits that chain; a Deal Matrix
          // producer has none (the backend accepts a null value_chain).
          valueChainId: ndValueChainId || undefined,
        });
        producerId = entity.id;
        if (ndAddContact) {
          await createEntityContact({
            entityId: entity.id,
            firstName: ndContactForm.firstName.trim(),
            lastName: ndContactForm.lastName.trim(),
            email: ndContactForm.email.trim(),
            phoneNo: ndContactForm.phoneNo.trim(),
            isPrimary: true,
          });
        }
        loadEntityDirectory();
        // Hand the created entity to the "existing" picker so a failure below
        // (or a retry) cannot create the same producer twice.
        setNdProducerMode('existing');
        setNdProducerId(entity.id);
      }

      const chain = ndValueChainId ? valueChains.find((vc) => vc.id === ndValueChainId) : undefined;
      const created = await createDealApi({
        primaryProducerId: producerId,
        valueChainId: ndValueChainId || undefined,
        isScpDeal: chain ? chain.isScp : false,
        dealReferenceNo: nextDealRefNo() || undefined,
        dealDate: ndDealDate || undefined,
        isCompleted: false,
      });
      const createdId = String(created?.id || '');
      // Reload deals so the previewed "next deal reference no" increments
      // past this deal.
      await loadDeals();
      setSelectedDealId(createdId);
      setNdCreatedDeal({
        id: createdId,
        label: String(created?.deal_no || created?.deal_reference_no || 'New deal'),
      });

      // Step 2 — the seller box starts on the producer just chosen; the
      // purchaser arrives prepopulated on an SCP deal (the backend fills the
      // programme's default purchaser in on create).
      const purchRaw = created?.purchaser;
      const purchId = purchRaw && typeof purchRaw === 'object'
        ? String(purchRaw.id || '')
        : purchRaw ? String(purchRaw) : '';
      setNdPurchaserId(purchId);
      setNdStep(2);
      if (createdId) refreshNdRequirements(createdId);
    } catch (error: any) {
      setNdError(parseApiError(error?.message) || error?.message || 'Could not create the deal.');
    } finally {
      setNdSaving(false);
    }
  };

  // Create a brand-new entity from a party panel's capture form (plus its
  // primary contact when one was typed), then select it in that panel. The
  // deal itself is only touched by "Save seller & purchaser" below.
  const createNdPartyEntity = async (side: 'SELLER' | 'PURCHASER') => {
    if (ndCreatingEntity) return;
    const form = side === 'SELLER' ? ndSellerForm : ndPurchaserForm;
    const sideLabel = side === 'SELLER' ? 'seller' : 'purchaser';
    if (!form.entityName.trim()) {
      setNdStep2Error(`Enter a name for the new ${sideLabel} entity.`);
      return;
    }
    if ((form.contactCell.trim() || form.contactEmail.trim()) && !form.contactName.trim()) {
      setNdStep2Error('Enter the contact name alongside the cell/email.');
      return;
    }
    setNdStep2Error('');
    setNdStep2Success('');
    setNdCreatingEntity(side);
    try {
      const entity = await createEntity({
        entityName: form.entityName.trim(),
        entityType: form.entityType,
        entityTypeOther: form.entityType === 'OTHER' ? form.entityTypeOther.trim() : '',
        partyKind: form.partyKind,
        identityNumber: form.identityNumber.trim(),
        addressLine1: form.addressLine1.trim(),
        addressLine2: form.addressLine2.trim(),
        city: form.city.trim(),
        postalCode: form.postalCode.trim(),
        farmName: form.farmName.trim(),
        district: form.district.trim(),
        province: form.province.trim(),
        vatRegistered: form.vatRegistered,
        vatNumber: form.vatRegistered ? form.vatNumber.trim() : '',
        glnApplicable: form.glnApplicable,
        valueChainId: ndValueChainId || undefined,
      });
      if (form.contactName.trim()) {
        const nameParts = form.contactName.trim().split(/\s+/).filter(Boolean);
        await createEntityContact({
          entityId: entity.id,
          firstName: nameParts[0] || '',
          lastName: nameParts.slice(1).join(' '),
          email: form.contactEmail.trim(),
          phoneNo: form.contactCell.trim(),
          isPrimary: true,
        });
      }
      await loadEntityDirectory();
      if (side === 'SELLER') {
        setNdProducerId(entity.id);
        setNdSellerMode('select');
        setNdSellerForm({ ...BLANK_ND_PARTY_FORM });
      } else {
        setNdPurchaserId(entity.id);
        setNdPurchaserMode('select');
        setNdPurchaserForm({ ...BLANK_ND_PARTY_FORM, entityType: 'AGENT' });
      }
      setNdStep2Success(`${entity.entityName} created and selected as the ${sideLabel} — remember to Save seller & purchaser.`);
    } catch (error: any) {
      setNdStep2Error(parseApiError(error?.message) || error?.message || `Could not create the ${sideLabel} entity.`);
    } finally {
      setNdCreatingEntity('');
    }
  };

  // Persist the parties onto the deal: seller = primary producer (changeable
  // here), purchaser link, and the per-side agents. Entity detail itself is
  // display-only on this step — it is edited on the entity screen.
  // Returns true when the parties were saved, so a "Continue" button can save
  // first and only move on if the save worked (the Save button ignores it).
  const submitNewDealParties = async (event?: React.FormEvent): Promise<boolean> => {
    event?.preventDefault();
    if (!ndCreatedDeal || ndSavingParties) return false;
    setNdStep2Error('');
    setNdStep2Success('');

    if (!ndProducerId) {
      setNdStep2Error('Select (or create) the seller entity.');
      return false;
    }
    if (ndSellerAgent.enabled && !ndSellerAgent.name.trim()) {
      setNdStep2Error("Enter the seller's agent name, or untick the agent option.");
      return false;
    }
    if (ndPurchaserAgent.enabled && !ndPurchaserAgent.name.trim()) {
      setNdStep2Error("Enter the purchaser's agent name, or untick the agent option.");
      return false;
    }

    setNdSavingParties(true);
    try {
      await updateDealApi(ndCreatedDeal.id, {
        primaryProducerId: ndProducerId,
        purchaserId: ndPurchaserId || null,
        sellerAgentName: ndSellerAgent.enabled ? ndSellerAgent.name.trim() : '',
        sellerAgentContact: ndSellerAgent.enabled ? ndSellerAgent.contact.trim() : '',
        purchaserAgentName: ndPurchaserAgent.enabled ? ndPurchaserAgent.name.trim() : '',
        purchaserAgentContact: ndPurchaserAgent.enabled ? ndPurchaserAgent.contact.trim() : '',
      });
      await refreshNdRequirements(ndCreatedDeal.id);
      setNdStep2Success('Seller and purchaser saved — the document checklist is up to date.');
      return true;
    } catch (error: any) {
      setNdStep2Error(parseApiError(error?.message) || error?.message || 'Could not save the parties.');
      return false;
    } finally {
      setNdSavingParties(false);
    }
  };

  // Upload a file against one compliance document slot: the document type is
  // resolved by its stable code, and the upload names the party so the
  // seller's ID copy cannot satisfy the purchaser's. Errors land on the step
  // banner that owns the slot (step 2's by default, step 3's for its rows).
  const uploadNdDocByCode = async (
    code: string,
    party: '' | 'SELLER' | 'PURCHASER',
    file: File | null,
    onError: (message: string) => void = setNdStep2Error,
    onDone?: () => void,
  ) => {
    if (!file || !ndCreatedDeal) return;
    const docType = dealDocumentTypeOptions.find((option) => option.code === code);
    if (!docType) {
      onError(`No document type carries the code ${code} — seed the compliance document types first.`);
      return;
    }
    const key = `${party}:${code}`;
    setNdUploadingKey(key);
    onError('');
    try {
      await uploadDealDocument({
        dealId: ndCreatedDeal.id,
        documentType: docType.id,
        file,
        dateOfDocument: new Date().toISOString().slice(0, 10),
        party,
        visibility: 'ALL',
      });
      await refreshNdRequirements(ndCreatedDeal.id);
      if (onDone) onDone();
    } catch (error: any) {
      onError(parseApiError(error?.message) || error?.message || 'Could not upload the document.');
    } finally {
      setNdUploadingKey('');
    }
  };

  const handleNdRequirementUpload = (
    requirement: DealDocumentRequirement,
    file: File | null,
    onError?: (message: string) => void,
  ) => uploadNdDocByCode(requirement.code, requirement.party, file, onError);

  // One row of the document checklist, shared across the flow's steps.
  const renderNdRequirementRow = (
    requirement: DealDocumentRequirement,
    onError?: (message: string) => void,
  ) => {
    const key = `${requirement.party}:${requirement.code}`;
    // The removal certificate is a file ON each journey, not an uploaded deal
    // document — offering an upload here would file something that can never
    // satisfy the rule. Status only; the attach happens on the journey.
    const uploadable = requirement.code !== 'REMOVAL_CERT';
    return (
      <div key={key} className="flex flex-wrap items-center gap-2 rounded-lg border border-[#1e6bb81a] bg-white px-3 py-2">
        <div className="min-w-[220px] flex-1">
          <span className="text-sm font-medium text-avcs-text">{requirement.label}</span>
          <span className="block text-xs text-avcs-muted">{requirement.reason}</span>
        </div>
        {!uploadable && !requirement.satisfied ? (
          <span className="rounded-full border border-[#ecd1b9] bg-[#fff7ef] px-2.5 py-0.5 text-xs font-semibold text-[#7b4a18]">Outstanding — attach it when you add the journey</span>
        ) : requirement.satisfied ? (
          <span
            className="rounded-full border border-[#b9e7c9] bg-[#e7f8ee] px-2.5 py-0.5 text-xs font-semibold text-[#106b38]"
            title={requirement.satisfied_by === 'entity' ? `Filed on the entity${requirement.entity_document_date ? `, dated ${requirement.entity_document_date}` : ''}` : undefined}
          >
            {requirement.satisfied_by === 'entity' ? "On the entity's file ✓" : 'Uploaded ✓'}
          </span>
        ) : ndUploadingKey === key ? (
          <span className="text-xs text-avcs-muted">Uploading…</span>
        ) : (
          <label className="cursor-pointer rounded-lg border border-dashed border-[#1e6bb84d] bg-[#f7fbff] px-3 py-1.5 text-xs font-semibold text-[#0f3b64] hover:bg-[#edf5ff]">
            Upload / drop file
            <input
              type="file"
              className="hidden"
              onChange={(event) => {
                handleNdRequirementUpload(requirement, event.target.files?.[0] || null, onError);
                event.target.value = '';
              }}
            />
          </label>
        )}
      </div>
    );
  };

  // Opens the full event-capture tool in a modal, preset to this deal and
  // the given event kind — registration (step 3) or a medicine/vaccination
  // data file (step 4) — rather than re-implementing ingest.
  const openNdEventCapture = (
    kind: string,
    target?: { id: string; label: string },
    inline = false,
  ) => {
    const deal = target || ndCreatedDeal;
    if (!deal) return;
    setNdEventInline(inline);
    setCaptureNotice('');
    captureOpenedAtCountRef.current = uploadCompletedCount;
    setCaptureModalDeal(deal);
    if (!ingestInFlightRef.current) {
      setDataSessionError('');
      setDataSessionSuccess('');
      setDataSessionResult(null);
      setDraftConfirmResult(null);
      setUploadAuditEvents([]);
    }
    setDataSessionDealId(deal.id);
    // The upload form keys its event list by location (FARM / FEED / ABAT /
    // OTHER); the code's prefix says which. 'ANY' leaves both for the operator.
    const prefill = ndEventPrefill(kind);
    // The form's Event dropdown works in categories (Register, Receive, Dispatch …);
    // the concrete code (FARM_REG …) is derived from it and the entity's type.
    const categoryFromKind = (code: string): string => {
      if (code === 'VACCINATION') return 'VACCINATE';
      const suffix = code.split('_')[1];
      const hit = Object.entries(EVENT_CATEGORY_SUFFIX).find(([, value]) => value === suffix);
      return hit ? hit[0] : '';
    };
    setDataSessionForm((prev) => ({
      ...prev,
      category: kind === 'ANY' ? '' : categoryFromKind(kind),
      eventType: kind === 'ANY' ? '' : kind,
      sourceEntityId: prefill.source?.id || '',
      destEntityId: prefill.destination?.id || '',
      species: prefill.species || prev.species,
    }));
    setSourceSelectedUnit(prefill.source || null);
    setDestSelectedUnit(prefill.destination || null);
    setSourceEntitySearch('');
    setDestEntitySearch('');
    setNdEventModalKind(kind);
  };

  // What the deal already tells us about an event's parties, so the capture
  // form opens filled in rather than blank. Rules follow the chain: a farm
  // dispatch leaves the producer for the programme's feedlot, the feedlot
  // receive mirrors it, the feedlot dispatch goes to the purchaser, and a
  // non-movement event happens wherever the animals are now.
  const ndEventPrefill = (kind: string): { source: any | null; destination: any | null; species: string } => {
    const byId = (id: string | null | undefined) => (id ? entityDirectory.find((e) => e.id === String(id)) || null : null);
    const byName = (name: string | null | undefined) => (name ? entityDirectory.find((e) => e.entityName === name) || null : null);
    const stats: any = ndDealStats;
    const producer = byId(stats?.primary_producer?.id) || byId(ndProducerId);
    const purchaserRaw = stats?.purchaser;
    const purchaser = byId(purchaserRaw && typeof purchaserRaw === 'object' ? purchaserRaw.id : purchaserRaw);
    const dealChainId = ndValueChainId || String((stats?.value_chain && typeof stats.value_chain === 'object' ? stats.value_chain.id : stats?.value_chain) || '');
    const chainFeedlots = entityDirectory.filter((e) => String(e.entityType || '').toUpperCase() === 'FEEDLOT' && dealChainId && e.valueChainId === dealChainId);
    const feedlot = chainFeedlots.length === 1 ? chainFeedlots[0] : null;
    const chainAbattoirs = entityDirectory.filter((e) => String(e.entityType || '').toUpperCase() === 'ABATTOIR' && dealChainId && e.valueChainId === dealChainId);
    const chainAbattoir = chainAbattoirs.length === 1 ? chainAbattoirs[0] : null;
    const events = [...ndDealEvents]
      .filter((ev) => !ev?.is_voided)
      .sort((a, b) => String(a?.event_date || '').localeCompare(String(b?.event_date || '')));
    const latestOf = (code: string) => [...events].reverse().find((ev) => String(ev?.entity_event_type_code || '') === code) || null;
    const latest = events.length > 0 ? events[events.length - 1] : null;
    const current = latest ? byName(latest.location_entity_name || latest.destination_entity_name) : null;
    const farmDis = latestOf('FARM_DIS');
    const abatRec = latestOf('ABAT_REC');
    const feedRec = latestOf('FEED_REC');
    const feedDis = latestOf('FEED_DIS');
    const rawSpecies = String(stats?.species || '').toUpperCase();
    const species = ['SHEEP', 'CATTLE', 'GOAT'].includes(rawSpecies) ? rawSpecies : '';
    const isAbattoir = (e: any) => e && String(e.entityType || '').toUpperCase() === 'ABATTOIR';
    switch (kind) {
      case 'FARM_REG':
        return { source: null, destination: producer, species };
      case 'FARM_DIS':
        // To the programme's feedlot; a chain with no feedlot goes straight to its abattoir.
        return { source: current || producer, destination: feedlot || (isAbattoir(purchaser) ? purchaser : null) || (chainFeedlots.length === 0 ? chainAbattoir : null), species };
      case 'FEED_REC':
        return { source: byName(farmDis?.source_entity_name) || producer, destination: feedlot || byName(farmDis?.destination_entity_name), species };
      case 'FEED_DIS':
        return { source: byName(feedRec?.destination_entity_name) || feedlot || current, destination: isAbattoir(purchaser) ? purchaser : null, species };
      case 'ABAT_REC':
        return {
          source: byName(feedDis?.source_entity_name) || byName(feedRec?.destination_entity_name) || feedlot
            || byName(farmDis?.source_entity_name) || producer,
          destination: (isAbattoir(purchaser) ? purchaser : null) || byName(feedDis?.destination_entity_name)
            || byName(farmDis?.destination_entity_name) || chainAbattoir,
          species,
        };
      case 'ABAT_SLA':
        // Slaughter happens at the abattoir that received the animals.
        return {
          source: null,
          destination: byName(abatRec?.destination_entity_name) || (isAbattoir(purchaser) ? purchaser : null) || chainAbattoir || current,
          species,
        };
      default:
        return { source: null, destination: current || producer, species };
    }
  };

  const refreshNdEvents = async (dealId: string) => {
    try {
      setNdDealEvents(await fetchDealEvents(dealId));
    } catch {
      // Non-fatal — the list keeps its last known rows.
    }
  };

  // View deal → "Open in wizard": resume the new-deal wizard on an existing
  // deal. The wizard reads everything it shows from the deal itself, so the
  // only state to seed is what step 1 would have chosen — producer, purchaser,
  // programme, date, agents — and it opens on step 2 with the deal in hand.
  const resumeWizardForDeal = async (dealId: string) => {
    resetNewDealFlow();
    const fallbackLabel = deals.find((d) => d.dealId === dealId)?.title || dealId;
    setNdCreatedDeal({ id: dealId, label: fallbackLabel });
    setSelectedDealId(dealId);
    setNdStep(2);
    setView('dealCreate');
    const idOf = (value: any) => (value && typeof value === 'object' ? String(value.id || '') : value ? String(value) : '');
    try {
      const detail: any = await fetchDealById(dealId);
      setNdCreatedDeal({ id: dealId, label: String(detail?.deal_no || detail?.deal_reference_no || fallbackLabel) });
      setNdProducerId(idOf(detail?.primary_producer));
      setNdPurchaserId(idOf(detail?.purchaser));
      const chain = idOf(detail?.value_chain);
      setNdValueChainId(chain && valueChains.some((vc) => vc.id === chain) ? chain : '');
      if (detail?.deal_date) setNdDealDate(String(detail.deal_date).slice(0, 10));
      setNdSellerAgent({ enabled: Boolean(detail?.seller_agent_name), name: String(detail?.seller_agent_name || ''), contact: String(detail?.seller_agent_contact || '') });
      setNdPurchaserAgent({ enabled: Boolean(detail?.purchaser_agent_name), name: String(detail?.purchaser_agent_name || ''), contact: String(detail?.purchaser_agent_contact || '') });
      // What was already answered on the later steps: the health and feeding
      // declarations, and the prices, weight and origin from the animals step.
      const text = (value: unknown) => (value === null || value === undefined ? '' : String(value));
      setNdHealthForm({
        examinedBeforeAndOnLoading: toTriState(detail?.examined_before_and_on_loading),
        freeOfListedDiseases: toTriState(detail?.free_of_listed_diseases),
        diseasesPresent: Array.isArray(detail?.diseases_present) ? detail.diseases_present : [],
        diseasesOther: text(detail?.diseases_other),
        clinicalReportAvailable: toTriState(detail?.clinical_report_available),
        withdrawalPeriodsAdhered: toTriState(detail?.withdrawal_periods_adhered),
        purchaserDocumentsRequired: toTriState(detail?.purchaser_documents_required),
        purchaserDocumentsCompleted: toTriState(detail?.purchaser_documents_completed),
        feedingSystem: text(detail?.feeding_system),
        feedingSystemOther: text(detail?.feeding_system_other),
        animalByProductsFed: toTriState(detail?.animal_by_products_fed),
        animalByProducts: Array.isArray(detail?.animal_by_products) ? detail.animal_by_products : [],
        animalByProductsOther: text(detail?.animal_by_products_other),
      });
      setNdAnimalsForm((prev) => ({
        ...prev,
        totalMale: text(detail?.total_male),
        totalFemale: text(detail?.total_female),
        pricePerKgMale: text(detail?.price_per_kg_male),
        pricePerKgFemale: text(detail?.price_per_kg_female),
        pricePerKgUnknown: text(detail?.price_per_kg_unknown),
        totalWeightKg: text(detail?.total_weight_kg),
        totalPriceExVat: text(detail?.total_price_ex_vat),
        penaltyTerms: text(detail?.penalty_terms),
        origin: text(detail?.origin),
        purchaseChannel: text(detail?.purchase_channel),
        traceabilityDocumented: Boolean(detail?.traceability_documented),
      }));
    } catch {
      // The wizard still opens; its per-step refreshes below fill what they can.
    }
    refreshNdDealStats(dealId);
    refreshNdRequirements(dealId);
    refreshNdEvents(dealId);
    refreshNdJourneys(dealId);
    loadNdPurchaseFinance(dealId);
  };

  const closeNdEventCapture = () => {
    setNdEventModalKind('');
    setNdEventInline(false);
    if (ndCreatedDeal && captureModalDeal?.id === ndCreatedDeal.id) {
      refreshNdDealStats(ndCreatedDeal.id);
      refreshNdRequirements(ndCreatedDeal.id);
      refreshNdEvents(ndCreatedDeal.id);
    } else {
      // Opened from the View-deal screen: nudge it to re-read events/vaccinations.
      setDealOverviewRefreshToken((n) => n + 1);
    }
    setCaptureModalDeal(null);
  };

  // Once the event exists the modal has done its job: close it and say so on
  // the screen underneath, instead of leaving an outcome panel to dismiss.
  // Every success path (draft confirm, one-shot upload, accept-a-dispatch)
  // bumps uploadCompletedCount, so that one signal covers them all.
  useEffect(() => {
    if (!ndEventModalKind) return;
    if (uploadCompletedCount <= captureOpenedAtCountRef.current) return;
    // A vaccination upload still owes its invoice-and-cost step; the modal
    // stays open until that step is saved or skipped.
    if (treatmentInvoiceStep) return;
    const created = draftConfirmResult || dataSessionResult;
    const unlinked = Number(created?.rows_unlinked || 0);
    setCaptureNotice(
      `${dataSessionSuccess || 'Event captured.'}${unlinked > 0 ? ` ${unlinked} row${unlinked === 1 ? '' : 's'} did not match an animal — see Needs review.` : ''}`,
    );
    // A registration loaded inside the wizard continues to the details screen,
    // filled in from the file.
    if (ndEventInline && ndEventModalKind === 'FARM_REG') setNdAnimalsStage('details');
    if (ndEventInline && ndEventModalKind === 'ABAT_SLA') {
      setNdSaleForm({ value: '', date: new Date().toISOString().slice(0, 10), file: null });
      setNdSaleError('');
      setNdSlaughterSale(true);
    }
    closeNdEventCapture();
  }, [uploadCompletedCount]);

  // The details screen opens with the total weight the registration file found:
  // the sum of the animals' registration weights, as the deal reports it.
  useEffect(() => {
    if (ndStep !== 3 || ndAnimalsStage !== 'details') return;
    const registered = Number((ndDealStats as any)?.registration_weight_kg);
    if (registered > 0 && !ndAnimalsForm.totalWeightKg.trim()) {
      setNdAnimalsForm((prev) => ({ ...prev, totalWeightKg: String(Math.round(registered * 100) / 100) }));
    }
  }, [ndStep, ndAnimalsStage, ndDealStats]);

  // The invoice-and-cost step is done (saved or skipped): finish what the
  // auto-close would have done had the step not held the modal open.
  const finishTreatmentInvoiceStep = (message: string) => {
    setTreatmentInvoiceStep(null);
    setTreatmentInvoiceForm({ costPerAnimal: '', referenceNumber: '', invoiceDate: '', file: null });
    setTreatmentInvoiceError('');
    if (ndEventModalKind) {
      setCaptureNotice(message);
      closeNdEventCapture();
    } else {
      setDataSessionSuccess(message);
    }
  };

  const renderCaptureNotice = () =>
    captureNotice ? (
      <div className="mb-3 flex items-start justify-between gap-3 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]" role="status">
        <span>{captureNotice}</span>
        <button type="button" className="shrink-0 text-xs font-semibold text-[#106b38] hover:underline" onClick={() => setCaptureNotice('')} aria-label="Dismiss">
          Dismiss
        </button>
      </div>
    ) : null;

  const submitNewDealAnimals = async (event?: React.FormEvent): Promise<boolean> => {
    event?.preventDefault();
    if (!ndCreatedDeal || ndSavingAnimals) return false;
    setNdStep3Error('');
    setNdStep3Success('');

    const form = ndAnimalsForm;
    const toNum = (value: string) => (value.trim() === '' ? 0 : Number(value));
    const anyCount = [form.totalMale, form.totalFemale, form.totalUnknown].some((v) => v.trim() !== '');
    const seller = entityDirectory.find((e) => e.id === ndProducerId);

    setNdSavingAnimals(true);
    try {
      await updateDealApi(ndCreatedDeal.id, {
        ...(anyCount ? {
          totalAnimals: toNum(form.totalMale) + toNum(form.totalFemale) + toNum(form.totalUnknown),
          totalMale: form.totalMale.trim() === '' ? null : Number(form.totalMale),
          totalFemale: form.totalFemale.trim() === '' ? null : Number(form.totalFemale),
        } : {}),
        pricePerKgMale: form.pricePerKgMale || null,
        pricePerKgFemale: form.pricePerKgFemale || null,
        pricePerKgUnknown: form.pricePerKgUnknown || null,
        // Identification is a system rule, not a question on this flow: the
        // backend assumes RFID ear tags on an SCP deal, and a Deal Matrix
        // deal needs no identification.
        totalWeightKg: form.totalWeightKg || null,
        ...(seller?.vatRegistered ? {
          totalPriceExVat: form.totalPriceExVat || null,
        } : {}),
        penaltyTerms: form.penaltyTerms,
        origin: form.origin,
        purchaseChannel: form.origin === 'PURCHASED' ? form.purchaseChannel : '',
        traceabilityDocumented: form.traceabilityDocumented,
      });
      // Declaring traceability adds a required upload — refresh so the row
      // appears on this step rather than surprising the operator at the finish.
      await refreshNdRequirements(ndCreatedDeal.id);
      await refreshNdDealStats(ndCreatedDeal.id);
      setNdStep3Success('Animals & pricing saved.');
      return true;
    } catch (error: any) {
      setNdStep3Error(parseApiError(error?.message) || error?.message || 'Could not save animals & pricing.');
      return false;
    } finally {
      setNdSavingAnimals(false);
    }
  };

  const submitNewDealHealth = async (event?: React.FormEvent): Promise<boolean> => {
    event?.preventDefault();
    if (!ndCreatedDeal || ndSavingHealth) return false;
    setNdStep4Error('');
    setNdStep4Success('');

    const form = ndHealthForm;
    setNdSavingHealth(true);
    try {
      await updateDealApi(ndCreatedDeal.id, {
        examinedBeforeAndOnLoading: fromTriState(form.examinedBeforeAndOnLoading),
        freeOfListedDiseases: fromTriState(form.freeOfListedDiseases),
        diseasesPresent: form.freeOfListedDiseases === 'no' ? form.diseasesPresent : [],
        diseasesOther: form.freeOfListedDiseases === 'no' ? form.diseasesOther : '',
        clinicalReportAvailable: fromTriState(form.clinicalReportAvailable),
        withdrawalPeriodsAdhered: fromTriState(form.withdrawalPeriodsAdhered),
        purchaserDocumentsRequired: fromTriState(form.purchaserDocumentsRequired),
        purchaserDocumentsCompleted: form.purchaserDocumentsRequired === 'yes'
          ? fromTriState(form.purchaserDocumentsCompleted)
          : null,
        feedingSystem: form.feedingSystem,
        feedingSystemOther: form.feedingSystem === 'OTHER' ? form.feedingSystemOther : '',
        animalByProductsFed: fromTriState(form.animalByProductsFed),
        animalByProducts: form.animalByProductsFed === 'yes' ? form.animalByProducts : [],
        animalByProductsOther: form.animalByProductsFed === 'yes' ? form.animalByProductsOther : '',
      });
      // Traceability and a clinical report both add required uploads once
      // declared — refresh so the new rows appear immediately.
      await refreshNdRequirements(ndCreatedDeal.id);
      await refreshNdDealStats(ndCreatedDeal.id);
      setNdStep4Success('Health & feeding declarations saved.');
      return true;
    } catch (error: any) {
      setNdStep4Error(parseApiError(error?.message) || error?.message || 'Could not save the declarations.');
      return false;
    } finally {
      setNdSavingHealth(false);
    }
  };

  // Upload a supporting document (typically a PDF) against the deal currently
  // being edited on the deal screen.
  const resetFeedForm = () => {
    setFeedForm({ dealId: selectedDealId || '', feedId: '', feedType: '', quantityKg: 0, date: '' });
    setEditingFeedId('');
    setFeedCrudError('');
  };

  const resetFeedTypeForm = () => {
    setEditingFeedTypeId('');
    setNewFeedType({ name: '', description: '', costPerKg: '', stockQty: '' });
  };

  const resetWeighbridgeForm = () => {
    setEditingWeighbridgeRecordId('');
    setWeighbridgeForm({ grossWeightKg: '', tareWeightKg: '', recordedAt: '', notes: '' });
  };

  const resetDocumentForm = () => {
    setJourneyExtraEvents([]);
    setDocumentExtraDealIds([]);
    setDocumentCostMode('deal');
    setDocumentCostLines([]);
    setDocumentForm({
      dealId: selectedDealId || '',
      category: 'Wool',
      documentType: '',
      systemCode: '',
      referenceNumber: '',
      saleValue: '',
      dealEventId: '',
      dispatchEventId: '',
      courierId: '',
      vehicleRegistration: '',
      startKm: '',
      endKm: '',
      totalCost: '',
      dateOfDocument: '',
      offloadingDate: '',
      loadingTime: '',
      loadingPoint: '',
      offloadingPoint: '',
      driverName: '',
      driverContact: '',
      animalsDown: '',
      animalsDownReason: '',
      notes: '',
      visibility: 'ALL',
      sharedWithProducer: false,
      file: null,
    });
    setJourneyRemovalCertFile(null);
    setDocumentUploadError('');
    setDocumentUploadSuccess('');
    setUseManualDealEventId(false);
    setEditingDealDocumentId('');
    setEditingTransportJourneyId('');
    setEditingWoolFinanceId('');
    resetWeighbridgeForm();
  };

  const resetAnimalForm = () => {
    setAnimalForm({ dealId: selectedDealId || '', species: 'SHEEP', tag: '', eid: '', location: '', status: 'ACTIVE', breed: '', dob: '', sex: '' });
    setAnimalCrudError('');
    setAnimalCrudSuccess('');
    setUseManualAnimalLocation(false);
    setEditingAnimalId('');
    setAnimalDetail(null);
    setAnimalDetailEvents([]);
    setAnimalDetailPerformance(null);
    setAnimalDetailWeights([]);
    setAnimalDetailRawRows([]);
    setAnimalDetailTab('events');
    setAnimalRawFocusKey(null);
  };

  const resetCourierForm = () => {
    setEditingCourierId('');
    setNewCourier({ name: '', contactNumber: '', email: '' });
    setCourierFormError('');
  };

  useEffect(() => {
    if (view !== 'feedCrud') return;

    let cancelled = false;
    const loadFeedData = async () => {
      setLoadingFeedData(true);
      try {
        const targetDealId = feedForm.dealId || selectedDealId || undefined;
        const [feeds, consumptions] = await Promise.all([
          fetchFeedOptions(),
          fetchFeedConsumption(targetDealId),
        ]);
        if (cancelled) return;

        setFeedOptions(feeds);
        const feedNameById = new Map(feeds.map((feed) => [String(feed.id), feed.name]));
        const mappedRows: FeedRecord[] = consumptions.map((row) => ({
          id: row.id,
          dealId: row.dealId,
          feedId: row.feedId,
          feedType: feedNameById.get(String(row.feedId)) || `Feed ${row.feedId}`,
          quantityKg: row.quantityKg,
          date: row.date,
        }));

        setFeedRecords(mappedRows);
        setFeedForm((prev) => {
          if (prev.feedId || feeds.length === 0) return prev;
          return { ...prev, feedId: String(feeds[0].id), feedType: feeds[0].name };
        });
      } finally {
        if (!cancelled) {
          setLoadingFeedData(false);
        }
      }
    };

    loadFeedData();
    return () => {
      cancelled = true;
    };
  }, [feedForm.dealId, selectedDealId, view]);


  // Deleting a deal is destructive and irreversible, so it is a superuser
  // action only. Admins cancel a deal instead (deal status → Cancelled), which
  // keeps the deal and its whole history intact and auditable.
  const isSuperuser = Boolean(user?.is_superuser);

  const deleteDeal = async (dealId: string) => {
    setDealCrudError('');
    setDealCrudSuccess('');
    try {
      await deleteDealById(dealId);
      setDealCrudSuccess('Deal deleted.');
    } catch (error: any) {
      setDealCrudError(parseApiError(error?.message) || 'Could not delete deal.');
      return;
    }

    setDeals((prev) => prev.filter((deal) => deal.dealId !== dealId));
    setFeedRecords((prev) => prev.filter((row) => row.dealId !== dealId));
    if (selectedDealId === dealId) {
      const fallbackDeal = deals.find((deal) => deal.dealId !== dealId);
      const fallbackId = fallbackDeal?.dealId || '';
      setSelectedDealId(fallbackId);
      setFeedForm((prev) => ({ ...prev, dealId: fallbackId }));
      setAnimalForm((prev) => ({ ...prev, dealId: fallbackId }));
    }
  };

  const submitFeedRecord = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!feedForm.dealId || !feedForm.feedId || !feedForm.date) {
      setFeedCrudError('Select deal, feed type, and date before saving.');
      return;
    }
    if (Number(feedForm.quantityKg) < 0) {
      setFeedCrudError('Quantity cannot be negative.');
      return;
    }

    setFeedCrudError('');
    setFeedCrudSuccess('');

    const payload = {
      dealId: feedForm.dealId,
      feedId: feedForm.feedId,
      quantityKg: Number(feedForm.quantityKg || 0),
      date: feedForm.date,
    };

    try {
      if (editingFeedId) {
        await updateFeedConsumption(editingFeedId, payload);
        setFeedCrudSuccess('Feed record updated.');
      } else {
        await createFeedConsumption(payload);
        setFeedCrudSuccess('Feed record saved.');
      }

      const consumptions = await fetchFeedConsumption(selectedDealId || feedForm.dealId || undefined);
      const feedNameById = new Map(feedOptions.map((feed) => [String(feed.id), feed.name]));
      const mappedRows: FeedRecord[] = consumptions.map((row) => ({
        id: row.id,
        dealId: row.dealId,
        feedId: row.feedId,
        feedType: feedNameById.get(String(row.feedId)) || `Feed ${row.feedId}`,
        quantityKg: row.quantityKg,
        date: row.date,
      }));
      setFeedRecords(mappedRows);

      resetFeedForm();
    } catch (error: any) {
      setFeedCrudError(parseApiError(error?.message) || 'Could not save feed record.');
    }
  };

  const submitFeedType = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!newFeedType.name.trim()) {
      setFeedCrudError('Feed type name is required.');
      return;
    }

    setCreatingFeedType(true);
    setFeedCrudError('');
    setFeedCrudSuccess('');

    try {
      const payload = {
        name: newFeedType.name.trim(),
        description: newFeedType.description.trim() || undefined,
        costPerKg: newFeedType.costPerKg ? Number(newFeedType.costPerKg) : undefined,
        stockQty: newFeedType.stockQty ? Number(newFeedType.stockQty) : undefined,
      };
      const saved = editingFeedTypeId
        ? await updateFeedOption(editingFeedTypeId, payload)
        : await createFeedOption(payload);

      const refreshedFeeds = await fetchFeedOptions();
      const nextFeeds = refreshedFeeds.length > 0 ? refreshedFeeds : [saved];
      setFeedOptions(nextFeeds);
      setFeedForm((prev) => ({
        ...prev,
        feedId: String(saved.id),
        feedType: saved.name,
      }));
      setFeedCrudSuccess(
        editingFeedTypeId
          ? `Feed type "${saved.name}" updated.`
          : `Feed type "${saved.name}" created.`
      );
      resetFeedTypeForm();
    } catch (error: any) {
      setFeedCrudError(parseApiError(error?.message) || 'Could not save feed type.');
    } finally {
      setCreatingFeedType(false);
    }
  };

  const editFeedType = (feedId: string) => {
    const row = feedOptions.find((feed) => String(feed.id) === String(feedId));
    if (!row) return;
    setEditingFeedTypeId(String(row.id));
    setNewFeedType({
      name: row.name || '',
      description: row.description || '',
      costPerKg: row.costPerKg != null ? String(row.costPerKg) : '',
      stockQty: row.stockQty != null ? String(row.stockQty) : '',
    });
    setFeedCrudError('');
    setFeedCrudSuccess('');
  };

  const removeFeedType = async (feedId: string) => {
    setFeedCrudError('');
    setFeedCrudSuccess('');
    try {
      await deleteFeedOption(feedId);
      const refreshedFeeds = await fetchFeedOptions();
      setFeedOptions(refreshedFeeds);
      if (String(feedForm.feedId) === String(feedId)) {
        setFeedForm((prev) => ({ ...prev, feedId: '', feedType: '' }));
      }
      if (editingFeedTypeId === feedId) {
        resetFeedTypeForm();
      }
      setFeedCrudSuccess('Feed type deleted.');
    } catch (error: any) {
      setFeedCrudError(parseApiError(error?.message) || 'Could not delete feed type.');
    }
  };

  function parseApiError(raw: string | undefined): string {
    if (!raw) return 'Something went wrong. Please try again.';
    const trimmed = raw.trim();
    if (trimmed.startsWith('<') || trimmed.toLowerCase().startsWith('<!doctype')) {
      const stripTags = (value: string) => value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
      const decodeEntities = (value: string) => value
        .replace(/&quot;/g, '"')
        .replace(/&#x27;/g, "'")
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>');

      const exceptionValueMatch =
        trimmed.match(/<pre[^>]*class=["']exception_value["'][^>]*>([\s\S]*?)<\/pre>/i) ||
        trimmed.match(/Exception Value:\s*<\/th>\s*<td[^>]*>\s*<pre[^>]*>([\s\S]*?)<\/pre>/i);
      if (exceptionValueMatch?.[1]) {
        const detail = decodeEntities(stripTags(exceptionValueMatch[1]));
        if (detail) return `Server error: ${detail}`;
      }

      const titleMatch = trimmed.match(/<title>\s*([^<]+?)\s*<\/title>/i);
      if (titleMatch?.[1]) {
        const title = decodeEntities(stripTags(titleMatch[1]));
        if (title && !/server error \(500\)/i.test(title)) {
          return `Server error: ${title}`;
        }
      }

      return 'The server encountered an error. Please try again or contact your AVCS administrator.';
    }
    const fieldLabels: Record<string, string> = {
      deal_event: 'transport event',
      deal: 'deal',
      document_type: 'document type',
      file: 'file',
      courier: 'courier',
      entity: 'entity',
      user: 'user',
      sale_value: 'sale value',
      sale_date: 'sale date',
      loading_date: 'loading date',
      vehicle_registration: 'vehicle registration',
      start_km: 'start KM',
      end_km: 'end KM',
      waybill_no: 'waybill number',
      non_field_errors: '',
      detail: '',
    };
    try {
      const parsed = JSON.parse(raw);
      if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
        const messages: string[] = [];
        for (const [field, value] of Object.entries(parsed)) {
          const label = fieldLabels[field] ?? field.replace(/_/g, ' ');
          const msgs = Array.isArray(value) ? value.map(String) : [String(value)];
          for (const msg of msgs) {
            const clean = msg.charAt(0).toUpperCase() + msg.slice(1);
            messages.push(label ? `${label.charAt(0).toUpperCase() + label.slice(1)}: ${clean}` : clean);
          }
        }
        if (messages.length > 0) return messages.join(' ');
      }
      if (Array.isArray(parsed)) return parsed.map(String).join(' ');
    } catch {
      // not JSON — fall through
    }
    return raw.length > 200 ? 'Something went wrong. Please try again.' : raw;
  }

  const submitDocumentUpload = async (event: React.FormEvent) => {
    event.preventDefault();
    const isEditingDocument = Boolean(editingDealDocumentId || editingTransportJourneyId || editingWoolFinanceId);
    if (!documentForm.dealId) {
      setDocumentUploadError('Please select a deal.');
      return;
    }
    if (!documentForm.dateOfDocument) {
      setDocumentUploadError('Please enter the date of the document.');
      return;
    }
    if (!documentForm.file && !isEditingDocument) {
      setDocumentUploadError('Please select a file to upload.');
      return;
    }

    if ((documentForm.category === 'Deal' || documentForm.category === 'GS1') && !documentForm.systemCode) {
      setDocumentUploadError('Please select a document type before uploading.');
      return;
    }

    if (documentForm.category === 'Wool' && (!documentForm.systemCode || !documentForm.saleValue || Number(documentForm.saleValue) < 0)) {
      setDocumentUploadError('Please fill in the document type and a valid (non-negative) sale value for wool records.');
      return;
    }

    if (
      documentForm.category === 'Transport'
      && (!documentForm.dealEventId || !documentForm.courierId || !documentForm.vehicleRegistration || documentForm.startKm === '' || documentForm.endKm === '')
    ) {
      const missing = [];
      if (!documentForm.dealEventId) missing.push('transport event ID');
      if (!documentForm.courierId) missing.push('courier');
      if (!documentForm.vehicleRegistration) missing.push('vehicle registration');
      if (documentForm.startKm === '' || documentForm.endKm === '') missing.push('KM readings');
      setDocumentUploadError(
        `Please fill in the following required fields: ${missing.join(', ')}. Every transport record requires full journey details.`
      );
      return;
    }

    if (documentForm.category === 'Transport' && documentForm.startKm !== '' && documentForm.endKm !== '') {
      if (Number(documentForm.endKm) <= Number(documentForm.startKm)) {
        setDocumentUploadError('End KM must be greater than start KM.');
        return;
      }
    }

    setUploadingDocument(true);
    setDocumentUploadError('');
    setDocumentUploadSuccess('');

    try {
      const documentMoneyKind = dealDocumentTypeOptions.find((o) => o.id === documentForm.systemCode)?.financeRecordType || '';
      const splitMeta = DEAL_FINANCE_TYPES.find((t) => t.value === documentMoneyKind);
      const splitting = documentForm.category === 'Deal' && !editingDealDocumentId && documentCostMode === 'split' && Boolean(splitMeta?.isCost);
      if (splitting && (documentCostLines.length === 0 || documentCostLines.some((l) => !costLineIsComplete(l)))) {
        setDocumentUploadError('Every cost line needs a description and a cost — or remove the empty line.');
        setUploadingDocument(false);
        return;
      }
      if (documentForm.category === 'Deal' || documentForm.category === 'GS1') {
        if (editingDealDocumentId) {
          await updateDealDocument(editingDealDocumentId, {
            documentType: documentForm.systemCode || documentForm.documentType,
            file: documentForm.file,
            dateOfDocument: documentForm.dateOfDocument,
            referenceNumber: documentForm.referenceNumber,
            saleValue: documentForm.saleValue,
            notes: documentForm.notes,
            visibility: documentForm.visibility,
            sharedWithProducer: documentForm.sharedWithProducer,
          });
        } else {
          // Every deal the file covers gets its own DealDocument (the model
          // is per deal). A sale value is the whole document's, so it is
          // split by head across the deals, remainder on the largest.
          const targetDealIds = [documentForm.dealId, ...documentExtraDealIds.filter((id) => id !== documentForm.dealId)];
          // When the value is split across animals the shared record carries
          // the money; the documents are filed without a value so nothing is
          // booked twice.
          const saleTotal = !splitting && documentForm.saleValue ? Number(documentForm.saleValue) : null;
          let saleShares: (string | undefined)[] = targetDealIds.map(() => documentForm.saleValue || undefined);
          if (saleTotal !== null && targetDealIds.length > 1) {
            const heads = targetDealIds.map((id) => Number(deals.find((d) => d.dealId === id)?.headcount || 0));
            const headTotal = heads.reduce((sum, n) => sum + n, 0);
            const weights = headTotal > 0 && heads.every((n) => n > 0) ? heads.map((n) => n / headTotal) : targetDealIds.map(() => 1 / targetDealIds.length);
            const parts = weights.map((w) => Math.round(saleTotal * w * 100) / 100);
            const remainder = Math.round((saleTotal - parts.reduce((sum, v) => sum + v, 0)) * 100) / 100;
            parts[weights.indexOf(Math.max(...weights))] = Math.round((parts[weights.indexOf(Math.max(...weights))] + remainder) * 100) / 100;
            saleShares = parts.map((v) => v.toFixed(2));
          }
          let firstCreatedDocumentId = '';
          for (const [index, dealId] of targetDealIds.entries()) {
            const createdDoc = await uploadDealDocument({
              dealId,
              documentType: documentForm.systemCode || documentForm.documentType,
              file: documentForm.file as File,
              dateOfDocument: documentForm.dateOfDocument,
              referenceNumber: documentForm.referenceNumber,
              saleValue: splitting ? '' : (saleShares[index] || ''),
              notes: targetDealIds.length > 1
                ? [documentForm.notes, `Filed against ${targetDealIds.length} deals${saleTotal !== null ? `; value R ${saleTotal.toFixed(2)} split by head` : ''}.`].filter(Boolean).join(' ')
                : documentForm.notes,
              visibility: documentForm.visibility,
              sharedWithProducer: documentForm.sharedWithProducer,
            });
            if (!firstCreatedDocumentId && createdDoc?.id) firstCreatedDocumentId = String(createdDoc.id);
          }
          if (splitting) {
            // A line with events becomes one shared record split equally
            // across every animal on those events (each deal gets its share).
            // A line with no events is divided across every animal in the
            // selected deals and booked straight onto each deal's ledger. Each
            // shared record points at the document just filed -- one copy of
            // the file, not one per line.
            let fileAttached = Boolean(firstCreatedDocumentId);
            const heads = targetDealIds.map((id) => ({ key: id, animals: Number(deals.find((d) => d.dealId === id)?.headcount || 0) }));
            for (const line of documentCostLines) {
              if (line.eventIds.length > 0) {
                await createSharedFinance({
                  recordType: documentMoneyKind,
                  amount: line.amount,
                  invoiceDate: documentForm.dateOfDocument,
                  basis: 'EVENT_ANIMALS',
                  basisEventIds: line.eventIds,
                  description: line.description.trim(),
                  referenceNumber: documentForm.referenceNumber || undefined,
                  sourceDocumentId: firstCreatedDocumentId || undefined,
                  document: fileAttached ? null : documentForm.file,
                });
                fileAttached = true;
              } else {
                for (const share of splitByHead(Number(line.amount), heads)) {
                  if (share.amount <= 0) continue;
                  await createDealFinance({
                    dealId: share.key,
                    recordType: documentMoneyKind as any,
                    amount: share.amount.toFixed(2),
                    transactionDate: documentForm.dateOfDocument,
                    description: `${line.description.trim()} — ${share.animals} of ${heads.reduce((s, h) => s + h.animals, 0)} head`,
                  });
                }
              }
            }
          }
        }
      }

      if (documentForm.category === 'Wool') {
        if (editingWoolFinanceId) {
          await updateWoolFinance(editingWoolFinanceId, {
            dealId: documentForm.dealId,
            documentTypeId: documentForm.systemCode,
            saleValue: Number(documentForm.saleValue),
            saleDate: documentForm.dateOfDocument,
            file: documentForm.file,
            notes: documentForm.notes,
            visibility: documentForm.visibility,
          });
        } else {
          await uploadWoolFinance({
            dealId: documentForm.dealId,
            documentTypeId: documentForm.systemCode,
            saleValue: Number(documentForm.saleValue),
            saleDate: documentForm.dateOfDocument,
            file: documentForm.file as File,
            notes: documentForm.notes,
            visibility: documentForm.visibility,
          });
        }
      }

      if (documentForm.category === 'Transport') {
        const invoiceSelected = documentForm.documentType === 'transport_invoice';
        if (editingTransportJourneyId) {
          await updateTransportJourney(editingTransportJourneyId, {
            dealEventId: documentForm.dealEventId,
            courierId: documentForm.courierId,
            loadingDate: documentForm.dateOfDocument,
            vehicleRegistration: documentForm.vehicleRegistration,
            startKm: Number(documentForm.startKm),
            endKm: Number(documentForm.endKm),
            waybillNumber: documentForm.referenceNumber,
            totalCost: documentForm.totalCost ? Number(documentForm.totalCost) : undefined,
            waybillFile: invoiceSelected ? undefined : (documentForm.file || undefined),
            invoiceFile: invoiceSelected ? (documentForm.file || undefined) : undefined,
            documentVisibility: documentForm.visibility,
          });
        } else {
          await uploadTransportJourney({
            dealEventId: documentForm.dealEventId,
            courierId: documentForm.courierId,
            loadingDate: documentForm.dateOfDocument,
            vehicleRegistration: documentForm.vehicleRegistration,
            startKm: Number(documentForm.startKm),
            endKm: Number(documentForm.endKm),
            waybillNumber: documentForm.referenceNumber,
            totalCost: documentForm.totalCost ? Number(documentForm.totalCost) : undefined,
            waybillFile: invoiceSelected ? undefined : (documentForm.file || undefined),
            invoiceFile: invoiceSelected ? (documentForm.file || undefined) : undefined,
            documentVisibility: documentForm.visibility,
          });
        }
      }

      const dealTitle = deals.find((deal) => deal.dealId === documentForm.dealId)?.title || documentForm.dealId;
      const selectedDocumentTypeLabel = documentForm.category === 'Transport'
        ? documentForm.documentType
        : (dealDocumentTypeOptions.find((option) => option.id === documentForm.systemCode)?.label || documentForm.systemCode);

      setUploadedDocuments((prev) => [
        {
          id: uid(),
          dealId: documentForm.dealId,
          dealTitle,
          category: documentForm.category,
          fileName: documentForm.file ? documentForm.file.name : 'Unknown file',
          documentType: selectedDocumentTypeLabel,
          systemCode: documentForm.systemCode,
          referenceNumber: documentForm.referenceNumber,
          dateOfDocument: documentForm.dateOfDocument,
        },
        ...prev,
      ]);

      const targetDealId = documentForm.dealId || selectedDealId;
      if (targetDealId) {
        await loadExistingDocuments(targetDealId);
      }
      const filedAcross = documentForm.category === 'Deal' && !editingDealDocumentId ? 1 + documentExtraDealIds.filter((id) => id !== documentForm.dealId).length : 1;
      setDocumentUploadSuccess(
        editingDealDocumentId || editingTransportJourneyId || editingWoolFinanceId
          ? `${documentForm.category} record updated successfully.`
          : splitting
            ? `Document filed and ${documentCostLines.length} cost line${documentCostLines.length === 1 ? '' : 's'} (R ${costLinesTotal(documentCostLines).toFixed(2)}) booked as ${splitMeta?.label.toLowerCase()} — each line split equally across the animals on its events, onto each deal's ledger.`
          : filedAcross > 1
            ? `Document filed against ${filedAcross} deals${documentForm.saleValue ? ', value split by head' : ''}.`
            : `${documentForm.category} upload saved successfully.`
      );
      setDocumentExtraDealIds([]);
      setDocumentCostMode('deal');
      setDocumentCostLines([]);
      setEditingDealDocumentId('');
      setEditingTransportJourneyId('');
      setEditingWoolFinanceId('');
      resetWeighbridgeForm();
      setFileInputKey((k) => k + 1);
      setDocumentForm((prev) => ({
        ...prev,
        documentType: '',
        referenceNumber: '',
        saleValue: '',
        dealEventId: '',
        courierId: '',
        vehicleRegistration: '',
        startKm: '',
        endKm: '',
        totalCost: '',
        dateOfDocument: '',
        notes: '',
        file: null,
      }));
    } catch (error: any) {
      const parsed = parseApiError(error?.message) || 'Could not save document.';
      const alreadyExists = parsed.toLowerCase().includes('already exists');
      setDocumentUploadError(
        alreadyExists
          ? `${parsed} Find the existing record in the table below and click Edit to update it.`
          : parsed
      );
    } finally {
      setUploadingDocument(false);
    }
  };

  const submitNewCourier = async () => {
    if (!newCourier.name.trim()) {
      setCourierFormError('Courier name is required.');
      return;
    }

    setCreatingCourier(true);
    setCourierFormError('');
    try {
      const payload = {
        name: newCourier.name.trim(),
        contactNumber: newCourier.contactNumber.trim(),
        email: newCourier.email.trim(),
      };
      const saved = editingCourierId
        ? await updateCourier(editingCourierId, payload)
        : await createCourier(payload);

      if (editingCourierId) {
        setCouriers((prev) => prev.map((row) => (row.id === editingCourierId ? saved : row)));
      } else {
        setCouriers((prev) => [saved, ...prev]);
      }
      setDocumentForm((prev) => ({ ...prev, courierId: saved.id }));
      resetCourierForm();
      setShowAddCourierForm(false);
      setDocumentUploadSuccess(
        editingCourierId
          ? `Courier "${saved.name}" updated and selected.`
          : `Courier "${saved.name}" added and selected.`
      );
      setDocumentUploadError('');
    } catch (error: any) {
      setCourierFormError(parseApiError(error?.message) || 'Could not save courier.');
    } finally {
      setCreatingCourier(false);
    }
  };

  const editCourier = (courierId: string) => {
    const row = couriers.find((courier) => courier.id === courierId);
    if (!row) return;
    setEditingCourierId(row.id);
    setNewCourier({
      name: row.name || '',
      contactNumber: row.contactNumber || '',
      email: row.email || '',
    });
    setCourierFormError('');
    setShowAddCourierForm(true);
  };

  const removeCourier = async (courierId: string) => {
    setCourierFormError('');
    setDocumentUploadError('');
    try {
      await deleteCourier(courierId);
      setCouriers((prev) => prev.filter((courier) => courier.id !== courierId));
      if (documentForm.courierId === courierId) {
        setDocumentForm((prev) => ({ ...prev, courierId: '' }));
      }
      if (editingCourierId === courierId) {
        resetCourierForm();
      }
      setDocumentUploadSuccess('Courier deleted.');
    } catch (error: any) {
      setDocumentUploadError(parseApiError(error?.message) || 'Could not delete courier.');
    }
  };

  const editFeedRecord = (recordId: string) => {
    const row = feedRecords.find((record) => record.id === recordId);
    if (!row) return;
    setEditingFeedId(recordId);
    setFeedForm({
      dealId: row.dealId,
      feedId: row.feedId,
      feedType: row.feedType,
      quantityKg: row.quantityKg,
      date: row.date,
    });
  };

  const deleteFeedRecord = async (recordId: string) => {
    try {
      await deleteFeedConsumption(recordId);
      setFeedRecords((prev) => prev.filter((record) => record.id !== recordId));
      setFeedCrudSuccess('Feed record deleted.');
      if (editingFeedId === recordId) {
        resetFeedForm();
      }
    } catch (error: any) {
      setFeedCrudError(parseApiError(error?.message) || 'Could not delete feed record.');
    }
  };

  const submitAnimal = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!animalForm.dealId) return;
    if (isSavingAnimal) return;
    setIsSavingAnimal(true);
    setAnimalCrudError('');
    setAnimalCrudSuccess('');

    const targetDealId = animalForm.dealId;
    const payload = {
      dealId: targetDealId,
      species: animalForm.species,
      vid: animalForm.tag.trim() || undefined,
      currentEntity: animalForm.location.trim() || undefined,
      status: (animalForm.status || 'ACTIVE') as AnimalStatus,
      breed: animalForm.breed || undefined,
      dob: animalForm.dob || null,
      sex: (animalForm.sex || null) as ('M' | 'F' | null),
    };

    try {
      if (editingAnimalId) {
        // EID is intentionally not editable from the detail form.
        await updateAnimalApi(editingAnimalId, payload);
        setAnimalCrudSuccess('Animal updated.');
        setShowAnimalEditForm(false);
        await openAnimalDetail(editingAnimalId, { silent: true });
      } else {
        const created = await createAnimalApi({ ...payload, eidTag: animalForm.eid.trim() || undefined });
        setAnimalCrudSuccess('Animal created.');
        if (created?.id) await openAnimalDetail(String(created.id), { silent: true });
      }
      fetchAnimalLocations().then(setAnimalRegister).catch(() => {});
      // Refresh the full animal list so the create/edit is reflected in it.
      fetchAnimals().then(setAllAnimals).catch(() => {});
    } catch (error: any) {
      setAnimalCrudError(parseApiError(error?.message) || 'Could not save animal.');
    } finally {
      setIsSavingAnimal(false);
    }
  };

  const openAnimalDetail = async (animalId: string, opts: { silent?: boolean; returnToDealTab?: string } = {}) => {
    // Only a click from a deal's tab sets a way back to that deal; any other entry clears it.
    if (!opts.silent) setAnimalReturnDealTab(opts.returnToDealTab ?? null);
    setEditingAnimalId(animalId);
    setView('animalCrud');
    setLoadingAnimalDetail(true);
    if (!opts.silent) setShowAnimalEditForm(false);
    if (!opts.silent) {
      setAnimalCrudError('');
      setAnimalCrudSuccess('');
    }
    try {
      const [animal, events, performance, weights, rawRows] = await Promise.all([
        fetchAnimal(animalId),
        fetchAnimalEvents(animalId).catch(() => []),
        fetchAnimalPerformance(animalId).catch(() => null),
        fetchAnimalWeightHistory(animalId).catch(() => []),
        fetchAnimalRawRows(animalId).catch(() => []),
      ]);
      setAnimalDetail(animal);
      // Newest date first (as the API returns), but tie-break same-date events
      // by value-chain step: farm → feedlot → abattoir.
      setAnimalDetailEvents(
        [...events].sort(
          (a, b) =>
            eventTimestamp(b) - eventTimestamp(a) ||
            valueChainEventRank(a.event_type) - valueChainEventRank(b.event_type)
        )
      );
      setAnimalDetailPerformance(performance);
      setAnimalDetailWeights(weights);
      setAnimalDetailRawRows(rawRows);
      if (!opts.silent) {
        setAnimalDetailTab('events');
        setAnimalRawFocusKey(null);
      }
      setAnimalForm({
        dealId: animal.deal ? String(animal.deal) : '',
        species: animal.species,
        tag: animal.vid || '',
        eid: animal.eid_tag || '',
        location: animal.current_entity || '',
        status: animal.status || 'ACTIVE',
        breed: animal.breed ? String(animal.breed) : '',
        dob: animal.dob || '',
        sex: animal.sex || '',
      });
      setUseManualAnimalLocation(!!animal.current_entity && !COMMON_LOCATION_OPTIONS.includes(animal.current_entity));
    } catch (error: any) {
      setAnimalCrudError(parseApiError(error?.message) || 'Could not load animal.');
    } finally {
      setLoadingAnimalDetail(false);
    }
  };

  const handleDeleteAnimal = async (animalId: string) => {
    if (!animalId) return;
    setDeletingAnimalId(animalId);
    setAnimalCrudError('');
    setAnimalCrudSuccess('');
    try {
      await deleteAnimalById(animalId);
      setAnimalRegister((prev) => prev.filter((a) => a.animal_id !== animalId));
      setAllAnimals((prev) => prev.filter((a) => a.id !== animalId));
      setAnimalCrudSuccess('Animal deleted.');
      if (editingAnimalId === animalId) {
        resetAnimalForm();
        setView('animalList');
      }
    } catch (error: any) {
      setAnimalCrudError(parseApiError(error?.message) || 'Could not delete animal.');
    } finally {
      setDeletingAnimalId('');
    }
  };

  const editDealDocumentRow = (row: DealDocumentSummary) => {
    setEditingDealDocumentId(row.id);
    setEditingTransportJourneyId('');
    setEditingWoolFinanceId('');
    resetWeighbridgeForm();
    setDocumentForm((prev) => ({
      ...prev,
      category: 'Deal',
      systemCode: row.documentTypeId || '',
      referenceNumber: row.referenceNumber || '',
      dateOfDocument: row.dateOfDocument || '',
      saleValue: row.saleValue || '',
      notes: row.notes || '',
      visibility: row.visibility === 'ADMIN' ? 'ADMIN' : 'ALL',
      sharedWithProducer: !!row.sharedWithProducer,
      file: null,
    }));
  };

  const removeDealDocumentRow = async (id: string) => {
    setDocumentUploadError('');
    setDocumentUploadSuccess('');
    try {
      await deleteDealDocument(id);
      const targetDealId = documentForm.dealId || selectedDealId;
      if (targetDealId) {
        await loadExistingDocuments(targetDealId);
      }
      if (editingDealDocumentId === id) {
        setEditingDealDocumentId('');
      }
      setDocumentUploadSuccess('Deal document deleted.');
    } catch (error: any) {
      setDocumentUploadError(parseApiError(error?.message) || 'Could not delete that document.');
    }
  };

  const editTransportJourneyRow = (row: TransportJourneySummary) => {
    setEditingDealDocumentId('');
    setEditingTransportJourneyId(row.id);
    setEditingWoolFinanceId('');
    setDocumentForm((prev) => ({
      ...prev,
      category: 'Transport',
      dealEventId: row.dealEventId || '',
      dispatchEventId: row.dispatchEventId || '',
      courierId: row.courierId || '',
      vehicleRegistration: row.vehicleRegistration || '',
      referenceNumber: row.waybillNo || '',
      startKm: row.startKm != null ? String(row.startKm) : '',
      endKm: row.endKm != null ? String(row.endKm) : '',
      totalCost: row.totalCost != null ? String(row.totalCost) : '',
      dateOfDocument: row.loadingDate || '',
      offloadingDate: row.offloadingDate || '',
      loadingTime: row.loadingTime ? row.loadingTime.slice(0, 5) : '',
      loadingPoint: row.loadingPoint || '',
      offloadingPoint: row.offloadingPoint || '',
      driverName: row.driverName || '',
      driverContact: row.driverContact || '',
      animalsDown: row.animalsDown != null ? String(row.animalsDown) : '',
      animalsDownReason: row.animalsDownReason || '',
      visibility: row.documentVisibility === 'ADMIN' ? 'ADMIN' : 'ALL',
      file: null,
    }));
    setJourneyRemovalCertFile(null);
    setEditingWeighbridgeRecordId(row.weighbridgeRecordId || '');
    setWeighbridgeForm({
      grossWeightKg: row.weighbridgeGrossWeightKg || '',
      tareWeightKg: row.weighbridgeTareWeightKg || '',
      recordedAt: row.weighbridgeRecordedAt ? row.weighbridgeRecordedAt.slice(0, 16) : '',
      notes: '',
    });

    // Ensure we are always in dropdown mode when editing — the useEffect will inject
    // a synthetic "Event #N (current)" option if the stored ID is not in the fetched list.
    setUseManualDealEventId(false);
  };

  const removeTransportJourneyRow = async (id: string) => {
    setDocumentUploadError('');
    setDocumentUploadSuccess('');
    try {
      await deleteTransportJourney(id);
      const targetDealId = documentForm.dealId || selectedDealId;
      if (targetDealId) {
        await loadExistingDocuments(targetDealId);
      }
      if (editingTransportJourneyId === id) {
        setEditingTransportJourneyId('');
        resetWeighbridgeForm();
      }
      setDocumentUploadSuccess('Transport journey deleted.');
    } catch (error: any) {
      setDocumentUploadError(parseApiError(error?.message) || 'Could not delete that transport record.');
    }
  };

  const openJourneyHistoryRowForEdit = async (row: { dealId: string; journey: TransportJourneySummary }) => {
    setDocumentUploadError('');
    setDocumentUploadSuccess('');
    setUseManualDealEventId(false);
    setTransportJourneyRows([]);
    setTransportDealEventOptions([]);
    setTransportDispatchEventOptions([]);
    setDealEventLabelsById({});
    setDocumentForm((prev) => ({ ...prev, dealId: row.dealId, dealEventId: '' }));
    if (row.dealId) {
      const [journeys, events, dispatchEvents, labels] = await Promise.all([
        fetchTransportJourneys(row.dealId).catch(() => []),
        fetchTransportDealEventOptions(row.dealId).catch(() => []),
        fetchTransportDispatchEventOptions(row.dealId).catch(() => []),
        fetchDealEventLabels(row.dealId).catch(() => ({})),
      ]);
      setTransportJourneyRows(journeys);
      setTransportDealEventOptions(events);
      setTransportDispatchEventOptions(dispatchEvents);
      setDealEventLabelsById(labels);
    }
    editTransportJourneyRow(row.journey);
    setView('transportJourneys');
  };

  const removeJourneyHistoryRow = async (id: string) => {
    setJourneyHistoryError('');
    try {
      await deleteTransportJourney(id);
      setJourneyHistoryRows((prev) => prev.filter((row) => row.id !== id));
    } catch (error: any) {
      setJourneyHistoryError(parseApiError(error?.message) || 'Could not delete that journey.');
    }
  };

  // --- Weighbridge record helpers (standalone screen) ---

  const resetWbForm = () => {
    setWbForm(emptyWeighbridgeStandaloneForm);
    setEditingWbId('');
    setWbReceiveSearch('');
    setWbShowReceiveDropdown(false);
    setWbJourneyOptions([]);
    setWbError('');
    setWbSuccess('');
  };

  // A weighbridge record can optionally link to a journey in the SAME deal —
  // load that deal's journeys so the dropdown only offers valid choices.
  const loadWbJourneyOptions = (dealId: string) => {
    if (!dealId) {
      setWbJourneyOptions([]);
      return;
    }
    fetchTransportJourneys(dealId)
      .then(setWbJourneyOptions)
      .catch(() => setWbJourneyOptions([]));
  };

  const openWeighbridgeNew = () => {
    resetWbForm();
    setView('weighbridgeNew');
  };

  const editWeighbridgeHistoryRow = (row: any) => {
    setWbError('');
    setWbSuccess('');
    setEditingWbId(row.id);
    setWbForm({
      dealId: row.dealId || '',
      dealEventId: row.record?.dealEventId || '',
      journeyId: row.journeyId || '',
      // datetime-local wants "YYYY-MM-DDTHH:mm"; trim any seconds/zone suffix.
      recordedAt: row.recordedAt ? String(row.recordedAt).slice(0, 16) : '',
      grossWeightKg: row.grossWeightKg || '',
      tareWeightKg: row.tareWeightKg || '',
      notes: row.notes || '',
    });
    setWbReceiveSearch('');
    setWbShowReceiveDropdown(false);
    loadWbJourneyOptions(row.dealId || '');
    setView('weighbridgeNew');
  };

  const removeWeighbridgeHistoryRow = async (id: string) => {
    setWeighbridgeHistoryError('');
    try {
      await deleteWeighbridgeRecord(id);
      setWeighbridgeHistoryRows((prev) => prev.filter((row) => row.id !== id));
    } catch (error: any) {
      setWeighbridgeHistoryError(parseApiError(error?.message) || 'Could not delete that weighbridge record.');
    }
  };

  const submitWeighbridgeStandalone = async (event: React.FormEvent) => {
    event.preventDefault();
    setWbError('');
    setWbSuccess('');

    const missing: string[] = [];
    if (!wbForm.dealEventId) missing.push('receive event');
    if (!wbForm.grossWeightKg.trim()) missing.push('gross weight');
    if (!wbForm.recordedAt) missing.push('recorded date/time');
    if (missing.length > 0) {
      setWbError(`Please fill in: ${missing.join(', ')}.`);
      return;
    }
    if (wbForm.tareWeightKg.trim() && Number(wbForm.tareWeightKg) > Number(wbForm.grossWeightKg)) {
      setWbError('Tare weight cannot be greater than gross weight.');
      return;
    }

    setWbSaving(true);
    try {
      const input: WeighbridgeRecordUpsertInput = {
        eventId: wbForm.dealEventId,
        recordedAt: wbForm.recordedAt,
        grossWeightKg: wbForm.grossWeightKg.trim(),
        tareWeightKg: wbForm.tareWeightKg.trim() || undefined,
        notes: wbForm.notes.trim(),
        journeyId: wbForm.journeyId || null,
      };
      if (editingWbId) {
        await updateWeighbridgeRecord(editingWbId, input);
        setWbSuccess('Weighbridge record updated.');
      } else {
        await createWeighbridgeRecord(input);
        setWbSuccess('Weighbridge record created.');
      }
      // Keep the deal/event selected for fast repeat capture, clear the readings.
      setWbForm((prev) => ({ ...prev, journeyId: '', recordedAt: '', grossWeightKg: '', tareWeightKg: '', notes: '' }));
      setEditingWbId('');
      setUploadCompletedCount((count) => count + 1);
    } catch (error: any) {
      setWbError(parseApiError(error?.message) || 'Could not save the weighbridge record.');
    } finally {
      setWbSaving(false);
    }
  };

  // Deal event edit — live on the backend as of v2.6.26 (PATCH /api/deals/{id}/events/{id}/).
  // Void/delete is intentionally not wired into any UI yet — edit only for now.
  const startEditEvent = (evt: any) => {
    setEventActionError('');
    setEventActionSuccess('');
    setEditingEventId(String(evt.id));
    setEditingEventDealId(evt.deal?.dealId || '');
    setEventEditForm({
      eventDate: evt.event_date ? String(evt.event_date).split('T')[0] : '',
      animalCount: evt.animal_count != null ? String(evt.animal_count) : '',
      sourceEntityId: evt.source_entity != null ? String(evt.source_entity) : '',
      destinationEntityId: evt.destination_entity != null ? String(evt.destination_entity) : '',
      species: evt.species || '',
    });
    const sourceById = evt.source_entity != null ? entityDirectory.find((e) => e.id === String(evt.source_entity)) : undefined;
    const destById = evt.destination_entity != null ? entityDirectory.find((e) => e.id === String(evt.destination_entity)) : undefined;
    setEventEditSourceUnit(sourceById || (evt.source_entity_name ? ({ id: '', entityName: evt.source_entity_name } as EntitySummary) : null));
    setEventEditDestUnit(destById || (evt.destination_entity_name ? ({ id: '', entityName: evt.destination_entity_name } as EntitySummary) : null));
    setEventEditSourceSearch('');
    setEventEditDestSearch('');
    setShowEventEditSourceDropdown(false);
    setShowEventEditDestDropdown(false);
  };

  const cancelEditEvent = () => {
    setEditingEventId('');
    setEditingEventDealId('');
    setEventEditForm({ eventDate: '', animalCount: '', sourceEntityId: '', destinationEntityId: '', species: '' });
    setEventEditSourceUnit(null);
    setEventEditDestUnit(null);
    setEventEditSourceSearch('');
    setEventEditDestSearch('');
  };

  const saveEventEdit = async () => {
    if (!editingEventId || !editingEventDealId) return;
    setSavingEventEdit(true);
    setEventActionError('');
    setEventActionSuccess('');
    try {
      const updated = await updateDealEvent(editingEventDealId, editingEventId, {
        eventDate: eventEditForm.eventDate || undefined,
        animalCount: eventEditForm.animalCount !== '' ? Number(eventEditForm.animalCount) : undefined,
        sourceEntityId: eventEditForm.sourceEntityId || undefined,
        destinationEntityId: eventEditForm.destinationEntityId || undefined,
        species: eventEditForm.species || undefined,
      });
      setEventHistoryRows((prev) => prev.map((row) => (String(row.id) === editingEventId ? { ...row, ...updated } : row)));
      delete trackingCacheRef.current[editingEventDealId];
      setEventActionSuccess('Event updated.');
      cancelEditEvent();
    } catch (error: any) {
      setEventActionError(parseApiError(error?.message) || 'Could not update that event.');
    } finally {
      setSavingEventEdit(false);
    }
  };

  const openAddEventForm = () => {
    cancelEditEvent();
    setEventActionError('');
    setEventActionSuccess('');
    setAddEventForm({
      dealId: '', eventTypeCode: 'ABAT_REC', eventDate: '', animalCount: '', species: '', sourceEntityId: '', destinationEntityId: '',
    });
    setAddEventSourceUnit(null);
    setAddEventDestUnit(null);
    setAddEventSourceSearch('');
    setAddEventDestSearch('');
    setShowAddEventForm(true);
  };

  const cancelAddEvent = () => {
    setShowAddEventForm(false);
    setAddEventSourceUnit(null);
    setAddEventDestUnit(null);
    setAddEventSourceSearch('');
    setAddEventDestSearch('');
  };

  const submitAddEvent = async () => {
    if (!addEventForm.dealId) { setEventActionError('Select a deal to add the event to.'); return; }
    if (!addEventForm.eventTypeCode) { setEventActionError('Select an event type.'); return; }
    if (!addEventForm.species) { setEventActionError('Select a species.'); return; }
    setSavingAddEvent(true);
    setEventActionError('');
    setEventActionSuccess('');
    try {
      const created = await createDealEvent(addEventForm.dealId, {
        eventTypeCode: addEventForm.eventTypeCode,
        species: addEventForm.species,
        eventDate: addEventForm.eventDate || undefined,
        animalCount: addEventForm.animalCount !== '' ? Number(addEventForm.animalCount) : undefined,
        sourceEntityId: addEventForm.sourceEntityId || undefined,
        destinationEntityId: addEventForm.destinationEntityId || undefined,
      });
      const deal = deals.find((d) => d.dealId === addEventForm.dealId);
      setEventHistoryRows((prev) => [{ ...created, deal }, ...prev]);
      delete trackingCacheRef.current[addEventForm.dealId];
      setEventActionSuccess(`${EVENT_TYPE_LABELS[addEventForm.eventTypeCode] || addEventForm.eventTypeCode} event added. You can now link a journey to it.`);
      cancelAddEvent();
    } catch (error: any) {
      setEventActionError(parseApiError(error?.message) || 'Could not add that event.');
    } finally {
      setSavingAddEvent(false);
    }
  };

  const editWoolFinanceRow = (row: WoolFinanceSummary) => {
    setEditingDealDocumentId('');
    setEditingTransportJourneyId('');
    setEditingWoolFinanceId(row.id);
    resetWeighbridgeForm();
    setDocumentForm((prev) => ({
      ...prev,
      category: 'Wool',
      systemCode: row.documentTypeId || '',
      saleValue: row.saleValue != null ? String(row.saleValue) : '',
      dateOfDocument: row.saleDate || '',
      notes: row.notes || '',
      visibility: row.visibility === 'ADMIN' ? 'ADMIN' : 'ALL',
      file: null,
    }));
  };

  const removeWoolFinanceRow = async (id: string) => {
    setDocumentUploadError('');
    setDocumentUploadSuccess('');
    try {
      await deleteWoolFinance(id);
      const targetDealId = documentForm.dealId || selectedDealId;
      if (targetDealId) {
        await loadExistingDocuments(targetDealId);
      }
      if (editingWoolFinanceId === id) {
        setEditingWoolFinanceId('');
      }
      setDocumentUploadSuccess('Wool finance record deleted.');
    } catch (error: any) {
      setDocumentUploadError(parseApiError(error?.message) || 'Could not delete that wool record.');
    }
  };

  const loadValueChainOptions = async () => {
    try {
      const options = await fetchValueChainOptions();
      if (options.length > 0) setValueChainOptions(options);
      hasLoadedValueChainOptionsRef.current = true;
    } catch {
      // fall back to whatever options were already derived from entities/deals
    }
  };

  const loadGs1Codes = async () => {
    setLoadingGs1Codes(true);
    setGs1CodesError('');
    try {
      const codes = await fetchGs1Codes();
      setGs1Codes(codes);
      hasLoadedGs1CodesRef.current = true;
    } catch (error: any) {
      setGs1CodesError(error?.message || 'Could not load GS1 codes.');
    } finally {
      setLoadingGs1Codes(false);
    }
  };

  const loadEntityDirectory = async () => {
    setLoadingEntityDirectory(true);
    try {
      const [rows, contacts] = await Promise.all([
        fetchEntities(),
        fetchEntityContacts().catch(() => []),
      ]);
      const contactsByEntity = new Map<string, Array<{ id: string; userId?: string; username?: string; name: string; email?: string; phoneNo?: string; isPrimary?: boolean }>>();
      contacts.forEach((contact) => {
        if (!contact.entityId) return;
        const existing = contactsByEntity.get(contact.entityId) || [];
        existing.push({
          id: contact.id,
          userId: contact.userId || '',
          username: contact.username || '',
          name: contact.name,
          email: contact.email || '',
          phoneNo: contact.phoneNo || '',
          isPrimary: contact.isPrimary,
        });
        contactsByEntity.set(contact.entityId, existing);
      });
      const rowsWithContacts = rows.map((entity) => ({
        ...entity,
        contacts: entity.contacts.length > 0 ? entity.contacts : (contactsByEntity.get(entity.id) || []),
      }));
      setEntityDirectory(rowsWithContacts);
      const profiles: Record<string, EntityProfile> = {};
      rowsWithContacts.forEach((entity) => {
        profiles[entity.id] = {
          id: entity.id,
          label: entity.entityName,
          farmerName: entity.entityName,
          addressLine1: entity.addressLine1 || '',
          addressLine2: entity.addressLine2 || '',
          latitude: entity.latitude || '',
          longitude: entity.longitude || '',
          contacts: entity.contacts || [],
        };
      });
      setEntityProfilesById(profiles);

      // Derive value chain options from entities (more complete than scraping deals)
      const vcById = new Map<string, string>();
      rows.forEach((entity) => {
        if (entity.valueChainId && entity.valueChainName) {
          vcById.set(entity.valueChainId, entity.valueChainName);
        }
      });
      if (vcById.size > 0) {
        setValueChainOptions(Array.from(vcById.entries()).map(([id, label]) => ({ id, label })));
      }

      hasLoadedEntityDirectoryRef.current = true;
    } catch {
      setEntityDirectory([]);
    } finally {
      setLoadingEntityDirectory(false);
    }
  };

  const updateGs1Code = async (id: string, form: GS1CodeUpsertInput) => {
    setGs1CrudError('');
    setGs1CrudSuccess('');
    try {
      await updateGs1CodeApi(id, form);
      setGs1CrudSuccess('GS1 code updated.');
      await loadGs1Codes();
      setEditingGs1Id('');
      setGs1Form({
        gs1Code: '',
        gs1Type: 'GLN',
        entityId: '',
        productTypeId: '',
        associatedGlnId: '',
      });
    } catch (error: any) {
      setGs1CrudError(parseApiError(error?.message) || 'Could not update GS1 code.');
    }
  };

  const deleteGs1Code = async (id: string) => {
    setGs1CrudError('');
    setGs1CrudSuccess('');
    try {
      await deleteGs1CodeApi(id);
      setGs1CrudSuccess('GS1 code deleted.');
      await loadGs1Codes();
    } catch (error: any) {
      setGs1CrudError(parseApiError(error?.message) || 'Could not delete GS1 code.');
    }
  };

  const resetEntityContactLinkState = () => {
    setEntityContactLinkQuery('');
    setEntityContactLinkUserId('');
    setEntityContactLinkPrimary(true);
    setEntityContactLinkMode('search');
    setEntityNewContactForm({ firstName: '', lastName: '', email: '', phoneNo: '' });
    setEntityNewContactCreateLogin(false);
    setEntityGlnMode('none');
    setEntityManualGlnCode('');
    setEntityGtinAllocationsToAdd([]);
  };

  const submitCreateEntity = async (event: React.FormEvent) => {
    event.preventDefault();
    const isCreatingNewContact = entityContactLinkMode === 'create' && (
      entityNewContactForm.firstName.trim() ||
      entityNewContactForm.lastName.trim() ||
      entityNewContactForm.email.trim() ||
      entityNewContactForm.phoneNo.trim()
    );
    if (isCreatingNewContact && !entityNewContactForm.email.trim()) {
      setEntityModalError('Email is required to create a new contact.');
      return;
    }
    if (entityGlnMode === 'manual' && !entityManualGlnCode.trim()) {
      setEntityModalError('Enter the customer-owned GLN code.');
      return;
    }
    if (entityGtinAllocationsToAdd.some((row) => row.productTypeId && row.mode === 'manual' && !row.gs1Code.trim())) {
      setEntityModalError('Enter the customer-owned GTIN code for each "Customer already has one" row.');
      return;
    }
    const gtinsRequested = entityGtinAllocationsToAdd.some((row) => row.productTypeId && (row.mode === 'allocate' || row.gs1Code.trim()));
    const entityHasOrWillHaveGln = Boolean(
      editingEntityId && gs1Codes.some((code) => code.gs1Type === 'GLN' && code.entityId === editingEntityId)
    ) || entityGlnMode !== 'none';
    if (gtinsRequested && !entityHasOrWillHaveGln) {
      setEntityModalError('Allocate or enter a GLN before adding GTINs.');
      return;
    }
    setEntityModalError('');
    setCreatingEntity(true);
    try {
      let entityId = editingEntityId;
      const wasEditingEntity = Boolean(editingEntityId);
      if (editingEntityId) {
        const updated = await updateEntity(editingEntityId, {
          entityName: newEntityForm.entityName.trim(),
          registeredBusinessName: newEntityForm.registeredBusinessName.trim(),
          vatNumber: newEntityForm.vatNumber.trim(),
          partyKind: newEntityForm.partyKind,
          identityNumber: newEntityForm.identityNumber.trim(),
          entityTypeOther: newEntityForm.entityTypeOther.trim(),
          farmName: newEntityForm.farmName.trim(),
          district: newEntityForm.district.trim(),
          province: newEntityForm.province.trim(),
          vatRegistered: Boolean(newEntityForm.vatRegistered),
          glnApplicable: Boolean(newEntityForm.glnApplicable),
          valueChainId: newEntityForm.valueChainId || undefined,
          entityType: newEntityForm.entityType || 'FARM',
          wooliesProducer: Boolean(newEntityForm.wooliesProducer),
          costPerDay: newEntityForm.costPerDay.trim() || null,
          addressLine1: newEntityForm.addressLine1.trim(),
          addressLine2: newEntityForm.addressLine2.trim(),
          city: newEntityForm.city.trim(),
          state: newEntityForm.state.trim(),
          postalCode: newEntityForm.postalCode.trim(),
          country: newEntityForm.country.trim(),
          latitude: newEntityForm.latitude.trim(),
          longitude: newEntityForm.longitude.trim(),
        });
        entityId = updated.id;
      } else {
        const created = await createEntity({
          entityName: newEntityForm.entityName.trim(),
          registeredBusinessName: newEntityForm.registeredBusinessName.trim(),
          vatNumber: newEntityForm.vatNumber.trim(),
          partyKind: newEntityForm.partyKind,
          identityNumber: newEntityForm.identityNumber.trim(),
          entityTypeOther: newEntityForm.entityTypeOther.trim(),
          farmName: newEntityForm.farmName.trim(),
          district: newEntityForm.district.trim(),
          province: newEntityForm.province.trim(),
          vatRegistered: Boolean(newEntityForm.vatRegistered),
          glnApplicable: Boolean(newEntityForm.glnApplicable),
          valueChainId: newEntityForm.valueChainId || undefined,
          entityType: newEntityForm.entityType || 'FARM',
          wooliesProducer: Boolean(newEntityForm.wooliesProducer),
          costPerDay: newEntityForm.costPerDay.trim() || null,
          addressLine1: newEntityForm.addressLine1.trim(),
          addressLine2: newEntityForm.addressLine2.trim(),
          city: newEntityForm.city.trim(),
          state: newEntityForm.state.trim(),
          postalCode: newEntityForm.postalCode.trim(),
          country: newEntityForm.country.trim(),
          latitude: newEntityForm.latitude.trim(),
          longitude: newEntityForm.longitude.trim(),
        });
        entityId = created.id;
      }

      let contactLinkFailed = false;
      let contactWasLinked = false;
      let rmisTokenSaved = false;
      // Only what was actually typed -- an empty string would clear a token on
      // an existing user, which is not what leaving a field blank means here.
      const rmisTokens = entityRmisEnabled && entityContactLinkPrimary
        ? {
            ...(entityRmisTestToken.trim() ? { rmis_test_token: entityRmisTestToken.trim() } : {}),
            ...(entityRmisProductionToken.trim() ? { rmis_production_token: entityRmisProductionToken.trim() } : {}),
          }
        : {};
      const hasRmisTokens = Object.keys(rmisTokens).length > 0;
      if (entityId) {
        try {
          if (isCreatingNewContact) {
            const createdUser = await createAdminUser({
              email: entityNewContactForm.email.trim(),
              first_name: entityNewContactForm.firstName.trim() || undefined,
              last_name: entityNewContactForm.lastName.trim() || undefined,
              is_staff: false,
              // RMIS participant tokens ride along on the primary contact user
              // -- the only place the movement code ever reads them from.
              ...rmisTokens,
            });
            if (hasRmisTokens) rmisTokenSaved = true;
            if (!entityNewContactCreateLogin) {
              await adminUpdateUser(createdUser.id, { is_active: false }).catch(() => null);
            }
            hasLoadedAdminUsersRef.current = false;
            await createEntityContact({
              entityId,
              userId: String(createdUser.id),
              phoneNo: entityNewContactForm.phoneNo.trim(),
              isPrimary: entityContactLinkPrimary,
            });
            contactWasLinked = true;
          } else if (entityContactLinkUserId) {
            await createEntityContact({
              entityId,
              userId: entityContactLinkUserId,
              isPrimary: entityContactLinkPrimary,
            });
            contactWasLinked = true;
            if (hasRmisTokens) {
              await adminUpdateUser(Number(entityContactLinkUserId), rmisTokens);
              hasLoadedAdminUsersRef.current = false;
              rmisTokenSaved = true;
            }
          }
        } catch (contactError: any) {
          contactLinkFailed = true;
          setEntityModalError(parseApiError(contactError?.message) || 'Entity saved, but the contact could not be linked.');
        }
      }

      let gs1AllocationFailed = false;
      const gs1AllocationNotes: string[] = [];
      if (entityId) {
        try {
          const existingGln = gs1Codes.find((code) => code.gs1Type === 'GLN' && code.entityId === entityId);
          let glnIdForGtins = existingGln?.id || '';
          if (!existingGln && entityGlnMode === 'allocate') {
            const allocatedGln = await allocateGln(entityId);
            glnIdForGtins = allocatedGln.id;
            gs1AllocationNotes.push(`GLN ${allocatedGln.gs1Code} allocated`);
          } else if (!existingGln && entityGlnMode === 'manual') {
            const savedGln = await createGs1Code({
              gs1Code: entityManualGlnCode.trim(),
              gs1Type: 'GLN',
              entityId,
            });
            glnIdForGtins = savedGln.id;
            gs1AllocationNotes.push(`GLN ${savedGln.gs1Code} saved`);
          }
          const validGtinRows = entityGtinAllocationsToAdd.filter(
            (row) => row.productTypeId && (row.mode === 'allocate' || row.gs1Code.trim())
          );
          for (const gtinRow of validGtinRows) {
            if (gtinRow.mode === 'manual') {
              const savedGtin = await createGs1Code({
                gs1Code: gtinRow.gs1Code.trim(),
                gs1Type: 'GTIN',
                entityId,
                productTypeId: gtinRow.productTypeId,
                associatedGlnId: glnIdForGtins || undefined,
              });
              gs1AllocationNotes.push(`GTIN ${savedGtin.gs1Code} saved`);
            } else {
              const allocatedGtin = await allocateGtin({
                entityId,
                productTypeId: gtinRow.productTypeId,
                associatedGlnId: glnIdForGtins || undefined,
              });
              gs1AllocationNotes.push(`GTIN ${allocatedGtin.gs1Code} allocated`);
            }
          }
          if (gs1AllocationNotes.length > 0) await loadGs1Codes();
        } catch (gs1Error: any) {
          gs1AllocationFailed = true;
          setEntityModalError(parseApiError(gs1Error?.message) || 'Entity saved, but a GS1 code could not be allocated.');
        }
      }

      // Virtual Routez onboarding: only ever queued from the create wizard, and
      // only meaningful once the entity row exists. A failure here must not
      // undo a successful create -- report it and leave the admin to retry
      // from the entity's Virtual Routez tab.
      let vrzRequestFailed = false;
      if (entityId && !wasEditingEntity && entityRequestVrzOnboarding) {
        try {
          const vrz = await requestVrzOnboarding(entityId);
          gs1AllocationNotes.push(
            vrz.emailSent
              ? `Virtual Routez onboarding requested (emailed ${vrz.recipientEmail})`
              : 'Virtual Routez onboarding link created, but the email could not be sent',
          );
        } catch (vrzError: any) {
          vrzRequestFailed = true;
          setEntityModalError(parseApiError(vrzError?.message) || 'Entity saved, but the Virtual Routez onboarding request failed.');
        }
      }

      await loadEntityDirectory();
      setGs1Form((prev) => ({ ...prev, entityId: entityId || '', associatedGlnId: '' }));
      setEditingEntityId('');
      setNewEntityForm(blankEntityForm());
      setEntityWizardStep(1);
      setEntityRequestVrzOnboarding(false);
      setEntityRmisEnabled(false);
      setEntityRmisTestToken('');
      setEntityRmisProductionToken('');
      setNextEntityNoPreview('');
      resetEntityContactLinkState();
      setCreatedEntityContactTargetId(wasEditingEntity || contactWasLinked ? '' : entityId || '');
      if (!contactLinkFailed && !gs1AllocationFailed && !vrzRequestFailed) {
        const notes = [
          contactWasLinked ? 'contact linked' : '',
          rmisTokenSaved ? 'RMIS token set on primary contact' : '',
          ...gs1AllocationNotes,
        ].filter(Boolean).join(', ');
        setGs1CrudSuccess(
          wasEditingEntity
            ? (notes ? `Entity updated (${notes}).` : 'Entity updated.')
            : (notes ? `Entity created (${notes}).` : 'Entity created. Link a contact when ready.')
        );
      }
      if (wasEditingEntity) setView('entityCrud');
    } catch (error: any) {
      setEntityModalError(parseApiError(error?.message) || 'Could not save entity.');
    } finally {
      setCreatingEntity(false);
    }
  };

  const openNewEntityForm = () => {
    setEditingEntityId('');
    setEntityTab('details');
    setEntityModalError('');
    setGs1CrudSuccess('');
    setCreatedEntityContactTargetId('');
    setNextEntityNoPreview('');
    setNewEntityForm(blankEntityForm());
    setEntityWizardStep(1);
    setEntityRequestVrzOnboarding(false);
    setEntityRmisEnabled(false);
    setEntityRmisTestToken('');
    setEntityRmisProductionToken('');
    resetEntityContactLinkState();
    setView('entityForm');
  };

  const openEditEntityForm = (entity: EntitySummary) => {
    setEditingEntityId(entity.id);
    setEntityTab('history');
    setEntityAnimalsSearch('');
    setEntityAnimalsPage(1);
    setOpenEntityDealIds(new Set());
    setEntityAnimalsMode('standard');
    setEntitySlaughterRows([]);
    setEntitySlaughterColumns([]);
    setEntitySlaughterError(null);
    setEntitySlaughterLoadedFor('');
    // The plan is entity-specific and fetched on demand, so it must not survive
    // a switch to another entity -- a stale plan would describe the wrong farm.
    setVrzPlan(null);
    setVrzPlanError('');
    setVrzResult(null);
    setVrzApiKey('');
    setVrzOverwriteKey(false);
    setVrzOnboardingProfile(null);
    setVrzOnboardingError('');
    setVrzOnboardingResult(null);
    setVrzRecipientEmail('');
    setVrzTestResult(null);
    resetEntityContactLinkState();
    setNewEntityForm({
      entityName: entity.entityName || '',
      registeredBusinessName: entity.registeredBusinessName || '',
      partyKind: (entity.partyKind as any) || '',
      identityNumber: entity.identityNumber || '',
      entityTypeOther: entity.entityTypeOther || '',
      farmName: entity.farmName || '',
      district: entity.district || '',
      province: entity.province || '',
      vatRegistered: Boolean(entity.vatRegistered),
      glnApplicable: Boolean(entity.glnApplicable),
      vatNumber: entity.vatNumber || '',
      entityNo: entity.entityNo || '',
      entityType: entity.entityType || 'FARM',
      valueChainId: entity.valueChainId || '',
      wooliesProducer: Boolean(entity.wooliesProducer),
      costPerDay: entity.costPerDay != null ? String(entity.costPerDay) : '',
      addressLine1: entity.addressLine1 || '',
      addressLine2: entity.addressLine2 || '',
      city: entity.city || '',
      state: entity.state || '',
      postalCode: entity.postalCode || '',
      country: entity.country || '',
      latitude: entity.latitude || '',
      longitude: entity.longitude || '',
    });
    setEntityModalError('');
    setGs1CrudSuccess('');
    setCreatedEntityContactTargetId('');
    setNextEntityNoPreview('');
    setView('entityForm');
  };

  const openEntityContactFormForEntity = (entityId: string, mode: 'existing' | 'newUser') => {
    if (!entityId) return;
    setGs1Form((prev: GS1CodeUpsertInput) => ({ ...prev, entityId }));
    setContactEditorEntityId(entityId);
    setContactEditorMode(mode);
    setEditingContactId('');
    setNewContactForm({ userId: '', phoneNo: '', isPrimary: true });
    setContactDetailsForm({ name: '', phoneNo: '', email: '', username: '' });
    setContactEntityLinks([{ entityId, isPrimary: true }]);
    setContactAddEntityId('');
    setContactAddEntityPrimary(false);
    setNewContactUserForm({ username: '', email: '', firstName: '', lastName: '', password: '', confirmPassword: '', isStaff: false });
    setContactModalError('');
    setShowCreateContactModal(true);
    setView('entityContactForm');
  };

  const resetContactEditor = () => {
    setContactEditorEntityId('');
    setContactEditorMode('existing');
    setEditingContactId('');
    setNewContactForm({ userId: '', phoneNo: '', isPrimary: true });
    setContactDetailsForm({ name: '', phoneNo: '', email: '', username: '' });
    setContactEntityLinks([]);
    setContactAddEntityId('');
    setContactAddEntityPrimary(false);
    setNewContactUserForm({ username: '', email: '', firstName: '', lastName: '', password: '', confirmPassword: '', isStaff: false });
  };

  const splitContactName = (value: string) => {
    const parts = value.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return { firstName: '', lastName: '' };
    return { firstName: parts[0], lastName: parts.slice(1).join(' ') };
  };

  const resolveContactUserId = async () => {
    if (contactEditorMode === 'existing') {
      // Linking a user is optional — a contact can be saved with just its
      // name/phone/email. Only validate when the admin actually picked one.
      const raw = newContactForm.userId.trim();
      if (!raw) return '';
      const contactUserPk = Number(raw);
      if (!Number.isInteger(contactUserPk) || contactUserPk <= 0) {
        throw new Error('Enter a valid numeric user ID (e.g. 5).');
      }
      return raw;
    }

    const usernameForNewUser = contactDetailsForm.username.trim() || newContactUserForm.username.trim();
    const { firstName, lastName } = splitContactName(contactDetailsForm.name || [newContactUserForm.firstName, newContactUserForm.lastName].filter(Boolean).join(' '));
    const emailForNewUser = contactDetailsForm.email.trim() || newContactUserForm.email.trim();
    if (!usernameForNewUser && !emailForNewUser) throw new Error('Email is required to invite a user.');
    const createdUser = await createAdminUser({
      username: usernameForNewUser || undefined,
      email: emailForNewUser || undefined,
      first_name: firstName || undefined,
      last_name: lastName || undefined,
      is_staff: newContactUserForm.isStaff,
      entity_contact: editingContactId || contactEntityLinks.find((link) => link.id)?.id,
    });
    hasLoadedAdminUsersRef.current = false;
    return String(createdUser.id);
  };

  const submitCreateContact = async (event: React.FormEvent) => {
    event.preventDefault();
    const targetEntityId = contactEditorEntityId || contactEntityLinks[0]?.entityId || contactAddEntityId || gs1Form.entityId;
    if (!targetEntityId) {
      setContactModalError('Select an entity before saving the contact.');
      return;
    }
    setContactModalError('');
    setCreatingContact(true);
    try {
      const userId = await resolveContactUserId();
      const numericUserId = Number(userId);
      const { firstName, lastName } = splitContactName(contactDetailsForm.name);
      if (Number.isInteger(numericUserId) && numericUserId > 0) {
        await adminUpdateUser(numericUserId, {
          email: contactDetailsForm.email.trim(),
          first_name: firstName,
          last_name: lastName,
        }).catch(() => null);
      }

      const linksToSave = contactEntityLinks.length > 0
        ? contactEntityLinks
        : [{ id: editingContactId || undefined, entityId: targetEntityId, isPrimary: newContactForm.isPrimary }];

      let savedContact: any = null;
      for (const link of linksToSave) {
        if (!link.entityId) continue;
        savedContact = link.id
          ? await updateEntityContact(link.id, {
              entityId: link.entityId,
              userId,
              firstName,
              lastName,
              email: contactDetailsForm.email.trim(),
              phoneNo: contactDetailsForm.phoneNo.trim(),
              isPrimary: link.isPrimary,
            })
          : await createEntityContact({
              entityId: link.entityId,
              userId,
              firstName,
              lastName,
              email: contactDetailsForm.email.trim(),
              phoneNo: contactDetailsForm.phoneNo.trim(),
              isPrimary: link.isPrimary,
            });
      }

      if (contactAddEntityId && !linksToSave.some((link) => link.entityId === contactAddEntityId)) {
        savedContact = await createEntityContact({
          entityId: contactAddEntityId,
          userId,
          firstName,
          lastName,
          email: contactDetailsForm.email.trim(),
          phoneNo: contactDetailsForm.phoneNo.trim(),
          isPrimary: contactAddEntityPrimary,
        });
      }

      await loadEntityDirectory();
      setSelectedEntityContactId(savedContact?.id || editingContactId || '');
      setShowCreateContactModal(false);
      setView('entityContacts');
      if (Number.isInteger(numericUserId) && numericUserId > 0) {
        hasLoadedAdminUsersRef.current = false;
        await loadAdminUsers();
      }
      resetContactEditor();
      setGs1CrudSuccess(editingContactId ? 'Contact updated.' : contactEditorMode === 'newUser' ? 'Contact converted into a user and linked to the entity.' : 'Contact person added to entity.');
    } catch (error: any) {
      setContactModalError(parseApiError(error?.message) || 'Could not save contact.');
    } finally {
      setCreatingContact(false);
    }
  };

  const editCurrentEntity = () => {
    if (!gs1Form.entityId) return;
    const row = entityDirectory.find((entity) => entity.id === gs1Form.entityId);
    if (!row) return;
    setEditingEntityId(row.id);
    setNewEntityForm({
      entityName: row.entityName || '',
      registeredBusinessName: row.registeredBusinessName || '',
      partyKind: (row.partyKind as any) || '',
      identityNumber: row.identityNumber || '',
      entityTypeOther: row.entityTypeOther || '',
      farmName: row.farmName || '',
      district: row.district || '',
      province: row.province || '',
      vatRegistered: Boolean(row.vatRegistered),
      glnApplicable: Boolean(row.glnApplicable),
      vatNumber: row.vatNumber || '',
      entityNo: row.entityNo || '',
      entityType: row.entityType || 'FARM',
      valueChainId: row.valueChainId || '',
      wooliesProducer: Boolean(row.wooliesProducer),
      costPerDay: row.costPerDay != null ? String(row.costPerDay) : '',
      addressLine1: row.addressLine1 || '',
      addressLine2: row.addressLine2 || '',
      city: row.city || '',
      state: row.state || '',
      postalCode: row.postalCode || '',
      country: row.country || '',
      latitude: row.latitude || '',
      longitude: row.longitude || '',
    });
    setEntityModalError('');
    setNextEntityNoPreview('');
    setView('entityForm');
  };

  const removeCurrentEntity = async () => {
    if (!gs1Form.entityId) return;
    try {
      await deleteEntity(gs1Form.entityId);
      await loadEntityDirectory();
      setGs1Form((prev) => ({ ...prev, entityId: '', associatedGlnId: '' }));
      setSelectedEntityContactId('');
      setGs1CrudSuccess('Entity deleted.');
    } catch (error: any) {
      setGs1CrudError(parseApiError(error?.message) || 'Could not delete entity.');
    }
  };

  const editCurrentContact = () => {
    if (!selectedEntityContactId || !gs1Form.entityId) return;
    const contacts = entityProfilesById[gs1Form.entityId]?.contacts || [];
    const contact = contacts.find((row) => row.id === selectedEntityContactId);
    if (!contact) return;
    const linkedRows = entityDirectory.flatMap((entity) => {
      const entityContacts = entityProfilesById[entity.id]?.contacts?.length
        ? entityProfilesById[entity.id].contacts
        : (entity.contacts || []);
      return entityContacts
        .filter((row) => contact.userId ? row.userId === contact.userId : row.id === contact.id)
        .map((row) => ({ id: row.id, entityId: entity.id, isPrimary: Boolean(row.isPrimary) }));
    });
    const selectedUser = contact.userId ? adminUsers.find((row) => String(row.id) === String(contact.userId)) : undefined;
    setContactEditorEntityId(gs1Form.entityId);
    setContactEditorMode('existing');
    setEditingContactId(contact.id);
    setNewContactForm({
      userId: contact.userId || '',
      phoneNo: contact.phoneNo || '',
      isPrimary: Boolean(contact.isPrimary),
    });
    setContactDetailsForm({
      name: selectedUser ? [selectedUser.first_name, selectedUser.last_name].filter(Boolean).join(' ') || contact.name : contact.name,
      phoneNo: contact.phoneNo || '',
      email: selectedUser?.email || contact.email || '',
      username: selectedUser?.username || contact.username || '',
    });
    setContactEntityLinks(linkedRows.length > 0 ? linkedRows : [{ id: contact.id, entityId: gs1Form.entityId, isPrimary: Boolean(contact.isPrimary) }]);
    setContactAddEntityId('');
    setContactAddEntityPrimary(false);
    setContactModalError('');
    setShowCreateContactModal(true);
  };

  const removeCurrentContact = async () => {
    if (!selectedEntityContactId) return;
    try {
      await deleteEntityContact(selectedEntityContactId);
      await loadEntityDirectory();
      setSelectedEntityContactId('');
      setGs1CrudSuccess('Contact deleted.');
    } catch (error: any) {
      setGs1CrudError(parseApiError(error?.message) || 'Could not delete contact.');
    }
  };

  // The Gendac ATP section only exists while the backend has the console
  // switched on (RMIS_ATP_ENABLED), so it disappears again after the workshop.
  const [rmisAtpEnabled, setRmisAtpEnabled] = useState(false);
  useEffect(() => {
    fetchRmisAtpConfig().then((c) => setRmisAtpEnabled(Boolean(c.enabled))).catch(() => setRmisAtpEnabled(false));
  }, []);

  // The UAT section only exists on servers that allow it (never production).
  const [uatEnabled, setUatEnabled] = useState(false);
  useEffect(() => {
    fetchUatStatus().then((c) => setUatEnabled(Boolean(c.enabled))).catch(() => setUatEnabled(false));
  }, []);

  const menuGroups = useMemo<Array<{
    heading: string;
    helpText?: string;
    items: Array<{ id: string; label: string; key: AdminView; helpText?: string; count?: number }>;
  }>>(() => [
    {
      heading: 'Overview',
      items: [
        { id: 'overview-dashboard', label: 'Dashboard', key: 'dashboard' },
      ],
    },
    {
      heading: 'Deals',
      items: [
        { id: 'deals-list', label: 'Deal list', key: 'dealList' },
        { id: 'deals-create', label: 'New deal', key: 'dealCreate' },
      ],
    },
    {
      heading: 'Documents',
      items: [
        { id: 'docs-list', label: 'Documents', key: 'documentsList' },
        { id: 'docs-upload', label: 'New Document', key: 'documentUpload' },
        { id: 'docs-search', label: 'Document Search', key: 'documentSearch' },
      ],
    },
    {
      heading: 'Event Management',
      items: [
        { id: 'data-session-upload', label: 'New Event', key: 'dataSessionUpload' },
        { id: 'event-history', label: 'Event history', key: 'eventHistory' },
        { id: 'abattoir-slaughter', label: 'Abattoir slaughter', key: 'abattoirSlaughter', helpText: 'Mark animals at an abattoir as slaughtered, grouped by the receive session they arrived in, when the EID wasn’t recorded at slaughter — enter a batch number and average CCM to estimate dressing %.' },
        { id: 'wool-bales', label: 'Wool baling', key: 'woolBales' },
        { id: 'add-feed', label: 'Add feed', key: 'addFeed', helpText: 'One feed bill for one or more deals: split by head across the deals now, and onto each deal’s animals by animal-days when the deal closes.' },
        { id: 'add-wool', label: 'Add wool', key: 'addWool', helpText: 'The clip’s kilograms, shearing bill, wool packs and account sale, divided by the sheep on the shearing sessions — each deal gets its share, and per-sheep figures follow.' },
      ],
    },
    {
      heading: 'Entities',
      helpText: ENTITY_HELP_TEXT,
      items: [
        { id: 'entity-list', label: 'Entity list', key: 'entityCrud' },
        { id: 'entity-new', label: 'New entity', key: 'entityForm' },
        { id: 'entity-contacts', label: 'Contact List', key: 'entityContacts' },
        { id: 'entity-contact-new', label: 'New contact', key: 'entityContactForm' },
      ],
    },
    {
      heading: 'Animals',
      items: [
        { id: 'animals-list', label: 'Animal list', key: 'animalList' },
        { id: 'animals-crud', label: 'Animal', key: 'animalCrud' },
        { id: 'unprocessed-records', label: 'Unprocessed records', key: 'unprocessedRecords' },
        { id: 'unlinked-animals', label: 'Unlinked animals', key: 'unlinkedAnimals' },
        { id: 'needs-review', label: 'Needs review', key: 'needsReview', count: pendingReviewClaims.length, helpText: 'Identifiers matched to existing animals, animals with no slaughter record, and unrecognised upload columns — across every deal.' },
      ],
    },
    {
      heading: 'Feed',
      items: [
        { id: 'feed-consumption', label: 'Feed consumption records', key: 'feedCrud' },
        { id: 'shared-costs', label: 'Shared feedlot costs', key: 'sharedCosts', helpText: 'Capture a feed, shearing or other bill the feedlot incurred for everyone on site once; it is split across deals by animal-days and lands on each deal’s ledger.' },
      ],
    },
    {
      heading: 'Transport',
      items: [
        { id: 'journey-history', label: 'Journey History', key: 'journeyHistory' },
        { id: 'transport-journeys', label: 'Add Journey', key: 'transportJourneys' },
        { id: 'weighbridge-history', label: 'Weighbridge History', key: 'weighbridgeHistory' },
        { id: 'weighbridge-new', label: 'New Weighbridge Record', key: 'weighbridgeNew' },
        { id: 'courier-management', label: 'Couriers', key: 'courierManagement' },
      ],
    },
    {
      heading: 'Reports',
      items: [
        { id: 'scp-analysis', label: 'Supply Chain Programme Analysis', key: 'scpAnalysis', helpText: 'Costs, income and margin pooled across the deals started in a period, for one programme or all.' },
        { id: 'cost-reports', label: 'Cost reports', key: 'costReports' },
        { id: 'performance-report', label: 'Performance report', key: 'performanceReport' },
        { id: 'availability-forecast', label: 'Availability forecast', key: 'availabilityForecast', helpText: 'Predict when animals’ meat will be available downstream (after the abattoir) for retailer/butcher supply planning.' },
        { id: 'woolies-stage-forecast', label: 'Woolies stage forecast', key: 'wooliesStageForecast', helpText: 'Month-by-month supply chain program stage projection (by species) for all Woolies producers.' },
      ],
    },
    {
      heading: 'Administration',
      items: [
        { id: 'user-management', label: 'User management', key: 'userManagement' },
        { id: 'production-schedules', label: 'Animal estimates', key: 'productionSchedules', helpText: 'Edit the per-species growth schedule (weaning / feedlot / buffer days) that drives the forecasts.' },
        { id: 'integrations', label: 'Integrations', key: 'integrations' },
        { id: 'field-mappings', label: 'Ingest field mappings', key: 'fieldMappings', helpText: 'Map column headings in uploaded files to database fields, and re-apply a correction to data already ingested.' },
      ],
    },
    ...(uatEnabled ? [{
      heading: 'UAT',
      helpText: 'Reload the user-acceptance-test data and find the UAT deals. Test servers only.',
      items: [
        { id: 'uat-console', label: 'UAT data & logins', key: 'uatConsole' as AdminView },
      ],
    }] : []),
    ...(rmisAtpEnabled ? [{
      heading: 'Gendac ATP',
      helpText: 'The RMIS Acceptance Test Procedure, run step by step with Gendac. Switched on only for the acceptance workshop.',
      items: [
        { id: 'rmis-atp-connect', label: 'Connection & evidence', key: 'rmisAtpConnect' as AdminView },
        ...ATP_SCREENS.map((screen) => ({ id: `rmis-atp-${screen.id}`, label: screen.menuLabel, key: screen.key as AdminView })),
      ],
    }] : []),
    {
      heading: 'Master Data',
      items: [
        { id: 'value-chain-crud', label: 'Supply Chain Programs', key: 'valueChainCrud' },
        { id: 'product-type-crud', label: 'Product types', key: 'productTypeCrud' },
        { id: 'breed-crud', label: 'Breeds', key: 'breedCrud' },
        { id: 'medicine-crud', label: 'Medicines', key: 'medicineCrud' },
        { id: 'equipment-allocation', label: 'Equipment', key: 'equipmentAllocation' },
        { id: 'wool-class-crud', label: 'Wool classes', key: 'woolClassCrud' },
        { id: 'document-type-crud', label: 'Document types', key: 'documentTypeCrud' },
        { id: 'master-gs1-codes', label: 'GS1 codes', key: 'gs1Gln' },
      ],
    },
  ], [rmisAtpEnabled, uatEnabled]);

  const flatMenuItems = useMemo(
    () => menuGroups.flatMap((group) => group.items),
    [menuGroups]
  );

  // One-way sync: when view changes (e.g. from an in-panel button), update the nav highlight.
  useEffect(() => {
    const activeItem = flatMenuItems.find((item) => item.id === activeMenuItemId);
    if (activeItem?.key === view) return;

    const fallbackItem = flatMenuItems.find((item) => item.key === view);
    if (fallbackItem) {
      setActiveMenuItemId(fallbackItem.id);
    }
  }, [view, flatMenuItems, activeMenuItemId]);

  const renderDashboard = () => {
    const speciesLabel = dashboardSpecies === 'ALL' ? 'All species' : DASHBOARD_SPECIES_LABEL[dashboardSpecies];
    // Register drill-downs carry a species filter only when one is selected.
    const speciesFilter = dashboardSpecies === 'ALL' ? undefined : dashboardSpecies;
    // System stats scoped by the filter bar (entered/alive/slaughtered/mortalities).
    const systemStats = dashboardStats;
    // Filter-scoped supply-chain-program stage figures + active-deal count.
    const valueChainStats = valueChainBySpecies[dashboardSpecies];
    const valueChainInTransitStats = valueChainBySpecies[dashboardSpecies];
    const speciesActiveDealsCount = activeDealsCountBySpecies[dashboardSpecies];
    // Lifetime + current counts under the current filters.
    const allTimeAnimalCount = dashboardSpecies === 'ALL'
      ? Object.values(allTimeSpeciesStats).reduce((sum, n) => sum + n, 0)
      : allTimeSpeciesStats[dashboardSpecies] || 0;
    const activeCount = valueChainStats.activeCount;
    const exitedAnimalCount = Math.max(allTimeAnimalCount - activeCount, 0);
    const selectedDashboardDeal = dashboardDealFilter
      ? deals.find((d) => d.dealId === dashboardDealFilter) || null
      : null;
    return (
    <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
      <div className="mb-4 flex items-start justify-between gap-3">
        <h2 className="text-2xl font-semibold text-avcs-text">Operations overview</h2>
        <div className="flex items-center gap-2">
        {wooliesNotifications && wooliesNotifications.count > 0 && (
          <div className="relative">
            <button
              type="button"
              className="rounded-lg border border-[#1e6bb833] px-3 py-1.5 text-sm font-medium text-avcs-text transition hover:bg-[#1e6bb80f] focus:outline-none focus-visible:ring-2 focus-visible:ring-avcs-blue"
              onClick={() => setShowNotifications((v) => !v)}
              aria-pressed={!showNotifications}
            >
              {showNotifications ? 'Hide notifications' : 'Show notifications'}
            </button>
            <span
              className="absolute -right-1.5 -top-1.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-600 px-1 text-xs font-bold leading-none text-white"
              aria-label={`${wooliesNotifications.count} notifications`}
            >
              {wooliesNotifications.count}
            </span>
          </div>
        )}
        <div className="group relative">
          <button
            type="button"
            className="flex items-center gap-1.5 rounded-lg border border-[#1e6bb833] px-3 py-1.5 text-sm font-medium text-avcs-text transition hover:bg-[#1e6bb80f] focus:outline-none focus-visible:ring-2 focus-visible:ring-avcs-blue"
            aria-haspopup="true"
          >
            Quick actions
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 8l4 4 4-4" /></svg>
          </button>
          <div className="pointer-events-none absolute right-0 top-full z-20 w-56 origin-top-right rounded-xl border border-[#1e6bb824] bg-white p-2 opacity-0 shadow-lg transition-opacity duration-150 group-hover:pointer-events-auto group-hover:opacity-100 group-focus-within:pointer-events-auto group-focus-within:opacity-100">
            <div className="mb-1 px-2 pt-1 text-xs font-semibold uppercase tracking-wide text-avcs-muted">Take action</div>
            <div className="flex flex-col gap-1">
              <button className="btn primary w-full justify-center whitespace-nowrap" onClick={() => { resetNewDealFlow(); setView('dealCreate'); }}>New deal</button>
              <button className="btn primary w-full justify-center whitespace-nowrap" onClick={() => setView('documentUpload')}>Upload document</button>
              <button className="btn primary w-full justify-center whitespace-nowrap" onClick={() => setView('dataSessionUpload')}>New event</button>
              <button className="btn primary w-full justify-center whitespace-nowrap" onClick={() => setView('feedCrud')}>Record feed</button>
              <button className="btn primary w-full justify-center whitespace-nowrap" onClick={() => setView('transportJourneys')}>New journey</button>
              <button className="btn primary w-full justify-center whitespace-nowrap" onClick={openNewEntityForm}>New entity</button>
            </div>
          </div>
        </div>
        </div>
      </div>

      {/* Filter bar: species → Supply Chain Program → deal. Everything below
          it is scoped to this selection. */}
      <div className="mb-5 flex flex-wrap items-end gap-4 rounded-xl border-2 border-[#1e6bb84d] bg-[#f2f7fc] p-4">
        <label className="grid gap-1.5">
          <span className="text-xs font-bold uppercase tracking-wide text-avcs-muted">Species</span>
          <select
            className="min-w-44 rounded-lg border-2 border-[#1e6bb84d] bg-white px-4 py-3 text-lg font-semibold text-avcs-text disabled:opacity-50"
            value={dashboardSpecies}
            disabled={Boolean(dashboardDealFilter)}
            title={dashboardDealFilter ? 'A single deal is selected — clear it to filter by species' : undefined}
            onChange={(event) => setDashboardSpecies(event.target.value as DashboardSpeciesFilter)}
          >
            <option value="ALL">All species</option>
            <option value="SHEEP">Sheep</option>
            <option value="CATTLE">Cattle</option>
          </select>
        </label>
        <label className="grid gap-1.5">
          <span className="text-xs font-bold uppercase tracking-wide text-avcs-muted">Supply Chain Program</span>
          <select
            className="min-w-64 rounded-lg border-2 border-[#1e6bb84d] bg-white px-4 py-3 text-lg font-semibold text-avcs-text disabled:opacity-50"
            value={dashboardScp}
            disabled={Boolean(dashboardDealFilter)}
            title={dashboardDealFilter ? 'A single deal is selected — clear it to filter by Supply Chain Program' : undefined}
            onChange={(event) => setDashboardScp(event.target.value)}
          >
            <option value={DASHBOARD_SCP_ALL}>All SCPs</option>
            <option value={DASHBOARD_SCP_MATRIX}>Deal Matrix</option>
            {valueChainOptions.map((chain) => (
              <option key={chain.id} value={chain.id}>{chain.label}</option>
            ))}
          </select>
        </label>
        <div className="relative grid min-w-[30rem] max-w-2xl flex-1 gap-1.5">
          <span className="text-xs font-bold uppercase tracking-wide text-avcs-muted">Deal</span>
          <input
            className="w-full rounded-lg border-2 border-[#1e6bb84d] bg-white px-4 py-3 text-lg text-avcs-text"
            placeholder="All deals — type to search…"
            value={dashboardDealSearch}
            onChange={(event) => {
              setDashboardDealSearch(event.target.value);
              setDashboardDealListOpen(true);
              if (dashboardDealFilter) setDashboardDealFilter('');
            }}
            onFocus={() => setDashboardDealListOpen(true)}
            onBlur={() => window.setTimeout(() => setDashboardDealListOpen(false), 150)}
          />
          {dashboardDealListOpen && !dashboardDealFilter && dashboardDealSuggestions.length > 0 && (
            <div className="absolute left-0 top-full z-30 mt-1 max-h-72 w-full overflow-y-auto rounded-lg border border-[#1e6bb833] bg-white shadow-lg">
              {dashboardDealSuggestions.map((deal) => (
                <button
                  key={deal.dealId}
                  type="button"
                  className="block w-full px-4 py-2.5 text-left text-sm hover:bg-[#1e6bb80f]"
                  onMouseDown={(event) => event.preventDefault()}
                  onClick={() => {
                    setDashboardDealFilter(deal.dealId);
                    setDashboardDealSearch(`${deal.title} · ${deal.counterpart}`);
                    setDashboardDealListOpen(false);
                    // A single deal overrides the other filters — widen them so
                    // the selected deal can never be filtered out of its own view.
                    setDashboardSpecies('ALL');
                    setDashboardScp(DASHBOARD_SCP_ALL);
                  }}
                >
                  <span className="font-semibold">{deal.title}</span>
                  <span className="text-avcs-muted">
                    {' · '}{deal.counterpart}
                    {deal.species ? ` · ${deal.species}` : ''}
                    {deal.scpName ? ` · ${deal.scpName}` : ' · Deal Matrix'}
                  </span>
                </button>
              ))}
            </div>
          )}
        </div>
        {(dashboardDealFilter || dashboardScp !== DASHBOARD_SCP_ALL || dashboardSpecies !== 'ALL') && (
          <button
            type="button"
            className="mb-1.5 inline-flex items-center gap-2 rounded-full border border-[#1e6bb84d] bg-white px-4 py-2 text-sm font-medium text-avcs-text hover:bg-[#1e6bb80f]"
            onClick={() => {
              setDashboardSpecies('ALL');
              setDashboardScp(DASHBOARD_SCP_ALL);
              setDashboardDealFilter('');
              setDashboardDealSearch('');
            }}
          >
            Reset filters ✕
          </button>
        )}
        {selectedDashboardDeal && (
          <div className="mb-1.5 text-sm font-medium text-avcs-muted">
            Showing only <span className="font-semibold text-avcs-text">{selectedDashboardDeal.title}</span>
          </div>
        )}
      </div>

      {showNotifications && wooliesNotifications && wooliesNotifications.count > 0 && (
        <div className="mb-4 rounded-xl border border-amber-300 bg-amber-50 p-4">
          <div className="flex items-center justify-between gap-3">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-amber-800">
              Woolies producers — {wooliesNotifications.count} recent registration{wooliesNotifications.count === 1 ? '' : 's'}
            </h3>
            <button type="button" className="text-xs font-medium text-amber-800 underline" onClick={() => setView('wooliesStageForecast')}>
              View stage forecast →
            </button>
          </div>
          <div className="mt-3 flex flex-col divide-y divide-amber-200">
            {wooliesNotifications.notifications.slice(0, 6).map((n) => {
              const species = Object.entries(n.by_species).map(([s, c]) => `${c} ${s.toLowerCase()}`).join(', ');
              return (
                <div key={n.event_id} className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 py-2 first:pt-0 last:pb-0">
                  <div className="text-sm text-avcs-text">
                    <span className="font-semibold">{n.producer_name || 'Unknown producer'}</span>
                    {' · '}{n.deal_no || '—'}{' · '}
                    <span className="text-avcs-muted">{n.animal_count} animals ({species}) registered {n.registered_on || ''}</span>
                  </div>
                  <div className="text-sm">
                    {n.earliest_available ? (
                      <span className="text-amber-900">
                        Est. available{' '}
                        <span className="font-semibold">
                          {n.earliest_available === n.latest_available
                            ? n.earliest_available
                            : `${n.earliest_available} – ${n.latest_available}`}
                        </span>
                        {n.estimated_carcass_weight_kg != null ? ` · ~${fmtNum(Math.round(n.estimated_carcass_weight_kg))} kg carcass` : ''}
                      </span>
                    ) : (
                      <span className="text-avcs-muted">No availability estimate (missing schedule / birth date)</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className="flex flex-col gap-4">

      <div className="grid gap-4 md:grid-cols-4 md:items-start">
        <div
          className="flex min-h-48 flex-col justify-center border border-[#1e6bb824] bg-white p-6"
          title="All-time, system-wide totals across every deal"
        >
          <div className="mb-3 text-sm font-semibold uppercase tracking-wide text-avcs-muted">System totals</div>
          <div className="flex flex-col divide-y divide-[#1e6bb81a]">
            {[
              { label: 'Animals entered', value: systemStats ? fmtNum(systemStats.animals.entered) : '—' },
              { label: 'Alive', value: systemStats ? fmtNum(systemStats.animals.alive) : '—' },
              { label: 'Slaughtered', value: systemStats ? fmtNum(systemStats.animals.slaughtered) : '—' },
              {
                label: 'Mortalities',
                value: systemStats
                  ? `${fmtNum(systemStats.animals.mortalities)}${
                      systemStats.animals.entered > 0
                        ? ` (${((systemStats.animals.mortalities / systemStats.animals.entered) * 100).toFixed(1)}%)`
                        : ''
                    }`
                  : '—',
              },
            ].map((row) => (
              <div
                key={row.label}
                className="flex items-baseline justify-between gap-3 py-1.5 first:pt-0 last:pb-0"
              >
                <span className="text-sm font-medium text-avcs-muted">{row.label}</span>
                <span className="text-xl font-bold leading-none tracking-tight text-avcs-text">{row.value}</span>
              </div>
            ))}
          </div>
        </div>

        <div
          className="flex min-h-48 flex-col justify-center gap-3 border border-[#1e6bb824] bg-white p-6"
          title={`${speciesLabel} currently alive, with the number of active deals carrying ${speciesLabel.toLowerCase()}`}
        >
          <div>
            <div className="text-4xl font-bold leading-none tracking-tight text-avcs-text">
              {systemStats ? fmtNum(systemStats.animals.alive) : '—'}
            </div>
            <div className="mt-3 text-sm font-semibold uppercase tracking-wide text-avcs-muted">Alive</div>
          </div>

          <div className="border-t border-[#1e6bb81a] pt-3">
            <div className="text-xl font-semibold leading-none text-avcs-text">{fmtNum(speciesActiveDealsCount)}</div>
            <div className="mt-1 text-xs font-medium uppercase tracking-wide text-avcs-muted">Active deals</div>
          </div>
        </div>

        <div
          className="flex min-h-48 flex-col justify-center gap-3 border border-[#1e6bb824] bg-white p-6"
          title="Every animal that has passed through the supply chain program (active deals), including those already slaughtered or lost"
        >
          {animalSummaryLoadError ? (
            <div>
              <div className="text-lg font-semibold leading-none text-red-600">Failed to load</div>
              <div className="mt-3 text-sm font-semibold uppercase tracking-wide text-avcs-muted">Supply Chain Program total</div>
              <button type="button" className="btn mt-2" onClick={() => loadDeals()}>Retry</button>
            </div>
          ) : (
            <div>
              <div className="text-4xl font-bold leading-none tracking-tight text-avcs-text">{fmtNum(allTimeAnimalCount)}</div>
              <div className="mt-3 text-sm font-semibold uppercase tracking-wide text-avcs-muted">Supply Chain Program total</div>
            </div>
          )}

          <div className="flex gap-6 border-t border-[#1e6bb81a] pt-3">
            <div>
              <div className="text-xl font-semibold leading-none text-avcs-text">{fmtNum(activeCount)}</div>
              <div className="mt-1 text-xs font-medium uppercase tracking-wide text-avcs-muted">Active</div>
            </div>
            <div>
              <div className="text-xl font-semibold leading-none text-avcs-text">{animalSummaryLoadError ? '—' : fmtNum(exitedAnimalCount)}</div>
              <div className="mt-1 text-xs font-medium uppercase tracking-wide text-avcs-muted">Exited</div>
            </div>
          </div>
        </div>

        <div
          className="flex min-h-48 flex-col justify-center gap-3 border border-[#1e6bb824] bg-white p-6"
          title="Average data quality score across every uploaded file that has been assessed"
        >
          <div>
            <div className="text-4xl font-bold leading-none tracking-tight text-avcs-text">
              {dashboardDataQuality?.average_score != null ? dashboardDataQuality.average_score.toFixed(0) : '—'}
            </div>
            <div className="mt-3 text-sm font-semibold uppercase tracking-wide text-avcs-muted">Data quality score</div>
          </div>
          {dashboardDataQuality?.average_score != null && (() => {
            const grade = dashboardDataQuality.average_score >= 90 ? 'EXCELLENT'
              : dashboardDataQuality.average_score >= 75 ? 'GOOD'
              : dashboardDataQuality.average_score >= 50 ? 'FAIR'
              : 'POOR';
            return (
              <div className="flex items-center gap-2 border-t border-[#1e6bb81a] pt-3">
                <span className={`inline-flex rounded-full border px-2 py-0.5 text-xs font-semibold ${DATA_QUALITY_BADGE[grade]?.cls || ''}`}>
                  {DATA_QUALITY_BADGE[grade]?.label || grade}
                </span>
                <span className="text-xs text-avcs-muted">
                  from {fmtNum(dashboardDataQuality.sessions_scored)} file{dashboardDataQuality.sessions_scored === 1 ? '' : 's'}
                </span>
              </div>
            );
          })()}
          {dashboardDataQuality && dashboardDataQuality.sessions_scored === 0 && (
            <div className="border-t border-[#1e6bb81a] pt-3 text-xs text-avcs-muted">No files assessed yet</div>
          )}
        </div>
      </div>

      <div className="border border-[#1e6bb824] bg-white p-8">
        <div className="mb-6 text-sm font-semibold uppercase tracking-wide text-avcs-muted">Supply Chain Program</div>
        <div className="relative">
          <div className="pointer-events-none absolute left-0 right-[12%] top-10 hidden border-t border-dashed border-[#1e6bb84d] md:block" aria-hidden="true" />
          <div className="relative z-10 grid gap-4 md:grid-cols-5">
          <button
            type="button"
            onClick={() => openAnimalRegister({ entityType: 'FARM', label: `${speciesLabel} · Farm`, species: speciesFilter })}
            className="relative border-0 bg-transparent p-0 text-left transition hover:-translate-y-0.5"
            title="View animals at farm"
          >
            <div className="inline-block bg-white pr-5 text-7xl font-bold leading-none tracking-tight text-avcs-text">{fmtNum(valueChainStats.farm)}</div>
            <div className="mt-4 text-sm font-semibold uppercase tracking-wide text-avcs-muted">Animals at farm</div>
          </button>
          <button
            type="button"
            onClick={() => openAnimalRegister({ entityType: 'IN_TRANSIT', label: `${speciesLabel} · In Transit → Feedlot`, inTransitLeg: 'TO_FEEDLOT', species: speciesFilter })}
            className="relative flex justify-center border-0 bg-transparent p-0 transition hover:-translate-y-0.5"
            title="View animals in transit to a feedlot"
          >
            <div className="inline-flex min-w-24 flex-col items-center gap-0.5 bg-white px-5">
              <div className="text-4xl font-semibold leading-none tracking-tight text-avcs-muted">
                {fmtNum(valueChainInTransitStats.farmToFeedlot)}
              </div>
              <div className="text-avcs-muted/80" aria-label="In transit to feedlot" title="In transit to feedlot">
                <svg className="h-8 w-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M3 7h11v10H3z" />
                  <path d="M14 10h3.4L21 13.8V17h-7z" />
                  <path d="M5.5 17a2 2 0 1 0 4 0" />
                  <path d="M16.5 17a2 2 0 1 0 4 0" />
                  <path d="M3 17h2.5" />
                  <path d="M9.5 17h7" />
                </svg>
              </div>
            </div>
          </button>
          <button
            type="button"
            onClick={() => openAnimalRegister({ entityType: 'FEEDLOT', label: `${speciesLabel} · Feedlot`, species: speciesFilter })}
            className="relative border-0 bg-transparent p-0 text-center transition hover:-translate-y-0.5"
            title="View animals at feedlot"
          >
            <div className="inline-block bg-white px-5 text-7xl font-bold leading-none tracking-tight text-avcs-text">{fmtNum(valueChainStats.feedlot)}</div>
            <div className="mt-4 text-sm font-semibold uppercase tracking-wide text-avcs-muted">Animals at feedlot</div>
          </button>
          <button
            type="button"
            onClick={() => openAnimalRegister({ entityType: 'IN_TRANSIT', label: `${speciesLabel} · In Transit → Abattoir`, inTransitLeg: 'TO_ABATTOIR', species: speciesFilter })}
            className="relative flex justify-center border-0 bg-transparent p-0 transition hover:-translate-y-0.5"
            title="View animals in transit to an abattoir"
          >
            <div className="inline-flex min-w-24 flex-col items-center gap-0.5 bg-white px-5">
              <div className="text-4xl font-semibold leading-none tracking-tight text-avcs-muted">
                {fmtNum(valueChainInTransitStats.feedlotToAbattoir)}
              </div>
              <div className="text-avcs-muted/80" aria-label="In transit to abattoir" title="In transit to abattoir">
                <svg className="h-8 w-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M3 7h11v10H3z" />
                  <path d="M14 10h3.4L21 13.8V17h-7z" />
                  <path d="M5.5 17a2 2 0 1 0 4 0" />
                  <path d="M16.5 17a2 2 0 1 0 4 0" />
                  <path d="M3 17h2.5" />
                  <path d="M9.5 17h7" />
                </svg>
              </div>
            </div>
          </button>
          <button
            type="button"
            onClick={() => openAnimalRegister({ entityType: 'ABATTOIR', label: `${speciesLabel} · Abattoir`, species: speciesFilter })}
            className="relative border-0 bg-transparent p-0 text-right transition hover:-translate-y-0.5"
            title="View animals at abattoir"
          >
            <div className="inline-block bg-white pl-5 text-7xl font-bold leading-none tracking-tight text-avcs-text">{fmtNum(valueChainStats.abattoir)}</div>
            <div className="mt-4 text-sm font-semibold uppercase tracking-wide text-avcs-muted">Animals at abattoir</div>
          </button>
          </div>
        </div>
      </div>

      <div>
        <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
          <h2 className="text-2xl font-semibold text-avcs-text">Performance Metrics</h2>
          <div className="flex flex-wrap items-center gap-3">
            <label className="flex items-center gap-2 text-sm font-medium text-avcs-text">
              <span className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Feedlot</span>
              <select
                className="min-w-56 rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm text-avcs-text"
                value={dashboardFeedlotId}
                onChange={(event) => setDashboardFeedlotId(event.target.value)}
              >
                <option value="">All feedlots</option>
                {dashboardFeedlotOptions.map((feedlot) => (
                  <option key={feedlot.id} value={feedlot.id}>{feedlot.label}</option>
                ))}
              </select>
            </label>
          </div>
        </div>
        <div className="grid gap-4 md:grid-cols-4">
          <div className="flex min-h-40 flex-col justify-center border border-[#1e6bb824] bg-white p-6">
            <div className="text-4xl font-bold leading-none tracking-tight text-avcs-text">
              {dashboardPerformanceStats.adg != null ? dashboardPerformanceStats.adg.toFixed(3) : '—'}
            </div>
            <div className="mt-3 text-sm font-semibold uppercase tracking-wide text-avcs-muted">ADG</div>
          </div>
          <div className="flex min-h-40 flex-col justify-center border border-[#1e6bb824] bg-white p-6">
            <div className="text-4xl font-bold leading-none tracking-tight text-avcs-text">
              {dashboardPerformanceStats.fcr != null
                ? dashboardPerformanceStats.fcr.toFixed(2)
                : dashboardPerformanceStats.fcrEstimated != null
                  ? dashboardPerformanceStats.fcrEstimated.toFixed(2)
                  : '—'}
            </div>
            <div className="mt-3 text-sm font-semibold uppercase tracking-wide text-avcs-muted">
              FCR{dashboardPerformanceStats.fcr == null && dashboardPerformanceStats.fcrEstimated != null && (
                <span className="text-amber-500"> (est.)</span>
              )}
            </div>
          </div>
          <div className="flex min-h-40 flex-col justify-center border border-[#1e6bb824] bg-white p-6">
            <div className="text-4xl font-bold leading-none tracking-tight text-avcs-text">
              {dashboardPerformanceStats.avgFeedlotDays != null ? Math.round(dashboardPerformanceStats.avgFeedlotDays) : '—'}
            </div>
            <div className="mt-3 text-sm font-semibold uppercase tracking-wide text-avcs-muted">Avg feedlot days</div>
            {dashboardPerformanceStats.feedlotDaysCount != null && (
              <div className="mt-1 text-xs text-avcs-muted">n={fmtNum(dashboardPerformanceStats.feedlotDaysCount)}</div>
            )}
          </div>
          <div className="flex min-h-40 flex-col justify-center border border-[#1e6bb824] bg-white p-6">
            <div className="text-4xl font-bold leading-none tracking-tight text-avcs-text">
              {dashboardPerformanceStats.slaughterPercentage != null ? `${dashboardPerformanceStats.slaughterPercentage.toFixed(1)}%` : '—'}
            </div>
            <div className="mt-3 text-sm font-semibold uppercase tracking-wide text-avcs-muted">Dressing percentage</div>
            <div className="mt-1 text-xs text-avcs-muted">
              {dashboardPerformanceStats.slaughterCount != null && dashboardPerformanceStats.slaughterCount > 0
                ? `${fmtNum(dashboardPerformanceStats.slaughterCount)} slaughtered animal${dashboardPerformanceStats.slaughterCount === 1 ? '' : 's'}`
                : 'No slaughtered animals in scope'}
            </div>
          </div>
        </div>
      </div>

      </div>
    </section>
    );
  };

  const renderAnimalRegister = () => (
    <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <button className="btn" onClick={() => setView('dashboard')}>← Back to dashboard</button>
          <h2 className="text-2xl font-semibold text-avcs-text">Animal Register</h2>
        </div>
        <span className="text-sm text-avcs-muted">{fmtNum(animalRegisterRows.length)} of {fmtNum(animalRegister.length)} animals</span>
      </div>

      {animalRegisterStageFilter && (
        <div className="mb-3 flex items-center justify-between gap-3 rounded-lg border border-[#1e6bb833] bg-[#e7f1fb] px-4 py-2.5">
          <span className="text-sm font-semibold text-[#184b87]">
            Showing animals at {animalRegisterStageFilter.label} ({fmtNum(animalRegisterRows.length)})
          </span>
          <button
            onClick={() => setAnimalRegisterStageFilter(null)}
            className="text-sm font-semibold text-[#184b87] underline-offset-2 hover:underline"
          >Clear filter</button>
        </div>
      )}

      <input
        type="text"
        placeholder="Search by EID, VID, species, deal, producer, location, GLN…"
        value={animalRegisterSearch}
        onChange={(event) => setAnimalRegisterSearch(event.target.value)}
        className="mb-3 w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm sm:w-96"
      />
      {animalRegister.length === 0 ? (
        <p className="text-sm text-avcs-muted">No animal location data available.</p>
      ) : animalRegisterRows.length === 0 ? (
        <p className="text-sm text-avcs-muted">No animals match this filter.</p>
      ) : (
        <div className="animal-register-shell max-h-[600px] overflow-auto rounded-xl border border-[#1e6bb824]">
          <table className="w-full text-sm">
            <thead className="sticky top-0 z-10">
              <tr className="border-b border-[#1e6bb824] bg-[#f1f7ff] text-left">
                <th className="px-4 py-3 font-semibold text-avcs-text">EID</th>
                <th className="px-4 py-3 font-semibold text-avcs-text">VID</th>
                <th className="px-4 py-3 font-semibold text-avcs-text">Species</th>
                <th className="px-4 py-3 font-semibold text-avcs-text">Breed</th>
                <th className="px-4 py-3 font-semibold text-avcs-text">Status</th>
                <th className="px-4 py-3 font-semibold text-avcs-text">Deal</th>
                <th className="px-4 py-3 font-semibold text-avcs-text">Primary Producer</th>
                <th className="px-4 py-3 font-semibold text-avcs-text">Stage</th>
                <th className="px-4 py-3 font-semibold text-avcs-text">Current Location</th>
                <th className="px-4 py-3 font-semibold text-avcs-text">GLN</th>
                <th className="px-4 py-3 font-semibold text-avcs-text">Supply Chain Program</th>
                <th className="px-4 py-3 font-semibold text-avcs-text">Last Weight</th>
                <th className="px-4 py-3 font-semibold text-avcs-text">Last Event</th>
              </tr>
            </thead>
            <tbody>
              {animalRegisterRows.map((a) => (
                <tr key={a.animal_id} className="border-b border-[#1e6bb81a] bg-white even:bg-[#fbfeff] hover:bg-[#f1f7ff]">
                  <td className="px-4 py-2.5 font-medium text-avcs-text">
                    {a.eid_tag
                      ? (a.animal_id
                          ? (
                            <button
                              type="button"
                              onClick={() => openAnimalDetail(a.animal_id)}
                              className="text-avcs-primary underline decoration-dotted underline-offset-2 hover:decoration-solid"
                              title="View animal detail"
                            >{a.eid_tag}</button>
                          )
                          : a.eid_tag)
                      : '—'}
                  </td>
                  <td className="px-4 py-2.5 text-avcs-muted">{a.vid || '—'}</td>
                  <td className="px-4 py-2.5 text-avcs-muted capitalize">{a.species ? a.species.toLowerCase() : '—'}</td>
                  <td className="px-4 py-2.5 text-avcs-muted">{a.breed_name || '—'}</td>
                  <td className="px-4 py-2.5">
                    <span className={`inline-flex px-2 py-0.5 text-xs font-semibold ${
                      a.status === 'ACTIVE' ? 'bg-green-50 text-green-700' :
                      a.status === 'DECEASED' ? 'bg-red-50 text-red-700' :
                      a.status === 'SOLD' ? 'bg-blue-50 text-blue-700' :
                      'bg-gray-100 text-gray-600'
                    }`}>{a.status || '—'}</span>
                  </td>
                  <td className="px-4 py-2.5 text-avcs-muted">{a.deal_no || '—'}</td>
                  <td className="px-4 py-2.5 text-avcs-muted">{a.primaryProducerName || '—'}</td>
                  <td className="px-4 py-2.5 text-avcs-muted">
                    {a.current_location?.entity_type === 'IN_TRANSIT'
                      ? 'In Transit'
                      : a.current_location?.entity_type
                        ? a.current_location.entity_type.charAt(0) + a.current_location.entity_type.slice(1).toLowerCase()
                        : '—'}
                  </td>
                  <td className="px-4 py-2.5 text-avcs-muted">
                    {a.current_location?.entity_type === 'IN_TRANSIT'
                      ? `${a.current_location?.source_entity_name || '—'} → ${a.current_location?.destination_entity_name || '—'}`
                      : a.current_location?.entity_name || '—'}
                  </td>
                  <td className="px-4 py-2.5 text-avcs-muted">{a.current_location?.gln || a.current_location?.destination_gln || '—'}</td>
                  <td className="px-4 py-2.5 text-avcs-muted">{a.current_location?.value_chain_name || '—'}</td>
                  <td className="px-4 py-2.5 text-avcs-muted">{a.last_weight?.weight_kg != null ? `${a.last_weight.weight_kg} kg` : '—'}</td>
                  <td className="px-4 py-2.5 text-avcs-muted">
                    {a.current_location?.latest_event_type || '—'}
                    {a.current_location?.latest_event_date ? ` • ${new Date(a.current_location.latest_event_date).toLocaleDateString('en-ZA', { day: '2-digit', month: 'short', year: 'numeric' })}` : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );

  const submitTransportJourneyOnly = async (event: React.FormEvent) => {
    event.preventDefault();
    const missing = [];
    if (!documentForm.dealEventId || !documentForm.dealId) missing.push('receipt event');
    if (!documentForm.courierId) missing.push('courier');
    if (!documentForm.vehicleRegistration) missing.push('vehicle registration');
    if (documentForm.startKm === '' || documentForm.endKm === '') missing.push('KM readings');
    if (missing.length > 0) {
      setDocumentUploadError(`Please fill in: ${missing.join(', ')}.`);
      return;
    }
    if (Number(documentForm.endKm) <= Number(documentForm.startKm)) {
      setDocumentUploadError('End KM must be greater than start KM.');
      return;
    }
    if (weighbridgeForm.grossWeightKg.trim() && !weighbridgeForm.recordedAt) {
      setDocumentUploadError('Enter a weighbridge recorded date/time along with the weight.');
      return;
    }
    const extraEvents = editingTransportJourneyId ? [] : journeyExtraEvents.filter((ev) => ev.id !== documentForm.dealEventId);
    // The legs saved below, so the weighbridge rows can point at their journeys.
    const savedLegs: { event: ReceiveEventOption; journeyId?: string }[] = [];
    setUploadingDocument(true);
    setDocumentUploadError('');
    setDocumentUploadSuccess('');
    try {
      let successMessage = '';
      if (editingTransportJourneyId) {
        await updateTransportJourney(editingTransportJourneyId, {
          dealEventId: documentForm.dealEventId,
          dispatchEventId: documentForm.dispatchEventId || null,
          courierId: documentForm.courierId,
          loadingDate: documentForm.dateOfDocument,
          offloadingDate: documentForm.offloadingDate,
          vehicleRegistration: documentForm.vehicleRegistration,
          startKm: Number(documentForm.startKm),
          endKm: Number(documentForm.endKm),
          waybillNumber: documentForm.referenceNumber,
          totalCost: documentForm.totalCost ? Number(documentForm.totalCost) : undefined,
          loadingTime: documentForm.loadingTime,
          loadingPoint: documentForm.loadingPoint,
          offloadingPoint: documentForm.offloadingPoint,
          driverName: documentForm.driverName,
          driverContact: documentForm.driverContact,
          removalCertFile: journeyRemovalCertFile,
          animalsDown: documentForm.animalsDown === '' ? undefined : Number(documentForm.animalsDown),
          animalsDownReason: documentForm.animalsDownReason,
        });
        setJourneyRemovalCertFile(null);
        successMessage = 'Journey updated successfully.';
        setEditingTransportJourneyId('');
      } else {
        // One truck, N deals: one Journey per receive event, identical trip
        // details, the invoice total split equally per animal across them
        // (rounded to the cent, remainder on the largest load). Animals down
        // are recorded on the first leg only -- the truck lost them once.
        const primary = allReceiveEvents.find((ev) => ev.id === documentForm.dealEventId && ev.dealId === documentForm.dealId)
          || { id: documentForm.dealEventId, dealId: documentForm.dealId, label: selectedReceiveEventLabelRef.current, animalCount: 0 };
        const legs = [primary, ...extraEvents];
        const total = documentForm.totalCost ? Number(documentForm.totalCost) : undefined;
        const counts = legs.map((ev) => Number(ev.animalCount || 0));
        const headTotal = counts.reduce((sum, n) => sum + n, 0);
        const weights = headTotal > 0 && counts.every((n) => n > 0) ? counts.map((n) => n / headTotal) : legs.map(() => 1 / legs.length);
        let shares: (number | undefined)[] = legs.map(() => total);
        if (total !== undefined && legs.length > 1) {
          shares = weights.map((w) => Math.round(total * w * 100) / 100);
          const remainder = Math.round((total - shares.reduce<number>((sum, v) => sum + (v || 0), 0)) * 100) / 100;
          const largest = weights.indexOf(Math.max(...weights));
          shares[largest] = Math.round(((shares[largest] || 0) + remainder) * 100) / 100;
        }
        for (const [index, leg] of legs.entries()) {
          const created = await uploadTransportJourney({
            dealEventId: leg.id,
            dispatchEventId: index === 0 ? (documentForm.dispatchEventId || undefined) : undefined,
            courierId: documentForm.courierId,
            loadingDate: documentForm.dateOfDocument || new Date().toISOString().split('T')[0],
            offloadingDate: documentForm.offloadingDate,
            vehicleRegistration: documentForm.vehicleRegistration,
            startKm: Number(documentForm.startKm),
            endKm: Number(documentForm.endKm),
            waybillNumber: documentForm.referenceNumber,
            totalCost: shares[index],
            waybillFile: transportJourneyDocType === 'waybill' && transportJourneyDocFile ? transportJourneyDocFile : undefined,
            invoiceFile: transportJourneyDocType === 'invoice' && transportJourneyDocFile ? transportJourneyDocFile : undefined,
            loadingTime: documentForm.loadingTime || undefined,
            loadingPoint: documentForm.loadingPoint || undefined,
            offloadingPoint: documentForm.offloadingPoint || undefined,
            driverName: documentForm.driverName || undefined,
            driverContact: documentForm.driverContact || undefined,
            removalCertFile: journeyRemovalCertFile,
            animalsDown: index === 0 && documentForm.animalsDown !== '' ? Number(documentForm.animalsDown) : null,
            animalsDownReason: index === 0 ? (documentForm.animalsDownReason || undefined) : undefined,
          });
          savedLegs.push({ event: leg, journeyId: created?.id ? String(created.id) : undefined });
        }
        setTransportJourneyDocFile(null);
        setTransportJourneyDocType('');
        setJourneyRemovalCertFile(null);
        setJourneyExtraEvents([]);
        if (legs.length > 1) {
          const split = total !== undefined
            ? ` — R ${total.toFixed(2)} split ${legs.map((leg, i) => `${leg.dealTitle || leg.dealId} R ${(shares[i] || 0).toFixed(2)}`).join(', ')}`
            : '';
          successMessage = `${legs.length} journeys created, one per deal on the truck${split}.`;
        } else {
          successMessage = transportJourneyDocFile ? 'Journey created with document attached.' : 'Journey created successfully.';
        }
      }

      // Weighbridge weight is a separate resource (transport.WeighbridgeRecord) keyed
      // to the same receive event — saved in its own try/catch so a failure here
      // doesn't roll back or block the journey save that already succeeded above.
      // One truck is weighed once: with several deals aboard every deal gets a
      // row carrying the truck's gross and tare, tied by one shared group, and
      // its own net share apportioned by head.
      let weighbridgeNote = '';
      if (weighbridgeForm.grossWeightKg.trim()) {
        try {
          const weighbridgeInput = {
            eventId: documentForm.dealEventId,
            recordedAt: weighbridgeForm.recordedAt,
            grossWeightKg: weighbridgeForm.grossWeightKg.trim(),
            tareWeightKg: weighbridgeForm.tareWeightKg.trim() || undefined,
            notes: weighbridgeForm.notes.trim(),
          };
          if (editingWeighbridgeRecordId) {
            await updateWeighbridgeRecord(editingWeighbridgeRecordId, weighbridgeInput);
            weighbridgeNote = ' Weighbridge weight updated.';
          } else if (savedLegs.length > 1) {
            const gross = Number(weighbridgeInput.grossWeightKg);
            const tare = weighbridgeInput.tareWeightKg ? Number(weighbridgeInput.tareWeightKg) : null;
            const truckNet = tare !== null ? gross - tare : null;
            const heads = savedLegs.map((leg) => Number(leg.event.animalCount || 0));
            const headTotal = heads.reduce((sum, n) => sum + n, 0);
            const weights = headTotal > 0 && heads.every((n) => n > 0) ? heads.map((n) => n / headTotal) : savedLegs.map(() => 1 / savedLegs.length);
            let netShares: (number | null)[] = savedLegs.map(() => null);
            if (truckNet !== null) {
              netShares = weights.map((w) => Math.round(truckNet * w * 100) / 100);
              const remainder = Math.round((truckNet - netShares.reduce<number>((sum, v) => sum + (v || 0), 0)) * 100) / 100;
              const largest = weights.indexOf(Math.max(...weights));
              netShares[largest] = Math.round(((netShares[largest] || 0) + remainder) * 100) / 100;
            }
            const sharedGroup = (globalThis.crypto && 'randomUUID' in globalThis.crypto)
              ? globalThis.crypto.randomUUID()
              : `${Date.now().toString(16)}-${Math.random().toString(16).slice(2, 10)}`;
            for (const [index, leg] of savedLegs.entries()) {
              await createWeighbridgeRecord({
                ...weighbridgeInput,
                eventId: leg.event.id,
                journeyId: leg.journeyId ?? null,
                sharedGroup,
                headCount: heads[index] || undefined,
                netShareKg: netShares[index] !== null ? String(netShares[index]) : undefined,
                notes: [weighbridgeInput.notes, `Truck weighed once for ${savedLegs.length} deals${headTotal > 0 ? ` (${heads[index]} of ${headTotal} head)` : ''}.`].filter(Boolean).join(' '),
              });
            }
            weighbridgeNote = truckNet !== null
              ? ` Weighbridge weight recorded on all ${savedLegs.length} deals — truck net ${truckNet.toFixed(2)} kg split by head.`
              : ` Weighbridge weight recorded on all ${savedLegs.length} deals.`;
          } else {
            await createWeighbridgeRecord({ ...weighbridgeInput, journeyId: savedLegs[0]?.journeyId ?? undefined });
            weighbridgeNote = ' Weighbridge weight recorded.';
          }
        } catch (weighError: any) {
          weighbridgeNote = ` Journey saved, but the weighbridge weight could not be saved: ${parseApiError(weighError?.message) || 'unknown error'}`;
        }
      }

      // The events just given a journey leave the picker at once, without
      // waiting for the list to reload.
      if (savedLegs.length > 0) {
        const savedIds = new Set(savedLegs.map((leg) => leg.event.id));
        setAllReceiveEvents((prev) => prev.map((ev) => (savedIds.has(ev.id) ? { ...ev, hasJourney: true } : ev)));
      }
      setDocumentUploadSuccess(successMessage + weighbridgeNote);
      // Opened from a deal (wizard or deal screen): once the journey is saved the
      // form has done its job, so it closes itself and says so underneath.
      if (ndShowJourneyModal) {
        setCaptureNotice(successMessage + weighbridgeNote);
        closeNdJourneyCapture();
      }
      const journeys = await fetchTransportJourneys(documentForm.dealId);
      setTransportJourneyRows(journeys);
      setDocumentForm((prev) => ({ ...prev, dealEventId: '', dispatchEventId: '', vehicleRegistration: '', startKm: '', endKm: '', totalCost: '', referenceNumber: '', dateOfDocument: '', offloadingDate: '' }));
      resetWeighbridgeForm();
    } catch (err: any) {
      setDocumentUploadError(err?.message || 'Failed to save journey.');
    } finally {
      setUploadingDocument(false);
    }
  };

  const renderJourneyHistory = () => {
    const query = journeyHistorySearch.trim().toLowerCase();
    const filteredRows = journeyHistoryRows.filter((row: any) => {
      const distance = row.startKm != null && row.endKm != null ? Number(row.endKm) - Number(row.startKm) : '';
      const fields = [
        row.dealTitle,
        row.dealRefNo,
        row.eventType,
        row.eventDate,
        row.vehicleRegistration,
        row.courierName,
        row.loadingDate,
        row.offloadingDate,
        row.startKm,
        row.endKm,
        distance,
        row.totalCost,
        row.waybillNo,
        row.weighbridgeGrossWeightKg,
        row.weighbridgeTareWeightKg,
        row.weighbridgeNetWeightKg,
      ];
      return fields.some((value) => String(value ?? '').toLowerCase().includes(query));
    });

    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5 flex flex-col gap-4 min-w-0">
        <div className="admin-section-head flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">Journey History</h2>
            <p className="text-sm text-avcs-muted">Transport journeys across all deals, newest first.</p>
          </div>
          <button
            className="btn primary whitespace-nowrap"
            onClick={() => {
              resetDocumentForm();
              setView('transportJourneys');
            }}
          >
            New journey
          </button>
        </div>

        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <label className="grid gap-1 text-sm text-avcs-text md:min-w-80">
            Search journeys
            <input
              className="rounded-lg border border-[#1e6bb833] px-3 py-2"
              placeholder="Search deal, vehicle, courier, waybill..."
              value={journeyHistorySearch}
              onChange={(event) => setJourneyHistorySearch(event.target.value)}
            />
          </label>
          <div className="text-sm text-avcs-muted">
            {loadingJourneyHistory ? 'Loading journeys...' : `${fmtNum(filteredRows.length)} of ${fmtNum(journeyHistoryRows.length)} journeys`}
          </div>
        </div>

        {journeyHistoryError && <div className="text-sm text-[#6b1010]">{journeyHistoryError}</div>}

        <div className="admin-table-shell admin-table-scroll overflow-x-auto">
          <table className="min-w-full border-collapse">
            <thead>
              <tr>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Event</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Vehicle</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Courier</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Loading date</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Offloading date</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Distance</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Cost</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Waybill</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Weighbridge weight</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRows.map((row: any) => (
                <tr key={row.id}>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                    <div>{row.eventType || '—'}</div>
                    <div className="text-xs text-avcs-muted">{fmtDate(row.eventDate)}</div>
                  </td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.vehicleRegistration || '—'}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.courierName || '—'}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{fmtDate(row.loadingDate)}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{fmtDate(row.offloadingDate)}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                    {row.startKm != null && row.endKm != null ? `${Number(row.endKm) - Number(row.startKm)} km` : '—'}
                  </td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.totalCost != null ? row.totalCost : '—'}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                    {row.waybillUrl ? (
                      <a href={row.waybillUrl} target="_blank" rel="noopener noreferrer" className="text-[#1e6bb8] underline">View</a>
                    ) : row.waybillNo ? (
                      <span>{row.waybillNo}</span>
                    ) : '—'}
                  </td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                    {row.weighbridgeGrossWeightKg ? (
                      <>
                        <div className="font-semibold text-[#0f3b64]">{row.weighbridgeNetWeightKg ? `Net: ${row.weighbridgeNetWeightKg} kg` : `Gross: ${row.weighbridgeGrossWeightKg} kg`}</div>
                        <div className="text-xs text-avcs-muted">
                          Gross: {row.weighbridgeGrossWeightKg} kg{row.weighbridgeTareWeightKg ? ` · Tare: ${row.weighbridgeTareWeightKg} kg` : ''}
                        </div>
                      </>
                    ) : '—'}
                  </td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                    <div className="flex gap-2">
                      <button className="btn" onClick={() => openJourneyHistoryRowForEdit(row)}>Edit</button>
                      <button className={DELETE_BTN} onClick={async () => { if (await requestConfirm({ message: 'Delete this journey record? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) removeJourneyHistoryRow(row.id); }}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
              {!loadingJourneyHistory && filteredRows.length === 0 && (
                <tr>
                  <td className="px-3 py-6 text-center text-sm text-avcs-muted" colSpan={11}>
                    {journeyHistorySearch.trim() ? 'No journeys match your search.' : 'No journeys found yet.'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    );
  };

  const WEIGHBRIDGE_PAGE_SIZE = 15;

  const renderWeighbridgeHistory = () => {
    const query = weighbridgeHistorySearch.trim().toLowerCase();
    const filteredRows = weighbridgeHistoryRows.filter((row: any) => {
      const fields = [
        row.dealTitle,
        row.dealRefNo,
        row.eventType,
        row.eventDate,
        row.recordedAt,
        row.grossWeightKg,
        row.tareWeightKg,
        row.netWeightKg,
        row.journeyLabel,
        row.notes,
      ];
      return fields.some((value) => String(value ?? '').toLowerCase().includes(query));
    });

    const totalPages = Math.max(1, Math.ceil(filteredRows.length / WEIGHBRIDGE_PAGE_SIZE));
    const currentPage = Math.min(weighbridgeHistoryPage, totalPages);
    const startIndex = (currentPage - 1) * WEIGHBRIDGE_PAGE_SIZE;
    const pageRows = filteredRows.slice(startIndex, startIndex + WEIGHBRIDGE_PAGE_SIZE);

    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5 flex flex-col gap-4 min-w-0">
        <div className="admin-section-head flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">Weighbridge History</h2>
            <p className="text-sm text-avcs-muted">Weighbridge records across all deals, newest first.</p>
          </div>
          <button className="btn primary whitespace-nowrap" onClick={openWeighbridgeNew}>
            New weighbridge record
          </button>
        </div>

        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <label className="grid gap-1 text-sm text-avcs-text md:min-w-80">
            Search weighbridge records
            <input
              className="rounded-lg border border-[#1e6bb833] px-3 py-2"
              placeholder="Search deal, event, weight, journey, notes..."
              value={weighbridgeHistorySearch}
              onChange={(event) => { setWeighbridgeHistorySearch(event.target.value); setWeighbridgeHistoryPage(1); }}
            />
          </label>
          <div className="text-sm text-avcs-muted">
            {loadingWeighbridgeHistory ? 'Loading weighbridge records...' : `${fmtNum(filteredRows.length)} of ${fmtNum(weighbridgeHistoryRows.length)} records`}
          </div>
        </div>

        {weighbridgeHistoryError && <div className="text-sm text-[#6b1010]" role="alert">{weighbridgeHistoryError}</div>}

        <div className="admin-table-shell admin-table-scroll overflow-x-auto">
          <table className="min-w-full border-collapse">
            <thead>
              <tr>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Deal</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Event</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Recorded at</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Gross</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Tare</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Net</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Linked journey</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Notes</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
              </tr>
            </thead>
            <tbody>
              {pageRows.map((row: any) => (
                <tr key={row.id}>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                    <div>{row.dealTitle || '—'}</div>
                    {row.dealRefNo && <div className="text-xs text-avcs-muted">{row.dealRefNo}</div>}
                  </td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                    <div>{row.eventType || '—'}</div>
                    <div className="text-xs text-avcs-muted">{fmtDate(row.eventDate)}</div>
                  </td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{fmtDate(row.recordedAt)}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text tabular-nums">{row.grossWeightKg ? `${row.grossWeightKg} kg` : '—'}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text tabular-nums">{row.tareWeightKg ? `${row.tareWeightKg} kg` : '—'}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm font-semibold text-[#0f3b64] tabular-nums">
                    {row.netWeightKg ? `${row.netWeightKg} kg` : '—'}
                    {row.sharedGroup && (
                      <div className="text-xs font-normal text-avcs-muted">
                        share{row.headCount ? ` for ${row.headCount} head` : ''}{row.truckNetWeightKg ? ` of truck net ${row.truckNetWeightKg} kg` : ''}
                      </div>
                    )}
                  </td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.journeyLabel || '—'}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.notes || '—'}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                    <div className="flex gap-2">
                      <button className="btn" onClick={() => editWeighbridgeHistoryRow(row)}>Edit</button>
                      <button className={DELETE_BTN} onClick={async () => { if (await requestConfirm({ message: 'Delete this weighbridge record? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) removeWeighbridgeHistoryRow(row.id); }}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
              {!loadingWeighbridgeHistory && filteredRows.length === 0 && (
                <tr>
                  <td className="px-3 py-6 text-center text-sm text-avcs-muted" colSpan={9}>
                    {weighbridgeHistorySearch.trim() ? 'No weighbridge records match your search.' : 'No weighbridge records found yet.'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {filteredRows.length > WEIGHBRIDGE_PAGE_SIZE && (
          <div className="flex items-center justify-between gap-3">
            <div className="text-xs text-avcs-muted">
              Showing {fmtNum(startIndex + 1)}–{fmtNum(startIndex + pageRows.length)} of {fmtNum(filteredRows.length)}
            </div>
            <div className="flex items-center gap-2">
              <button
                className="btn"
                disabled={currentPage <= 1}
                onClick={() => setWeighbridgeHistoryPage((p) => Math.max(1, p - 1))}
              >
                Previous
              </button>
              <span className="text-sm text-avcs-text">Page {currentPage} of {totalPages}</span>
              <button
                className="btn"
                disabled={currentPage >= totalPages}
                onClick={() => setWeighbridgeHistoryPage((p) => Math.min(totalPages, p + 1))}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </section>
    );
  };

  const renderWeighbridgeNew = () => {
    const wbSelectedReceiveLabel = wbForm.dealEventId
      ? (allReceiveEvents.find((option) => option.id === wbForm.dealEventId && option.dealId === wbForm.dealId)?.label
        ?? 'Selected receive event')
      : '';

    const wbFilteredReceiveEvents = (() => {
      const q = wbReceiveSearch.trim().toLowerCase();
      const source = q
        ? allReceiveEvents.filter((option) => option.label.toLowerCase().includes(q))
        : allReceiveEvents;
      return source.slice(0, 8);
    })();

    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-6">
        <div className="mb-6 flex items-start justify-between gap-3">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">{editingWbId ? 'Edit weighbridge record' : 'New weighbridge record'}</h2>
            <p className="mt-1 text-sm text-avcs-muted">
              Capture a weighbridge reading against a receive event. A receive event can hold more than one weighbridge record, and each can optionally be linked to a transport journey.
            </p>
          </div>
          <div className="flex shrink-0 gap-2">
            <button type="button" className="btn" onClick={() => setView('weighbridgeHistory')}>View history</button>
            <button type="button" className="btn" onClick={resetWbForm}>Clear</button>
          </div>
        </div>

        {wbError && <div className="mb-4 rounded-lg border border-[#f0b4b4] bg-[#fdf1f1] px-3 py-2 text-sm text-[#6b1010]" role="alert">{wbError}</div>}
        {wbSuccess && <div className="mb-4 rounded-lg border border-[#b7e0c1] bg-[#f0faf3] px-3 py-2 text-sm text-[#0f5d2c]" role="status">{wbSuccess}</div>}

        <form onSubmit={submitWeighbridgeStandalone} className="space-y-5">
          <div className="rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4">
            <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-avcs-muted">Step 1 — Which receive event?</p>
            <div className="grid gap-3 sm:grid-cols-2">
              <ReceiveEventCombobox
                selectedLabel={wbSelectedReceiveLabel}
                searchValue={wbReceiveSearch}
                onSearchChange={(value) => { setWbReceiveSearch(value); setWbShowReceiveDropdown(true); }}
                results={wbFilteredReceiveEvents}
                showDropdown={wbShowReceiveDropdown}
                onFocus={() => setWbShowReceiveDropdown(true)}
                onBlur={() => setTimeout(() => setWbShowReceiveDropdown(false), 150)}
                onSelect={(option) => {
                  setWbForm((prev) => ({ ...prev, dealId: option.dealId, dealEventId: option.id, journeyId: '' }));
                  setWbReceiveSearch('');
                  setWbShowReceiveDropdown(false);
                  setWbError('');
                  setWbSuccess('');
                  loadWbJourneyOptions(option.dealId);
                }}
                onClear={() => {
                  setWbForm((prev) => ({ ...prev, dealId: '', dealEventId: '', journeyId: '' }));
                  setWbJourneyOptions([]);
                  setWbReceiveSearch('');
                }}
              />
              {loadingReceiveEvents && <p className="sm:col-span-2 -mt-2 text-xs text-avcs-muted">Loading receipt events…</p>}

              <label className="grid gap-1 text-sm text-avcs-text sm:col-span-2">
                Linked journey <span className="text-avcs-muted">(optional — attach this weighing to a transport journey in the same deal)</span>
                <select
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  value={wbForm.journeyId}
                  onChange={(event) => setWbForm((prev) => ({ ...prev, journeyId: event.target.value }))}
                  disabled={!wbForm.dealId}
                >
                  <option value="">— None —</option>
                  {wbJourneyOptions.map((journey) => (
                    <option key={journey.id} value={journey.id}>
                      {[journey.vehicleRegistration, journey.loadingDate ? fmtDate(journey.loadingDate) : ''].filter(Boolean).join(' · ') || `Journey ${journey.id.slice(0, 8)}`}
                    </option>
                  ))}
                </select>
              </label>
            </div>
          </div>

          <div className="rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4">
            <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-avcs-muted">Step 2 — Weighbridge reading</p>
            <div className="grid gap-3 sm:grid-cols-2">
              <label className="grid gap-1 text-sm text-avcs-text">
                Gross weight (kg) <span className="text-[#b4453b]">*</span>
                <span className="text-xs text-avcs-muted -mt-0.5">Loaded — vehicle + livestock</span>
                <input type="number" min="0" step="0.01"
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm tabular-nums"
                  value={wbForm.grossWeightKg}
                  onChange={(event) => setWbForm((prev) => ({ ...prev, grossWeightKg: event.target.value }))}
                />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Tare weight (kg)
                <span className="text-xs text-avcs-muted -mt-0.5">Empty vehicle (optional)</span>
                <input type="number" min="0" step="0.01"
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm tabular-nums"
                  value={wbForm.tareWeightKg}
                  onChange={(event) => setWbForm((prev) => ({ ...prev, tareWeightKg: event.target.value }))}
                />
              </label>
              <div className="grid gap-1 text-sm text-avcs-text">
                Net weight (livestock)
                <span className="text-xs text-avcs-muted -mt-0.5">Computed: gross − tare</span>
                <div className="rounded-lg border border-dashed border-[#1e6bb84d] bg-white px-3 py-2 text-sm font-semibold tabular-nums text-[#0f3b64]">
                  {(() => {
                    const gross = parseFloat(wbForm.grossWeightKg);
                    const tare = parseFloat(wbForm.tareWeightKg);
                    if (isNaN(gross) || isNaN(tare)) return '—';
                    return `${(gross - tare).toFixed(2)} kg`;
                  })()}
                </div>
              </div>
              <label className="grid gap-1 text-sm text-avcs-text">
                Recorded at <span className="text-[#b4453b]">*</span>
                <input
                  type="datetime-local"
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  value={wbForm.recordedAt}
                  onChange={(event) => setWbForm((prev) => ({ ...prev, recordedAt: event.target.value }))}
                />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text sm:col-span-2">
                Notes
                <input
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  placeholder="Optional"
                  value={wbForm.notes}
                  onChange={(event) => setWbForm((prev) => ({ ...prev, notes: event.target.value }))}
                />
              </label>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button type="submit" className="btn primary" disabled={wbSaving}>
              {wbSaving ? 'Saving…' : editingWbId ? 'Update weighbridge record' : 'Create weighbridge record'}
            </button>
            {editingWbId && (
              <button type="button" className="btn" onClick={resetWbForm} disabled={wbSaving}>Cancel edit</button>
            )}
          </div>
        </form>
      </section>
    );
  };

  const selectedReceiveEventLabelRef = useRef('');

  const renderTransportJourneys = () => {
    const selectedReceiveEventLabel = documentForm.dealEventId
      ? (allReceiveEvents.find((option) => option.id === documentForm.dealEventId && option.dealId === documentForm.dealId)?.label
        ?? (documentForm.dealId && dealEventLabelsById[documentForm.dealEventId])
        ?? `Event #${documentForm.dealEventId}`)
      : '';
    selectedReceiveEventLabelRef.current = selectedReceiveEventLabel;
    const primaryReceiveEvent = allReceiveEvents.find((option) => option.id === documentForm.dealEventId && option.dealId === documentForm.dealId) || null;
    const journeyLegs: ReceiveEventOption[] = documentForm.dealEventId
      ? [primaryReceiveEvent || { id: documentForm.dealEventId, dealId: documentForm.dealId, label: selectedReceiveEventLabel, animalCount: 0 }, ...journeyExtraEvents]
      : [];
    const journeyHead = journeyLegs.reduce((sum, ev) => sum + Number(ev.animalCount || 0), 0);
    const journeyTotal = documentForm.totalCost ? Number(documentForm.totalCost) : 0;

    const pickedEventIds = new Set(journeyLegs.map((ev) => ev.id));
    // A receive event carries one journey. Once it has one it is not offered
    // again here (editing keeps the current event visible); the weighbridge
    // screen shares this list and still shows them.
    const openReceiveEvents = allReceiveEvents.filter((option) => !option.hasJourney || option.id === documentForm.dealEventId);
    const filteredReceiveEvents = (() => {
      const query = receiveEventSearch.trim().toLowerCase();
      const source = (query
        ? openReceiveEvents.filter((option) => option.label.toLowerCase().includes(query))
        : openReceiveEvents
      ).filter((option) => !pickedEventIds.has(option.id));
      return source.slice(0, 8);
    })();

    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-6">
        <div className="mb-6 flex items-start justify-between gap-3">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">Add journey</h2>
            <p className="mt-1 text-sm text-avcs-muted">Capture a journey when livestock are received, and optionally attach the waybill scan.</p>
          </div>
          <button className="btn shrink-0" onClick={() => { resetDocumentForm(); setDocumentUploadError(''); setDocumentUploadSuccess(''); }}>Clear</button>
        </div>

        <form onSubmit={submitTransportJourneyOnly} className="space-y-5">
          <div className="rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4">
            <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-avcs-muted">Step 1 — Journey details</p>
            <div className="grid gap-3 sm:grid-cols-2">
              {(!documentForm.dealEventId || editingTransportJourneyId) && (
              <ReceiveEventCombobox
                selectedLabel={selectedReceiveEventLabel}
                searchValue={receiveEventSearch}
                onSearchChange={(value) => {
                  setReceiveEventSearch(value);
                  setShowReceiveEventDropdown(true);
                }}
                results={filteredReceiveEvents}
                showDropdown={showReceiveEventDropdown}
                onFocus={() => setShowReceiveEventDropdown(true)}
                onBlur={() => setTimeout(() => setShowReceiveEventDropdown(false), 150)}
                onSelect={(option) => {
                  setDocumentForm((prev) => ({ ...prev, dealId: option.dealId, dealEventId: option.id, dispatchEventId: '' }));
                  setReceiveEventSearch('');
                  setShowReceiveEventDropdown(false);
                  setDocumentUploadError('');
                  setDocumentUploadSuccess('');
                  setTransportJourneyRows([]);
                  fetchTransportJourneys(option.dealId)
                    .then(setTransportJourneyRows)
                    .catch(() => setTransportJourneyRows([]));
                }}
                onClear={() => {
                  setDocumentForm((prev) => ({ ...prev, dealId: '', dealEventId: '', dispatchEventId: '' }));
                  setJourneyExtraEvents([]);
                  setTransportJourneyRows([]);
                  setTransportDealEventOptions([]);
                  setTransportDispatchEventOptions([]);
                  setDealEventLabelsById({});
                  setReceiveEventSearch('');
                }}
              />
              )}
              {loadingReceiveEvents && <p className="sm:col-span-2 -mt-2 text-xs text-avcs-muted">Loading receipt events…</p>}

              {/* Same truck, more deals: add the other deals' receive events and
                  the journey is captured once for all of them, one Journey per
                  deal with the cost split equally per animal. */}
              {documentForm.dealEventId && !editingTransportJourneyId && (
                <div className="sm:col-span-2 rounded-lg border border-[#1e6bb824] bg-white p-3">
                  <div className="flex flex-wrap items-baseline justify-between gap-2">
                    <span className="text-sm font-medium text-avcs-text">Event — receipt of animals · deals on this truck</span>
                    <span className="text-xs text-avcs-muted">
                      {journeyLegs.length} deal{journeyLegs.length === 1 ? '' : 's'}
                      {journeyHead > 0 ? ` · ${fmtNum(journeyHead)} animals` : ''}
                      {journeyTotal > 0 && journeyHead > 0 ? ` · R ${(journeyTotal / journeyHead).toFixed(2)} per animal` : ''}
                    </span>
                  </div>
                  <div className="mt-2 flex flex-wrap gap-2">
                    {journeyLegs.map((leg, index) => (
                      <span key={leg.id} title={leg.label} className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs ${index === 0 ? 'border-[#1e6bb833] bg-[#edf5ff] text-[#0f3b64]' : 'border-[#1e6bb824] bg-[#fbfeff] text-avcs-text'}`}>
                        <span className="font-semibold">{leg.dealTitle || leg.label}</span>
                        {leg.animalCount ? <span className="text-avcs-muted">{fmtNum(leg.animalCount)} head</span> : null}
                        {journeyTotal > 0 && journeyHead > 0 && leg.animalCount ? (
                          <span className="text-avcs-muted">R {((journeyTotal * Number(leg.animalCount)) / journeyHead).toFixed(2)}</span>
                        ) : null}
                        {index > 0 ? (
                          <button type="button" className="text-avcs-muted hover:text-[#6b1010]" aria-label="Remove this deal from the journey" onClick={() => setJourneyExtraEvents((prev) => prev.filter((ev) => ev.id !== leg.id))}>×</button>
                        ) : (
                          <button
                            type="button"
                            className="text-avcs-muted hover:text-[#6b1010]"
                            aria-label="Remove this deal from the journey"
                            onClick={() => {
                              // The first chip is the form's anchor event: dropping it
                              // promotes the next deal on the truck, or empties the form.
                              const [next, ...rest] = journeyExtraEvents;
                              if (next) {
                                setDocumentForm((prev) => ({ ...prev, dealId: next.dealId, dealEventId: next.id, dispatchEventId: '' }));
                                setJourneyExtraEvents(rest);
                                fetchTransportJourneys(next.dealId).then(setTransportJourneyRows).catch(() => setTransportJourneyRows([]));
                              } else {
                                setDocumentForm((prev) => ({ ...prev, dealId: '', dealEventId: '', dispatchEventId: '' }));
                                setTransportJourneyRows([]);
                                setTransportDealEventOptions([]);
                                setTransportDispatchEventOptions([]);
                                setDealEventLabelsById({});
                              }
                              setReceiveEventSearch('');
                            }}
                          >×</button>
                        )}
                      </span>
                    ))}
                  </div>
                  <div className="relative mt-2">
                    <input
                      className="w-full rounded-lg border border-dashed border-[#1e6bb84d] px-3 py-2 text-sm"
                      placeholder="Add another deal's receive event on the same truck…"
                      value={receiveEventSearch}
                      onChange={(e) => { setReceiveEventSearch(e.target.value); setShowReceiveEventDropdown(true); }}
                      onFocus={() => setShowReceiveEventDropdown(true)}
                      onBlur={() => setTimeout(() => setShowReceiveEventDropdown(false), 150)}
                      autoComplete="off"
                    />
                    {showReceiveEventDropdown && (
                      <div className="absolute left-0 right-0 top-full z-20 mt-1 max-h-56 overflow-auto rounded-lg border border-[#1e6bb833] bg-white shadow-lg">
                        {filteredReceiveEvents.length === 0 ? (
                          <div className="px-3 py-2 text-xs text-avcs-muted">No other receipt events found.</div>
                        ) : filteredReceiveEvents.map((option) => (
                          <button
                            key={option.id}
                            type="button"
                            className="w-full border-b border-[#1e6bb812] px-3 py-2 text-left text-sm text-avcs-text hover:bg-[#edf5ff] last:border-0"
                            onMouseDown={(ev) => ev.preventDefault()}
                            onClick={() => {
                              setJourneyExtraEvents((prev) => prev.some((ev) => ev.id === option.id) ? prev : [...prev, option]);
                              setReceiveEventSearch('');
                              setShowReceiveEventDropdown(false);
                            }}
                          >
                            <span className="font-medium">{option.label}</span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                  {journeyLegs.length > 1 && (
                    <p className="mt-2 text-xs text-avcs-muted">
                      Saving creates one journey per deal with these trip details. The total cost and the weighbridge net are split by head across the deals.
                    </p>
                  )}
                </div>
              )}

              <label className="grid gap-1 text-sm text-avcs-text sm:col-span-2">
                Dispatch event <span className="text-avcs-muted">(optional — link the FARM_DIS/FEED_DIS/ABAT_DIS event this journey fulfils, if it exists; leave blank to auto-detect a single unpaired match)</span>
                <select
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  value={documentForm.dispatchEventId}
                  onChange={(event) => setDocumentForm((prev) => ({ ...prev, dispatchEventId: event.target.value }))}
                  disabled={!documentForm.dealId}
                >
                  <option value="">— None (auto-detect if unambiguous) —</option>
                  {transportDispatchEventOptions.map((option) => (
                    <option key={option.id} value={option.id}>{option.label}</option>
                  ))}
                </select>
              </label>

              <div className="grid gap-1 text-sm text-avcs-text">
                Courier (required)
                <div className="flex gap-2">
                  <select
                    className="h-12 min-w-0 flex-1 rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                    value={documentForm.courierId}
                    onChange={(event) => setDocumentForm((prev) => ({ ...prev, courierId: event.target.value }))}
                  >
                    <option value="">Select courier…</option>
                    {couriers.map((courier) => (
                      <option key={courier.id} value={courier.id}>{courier.name}</option>
                    ))}
                  </select>
                  <button type="button" className="btn shrink-0" onClick={() => { resetCourierForm(); setShowAddCourierForm(true); }}>+ New</button>
                </div>
              </div>

              <label className="grid gap-1 text-sm text-avcs-text">
                Vehicle registration (required)
                <input
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  value={documentForm.vehicleRegistration}
                  onChange={(event) => setDocumentForm((prev) => ({ ...prev, vehicleRegistration: event.target.value }))}
                />
              </label>

              <label className="grid gap-1 text-sm text-avcs-text">
                Start KM (required)
                <input type="number" min="0" step="0.01"
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  value={documentForm.startKm}
                  onChange={(event) => setDocumentForm((prev) => ({ ...prev, startKm: event.target.value }))}
                />
              </label>

              <label className="grid gap-1 text-sm text-avcs-text">
                End KM (required)
                <input type="number" min="0" step="0.01"
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  value={documentForm.endKm}
                  onChange={(event) => setDocumentForm((prev) => ({ ...prev, endKm: event.target.value }))}
                />
              </label>

              <label className="grid gap-1 text-sm text-avcs-text">
                Total cost
                <input type="number" min="0" step="0.01"
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  value={documentForm.totalCost}
                  onChange={(event) => setDocumentForm((prev) => ({ ...prev, totalCost: event.target.value }))}
                />
              </label>

              <label className="grid gap-1 text-sm text-avcs-text">
                Waybill number (optional)
                <input
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  placeholder="Optional"
                  value={documentForm.referenceNumber}
                  onChange={(event) => setDocumentForm((prev) => ({ ...prev, referenceNumber: event.target.value }))}
                />
              </label>

              <label className="grid gap-1 text-sm text-avcs-text">
                Loading date
                <input
                  type="date"
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  value={documentForm.dateOfDocument}
                  onChange={(event) => setDocumentForm((prev) => ({ ...prev, dateOfDocument: event.target.value }))}
                />
              </label>

              <label className="grid gap-1 text-sm text-avcs-text">
                Offloading date
                <input
                  type="date"
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  value={documentForm.offloadingDate}
                  onChange={(event) => setDocumentForm((prev) => ({ ...prev, offloadingDate: event.target.value }))}
                />
              </label>

              <label className="grid gap-1 text-sm text-avcs-text">
                Loading time
                <input
                  type="time"
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  value={documentForm.loadingTime}
                  onChange={(event) => setDocumentForm((prev) => ({ ...prev, loadingTime: event.target.value }))}
                />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Driver name
                <input
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  value={documentForm.driverName}
                  onChange={(event) => setDocumentForm((prev) => ({ ...prev, driverName: event.target.value }))}
                />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Driver contact
                <input
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  value={documentForm.driverContact}
                  onChange={(event) => setDocumentForm((prev) => ({ ...prev, driverContact: event.target.value }))}
                />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Removal certificate — Stock Theft Act 1959, s8(1)
                <input
                  type="file"
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  onChange={(event) => setJourneyRemovalCertFile(event.target.files?.[0] || null)}
                />
                <span className="text-xs text-avcs-muted">
                  Required on every journey — the deal cannot be marked complete while any journey is missing it.
                </span>
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Animals down / DOA count
                <input
                  type="number"
                  min="0"
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  value={documentForm.animalsDown}
                  onChange={(event) => setDocumentForm((prev) => ({ ...prev, animalsDown: event.target.value }))}
                />
              </label>
              {documentForm.animalsDown !== '' && Number(documentForm.animalsDown) > 0 && (
                <label className="grid gap-1 text-sm text-avcs-text sm:col-span-2">
                  Reason for injury / DOA
                  <textarea
                    rows={2}
                    className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                    value={documentForm.animalsDownReason}
                    onChange={(event) => setDocumentForm((prev) => ({ ...prev, animalsDownReason: event.target.value }))}
                  />
                </label>
              )}
            </div>
          </div>

          {/* Step 2 — optional weighbridge weight */}
          <div className="rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4">
            <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-avcs-muted">Step 2 — Weighbridge weight (optional)</p>
            <p className="mb-3 text-xs text-avcs-muted">
              Records the weighbridge gross/tare reading for this receive event (net livestock weight = gross − tare). Leave blank if no weighbridge reading was taken.
              {journeyExtraEvents.length > 0 && !editingTransportJourneyId && (
                <> With several deals on the truck the bridge weighs it once: the same gross and tare go on every deal, and each deal's net is its share by head.</>
              )}
            </p>
            <div className="grid gap-3 sm:grid-cols-2">
              <label className="grid gap-1 text-sm text-avcs-text">
                Gross weight (kg){weighbridgeForm.grossWeightKg.trim() && ' (required with weight)'}
                <span className="text-xs text-avcs-muted -mt-0.5">Loaded — vehicle + livestock</span>
                <input type="number" min="0" step="0.01"
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm tabular-nums"
                  value={weighbridgeForm.grossWeightKg}
                  onChange={(event) => setWeighbridgeForm((prev) => ({ ...prev, grossWeightKg: event.target.value }))}
                />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Tare weight (kg)
                <span className="text-xs text-avcs-muted -mt-0.5">Empty vehicle (optional)</span>
                <input type="number" min="0" step="0.01"
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm tabular-nums"
                  value={weighbridgeForm.tareWeightKg}
                  onChange={(event) => setWeighbridgeForm((prev) => ({ ...prev, tareWeightKg: event.target.value }))}
                />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Recorded at{weighbridgeForm.grossWeightKg.trim() && ' (required with weight)'}
                <input
                  type="datetime-local"
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  value={weighbridgeForm.recordedAt}
                  onChange={(event) => setWeighbridgeForm((prev) => ({ ...prev, recordedAt: event.target.value }))}
                />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Weighbridge notes
                <input
                  className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                  placeholder="Optional"
                  value={weighbridgeForm.notes}
                  onChange={(event) => setWeighbridgeForm((prev) => ({ ...prev, notes: event.target.value }))}
                />
              </label>
            </div>
          </div>

          {/* Step 3 — optional document */}
          {!editingTransportJourneyId && (
            <div className="rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4">
              <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-avcs-muted">Step 3 — Attach document (optional)</p>
              <div className="grid gap-3 sm:grid-cols-2">
                <label className="grid gap-1 text-sm text-avcs-text">
                  Document type
                  <select
                    className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                    value={transportJourneyDocType}
                    onChange={(e) => { setTransportJourneyDocType(e.target.value as 'waybill' | 'invoice' | ''); setTransportJourneyDocFile(null); }}
                  >
                    <option value="">— None —</option>
                    <option value="waybill">Waybill</option>
                    <option value="invoice">Invoice</option>
                  </select>
                </label>
                {transportJourneyDocType && (
                  <label className="grid gap-1 text-sm text-avcs-text">
                    {transportJourneyDocType === 'waybill' ? 'Waybill file' : 'Invoice file'}
                    <input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                      className="cursor-pointer rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm text-[#315d86] transition-colors duration-150 hover:border-[#1e6bb866] hover:bg-[#f0f7ff] hover:shadow-[0_0_0_3px_rgba(30,107,184,0.07)] file:cursor-pointer file:mr-3 file:rounded-md file:border-0 file:bg-[#e8f4ff] file:px-3 file:py-1.5 file:text-xs file:font-semibold file:text-[#0f3b64] file:transition-colors file:duration-150 file:hover:bg-[#cce2f8]"
                      onChange={(e) => setTransportJourneyDocFile(e.target.files?.[0] ?? null)}
                    />
                  </label>
                )}
              </div>
            </div>
          )}

          <div className="flex flex-wrap items-center gap-3">
            <button className="btn primary" type="submit" disabled={uploadingDocument}>
              {uploadingDocument ? 'Saving…' : editingTransportJourneyId ? 'Save changes' : 'Create journey'}
            </button>
            {editingTransportJourneyId && (
              <button className="btn" type="button" onClick={() => { setEditingTransportJourneyId(''); resetDocumentForm(); }}>
                Cancel edit
              </button>
            )}
            {documentUploadSuccess && <span className="rounded-lg bg-[#e7f8ee] px-3 py-1.5 text-sm font-medium text-[#106b38]">{documentUploadSuccess}</span>}
            {documentUploadError && <span className="rounded-lg bg-[#f8eae7] px-3 py-1.5 text-sm font-medium text-[#6b1010]">{documentUploadError}</span>}
          </div>
        </form>
      </section>
    );
  };

  const renderCourierManagement = () => (
    <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-6">
      <div className="mb-6 flex items-start justify-between gap-3">
        <div>
          <h2 className="text-2xl font-semibold text-avcs-text">Couriers</h2>
          <p className="mt-1 text-sm text-avcs-muted">Manage transport courier companies used in journey records.</p>
        </div>
        <button type="button" className="btn shrink-0" onClick={() => { resetCourierForm(); setShowAddCourierForm(true); }}>Add courier</button>
      </div>

      <div className="admin-table-scroll overflow-x-auto rounded-xl border border-[#1e6bb824]">
        <table className="min-w-full border-collapse">
          <thead>
            <tr>
              <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Name</th>
              <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Contact</th>
              <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Email</th>
              <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
            </tr>
          </thead>
          <tbody>
            {couriers.map((courier) => (
              <tr key={courier.id}>
                <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{courier.name}</td>
                <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{courier.contactNumber || '—'}</td>
                <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{courier.email || '—'}</td>
                <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm">
                  <div className="flex gap-2">
                    <button className="btn" onClick={() => editCourier(courier.id)}>Edit</button>
                    <button className={DELETE_BTN} onClick={async () => { if (await requestConfirm({ message: 'Delete this courier? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) removeCourier(courier.id); }}>Delete</button>
                  </div>
                </td>
              </tr>
            ))}
            {couriers.length === 0 && (
              <tr><td colSpan={4} className="px-3 py-3 text-sm text-avcs-muted">No couriers yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );

  // Rendered globally (in the main return), not inside renderCourierManagement,
  // so the "+ New courier" button works from any screen that references a
  // courier — e.g. the Add Journey form — opening the modal in place and
  // returning the created courier to that form (submitNewCourier sets
  // documentForm.courierId). Previously it lived inside the Couriers view, so
  // clicking + New elsewhere only set the flag and the modal appeared once you
  // navigated to the Couriers screen.
  const renderCourierModal = () => {
    if (!showAddCourierForm) return null;
    return (
      <div
        className="fixed inset-0 z-[120] flex items-center justify-center bg-[#0b223a66] px-4"
        onClick={() => setShowAddCourierForm(false)}
      >
        <div
          className="w-full max-w-2xl rounded-2xl border border-[#1e6bb833] bg-white p-4 shadow-xl md:p-5"
          onClick={(event) => event.stopPropagation()}
        >
          <div className="mb-3 flex items-center justify-between gap-2">
            <h3 className="text-lg font-semibold text-avcs-text">{editingCourierId ? 'Edit courier' : 'Add new courier'}</h3>
            <button type="button" className="btn" onClick={() => { setShowAddCourierForm(false); resetCourierForm(); }}>Close</button>
          </div>
          <div className="grid gap-2 md:grid-cols-3">
            <input
              className="rounded-lg border border-[#1e6bb833] px-3 py-2 text-sm"
              placeholder="Courier name*"
              value={newCourier.name}
              onChange={(event) => setNewCourier((prev) => ({ ...prev, name: event.target.value }))}
            />
            <input
              className="rounded-lg border border-[#1e6bb833] px-3 py-2 text-sm"
              placeholder="Contact number"
              value={newCourier.contactNumber}
              onChange={(event) => setNewCourier((prev) => ({ ...prev, contactNumber: event.target.value }))}
            />
            <input
              className="rounded-lg border border-[#1e6bb833] px-3 py-2 text-sm"
              placeholder="Email"
              value={newCourier.email}
              onChange={(event) => setNewCourier((prev) => ({ ...prev, email: event.target.value }))}
            />
          </div>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <button className="btn primary" type="button" onClick={submitNewCourier} disabled={creatingCourier}>
              {creatingCourier ? 'Saving…' : editingCourierId ? 'Save courier' : 'Add courier'}
            </button>
            <button type="button" className="btn" onClick={() => { setShowAddCourierForm(false); resetCourierForm(); }} disabled={creatingCourier}>Cancel</button>
            {courierFormError && <span className="text-sm text-[#6b1010]">{courierFormError}</span>}
          </div>
        </div>
      </div>
    );
  };

  // Shared results table for the Documents list and Document search screens.
  const renderDocumentResultTable = (rows: DocumentIndexRow[], fillHeight = false) => (
    <div className={`admin-table-scroll overflow-x-auto${fillHeight ? ' documents-table-scroll min-h-0 flex-1' : ''}`}>
      <table className="min-w-full border-collapse">
        <thead>
          <tr>
            <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Type</th>
            <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Reference / title</th>
            <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Deal</th>
            <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Primary producer</th>
            <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Date</th>
            <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Source</th>
            <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            const url = normalizeDocumentUrl(row.fileUrl);
            return (
              <tr key={`${row.source}-${row.id}-${row.fileName || ''}`}>
                <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.documentType || '—'}</td>
                <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                  <span title={row.fileName || ''}>{row.referenceNumber || row.title || '—'}</span>
                  {row.saleValue && <span className="ml-2 text-xs text-avcs-muted">R {row.saleValue}</span>}
                  {row.visibility === 'ADMIN' && (
                    <span className="ml-2 inline-block rounded-full bg-[#fdecec] px-2 py-0.5 text-xs font-medium text-[#b42318]" title="Hidden from viewer users">Admin only</span>
                  )}
                </td>
                <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.dealNo || '—'}</td>
                <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.primaryProducerName || '—'}</td>
                <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{fmtDate(row.documentDate)}</td>
                <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                  <span className="inline-block rounded-full bg-[#eef4fb] px-2 py-0.5 text-xs font-medium text-[#315d86]">{row.sourceLabel}</span>
                </td>
                <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                  {url ? (
                    <div className="flex gap-2">
                      <a className="btn" href={url} target="_blank" rel="noreferrer">View</a>
                      <a className="btn" href={url} download={row.fileName || true}>Download</a>
                    </div>
                  ) : (
                    <span className="text-avcs-muted">No file</span>
                  )}
                </td>
              </tr>
            );
          })}
          {rows.length === 0 && (
            <tr>
              <td colSpan={7} className="px-3 py-3 text-sm text-avcs-muted">No documents found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  const renderDocumentsList = () => {
    const from = documentsListCount === 0 ? 0 : (documentsListPage - 1) * DOCUMENTS_LIST_PAGE_SIZE + 1;
    const to = Math.min(documentsListPage * DOCUMENTS_LIST_PAGE_SIZE, documentsListCount);
    return (
      <section className="flex flex-col rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-6">
        <div className="mb-4 flex items-start justify-between gap-3">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">Documents</h2>
            <p className="mt-1 text-sm text-avcs-muted">Every uploaded document and the deal &amp; primary producer it belongs to. Data-session upload files are shown on the Event History screen.</p>
          </div>
        </div>

        <div className="mb-4 flex flex-wrap items-end gap-3">
          <label className="grid gap-1 text-sm text-avcs-text">
            <span className="font-medium">Search</span>
            <input
              className="w-64 rounded-lg border border-[#1e6bb833] px-3 py-2"
              placeholder="Reference, deal no, producer, filename…"
              value={documentsListSearch}
              onChange={(e) => setDocumentsListSearch(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') loadDocumentsList(1); }}
            />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">
            <span className="font-medium">Source</span>
            <select
              className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
              value={documentsListSource}
              onChange={(e) => setDocumentsListSource(e.target.value as DocumentSource | 'all')}
            >
              <option value="all">All sources</option>
              <option value="deal">Deal documents</option>
              <option value="transport">Transport waybills / invoices</option>
              <option value="wool">Wool sale documents</option>
              <option value="feedlot">Feedlot invoices</option>
            </select>
          </label>
          <button className="btn primary" type="button" onClick={() => loadDocumentsList(1)}>Search</button>
          <button
            className="btn"
            type="button"
            onClick={() => { setDocumentsListSearch(''); setDocumentsListSource('all'); setTimeout(() => loadDocumentsList(1), 0); }}
          >
            Reset
          </button>
        </div>

        {documentsListError && <div className="mb-3 rounded-lg bg-[#f8eae7] px-3 py-2 text-sm font-medium text-[#6b1010]">{documentsListError}</div>}

        {documentsListLoading ? (
          <p className="text-sm text-avcs-muted">Loading documents…</p>
        ) : (
          <div className="flex min-h-0 flex-1 flex-col">
            <p className="mb-2 text-xs text-avcs-muted">Showing {from}–{to} of {documentsListCount}</p>
            {renderDocumentResultTable(documentsList, true)}
            <div className="mt-3 flex items-center justify-end gap-3 text-sm">
              <button className="btn" type="button" disabled={documentsListPage <= 1} onClick={() => loadDocumentsList(documentsListPage - 1)}>Previous</button>
              <span className="text-avcs-muted">Page {documentsListPage} of {documentsListNumPages}</span>
              <button className="btn" type="button" disabled={documentsListPage >= documentsListNumPages} onClick={() => loadDocumentsList(documentsListPage + 1)}>Next</button>
            </div>
          </div>
        )}
      </section>
    );
  };

  const renderDocumentUpload = () => {
    const totalDealDocPages = Math.max(1, Math.ceil(dealDocumentRows.length / NEW_DOC_DEAL_DOCS_PAGE_SIZE));
    const dealDocsPage = Math.min(newDocDealDocsPage, totalDealDocPages);
    const dealDocsStart = (dealDocsPage - 1) * NEW_DOC_DEAL_DOCS_PAGE_SIZE;
    const dealDocsPageRows = dealDocumentRows.slice(dealDocsStart, dealDocsStart + NEW_DOC_DEAL_DOCS_PAGE_SIZE);
    const selectedDeal = deals.find((d) => d.dealId === documentForm.dealId) || null;

    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-6">
        <div className="mb-6 flex items-start justify-between gap-3">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">New Document</h2>
            <p className="mt-1 text-sm text-avcs-muted">Attach a document to a deal. Choose the deal first to see its existing documents.</p>
          </div>
          <button className="btn shrink-0" onClick={() => { resetDocumentForm(); setDocumentForm((prev) => ({ ...prev, dealId: '', category: 'Deal' })); setDealDocumentRows([]); setDocumentDealSearch(''); setFileInputKey((k) => k + 1); }}>Clear</button>
        </div>

        <form onSubmit={submitDocumentUpload} className="space-y-5">
          {/* Step 1 — Deal (first, required, blank by default) */}
          <div className="rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4">
            <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-avcs-muted">Step 1 — Choose the deal{documentForm.category === 'Deal' && !editingDealDocumentId ? 's' : ''}</p>
            {!(documentForm.dealId && documentForm.category === 'Deal' && !editingDealDocumentId) && (
            <DealCombobox
              label="Deal *"
              selectedDeal={selectedDeal}
              searchValue={documentDealSearch}
              results={(() => {
                const query = documentDealSearch.trim().toLowerCase();
                const source = query
                  ? deals.filter((deal) => formatDealOption(deal).toLowerCase().includes(query))
                  : deals;
                return source.slice(0, 8);
              })()}
              showDropdown={showDocumentDealDropdown}
              onSearchChange={(value) => { setDocumentDealSearch(value); setShowDocumentDealDropdown(true); }}
              onFocus={() => setShowDocumentDealDropdown(true)}
              onBlur={() => setTimeout(() => setShowDocumentDealDropdown(false), 150)}
              onSelect={(deal) => {
                setDocumentForm((prev) => ({ ...prev, dealId: deal.dealId, category: 'Deal' }));
                setDocumentDealSearch('');
                setShowDocumentDealDropdown(false);
                setNewDocDealDocsPage(1);
                setEditingDealDocumentId('');
                setDocumentUploadError('');
                setDocumentUploadSuccess('');
                loadExistingDocuments(deal.dealId);
              }}
              onClear={() => {
                setDocumentForm((prev) => ({ ...prev, dealId: '' }));
                setDocumentExtraDealIds([]);
                setDocumentDealSearch('');
                setShowDocumentDealDropdown(false);
                setDealDocumentRows([]);
                setEditingDealDocumentId('');
              }}
              formatDeal={formatDealOption}
            />
            )}
            {/* The same file often covers several deals (a slaughter sheet, a
                settlement). Once one deal is chosen this box is the deal
                control: add more, remove any; one DealDocument is filed per
                deal and a sale value is split by head. Editing stays single-deal. */}
            {documentForm.dealId && documentForm.category === 'Deal' && !editingDealDocumentId && (() => {
              const extraIds = documentExtraDealIds.filter((id) => id !== documentForm.dealId);
              const targetIds = [documentForm.dealId, ...extraIds];
              const targets = targetIds.map((id) => deals.find((d) => d.dealId === id)).filter(Boolean) as Deal[];
              const headTotal = targets.reduce((sum, d) => sum + Number(d.headcount || 0), 0);
              const saleTotal = documentForm.saleValue ? Number(documentForm.saleValue) : 0;
              const query = documentDealSearch.trim().toLowerCase();
              const candidates = (query ? deals.filter((deal) => formatDealOption(deal).toLowerCase().includes(query)) : deals)
                .filter((deal) => !targetIds.includes(deal.dealId)).slice(0, 8);
              return (
                <div className="rounded-lg border border-[#1e6bb824] bg-white p-3">
                  <div className="flex flex-wrap items-baseline justify-between gap-2">
                    <span className="text-sm font-medium text-avcs-text">Deals this document covers *</span>
                    <span className="text-xs text-avcs-muted">
                      {targets.length} deal{targets.length === 1 ? '' : 's'}{headTotal > 0 ? ` · ${fmtNum(headTotal)} animals` : ''}
                      {saleTotal > 0 && targets.length > 1 && headTotal > 0 ? ` · value split by head` : ''}
                    </span>
                  </div>
                  <div className="mt-2 flex flex-wrap gap-2">
                    {targets.map((deal, index) => (
                      <span key={deal.dealId} className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs ${index === 0 ? 'border-[#1e6bb833] bg-[#edf5ff] text-[#0f3b64]' : 'border-[#1e6bb824] bg-[#fbfeff] text-avcs-text'}`}>
                        <span className="font-semibold">{deal.title}</span>
                        {deal.headcount ? <span className="text-avcs-muted">{fmtNum(deal.headcount)} head</span> : null}
                        {saleTotal > 0 && targets.length > 1 && headTotal > 0 && deal.headcount ? (
                          <span className="text-avcs-muted">R {((saleTotal * Number(deal.headcount)) / headTotal).toFixed(2)}</span>
                        ) : null}
                        {index > 0 ? (
                          <button type="button" className="text-avcs-muted hover:text-[#6b1010]" aria-label="Remove this deal" onClick={() => setDocumentExtraDealIds((prev) => prev.filter((id) => id !== deal.dealId))}>×</button>
                        ) : (
                          <button
                            type="button"
                            className="text-avcs-muted hover:text-[#6b1010]"
                            aria-label="Remove this deal"
                            onClick={() => {
                              // The first chip anchors the form (its existing
                              // documents are listed below): dropping it promotes
                              // the next deal, or empties the form.
                              const [next, ...rest] = extraIds;
                              if (next) {
                                setDocumentForm((prev) => ({ ...prev, dealId: next }));
                                setDocumentExtraDealIds(rest);
                                setNewDocDealDocsPage(1);
                                loadExistingDocuments(next);
                              } else {
                                setDocumentForm((prev) => ({ ...prev, dealId: '' }));
                                setDocumentExtraDealIds([]);
                                setDealDocumentRows([]);
                              }
                              setEditingDealDocumentId('');
                              setDocumentDealSearch('');
                            }}
                          >×</button>
                        )}
                      </span>
                    ))}
                  </div>
                  <div className="relative mt-2">
                    <input
                      className="w-full rounded-lg border border-dashed border-[#1e6bb84d] px-3 py-2 text-sm"
                      placeholder="Add another deal this document covers…"
                      value={documentDealSearch}
                      onChange={(e) => { setDocumentDealSearch(e.target.value); setShowDocumentDealDropdown(true); }}
                      onFocus={() => setShowDocumentDealDropdown(true)}
                      onBlur={() => setTimeout(() => setShowDocumentDealDropdown(false), 150)}
                      autoComplete="off"
                    />
                    {showDocumentDealDropdown && (
                      <div className="absolute left-0 right-0 top-full z-20 mt-1 max-h-56 overflow-auto rounded-lg border border-[#1e6bb833] bg-white shadow-lg">
                        {candidates.length === 0 ? (
                          <div className="px-3 py-2 text-xs text-avcs-muted">No other deals found.</div>
                        ) : candidates.map((deal) => (
                          <button
                            key={deal.dealId}
                            type="button"
                            className="w-full border-b border-[#1e6bb812] px-3 py-2 text-left text-sm text-avcs-text hover:bg-[#edf5ff] last:border-0"
                            onMouseDown={(ev) => ev.preventDefault()}
                            onClick={() => {
                              setDocumentExtraDealIds((prev) => (prev.includes(deal.dealId) ? prev : [...prev, deal.dealId]));
                              setDocumentDealSearch('');
                              setShowDocumentDealDropdown(false);
                            }}
                          >
                            {formatDealOption(deal)}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              );
            })()}
          </div>

          {documentForm.dealId && (
            <>
              {/* Step 2 — Details */}
              <div className="rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4">
                <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-avcs-muted">Step 2 — Document details</p>
                <div className="grid gap-3 sm:grid-cols-2">
                  <SearchSelect
                    label="Document type"
                    required
                    placeholder="Search document types…"
                    options={dealDocumentTypeOptions as SearchSelectOption[]}
                    value={documentForm.systemCode || null}
                    onChange={(id) => setDocumentForm((prev) => ({ ...prev, systemCode: id || '' }))}
                    emptyText={loadingDocumentTypes ? 'Loading…' : 'No document types configured.'}
                  />
                  <label className="grid gap-1 text-sm text-avcs-text">
                    <span className="font-medium">Document date <span className="text-[#b42318]">*</span></span>
                    <input
                      type="date"
                      className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                      value={documentForm.dateOfDocument}
                      onChange={(event) => setDocumentForm((prev) => ({ ...prev, dateOfDocument: event.target.value }))}
                    />
                  </label>
                  {(() => {
                    // The box is labelled by what the chosen type's money IS, and
                    // the ledger row the backend books carries that type. A
                    // filing-only type (certificate, photo) has no box at all.
                    const kind = dealDocumentTypeOptions.find((o) => o.id === documentForm.systemCode)?.financeRecordType || '';
                    if (kind === 'NONE') {
                      return (
                        <div className="grid gap-1 text-sm text-avcs-text">
                          <span className="font-medium text-avcs-muted">No value</span>
                          <span className="text-xs text-avcs-muted">This document type carries no money — it is filed against the deal only.</span>
                        </div>
                      );
                    }
                    const meta = DEAL_FINANCE_TYPES.find((t) => t.value === kind);
                    if (meta?.isCost && documentCostMode === 'split' && !editingDealDocumentId) {
                      return (
                        <div className="grid gap-1 text-sm text-avcs-text">
                          <span className="font-medium">{meta.label} cost (ex VAT)</span>
                          <span className="text-xs text-avcs-muted">Comes from the cost lines below.</span>
                          <span className="rounded-lg border border-dashed border-[#1e6bb84d] bg-[#f8fafc] px-3 py-2 text-sm font-semibold tabular-nums">R {costLinesTotal(documentCostLines).toFixed(2)}</span>
                        </div>
                      );
                    }
                    const label = !meta ? 'Sale value' : meta.isCost ? `${meta.label} cost (ex VAT)` : `${meta.label} value`;
                    const hint = !meta
                      ? 'Booked as a sale. Set the money type on the document type (Master data → Document types) if this is a cost or carries no money.'
                      : meta.isCost ? 'Booked to the deal as a cost.' : 'Booked to the deal as income.';
                    return (
                      <label className="grid gap-1 text-sm text-avcs-text">
                        <span className="font-medium">{label} <span className="text-avcs-muted">(optional)</span></span>
                        <span className="-mt-0.5 text-xs text-avcs-muted">{hint}</span>
                        <input
                          type="number" min="0" step="0.01"
                          className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                          value={documentForm.saleValue}
                          onChange={(event) => setDocumentForm((prev) => ({ ...prev, saleValue: event.target.value }))}
                        />
                      </label>
                    );
                  })()}
                  <label className="grid gap-1 text-sm text-avcs-text">
                    <span className="font-medium">Reference <span className="text-avcs-muted">(optional)</span></span>
                    <input
                      className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                      value={documentForm.referenceNumber}
                      onChange={(event) => setDocumentForm((prev) => ({ ...prev, referenceNumber: event.target.value }))}
                    />
                  </label>
                  <label className="grid gap-1 text-sm text-avcs-text sm:col-span-2">
                    <span className="font-medium">Notes <span className="text-avcs-muted">(optional)</span></span>
                    <textarea
                      className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                      rows={2}
                      value={documentForm.notes}
                      onChange={(event) => setDocumentForm((prev) => ({ ...prev, notes: event.target.value }))}
                    />
                  </label>
                  <label className="grid gap-1 text-sm text-avcs-text sm:col-span-2">
                    <span className="font-medium">Who can see this document</span>
                    <select
                      className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                      value={documentForm.visibility}
                      onChange={(event) => setDocumentForm((prev) => ({ ...prev, visibility: event.target.value === 'ADMIN' ? 'ADMIN' : 'ALL' }))}
                    >
                      <option value="ALL">Standard (producers see it only if released below)</option>
                      <option value="ADMIN">Admin/staff only (never shown to producers)</option>
                    </select>
                    <span className="text-xs text-avcs-muted">Choose “Admin/staff only” for documents like a Sale Agreement that no producer should ever see.</span>
                  </label>
                  {documentForm.category === 'Deal' && (
                    <label className="flex items-start gap-3 text-sm text-avcs-text sm:col-span-2">
                      <input
                        type="checkbox"
                        className="mt-1 h-4 w-4"
                        checked={documentForm.sharedWithProducer}
                        disabled={documentForm.visibility === 'ADMIN'}
                        onChange={(event) => setDocumentForm((prev) => ({ ...prev, sharedWithProducer: event.target.checked }))}
                      />
                      <span>
                        <span className="font-medium">Show this document to the producer</span>
                        <span className="block text-xs text-avcs-muted">The farmer sees it on their own view of the deal. Off by default: a producer only sees documents someone here chooses to release. Not available for “Admin/staff only” documents.</span>
                      </span>
                    </label>
                  )}
                </div>
                {(() => {
                  // A cost can land whole on this deal, or be spread onto the
                  // animals it was really for — a vaccination bill on the treated
                  // animals, a feed statement by animal-days, a shearing bill by
                  // the sheep shorn — reaching other deals' ledgers where it must.
                  const kind = dealDocumentTypeOptions.find((o) => o.id === documentForm.systemCode)?.financeRecordType || '';
                  const meta = DEAL_FINANCE_TYPES.find((t) => t.value === kind);
                  if (!meta?.isCost || editingDealDocumentId || documentForm.category !== 'Deal') return null;
                  return (
                    <div className="mt-3 rounded-lg border border-[#1e6bb824] bg-white p-3">
                      <p className="text-sm font-medium text-avcs-text">How is this {meta.label.toLowerCase()} cost applied?</p>
                      <div className="mt-2 flex flex-wrap gap-3 text-sm">
                        <label className="flex items-center gap-2"><input type="radio" name="documentCostMode" checked={documentCostMode === 'deal'} onChange={() => setDocumentCostMode('deal')} /> Whole amount to {documentExtraDealIds.length > 0 ? 'the selected deals, split by head' : 'this deal'}</label>
                        <label className="flex items-center gap-2"><input type="radio" name="documentCostMode" checked={documentCostMode === 'split'} onChange={() => { setDocumentCostMode('split'); if (documentCostLines.length === 0) setDocumentCostLines([newCostLine(kind === 'TRANSPORT' ? 'MOVEMENT' : kind === 'SHEARING' ? 'SHEARING' : 'VACCINATION')]); }} /> Line items, each split across the animals on its events</label>
                      </div>
                      {documentCostMode === 'split' && (
                        <div className="mt-3">
                          <p className="mb-2 text-xs text-avcs-muted">One line per charge on the invoice: pick the event type, describe it, enter its cost, then tick the events it covered (only the selected deals' events that carry no cost yet are offered). A line with events is split equally across the animals on them; a line with no events is divided across every animal in the selected deals.</p>
                          <CostLineItems
                            dealHeads={[documentForm.dealId, ...documentExtraDealIds.filter((id) => id !== documentForm.dealId)].map((id) => {
                              const deal = deals.find((d) => d.dealId === id);
                              return { dealId: id, dealNo: deal?.title || id, animals: Number(deal?.headcount || 0) };
                            })}
                            lines={documentCostLines}
                            onChange={setDocumentCostLines}
                          />
                        </div>
                      )}
                    </div>
                  );
                })()}
                {!loadingDocumentTypes && dealDocumentTypeOptions.length === 0 && (
                  <p className="mt-3 rounded-lg bg-[#fff7e6] px-3 py-2 text-xs text-[#8a5a00]">No document types are configured yet. Add them under Reference data before uploading.</p>
                )}
              </div>

              {/* Step 3 — File */}
              <div className="rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4">
                <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-avcs-muted">Step 3 — Upload file <span className="text-[#b42318]">*</span></p>
                <FileDropzone
                  file={documentForm.file}
                  onFileChange={(f) => setDocumentForm((prev) => ({ ...prev, file: f }))}
                  resetKey={fileInputKey}
                />
                {editingDealDocumentId && !documentForm.file && (
                  <p className="mt-2 text-xs text-avcs-muted">Leave empty to keep the current file when editing.</p>
                )}
              </div>

              {/* Submit row */}
              <div className="flex flex-wrap items-center gap-3">
                <button className="btn primary" type="submit" disabled={uploadingDocument}>
                  {uploadingDocument ? 'Saving…' : editingDealDocumentId ? 'Save changes' : 'Upload document'}
                </button>
                {editingDealDocumentId && (
                  <button
                    className="btn"
                    type="button"
                    onClick={() => { setEditingDealDocumentId(''); setDocumentForm((prev) => ({ ...prev, systemCode: '', referenceNumber: '', saleValue: '', dateOfDocument: '', notes: '', file: null })); setFileInputKey((k) => k + 1); }}
                  >
                    Cancel edit
                  </button>
                )}
                {documentUploadSuccess && <span className="rounded-lg bg-[#e7f8ee] px-3 py-1.5 text-sm font-medium text-[#106b38]">{documentUploadSuccess}</span>}
                {documentUploadError && <span className="rounded-lg bg-[#f8eae7] px-3 py-1.5 text-sm font-medium text-[#6b1010]">{documentUploadError}</span>}
              </div>
            </>
          )}
        </form>

        {/* Documents linked to the selected deal (paginated) */}
        {documentForm.dealId && (
          <div className="mt-5 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
            <div className="mb-3 flex items-center justify-between gap-2">
              <h3 className="text-lg font-semibold text-avcs-text">Documents for {selectedDeal ? formatDealOption(selectedDeal) : 'this deal'}</h3>
              <button type="button" className="btn" onClick={() => loadExistingDocuments(documentForm.dealId)}>Refresh</button>
            </div>
            {loadingExistingDocuments ? (
              <p className="text-sm text-avcs-muted">Loading documents…</p>
            ) : (
              <>
                <div className="admin-table-scroll overflow-x-auto">
                  <table className="min-w-full border-collapse">
                    <thead>
                      <tr>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Type</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Reference</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Date</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Value</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Shown to producer</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">File</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dealDocsPageRows.map((row) => (
                        <tr key={row.id}>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.documentTypeName || row.documentTypeId || '—'}</td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.referenceNumber || '—'}</td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{fmtDate(row.dateOfDocument)}</td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.saleValue ? `R ${row.saleValue}` : '—'}</td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                            {row.sharedWithProducer
                              ? <span className="inline-block rounded-full bg-[#e7f8ee] px-2 py-0.5 text-xs font-medium text-[#106b38]">{row.uploadedByProducer ? 'Sent by producer' : 'Shown'}</span>
                              : <span className="text-avcs-muted">—</span>}
                            {row.producerStatedAmount && (
                              <span className="mt-1 block text-xs text-avcs-muted" title="The invoice total the producer typed. Unverified and not booked: check it against the file, then record the value on the document.">Producer says R {row.producerStatedAmount}</span>
                            )}
                          </td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                            {row.fileUrl ? <a className="btn" href={normalizeDocumentUrl(row.fileUrl)} target="_blank" rel="noreferrer">Open</a> : '—'}
                          </td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                            <div className="flex gap-2">
                              <button className="btn" type="button" onClick={() => editDealDocumentRow(row)}>Edit</button>
                              <button className={DELETE_BTN} type="button" onClick={async () => { if (await requestConfirm({ message: 'Delete this document? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) removeDealDocumentRow(row.id); }}>Delete</button>
                            </div>
                          </td>
                        </tr>
                      ))}
                      {dealDocumentRows.length === 0 && (
                        <tr>
                          <td colSpan={6} className="px-3 py-3 text-sm text-avcs-muted">No documents attached to this deal yet.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {totalDealDocPages > 1 && (
                  <div className="mt-3 flex items-center justify-end gap-3 text-sm">
                    <button className="btn" type="button" disabled={dealDocsPage <= 1} onClick={() => setNewDocDealDocsPage(dealDocsPage - 1)}>Previous</button>
                    <span className="text-avcs-muted">Page {dealDocsPage} of {totalDealDocPages}</span>
                    <button className="btn" type="button" disabled={dealDocsPage >= totalDealDocPages} onClick={() => setNewDocDealDocsPage(dealDocsPage + 1)}>Next</button>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {/* Recent uploads (this session) */}
        <div className="admin-table-scroll mt-5 overflow-x-auto">
          <h3 className="text-lg font-semibold text-avcs-text">Recent uploads (this session)</h3>
          <table className="mt-2 min-w-full border-collapse">
            <thead>
              <tr>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Deal</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Document type</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">File</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Date</th>
              </tr>
            </thead>
            <tbody>
              {uploadedDocuments.map((doc) => (
                <tr key={doc.id}>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{doc.dealTitle}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{doc.documentType}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{doc.fileName}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{fmtDate(doc.dateOfDocument)}</td>
                </tr>
              ))}
              {uploadedDocuments.length === 0 && (
                <tr>
                  <td colSpan={4} className="px-3 py-3 text-sm text-avcs-muted">No uploads in this session yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    );
  };

  const renderDocumentSearch = () => {
    const selectedDeal = deals.find((d) => d.dealId === docSearchDealId) || null;
    const toggleSource = (s: DocumentSource) => setDocSearchSources((prev) => ({ ...prev, [s]: !prev[s] }));
    const sourceLabels: Array<{ key: DocumentSource; label: string }> = [
      { key: 'deal', label: 'Deal documents' },
      { key: 'transport', label: 'Transport waybills' },
      { key: 'wool', label: 'Wool documents' },
      { key: 'feedlot', label: 'Feedlot invoices' },
      { key: 'data_session', label: 'Data session files' },
    ];
    const from = docSearchCount === 0 ? 0 : (docSearchPage - 1) * DOC_SEARCH_PAGE_SIZE + 1;
    const to = Math.min(docSearchPage * DOC_SEARCH_PAGE_SIZE, docSearchCount);
    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-6">
        <div className="mb-4">
          <h2 className="text-2xl font-semibold text-avcs-text">Document Search</h2>
          <p className="mt-1 text-sm text-avcs-muted">Search across every document type — deal documents, transport waybills, wool &amp; feedlot documents, and data-session upload files.</p>
        </div>

        <form
          className="mb-5 grid gap-4 rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4"
          onSubmit={(e) => { e.preventDefault(); runDocumentSearch(1); }}
        >
          <div className="grid gap-3 md:grid-cols-2">
            <label className="grid gap-1 text-sm text-avcs-text">
              <span className="font-medium">Search text</span>
              <input
                className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                placeholder="Reference, deal no, producer, filename, notes…"
                value={docSearchQuery}
                onChange={(e) => setDocSearchQuery(e.target.value)}
              />
            </label>
            <DealCombobox
              label="Deal (optional)"
              selectedDeal={selectedDeal}
              searchValue={docSearchDealSearch}
              results={(() => {
                const query = docSearchDealSearch.trim().toLowerCase();
                const source = query
                  ? deals.filter((deal) => formatDealOption(deal).toLowerCase().includes(query))
                  : deals;
                return source.slice(0, 8);
              })()}
              showDropdown={showDocSearchDealDropdown}
              onSearchChange={(value) => { setDocSearchDealSearch(value); setShowDocSearchDealDropdown(true); }}
              onFocus={() => setShowDocSearchDealDropdown(true)}
              onBlur={() => setTimeout(() => setShowDocSearchDealDropdown(false), 150)}
              onSelect={(deal) => { setDocSearchDealId(deal.dealId); setDocSearchDealSearch(''); setShowDocSearchDealDropdown(false); }}
              onClear={() => { setDocSearchDealId(''); setDocSearchDealSearch(''); setShowDocSearchDealDropdown(false); }}
              formatDeal={formatDealOption}
            />
            <label className="grid gap-1 text-sm text-avcs-text">
              <span className="font-medium">Date from</span>
              <input type="date" className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm" value={docSearchDateFrom} onChange={(e) => setDocSearchDateFrom(e.target.value)} />
            </label>
            <label className="grid gap-1 text-sm text-avcs-text">
              <span className="font-medium">Date to</span>
              <input type="date" className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm" value={docSearchDateTo} onChange={(e) => setDocSearchDateTo(e.target.value)} />
            </label>
          </div>

          <div className="grid gap-2 text-sm text-avcs-text">
            <span className="font-medium">Include sources</span>
            <div className="flex flex-wrap gap-4">
              {sourceLabels.map(({ key, label }) => (
                <label key={key} className="flex items-center gap-2">
                  <input type="checkbox" checked={docSearchSources[key]} onChange={() => toggleSource(key)} />
                  {label}
                </label>
              ))}
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            <button className="btn primary" type="submit" disabled={docSearchLoading}>{docSearchLoading ? 'Searching…' : 'Search'}</button>
            <button
              className="btn"
              type="button"
              onClick={() => {
                setDocSearchQuery(''); setDocSearchDealId(''); setDocSearchDealSearch('');
                setDocSearchDateFrom(''); setDocSearchDateTo('');
                setDocSearchSources({ deal: true, transport: true, wool: true, feedlot: true, data_session: true });
                setDocSearchResults([]); setDocSearchHasSearched(false); setDocSearchError('');
              }}
            >
              Reset
            </button>
          </div>
        </form>

        {docSearchError && <div className="mb-3 rounded-lg bg-[#f8eae7] px-3 py-2 text-sm font-medium text-[#6b1010]">{docSearchError}</div>}

        {docSearchLoading ? (
          <p className="text-sm text-avcs-muted">Searching documents…</p>
        ) : !docSearchHasSearched ? (
          <p className="text-sm text-avcs-muted">Enter your criteria above and click Search.</p>
        ) : (
          <>
            <p className="mb-2 text-xs text-avcs-muted">Showing {from}–{to} of {docSearchCount}</p>
            {renderDocumentResultTable(docSearchResults)}
            {docSearchNumPages > 1 && (
              <div className="mt-3 flex items-center justify-end gap-3 text-sm">
                <button className="btn" type="button" disabled={docSearchPage <= 1} onClick={() => runDocumentSearch(docSearchPage - 1)}>Previous</button>
                <span className="text-avcs-muted">Page {docSearchPage} of {docSearchNumPages}</span>
                <button className="btn" type="button" disabled={docSearchPage >= docSearchNumPages} onClick={() => runDocumentSearch(docSearchPage + 1)}>Next</button>
              </div>
            )}
          </>
        )}
      </section>
    );
  };

  const renderDealList = () => {
    const dealAnimalStats = (deal: Deal) => {
      const { total, eidCount, nonEidCount, speciesCounts } = getDealAnimalStats(deal);
      const species = Object.entries(speciesCounts)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([name, count]) => `${name.charAt(0) + name.slice(1).toLowerCase()} ${fmtNum(count)}`)
        .join(', ');

      return { total, species: species || '—', eidCount, nonEidCount };
    };

    const primaryEntityContact = (deal: Deal) => {
      const producerId = dealOverviewById[deal.dealId]?.primary_producer?.id;
      const entity = producerId ? entityDirectory.find((row) => row.id === producerId) : null;
      const contacts = entity?.contacts || [];
      const contact = contacts.find((row) => row.isPrimary) || contacts[0];
      if (!contact) return null;
      return {
        name: contact.name || 'Unnamed contact',
        details: [contact.email, contact.phoneNo].filter(Boolean).join(' · '),
      };
    };

    const orderedDeals = [...activeDeals, ...completedDeals];
    const dealSearchQuery = dealSearch.trim().toLowerCase();
    const visibleDeals = dealSearchQuery
      ? orderedDeals.filter((deal) => {
          const stats = dealAnimalStats(deal);
          const contact = primaryEntityContact(deal);
          const haystack = [
            deal.title,
            deal.dealRefNo,
            deal.counterpart,
            deal.status,
            stats.species,
            contact?.name,
            contact?.details,
          ].filter(Boolean).join(' ').toLowerCase();
          return haystack.includes(dealSearchQuery);
        })
      : orderedDeals;

    const dealTotalPages = Math.max(1, Math.ceil(visibleDeals.length / DEAL_LIST_PAGE_SIZE));
    const dealCurrentPage = Math.min(dealListPage, dealTotalPages);
    const dealPageStart = (dealCurrentPage - 1) * DEAL_LIST_PAGE_SIZE;
    const pagedDeals = visibleDeals.slice(dealPageStart, dealPageStart + DEAL_LIST_PAGE_SIZE);

    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">Deal list</h2>
            <p className="mt-1 text-sm text-avcs-muted">All deals with animal and EID coverage.</p>
          </div>
          <button className="btn primary" onClick={() => { resetNewDealFlow(); setView('dealCreate'); }}>New deal</button>
        </div>

        {/* Deleting happens from this screen, but its result messages used to
            render only inside the New/Edit deal form — so a delete here looked
            identical whether it succeeded, was refused, or errored. Surface
            them where the action actually is. */}
        {dealCrudError && (
          <div role="alert" className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{dealCrudError}</div>
        )}
        {dealCrudSuccess && (
          <div role="status" className="mb-3 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{dealCrudSuccess}</div>
        )}

        <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
          <input
            type="search"
            placeholder="Search deals..."
            value={dealSearch}
            onChange={(event) => setDealSearch(event.target.value)}
            className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm sm:w-80"
          />
          {visibleDeals.length > 0 && (
            <span className="text-sm text-avcs-muted">
              Showing {dealPageStart + 1}–{Math.min(dealPageStart + DEAL_LIST_PAGE_SIZE, visibleDeals.length)} of {visibleDeals.length}{dealSearch.trim() ? ` (filtered from ${orderedDeals.length})` : ''} deals
            </span>
          )}
        </div>

        <div className="admin-table-shell admin-table-scroll deal-table-scroll overflow-x-auto">
          <table className="min-w-full border-collapse">
            <thead>
              <tr>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Deal</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Primary producer</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Primary contact</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Status</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">Total animals</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Species</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">Non-EID count</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">EID count</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
              </tr>
            </thead>
            <tbody>
              {pagedDeals.map((deal) => {
                const stats = dealAnimalStats(deal);
                const contact = primaryEntityContact(deal);
                return (
                  <tr key={deal.dealId}>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                      <div className="font-medium">{deal.title}</div>
                      <div className="text-xs text-avcs-muted">Start date: {fmtDate(deal.startDate)}</div>
                    </td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{deal.counterpart}</td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                      {contact ? (
                        <div>
                          <div className="font-medium">{contact.name}</div>
                          {contact.details && <div className="text-xs text-avcs-muted">{contact.details}</div>}
                        </div>
                      ) : '—'}
                    </td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                      <span className={`badge ${deal.status === 'Completed' ? 'success' : deal.status === 'Cancelled' ? 'failure' : 'info'}`}>{deal.status}</span>
                      {deal.status === 'Completed' && deal.completedUnderOverride && (
                        <span className="ml-1 badge info" title="Closed under an approved close-out override — some requirements were waived">Under override</span>
                      )}
                    </td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-right text-sm text-avcs-text">{fmtNum(stats.total)}</td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{stats.species}</td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-right text-sm text-avcs-text">{fmtNum(stats.nonEidCount)}</td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-right text-sm text-avcs-text">{fmtNum(stats.eidCount)}</td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                      <div className="flex flex-wrap gap-2">
                        <button className="btn primary" onClick={() => { setSelectedDealId(deal.dealId); setView('dealSummary'); }}>Open</button>
                        {isSuperuser && (
                          <button
                            className={DELETE_BTN}
                            title="Superuser only — admins should cancel the deal instead, which keeps its history"
                            onClick={async () => {
                              if (await requestConfirm({
                                title: 'Delete deal',
                                message: 'Delete this deal and its associated data — including its transport journeys, weighbridge records and their documents? This cannot be undone. To keep the record, cancel the deal instead.',
                                confirmLabel: 'Delete deal',
                                tone: 'danger',
                              })) deleteDeal(deal.dealId);
                            }}
                          >Delete</button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
              {orderedDeals.length === 0 && (
                <tr>
                  <td className="px-3 py-6 text-center text-sm text-avcs-muted" colSpan={9}>No deals found.</td>
                </tr>
              )}
              {orderedDeals.length > 0 && visibleDeals.length === 0 && (
                <tr>
                  <td className="px-3 py-6 text-center text-sm text-avcs-muted" colSpan={9}>No deals match "{dealSearch}".</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {dealTotalPages > 1 && (
          <div className="mt-3 flex flex-wrap items-center justify-end gap-2 text-sm text-avcs-muted">
            <button
              type="button"
              className="rounded-lg border border-[#1e6bb824] bg-white px-3 py-1.5 text-sm text-avcs-text disabled:opacity-40"
              disabled={dealCurrentPage <= 1}
              onClick={() => setDealListPage((prev) => Math.max(1, prev - 1))}
            >
              Previous
            </button>
            <span className="text-avcs-text">Page {dealCurrentPage} of {dealTotalPages}</span>
            <button
              type="button"
              className="rounded-lg border border-[#1e6bb824] bg-white px-3 py-1.5 text-sm text-avcs-text disabled:opacity-40"
              disabled={dealCurrentPage >= dealTotalPages}
              onClick={() => setDealListPage((prev) => Math.min(dealTotalPages, prev + 1))}
            >
              Next
            </button>
          </div>
        )}
      </section>
    );
  };

  const dealModalTarget = (id: string) => ({
    id,
    label: deals.find((d) => d.dealId === id)?.title || id,
  });

  const renderDealSummary = () => (
    <>
      {renderCaptureNotice()}
      <DealOverview
        deals={deals}
        animalSummaryByDeal={animalSummaryByDeal}
        selectedDealId={selectedDealId}
        onSelectDeal={setSelectedDealId}
        onBack={() => setView('dealList')}
        onEditFeed={(id) => { setFeedForm((prev) => ({ ...prev, dealId: id })); setView('feedCrud'); }}
        onAddFeed={(id) => { resetAddFeed(); setAddFeedDealIds([id]); setView('addFeed'); }}
        onUploadDocs={(id) => { setDocumentForm((prev) => ({ ...prev, dealId: id })); setView('documentUpload'); }}
        onViewAnimals={(id) => { setAnimalListDealFilter(id); setAnimalSearch(''); setView('animalList'); }}
        onViewAnimal={(animalId, fromTab) => openAnimalDetail(animalId, { returnToDealTab: fromTab || 'dashboard' })}
        initialTab={animalReturnDealTab || undefined}
        onNewEvent={(id) => {
          // Carry the deal across so a registration event opens with it already
          // chosen — the user got here from that deal, so re-picking it is busywork.
          setDataSessionDealId(id);
          setDataSessionDealSearch('');
          setView('dataSessionUpload');
        }}
        onNewVaccination={(id) => openNdEventCapture('VACCINATION', dealModalTarget(id))}
        onNewJourney={(id) => openNdJourneyCapture(dealModalTarget(id))}
        onOpenWizard={(id) => { resumeWizardForDeal(id); }}
        refreshToken={dealOverviewRefreshToken}
        onDealStatusChanged={(id, completed) =>
          setDeals((prev) => prev.map((d) => (d.dealId === id ? { ...d, status: completed ? 'Completed' : 'Active' } : d)))
        }
      />
      {renderCaptureModals()}
    </>
  );

  // "Needs review" as its own screen: the same per-deal review panel the deal
  // view used to carry, but reachable from the menu with a count badge, and
  // opening on whichever deal actually has something pending.
  const renderNeedsReview = () => {
    const claimsByDeal = new Map<string, number>();
    pendingReviewClaims.forEach((claim) => {
      const key = claim.animal_deal_id || '';
      if (key) claimsByDeal.set(key, (claimsByDeal.get(key) || 0) + 1);
    });
    const dealsWithClaims = deals.filter((d) => claimsByDeal.has(d.dealId));
    const effectiveDealId = needsReviewDealId || dealsWithClaims[0]?.dealId || deals[0]?.dealId || '';
    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
        <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">Needs review</h2>
            <p className="mt-1 text-sm text-avcs-muted">
              {pendingReviewClaims.length > 0
                ? `${pendingReviewClaims.length} identifier claim(s) waiting across ${claimsByDeal.size} deal(s), plus any animals without a slaughter record and unrecognised upload columns for the selected deal.`
                : 'No identifier claims are waiting. Pick a deal to check its slaughter reconciliation and unrecognised columns.'}
            </p>
          </div>
          <label className="grid gap-1 text-sm text-avcs-text">
            Deal
            <select
              className="min-w-[16rem] rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
              value={effectiveDealId}
              onChange={(e) => setNeedsReviewDealId(e.target.value)}
            >
              {dealsWithClaims.length > 0 && (
                <optgroup label="With pending claims">
                  {dealsWithClaims.map((d) => (
                    <option key={d.dealId} value={d.dealId}>{d.title} · {claimsByDeal.get(d.dealId)} pending</option>
                  ))}
                </optgroup>
              )}
              <optgroup label="All deals">
                {deals.filter((d) => !claimsByDeal.has(d.dealId)).map((d) => (
                  <option key={d.dealId} value={d.dealId}>{d.title}</option>
                ))}
              </optgroup>
            </select>
          </label>
        </div>
        {effectiveDealId ? (
          <DealNeedsReview
            key={effectiveDealId}
            dealId={effectiveDealId}
            eventTypes={[]}
            onChanged={loadPendingReviewClaims}
          />
        ) : (
          <p className="text-sm text-avcs-muted">No deals yet.</p>
        )}
      </section>
    );
  };

  // Step 1 of the deal creation workflow. Later steps (parties & documents,
  // animals & pricing, health & feeding — see the deal capture redesign spec)
  // will slot in behind the stepper below.
  // After a slaughter: the abattoir's settlement or invoice, and what it paid.
  const renderNdSlaughterSale = () => {
    if (!ndCreatedDeal) return null;
    const saleType = dealDocumentTypeOptions.find((o) => o.financeRecordType === 'SALE');
    const input = 'h-[42px] w-full rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm';
    const canSave = Boolean(ndSaleForm.value.trim() && Number(ndSaleForm.value) > 0 && ndSaleForm.file && ndSaleForm.date) && !ndSavingSale;
    const save = async () => {
      if (!canSave || !ndSaleForm.file) return;
      if (!saleType) { setNdSaleError('No document type is set up to book a sale. Add one under document types first.'); return; }
      setNdSavingSale(true);
      setNdSaleError('');
      try {
        await uploadDealDocument({
          dealId: ndCreatedDeal.id,
          documentType: saleType.id,
          file: ndSaleForm.file,
          dateOfDocument: ndSaleForm.date,
          saleValue: ndSaleForm.value.trim(),
          party: '',
          visibility: 'ALL',
          notes: 'Slaughter sale invoice',
        });
        setCaptureNotice(`Slaughter sale of R ${Number(ndSaleForm.value).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} recorded and the invoice filed.`);
        setNdSlaughterSale(false);
        refreshNdRequirements(ndCreatedDeal.id);
        refreshNdDealStats(ndCreatedDeal.id);
      } catch (error: any) {
        setNdSaleError(parseApiError(error?.message) || error?.message || 'Could not record the sale.');
      } finally {
        setNdSavingSale(false);
      }
    };
    return (
      <div className="mx-auto flex w-full max-w-2xl flex-col items-center px-2 pt-3 md:pt-6">
        <p className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Deal {ndCreatedDeal.label} · Slaughter</p>
        <h3 className="mt-3 text-center text-3xl font-semibold text-avcs-text">What did the slaughter earn?</h3>
        <p className="mt-2 text-center text-sm text-avcs-muted">
          Upload the abattoir’s settlement or invoice and enter the amount it paid, excluding VAT. It is booked to the deal as revenue.
        </p>
        {ndSaleError && (
          <div role="alert" className="mt-5 w-full rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{ndSaleError}</div>
        )}
        <div className="mt-6 grid w-full items-start gap-x-4 gap-y-2 md:grid-cols-2">
          <label className="grid content-start gap-1 text-sm text-avcs-text">
            Sale value (excl VAT)
            <input type="number" min="0" step="0.01" className={input} value={ndSaleForm.value} onChange={(e) => setNdSaleForm((f) => ({ ...f, value: e.target.value }))} />
            <span className="min-h-4 text-xs text-avcs-muted">The total on the invoice, before VAT.</span>
          </label>
          <label className="grid content-start gap-1 text-sm text-avcs-text">
            Invoice date
            <input type="date" className={input} value={ndSaleForm.date} onChange={(e) => setNdSaleForm((f) => ({ ...f, date: e.target.value }))} />
            <span className="min-h-4 text-xs text-avcs-muted">The date on the invoice.</span>
          </label>
          <div className="grid content-start gap-1 text-sm text-avcs-text md:col-span-2">
            Invoice or settlement
            {ndSaleForm.file ? (
              <span className="inline-flex h-[42px] items-center justify-between gap-2 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 text-sm font-semibold text-[#106b38]">
                <span className="truncate" title={ndSaleForm.file.name}>{ndSaleForm.file.name} ✓</span>
                <button type="button" className="text-xs font-semibold text-avcs-muted hover:text-[#6b1010]" onClick={() => setNdSaleForm((f) => ({ ...f, file: null }))}>Remove</button>
              </span>
            ) : (
              <span className="relative inline-flex h-[42px] cursor-pointer items-center justify-center rounded-lg border border-dashed border-[#1e6bb84d] bg-[#f7fbff] px-3 text-sm font-semibold text-[#0f3b64] hover:bg-[#edf5ff]">
                Upload the invoice or settlement
                <input type="file" className="absolute inset-0 h-full w-full cursor-pointer opacity-0" onChange={(e) => { const file = e.target.files?.[0] || null; setNdSaleForm((f) => ({ ...f, file })); e.target.value = ''; }} />
              </span>
            )}
          </div>
        </div>
        {wizardFooter(
          <div className="flex w-full flex-wrap items-center justify-between gap-3">
            <button type="button" className="btn" onClick={() => setNdSlaughterSale(false)}>Skip for now</button>
            <button type="button" className="btn primary" disabled={!canSave} onClick={save}>
              {ndSavingSale ? 'Saving…' : 'Save the sale'}
            </button>
          </div>,
        )}
      </div>
    );
  };

  // Step 7: every document the deal still needs, in one place.
  const renderNdDocumentsStep = () => {
    if (!ndCreatedDeal) return null;
    const documentRows = ndRequirements.filter((r) => r.kind !== 'FIELD');
    const groups = [
      { key: 'SELLER', title: 'The seller', rows: documentRows.filter((r) => r.party === 'SELLER') },
      { key: 'PURCHASER', title: 'The purchaser', rows: documentRows.filter((r) => r.party === 'PURCHASER') },
      { key: 'DEAL', title: 'This deal', rows: documentRows.filter((r) => !r.party) },
    ].filter((group) => group.rows.length > 0);
    const filed = documentRows.filter((r) => r.satisfied).length;
    const allFiled = documentRows.length > 0 && filed === documentRows.length;

    return (
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-2 pt-3 md:pt-6">
        <p className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Deal {ndCreatedDeal.label} · Documents</p>
        <h3 className="mt-3 text-center text-3xl font-semibold text-avcs-text">
          {allFiled ? 'Every required document is in' : 'Which documents are still needed?'}
        </h3>
        <p className="mt-2 text-center text-sm text-avcs-muted">
          {documentRows.length === 0
            ? 'No documents are required yet.'
            : `${filed} of ${documentRows.length} filed. A document filed once on the seller’s or purchaser’s own record counts here automatically.`}
        </p>

        {ndStep7Error && (
          <div role="alert" className="mt-5 w-full rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{ndStep7Error}</div>
        )}

        <div className="mt-6 grid w-full gap-6">
          {groups.map((group) => (
            <div key={group.key}>
              <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-avcs-muted">{group.title}</p>
              <div className="grid gap-2">
                {group.rows.map((row) => renderNdRequirementRow(row, setNdStep7Error))}
              </div>
            </div>
          ))}
        </div>

        {wizardFooter(
          <div className="flex w-full flex-wrap items-center justify-between gap-3">
            <button type="button" className="btn" onClick={() => setNdStep(6)}>← Transportation</button>
            <span className="max-w-md text-xs text-avcs-muted">Anything still missing can be uploaded later from the deal; it must be in before the deal can be closed.</span>
            <button type="button" className="btn primary" onClick={() => setNdStep('done')}>Finish →</button>
          </div>,
        )}
      </div>
    );
  };

  // The journey as a short sequence of screens inside step 6 (same fields and
  // the same save as the Transport screen's Add journey form).
  const renderNdJourneyWizard = () => {
    const stage = ndJourneyStage;
    const dealId = ndCreatedDeal?.id || '';
    const f = documentForm;
    const setF = (patch: Partial<typeof documentForm>) => setDocumentForm((prev) => ({ ...prev, ...patch }));
    const stages = [
      { title: 'Which delivery?', hint: 'The receive event this journey belongs to, and when it happened.' },
      { title: 'Who carried the animals?', hint: 'The transporter and the truck.' },
      { title: 'How far did they travel?', hint: 'The odometer readings, and any animals lost on the way.' },
      { title: 'What did the transport cost?', hint: 'The cost, and the invoice or waybill that backs it.' },
      { title: 'Paperwork', hint: 'The removal certificate is required on every journey.' },
    ];
    const taken = new Set(ndDealJourneys.map((j: any) => String(j.dealEventId || '')));
    const openEvents = allReceiveEvents.filter((o) => o.dealId === dealId && !taken.has(o.id));
    const input = 'h-[42px] w-full rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm';
    const field = (label: string, control: React.ReactNode, help = '', span2 = false) => (
      <label className={`grid content-start gap-1 text-sm text-avcs-text ${span2 ? 'md:col-span-2' : ''}`}>
        {label}
        {control}
        <span className="min-h-4 text-xs text-avcs-muted">{help}</span>
      </label>
    );
    const fileButton = (label: string, file: File | null, onPick: (file: File | null) => void) => (
      file ? (
        <span className="inline-flex h-[42px] items-center justify-between gap-2 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 text-sm font-semibold text-[#106b38]">
          <span className="truncate" title={file.name}>{file.name} ✓</span>
          <button type="button" className="text-xs font-semibold text-avcs-muted hover:text-[#6b1010]" onClick={() => onPick(null)}>Remove</button>
        </span>
      ) : (
        <span className="relative inline-flex h-[42px] cursor-pointer items-center justify-center rounded-lg border border-dashed border-[#1e6bb84d] bg-[#f7fbff] px-3 text-sm font-semibold text-[#0f3b64] hover:bg-[#edf5ff]">
          {label}
          <input type="file" className="absolute inset-0 h-full w-full cursor-pointer opacity-0" onChange={(e) => { onPick(e.target.files?.[0] || null); e.target.value = ''; }} />
        </span>
      )
    );
    const problem = (text: string) => setDocumentUploadError(text);
    const next = () => {
      setDocumentUploadError('');
      if (stage === 0 && !f.dealEventId) return problem('Choose the receive event this journey belongs to.');
      if (stage === 1 && (!f.courierId || !f.vehicleRegistration.trim())) return problem('Choose the courier and enter the vehicle registration.');
      if (stage === 2) {
        if (f.startKm === '' || f.endKm === '') return problem('Enter the start and end kilometre readings.');
        if (Number(f.endKm) <= Number(f.startKm)) return problem('End KM must be greater than start KM.');
      }
      setNdJourneyStage(stage + 1);
    };
    const docKind = transportJourneyDocType || 'invoice';

    return (
      <div className="mx-auto flex w-full max-w-2xl flex-col items-center px-2 pt-3 md:pt-6">
        <p className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">
          Deal {ndCreatedDeal?.label} · Journey · {stage + 1} of {stages.length}
        </p>
        <h3 className="mt-3 text-center text-3xl font-semibold text-avcs-text">{stages[stage].title}</h3>
        <p className="mt-2 text-center text-sm text-avcs-muted">{stages[stage].hint}</p>
        <div className="mt-3 flex items-center gap-2" aria-hidden="true">
          {stages.map((_, index) => (
            <span key={index} className={`h-2.5 rounded-full ${index === stage ? 'w-8 bg-[#1e6bb8]' : index < stage ? 'w-2.5 bg-[#7fb3e0]' : 'w-2.5 bg-[#1e6bb824]'}`} />
          ))}
        </div>

        {documentUploadError && (
          <div role="alert" className="mt-5 w-full rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{documentUploadError}</div>
        )}

        <div className="mt-6 grid w-full items-start gap-x-4 gap-y-2 md:grid-cols-2">
          {stage === 0 && (
            <>
              <div className="grid content-start gap-2 text-sm text-avcs-text md:col-span-2">
                <span>Receive event{openEvents.length > 1 ? 's' : ''} *</span>
                {openEvents.length === 0 ? (
                  <p className="rounded-lg border border-[#1e6bb824] bg-[#f8fafc] px-3 py-3 text-sm text-avcs-muted">
                    {loadingReceiveEvents ? 'Loading…' : 'No receive event without a journey. Capture a receive event first (on the previous screen).'}
                  </p>
                ) : (
                  <div className="grid gap-2">
                    {openEvents.map((o) => {
                      const chosen = o.id === f.dealEventId || journeyExtraEvents.some((ev) => ev.id === o.id);
                      return (
                        <label
                          key={o.id}
                          className={`flex cursor-pointer items-center gap-3 rounded-lg border px-3 py-2.5 ${chosen ? 'border-[#1e6bb8] bg-[#edf5ff]' : 'border-[#1e6bb833] bg-white hover:bg-[#f7fbff]'}`}
                        >
                          <input
                            type="checkbox"
                            checked={chosen}
                            onChange={() => {
                              // First ticked event anchors the form; the rest ride along as extra legs.
                              const ids = [f.dealEventId, ...journeyExtraEvents.map((ev) => ev.id)].filter(Boolean);
                              const nextIds = chosen ? ids.filter((id) => id !== o.id) : [...ids, o.id];
                              const [first, ...rest] = nextIds;
                              setF({ dealId, dealEventId: first || '', dispatchEventId: '' });
                              setJourneyExtraEvents(rest.map((id) => openEvents.find((ev) => ev.id === id)).filter(Boolean) as ReceiveEventOption[]);
                            }}
                          />
                          <span>{o.label}</span>
                        </label>
                      );
                    })}
                  </div>
                )}
                <span className="min-h-4 text-xs text-avcs-muted">
                  {journeyExtraEvents.length > 0
                    ? `${journeyExtraEvents.length + 1} receive events ticked. One journey is saved for each, with the cost split by head.`
                    : openEvents.length > 1 ? 'Tick every receive event this truck delivered.' : ''}
                </span>
              </div>
              {transportDispatchEventOptions.length > 0 && (
                <div className="rounded-lg border border-[#1e6bb81a] bg-[#f8fafc] px-3 py-2.5 text-sm md:col-span-2">
                  <p className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Dispatched as</p>
                  {transportDispatchEventOptions.map((o) => (
                    <p key={o.id} className="mt-1 text-avcs-text">{o.label}{(o as any).location ? ` — ${(o as any).location}` : ''}</p>
                  ))}
                  <p className="mt-1 text-xs text-avcs-muted">AVCS links the journey to its dispatch for you.</p>
                </div>
              )}
              {field('Loading date', <input type="date" className={input} value={f.dateOfDocument} onChange={(e) => setF({ dateOfDocument: e.target.value })} />)}
              {field('Loading time', <input type="time" className={input} value={f.loadingTime} onChange={(e) => setF({ loadingTime: e.target.value })} />)}
              {field('Offloading date', <input type="date" className={input} value={f.offloadingDate} onChange={(e) => setF({ offloadingDate: e.target.value })} />)}
            </>
          )}

          {stage === 1 && (
            <>
              {field('Courier *', (
                <span className="flex gap-2">
                  <select className={`${input} min-w-0 flex-1`} value={f.courierId} onChange={(e) => setF({ courierId: e.target.value })}>
                    <option value="">Choose the courier…</option>
                    {couriers.map((c) => (<option key={c.id} value={c.id}>{c.name}</option>))}
                  </select>
                  <button type="button" className="btn shrink-0" style={{ height: 42 }} onClick={() => { resetCourierForm(); setShowAddCourierForm(true); }}>+ New</button>
                </span>
              ), '', true)}
              {field('Vehicle registration *', <input className={input} value={f.vehicleRegistration} onChange={(e) => setF({ vehicleRegistration: e.target.value })} />)}
              {field('Driver name', <input className={input} value={f.driverName} onChange={(e) => setF({ driverName: e.target.value })} />)}
              {field('Driver contact', <input className={input} value={f.driverContact} onChange={(e) => setF({ driverContact: e.target.value })} />)}
            </>
          )}

          {stage === 2 && (
            <>
              {field('Start KM *', <input type="number" min="0" step="0.01" className={input} value={f.startKm} onChange={(e) => setF({ startKm: e.target.value })} />, 'Odometer when the truck left.')}
              {field('End KM *', <input type="number" min="0" step="0.01" className={input} value={f.endKm} onChange={(e) => setF({ endKm: e.target.value })} />,
                f.startKm !== '' && f.endKm !== '' && Number(f.endKm) > Number(f.startKm) ? `${(Number(f.endKm) - Number(f.startKm)).toLocaleString('en-ZA')} km travelled.` : 'Odometer when it arrived.')}
              {field('Animals down / DOA', <input type="number" min="0" className={input} value={f.animalsDown} onChange={(e) => setF({ animalsDown: e.target.value })} />, 'Leave blank if none.')}
              {f.animalsDown !== '' && Number(f.animalsDown) > 0 && field('Reason for injury / DOA', <input className={input} value={f.animalsDownReason} onChange={(e) => setF({ animalsDownReason: e.target.value })} />)}
            </>
          )}

          {stage === 3 && (
            <>
              {field('Transport cost (excl VAT)', <input type="number" min="0" step="0.01" className={input} value={f.totalCost} onChange={(e) => setF({ totalCost: e.target.value })} />, 'The amount on the transporter’s invoice.')}
              {field('Waybill number', <input className={input} value={f.referenceNumber} onChange={(e) => setF({ referenceNumber: e.target.value })} />, 'Optional.')}
              <div className="grid content-start gap-1 text-sm text-avcs-text md:col-span-2">
                Document
                <div className="flex flex-wrap items-center gap-3">
                  <span className="flex gap-1 rounded-lg border border-[#1e6bb833] p-0.5">
                    {(['invoice', 'waybill'] as const).map((kind) => (
                      <button
                        key={kind}
                        type="button"
                        className={`rounded-md px-3 py-1.5 text-xs font-semibold ${docKind === kind ? 'bg-[#1e6bb8] text-white' : 'text-avcs-muted hover:text-avcs-text'}`}
                        onClick={() => { setTransportJourneyDocType(kind); setTransportJourneyDocFile(null); }}
                      >
                        {kind === 'invoice' ? 'Invoice' : 'Waybill'}
                      </button>
                    ))}
                  </span>
                  <span className="min-w-[14rem] flex-1">
                    {fileButton(`Upload the ${docKind}`, transportJourneyDocFile, (file) => { if (file && !transportJourneyDocType) setTransportJourneyDocType('invoice'); setTransportJourneyDocFile(file); })}
                  </span>
                </div>
                <span className="min-h-4 text-xs text-avcs-muted">Optional. It is filed against the journey.</span>
              </div>
            </>
          )}

          {stage === 4 && (
            <>
              <div className="grid content-start gap-1 text-sm text-avcs-text md:col-span-2">
                Removal certificate (Stock Theft Act 1959, s8(1)) *
                {fileButton('Upload the removal certificate', journeyRemovalCertFile, setJourneyRemovalCertFile)}
                <span className="min-h-4 text-xs text-avcs-muted">The deal cannot be completed while a journey is missing it. You can also add it later.</span>
              </div>
              <details className="mt-2 w-full rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3 md:col-span-2">
                <summary className="cursor-pointer text-sm font-semibold text-avcs-text">Weighbridge reading (optional)</summary>
                <div className="mt-3 grid items-start gap-x-4 gap-y-2 md:grid-cols-2">
                  {field('Gross weight (kg)', <input type="number" min="0" step="0.01" className={input} value={weighbridgeForm.grossWeightKg} onChange={(e) => setWeighbridgeForm((prev) => ({ ...prev, grossWeightKg: e.target.value }))} />, 'Truck and animals, loaded.')}
                  {field('Tare weight (kg)', <input type="number" min="0" step="0.01" className={input} value={weighbridgeForm.tareWeightKg} onChange={(e) => setWeighbridgeForm((prev) => ({ ...prev, tareWeightKg: e.target.value }))} />, 'The empty truck.')}
                  {field('Recorded at', <input type="datetime-local" className={input} value={weighbridgeForm.recordedAt} onChange={(e) => setWeighbridgeForm((prev) => ({ ...prev, recordedAt: e.target.value }))} />, 'Needed with a weight.')}
                  {field('Notes', <input className={input} value={weighbridgeForm.notes} onChange={(e) => setWeighbridgeForm((prev) => ({ ...prev, notes: e.target.value }))} />)}
                </div>
              </details>
            </>
          )}
        </div>

        {wizardFooter(
          <div className="flex w-full flex-wrap items-center justify-between gap-3">
            {stage === 0 ? (
              <button type="button" className="btn" onClick={closeNdJourneyCapture}>← Transportation</button>
            ) : (
              <button type="button" className="btn" onClick={() => { setDocumentUploadError(''); setNdJourneyStage(stage - 1); }}>← Back</button>
            )}
            {stage < stages.length - 1 ? (
              <button type="button" className="btn primary" onClick={next}>Next: {stages[stage + 1].title.replace(/\?$/, '').toLowerCase()} →</button>
            ) : (
              <button
                type="button"
                className="btn primary"
                disabled={uploadingDocument}
                onClick={() => submitTransportJourneyOnly({ preventDefault() { /* no form */ } } as React.FormEvent)}
              >
                {uploadingDocument ? 'Saving…' : 'Save journey'}
              </button>
            )}
          </div>,
        )}
      </div>
    );
  };

  // The event-capture form as a screen of the wizard (not an overlay).
  const renderInlineCapturePanel = (areaLabel: string, backLabel: string) => {
    const copy = ND_EVENT_KIND_COPY[ndEventModalKind] || ND_EVENT_KIND_COPY.DEFAULT;
    return (
      <div className="mx-auto w-full max-w-5xl pt-2">
        <div className="mb-4 flex flex-wrap items-start justify-between gap-2">
          <div className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">
              {ndCreatedDeal ? `Deal ${ndCreatedDeal.label} · ` : ''}{areaLabel}
            </p>
            <h3 className="mt-1 text-2xl font-semibold text-avcs-text">{copy.title}</h3>
            <p className="mt-1 max-w-2xl text-sm text-avcs-muted">{copy.hint}</p>
          </div>
          <button type="button" className="btn" onClick={closeNdEventCapture}>{backLabel}</button>
        </div>
        {renderDataSessionUpload()}
      </div>
    );
  };

  const renderNewDealFlow = () => {
    // Position in the flow, so each chip's state is "done" for anything behind
    // the active step without spelling every comparison out.
    const stepIndex = ndStep === 'done' ? 99 : ndStep;
    const stepState = (n: number) => (ndStep === n ? 'active' : stepIndex > n ? 'done' : 'upcoming');
    const flowSteps = [
      { label: 'Deal details', state: stepState(1) },
      { label: 'Seller & purchaser', state: stepState(2) },
      { label: 'Animals & pricing', state: stepState(3) },
      { label: 'Movement & events', state: stepState(4) },
      { label: 'Health & feeding', state: stepState(5) },
      { label: 'Transportation', state: stepState(6) },
      { label: 'Deal documents', state: stepState(7) },
    ];
    const activeChains = valueChains.filter((vc) => vc.isActive);
    const selectedChain = ndValueChainId ? valueChains.find((vc) => vc.id === ndValueChainId) : undefined;

    // What this deal's Supply Chain Program asks of it. A Deal Matrix deal
    // (no chain) resolves to OPTIONAL throughout, which is the behaviour that
    // existed before programs could configure anything — so an unconfigured
    // flow looks exactly as it did.
    const ndFieldState = (key: string): FieldRequirementState =>
      selectedChain?.fieldRequirements?.[key] ?? 'OPTIONAL';
    /** False when the program does not capture this field at all. */
    const ndShows = (key: string) => ndFieldState(key) !== 'HIDDEN';
    /** The asterisk a required field carries in its label. */
    const ndMark = (key: string) => (ndFieldState(key) === 'REQUIRED' ? ' *' : '');
    const producerResults = (ndProducerSearch.trim()
      ? entityDirectory.filter((e) => e.entityName?.toLowerCase().includes(ndProducerSearch.toLowerCase()))
      : entityDirectory
    ).slice(0, 8);

    return (
      <section className="avcs-wizard rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
        <div className="admin-section-head mb-4 flex flex-wrap items-center justify-between gap-2">
          <h2 className="text-2xl font-semibold text-avcs-text">New deal</h2>
          <div className="flex flex-wrap items-center gap-2">
            {/* One click, no questions: the deal already created stays saved and can
                be reopened from the deal list. */}
            <button className="admin-inline-action btn" type="button" onClick={resetNewDealFlow}>New deal</button>
            {/* Everything saved so far is on the deal already — leaving loses
                nothing. With a deal created the exit lands on View deal, where
                the remaining steps can be finished tab by tab; before that it
                goes back to the deal list. */}
            <button
              className="admin-inline-action btn"
              type="button"
              title={ndCreatedDeal ? `Leave the wizard and open deal ${ndCreatedDeal.label}` : 'Leave the wizard'}
              onClick={() => {
                const created = ndCreatedDeal;
                resetNewDealFlow();
                if (created) {
                  setSelectedDealId(created.id);
                  setView('dealSummary');
                } else {
                  setView('dealList');
                }
              }}
            >
              Exit wizard
            </button>
          </div>
        </div>

        <ol className="mb-5 flex flex-wrap items-center gap-2">
          {flowSteps.map((step, index) => {
            // Once the deal exists every later step is reachable directly, so a
            // resumed deal can jump to the step it needs instead of clicking
            // through the ones before it. Step 1 only ever creates the deal.
            const chipTarget = index + 1;
            const chipClickable = Boolean(ndCreatedDeal) && ndStep !== 'done' && chipTarget >= 2 && ndStep !== chipTarget;
            const ChipTag: any = chipClickable ? 'button' : 'span';
            return (
            <li key={step.label} className="flex items-center gap-2">
              <ChipTag
                {...(chipClickable ? {
                  type: 'button',
                  title: `Go to ${step.label}`,
                  onClick: () => {
                    if (!ndCreatedDeal) return;
                    setNdStep(chipTarget as 2 | 3 | 4 | 5 | 6 | 7);
                    if (chipTarget === 7) refreshNdRequirements(ndCreatedDeal.id);
                    if (chipTarget === 3) refreshNdDealStats(ndCreatedDeal.id);
                    if (chipTarget === 4) refreshNdEvents(ndCreatedDeal.id);
                    if (chipTarget === 6) refreshNdJourneys(ndCreatedDeal.id);
                  },
                } : {})}
                className={`flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-semibold ${chipClickable ? 'cursor-pointer hover:border-[#1e6bb8]' : ''} ${
                  step.state === 'active'
                    ? 'border-[#1e6bb8] bg-[#edf5ff] text-[#0f3b64]'
                    : step.state === 'done'
                      ? 'border-[#b9e7c9] bg-[#e7f8ee] text-[#106b38]'
                      : 'border-[#1e6bb824] bg-[#f8fafc] text-avcs-muted'
                }`}
              >
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-white text-[11px] font-bold">
                  {step.state === 'done' ? '✓' : index + 1}
                </span>
                {step.label}
              </ChipTag>
              {index < flowSteps.length - 1 && <span className="text-avcs-muted" aria-hidden="true">›</span>}
            </li>
            );
          })}
        </ol>

        {/* The step scrolls inside the card, so the header and stage chips stay
            put and the action buttons at the foot of a long step are never jammed
            against the card edge. */}
        <div className="avcs-wizard-body">
        {renderCaptureNotice()}

        {ndStep === 'done' && ndCreatedDeal ? (
          <div className="rounded-xl border border-[#b9e7c9] bg-[#e7f8ee] px-4 py-4">
            <p className="text-base font-semibold text-[#106b38]">Deal {ndCreatedDeal.label} captured — status Active.</p>
            <p className="mt-1 text-sm text-[#106b38]">
              All seven steps are done. Continue on the deal overview (events, documents, finances).
              Outstanding documents can be uploaded there at any time; the deal cannot be closed
              until they are all in.
            </p>
            {/* Required capture fields this program demands that are still
                empty. Documents have their own per-step upload slots; a field
                has nowhere else to be reported, so an operator would otherwise
                only discover it when closing the deal failed. */}
            {(() => {
              const missingFields = ndRequirements.filter((r) => r.kind === 'FIELD' && !r.satisfied);
              if (missingFields.length === 0) return null;
              return (
                <div className="mt-3 rounded-lg border border-[#ecd1b9] bg-[#fff7ef] px-3 py-2">
                  <p className="text-sm font-semibold text-[#7b4a18]">
                    Still required by this Supply Chain Program before the deal can be closed:
                  </p>
                  <ul className="mt-1 list-disc pl-5 text-sm text-[#7b4a18]">
                    {missingFields.map((requirement) => (
                      <li key={requirement.code}>{requirement.label}</li>
                    ))}
                  </ul>
                </div>
              );
            })()}
            <div className="mt-3 flex flex-wrap gap-2">
              <button
                type="button"
                className="btn primary"
                onClick={() => { setSelectedDealId(ndCreatedDeal.id); setView('dealSummary'); }}
              >
                Open the deal
              </button>
              <button type="button" className="btn" onClick={() => setNdStep(2)}>Back to seller & purchaser</button>
              <button type="button" className="btn" onClick={resetNewDealFlow}>Capture another deal</button>
            </div>
          </div>
        ) : ndStep === 2 && ndCreatedDeal ? (
          (() => {
            const dealIsScpFlow = ndValueChainId
              ? Boolean(valueChains.find((vc) => vc.id === ndValueChainId)?.isScp)
              : false;
            const sellerEntity = entityDirectory.find((entity) => entity.id === ndProducerId) || null;
            const purchaserEntity = entityDirectory.find((entity) => entity.id === ndPurchaserId) || null;
            const sellerResults = (ndSellerSearch.trim()
              ? entityDirectory.filter((e) => e.entityName?.toLowerCase().includes(ndSellerSearch.toLowerCase()))
              : entityDirectory
            ).slice(0, 8);
            const purchaserResults = (ndPurchaserSearch.trim()
              ? entityDirectory.filter((e) => e.entityName?.toLowerCase().includes(ndPurchaserSearch.toLowerCase()))
              : entityDirectory
            ).slice(0, 8);

            // Display-only card for a selected party entity — editing happens
            // on the entity screen, so the flow can never disagree with it.
            const renderNdEntityDetails = (entity: any) => {
              const contacts = Array.isArray(entity?.contacts) ? entity.contacts : [];
              const contact = contacts.find((c: any) => c?.isPrimary) || contacts[0];
              const address = [entity.addressLine1, entity.addressLine2, entity.city, entity.postalCode]
                .filter((part: any) => part && String(part).trim())
                .join(', ');
              const dash = (value?: string | null) => (value && String(value).trim() ? String(value) : '—');
              const rows: Array<[string, string]> = [
                ['Entity no', dash(entity.entityNo)],
                ['Type', entity.entityType === 'OTHER' && entity.entityTypeOther ? `Other — ${entity.entityTypeOther}` : dash(entity.entityType)],
                ['Individual / Entity', entity.partyKind === 'INDIVIDUAL' ? 'Individual' : entity.partyKind === 'ENTITY' ? 'Entity' : '—'],
                [entity.partyKind === 'INDIVIDUAL' ? 'ID number' : 'Registration number', dash(entity.identityNumber)],
                ['Farm name', dash(entity.farmName)],
                ['District', dash(entity.district)],
                ['Province', dash(entity.province)],
                ['Address', address || '—'],
                ['VAT registered', entity.vatRegistered ? `Yes${entity.vatNumber ? ` — ${entity.vatNumber}` : ''}` : 'No'],
                ['GLN applicable', entity.glnApplicable ? 'Yes' : 'No'],
                ['Contact', contact ? [contact.name, contact.phoneNo, contact.email].filter(Boolean).join(' · ') : '—'],
              ];
              return (
                <div className="mt-3 rounded-lg border border-[#1e6bb81a] bg-white p-3">
                  <div className="grid gap-x-4 gap-y-2 sm:grid-cols-2 md:grid-cols-3">
                    {rows.map(([label, value]) => (
                      <div key={label}>
                        <span className="block text-xs font-semibold uppercase tracking-wide text-avcs-muted">{label}</span>
                        <span className="text-sm text-avcs-text">{value}</span>
                      </div>
                    ))}
                  </div>
                  <div className="mt-3 flex flex-wrap items-center justify-between gap-2 border-t border-[#1e6bb812] pt-2">
                    <span className="text-xs text-avcs-muted">Display only — editing happens on the entity screen.</span>
                    <button type="button" className="admin-inline-action btn" onClick={() => openEditEntityForm(entity)}>
                      Open entity screen
                    </button>
                  </div>
                </div>
              );
            };

            const renderNdCreateForm = (
              side: 'SELLER' | 'PURCHASER',
              form: NdPartyForm,
              setForm: React.Dispatch<React.SetStateAction<NdPartyForm>>,
            ) => {
              const isSeller = side === 'SELLER';
              const set = (patch: Partial<NdPartyForm>) => setForm((prev) => ({ ...prev, ...patch }));
              const typeOptions: Array<[string, string]> = isSeller
                ? [['FARM', 'Primary producer'], ['FEEDLOT', 'Feedlot'], ['OTHER', 'Other']]
                : [['FARM', 'Primary producer'], ['FEEDLOT', 'Feedlot'], ['ABATTOIR', 'Abattoir'], ['OTHER', 'Other']];
              return (
                <div className="mt-3 grid gap-3 md:grid-cols-2">
                  <label className="grid gap-1 text-sm text-avcs-text">
                    Type *
                    <select
                      className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                      value={form.entityType}
                      onChange={(event) => set({ entityType: event.target.value })}
                    >
                      {typeOptions.map(([value, label]) => (
                        <option key={value} value={value}>{label}</option>
                      ))}
                    </select>
                  </label>
                  {form.entityType === 'OTHER' && (
                    <label className="grid gap-1 text-sm text-avcs-text">
                      Other — specify *
                      <input
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                        value={form.entityTypeOther}
                        onChange={(event) => set({ entityTypeOther: event.target.value })}
                      />
                    </label>
                  )}
                  <label className="grid gap-1 text-sm text-avcs-text">
                    Individual / Entity
                    <select
                      className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                      value={form.partyKind}
                      onChange={(event) => set({ partyKind: event.target.value as NdPartyForm['partyKind'] })}
                    >
                      <option value="">Not established yet</option>
                      <option value="INDIVIDUAL">Individual</option>
                      <option value="ENTITY">Entity</option>
                    </select>
                    <span className="text-xs text-avcs-muted">
                      Decides the identity document owed: an ID copy, or the CIPC registration.
                    </span>
                  </label>
                  <label className="grid gap-1 text-sm text-avcs-text">
                    {form.partyKind === 'INDIVIDUAL' ? 'Individual name *' : 'Entity name *'}
                    <input
                      className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                      value={form.entityName}
                      onChange={(event) => set({ entityName: event.target.value })}
                    />
                  </label>
                  <label className="grid gap-1 text-sm text-avcs-text">
                    {form.partyKind === 'INDIVIDUAL' ? 'ID number' : 'Entity registration number'}
                    <input
                      className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                      value={form.identityNumber}
                      onChange={(event) => set({ identityNumber: event.target.value })}
                    />
                  </label>
                  <label className="grid gap-1 text-sm text-avcs-text">
                    Farm name
                    <input
                      className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                      value={form.farmName}
                      onChange={(event) => set({ farmName: event.target.value })}
                    />
                  </label>
                  <label className="grid gap-1 text-sm text-avcs-text">
                    Address line 1
                    <input
                      className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                      value={form.addressLine1}
                      onChange={(event) => set({ addressLine1: event.target.value })}
                    />
                  </label>
                  <label className="grid gap-1 text-sm text-avcs-text">
                    Address line 2
                    <input
                      className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                      value={form.addressLine2}
                      onChange={(event) => set({ addressLine2: event.target.value })}
                    />
                  </label>
                  <label className="grid gap-1 text-sm text-avcs-text">
                    City / town
                    <input
                      className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                      value={form.city}
                      onChange={(event) => set({ city: event.target.value })}
                    />
                  </label>
                  <label className="grid gap-1 text-sm text-avcs-text">
                    Postal code
                    <input
                      className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                      value={form.postalCode}
                      onChange={(event) => set({ postalCode: event.target.value })}
                    />
                  </label>
                  <label className="grid gap-1 text-sm text-avcs-text">
                    District
                    <input
                      className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                      value={form.district}
                      onChange={(event) => set({ district: event.target.value })}
                    />
                  </label>
                  <label className="grid gap-1 text-sm text-avcs-text">
                    Province
                    <input
                      className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                      value={form.province}
                      onChange={(event) => set({ province: event.target.value })}
                    />
                  </label>
                  {isSeller && (
                    <>
                      <label className="flex items-start gap-2 text-sm text-avcs-text">
                        <input
                          type="checkbox"
                          className="mt-0.5"
                          checked={form.vatRegistered}
                          onChange={(event) => set({ vatRegistered: event.target.checked })}
                        />
                        <span>
                          VAT registered
                          <span className="block text-xs text-avcs-muted">If yes, the VAT number and certificate are required.</span>
                        </span>
                      </label>
                      {form.vatRegistered && (
                        <label className="grid gap-1 text-sm text-avcs-text">
                          VAT number *
                          <input
                            className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                            value={form.vatNumber}
                            onChange={(event) => set({ vatNumber: event.target.value })}
                          />
                        </label>
                      )}
                    </>
                  )}
                  <label className="flex items-start gap-2 text-sm text-avcs-text md:col-span-2">
                    <input
                      type="checkbox"
                      className="mt-0.5"
                      checked={form.glnApplicable}
                      onChange={(event) => set({ glnApplicable: event.target.checked })}
                    />
                    <span>
                      GLN applicable to the transaction
                      <span className="block text-xs text-avcs-muted">
                        {dealIsScpFlow
                          ? 'This is an SCP deal, so a GLN certificate is required regardless.'
                          : 'Ticked, a GLN certificate joins the required documents.'}
                      </span>
                    </span>
                  </label>
                  <div className="md:col-span-2 grid gap-3 md:grid-cols-3 rounded-lg border border-[#1e6bb81a] bg-[#f8fafc] p-3">
                    <label className="grid gap-1 text-sm text-avcs-text">
                      Contact name
                      <input
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                        value={form.contactName}
                        onChange={(event) => set({ contactName: event.target.value })}
                      />
                    </label>
                    <label className="grid gap-1 text-sm text-avcs-text">
                      Cell
                      <input
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                        value={form.contactCell}
                        onChange={(event) => set({ contactCell: event.target.value })}
                      />
                    </label>
                    <label className="grid gap-1 text-sm text-avcs-text">
                      Email
                      <input
                        type="email"
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                        value={form.contactEmail}
                        onChange={(event) => set({ contactEmail: event.target.value })}
                      />
                    </label>
                  </div>
                  <div className="md:col-span-2">
                    <button
                      type="button"
                      className="btn primary"
                      disabled={ndCreatingEntity !== ''}
                      onClick={() => createNdPartyEntity(side)}
                    >
                      {ndCreatingEntity === side ? 'Creating entity…' : 'Create entity'}
                    </button>
                  </div>
                </div>
              );
            };

            const renderNdAgentBlock = (
              side: 'SELLER' | 'PURCHASER',
              agent: { enabled: boolean; name: string; contact: string },
              setAgent: React.Dispatch<React.SetStateAction<{ enabled: boolean; name: string; contact: string }>>,
            ) => {
              const prefix = side === 'SELLER' ? 'seller_agent' : 'purchaser_agent';
              const nameCode = `${prefix}_name`;
              const contactCode = `${prefix}_contact`;
              // Both halves hidden means the program does not deal through
              // agents at all — drop the question, not just the answers.
              if (!ndShows(nameCode) && !ndShows(contactCode)) return null;
              return (
                <div className="mt-3 grid gap-3 md:grid-cols-2">
                  <label className="flex items-start gap-2 text-sm text-avcs-text md:col-span-2">
                    <input
                      type="checkbox"
                      className="mt-0.5"
                      checked={agent.enabled}
                      onChange={(event) => setAgent((prev) => ({ ...prev, enabled: event.target.checked }))}
                    />
                    <span>{side === 'SELLER' ? 'Agent acting for the seller' : 'Agent acting for the purchaser'}</span>
                  </label>
                  {agent.enabled && (
                    <>
                      {ndShows(nameCode) && (
                      <label className="grid gap-1 text-sm text-avcs-text">
                        Agent name *
                        <input
                          className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                          value={agent.name}
                          onChange={(event) => setAgent((prev) => ({ ...prev, name: event.target.value }))}
                        />
                      </label>
                      )}
                      {ndShows(contactCode) && (
                      <label className="grid gap-1 text-sm text-avcs-text">
                        Agent contact number{ndMark(contactCode)}
                        <input
                          className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                          value={agent.contact}
                          onChange={(event) => setAgent((prev) => ({ ...prev, contact: event.target.value }))}
                        />
                      </label>
                      )}
                    </>
                  )}
                </div>
              );
            };

            const modeToggle = (
              mode: 'select' | 'create',
              setMode: (m: 'select' | 'create') => void,
            ) => (
              <div className="flex gap-1 rounded-lg border border-[#1e6bb833] p-0.5">
                <button
                  type="button"
                  className={`rounded-md px-3 py-1 text-xs font-semibold ${mode === 'select' ? 'bg-[#1e6bb8] text-white' : 'text-avcs-muted hover:text-avcs-text'}`}
                  onClick={() => setMode('select')}
                >
                  Select existing
                </button>
                <button
                  type="button"
                  className={`rounded-md px-3 py-1 text-xs font-semibold ${mode === 'create' ? 'bg-[#1e6bb8] text-white' : 'text-avcs-muted hover:text-avcs-text'}`}
                  onClick={() => setMode('create')}
                >
                  Create new
                </button>
              </div>
            );

            // One question per screen. The deal's documents are not asked here:
            // they have their own step at the end of the wizard.
            const isSellerStage = ndPartyStage === 'seller';
            const sideWord = isSellerStage ? 'seller' : 'purchaser';
            const stageMode = isSellerStage ? ndSellerMode : ndPurchaserMode;
            const setStageMode = isSellerStage ? setNdSellerMode : setNdPurchaserMode;
            const stageEntity = isSellerStage ? sellerEntity : purchaserEntity;
            const stageChosenId = isSellerStage ? ndProducerId : ndPurchaserId;
            const goNext = async () => {
              if (!(await submitNewDealParties())) return;
              if (isSellerStage) {
                setNdPartyStage('purchaser');
                return;
              }
              setNdStep(3);
              if (ndCreatedDeal) refreshNdDealStats(ndCreatedDeal.id);
            };

            return (
              <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-2 pt-3 md:pt-6">
                <p className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">
                  Deal {ndCreatedDeal.label} · {isSellerStage ? 'Seller' : 'Purchaser'}
                </p>
                <h3 className="mt-3 text-center text-3xl font-semibold text-avcs-text">Who is the {sideWord}?</h3>
                <p className="mt-2 text-center text-sm text-avcs-muted">
                  {isSellerStage
                    ? 'The farm or person the animals are bought from.'
                    : dealIsScpFlow && ndPurchaserId
                      ? 'Filled in from the Supply Chain Program. Change it only if this deal differs.'
                      : 'Who buys the animals. You can also leave this for later.'}
                </p>

                {ndStep2Error && (
                  <div className="mt-6 w-full rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{ndStep2Error}</div>
                )}

                <div className="mt-5">{modeToggle(stageMode, setStageMode)}</div>

                <div className="mt-4 w-full">
                  {stageMode === 'select' ? (
                    <>
                      {isSellerStage ? (
                        <EntityCombobox
                          label="Search for the seller"
                          selectedUnit={sellerEntity}
                          searchValue={ndSellerSearch}
                          onSearchChange={(v) => { setNdSellerSearch(v); setNdShowSellerDropdown(true); }}
                          results={sellerResults}
                          showDropdown={ndShowSellerDropdown}
                          onFocus={() => setNdShowSellerDropdown(true)}
                          onBlur={() => setTimeout(() => setNdShowSellerDropdown(false), 150)}
                          onSelect={(unit) => {
                            setNdProducerId(unit.id || '');
                            setNdSellerSearch('');
                            setNdShowSellerDropdown(false);
                          }}
                          onClear={() => {
                            setNdProducerId('');
                            setNdSellerSearch('');
                          }}
                          showEntityType
                        />
                      ) : (
                        <EntityCombobox
                          label="Search for the purchaser"
                          selectedUnit={purchaserEntity}
                          searchValue={ndPurchaserSearch}
                          onSearchChange={(v) => { setNdPurchaserSearch(v); setNdShowPurchaserDropdown(true); }}
                          results={purchaserResults}
                          showDropdown={ndShowPurchaserDropdown}
                          onFocus={() => setNdShowPurchaserDropdown(true)}
                          onBlur={() => setTimeout(() => setNdShowPurchaserDropdown(false), 150)}
                          onSelect={(unit) => {
                            setNdPurchaserId(unit.id || '');
                            setNdPurchaserSearch('');
                            setNdShowPurchaserDropdown(false);
                          }}
                          onClear={() => {
                            setNdPurchaserId('');
                            setNdPurchaserSearch('');
                          }}
                          showEntityType
                        />
                      )}
                      {stageEntity && renderNdEntityDetails(stageEntity)}
                    </>
                  ) : isSellerStage ? (
                    renderNdCreateForm('SELLER', ndSellerForm, setNdSellerForm)
                  ) : (
                    renderNdCreateForm('PURCHASER', ndPurchaserForm, setNdPurchaserForm)
                  )}
                </div>

                <div className="w-full">
                  {isSellerStage
                    ? renderNdAgentBlock('SELLER', ndSellerAgent, setNdSellerAgent)
                    : renderNdAgentBlock('PURCHASER', ndPurchaserAgent, setNdPurchaserAgent)}
                </div>

                {/* Pinned to the foot of the scrolling step so the way forward is always in view. */}
                {wizardFooter(
<div className="flex w-full flex-wrap items-center justify-between gap-3">
                  {isSellerStage ? <span /> : (
                    <button type="button" className="btn" onClick={() => setNdPartyStage('seller')}>← Seller</button>
                  )}
                  <div className="flex flex-wrap items-center gap-3">
                    {stageMode === 'create' && (
                      <span className="text-xs text-avcs-muted">Create the entity first, or switch to Select existing.</span>
                    )}
                    <button
                      type="button"
                      className="btn primary"
                      disabled={ndSavingParties || ndCreatingEntity !== '' || stageMode === 'create' || (isSellerStage && !stageChosenId)}
                      onClick={goNext}
                    >
                      {ndSavingParties ? 'Saving…' : isSellerStage ? 'Select purchaser →' : 'Continue to animals →'}
                    </button>
                  </div>
                </div>
)}
              </div>
            );
          })()
        ) : ndStep === 3 && ndCreatedDeal ? (
          (() => {
            const dealIsScpFlow = ndValueChainId
              ? Boolean(valueChains.find((vc) => vc.id === ndValueChainId)?.isScp)
              : false;
            const seller = entityDirectory.find((e) => e.id === ndProducerId);
            const sellerVat = Boolean(seller?.vatRegistered);
            const form = ndAnimalsForm;
            const set = (patch: Partial<typeof ndAnimalsForm>) => setNdAnimalsForm((prev) => ({ ...prev, ...patch }));
            const toNum = (value: string) => (value.trim() === '' ? 0 : Number(value) || 0);
            const manualTotal = toNum(form.totalMale) + toNum(form.totalFemale) + toNum(form.totalUnknown);
            const sexSplit = ndDealStats?.sex_split;
            const headcount = Number(ndDealStats?.headcount || 0);
            const hasAnimals = sexSplit?.source === 'animals' && headcount > 0;
            // Declaring traceability creates its own upload row — shown beside the
            // tick that caused it rather than three steps later at the finish.
            const traceabilityReq = ndRequirements.find((r) => !r.party && r.code === 'TRACEABILITY');
            const averageWeight = ndDealStats?.average_weight_kg;
            const effectiveTotal = hasAnimals ? headcount : manualTotal;
            const averagePreview = !averageWeight && form.totalWeightKg && effectiveTotal > 0
              ? (Number(form.totalWeightKg) / effectiveTotal).toFixed(2)
              : null;

            // ---- Screen 1 of step 3: the animals --------------------------------
            // The capture form opens as a screen of the wizard, not an overlay.
            if (ndEventInline && ndEventModalKind === 'FARM_REG') {
              return (
                <div className="mx-auto w-full max-w-5xl pt-2">
                  <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
                    <div>
                      <p className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Deal {ndCreatedDeal.label} · Animals</p>
                      <h3 className="mt-1 text-2xl font-semibold text-avcs-text">Load the registration file</h3>
                    </div>
                    <button type="button" className="btn" onClick={closeNdEventCapture}>← Back to animals</button>
                  </div>
                  {renderDataSessionUpload()}
                </div>
              );
            }

            // Species, breed, how many, and what it cost.
            const statsAny: any = ndDealStats;
            const basicsSpecies = ndBasics.species ?? String(statsAny?.planned_species || statsAny?.species || '');
            const basicsBreedId = ndBasics.breedId ?? String(statsAny?.planned_breed || '');
            const basicsTotal = hasAnimals
              ? String(headcount)
              : (ndBasics.total ?? (Number(statsAny?.total_animals) > 0 ? String(statsAny.total_animals) : ''));
            const saveBasics = async (): Promise<boolean> => {
              setNdStep3Error('');
              const count = Number(basicsTotal);
              if (!basicsSpecies) { setNdStep3Error('Choose the species.'); return false; }
              if (!hasAnimals && !(count > 0)) { setNdStep3Error('Enter how many animals.'); return false; }
              try {
                await updateDealApi(ndCreatedDeal.id, {
                  plannedSpecies: basicsSpecies,
                  plannedBreedId: basicsBreedId || null,
                  ...(hasAnimals ? {} : { totalAnimals: count }),
                });
                if (ndPurchaseInvoiceAmount.trim()) await syncNdPurchase();
                await refreshNdDealStats(ndCreatedDeal.id);
                return true;
              } catch (error: any) {
                setNdStep3Error(parseApiError(error?.message) || error?.message || 'Could not save the animals.');
                return false;
              }
            };
            const screenLabel = (text: string) => (
              <p className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Deal {ndCreatedDeal.label} · {text}</p>
            );
            const errorBox = ndStep3Error ? (
              <div className="mt-5 w-full rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{ndStep3Error}</div>
            ) : null;

            if (ndAnimalsStage === 'animals') {
              const breedChoices = breeds.filter((b) => !basicsSpecies || b.species === basicsSpecies);
              return (
                <div className="mx-auto flex w-full max-w-2xl flex-col items-center px-2 pt-3 md:pt-6">
                  {screenLabel('Animals')}
                  <h3 className="mt-3 text-center text-3xl font-semibold text-avcs-text">Which animals are you buying?</h3>
                  <p className="mt-2 text-center text-sm text-avcs-muted">Roughly what to expect, and what it cost. You can fill in the detail on the next screens.</p>
                  {errorBox}

                  <div className="mt-6 grid w-full gap-4 md:grid-cols-3">
                    <label className="grid gap-1 text-sm text-avcs-text">
                      Species
                      <select
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                        value={basicsSpecies}
                        onChange={(e) => setNdBasics((b) => ({ ...b, species: e.target.value, breedId: '' }))}
                      >
                        <option value="">Choose…</option>
                        <option value="CATTLE">Cattle</option>
                        <option value="SHEEP">Sheep</option>
                        <option value="GOAT">Goat</option>
                      </select>
                    </label>
                    <label className="grid gap-1 text-sm text-avcs-text">
                      Breed
                      <select
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2 disabled:bg-[#f3f6f9]"
                        value={basicsBreedId}
                        disabled={!basicsSpecies}
                        onChange={(e) => setNdBasics((b) => ({ ...b, breedId: e.target.value }))}
                      >
                        <option value="">{basicsSpecies ? 'Mixed / not sure' : 'Choose the species first'}</option>
                        {breedChoices.map((b) => (<option key={b.id} value={b.id}>{b.name}</option>))}
                      </select>
                    </label>
                    <label className="grid gap-1 text-sm text-avcs-text">
                      How many animals
                      <input
                        type="number"
                        min="1"
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2 read-only:bg-[#f3f6f9]"
                        value={basicsTotal}
                        readOnly={hasAnimals}
                        onChange={(e) => setNdBasics((b) => ({ ...b, total: e.target.value }))}
                      />
                    </label>
                  </div>

                  <div className="mt-6 grid w-full gap-4 md:grid-cols-[1fr_1fr] md:items-end">
                    <label className="grid gap-1 text-sm text-avcs-text">
                      Purchase cost (excl VAT)
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                        value={ndPurchaseInvoiceAmount}
                        onChange={(event) => setNdPurchaseInvoiceAmount(event.target.value)}
                        onBlur={() => { if (ndPurchaseInvoiceAmount.trim()) syncNdPurchase(); }}
                      />
                    </label>
                    <div className="grid gap-1 text-sm text-avcs-text">
                      Invoice
                      {(ndPurchaseInvoiceDone || (Array.isArray(statsAny?.documents) && statsAny.documents.some((d: any) => d?.document_type_code === 'INVOICE'))) ? (
                        <span className="inline-flex h-[42px] items-center justify-center rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 text-sm font-semibold text-[#106b38]">Invoice filed ✓</span>
                      ) : ndUploadingKey === ':PURCHASE_INVOICE' ? (
                        <span className="inline-flex h-[42px] items-center px-3 text-sm text-avcs-muted">Uploading…</span>
                      ) : (
                        <label className="inline-flex h-[42px] cursor-pointer items-center justify-center rounded-lg border border-dashed border-[#1e6bb84d] bg-[#f7fbff] px-3 text-sm font-semibold text-[#0f3b64] hover:bg-[#edf5ff]">
                          Upload the invoice
                          <input
                            type="file"
                            className="hidden"
                            onChange={(event) => {
                              submitNdPurchaseInvoice(event.target.files?.[0] || null);
                              event.target.value = '';
                            }}
                          />
                        </label>
                      )}
                    </div>
                  </div>
                  {ndPurchaseSyncing && <p className="mt-2 w-full text-xs text-avcs-muted">Recording the purchase…</p>}

                  <div className="mt-6 grid w-full gap-4 md:grid-cols-[180px_minmax(0,1fr)_auto] md:items-end">
                    <label className="grid gap-1 text-sm text-avcs-text">
                      Penalty amount
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                        value={ndPenaltyAmount}
                        onChange={(event) => setNdPenaltyAmount(event.target.value)}
                      />
                    </label>
                    <label className="grid gap-1 text-sm text-avcs-text">
                      Penalty description
                      <input
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                        value={form.penaltyTerms}
                        onChange={(event) => set({ penaltyTerms: event.target.value })}
                        placeholder="e.g. >240kg carcass — 50c/kg deduction"
                      />
                    </label>
                    <button type="button" className="btn" style={{ height: 42 }} disabled={ndRecordingPenalty} onClick={recordNdPenalty}>
                      {ndRecordingPenalty ? 'Recording…' : 'Record penalty'}
                    </button>
                  </div>

                  {wizardFooter(
<div className="flex w-full flex-wrap items-center justify-between gap-3">
                    <button type="button" className="btn" onClick={() => setNdStep(2)}>← Seller &amp; purchaser</button>
                    <button
                      type="button"
                      className="btn primary"
                      disabled={ndPurchaseSyncing}
                      onClick={async () => { if (await saveBasics()) setNdAnimalsStage('register'); }}
                    >
                      More animal details →
                    </button>
                  </div>
)}
                </div>
              );
            }

            // The registration-file question.
            if (ndAnimalsStage === 'register') {
              return (
                <div className="mx-auto flex w-full max-w-2xl flex-col items-center px-2 pt-6 md:pt-14">
                  {screenLabel('Animals')}
                  <h3 className="mt-3 text-center text-3xl font-semibold text-avcs-text">Do you have a registration file?</h3>
                  <p className="mt-3 max-w-md text-center text-sm text-avcs-muted">
                    This is the file from your tag reader. With it AVCS fills in every animal's tag, breed, sex and weight for you.
                  </p>
                  {errorBox}
                  <div className="mt-10 flex w-full flex-wrap items-center justify-center gap-4">
                    <button
                      type="button"
                      className="btn primary"
                      style={{ padding: '12px 28px', fontSize: '1rem' }}
                      onClick={() => {
                        openNdEventCapture('FARM_REG', undefined, true);
                        if (basicsSpecies) setDataSessionForm((prev) => ({ ...prev, species: basicsSpecies }));
                      }}
                    >
                      Yes, load the file
                    </button>
                    <button
                      type="button"
                      className="btn"
                      style={{ padding: '12px 28px', fontSize: '1rem' }}
                      onClick={() => setNdAnimalsStage('details')}
                    >
                      No
                    </button>
                  </div>
                  {wizardFooter(
<div className="flex w-full flex-wrap items-center justify-between gap-3">
                    <button type="button" className="btn" onClick={() => setNdAnimalsStage('animals')}>← Animals</button>
                    <span />
                  </div>
)}
                </div>
              );
            }

            // `countCode`/`priceCode` are the catalogue keys (snake_case Deal
            // fields) behind each box. `totalUnknown` passes '' — it is folded
            // into totalAnimals and has no column of its own, so no program
            // can require or hide it.
            const countPriceRow = (
              label: string,
              countKey: 'totalMale' | 'totalFemale' | 'totalUnknown',
              priceKey: 'pricePerKgMale' | 'pricePerKgFemale' | 'pricePerKgUnknown',
              countCode: string,
              priceCode: string,
            ) => {
              const showCount = !countCode || ndShows(countCode);
              const showPrice = ndShows(priceCode);
              if (!showCount && !showPrice) return null;
              return (
                <div className="grid gap-3 md:grid-cols-2">
                  {showCount && (
                    <label className="grid gap-1 text-sm text-avcs-text">
                      {label}{countCode ? ndMark(countCode) : ''}
                      <input
                        type="number"
                        min="0"
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                        value={form[countKey]}
                        onChange={(event) => set({ [countKey]: event.target.value } as any)}
                      />
                    </label>
                  )}
                  {showPrice && (
                    <label className="grid gap-1 text-sm text-avcs-text">
                      Purchase price per kg (ex VAT){ndMark(priceCode)}
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                        value={form[priceKey]}
                        onChange={(event) => set({ [priceKey]: event.target.value } as any)}
                      />
                    </label>
                  )}
                </div>
              );
            };

            // The details screen: how many of each, what a kilo cost, total weight.
            // Filled in from the registration file when one was loaded.
            const weightReq = ndRequirements.find((r) => !r.party && r.code === 'WEIGHT_RECEIPT');
            const weightNumber = Number(form.totalWeightKg);
            const purchaseNumber = Number(ndPurchaseInvoiceAmount);
            const perKg = purchaseNumber > 0 && weightNumber > 0 ? purchaseNumber / weightNumber : null;
            const fmtRand = (value: number) => `R ${value.toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            return (
              <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-2 pt-3 md:pt-6">
                {screenLabel('Animals')}
                <h3 className="mt-3 text-center text-3xl font-semibold text-avcs-text">How many of each, and what did they weigh?</h3>
                <p className="mt-2 text-center text-sm text-avcs-muted">
                  {hasAnimals
                    ? 'Filled in from the registration file. Check the figures and change anything that is wrong.'
                    : 'Fill in what you know. Prices are per kilo, excluding VAT.'}
                </p>
                {errorBox}

                <div className="mt-6 grid w-full gap-3">
                  {countPriceRow('Males', 'totalMale', 'pricePerKgMale', 'total_male', 'price_per_kg_male')}
                  {countPriceRow('Females', 'totalFemale', 'pricePerKgFemale', 'total_female', 'price_per_kg_female')}
                  {countPriceRow('Unknown sex', 'totalUnknown', 'pricePerKgUnknown', '', 'price_per_kg_unknown')}
                </div>

                {ndShows('total_weight_kg') && (
                  <div className="mt-5 grid w-full gap-3 md:grid-cols-2 md:items-end">
                    <label className="grid gap-1 text-sm text-avcs-text">
                      Total weight (kg){ndMark('total_weight_kg')}
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                        value={form.totalWeightKg}
                        onChange={(event) => set({ totalWeightKg: event.target.value })}
                        onBlur={() => { if (form.totalWeightKg.trim()) syncNdPurchase(); }}
                      />
                    </label>
                    <div className="grid gap-1 text-sm text-avcs-text">
                      Weight slip
                      {(weightReq?.satisfied || (Array.isArray((ndDealStats as any)?.documents) && (ndDealStats as any).documents.some((d: any) => d?.document_type_code === 'WEIGHT_RECEIPT'))) ? (
                        <span className="inline-flex h-[42px] items-center justify-center rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 text-sm font-semibold text-[#106b38]">Weight slip filed ✓</span>
                      ) : ndUploadingKey === ':WEIGHT_RECEIPT' ? (
                        <span className="inline-flex h-[42px] items-center px-3 text-sm text-avcs-muted">Uploading…</span>
                      ) : (
                        <label className="inline-flex h-[42px] cursor-pointer items-center justify-center rounded-lg border border-dashed border-[#1e6bb84d] bg-[#f7fbff] px-3 text-sm font-semibold text-[#0f3b64] hover:bg-[#edf5ff]">
                          Upload the weight slip
                          <input
                            type="file"
                            className="hidden"
                            onChange={(event) => {
                              uploadNdDocByCode('WEIGHT_RECEIPT', '', event.target.files?.[0] || null, setNdStep3Error, () => refreshNdDealStats(ndCreatedDeal.id));
                              event.target.value = '';
                            }}
                          />
                        </label>
                      )}
                    </div>
                  </div>
                )}

                <p className="mt-4 w-full text-sm text-avcs-muted">
                  Total animals: <span className="font-semibold text-avcs-text">{manualTotal || (hasAnimals ? headcount : 0)}</span>
                  {perKg !== null && (
                    <span> · average purchase price <span className="font-semibold text-avcs-text">{fmtRand(perKg)} / kg</span></span>
                  )}
                </p>

                <details className="mt-6 w-full rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3">
                  <summary className="cursor-pointer text-sm font-semibold text-avcs-text">Origin and traceability (optional)</summary>
                  <div className="mt-3 grid gap-4">
                    {(ndShows('origin') || ndShows('purchase_channel')) && (
                      <div className="grid gap-3 md:grid-cols-2">
                        {ndShows('origin') && (
                          <label className="grid gap-1 text-sm text-avcs-text">
                            Origin{ndMark('origin')}
                            <select
                              className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                              value={form.origin}
                              onChange={(event) => set({
                                origin: event.target.value,
                                purchaseChannel: event.target.value === 'PURCHASED' ? form.purchaseChannel : '',
                              })}
                            >
                              <option value="">Not captured</option>
                              <option value="PURCHASED">Purchased</option>
                              <option value="BORN_ON_FARM">Born on farm</option>
                            </select>
                          </label>
                        )}
                        {form.origin === 'PURCHASED' && ndShows('purchase_channel') && (
                          <label className="grid gap-1 text-sm text-avcs-text">
                            Purchased via{ndMark('purchase_channel')}
                            <select
                              className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                              value={form.purchaseChannel}
                              onChange={(event) => set({ purchaseChannel: event.target.value })}
                            >
                              <option value="">Not captured</option>
                              <option value="AUCTION">Auction</option>
                              <option value="PRIVATE_SALE">Private sale</option>
                            </select>
                          </label>
                        )}
                        <label className="flex items-start gap-2 text-sm text-avcs-text md:col-span-2">
                          <input
                            type="checkbox"
                            className="mt-0.5"
                            checked={form.traceabilityDocumented}
                            onChange={(event) => set({ traceabilityDocumented: event.target.checked })}
                          />
                          <span>Full traceability documentation is in place</span>
                        </label>
                      </div>
                    )}
                  </div>
                </details>

                {wizardFooter(
<div className="flex w-full flex-wrap items-center justify-between gap-3">
                  <button type="button" className="btn" onClick={() => setNdAnimalsStage('register')}>← Back</button>
                  <button
                    type="button"
                    className="btn primary"
                    disabled={ndSavingAnimals || ndPurchaseSyncing}
                    onClick={async () => {
                      if (!(await submitNewDealAnimals())) return;
                      if (ndPurchaseInvoiceAmount.trim() || form.totalWeightKg.trim()) await syncNdPurchase();
                      setNdStep(4);
                      refreshNdEvents(ndCreatedDeal.id);
                    }}
                  >
                    {ndSavingAnimals ? 'Saving…' : 'Confirm & continue to movement & events →'}
                  </button>
                </div>
)}
              </div>
            );
          })()
        ) : ndStep === 4 && ndCreatedDeal && ndSlaughterSale ? (
          renderNdSlaughterSale()
        ) : ndStep === 4 && ndCreatedDeal && ndEventInline && ndEventModalKind ? (
          renderInlineCapturePanel('Movement & events', '← Back to movement & events')
        ) : ndStep === 4 && ndCreatedDeal ? (
          <div>
            <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-avcs-muted">
              Step 4 — Movement &amp; events · deal {ndCreatedDeal.label}
            </p>

            {(() => {
              const captured = new Set(ndDealEvents.filter((ev) => !ev?.is_voided).map((ev) => String(ev?.entity_event_type_code || '')));
              // A chain with no feedlot (animals go farm to abattoir) has no feedlot legs.
              const stepChainId = ndValueChainId || String(((ndDealStats as any)?.value_chain && typeof (ndDealStats as any).value_chain === 'object' ? (ndDealStats as any).value_chain.id : (ndDealStats as any)?.value_chain) || '');
              const chainHasFeedlot = entityDirectory.some((e) => String(e.entityType || '').toUpperCase() === 'FEEDLOT' && stepChainId && e.valueChainId === stepChainId);
              const movement = [
                { code: 'FARM_DIS', label: 'Farm dispatch' },
                { code: 'FEED_REC', label: 'Feedlot receive' },
                { code: 'FEED_DIS', label: 'Feedlot dispatch' },
                { code: 'ABAT_REC', label: 'Abattoir receive' },
              ].filter((step) => !captured.has(step.code))
                .filter((step) => chainHasFeedlot || !step.code.startsWith('FEED_') || captured.has('FEED_REC') || captured.has('FEED_DIS'));
              return (
                <div className="mb-4 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3">
                  <p className="text-sm font-semibold text-avcs-text">Movement &amp; events</p>
                  <p className="mb-3 mt-1 text-xs text-avcs-muted">
                    Each capture opens filled in with what the deal already knows — the deal, the
                    producer, the programme's feedlot, the purchaser, the species. A movement already
                    on the deal drops off this row. Inside a receive capture, the expected-receipts
                    panel accepts an in-transit dispatch without a file. Medicines and vaccinations
                    are captured on the Health &amp; feeding step; journeys on Transportation.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {movement.map((step) => (
                      <button key={step.code} type="button" className="btn" onClick={() => openNdEventCapture(step.code, undefined, true)}>{step.label}</button>
                    ))}
                    <button type="button" className="btn" onClick={() => openNdEventCapture('ABAT_SLA', undefined, true)}>Slaughter</button>
                    <button type="button" className="btn primary" onClick={() => openNdEventCapture('ANY', undefined, true)}>Create other event</button>
                  </div>
                  {movement.length === 0 && (
                    <p className="mt-2 text-xs text-avcs-muted">Every movement leg is on the deal.</p>
                  )}
                </div>
              );
            })()}

            <div className="mb-4 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3">
              <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
                <p className="text-sm font-semibold text-avcs-text">Events on this deal ({fmtNum(ndDealEvents.length)})</p>
                <button type="button" className="btn" onClick={() => refreshNdEvents(ndCreatedDeal.id)}>Refresh</button>
              </div>
              {ndDealEvents.length === 0 ? (
                <p className="text-sm text-avcs-muted">No events recorded yet beyond what the animals step captured.</p>
              ) : (
                <DealEventsSection dealId={ndCreatedDeal.id} dealEvents={ndDealEvents} />
              )}
            </div>

            {wizardFooter(
<div className="flex w-full flex-wrap items-center justify-between gap-3">
              <button type="button" className="btn" onClick={() => setNdStep(3)}>← Animals</button>
              <span className="text-xs text-avcs-muted">Events can be added later from the deal's Events tab too.</span>
              <button type="button" className="btn primary" onClick={() => setNdStep(5)}>Continue to health &amp; feeding →</button>
            </div>
)}
          </div>
        ) : ndStep === 5 && ndCreatedDeal ? (
          (() => {
            const form = ndHealthForm;
            const set = (patch: Partial<typeof ndHealthForm>) => setNdHealthForm((prev) => ({ ...prev, ...patch }));
            type TriKey = 'examinedBeforeAndOnLoading' | 'freeOfListedDiseases'
              | 'clinicalReportAvailable' | 'withdrawalPeriodsAdhered'
              | 'purchaserDocumentsRequired' | 'purchaserDocumentsCompleted'
              | 'animalByProductsFed';
            // Every one of these state keys is the camelCase form of its Deal
            // column, which is also its catalogue key — so the mapping is
            // mechanical rather than a second list to keep in step.
            const codeFor = (key: TriKey) => key.replace(/[A-Z]/g, (c) => `_${c.toLowerCase()}`);

            // The compact two-column select, still used inside the feeding block
            // where the questions sit among other feeding fields.
            const triSelect = (label: string, key: TriKey, hint?: string) => {
              const code = codeFor(key);
              if (!ndShows(code)) return null;
              return (
                <label className="grid gap-1 text-sm text-avcs-text">
                  {label}{ndMark(code)}
                  <select
                    className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                    value={form[key]}
                    onChange={(event) => set({ [key]: event.target.value } as any)}
                  >
                    <option value="">Not answered</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                  {hint && <span className="text-xs text-avcs-muted">{hint}</span>}
                </label>
              );
            };

            // One declaration question per line: the question, a Yes/No answer,
            // and somewhere to put the paper that backs it up. The previous
            // two-column grid of selects made the reader hold six half-questions
            // at once and had nowhere at all to attach evidence.
            const declarationRow = (label: string, key: TriKey, hint?: string) => {
              const code = codeFor(key);
              if (!ndShows(code)) return null;
              const answer = form[key];
              const field = code;
              const evidence = ndDeclEvidence[field];
              const answerButton = (value: 'yes' | 'no', text: string) => (
                <button
                  type="button"
                  aria-pressed={answer === value}
                  className={`nd-decl-answer ${answer === value ? 'is-on' : ''}`}
                  onClick={() => set({ [key]: answer === value ? '' : value } as any)}
                >
                  {text}
                </button>
              );
              return (
                <div key={key} className="nd-decl-row">
                  <div className="nd-decl-question">
                    <span className="text-sm text-avcs-text">{label}{ndMark(code)}</span>
                    {hint && <span className="block text-xs text-avcs-muted">{hint}</span>}
                    {!answer && (
                      <span className="block text-xs text-avcs-muted">Not answered — recorded as unasked, not as "no".</span>
                    )}
                  </div>
                  <div className="nd-decl-answers" role="group" aria-label={label}>
                    {answerButton('yes', 'Yes')}
                    {answerButton('no', 'No')}
                  </div>
                  <div className="nd-decl-evidence">
                    {evidence ? (
                      <span className="nd-decl-chip" title={evidence}>{evidence}</span>
                    ) : ndDeclUploadingKey === field ? (
                      <span className="text-xs text-avcs-muted">Uploading…</span>
                    ) : (
                      <label className="nd-decl-attach">
                        Attach evidence
                        <input
                          type="file"
                          className="hidden"
                          onChange={(event) => {
                            uploadNdDeclarationEvidence(field, event.target.files?.[0] || null);
                            event.target.value = '';
                          }}
                        />
                      </label>
                    )}
                  </div>
                </div>
              );
            };

            const medications = Array.isArray(ndDealStats?.medications) ? ndDealStats.medications : [];
            const feedingDeclarations = Array.isArray(ndDealStats?.feeding_declarations) ? ndDealStats.feeding_declarations : [];
            const declarationDocReqs = ndRequirements.filter(
              (r) => (!r.party && r.code === 'CLINICAL_REPORT')
                || (r.party === 'PURCHASER' && r.code === 'PURCHASER_DOCS'),
            );
            const headcount = Number(ndDealStats?.headcount || 0);
            const medicineOptions: SearchSelectOption[] = medicines.map((med: any) => ({
              id: med.id,
              label: med.name,
              sublabel: [med.brandName, med.withholdingPeriod ? `${med.withholdingPeriod}d withdrawal` : '']
                .filter(Boolean).join(' · '),
            }));
            // A live preview of the division the save is about to do, so the
            // operator sees the per-animal cost before committing to it.
            const costPreview = ndMedCapture.totalCost && headcount > 0
              ? (Number(ndMedCapture.totalCost) / headcount).toFixed(2)
              : null;

            const declarationAnswered = [
              form.examinedBeforeAndOnLoading, form.freeOfListedDiseases,
              form.clinicalReportAvailable, form.withdrawalPeriodsAdhered,
              form.purchaserDocumentsRequired,
            ].filter(Boolean).length;

            const subSteps: Array<{ key: NdStep4Sub; label: string; note: string }> = [
              { key: 'declaration', label: 'Health declaration', note: `${declarationAnswered} of 5 answered` },
              { key: 'medications', label: 'Medications', note: medications.length ? `${medications.length} recorded` : 'None yet' },
              { key: 'feeding', label: 'Feeding', note: feedingDeclarations.length ? `${feedingDeclarations.length} feed(s)` : form.feedingSystem ? 'Declared' : 'Not declared' },
            ];

            return (
              <form onSubmit={submitNewDealHealth}>
                <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-avcs-muted">
                  Step 5 — Health &amp; feeding · deal {ndCreatedDeal.label}
                </p>

                {/* The three parts are walked in order with the buttons at the foot. */}
                <div className="mb-5 flex flex-wrap items-center justify-between gap-2">
                  <div>
                    <p className="text-2xl font-semibold text-avcs-text">{subSteps.find((sub) => sub.key === ndStep4Sub)?.label}</p>
                    <p className="text-sm text-avcs-muted">{subSteps.find((sub) => sub.key === ndStep4Sub)?.note}</p>
                  </div>
                  <div className="flex items-center gap-2" aria-label={`Part ${subSteps.findIndex((sub) => sub.key === ndStep4Sub) + 1} of ${subSteps.length}`}>
                    {subSteps.map((sub, index) => (
                      <span
                        key={sub.key}
                        title={sub.label}
                        className={`h-2.5 rounded-full ${sub.key === ndStep4Sub ? 'w-8 bg-[#1e6bb8]' : index < subSteps.findIndex((x) => x.key === ndStep4Sub) ? 'w-2.5 bg-[#7fb3e0]' : 'w-2.5 bg-[#1e6bb824]'}`}
                      />
                    ))}
                  </div>
                </div>

                {ndStep4Error && <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{ndStep4Error}</div>}
                {ndStep4Success && <div className="mb-3 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{ndStep4Success}</div>}

                <div className="nd-substep-panel" key={ndStep4Sub}>
                {ndStep4Sub === 'declaration' && (
                  <>
                    <div className="mb-4 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3">
                      <p className="mb-1 text-sm font-semibold text-avcs-text">Animal health declaration</p>
                      <p className="mb-3 text-xs text-avcs-muted">
                        The seller's answers, one question at a time. Attach the paperwork that
                        backs an answer where you have it — it is filed against that question.
                      </p>
                      <div className="grid gap-2">
                        {declarationRow('Individually examined before and upon loading', 'examinedBeforeAndOnLoading')}
                        {declarationRow('Free of clinical signs of the listed diseases', 'freeOfListedDiseases')}
                        {form.freeOfListedDiseases === 'no' && (
                          <div className="rounded-lg border border-[#e7bbb9] bg-[#fdf5f4] p-3">
                            <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-[#6b1010]">Clinical signs present</p>
                            <div className="grid gap-1 md:grid-cols-2">
                              {LISTED_DISEASES.map((disease) => (
                                <label key={disease.code} className="flex items-center gap-2 text-sm text-avcs-text">
                                  <input
                                    type="checkbox"
                                    checked={form.diseasesPresent.includes(disease.code)}
                                    onChange={(event) => set({
                                      diseasesPresent: event.target.checked
                                        ? [...form.diseasesPresent, disease.code]
                                        : form.diseasesPresent.filter((c) => c !== disease.code),
                                    })}
                                  />
                                  {disease.label}
                                </label>
                              ))}
                            </div>
                            <label className="mt-2 grid gap-1 text-sm text-avcs-text">
                              Other condition
                              <input
                                className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                                value={form.diseasesOther}
                                onChange={(event) => set({ diseasesOther: event.target.value })}
                              />
                            </label>
                          </div>
                        )}
                        {declarationRow('Clinical examinations report available', 'clinicalReportAvailable', 'Answering yes makes the report a required upload.')}
                        {declarationRow('Withdrawal periods adhered to', 'withdrawalPeriodsAdhered')}
                        {declarationRow('Purchaser requires documents of their own', 'purchaserDocumentsRequired')}
                        {form.purchaserDocumentsRequired === 'yes'
                          && declarationRow('Purchaser documents completed', 'purchaserDocumentsCompleted')}
                      </div>
                    </div>

                    {declarationDocReqs.length > 0 && (
                      <div className="mb-4 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3">
                        <p className="mb-1 text-sm font-semibold text-avcs-text">Required by these answers</p>
                        <p className="mb-3 text-xs text-avcs-muted">
                          Documents the answers above made compulsory. The deal cannot be completed
                          without them.
                        </p>
                        <div className="grid gap-2">
                          {declarationDocReqs.map((row) => renderNdRequirementRow(row, setNdStep4Error))}
                        </div>
                      </div>
                    )}

                  </>
                )}

                {ndStep4Sub === 'medications' && (
                  <>
                    <div className="mb-4 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3">
                      <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
                        <p className="text-sm font-semibold text-avcs-text">Add a medication</p>
                        <button type="button" className="btn" onClick={() => openNdEventCapture('VACCINATION')}>
                          Capture from a data file
                        </button>
                      </div>
                      <p className="mb-3 text-xs text-avcs-muted">
                        One save records the declaration, the treatment on every registered animal,
                        and the cost against the deal.
                        {headcount > 0
                          ? ` The total is divided across the ${headcount} registered animal(s).`
                          : ' No animals are registered yet — the declaration and cost are kept, and the per-animal records can be created afterwards.'}
                      </p>

                      <div className="grid gap-3">
                        <div className="grid gap-3 md:grid-cols-[minmax(0,2fr)_auto] md:items-end">
                          <SearchSelect
                            label="Medicine"
                            required
                            placeholder="Search the catalogue…"
                            options={medicineOptions}
                            value={ndMedCapture.medicineId || null}
                            emptyText="No medicine matches. Add it to the catalogue below."
                            onChange={(id) => {
                              const picked = medicines.find((m: any) => m.id === id);
                              setNdMedCapture((prev) => ({
                                ...prev,
                                medicineId: id || '',
                                // The catalogued withholding period is the default
                                // withdrawal; still editable, since a vet may
                                // have specified a longer one for this batch.
                                withdrawalDays: picked?.withholdingPeriod
                                  ? String(picked.withholdingPeriod)
                                  : prev.withdrawalDays,
                              }));
                            }}
                          />
                          <button
                            type="button"
                            className="btn mb-1"
                            onClick={() => setNdShowAddMedicine((open) => !open)}
                          >
                            {ndShowAddMedicine ? 'Cancel new medicine' : 'Add a new medicine'}
                          </button>
                        </div>

                        {ndShowAddMedicine && (
                          <div className="rounded-lg border border-[#1e6bb81a] bg-[#f8fafc] p-3">
                            <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-avcs-muted">New medicine</p>
                            <div className="grid gap-3 md:grid-cols-4">
                              <label className="grid content-start gap-1 text-sm text-avcs-text">
                                Name *
                                <input
                                  className="h-[42px] rounded-lg border border-[#1e6bb833] px-3 py-2"
                                  value={ndNewMedicine.name}
                                  onChange={(event) => setNdNewMedicine((prev) => ({ ...prev, name: event.target.value }))}
                                />
                              </label>
                              <label className="grid content-start gap-1 text-sm text-avcs-text">
                                Brand
                                <input
                                  className="h-[42px] rounded-lg border border-[#1e6bb833] px-3 py-2"
                                  value={ndNewMedicine.brandName}
                                  onChange={(event) => setNdNewMedicine((prev) => ({ ...prev, brandName: event.target.value }))}
                                />
                              </label>
                              <label className="grid content-start gap-1 text-sm text-avcs-text">
                                Producer
                                <input
                                  className="h-[42px] rounded-lg border border-[#1e6bb833] px-3 py-2"
                                  value={ndNewMedicine.producer}
                                  onChange={(event) => setNdNewMedicine((prev) => ({ ...prev, producer: event.target.value }))}
                                />
                              </label>
                              <label className="grid content-start gap-1 text-sm text-avcs-text">
                                Withholding (days)
                                <input
                                  type="number"
                                  min="0"
                                  className="h-[42px] rounded-lg border border-[#1e6bb833] px-3 py-2"
                                  value={ndNewMedicine.withholdingPeriod}
                                  onChange={(event) => setNdNewMedicine((prev) => ({ ...prev, withholdingPeriod: event.target.value }))}
                                />
                              </label>
                            </div>
                            <button
                              type="button"
                              className="btn mt-3"
                              disabled={ndSavingNewMedicine}
                              onClick={addNdMedicineToCatalogue}
                            >
                              {ndSavingNewMedicine ? 'Adding…' : 'Add & select'}
                            </button>
                          </div>
                        )}

                        {(() => {
                          // Treatments are given on the farm the animals came from, not wherever they are now.
                          const defaultLocation = entityDirectory.find((e) => e.id === ndProducerId) || ndEventPrefill('ANY').destination;
                          const chosenLocation = entityDirectory.find((e) => e.id === ndMedLocationId) || defaultLocation || null;
                          const locationResults = (ndMedLocationSearch.trim()
                            ? entityDirectory.filter((e) => e.entityName?.toLowerCase().includes(ndMedLocationSearch.toLowerCase()))
                            : entityDirectory
                          ).slice(0, 8);
                          return (
                            <div>
                              <EntityCombobox
                                label="Where were they treated?"
                                required={false}
                                selectedUnit={chosenLocation}
                                searchValue={ndMedLocationSearch}
                                onSearchChange={(v) => { setNdMedLocationSearch(v); setNdShowMedLocationDropdown(true); }}
                                results={locationResults}
                                showDropdown={ndShowMedLocationDropdown}
                                onFocus={() => setNdShowMedLocationDropdown(true)}
                                onBlur={() => setTimeout(() => setNdShowMedLocationDropdown(false), 150)}
                                onSelect={(unit) => { setNdMedLocationId(unit.id || ''); setNdMedLocationSearch(''); setNdShowMedLocationDropdown(false); }}
                                onClear={() => { setNdMedLocationId(''); setNdMedLocationSearch(''); }}
                                showEntityType
                              />
                              <p className="mt-1 text-xs text-avcs-muted">The farm or feedlot where the animals were treated. Filled in with the seller's farm.</p>
                            </div>
                          );
                        })()}

                        <div className="grid items-start gap-3 md:grid-cols-4">
                          <label className="grid content-start gap-1 text-sm text-avcs-text">
                            Treatment date
                            <input
                              type="date"
                              className="h-[42px] rounded-lg border border-[#1e6bb833] px-3 py-2"
                              value={ndMedCapture.lastTreatmentDate}
                              onChange={(event) => setNdMedCapture((prev) => ({ ...prev, lastTreatmentDate: event.target.value }))}
                            />
                            <span className="min-h-4 text-xs text-avcs-muted">Dates the per-animal records.</span>
                          </label>
                          <label className="grid content-start gap-1 text-sm text-avcs-text">
                            Withdrawal (days)
                            <input
                              type="number"
                              min="0"
                              className="h-[42px] rounded-lg border border-[#1e6bb833] px-3 py-2"
                              value={ndMedCapture.withdrawalDays}
                              onChange={(event) => setNdMedCapture((prev) => ({ ...prev, withdrawalDays: event.target.value }))}
                              placeholder="From catalogue"
                            />
                            <span className="min-h-4 text-xs text-avcs-muted">Filled in from the catalogue.</span>
                          </label>
                          <label className="grid content-start gap-1 text-sm text-avcs-text">
                            Dosage
                            <input
                              className="h-[42px] rounded-lg border border-[#1e6bb833] px-3 py-2"
                              value={ndMedCapture.dosage}
                              onChange={(event) => setNdMedCapture((prev) => ({ ...prev, dosage: event.target.value }))}
                              placeholder="e.g. 2ml"
                            />
                            <span className="min-h-4 text-xs text-avcs-muted">The dose given.</span>
                          </label>
                          <label className="grid content-start gap-1 text-sm text-avcs-text">
                            Total cost
                            <input
                              type="number"
                              min="0"
                              step="0.01"
                              className="h-[42px] rounded-lg border border-[#1e6bb833] px-3 py-2"
                              value={ndMedCapture.totalCost}
                              onChange={(event) => setNdMedCapture((prev) => ({ ...prev, totalCost: event.target.value }))}
                            />
                            <span className="min-h-4 text-xs text-avcs-muted">
                              {costPreview ? `${costPreview} per animal.` : 'For the whole deal.'}
                            </span>
                          </label>
                        </div>

                        <div className="flex flex-wrap items-center gap-3 border-t border-[#1e6bb812] pt-4">
                          <label className="flex items-center gap-2 text-sm text-avcs-text">
                            <input
                              type="checkbox"
                              checked={ndMedCapture.isAntibiotic}
                              onChange={(event) => setNdMedCapture((prev) => ({ ...prev, isAntibiotic: event.target.checked }))}
                            />
                            Antibiotic
                          </label>
                          {ndMedCaptureFile ? (
                            <span className="nd-decl-chip" title={ndMedCaptureFile.name}>
                              {ndMedCaptureFile.name}
                              <button
                                type="button"
                                className="nd-decl-chip-clear"
                                aria-label="Remove the attached document"
                                onClick={() => setNdMedCaptureFile(null)}
                              >
                                Remove
                              </button>
                            </span>
                          ) : (
                            <label className="nd-decl-attach">
                              Attach document
                              <input
                                type="file"
                                className="hidden"
                                onChange={(event) => {
                                  setNdMedCaptureFile(event.target.files?.[0] || null);
                                  event.target.value = '';
                                }}
                              />
                            </label>
                          )}
                          <button
                            type="button"
                            className="btn primary ml-auto"
                            disabled={ndCapturingMed}
                            onClick={captureNdMedication}
                          >
                            {ndCapturingMed ? 'Saving…' : 'Save medication'}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="mb-4 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3">
                      <p className="mb-1 text-sm font-semibold text-avcs-text">Recorded on this deal</p>
                      {medications.length === 0 ? (
                        <p className="text-xs text-avcs-muted">
                          Nothing yet. The withdrawal is calculated per medicine, and the deal is
                          only clear once the last one has cleared.
                        </p>
                      ) : (
                        <div className="mt-2 grid gap-2">
                          {medications.map((row: any) => (
                            <div key={row.id} className="rounded-lg border border-[#1e6bb81a] bg-white px-3 py-2">
                              <div className="flex flex-wrap items-center gap-2 text-sm">
                                <span className="font-medium text-avcs-text">{row.display_name || row.medication_name || 'Medication'}</span>
                                {row.is_antibiotic && (
                                  <span className="rounded bg-[#fdf5f4] px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-[#6b1010]">Antibiotic</span>
                                )}
                                {row.last_treatment_date && <span className="text-xs text-avcs-muted">treated {row.last_treatment_date}</span>}
                                {row.effective_withdrawal_days != null && <span className="text-xs text-avcs-muted">{row.effective_withdrawal_days}d withdrawal</span>}
                                {row.clears_on && <span className="text-xs text-avcs-muted">clears {row.clears_on}</span>}
                                {row.dosage && <span className="text-xs text-avcs-muted">{row.dosage}</span>}
                                {row.location_name && <span className="text-xs text-avcs-muted">at {row.location_name}</span>}
                                {row.total_cost != null && <span className="text-xs text-avcs-muted">R{row.total_cost}</span>}
                                {row.animals_treated != null && <span className="text-xs text-avcs-muted">{row.animals_treated} animal(s)</span>}
                                <button
                                  type="button"
                                  className="ml-auto text-xs font-semibold text-avcs-muted hover:text-[#6b1010]"
                                  onClick={() => removeNdMedication(row.id)}
                                >
                                  Remove
                                </button>
                              </div>
                              {row.treatment_pending && (
                                <div className="mt-2 flex flex-wrap items-center gap-2 border-t border-[#1e6bb814] pt-2">
                                  <span className="rounded-full border border-[#ecd1b9] bg-[#fff7ef] px-2.5 py-0.5 text-xs font-semibold text-[#7b4a18]">
                                    Per-animal records outstanding
                                  </span>
                                  <span className="text-xs text-avcs-muted">
                                    {row.last_treatment_date
                                      ? 'Captured before the animals were registered.'
                                      : 'Add a treatment date to this medication first.'}
                                  </span>
                                  <button
                                    type="button"
                                    className="btn ml-auto"
                                    disabled={ndReplayingMedId === row.id || headcount === 0 || !row.last_treatment_date}
                                    onClick={() => replayNdMedication(row.id)}
                                  >
                                    {ndReplayingMedId === row.id ? 'Creating…' : 'Create them now'}
                                  </button>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                  </>
                )}

                {ndStep4Sub === 'feeding' && (
                  <>
                    <div className="mb-4 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3">
                      <p className="mb-1 text-sm font-semibold text-avcs-text">Feeding declaration</p>
                      <p className="mb-3 text-xs text-avcs-muted">
                        The seller's statement about the 90 days before the deal — separate from the
                        feedlot records, which are what AVCS measured.
                      </p>
                      <div className="grid gap-3 md:grid-cols-2">
                        {ndShows('feeding_system') && (
                        <label className="grid gap-1 text-sm text-avcs-text">
                          Feeding system{ndMark('feeding_system')}
                          <select
                            className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                            value={form.feedingSystem}
                            onChange={(event) => set({ feedingSystem: event.target.value })}
                          >
                            <option value="">Not answered</option>
                            {FEEDING_SYSTEMS.map((system) => (
                              <option key={system.code} value={system.code}>{system.label}</option>
                            ))}
                          </select>
                        </label>
                        )}
                        {form.feedingSystem === 'OTHER' && (
                          <label className="grid gap-1 text-sm text-avcs-text">
                            Specify feeding system
                            <input
                              className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                              value={form.feedingSystemOther}
                              onChange={(event) => set({ feedingSystemOther: event.target.value })}
                            />
                          </label>
                        )}
                        {triSelect('Animal by-products fed', 'animalByProductsFed')}
                        {form.animalByProductsFed === 'yes' && (
                          <div className="md:col-span-2 rounded-lg border border-[#1e6bb824] bg-white p-3">
                            <div className="grid gap-1 md:grid-cols-2">
                              {ANIMAL_BY_PRODUCTS.map((product) => (
                                <label key={product.code} className="flex items-center gap-2 text-sm text-avcs-text">
                                  <input
                                    type="checkbox"
                                    checked={form.animalByProducts.includes(product.code)}
                                    onChange={(event) => set({
                                      animalByProducts: event.target.checked
                                        ? [...form.animalByProducts, product.code]
                                        : form.animalByProducts.filter((c) => c !== product.code),
                                    })}
                                  />
                                  {product.label}
                                </label>
                              ))}
                            </div>
                            <label className="mt-2 grid gap-1 text-sm text-avcs-text">
                              Other by-product
                              <input
                                className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                                value={form.animalByProductsOther}
                                onChange={(event) => set({ animalByProductsOther: event.target.value })}
                              />
                            </label>
                          </div>
                        )}
                      </div>
                    </div>

                    {ndShows('feed_product') && (
                      <div className="mb-4 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3">
                        <p className="mb-1 text-sm font-semibold text-avcs-text">Feeds declared on this deal{ndMark('feed_product')}</p>
                        <p className="mb-3 text-xs text-avcs-muted">
                          A declaration routinely lists several feeds — pellets, planted pasture, a
                          finishing ration. Add each as its own line; days on feed are calculated
                          per feed from the deal date.
                        </p>

                        {feedingDeclarations.length === 0 ? (
                          <p className="mb-3 text-xs text-avcs-muted">No feeds recorded yet.</p>
                        ) : (
                          <div className="mb-3 grid gap-2">
                            {feedingDeclarations.map((row: any) => (
                              <div key={row.id} className="rounded-lg border border-[#1e6bb81a] bg-white px-3 py-2">
                                <div className="flex flex-wrap items-center gap-2 text-sm">
                                  <span className="font-medium text-avcs-text">{row.feed_name}</span>
                                  {row.nutritional_value && <span className="text-xs text-avcs-muted">{row.nutritional_value}</span>}
                                  {row.introduced_date && (
                                    <span className="text-xs text-avcs-muted">
                                      introduced {row.introduced_date}
                                      {row.days_since_introduced != null ? ` — ${row.days_since_introduced} day(s) on feed` : ''}
                                    </span>
                                  )}
                                  <button
                                    type="button"
                                    className="ml-auto text-xs font-semibold text-avcs-muted hover:text-[#6b1010]"
                                    onClick={() => removeNdFeeding(row.id)}
                                  >
                                    Remove
                                  </button>
                                </div>
                                {row.description && <p className="mt-1 text-xs text-avcs-muted">{row.description}</p>}
                              </div>
                            ))}
                          </div>
                        )}

                        <div className="grid items-start gap-3 md:grid-cols-3">
                          {(() => {
                            const needle = ndFeedCapture.feedName.trim().toLowerCase();
                            const matches = (needle
                              ? ndFeedSuggestions.filter((f) => f.name.toLowerCase().includes(needle) || f.description.toLowerCase().includes(needle))
                              : ndFeedSuggestions
                            ).slice(0, 8);
                            const exact = ndFeedSuggestions.some((f) => f.name.toLowerCase() === needle);
                            const pick = (f: NdFeedSuggestion) => {
                              setNdFeedCapture((prev) => ({
                                ...prev,
                                feedName: f.name,
                                nutritionalValue: prev.nutritionalValue || f.nutritionalValue,
                                description: prev.description || f.description,
                              }));
                              setNdFeedPickerOpen(false);
                            };
                            return (
                              <label className="relative grid content-start gap-1 text-sm text-avcs-text">
                                Feed *
                                <input
                                  className="h-[42px] rounded-lg border border-[#1e6bb833] px-3 py-2"
                                  placeholder="Search feeds or type a new one"
                                  value={ndFeedCapture.feedName}
                                  autoComplete="off"
                                  onFocus={() => { setNdFeedPickerOpen(true); if (!ndFeedSuggestionsLoaded) loadNdFeedSuggestions(); }}
                                  onBlur={() => setTimeout(() => setNdFeedPickerOpen(false), 150)}
                                  onChange={(event) => { setNdFeedCapture((prev) => ({ ...prev, feedName: event.target.value })); setNdFeedPickerOpen(true); }}
                                  onKeyDown={(event) => { if (event.key === 'Escape') setNdFeedPickerOpen(false); }}
                                />
                                <span className="min-h-4 text-xs text-avcs-muted">
                                  {!needle
                                    ? 'Pick a feed already on file, or type a new one.'
                                    : exact
                                      ? 'Matches a feed on file.'
                                      : `"${ndFeedCapture.feedName.trim()}" will be added as a new feed.`}
                                </span>
                                {ndFeedPickerOpen && (matches.length > 0 || !ndFeedSuggestionsLoaded) && (
                                  <div className="absolute left-0 right-0 top-full z-20 mt-1 max-h-72 overflow-y-auto rounded-lg border border-[#1e6bb833] bg-white shadow-lg" role="listbox">
                                    {!ndFeedSuggestionsLoaded && <div className="px-3 py-2 text-xs text-avcs-muted">Loading feeds…</div>}
                                    {matches.map((f) => (
                                      <button
                                        key={f.key}
                                        type="button"
                                        role="option"
                                        aria-selected={f.name === ndFeedCapture.feedName}
                                        className="flex w-full items-start justify-between gap-3 px-3 py-2 text-left hover:bg-[#f1f7ff]"
                                        onMouseDown={(event) => event.preventDefault()}
                                        onClick={() => pick(f)}
                                      >
                                        <span className="min-w-0">
                                          <span className="block truncate text-sm font-medium text-avcs-text">{f.name}</span>
                                          {(f.nutritionalValue || f.description) && (
                                            <span className="block truncate text-xs text-avcs-muted">{[f.nutritionalValue, f.description].filter(Boolean).join(' · ')}</span>
                                          )}
                                        </span>
                                        <span className="shrink-0 rounded-full border border-[#1e6bb824] bg-[#fbfeff] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-avcs-muted">
                                          {f.source === 'declared' ? `${f.uses} deal${f.uses === 1 ? '' : 's'}` : 'catalogue'}
                                        </span>
                                      </button>
                                    ))}
                                  </div>
                                )}
                              </label>
                            );
                          })()}
                          <label className="grid content-start gap-1 text-sm text-avcs-text">
                            Nutritional value (est.)
                            <input
                              className="h-[42px] rounded-lg border border-[#1e6bb833] px-3 py-2"
                              placeholder="e.g. 16% protein"
                              value={ndFeedCapture.nutritionalValue}
                              onChange={(event) => setNdFeedCapture((prev) => ({ ...prev, nutritionalValue: event.target.value }))}
                            />
                            <span className="min-h-4 text-xs text-avcs-muted">A rough guide to what it gives.</span>
                          </label>
                          {ndShows('feed_introduced_date') && (
                            <label className="grid content-start gap-1 text-sm text-avcs-text">
                              Introduced on{ndMark('feed_introduced_date')}
                              <input
                                type="date"
                                className="h-[42px] rounded-lg border border-[#1e6bb833] px-3 py-2"
                                value={ndFeedCapture.introducedDate}
                                onChange={(event) => setNdFeedCapture((prev) => ({ ...prev, introducedDate: event.target.value }))}
                              />
                              <span className="min-h-4 text-xs text-avcs-muted">When the animals started on it.</span>
                            </label>
                          )}
                          <label className="grid content-start gap-1 text-sm text-avcs-text md:col-span-3">
                            Description
                            <input
                              className="h-[42px] rounded-lg border border-[#1e6bb833] px-3 py-2"
                              placeholder="e.g. De Heus Lamb Booster 4 and 6mm pellets on irrigated pastures"
                              value={ndFeedCapture.description}
                              onChange={(event) => setNdFeedCapture((prev) => ({ ...prev, description: event.target.value }))}
                            />
                          </label>
                        </div>
                        <div className="mt-3">
                          <button
                            type="button"
                            className="btn primary"
                            disabled={ndCapturingFeed || !ndFeedCapture.feedName.trim()}
                            onClick={captureNdFeeding}
                          >
                            {ndCapturingFeed ? 'Adding…' : 'Add feed'}
                          </button>
                        </div>
                      </div>
                    )}

                  </>
                )}
                </div>

                {/* One pair of buttons, pinned, whichever part is showing. */}
                {wizardFooter(
<div className="flex w-full flex-wrap items-center justify-between gap-3">
                  {ndStep4Sub === 'declaration' && (
                    <>
                      <button type="button" className="btn" onClick={() => setNdStep(4)}>← Movement &amp; events</button>
                      <button
                        type="button"
                        className="btn primary"
                        disabled={ndSavingHealth}
                        onClick={async () => { if (await submitNewDealHealth()) setNdStep4Sub('medications'); }}
                      >
                        {ndSavingHealth ? 'Saving…' : 'Save & continue to medications →'}
                      </button>
                    </>
                  )}
                  {ndStep4Sub === 'medications' && (
                    <>
                      <button type="button" className="btn" onClick={() => setNdStep4Sub('declaration')}>← Health declaration</button>
                      <button type="button" className="btn primary" onClick={() => setNdStep4Sub('feeding')}>Continue to feeding →</button>
                    </>
                  )}
                  {ndStep4Sub === 'feeding' && (
                    <>
                      <button type="button" className="btn" onClick={() => setNdStep4Sub('medications')}>← Medications</button>
                      <button
                        type="button"
                        className="btn primary"
                        disabled={ndSavingHealth}
                        onClick={async () => {
                          if (!(await submitNewDealHealth())) return;
                          setNdStep(6);
                          if (ndCreatedDeal) refreshNdJourneys(ndCreatedDeal.id);
                        }}
                      >
                        {ndSavingHealth ? 'Saving…' : 'Save & continue to transportation →'}
                      </button>
                    </>
                  )}
                </div>
)}
              </form>
            );
          })()
        ) : ndStep === 7 && ndCreatedDeal ? (
          renderNdDocumentsStep()
        ) : ndStep === 6 && ndCreatedDeal && ndEventInline && ndEventModalKind ? (
          renderInlineCapturePanel('Transportation', '← Back to transportation')
        ) : ndStep === 6 && ndCreatedDeal && ndShowJourneyModal && ndJourneyInline ? (
          renderNdJourneyWizard()
        ) : ndStep === 6 && ndCreatedDeal ? (
          (() => {
            const removalCertReq = ndRequirements.find((r) => !r.party && r.code === 'REMOVAL_CERT');
            return (
              <div>
                <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-avcs-muted">
                  Step 6 — Transportation · deal {ndCreatedDeal.label}
                </p>

                <div className="mb-4 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3">
                  <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
                    <p className="text-sm font-semibold text-avcs-text">Journeys on this deal</p>
                    <div className="flex flex-wrap gap-2">
                      <button type="button" className="btn" onClick={() => openNdEventCapture('FARM_REC', undefined, true)}>
                        Capture receive event
                      </button>
                      <button type="button" className="btn primary" onClick={() => openNdJourneyCapture(undefined, true)}>
                        Add journey
                      </button>
                    </div>
                  </div>
                  <p className="mb-3 text-xs text-avcs-muted">
                    A journey hangs off a <span className="font-medium">receive</span> event (farm,
                    feedlot or abattoir receive) — capture one first if the animals haven't been
                    received anywhere yet. The journey carries the date &amp; time, transporter and
                    driver, truck registration, km readings, the Stock Theft Act removal
                    certificate and any animals down / DOA. Where it loaded and offloaded comes
                    from the receive event.
                  </p>
                  {ndDealJourneys.length === 0 ? (
                    <p className="text-sm text-avcs-muted">No journeys recorded yet.</p>
                  ) : (
                    <div className="grid gap-1">
                      {ndDealJourneys.map((journey) => (
                        <div key={journey.id} className="flex flex-wrap items-center gap-2 rounded-lg border border-[#1e6bb81a] bg-white px-3 py-1.5 text-sm">
                          <span className="font-medium text-avcs-text">{journey.loadingDate || 'Journey'}</span>
                          {journey.loadingTime && <span className="text-xs text-avcs-muted">{String(journey.loadingTime).slice(0, 5)}</span>}
                          {journey.vehicleRegistration && <span className="text-xs text-avcs-muted">{journey.vehicleRegistration}</span>}
                          {journey.driverName && <span className="text-xs text-avcs-muted">driver {journey.driverName}</span>}
                          {(journey.loadingPoint || journey.offloadingPoint) && (
                            <span className="text-xs text-avcs-muted">
                              {[journey.loadingPoint, journey.offloadingPoint].filter(Boolean).join(' → ')}
                            </span>
                          )}
                          {journey.startKm != null && journey.endKm != null && (
                            <span className="text-xs text-avcs-muted">{journey.startKm}–{journey.endKm} km</span>
                          )}
                          {Number(journey.animalsDown || 0) > 0 && (
                            <span className="rounded bg-[#fdf5f4] px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-[#6b1010]">
                              {journey.animalsDown} down / DOA
                            </span>
                          )}
                          {journey.removalCertificateUrl ? (
                            <span className="rounded-full border border-[#b9e7c9] bg-[#e7f8ee] px-2.5 py-0.5 text-xs font-semibold text-[#106b38]">Removal cert ✓</span>
                          ) : (
                            <span className="rounded-full border border-[#ecd1b9] bg-[#fff7ef] px-2.5 py-0.5 text-xs font-semibold text-[#7b4a18]">Removal cert missing</span>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                  {removalCertReq && (
                    <div className="mt-3">
                      {renderNdRequirementRow(removalCertReq)}
                    </div>
                  )}
                </div>

                {wizardFooter(
<div className="flex w-full flex-wrap items-center justify-between gap-3">
                  <button type="button" className="btn" onClick={() => setNdStep(5)}>← Health &amp; feeding</button>
                  <span className="max-w-md text-xs text-avcs-muted">
                    Journeys can also be added later from Transport → Add Journey — a missing
                    removal certificate keeps the deal open either way.
                  </span>
                  <button type="button" className="btn primary" onClick={() => { setNdStep(7); if (ndCreatedDeal) refreshNdRequirements(ndCreatedDeal.id); }}>Continue to documents →</button>
                </div>
)}
              </div>
            );
          })()
        ) : (
          <>
            <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-avcs-muted">Step 1 — Deal details</p>

            {ndError && <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{ndError}</div>}

            <form className="grid gap-3 md:grid-cols-2" onSubmit={submitNewDeal}>
              <label className="grid gap-1 text-sm text-avcs-text md:col-span-2">
                Deal reference no
                <div
                  className="rounded-lg border border-dashed border-[#1e6bb84d] bg-[#f8fafc] px-3 py-2 text-avcs-text"
                  title="Auto-generated — reserved when the deal is created"
                >
                  {nextDealRefNo() || <span className="text-avcs-muted">Pending…</span>}
                  <span className="ml-2 text-xs text-avcs-muted">pending</span>
                </div>
                <span className="text-xs text-avcs-muted">Reserved when the deal is created — may shift if another deal lands first.</span>
              </label>

              {/* Own row: a date picker stretched across the form reads wrong,
                  so the label spans but the control keeps a sensible width. */}
              <label className="grid gap-1 text-sm text-avcs-text md:col-span-2">
                Deal date
                <input
                  type="date"
                  className="rounded-lg border border-[#1e6bb833] px-3 py-2 md:max-w-xs"
                  value={ndDealDate}
                  onChange={(event) => setNdDealDate(event.target.value)}
                />
              </label>

              <div className="md:col-span-2 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3">
                <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
                  <span className="text-sm font-medium text-avcs-text">Primary producer *</span>
                  <div className="flex gap-1 rounded-lg border border-[#1e6bb833] p-0.5">
                    <button
                      type="button"
                      className={`rounded-md px-3 py-1 text-xs font-semibold ${ndProducerMode === 'existing' ? 'bg-[#1e6bb8] text-white' : 'text-avcs-muted hover:text-avcs-text'}`}
                      onClick={() => setNdProducerMode('existing')}
                    >
                      Select existing
                    </button>
                    <button
                      type="button"
                      className={`rounded-md px-3 py-1 text-xs font-semibold ${ndProducerMode === 'new' ? 'bg-[#1e6bb8] text-white' : 'text-avcs-muted hover:text-avcs-text'}`}
                      onClick={() => setNdProducerMode('new')}
                    >
                      Create new
                    </button>
                  </div>
                </div>

                {ndProducerMode === 'existing' ? (
                  <EntityCombobox
                    label="Search or select entity"
                    selectedUnit={entityDirectory.find((entity) => entity.id === ndProducerId) || null}
                    searchValue={ndProducerSearch}
                    onSearchChange={(v) => { setNdProducerSearch(v); setNdShowProducerDropdown(true); }}
                    results={producerResults}
                    showDropdown={ndShowProducerDropdown}
                    onFocus={() => setNdShowProducerDropdown(true)}
                    onBlur={() => setTimeout(() => setNdShowProducerDropdown(false), 150)}
                    onSelect={(unit) => {
                      setNdProducerId(unit.id || '');
                      setNdProducerSearch('');
                      setNdShowProducerDropdown(false);
                      // The deal follows its producer's Supply Chain Program: a
                      // producer in a program puts the deal in it, one without
                      // starts on the Deal Matrix. The operator can still change
                      // it below before creating the deal.
                      const producerChain = entityDirectory.find((entity) => entity.id === unit.id)?.valueChainId || '';
                      setNdValueChainId(producerChain && valueChains.some((vc) => vc.id === producerChain) ? producerChain : '');
                    }}
                    onClear={() => {
                      setNdProducerId('');
                      setNdProducerSearch('');
                    }}
                    showEntityType
                  />
                ) : (
                  <div className="grid gap-3 md:grid-cols-2">
                    <label className="grid gap-1 text-sm text-avcs-text">
                      Producer name *
                      <input
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                        value={ndNewProducerName}
                        onChange={(event) => setNdNewProducerName(event.target.value)}
                        placeholder="Entity / farm business name"
                      />
                    </label>
                    <label className="grid gap-1 text-sm text-avcs-text">
                      Entity type
                      <select
                        className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                        value={ndNewProducerType}
                        onChange={(event) => setNdNewProducerType(event.target.value)}
                      >
                        <option value="FARM">Farm</option>
                        <option value="FEEDLOT">Feedlot</option>
                        <option value="OTHER">Other</option>
                      </select>
                    </label>
                    <label className="flex items-start gap-2 text-sm text-avcs-text md:col-span-2">
                      <input
                        type="checkbox"
                        className="mt-0.5"
                        checked={ndAddContact}
                        onChange={(event) => setNdAddContact(event.target.checked)}
                      />
                      <span>
                        Add a contact for this producer
                        <span className="block text-xs text-avcs-muted">
                          Created as the producer's primary contact. More detail (address, VAT, GLN)
                          can be captured later on the entity screen.
                        </span>
                      </span>
                    </label>
                    {ndAddContact && (
                      <>
                        <label className="grid gap-1 text-sm text-avcs-text">
                          First name *
                          <input
                            className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                            value={ndContactForm.firstName}
                            onChange={(event) => setNdContactForm((prev) => ({ ...prev, firstName: event.target.value }))}
                          />
                        </label>
                        <label className="grid gap-1 text-sm text-avcs-text">
                          Last name
                          <input
                            className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                            value={ndContactForm.lastName}
                            onChange={(event) => setNdContactForm((prev) => ({ ...prev, lastName: event.target.value }))}
                          />
                        </label>
                        <label className="grid gap-1 text-sm text-avcs-text">
                          Email
                          <input
                            type="email"
                            className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                            value={ndContactForm.email}
                            onChange={(event) => setNdContactForm((prev) => ({ ...prev, email: event.target.value }))}
                          />
                        </label>
                        <label className="grid gap-1 text-sm text-avcs-text">
                          Phone number
                          <input
                            className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                            value={ndContactForm.phoneNo}
                            onChange={(event) => setNdContactForm((prev) => ({ ...prev, phoneNo: event.target.value }))}
                          />
                        </label>
                      </>
                    )}
                  </div>
                )}
              </div>

              <label className="grid gap-1 text-sm text-avcs-text">
                Supply chain
                <select
                  className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                  value={ndValueChainId}
                  onChange={(event) => setNdValueChainId(event.target.value)}
                >
                  <option value="">Deal Matrix — no Supply Chain Program</option>
                  {activeChains.map((vc) => (
                    <option key={vc.id} value={vc.id}>{vc.name}</option>
                  ))}
                </select>
                <span className="text-xs text-avcs-muted">
                  {selectedChain
                    ? selectedChain.isScp
                      ? `Runs under the ${selectedChain.name} Supply Chain Program.`
                      : `Runs through ${selectedChain.name}, which is not an SCP — the deal sits in the Deal Matrix.`
                    : 'The deal sits in the Deal Matrix — not part of a Supply Chain Program.'}
                </span>
              </label>

              <div className="sticky bottom-0 z-10 mt-2 flex flex-wrap items-center gap-3 border-t border-[#1e6bb824] bg-white py-3 md:col-span-2">
                <button type="submit" className="btn primary" disabled={ndSaving}>
                  {ndSaving ? 'Creating deal…' : 'Create deal'}
                </button>
                <span className="text-xs text-avcs-muted">A new deal starts as Active. Status can be changed later from the deal overview.</span>
              </div>
            </form>
          </>
        )}
        </div>
        <div ref={setNdFooterSlot} className="avcs-wizard-footer" />

        {renderCaptureModals()}
      </section>
    );
  };

  // The two capture modals -- event-capture (registration / receive /
  // vaccination file) and journey -- shared by the new-deal wizard and the
  // View-deal screen. `captureModalDeal` names whichever deal they are open on.
  const renderCaptureModals = () => (
    <>
      {ndEventModalKind && !ndEventInline && (
        <div className="fixed inset-0 z-[150] overflow-y-auto bg-black/45 p-3 md:p-6">
          <div className="mx-auto w-full max-w-5xl rounded-2xl bg-[#eef4fa] p-3 shadow-2xl md:p-4">
            <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
              <div>
                <p className="text-base font-semibold text-avcs-text">
                  {(ND_EVENT_KIND_COPY[ndEventModalKind] || ND_EVENT_KIND_COPY.DEFAULT).title}
                  {captureModalDeal ? ` — deal ${captureModalDeal.label}` : ''}
                </p>
                <p className="text-xs text-avcs-muted">
                  {(ND_EVENT_KIND_COPY[ndEventModalKind] || ND_EVENT_KIND_COPY.DEFAULT).hint} The modal closes on its own once the event is created.
                </p>
              </div>
              <button type="button" className="btn primary" onClick={closeNdEventCapture}>
                ← Back to deal
              </button>
            </div>
            {renderDataSessionUpload()}
          </div>
        </div>
      )}

      {ndShowJourneyModal && !ndJourneyInline && (
        <div className="fixed inset-0 z-[150] overflow-y-auto bg-black/45 p-3 md:p-6">
          <div className="mx-auto w-full max-w-5xl rounded-2xl bg-[#eef4fa] p-3 shadow-2xl md:p-4">
            <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
              <div>
                <p className="text-base font-semibold text-avcs-text">
                  Add journey{captureModalDeal ? ` — deal ${captureModalDeal.label}` : ''}
                </p>
                <p className="text-xs text-avcs-muted">
                  Pick this deal's receive event, then capture the journey — transporter, driver,
                  truck, km readings, removal certificate, animals down.
                </p>
              </div>
              <button type="button" className="btn primary" onClick={closeNdJourneyCapture}>
                ← Back to deal
              </button>
            </div>
            {renderTransportJourneys()}
          </div>
        </div>
      )}
    </>
  );

  const renderAddWool = () => {
    const soldWoolEvents = woolEvents.filter((e) => woolBooked[e.id]?.sale);
    const listedWoolEvents = showSoldWool ? woolEvents : woolEvents.filter((e) => !woolBooked[e.id]?.sale);
    const picked = woolEvents.filter((e) => woolEventIds.includes(e.id));
    const byDeal = new Map<string, { title: string; head: number }>();
    picked.forEach((e) => {
      const key = e.dealId || e.id;
      const cur = byDeal.get(key) || { title: e.dealNo || e.dealName || key, head: 0 };
      cur.head += e.animalCount;
      byDeal.set(key, cur);
    });
    const dealsShorn = Array.from(byDeal.entries()).map(([id, v]) => ({ id, ...v }));
    const headTotal = dealsShorn.reduce((s, d) => s + d.head, 0);
    const shareOf = (total: number, head: number) => (headTotal > 0 ? (total * head) / headTotal : 0);
    const kg = parseTypedNumber(woolKg);
    const shearing = parseTypedNumber(woolShearing.amount);
    const packs = parseTypedNumber(woolPacks.amount);
    const sale = parseTypedNumber(woolSale.amount);
    const broker = parseTypedNumber(woolBroker);
    const typedButUnread = [['broker charges', woolBroker, broker], ['shearing', woolShearing.amount, shearing], ['wool packs', woolPacks.amount, packs], ['account sale', woolSale.amount, sale], ['wool kg', woolKg, kg]].filter(([, raw, n]) => String(raw).trim() !== '' && (n as number) <= 0).map(([l]) => l as string);
    const anyMoney = shearing > 0 || packs > 0 || sale > 0 || broker > 0;
    const canSave = picked.length > 0 && anyMoney && typedButUnread.length === 0 && !woolSaving && (sale <= 0 || Boolean(woolSale.date)) && (shearing <= 0 || Boolean(woolShearing.date)) && (packs <= 0 || Boolean(woolPacks.date));
    const eventLabel = (e: SharedFinanceEventOption) => `${e.dealNo || e.dealName || ''} · ${e.eventDate || '—'} · ${fmtNum(e.animalCount)} sheep${e.entityName ? ` · ${e.entityName}` : ''}`;

    const submit = async (event: React.FormEvent) => {
      event.preventDefault();
      if (!canSave) return;
      setWoolSaving(true); setWoolError(''); setWoolSuccess('');
      const today = new Date().toISOString().slice(0, 10);
      const made: string[] = [];
      try {
        if (shearing > 0) {
          await createSharedFinance({ recordType: 'SHEARING', amount: String(shearing), invoiceDate: woolShearing.date || today, basis: 'EVENT_ANIMALS', basisEventIds: woolEventIds, description: `Shearing${woolShearing.reference ? ` — ${woolShearing.reference}` : ''}`, referenceNumber: woolShearing.reference || undefined, document: woolShearing.file });
          made.push(`shearing R ${shearing.toFixed(2)}`);
        }
        if (packs > 0) {
          await createSharedFinance({ recordType: 'OTHER_COST', amount: String(packs), invoiceDate: woolPacks.date || today, basis: 'EVENT_ANIMALS', basisEventIds: woolEventIds, description: `Wool packs${woolPacks.reference ? ` — ${woolPacks.reference}` : ''}`, referenceNumber: woolPacks.reference || undefined, document: woolPacks.file });
          made.push(`wool packs R ${packs.toFixed(2)}`);
        }
        if (sale > 0) {
          await createSharedFinance({ recordType: 'WOOL_SALE', amount: String(sale), quantityKg: kg > 0 ? String(kg) : undefined, invoiceDate: woolSale.date || today, basis: 'EVENT_ANIMALS', basisEventIds: woolEventIds, description: `Wool sale${woolSale.reference ? ` — ${woolSale.reference}` : ''}${kg > 0 ? ` (${kg.toLocaleString('en-ZA')} kg)` : ''}`, referenceNumber: woolSale.reference || undefined, document: woolSale.file });
          made.push(`wool sale R ${sale.toFixed(2)}${kg > 0 ? ` / ${kg.toLocaleString('en-ZA')} kg` : ''}`);
        }
        if (broker > 0) {
          await createSharedFinance({ recordType: 'OTHER_COST', amount: String(broker), invoiceDate: woolSale.date || today, basis: 'EVENT_ANIMALS', basisEventIds: woolEventIds, description: `Wool broker charges${woolSale.reference ? ` — ${woolSale.reference}` : ''}`, referenceNumber: woolSale.reference || undefined, document: null });
          made.push(`broker charges R ${broker.toFixed(2)}`);
        }
        setWoolSuccess(`Recorded ${made.join(', ')} across ${dealsShorn.length} deal${dealsShorn.length === 1 ? '' : 's'} by sheep shorn (${fmtNum(headTotal)} sheep): ${dealsShorn.map((d) => `${d.title} ${fmtNum(d.head)}`).join(', ')}.`);
        setWoolBooked((prev) => {
          const next = { ...prev };
          woolEventIds.forEach((id) => { next[id] = { ...(next[id] || { sale: false, shearing: false, packs: false, broker: false }), sale: next[id]?.sale || sale > 0, shearing: next[id]?.shearing || shearing > 0, packs: next[id]?.packs || packs > 0, broker: next[id]?.broker || broker > 0 }; });
          if (sale > 0) setWoolEventIds([]);
          return next;
        });
        setWoolKg(''); setWoolShearing(blankWoolLine()); setWoolPacks(blankWoolLine()); setWoolSale(blankWoolLine()); setWoolBroker('');
        loadDeals();
      } catch (error: any) {
        setWoolError(parseApiError(error?.message) || error?.message || 'Could not record the wool.');
      } finally {
        setWoolSaving(false);
      }
    };

    const line = (label: string, hint: string, value: WoolLine, set: (v: WoolLine) => void, extra?: React.ReactNode) => (
      <div className="rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4">
        <p className="text-sm font-semibold text-avcs-text">{label}</p>
        <p className="mb-2 text-xs text-avcs-muted">{hint}</p>
        <div className="grid gap-3 md:grid-cols-4">
          <label className="grid gap-1 text-sm text-avcs-text">Amount (R, ex VAT)<input type="text" inputMode="decimal" placeholder="e.g. 5 828,00" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={value.amount} onChange={(e) => set({ ...value, amount: e.target.value })} /></label>
          <label className="grid gap-1 text-sm text-avcs-text">Date<input type="date" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={value.date} onChange={(e) => set({ ...value, date: e.target.value })} /></label>
          <label className="grid gap-1 text-sm text-avcs-text">Reference<input className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={value.reference} onChange={(e) => set({ ...value, reference: e.target.value })} /></label>
          {extra}
        </div>
        <div className="mt-2">
          <FileDropzone file={value.file} onFileChange={(file: File | null) => set({ ...value, file })} acceptedExtensions={['pdf', 'jpg', 'jpeg', 'png']} />
        </div>
      </div>
    );

    return (
      <section className="avcs-wizard rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
        <div className="admin-section-head mb-4 flex items-center justify-between gap-2">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">Add wool</h2>
            <p className="mt-0.5 text-sm text-avcs-muted">
              The clip and its money, divided by the sheep on the shearing sessions. Each deal gets its share of the kilograms, the shearing bill, the wool packs and the sale; per-sheep figures are the deal's share over its sheep shorn. Baling is captured separately for Virtual Routez and carries no money.
            </p>
          </div>
          <button className="admin-inline-action btn" type="button" onClick={resetAddWool}>Clear</button>
        </div>
        {woolError && <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{woolError}</div>}
        {typedButUnread.length > 0 && <div className="mb-3 rounded-lg border border-[#e7d3a6] bg-[#fdf6e7] px-3 py-2 text-sm text-[#5c4300]">Could not read the figure typed for {typedButUnread.join(', ')} — enter a number such as 7 180,02 or 7180.02.</div>}
        {woolSuccess && <div className="mb-3 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{woolSuccess}</div>}

        <form onSubmit={submit} className="space-y-4">
          <div className="rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4">
            <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
              <p className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Step 1 — Shearing sessions the clip came from</p>
              <div className="flex flex-wrap items-center gap-3">
                {soldWoolEvents.length > 0 && (
                  <label className="flex items-center gap-2 text-xs text-avcs-muted">
                    <input type="checkbox" checked={showSoldWool} onChange={(e) => { setShowSoldWool(e.target.checked); if (!e.target.checked) setWoolEventIds((prev) => prev.filter((id) => !woolBooked[id]?.sale)); }} /> Show {soldWoolEvents.length} already sold
                  </label>
                )}
                {listedWoolEvents.length > 0 && (
                  <label className="flex items-center gap-2 text-xs text-avcs-text">
                    <input type="checkbox" checked={listedWoolEvents.every((x) => woolEventIds.includes(x.id))} onChange={(e) => setWoolEventIds(e.target.checked ? listedWoolEvents.map((x) => x.id) : [])} /> Select all
                  </label>
                )}
              </div>
            </div>
            {woolEventsLoading && <p className="text-sm text-avcs-muted">Loading shearing sessions…</p>}
            {!woolEventsLoading && woolEvents.length > 0 && listedWoolEvents.length === 0 && <p className="text-sm text-avcs-muted">Every shearing session already has its wool sale booked. Upload the next shearing session first, or tick “Show already sold” to add a late cost to a sold clip.</p>}
            {!woolEventsLoading && woolEvents.length === 0 && <p className="text-sm text-avcs-muted">No shearing events yet. Upload the shearing session under Movement &amp; events (“Shearing at the feedlot”) first — the sheep on it are what everything is divided by.</p>}
            {listedWoolEvents.length > 0 && (
              <div className="grid gap-1 sm:grid-cols-2">
                {listedWoolEvents.map((e) => {
                  const checked = woolEventIds.includes(e.id);
                  const b = woolBooked[e.id];
                  const done = [b?.shearing && 'shearing', b?.packs && 'packs', b?.sale && 'sale', b?.broker && 'broker'].filter(Boolean) as string[];
                  return (
                    <label key={e.id} className={`flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm ${checked ? 'bg-[#f1f7ff]' : 'hover:bg-[#fbfeff]'} ${b?.sale ? 'opacity-70' : ''}`}>
                      <input type="checkbox" checked={checked} onChange={() => setWoolEventIds((prev) => (prev.includes(e.id) ? prev.filter((x) => x !== e.id) : [...prev, e.id]))} />
                      <span className="flex-1">{eventLabel(e)}</span>
                      {done.length > 0 && <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${b?.sale ? 'bg-[#e7f8ee] text-[#106b38]' : 'bg-[#fdf6e7] text-[#5c4300]'}`}>{b?.sale ? 'Sold' : 'Costs'}: {done.join(' · ')}</span>}
                    </label>
                  );
                })}
              </div>
            )}
            {picked.length > 0 && (
              <p className="mt-2 text-xs text-avcs-muted">{fmtNum(headTotal)} sheep shorn across {dealsShorn.length} deal{dealsShorn.length === 1 ? '' : 's'}: {dealsShorn.map((d) => `${d.title} ${fmtNum(d.head)}`).join(', ')}.</p>
            )}
          </div>

          <div className="rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4">
            <p className="text-sm font-semibold text-avcs-text">Step 2 — The clip</p>
            <label className="mt-2 grid max-w-xs gap-1 text-sm text-avcs-text">Total wool shorn (kg)<input type="text" inputMode="decimal" placeholder="e.g. 397,2" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={woolKg} onChange={(e) => setWoolKg(e.target.value)} /></label>
            <p className="mt-1 text-xs text-avcs-muted">Divided by sheep shorn; rides with the wool sale so each deal has its kilograms{headTotal > 0 && kg > 0 ? ` — ${(kg / headTotal).toFixed(2)} kg per sheep` : ''}.</p>
          </div>

          {line('Step 3 — Shearing bill', 'The shearer’s invoice (e.g. HAC). Booked to each deal as a shearing cost.', woolShearing, setWoolShearing)}
          {line('Step 4 — Wool packs', 'Wool pack invoices (e.g. Kyto wolsakke). Booked as other cost.', woolPacks, setWoolPacks)}
          {line('Step 5 — Account sale', 'The broker’s account sale. Enter the gross ex VAT as the amount; broker charges go in the box alongside and are booked as other cost, so the deal shows gross income and its charges, not the net cheque.', woolSale, setWoolSale,
            <label className="grid gap-1 text-sm text-avcs-text">Broker charges (R)<input type="text" inputMode="decimal" placeholder="e.g. 7 180,02" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={woolBroker} onChange={(e) => setWoolBroker(e.target.value)} /></label>)}

          {picked.length > 0 && (anyMoney || kg > 0) && (
            <div className="rounded-xl border border-[#1e6bb824] bg-white p-3">
              <div className="mb-1 text-sm font-semibold text-avcs-text">Split by sheep shorn</div>
              <div className="admin-table-scroll overflow-x-auto">
                <table className="w-full min-w-[640px] text-sm">
                  <thead><tr className="text-left text-xs uppercase tracking-wide text-avcs-muted"><th className="px-2 py-1">Deal</th><th className="px-2 py-1 text-right">Sheep</th><th className="px-2 py-1 text-right">Wool kg</th><th className="px-2 py-1 text-right">Shearing</th><th className="px-2 py-1 text-right">Packs</th><th className="px-2 py-1 text-right">Sale</th><th className="px-2 py-1 text-right">Broker</th><th className="px-2 py-1 text-right">Income / sheep</th></tr></thead>
                  <tbody>
                    {dealsShorn.map((d) => (
                      <tr key={d.id} className="border-t border-[#1e6bb814]">
                        <td className="px-2 py-1 text-avcs-text">{d.title}</td>
                        <td className="px-2 py-1 text-right tabular-nums">{fmtNum(d.head)}</td>
                        <td className="px-2 py-1 text-right tabular-nums">{kg > 0 ? shareOf(kg, d.head).toFixed(1) : '—'}</td>
                        <td className="px-2 py-1 text-right tabular-nums">{shearing > 0 ? `R ${shareOf(shearing, d.head).toFixed(2)}` : '—'}</td>
                        <td className="px-2 py-1 text-right tabular-nums">{packs > 0 ? `R ${shareOf(packs, d.head).toFixed(2)}` : '—'}</td>
                        <td className="px-2 py-1 text-right font-semibold tabular-nums">{sale > 0 ? `R ${shareOf(sale, d.head).toFixed(2)}` : '—'}</td>
                        <td className="px-2 py-1 text-right tabular-nums">{broker > 0 ? `R ${shareOf(broker, d.head).toFixed(2)}` : '—'}</td>
                        <td className="px-2 py-1 text-right tabular-nums">{sale > 0 && d.head > 0 ? `R ${(shareOf(sale, d.head) / d.head).toFixed(2)}` : '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="flex flex-wrap items-center gap-2">
            <button type="submit" className="btn primary" disabled={!canSave}>{woolSaving ? 'Recording…' : 'Record wool across the deals'}</button>
            <span className="text-xs text-avcs-muted">Each figure needs a date. Lines left empty are skipped.</span>
          </div>
        </form>
      </section>
    );
  };

  const renderAddFeed = () => {
    const chosen = addFeedDealIds.map((id) => deals.find((d) => d.dealId === id)).filter(Boolean) as Deal[];
    const heads = chosen.map((d) => Number(d.headcount || 0));
    const headTotal = heads.reduce((a, b) => a + b, 0);
    const kgTotal = Number(addFeedForm.quantityKg) || 0;
    const costTotal = Number(addFeedForm.cost) || 0;
    const splitBy = (total: number, decimals: number) => {
      if (headTotal <= 0 || total <= 0) return chosen.map(() => 0);
      const f = 10 ** decimals;
      const parts = heads.map((h) => Math.round((total * h / headTotal) * f) / f);
      const remainder = Math.round((total - parts.reduce((a, b) => a + b, 0)) * f) / f;
      const largest = heads.indexOf(Math.max(...heads));
      parts[largest] = Math.round((parts[largest] + remainder) * f) / f;
      return parts;
    };
    const kgShares = splitBy(kgTotal, 3);
    const costShares = splitBy(costTotal, 2);
    const feedDocType = dealDocumentTypeOptions.find((o) => o.financeRecordType === 'FEED') || dealDocumentTypeOptions.find((o) => /feed/i.test(o.label));
    const dealResults = (() => {
      const q = addFeedDealSearch.trim().toLowerCase();
      const active = deals.filter((d) => d.status === 'Active' && !addFeedDealIds.includes(d.dealId));
      return (q ? active.filter((d) => formatDealOption(d).toLowerCase().includes(q)) : active).slice(0, 8);
    })();
    const feedlots = [...entityDirectory].sort((a, b) => {
      const fa = String(a.entityType || '').toUpperCase() === 'FEEDLOT' ? 0 : 1;
      const fb = String(b.entityType || '').toUpperCase() === 'FEEDLOT' ? 0 : 1;
      return fa - fb || a.entityName.localeCompare(b.entityName);
    });
    const canSave = chosen.length > 0 && Boolean(addFeedForm.entityId) && Boolean(addFeedForm.feedName.trim()) && costTotal > 0 && Boolean(addFeedForm.invoiceDate) && !addFeedSaving
      && (addFeedForm.docMode === 'existing' ? Boolean(addFeedForm.existingDocId) : true);

    const submit = async (event: React.FormEvent) => {
      event.preventDefault();
      if (!canSave) return;
      if (addFeedForm.docMode === 'upload' && addFeedForm.file && !feedDocType) {
        setAddFeedError('No document type carries the money kind Feed — set one on Master data → Document types (Feedlot Costs) before filing the invoice.');
        return;
      }
      setAddFeedSaving(true);
      setAddFeedError('');
      setAddFeedSuccess('');
      try {
        for (const [i, deal] of chosen.entries()) {
          let sourceDocumentId: string | undefined = addFeedForm.docMode === 'existing' ? addFeedForm.existingDocId : undefined;
          if (addFeedForm.docMode === 'upload' && addFeedForm.file && feedDocType) {
            const doc = await uploadDealDocument({
              dealId: deal.dealId,
              documentType: feedDocType.id,
              file: addFeedForm.file,
              dateOfDocument: addFeedForm.invoiceDate,
              referenceNumber: addFeedForm.referenceNumber || undefined,
              notes: chosen.length > 1 ? `Feed invoice split by head across ${chosen.length} deals.` : undefined,
              visibility: 'ALL',
            });
            sourceDocumentId = doc?.id ? String(doc.id) : undefined;
          }
          await createDealFeedRecord({
            dealId: deal.dealId,
            entityId: addFeedForm.entityId,
            description: addFeedForm.feedName.trim(),
            quantityKg: kgTotal > 0 ? String(kgShares[i]) : undefined,
            cost: String(costShares[i]),
            invoiceDate: addFeedForm.invoiceDate,
            sourceDocumentId,
          });
        }
        setAddFeedSuccess(`${addFeedForm.feedName.trim()} — R ${costTotal.toFixed(2)}${kgTotal > 0 ? ` and ${kgTotal.toLocaleString('en-ZA')} kg` : ''} recorded across ${chosen.length} deal${chosen.length === 1 ? '' : 's'} by head: ${chosen.map((d, i) => `${d.title} R ${costShares[i].toFixed(2)}`).join(', ')}. Each deal's animals get their share when it closes.`);
        setAddFeedForm((prev) => ({ ...prev, quantityKg: '', cost: '', referenceNumber: '', file: null, existingDocId: '' }));
        setAddFeedDealIds([]);
        loadDeals();
      } catch (error: any) {
        setAddFeedError(parseApiError(error?.message) || error?.message || 'Could not record the feed.');
      } finally {
        setAddFeedSaving(false);
      }
    };

    const feedOptions: SearchOrTypeOption[] = ndFeedSuggestions.map((f) => ({
      key: f.key,
      value: f.name,
      detail: f.description || f.nutritionalValue || '',
      badge: f.source === 'declared' ? `${f.uses} deal${f.uses === 1 ? '' : 's'}` : 'catalogue',
    }));

    return (
      <section className="avcs-wizard rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
        <div className="admin-section-head mb-4 flex items-center justify-between gap-2">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">Add feed</h2>
            <p className="mt-0.5 text-sm text-avcs-muted">
              One feed bill, one or more deals. The kilograms and the cost are split by head across the deals you pick and booked to each deal's ledger today; when a deal closes, its feed is spread onto its animals by their days at the feedlot.
            </p>
          </div>
          <button className="admin-inline-action btn" type="button" onClick={resetAddFeed}>Clear</button>
        </div>
        {addFeedError && <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{addFeedError}</div>}
        {addFeedSuccess && <div className="mb-3 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{addFeedSuccess}</div>}

        <form onSubmit={submit} className="space-y-4">
          <div className="rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4">
            <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-avcs-muted">Step 1 — Deals on the bill</p>
            {chosen.length > 0 && (
              <div className="mb-2 flex flex-wrap gap-2">
                {chosen.map((d, i) => (
                  <span key={d.dealId} className="inline-flex items-center gap-2 rounded-full border border-[#1e6bb833] bg-[#edf5ff] px-3 py-1 text-xs text-[#0f3b64]">
                    <span className="font-semibold">{d.title}</span>
                    <span className="text-avcs-muted">{fmtNum(heads[i])} head</span>
                    {costTotal > 0 && headTotal > 0 && <span className="text-avcs-muted">R {costShares[i].toFixed(2)}</span>}
                    <button type="button" className="text-avcs-muted hover:text-[#6b1010]" aria-label={`Remove ${d.title}`} onClick={() => setAddFeedDealIds((prev) => prev.filter((id) => id !== d.dealId))}>×</button>
                  </span>
                ))}
              </div>
            )}
            <div className="relative">
              <input
                className="w-full rounded-lg border border-dashed border-[#1e6bb84d] bg-white px-3 py-2 text-sm"
                placeholder={chosen.length ? 'Add another deal on this bill…' : 'Search a deal by number or producer…'}
                value={addFeedDealSearch}
                onChange={(e) => { setAddFeedDealSearch(e.target.value); setAddFeedShowDeals(true); }}
                onFocus={() => setAddFeedShowDeals(true)}
                onBlur={() => setTimeout(() => setAddFeedShowDeals(false), 150)}
                autoComplete="off"
              />
              {addFeedShowDeals && dealResults.length > 0 && (
                <div className="absolute left-0 right-0 top-full z-20 mt-1 max-h-56 overflow-auto rounded-lg border border-[#1e6bb833] bg-white shadow-lg">
                  {dealResults.map((d) => (
                    <button key={d.dealId} type="button" className="w-full border-b border-[#1e6bb812] px-3 py-2 text-left text-sm text-avcs-text hover:bg-[#edf5ff] last:border-0" onMouseDown={(ev) => ev.preventDefault()} onClick={() => { setAddFeedDealIds((prev) => [...prev, d.dealId]); setAddFeedDealSearch(''); setAddFeedShowDeals(false); }}>
                      <span className="font-medium">{formatDealOption(d)}</span> <span className="text-xs text-avcs-muted">· {fmtNum(d.headcount || 0)} head</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
            <p className="mt-2 text-xs text-avcs-muted">{chosen.length} deal{chosen.length === 1 ? '' : 's'} · {fmtNum(headTotal)} animals. The split is by head: a deal with a third of the animals carries a third of the bill.</p>
          </div>

          <div className="rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4">
            <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-avcs-muted">Step 2 — The bill</p>
            {/* .afield pins each field's contents to the top and gives every
                control one height, so the three controls on a row share a
                baseline whether or not a neighbour carries a hint. */}
            <div className="afield-row afield-row-3">
              <div className="afield">
                <label className="afield-label" htmlFor="add-feed-name">Feed <span className="afield-req">*</span></label>
                <SearchOrType
                  id="add-feed-name"
                  value={addFeedForm.feedName}
                  onChange={(next) => setAddFeedForm((prev) => ({ ...prev, feedName: next }))}
                  options={feedOptions}
                  loading={!ndFeedSuggestionsLoaded}
                  failed={ndFeedSuggestionsFailed}
                  onRetry={loadNdFeedSuggestions}
                  onOpen={() => { if (!ndFeedSuggestionsLoaded) loadNdFeedSuggestions(); }}
                  placeholder="Search feeds or type a new one"
                  freeTextNote="It will be recorded under this name."
                  emptyNote="No feeds captured yet. Type the name off the invoice."
                />
                <span className="afield-hint">Pick one that has been used before, or type a new name.</span>
              </div>
              <div className="afield">
                <label className="afield-label" htmlFor="add-feed-entity">Feedlot <span className="afield-req">*</span></label>
                <select id="add-feed-entity" value={addFeedForm.entityId} onChange={(e) => setAddFeedForm((prev) => ({ ...prev, entityId: e.target.value }))}>
                  <option value="">Select…</option>
                  {feedlots.map((en) => <option key={en.id} value={en.id}>{en.entityName}{String(en.entityType || '').toUpperCase() !== 'FEEDLOT' ? ` (${en.entityType})` : ''}</option>)}
                </select>
                <span className="afield-hint">Where it was eaten. Used at close for the per-animal split.</span>
              </div>
              <div className="afield">
                <label className="afield-label" htmlFor="add-feed-date">Invoice date <span className="afield-req">*</span></label>
                <input id="add-feed-date" type="date" value={addFeedForm.invoiceDate} onChange={(e) => setAddFeedForm((prev) => ({ ...prev, invoiceDate: e.target.value }))} />
                <span className="afield-hint">The date on the bill.</span>
              </div>
              <div className="afield afield-num">
                <label className="afield-label" htmlFor="add-feed-kg">Total feed (kg)</label>
                <input id="add-feed-kg" type="number" min="0" step="0.001" inputMode="decimal" value={addFeedForm.quantityKg} onChange={(e) => setAddFeedForm((prev) => ({ ...prev, quantityKg: e.target.value }))} />
                <span className="afield-hint">Optional — makes FCR measured.</span>
              </div>
              <div className="afield afield-num">
                <label className="afield-label" htmlFor="add-feed-cost">Total cost (R, ex VAT) <span className="afield-req">*</span></label>
                <input id="add-feed-cost" type="number" min="0" step="0.01" inputMode="decimal" value={addFeedForm.cost} onChange={(e) => setAddFeedForm((prev) => ({ ...prev, cost: e.target.value }))} />
                <span className="afield-hint">The whole bill — it is split by head.</span>
              </div>
              <div className="afield">
                <label className="afield-label" htmlFor="add-feed-ref">Invoice number</label>
                <input id="add-feed-ref" value={addFeedForm.referenceNumber} onChange={(e) => setAddFeedForm((prev) => ({ ...prev, referenceNumber: e.target.value }))} />
                <span className="afield-hint">Optional — shows on the ledger row.</span>
              </div>
            </div>
          </div>

          <div className="rounded-xl border border-[#1e6bb824] bg-[#f7fbff] p-4">
            <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-avcs-muted">Step 3 — Invoice document</p>
            {chosen.length === 1 && addFeedExistingDocs.length > 0 && (
              <div className="mb-2 flex flex-wrap gap-4 text-sm text-avcs-text">
                <label className="flex items-center gap-2"><input type="radio" checked={addFeedForm.docMode === 'existing'} onChange={() => setAddFeedForm((prev) => ({ ...prev, docMode: 'existing' }))} /> Use a document already filed on this deal</label>
                <label className="flex items-center gap-2"><input type="radio" checked={addFeedForm.docMode === 'upload'} onChange={() => setAddFeedForm((prev) => ({ ...prev, docMode: 'upload' }))} /> Upload a new document</label>
              </div>
            )}
            {addFeedForm.docMode === 'existing' && chosen.length === 1 ? (
              <select className="w-full rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm" value={addFeedForm.existingDocId} onChange={(e) => setAddFeedForm((prev) => ({ ...prev, existingDocId: e.target.value }))}>
                <option value="">Select the document…</option>
                {addFeedExistingDocs.map((d) => <option key={d.id} value={d.id}>{[d.documentTypeName || 'Document', d.referenceNumber, d.dateOfDocument].filter(Boolean).join(' · ')}</option>)}
              </select>
            ) : (
              <>
                <FileDropzone file={addFeedForm.file} onFileChange={(file: File | null) => setAddFeedForm((prev) => ({ ...prev, file }))} acceptedExtensions={['pdf', 'jpg', 'jpeg', 'png']} />
                <p className="mt-1 text-xs text-avcs-muted">Optional. Uploaded once and filed on every selected deal{feedDocType ? ` as "${feedDocType.label}"` : ''}; each deal's feed record points at its copy.</p>
              </>
            )}
          </div>

          {chosen.length > 0 && (costTotal > 0 || kgTotal > 0) && (
            <div className="rounded-xl border border-[#1e6bb824] bg-white p-3">
              <div className="mb-1 text-sm font-semibold text-avcs-text">Split by head</div>
              <table className="w-full text-sm">
                <thead><tr className="text-left text-xs uppercase tracking-wide text-avcs-muted"><th className="px-2 py-1">Deal</th><th className="px-2 py-1 text-right">Head</th><th className="px-2 py-1 text-right">Share</th><th className="px-2 py-1 text-right">Feed kg</th><th className="px-2 py-1 text-right">Cost</th></tr></thead>
                <tbody>
                  {chosen.map((d, i) => (
                    <tr key={d.dealId} className="border-t border-[#1e6bb814]">
                      <td className="px-2 py-1 text-avcs-text">{d.title}</td>
                      <td className="px-2 py-1 text-right tabular-nums">{fmtNum(heads[i])}</td>
                      <td className="px-2 py-1 text-right tabular-nums">{headTotal > 0 ? `${((heads[i] / headTotal) * 100).toFixed(1)}%` : '—'}</td>
                      <td className="px-2 py-1 text-right tabular-nums">{kgTotal > 0 ? kgShares[i].toLocaleString('en-ZA', { maximumFractionDigits: 3 }) : '—'}</td>
                      <td className="px-2 py-1 text-right font-semibold tabular-nums">R {costShares[i].toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div className="flex flex-wrap items-center gap-2">
            <button type="submit" className="btn primary" disabled={!canSave}>{addFeedSaving ? 'Recording…' : `Record feed on ${chosen.length || ''} deal${chosen.length === 1 ? '' : 's'}`}</button>
            <span className="text-xs text-avcs-muted">Books a FEED row on each deal's ledger now. Per-animal shares are worked out when each deal closes.</span>
          </div>
        </form>
      </section>
    );
  };

  const renderFeedCrud = () => (
    <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
      <div className="admin-section-head mb-4 flex items-center justify-between gap-2">
        <h2 className="text-2xl font-semibold text-avcs-text">Feed / consumption screen</h2>
        <button className="admin-inline-action btn" onClick={resetFeedForm}>Clear</button>
      </div>

      {loadingFeedData && <div className="mb-3 text-sm text-avcs-muted">Loading feed data…</div>}
      {feedCrudError && <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{feedCrudError}</div>}
      {feedCrudSuccess && <div className="mb-3 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{feedCrudSuccess}</div>}

      <div className="mb-4 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3">
        <h3 className="text-base font-semibold text-avcs-text">{editingFeedTypeId ? 'Edit feed type' : 'Create feed type'}</h3>
        <form className="mt-2 grid gap-3 md:grid-cols-2" onSubmit={submitFeedType}>
          <label className="grid gap-1 text-sm text-avcs-text">
            Feed name
            <input
              className="rounded-lg border border-[#1e6bb833] px-3 py-2"
              value={newFeedType.name}
              onChange={(event) => setNewFeedType((prev) => ({ ...prev, name: event.target.value }))}
            />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">
            Cost per kg (optional)
            <input
              type="number"
              min={0}
              step="0.01"
              className="rounded-lg border border-[#1e6bb833] px-3 py-2"
              value={newFeedType.costPerKg}
              onChange={(event) => setNewFeedType((prev) => ({ ...prev, costPerKg: event.target.value }))}
            />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">
            Stock qty (optional)
            <input
              type="number"
              min={0}
              step="1"
              className="rounded-lg border border-[#1e6bb833] px-3 py-2"
              value={newFeedType.stockQty}
              onChange={(event) => setNewFeedType((prev) => ({ ...prev, stockQty: event.target.value }))}
            />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text md:col-span-2">
            Description (optional)
            <input
              className="rounded-lg border border-[#1e6bb833] px-3 py-2"
              value={newFeedType.description}
              onChange={(event) => setNewFeedType((prev) => ({ ...prev, description: event.target.value }))}
            />
          </label>
          <div className="md:col-span-2 flex flex-wrap gap-2">
            <button className="btn" type="submit" disabled={creatingFeedType}>
              {creatingFeedType ? 'Saving feed type…' : editingFeedTypeId ? 'Save feed type' : 'Create feed type'}
            </button>
            {editingFeedTypeId && (
              <button className="btn" type="button" onClick={resetFeedTypeForm}>
                Cancel edit
              </button>
            )}
          </div>
        </form>

        <div className="admin-table-scroll mt-4 overflow-x-auto">
          <table className="min-w-full border-collapse">
            <thead>
              <tr>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Name</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Cost/kg</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Stock</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
              </tr>
            </thead>
            <tbody>
              {feedOptions.map((feed) => (
                <tr key={feed.id}>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{feed.name}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{feed.costPerKg ?? 0}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{feed.stockQty ?? 0}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                    <div className="flex gap-2">
                      <button className="btn" onClick={() => editFeedType(String(feed.id))}>Edit</button>
                      <button className={DELETE_BTN} onClick={async () => { if (await requestConfirm({ message: 'Delete this feed type? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) removeFeedType(String(feed.id)); }}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
              {feedOptions.length === 0 && (
                <tr>
                  <td colSpan={4} className="px-3 py-3 text-sm text-avcs-muted">No feed types yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <form className="grid gap-3 md:grid-cols-2" onSubmit={submitFeedRecord}>
        <label className="grid gap-1 text-sm text-avcs-text">
          Deal
          <select
            className="rounded-lg border border-[#1e6bb833] px-3 py-2"
            value={feedForm.dealId}
            onChange={(event) => {
              const nextDealId = event.target.value;
              setFeedForm((prev) => ({ ...prev, dealId: nextDealId }));
              setSelectedDealId(nextDealId);
            }}
          >
            <option value="">Select deal</option>
            {deals.map((deal) => (
              <option key={deal.dealId} value={deal.dealId}>{deal.title}</option>
            ))}
          </select>
        </label>
        <label className="grid gap-1 text-sm text-avcs-text">
          Feed type
          <select
            className="rounded-lg border border-[#1e6bb833] px-3 py-2"
            value={feedForm.feedId}
            onChange={(event) => {
              const selected = feedOptions.find((feed) => String(feed.id) === String(event.target.value));
              setFeedForm((prev) => ({
                ...prev,
                feedId: event.target.value,
                feedType: selected?.name || '',
              }));
            }}
          >
            <option value="">Select feed</option>
            {feedOptions.map((feed) => (
              <option key={feed.id} value={feed.id}>{feed.name}</option>
            ))}
          </select>
        </label>
        <label className="grid gap-1 text-sm text-avcs-text">
          Quantity (kg)
          <input type="number" min={0} className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={feedForm.quantityKg} onChange={(event) => setFeedForm((prev) => ({ ...prev, quantityKg: Number(event.target.value || 0) }))} />
        </label>
        <label className="grid gap-1 text-sm text-avcs-text">
          Date
          <input type="date" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={feedForm.date} onChange={(event) => setFeedForm((prev) => ({ ...prev, date: event.target.value }))} />
        </label>
        <div className="md:col-span-2 flex flex-wrap gap-2">
          <button className="admin-submit-action btn primary" type="submit">{editingFeedId ? 'Update record' : 'Create record'}</button>
        </div>
      </form>

      <div className="admin-table-scroll mt-5 overflow-x-auto">
        <table className="min-w-full border-collapse">
          <thead>
            <tr>
              <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Deal</th>
              <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Feed type</th>
              <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Quantity</th>
              <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Date</th>
              <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
            </tr>
          </thead>
          <tbody>
            {feedRecords.map((record) => {
              const deal = deals.find((row) => row.dealId === record.dealId);
              return (
                <tr key={record.id}>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{deal?.title || record.dealId}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{record.feedType}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{record.quantityKg} kg</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{fmtDate(record.date)}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                    <div className="flex gap-2">
                      <button className="btn" onClick={() => editFeedRecord(record.id)}>Edit</button>
                      <button className={DELETE_BTN} onClick={async () => { if (await requestConfirm({ message: 'Delete this feed record? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) deleteFeedRecord(record.id); }}>Delete</button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );

  const renderAnimalList = () => {
    const fmtLocation = (loc: AnimalLocationEntry['current_location']) => {
      if (!loc) return '—';
      if (loc.entity_type === 'IN_TRANSIT') return `${loc.source_entity_name || '—'} → ${loc.destination_entity_name || '—'}`;
      return loc.entity_name || '—';
    };
    const totalPages = Math.max(1, Math.ceil(flatAnimalRows.length / ANIMAL_LIST_PAGE_SIZE));
    const currentPage = Math.min(animalListPage, totalPages);
    const pageStart = (currentPage - 1) * ANIMAL_LIST_PAGE_SIZE;
    const pageRows = flatAnimalRows.slice(pageStart, pageStart + ANIMAL_LIST_PAGE_SIZE);
    // Slaughter-view rows filtered by the same search box (matches identity +
    // any raw field value).
    const slaughterSearch = animalSearch.trim().toLowerCase();
    const slaughterFilteredRows = slaughterSearch
      ? slaughterRawRows.filter((r) =>
          [r.eid, r.vid, r.species, r.status, r.deal_no, ...Object.values(r.raw_data || {})]
            .filter((v) => v != null && v !== '')
            .join(' ')
            .toLowerCase()
            .includes(slaughterSearch))
      : slaughterRawRows;
    // When scoped to a single deal, surface which deal in the heading — deal
    // number, primary producer, and species — so the user always knows the
    // deal they're working on.
    const filterDeal = animalListDealFilter ? deals.find((d) => d.dealId === animalListDealFilter) : null;
    const filterDealSpecies = filterDeal?.species
      ? filterDeal.species.charAt(0) + filterDeal.species.slice(1).toLowerCase()
      : '';
    const filterDealSubtitle = filterDeal
      ? [filterDeal.counterpart, filterDealSpecies].filter((part) => part && part !== '—').join(' · ')
      : '';
    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">
              {filterDeal ? `Animal list — ${filterDeal.title}` : 'Animal list'}
            </h2>
            <p className="mt-1 text-sm text-avcs-muted">
              {filterDeal
                ? (filterDealSubtitle
                    ? `${filterDealSubtitle} · Click an EID for full detail.`
                    : 'Animals for the selected deal. Click an EID for full detail.')
                : 'All animals across every deal. Filter to find one quickly, then click an EID for full detail.'}
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {animalListDealFilter && (
              <button
                type="button"
                className="btn whitespace-nowrap"
                onClick={() => { setSelectedDealId(animalListDealFilter); setView('dealSummary'); }}
              >
                ← Back to deal details
              </button>
            )}
            {animalListDealFilter && (
              <button type="button" className="btn whitespace-nowrap" onClick={() => setAnimalListDealFilter(null)}>Show all animals</button>
            )}
            {hasDeals && (
              <button className="btn primary whitespace-nowrap px-4" onClick={() => { resetAnimalForm(); setAnimalForm((prev) => ({ ...prev, dealId: selectedDealId || '' })); setView('animalCrud'); }}>Add animal</button>
            )}
          </div>
        </div>

        {animalCrudError && <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{animalCrudError}</div>}
        {animalCrudSuccess && <div className="mb-3 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{animalCrudSuccess}</div>}
        {allAnimalsError && <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{allAnimalsError}</div>}

        {animalListDealFilter && (
          <div className="mb-3 flex flex-wrap items-center gap-2 rounded-lg border border-[#1e6bb84d] bg-[#f1f7ff] px-3 py-2 text-sm text-[#154f89]">
            <span>Showing animals for the selected deal only.</span>
          </div>
        )}

        <div className="mb-3 grid gap-2 md:grid-cols-[1fr_auto] md:items-center">
          <input
            className="rounded-lg border border-[#1e6bb833] px-3 py-2 text-sm"
            placeholder="Filter by EID, deal, producer, location, GLN, status…"
            value={animalSearch}
            onChange={(event) => setAnimalSearch(event.target.value)}
          />
          <div className="text-sm text-avcs-muted">
            {animalListMode === 'slaughter'
              ? (slaughterRawLoading
                  ? 'Loading slaughter data…'
                  : `${slaughterFilteredRows.length} animal${slaughterFilteredRows.length === 1 ? '' : 's'} with slaughter data${animalSearch.trim() ? ` (filtered from ${slaughterRawRows.length})` : ''}`)
              : (allAnimalsLoading
                  ? 'Loading animals…'
                  : flatAnimalRows.length === 0
                    ? 'No animals'
                    : `Showing ${pageStart + 1}–${Math.min(pageStart + ANIMAL_LIST_PAGE_SIZE, flatAnimalRows.length)} of ${flatAnimalRows.length}${animalSearch.trim() ? ` (filtered from ${allAnimals.length})` : ''} animals`)}
          </div>
        </div>

        <div className="mb-3 inline-flex rounded-lg border border-[#1e6bb833] p-0.5 text-sm">
          <button
            type="button"
            className={`rounded-md px-3 py-1.5 font-medium transition ${animalListMode === 'standard' ? 'bg-[#1e6bb8] text-white' : 'text-avcs-muted hover:text-avcs-text'}`}
            onClick={() => setAnimalListMode('standard')}
          >
            Standard
          </button>
          <button
            type="button"
            className={`rounded-md px-3 py-1.5 font-medium transition ${animalListMode === 'slaughter' ? 'bg-[#1e6bb8] text-white' : 'text-avcs-muted hover:text-avcs-text'}`}
            onClick={() => setAnimalListMode('slaughter')}
          >
            Slaughter data
          </button>
        </div>

        {animalListMode === 'standard' && (
        <div className="admin-table-scroll animal-table-scroll overflow-x-auto">
          <table className="min-w-full border-collapse">
            <thead>
              <tr>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">EID</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Species</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Status</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Deal</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Primary producer</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Current location</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">GLN</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
              </tr>
            </thead>
            <tbody>
              {pageRows.map((animal) => (
                <tr key={animal.animal_id} className="hover:bg-[#f8fbff]">
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm font-medium">
                    <button type="button" className="font-medium text-[#1e6bb8] hover:underline" onClick={() => openAnimalDetail(animal.animal_id)}>{animal.eid_tag || animal.vid || '—'}</button>
                  </td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text capitalize">{animal.species ? animal.species.toLowerCase() : '—'}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{animal.status || '—'}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{animal.deal_no || '—'}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{animal.primaryProducerName || '—'}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                    {animal.current_location?.entity_type === 'IN_TRANSIT'
                      ? <span className="inline-flex items-center rounded-full bg-[#fdf3e0] px-2 py-0.5 text-xs font-medium text-[#8a5a12]">In transit</span>
                      : fmtLocation(animal.current_location)}
                  </td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{animal.current_location?.gln || animal.current_location?.destination_gln || '—'}</td>
                  <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                    <div className="flex gap-2">
                      <button className={DELETE_BTN} disabled={deletingAnimalId === animal.animal_id} onClick={async () => { if (await requestConfirm({ message: 'Delete this animal? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) handleDeleteAnimal(animal.animal_id); }}>{deletingAnimalId === animal.animal_id ? 'Deleting…' : 'Delete'}</button>
                    </div>
                  </td>
                </tr>
              ))}
              {flatAnimalRows.length === 0 && (
                <tr>
                  <td colSpan={8} className="px-3 py-3 text-sm text-avcs-muted">{allAnimalsLoading ? 'Loading animals…' : allAnimals.length === 0 ? 'No animal data available yet.' : 'No animals match your filter.'}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        )}

        {animalListMode === 'slaughter' && (
          slaughterRawError ? (
            <div className="rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{slaughterRawError}</div>
          ) : (
          <div className="admin-table-scroll animal-table-scroll slaughter-raw-scroll overflow-x-auto">
            <table className="min-w-full border-collapse">
              <thead>
                <tr>
                  {['Tag / EID', 'Species', 'Status', 'Deal', ...slaughterRawColumns].map((h, i) => (
                    <th key={`${h}-${i}`} className="whitespace-nowrap border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {slaughterFilteredRows.map((row) => (
                  <tr key={row.animal_id} className="hover:bg-[#f8fbff]">
                    <td className="whitespace-nowrap border-b border-[#1e6bb814] px-3 py-2 text-sm font-medium">
                      <button type="button" className="font-medium text-[#1e6bb8] hover:underline" onClick={() => openAnimalDetail(row.animal_id)}>{row.eid || row.vid || '—'}</button>
                    </td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm capitalize text-avcs-text">{row.species ? String(row.species).toLowerCase() : '—'}</td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.status || '—'}</td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.deal_no || '—'}</td>
                    {slaughterRawColumns.map((col) => {
                      const val = row.raw_data ? (row.raw_data as Record<string, unknown>)[col] : undefined;
                      const text = val == null || val === '' ? '—' : String(val);
                      return (
                        <td key={col} className="whitespace-nowrap border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{text}</td>
                      );
                    })}
                  </tr>
                ))}
                {slaughterFilteredRows.length === 0 && (
                  <tr>
                    <td colSpan={slaughterRawColumns.length + 4} className="px-3 py-3 text-sm text-avcs-muted">
                      {slaughterRawLoading
                        ? 'Loading slaughter data…'
                        : slaughterRawRows.length === 0
                          ? (animalListDealFilter ? 'No abattoir-slaughter data uploaded for this deal’s animals yet.' : 'No abattoir-slaughter data uploaded yet.')
                          : 'No animals match your filter.'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          )
        )}

        {animalListMode === 'standard' && totalPages > 1 && (
          <div className="mt-3 flex flex-wrap items-center justify-end gap-2 text-sm text-avcs-muted">
            <button
              type="button"
              className="rounded-lg border border-[#1e6bb824] bg-white px-3 py-1.5 text-sm text-avcs-text disabled:opacity-40"
              disabled={currentPage <= 1}
              onClick={() => setAnimalListPage((prev) => Math.max(1, prev - 1))}
            >
              Previous
            </button>
            <span className="text-avcs-text">Page {currentPage} of {totalPages}</span>
            <button
              type="button"
              className="rounded-lg border border-[#1e6bb824] bg-white px-3 py-1.5 text-sm text-avcs-text disabled:opacity-40"
              disabled={currentPage >= totalPages}
              onClick={() => setAnimalListPage((prev) => Math.min(totalPages, prev + 1))}
            >
              Next
            </button>
          </div>
        )}
      </section>
    );
  };

  const renderWeightChart = (weightsInput: AnimalWeightRecord[], events: AnimalEventRow[] = []) => {
    // Sort by date, then value-chain step (farm → feedlot → abattoir), so
    // same-day weigh-ins plot in lifecycle order rather than insertion order.
    const weights = [...(weightsInput || [])].sort(
      (a, b) =>
        (Date.parse(a.weigh_date || '') || 0) - (Date.parse(b.weigh_date || '') || 0) ||
        weightRecordRank(a.weight_type) - weightRecordRank(b.weight_type)
    );
    const fmtDate = (d: string, opts?: Intl.DateTimeFormatOptions) =>
      d ? new Date(d).toLocaleDateString('en-ZA', opts || { day: '2-digit', month: 'short', year: '2-digit' }) : '';

    // Map each event to its calendar date — used ONLY to disambiguate the
    // ambiguous CURRENT weight type (Farm weigh vs Feedlot weigh), which has no
    // 1:1 event type. Every other point is labelled from its own weight_type.
    const eventLabelByDate = new Map<string, string>();
    events.forEach((e) => {
      const key = (e.event_date || '').slice(0, 10);
      if (!key) return;
      const label = EVENT_TYPE_LABELS[e.event_type || ''] || e.event_type || '';
      if (label && !eventLabelByDate.has(key)) eventLabelByDate.set(key, label);
    });

    // Per-point label from the record's own weight_type (not date-matched), so
    // points that share a calendar date keep their distinct labels.
    const labelForWeight = (w: AnimalWeightRecord): string => {
      const wt = (w.weight_type || '').toUpperCase();
      const dateKey = (w.weigh_date || '').slice(0, 10);
      if (wt === 'CURRENT') return eventLabelByDate.get(dateKey) || 'Weigh';
      const evType = WEIGHT_TYPE_TO_EVENT_TYPE[wt];
      if (evType) return EVENT_TYPE_LABELS[evType] || evType;
      return WEIGHT_TYPE_LABELS[wt] || eventLabelByDate.get(dateKey) || '';
    };

    if (!weights || weights.length === 0) {
      return (
        <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-[#1e6bb833] bg-[#f8fbff] px-4 py-10 text-center">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#9db2c6" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M3 3v18h18" /><path d="m19 9-5 5-4-4-3 3" />
          </svg>
          <p className="mt-2 text-sm text-avcs-muted">No weight records captured yet.</p>
        </div>
      );
    }

    if (weights.length === 1) {
      const only = weights[0];
      return (
        <div className="flex items-center justify-between rounded-xl border border-[#1e6bb824] bg-gradient-to-br from-[#f4f9ff] to-white px-4 py-4">
          <div>
            <div className="text-xs uppercase tracking-wide text-avcs-muted">Latest weight</div>
            <div className="text-3xl font-bold text-avcs-primary">{Number(only.weight).toFixed(1)}<span className="ml-1 text-base font-medium text-avcs-muted">kg</span></div>
          </div>
          <div className="text-right text-sm text-avcs-muted">
            <div>{fmtDate(only.weigh_date, { day: '2-digit', month: 'short', year: 'numeric' })}</div>
            <div className="mt-1 text-xs">One more record needed to chart a trend.</div>
          </div>
        </div>
      );
    }

    // Layout — generous padding so labels never clip.
    const W = 640;
    const H = 272;
    const padL = 46;
    const padR = 22;
    const padT = 40;
    const padB = 42;
    const plotW = W - padL - padR;
    const plotH = H - padT - padB;

    const values = weights.map((w) => Number(w.weight));
    const rawMin = Math.min(...values);
    const rawMax = Math.max(...values);
    // Pad the domain by 8% of the span (min 2kg) so the line sits off the edges.
    const pad = Math.max((rawMax - rawMin) * 0.08, 2);
    const domMin = Math.floor((rawMin - pad));
    const domMax = Math.ceil((rawMax + pad));
    const domSpan = domMax - domMin || 1;
    const n = weights.length;

    const xAt = (i: number) => padL + (n === 1 ? plotW / 2 : (i * plotW) / (n - 1));
    const yAt = (w: number) => padT + plotH - ((w - domMin) / domSpan) * plotH;

    // Smooth line via Catmull-Rom → cubic bezier.
    const pts = weights.map((w, i) => ({ x: xAt(i), y: yAt(Number(w.weight)) }));
    const linePath = pts.reduce((acc, p, i) => {
      if (i === 0) return `M ${p.x.toFixed(1)} ${p.y.toFixed(1)}`;
      const p0 = pts[i - 1];
      const pPrev = pts[i - 2] || p0;
      const pNext = pts[i + 1] || p;
      const c1x = p0.x + (p.x - pPrev.x) / 6;
      const c1y = p0.y + (p.y - pPrev.y) / 6;
      const c2x = p.x - (pNext.x - p0.x) / 6;
      const c2y = p.y - (pNext.y - p0.y) / 6;
      return `${acc} C ${c1x.toFixed(1)} ${c1y.toFixed(1)}, ${c2x.toFixed(1)} ${c2y.toFixed(1)}, ${p.x.toFixed(1)} ${p.y.toFixed(1)}`;
    }, '');
    const areaPath = `${linePath} L ${pts[n - 1].x.toFixed(1)} ${(padT + plotH).toFixed(1)} L ${pts[0].x.toFixed(1)} ${(padT + plotH).toFixed(1)} Z`;

    // Y gridlines / ticks.
    const ticks = 4;
    const gridY = Array.from({ length: ticks + 1 }, (_, i) => domMin + (domSpan * i) / ticks);

    // Only label every Nth x point when crowded, but always first & last.
    const labelEvery = Math.max(1, Math.ceil(n / 6));

    const gain = values[n - 1] - values[0];
    const gainPositive = gain >= 0;
    const gainColor = gainPositive ? '#0f8a4e' : '#c0392b';

    return (
      <div className="rounded-xl border border-[#1e6bb824] bg-white p-3 shadow-sm">
        <div className="mb-2 flex flex-wrap items-center justify-between gap-2 px-1">
          <div className="flex items-baseline gap-2">
            <span className="text-2xl font-bold text-avcs-text">{values[n - 1].toFixed(1)}</span>
            <span className="text-sm font-medium text-avcs-muted">kg latest</span>
          </div>
          <span
            className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold"
            style={{ backgroundColor: gainPositive ? '#e7f6ee' : '#fbecea', color: gainColor }}
          >
            <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              {gainPositive ? <><polyline points="3 11 8 6 11 9 14 5" /><polyline points="14 8 14 5 11 5" /></> : <><polyline points="3 5 8 10 11 7 14 11" /><polyline points="14 8 14 11 11 11" /></>}
            </svg>
            {gainPositive ? '+' : ''}{gain.toFixed(1)} kg overall
          </span>
        </div>
        <svg viewBox={`0 0 ${W} ${H}`} className="w-full" style={{ height: 'auto' }} role="img" aria-label="Weight gain over time">
          <defs>
            <linearGradient id="wgArea" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#1e6bb8" stopOpacity="0.22" />
              <stop offset="100%" stopColor="#1e6bb8" stopOpacity="0" />
            </linearGradient>
            <linearGradient id="wgLine" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="#1e6bb8" />
              <stop offset="100%" stopColor="#4a97e0" />
            </linearGradient>
          </defs>

          {/* Horizontal gridlines + y-axis labels */}
          {gridY.map((v, i) => {
            const y = yAt(v);
            return (
              <g key={`grid-${i}`}>
                <line x1={padL} y1={y} x2={W - padR} y2={y} stroke="#eef2f6" strokeWidth="1" />
                <text x={padL - 8} y={y + 3} textAnchor="end" fontSize="10" fill="#9aa8b4">{Math.round(v)}</text>
              </g>
            );
          })}
          <text x={14} y={padT + plotH / 2} textAnchor="middle" fontSize="10" fill="#9aa8b4" transform={`rotate(-90 14 ${padT + plotH / 2})`}>Weight (kg)</text>

          {/* Area + line */}
          <path d={areaPath} fill="url(#wgArea)" />
          <path d={linePath} fill="none" stroke="url(#wgLine)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />

          {/* Data points + value labels */}
          {weights.map((w, i) => {
            const cx = xAt(i);
            const cy = yAt(Number(w.weight));
            const evLabel = labelForWeight(w);
            // Always label points that carry an event; otherwise thin out when crowded.
            const showLabel = !!evLabel || i === 0 || i === n - 1 || i % labelEvery === 0;
            const anchor = i === 0 ? 'start' : i === n - 1 ? 'end' : 'middle';
            return (
              <g key={w.id}>
                {showLabel && evLabel && (
                  <text x={cx} y={cy - 26} textAnchor={anchor} fontSize="9" fontWeight="500" fill="#7a8794">{evLabel}</text>
                )}
                {showLabel && (
                  <text x={cx} y={cy - (evLabel ? 13 : 12)} textAnchor={anchor} fontSize="10.5" fontWeight="700" fill="#155089">{Number(w.weight).toFixed(0)} kg</text>
                )}
                <circle cx={cx} cy={cy} r="4.5" fill="#fff" stroke="#1e6bb8" strokeWidth="2.5" />
              </g>
            );
          })}

          {/* X-axis date labels */}
          {weights.map((w, i) => {
            const show = i === 0 || i === n - 1 || i % labelEvery === 0;
            if (!show) return null;
            const anchor = i === 0 ? 'start' : i === n - 1 ? 'end' : 'middle';
            return (
              <text key={`xl-${w.id}`} x={xAt(i)} y={H - 16} textAnchor={anchor} fontSize="9.5" fill="#7a8794">{fmtDate(w.weigh_date)}</text>
            );
          })}
        </svg>
      </div>
    );
  };

  const renderAnimalCrud = () => {
    const isExisting = !!editingAnimalId;
    const detail = animalDetail;
    const producerName = detail?.deal ? (dealOverviewById[String(detail.deal)]?.primary_producer?.entity_name || '') : '';
    const perf = animalDetailPerformance;
    const sexLabel = detail?.sex === 'M' ? 'Male' : detail?.sex === 'F' ? 'Female' : '—';
    const num = (v: any, d = 2) => (v == null ? '—' : Number(v).toFixed(d));
    // Map weight records to their calendar date so the event history table can
    // surface the weight captured on the day of each event.
    const weightByDate = new Map<string, AnimalWeightRecord>();
    animalDetailWeights.forEach((w) => {
      const key = (w.weigh_date || '').slice(0, 10);
      if (key) weightByDate.set(key, w);
    });
    const stat = (label: string, value: React.ReactNode, sub?: React.ReactNode) => (
      <div className="rounded-lg bg-[#f6f9fd] p-3">
        <div className="text-xs text-avcs-muted">{label}</div>
        <div className="text-xl font-semibold leading-tight text-avcs-text">{value}</div>
        {sub != null && sub !== '' && <div className="mt-1 text-[11px] leading-tight text-avcs-muted">{sub}</div>}
      </div>
    );
    // While editing an existing animal, collapse all read-only detail so only the
    // edit form is visible; Cancel/Save restores the detail view.
    const showDetails = isExisting && !showAnimalEditForm;
    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5 flex flex-col gap-5">
        <div className="admin-section-head flex items-center justify-between gap-2">
          <button className="btn" onClick={() => {
            resetAnimalForm();
            if (animalReturnDealTab && selectedDealId) setView('dealSummary');
            else setView('animalList');
          }}>← Back to list</button>
          {showDetails && (
            <div className="flex items-center gap-2">
              <button
                className="btn primary inline-flex items-center gap-1.5"
                onClick={() => {
                  setShowAnimalEditForm(true);
                  setTimeout(() => { animalFormRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 0);
                }}
              >
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M11.5 2.5a1.414 1.414 0 0 1 2 2L5 13l-3 .5.5-3 9-8Z" />
                </svg>
                Edit
              </button>
              <button className={DELETE_BTN} disabled={deletingAnimalId === editingAnimalId} onClick={async () => { if (await requestConfirm({ title: 'Delete animal', message: 'Delete this animal? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) handleDeleteAnimal(editingAnimalId); }}>
                {deletingAnimalId === editingAnimalId ? 'Deleting…' : 'Delete animal'}
              </button>
            </div>
          )}
        </div>

        {animalCrudError && <div className="rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{animalCrudError}</div>}
        {animalCrudSuccess && <div className="rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{animalCrudSuccess}</div>}

        {showDetails && (
          <div className="flex items-baseline justify-between gap-3 border-b border-[#1e6bb824] pb-3">
            <div>
              <div className="text-xs uppercase tracking-wide text-avcs-muted">EID</div>
              <div className="text-2xl font-semibold text-avcs-text">{detail?.eid_tag || detail?.vid || '—'}</div>
            </div>
            <span className="rounded-full bg-[#eef2f6] px-3 py-1 text-xs font-semibold text-[#4a5b6b]">{detail?.status || '—'}</span>
          </div>
        )}

        {showDetails && (
          <div className="grid gap-x-6 gap-y-3 sm:grid-cols-2 md:grid-cols-3">
            <div><div className="text-xs text-avcs-muted">Current GLN</div><div className="text-sm text-avcs-text">{detail?.current_gln || '—'}</div></div>
            <div><div className="text-xs text-avcs-muted">Current location</div><div className="text-sm text-avcs-text">{detail?.current_entity || '—'}</div></div>
            <div><div className="text-xs text-avcs-muted">Date of birth</div><div className="text-sm text-avcs-text">{detail?.dob || '—'}</div></div>
            <div><div className="text-xs text-avcs-muted">Sex</div><div className="text-sm text-avcs-text">{sexLabel}</div></div>
            <div><div className="text-xs text-avcs-muted">Breed</div><div className="text-sm text-avcs-text">{detail?.breed_name || '—'}</div></div>
            <div><div className="text-xs text-avcs-muted">Deal · producer</div><div className="text-sm text-avcs-text">{detail?.deal_no || detail?.deal ? `${detail?.deal_no || ''}${producerName ? ` · ${producerName}` : ''}` || '—' : '—'}</div></div>
          </div>
        )}

        {showDetails && (
          <div>
            <h3 className="mb-2 text-sm font-semibold text-avcs-text">Performance</h3>
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-5">
              {stat('Days on feed', perf?.days_on_feed ?? '—')}
              {stat('Weight gain', perf?.weight_gain_kg != null ? `${num(perf.weight_gain_kg, 1)} kg` : '—')}
              {stat('ADG', num(perf?.adg_kg_per_day, 2))}
              {stat('FCR (deal)', num(perf?.fcr, 1))}
              {stat(
                'Dressing %',
                perf?.dressing_percentage != null ? `${num(perf.dressing_percentage, 1)}%` : '—',
                (perf?.ccm != null || perf?.last_live_weight != null)
                  ? `CCM ${perf?.ccm != null ? `${num(perf.ccm, 1)} kg` : '—'} · Live ${perf?.last_live_weight != null ? `${num(perf.last_live_weight, 1)} kg` : '—'}`
                  : null
              )}
            </div>
          </div>
        )}

        {showDetails && (() => {
          // An event's `data_session` is the revision ROOT, so matching rows on
          // it found revision 1's row (or none at all, when the animal only
          // appears in a later revision). Match on the whole revision group and
          // prefer the current revision's row -- the superseded ones stay
          // reachable in the Source data tab, which lists every revision.
          const rawBySession = (sessionId?: string | null) => {
            if (!sessionId) return [];
            const target = String(sessionId);
            const inGroup = animalDetailRawRows.filter((r) =>
              String(r.data_session_id) === target
              || String(r.revision_root_id || '') === target);
            const current = inGroup.filter((r) => r.is_current_revision !== false);
            return current.length ? current : inGroup;
          };
          const focusedRows = animalRawFocusKey ? rawBySession(animalRawFocusKey) : [];
          // `raw-rows` returns every revision by default (it is the audit
          // trail), which listed one row per revision with nothing to say which
          // was live -- this animal showed 9 rows across 4 ABAT_SLA revisions
          // and 2 FARM_DIS ones. Show the current revisions by default and put
          // the superseded ones behind a toggle rather than hiding them.
          const supersededCount = animalDetailRawRows.filter((r) => r.is_current_revision === false).length;
          const currentOnlyRows = animalDetailRawRows.filter((r) => r.is_current_revision !== false);
          const allSourceRows = showSupersededRawRows ? animalDetailRawRows : currentOnlyRows;
          const sourceRows = animalRawFocusKey && focusedRows.length ? focusedRows : allSourceRows;
          const tabs = [
            { key: 'weight' as const, label: 'Weight gain' },
            { key: 'events' as const, label: 'Event history' },
            { key: 'source' as const, label: `Source data${animalDetailRawRows.length ? ` (${animalDetailRawRows.length})` : ''}` },
          ];
          return (
          <div className="rounded-xl border border-[#1e6bb824] bg-white">
            <div className="flex flex-wrap gap-1 border-b border-[#1e6bb824] px-2 pt-2">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  className={`-mb-px rounded-t-lg border-b-2 px-3 py-2 text-sm font-semibold transition-colors ${animalDetailTab === tab.key ? 'border-[#1e6bb8] text-[#154f89]' : 'border-transparent text-avcs-muted hover:text-avcs-text'}`}
                  onClick={() => { setAnimalDetailTab(tab.key); if (tab.key !== 'source') setAnimalRawFocusKey(null); }}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="p-3 md:p-4">
              {animalDetailTab === 'weight' && (
                <div>{renderWeightChart(animalDetailWeights, animalDetailEvents)}</div>
              )}

              {animalDetailTab === 'events' && (
                <div className="admin-table-scroll overflow-x-auto">
                  <table className="min-w-full text-sm">
                    <thead className="border-b border-[#1e6bb824] bg-[#f8fbff]">
                      <tr>
                        <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Date</th>
                        <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Event</th>
                        <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Where it happened</th>
                        <th className="px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">Weight</th>
                        <th className="px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">Source</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-[#1e6bb812]">
                      {animalDetailEvents.length === 0 && (
                        <tr><td colSpan={5} className="px-3 py-3 text-avcs-muted">No events recorded for this animal yet.</td></tr>
                      )}
                      {animalDetailEvents.map((e) => {
                        const w = e.event_date ? weightByDate.get(String(e.event_date).slice(0, 10)) : undefined;
                        const hasRaw = rawBySession(e.data_session).length > 0;
                        return (
                        <tr key={e.id} className="bg-white">
                          <td className="px-3 py-2 text-avcs-text">{e.event_date ? new Date(e.event_date).toLocaleDateString('en-ZA', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}</td>
                          <td className="px-3 py-2 text-avcs-text">{EVENT_TYPE_LABELS[e.event_type || ''] || e.event_type || '—'}</td>
                          <td className="px-3 py-2 text-avcs-muted">
                            {e.location_entity_name || '—'}{e.location_gln ? ` · ${e.location_gln}` : ''}
                          </td>
                          <td className="px-3 py-2 text-right tabular-nums text-avcs-text">
                            {w ? <span className="font-semibold">{Number(w.weight).toFixed(1)}<span className="ml-0.5 text-xs font-normal text-avcs-muted">kg</span></span> : <span className="text-avcs-muted">—</span>}
                          </td>
                          <td className="px-3 py-2 text-right">
                            {hasRaw ? (
                              <button
                                type="button"
                                className="btn tiny"
                                title="View the raw uploaded record this event came from"
                                onClick={() => { setAnimalRawFocusKey(String(e.data_session)); setAnimalDetailTab('source'); }}
                              >
                                View raw data
                              </button>
                            ) : (
                              <span className="text-xs text-avcs-muted">—</span>
                            )}
                          </td>
                        </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}

              {animalDetailTab === 'source' && (
                animalDetailRawRows.length === 0 ? (
                  <p className="rounded-xl border border-[#1e6bb824] bg-[#f8fbff] px-3 py-3 text-sm text-avcs-muted">
                    No raw uploaded data is linked to this animal. It may have been created manually rather than via a file upload.
                  </p>
                ) : (
                  <>
                    {animalRawFocusKey && focusedRows.length ? (
                      <div className="mb-2 flex flex-wrap items-center justify-between gap-2 rounded-lg border border-[#1e6bb84d] bg-[#f1f7ff] px-3 py-2 text-xs text-[#154f89]">
                        <span>Showing the raw record for one event{focusedRows[0]?.event_type ? ` · ${focusedRows[0].event_type}` : ''}.</span>
                        <button type="button" className="btn tiny" onClick={() => setAnimalRawFocusKey(null)}>Show all {animalDetailRawRows.length} rows</button>
                      </div>
                    ) : (
                      <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
                        <p className="text-xs text-avcs-muted">
                          The raw uploaded row(s) this record was produced from{allSourceRows.length > 1 ? `, across ${new Set(allSourceRows.map((r) => r.original_filename || r.data_session_id)).size} file(s)` : ''}.
                        </p>
                        {supersededCount > 0 && (
                          <button
                            type="button"
                            className="text-xs font-semibold text-[#1e6bb8] hover:underline"
                            aria-expanded={showSupersededRawRows}
                            title="A corrected re-upload keeps the earlier revision's rows. They are history: the animal's figures come from the current revision."
                            onClick={() => setShowSupersededRawRows((v) => !v)}
                          >
                            {showSupersededRawRows
                              ? `Hide ${supersededCount} superseded row${supersededCount === 1 ? '' : 's'}`
                              : `Show ${supersededCount} superseded row${supersededCount === 1 ? '' : 's'}`}
                          </button>
                        )}
                      </div>
                    )}
                    <div className="grid gap-2">
                      {sourceRows.map((row) => (
                        <RawRowCard key={row.id} row={row} defaultOpen={Boolean(animalRawFocusKey && focusedRows.length)} />
                      ))}
                    </div>
                  </>
                )
              )}
            </div>
          </div>
          );
        })()}

        {loadingAnimalDetail && <p className="text-sm text-avcs-muted">Loading animal…</p>}

        {isExisting && !showAnimalEditForm && (
          <p className="text-sm text-avcs-muted">Use <span className="font-semibold text-avcs-text">Edit</span> above to change this animal's details.</p>
        )}

        {(!isExisting || showAnimalEditForm) && (
        <div ref={animalFormRef} className={isExisting ? 'rounded-xl border border-[#1e6bb824] bg-[#f8fbff] p-4' : undefined}>
          <div className="mb-3 flex items-center justify-between">
            <h3 className="text-sm font-semibold text-avcs-text">{isExisting ? 'Edit details' : 'Add animal'}</h3>
            {isExisting && (
              <button type="button" className="btn" onClick={() => setShowAnimalEditForm(false)}>Cancel</button>
            )}
          </div>
          <form className="grid gap-3 md:grid-cols-2" onSubmit={submitAnimal}>
            <label className="grid gap-1 text-sm text-avcs-text">
              Deal
              <select className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={animalForm.dealId} onChange={(event) => setAnimalForm((prev) => ({ ...prev, dealId: event.target.value }))} disabled={!hasDeals}>
                <option value="">Select deal</option>
                {deals.map((deal) => (
                  <option key={deal.dealId} value={deal.dealId}>{deal.title}</option>
                ))}
              </select>
            </label>
            <label className="grid gap-1 text-sm text-avcs-text">
              Species
              <select className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={animalForm.species} onChange={(event) => setAnimalForm((prev) => ({ ...prev, species: event.target.value as 'SHEEP' | 'GOAT' | 'CATTLE', breed: '' }))}>
                <option value="SHEEP">Sheep</option>
                <option value="GOAT">Goat</option>
                <option value="CATTLE">Cattle</option>
              </select>
            </label>
            <label className="grid gap-1 text-sm text-avcs-text">
              Breed
              <select className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={animalForm.breed} onChange={(event) => setAnimalForm((prev) => ({ ...prev, breed: event.target.value }))}>
                <option value="">— select breed —</option>
                {breeds.filter(b => b.species === animalForm.species).map(b => (
                  <option key={b.id} value={b.id}>{b.name}</option>
                ))}
              </select>
            </label>
            <label className="grid gap-1 text-sm text-avcs-text">
              Ear/visual tag
              <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" placeholder="e.g. LTL-001" value={animalForm.tag} onChange={(event) => setAnimalForm((prev) => ({ ...prev, tag: event.target.value }))} />
            </label>
            {!isExisting && (
              <label className="grid gap-1 text-sm text-avcs-text">
                RFID / EID
                <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" placeholder="Electronic tag number" value={animalForm.eid} onChange={(event) => setAnimalForm((prev) => ({ ...prev, eid: event.target.value }))} />
              </label>
            )}
            <label className="grid gap-1 text-sm text-avcs-text">
              Date of birth
              <input type="date" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={animalForm.dob} onChange={(event) => setAnimalForm((prev) => ({ ...prev, dob: event.target.value }))} />
            </label>
            <label className="grid gap-1 text-sm text-avcs-text">
              Sex
              <select className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={animalForm.sex} onChange={(event) => setAnimalForm((prev) => ({ ...prev, sex: event.target.value }))}>
                <option value="">— select —</option>
                <option value="M">Male</option>
                <option value="F">Female</option>
              </select>
            </label>
            <label className="grid gap-1 text-sm text-avcs-text">
              Location
              <select
                className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                value={useManualAnimalLocation ? '__manual__' : animalForm.location}
                onChange={(event) => {
                  const value = event.target.value;
                  if (value === '__manual__') {
                    setUseManualAnimalLocation(true);
                    setAnimalForm((prev) => ({ ...prev, location: '' }));
                    return;
                  }
                  setUseManualAnimalLocation(false);
                  setAnimalForm((prev) => ({ ...prev, location: value }));
                }}
              >
                <option value="">Select location</option>
                {animalLocationOptions.map((location) => (
                  <option key={location} value={location}>{location}</option>
                ))}
                <option value="__manual__">Enter location manually</option>
              </select>
            </label>
            {useManualAnimalLocation && (
              <label className="grid gap-1 text-sm text-avcs-text">
                Manual location
                <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" placeholder="Type custom location" value={animalForm.location} onChange={(event) => setAnimalForm((prev) => ({ ...prev, location: event.target.value }))} />
              </label>
            )}
            <label className="grid gap-1 text-sm text-avcs-text">
              Status
              <select className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={animalForm.status} onChange={(event) => setAnimalForm((prev) => ({ ...prev, status: event.target.value }))}>
                <option value="ACTIVE">Active</option>
                <option value="SOLD">Slaughtered</option>
                <option value="DECEASED">Deceased</option>
              </select>
            </label>
            <div className="md:col-span-2 flex flex-wrap gap-2">
              <button className="admin-submit-action btn primary" type="submit" disabled={!hasDeals || isSavingAnimal}>{isSavingAnimal ? 'Saving…' : isExisting ? 'Save changes' : 'Add animal'}</button>
            </div>
          </form>
        </div>
        )}
      </section>
    );
  };

  const renderGs1Codes = (tab: 'GLN' | 'GTIN') => {
    const allocationType = gs1Form.gs1Type === 'GTIN' ? 'GTIN' : 'GLN';
    const isGlnAllocation = allocationType === 'GLN';
    const glnRows = gs1Codes.filter((code: GS1CodeSummary) => code.gs1Type === 'GLN');
    const allocatedRows = gs1Codes.filter(isGs1CodeAllocated);
    const availableRows = gs1Codes.filter((code) => !isGs1CodeAllocated(code));
    const gtinAllocationCount = gs1Codes.filter((code) => code.gs1Type === 'GTIN' && isGs1CodeAllocated(code)).length;
    const glnAllocationCount = gs1Codes.filter((code) => code.gs1Type === 'GLN' && isGs1CodeAllocated(code)).length;
    const gs1Query = gs1Search.trim().toLowerCase();
    const rows = gs1Query
      ? gs1Codes.filter((code) =>
          [
            code.gs1Code,
            code.gs1Type,
            isGs1CodeAllocated(code) ? 'allocated' : 'available',
            code.source,
            code.entityName,
            code.productTypeName,
            code.associatedGlnCode,
          ].some((value) => (value || '').toLowerCase().includes(gs1Query))
        )
      : gs1Codes;
    const selectedEntityLabel = entityOptions.find((entity) => entity.id === gs1Form.entityId)?.label || '';
    const selectedEntityProfile = gs1Form.entityId ? entityProfilesById[gs1Form.entityId] : undefined;
    const selectedEntityContacts = selectedEntityProfile?.contacts || [];
    const selectedGs1Entity = gs1Form.entityId
      ? entityDirectory.find((entity) => entity.id === gs1Form.entityId) || null
      : null;
    const gs1EntityQuery = gs1EntitySearch.trim().toLowerCase();
    const gs1EntityResults = gs1EntityQuery
      ? entityDirectory
          .filter((entity) =>
            [
              entity.entityName,
              entity.entityNo,
              entity.entityType,
              entity.valueChainName,
            ].some((value) => (value || '').toLowerCase().includes(gs1EntityQuery))
          )
          .slice(0, 20)
      : entityDirectory.slice(0, 20);
    const requiresContactSelection = selectedEntityContacts.length > 0;
    const selectedEntityGln = gs1Form.entityId
      ? glnRows.find((code: GS1CodeSummary) => code.entityId === gs1Form.entityId)
      : undefined;
    const selectedEntityHasExistingGln = Boolean(
      isGlnAllocation &&
      selectedEntityGln &&
      (!editingGs1Id || selectedEntityGln.id !== editingGs1Id)
    );
    const linkedGlnOptions = glnRows.filter(
      (code: GS1CodeSummary) => !gs1Form.entityId || code.entityId === gs1Form.entityId
    );

    const clearForm = () => {
      setEditingGs1Id('');
      setGs1Form((prev) => ({
        ...prev,
        gs1Code: '',
        gs1Type: tab,
        productTypeId: '',
        associatedGlnId: '',
      }));
      setShowGs1AllocationForm(false);
      setGs1EntitySearch('');
      setShowGs1EntityDropdown(false);
      setGs1CrudError('');
      setGs1CrudSuccess('');
    };

    const submitGs1Form = async (event: React.FormEvent) => {
      event.preventDefault();
      if (!gs1Form.entityId) {
        setGs1CrudError('Select a farmer/entity first.');
        setGs1CrudSuccess('');
        return;
      }
      if (requiresContactSelection && !selectedEntityContactId && !editingGs1Id) {
        setGs1CrudError('Select a contact person for this entity.');
        setGs1CrudSuccess('');
        return;
      }
      if (selectedEntityHasExistingGln) {
        setGs1CrudError('This entity already has a GS1 code with type GLN linked. Edit the existing GLN record instead of creating a new one.');
        setGs1CrudSuccess('');
        return;
      }
      if (!gs1Form.gs1Code.trim()) {
        setGs1CrudError(`Enter the customer-owned ${allocationType} code.`);
        setGs1CrudSuccess('');
        return;
      }
      if (!isGlnAllocation && !gs1Form.associatedGlnId) {
        setGs1CrudError('This entity does not have a GS1 code with type GLN yet. Create or link a GLN first.');
        setGs1CrudSuccess('');
        return;
      }
      if (!isGlnAllocation && !gs1Form.productTypeId) {
        setGs1CrudError('Select a product type before creating a GTIN.');
        setGs1CrudSuccess('');
        return;
      }
      const payload: GS1CodeUpsertInput = {
        ...gs1Form,
        gs1Code: gs1Form.gs1Code.trim(),
        gs1Type: allocationType,
        productTypeId: isGlnAllocation ? '' : gs1Form.productTypeId,
        associatedGlnId: isGlnAllocation ? '' : gs1Form.associatedGlnId,
      };

      if (editingGs1Id) {
        try {
          await updateGs1Code(editingGs1Id, payload);
          await loadGs1Codes();
          setGs1CrudSuccess(`${allocationType} updated.`);
        } catch (error: any) {
          setGs1CrudError(parseApiError(error?.message) || `Could not update ${allocationType}.`);
        }
        return;
      }

      setGs1CrudError('');
      setGs1CrudSuccess('');
      try {
        const created = await createGs1Code(payload);
        await loadGs1Codes();
        setGs1CrudSuccess(`${allocationType} created: ${created.gs1Code}`);
        setShowGs1AllocationForm(false);
      } catch (error: any) {
        setGs1CrudError(parseApiError(error?.message) || `Could not create ${allocationType}.`);
      }
    };

    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
        <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">GS1 Codes</h2>
            <p className="mt-1 text-sm text-avcs-muted">
              Manage the GS1 code pool, allocations, GLNs and GTINs from one view.
            </p>
          </div>
          <button
            type="button"
            className="btn primary"
            onClick={() => {
              setEditingGs1Id('');
              setGs1Form((prev) => ({
                ...prev,
                gs1Code: '',
                gs1Type: tab,
                productTypeId: '',
                associatedGlnId: '',
              }));
              setShowGs1AllocationForm(true);
              setGs1EntitySearch('');
              setShowGs1EntityDropdown(false);
              setGs1CrudError('');
              setGs1CrudSuccess('');
            }}
          >
            Create GS1 code
          </button>
        </div>

        <div className="mb-4 grid gap-3 md:grid-cols-2 xl:grid-cols-5">
          {[
            { label: 'GS1 codes', value: gs1Codes.length },
            { label: 'Allocated', value: allocatedRows.length },
            { label: 'Available', value: availableRows.length },
            { label: 'GTIN allocations', value: gtinAllocationCount },
            { label: 'GLN allocations', value: glnAllocationCount },
          ].map((card) => (
            <div key={card.label} className="rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
              <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">{card.label}</div>
              <div className="mt-2 text-2xl font-semibold text-avcs-text">{loadingGs1Codes ? '...' : fmtNum(card.value)}</div>
            </div>
          ))}
        </div>

        {showGs1AllocationForm && (
        <div className="rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
          <div className="mb-4">
            <EntityCombobox
              label="Entity"
              selectedUnit={selectedGs1Entity}
              searchValue={gs1EntitySearch}
              onSearchChange={(value) => {
                setGs1EntitySearch(value);
                setShowGs1EntityDropdown(true);
              }}
              results={gs1EntityResults}
              showDropdown={showGs1EntityDropdown}
              onFocus={() => setShowGs1EntityDropdown(true)}
              onBlur={() => setTimeout(() => setShowGs1EntityDropdown(false), 150)}
              onSelect={(entity) => {
                const nextEntityId = entity.id || '';
                const nextContacts = entityProfilesById[nextEntityId]?.contacts || [];
                setSelectedEntityContactId(nextContacts[0]?.id || '');
                setGs1Form((prev: GS1CodeUpsertInput) => ({
                  ...prev,
                  entityId: nextEntityId,
                  gs1Code: '',
                  associatedGlnId: '',
                }));
                setGs1EntitySearch('');
                setShowGs1EntityDropdown(false);
              }}
              onClear={() => {
                setSelectedEntityContactId('');
                setGs1Form((prev: GS1CodeUpsertInput) => ({
                  ...prev,
                  entityId: '',
                  gs1Code: '',
                  associatedGlnId: '',
                }));
                setGs1EntitySearch('');
                setShowGs1EntityDropdown(false);
              }}
            />
          </div>

          {loadingEntityDirectory && <p className="mb-4 text-xs text-avcs-muted">Loading farmers/entities...</p>}

          {entityOptions.length === 0 && (
            <div className="mb-4 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-800">
              No farmers/entities found. Add the entity first, then link its GS1 code.
            </div>
          )}

          {gs1Form.entityId && (
            <div className="mb-4 grid gap-3 rounded-lg border border-[#1e6bb824] bg-white p-3 md:grid-cols-2">
              <div>
                <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Who is the farmer</div>
                <div className="mt-1 text-sm text-avcs-text">{selectedEntityProfile?.farmerName || selectedEntityProfile?.label || selectedEntityLabel || 'Not available'}</div>
              </div>
              <div>
                <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">GLN status</div>
                <div className="mt-1 text-sm text-avcs-text">
                  {selectedEntityGln ? `Linked (${selectedEntityGln.gs1Code})` : 'No GS1 code type GLN linked yet'}
                </div>
              </div>
              <div>
                <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Farm address</div>
                <div className="mt-1 text-sm text-avcs-text">
                  {[selectedEntityProfile?.addressLine1, selectedEntityProfile?.addressLine2].filter(Boolean).join(', ') || 'Not available'}
                </div>
              </div>
              <div>
                <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Coordinates</div>
                <div className="mt-1 text-sm text-avcs-text">
                  {selectedEntityProfile?.latitude && selectedEntityProfile?.longitude
                    ? `${selectedEntityProfile.latitude}, ${selectedEntityProfile.longitude}`
                    : 'Not available'}
                </div>
              </div>
              <div className="md:col-span-2">
                <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Contact person</div>
                {selectedEntityContacts.length > 0 ? (
                  <select
                    className="mt-1 w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                    value={selectedEntityContactId}
                    onChange={(event) => setSelectedEntityContactId(event.target.value)}
                  >
                    <option value="">Select contact person...</option>
                    {selectedEntityContacts.map((contact) => (
                      <option key={contact.id} value={contact.id}>
                        {contact.name}{contact.email ? ` (${contact.email})` : ''}
                      </option>
                    ))}
                  </select>
                ) : (
                  <p className="mt-1 text-sm text-avcs-muted">No contact person available for this entity.</p>
                )}
              </div>
            </div>
          )}

          {isGlnAllocation && selectedEntityHasExistingGln && !editingGs1Id && (
            <div className="mb-4 rounded-lg border border-[#1e6bb833] bg-[#eef7ff] px-3 py-2 text-sm text-avcs-text">
              This entity already has a GLN. Use Edit on the existing record if you need changes.
            </div>
          )}

          <h3 className="text-lg font-semibold text-avcs-text mb-3">{editingGs1Id ? 'Edit' : 'Create'} GS1 code</h3>
          <form onSubmit={submitGs1Form} className="grid gap-3 md:grid-cols-2 md:items-start">
            <label className="grid gap-1 text-sm text-avcs-text">
              Allocation type
              <select
                value={allocationType}
                onChange={(event) => {
                  const nextType = event.target.value as 'GLN' | 'GTIN';
                  setGs1Form((prev) => ({
                    ...prev,
                    gs1Type: nextType,
                    gs1Code: '',
                    productTypeId: nextType === 'GLN' ? '' : prev.productTypeId,
                    associatedGlnId: nextType === 'GLN' ? '' : prev.associatedGlnId,
                  }));
                }}
                className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                disabled={Boolean(editingGs1Id)}
              >
                <option value="GLN">GLN</option>
                <option value="GTIN">GTIN</option>
              </select>
            </label>
            <label className="grid gap-1 text-sm text-avcs-text">
              GS1 code
              <input
                type="text"
                value={gs1Form.gs1Code}
                onChange={(event) => setGs1Form((prev: GS1CodeUpsertInput) => ({ ...prev, gs1Code: event.target.value }))}
                className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                required
                disabled={isGlnAllocation && selectedEntityHasExistingGln && !editingGs1Id}
                placeholder={
                  !gs1Form.entityId
                    ? 'Select entity first'
                    : isGlnAllocation
                      ? 'Enter customer-owned GLN'
                      : 'Enter customer-owned GTIN'
                }
              />
            </label>

            {!isGlnAllocation && (
              <>
                <label className="grid gap-1 text-sm text-avcs-text">
                  Product type
                  <select
                    value={gs1Form.productTypeId}
                    onChange={(event) => setGs1Form((prev: GS1CodeUpsertInput) => ({ ...prev, productTypeId: event.target.value }))}
                    className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                  >
                    <option value="">No product type</option>
                    {productTypeOptions.map((option) => (
                      <option key={option.id} value={option.id}>{option.label}</option>
                    ))}
                  </select>
                </label>
                <label className="grid gap-1 text-sm text-avcs-text">
                  Linked GLN
                  <input
                    type="text"
                    readOnly
                    className="w-full rounded-lg border border-[#1e6bb824] bg-gray-50 px-3 py-2 text-sm text-avcs-muted"
                    value={
                      gs1Form.associatedGlnId
                        ? (linkedGlnOptions.find((c) => c.id === gs1Form.associatedGlnId)?.gs1Code ?? gs1Form.associatedGlnId)
                        : (gs1Form.entityId ? 'No GS1 code with type GLN found — allocate a GLN first' : 'Select entity first')
                    }
                  />
                </label>
              </>
            )}

            <div className="md:col-span-2 flex flex-wrap gap-2">
              <button
                type="submit"
                className="btn primary"
                disabled={
                  !gs1Form.entityId
                  || (!editingGs1Id && requiresContactSelection && !selectedEntityContactId)
                  || (isGlnAllocation && selectedEntityHasExistingGln && !editingGs1Id)
                }
              >
                {editingGs1Id ? `Update ${allocationType}` : `Create ${allocationType}`}
              </button>
              <button type="button" className="btn" onClick={clearForm}>Clear</button>
            </div>
          </form>
          {gs1CrudError && <p className="mt-3 text-sm text-red-600">{gs1CrudError}</p>}
          {gs1CrudSuccess && <p className="mt-3 text-sm text-green-700">{gs1CrudSuccess}</p>}
        </div>
        )}

        {!showGs1AllocationForm && gs1CrudError && <p className="mt-3 text-sm text-red-600">{gs1CrudError}</p>}
        {!showGs1AllocationForm && gs1CrudSuccess && <p className="mt-3 text-sm text-green-700">{gs1CrudSuccess}</p>}

        <div className="mt-6 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
          <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
            <h3 className="text-lg font-semibold text-avcs-text">All GS1 codes</h3>
            <input
              type="search"
              value={gs1Search}
              onChange={(event) => setGs1Search(event.target.value)}
              placeholder="Search GS1 codes..."
              className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm sm:w-80"
            />
          </div>
          {loadingGs1Codes ? (
            <p className="text-sm text-avcs-muted">Loading GS1 codes...</p>
          ) : gs1CodesError ? (
            <p className="text-sm text-red-600">{gs1CodesError}</p>
          ) : (
            <div className="gs1-records-shell max-h-[320px] overflow-auto rounded-xl border border-[#1e6bb824] bg-white">
              <table className="gs1-records-table w-full text-sm">
                <thead className="gs1-records-head sticky top-0">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold text-avcs-text">GS1 code</th>
                    <th className="px-4 py-3 text-left font-semibold text-avcs-text">Source</th>
                    <th className="px-4 py-3 text-left font-semibold text-avcs-text">Status</th>
                    <th className="px-4 py-3 text-left font-semibold text-avcs-text">Allocation</th>
                    <th className="px-4 py-3 text-left font-semibold text-avcs-text">Entity</th>
                    <th className="px-4 py-3 text-left font-semibold text-avcs-text">Product type</th>
                    <th className="px-4 py-3 text-left font-semibold text-avcs-text">Linked GLN</th>
                    <th className="px-4 py-3 text-left font-semibold text-avcs-text">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((code: GS1CodeSummary) => {
                    const allocated = isGs1CodeAllocated(code);
                    return (
                      <tr key={code.id} className="gs1-record-row">
                        <td className="px-4 py-3 text-avcs-text">{code.gs1Code}</td>
                        <td className="px-4 py-3 text-avcs-text">{code.source === 'CUSTOMER_OWNED' ? 'Customer owned' : code.source === 'POOL' ? 'Pool' : code.source || '—'}</td>
                        <td className="px-4 py-3 text-avcs-text">{allocated ? 'Allocated' : 'Available'}</td>
                        <td className="px-4 py-3 text-avcs-text">{allocated ? code.gs1Type : '—'}</td>
                        <td className="px-4 py-3 text-avcs-text">{allocated ? (code.entityName || '—') : '—'}</td>
                        <td className="px-4 py-3 text-avcs-text">{code.productTypeName || code.productTypeId || '—'}</td>
                        <td className="px-4 py-3 text-avcs-text">{code.associatedGlnCode || '—'}</td>
                        <td className="px-4 py-3">
                          <button
                            onClick={() => {
                              setEditingGs1Id(code.id);
                              setGs1Form({
                                gs1Code: code.gs1Code,
                                gs1Type: code.gs1Type === 'GTIN' ? 'GTIN' : 'GLN',
                                entityId: code.entityId || '',
                                productTypeId: code.productTypeId || '',
                                associatedGlnId: code.associatedGlnId || '',
                              });
                              setShowGs1AllocationForm(true);
                              setGs1EntitySearch('');
                              setShowGs1EntityDropdown(false);
                            }}
                            className="gs1-action-btn edit mr-2"
                          >
                            Edit
                          </button>
                          <button onClick={() => deleteGs1Code(code.id)} className="gs1-action-btn delete">
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                  {rows.length === 0 && (
                    <tr>
                      <td colSpan={8} className="px-4 py-6 text-center text-sm text-avcs-muted">
                        No GS1 codes found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {tab === 'GLN' && (
          <div className="mt-6 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
            <h3 className="text-lg font-semibold text-avcs-text mb-2">Document upload</h3>
            <p className="text-sm text-avcs-muted mb-3">Upload GLN supporting documents from here.</p>
            <button
              type="button"
              className="btn"
              onClick={() => {
                setDocumentForm((prev) => ({ ...prev, category: 'GS1' }));
                setView('documentUpload');
              }}
            >
              Open document upload
            </button>
          </div>
        )}

      </section>
    );
  };

  const renderContactEditorPanel = () => {
    if (!showCreateContactModal) return null;
    const selectedExistingUser = adminUsers.find((row) => String(row.id) === newContactForm.userId);
    const linkedEntityIds = new Set(contactEntityLinks.map((link) => link.entityId).filter(Boolean));
    const availableAddEntities = entityDirectory.filter((entity) => !linkedEntityIds.has(entity.id));

    return (
      <div className="mb-6 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-avcs-text">{editingContactId ? 'Edit contact' : 'Add contact'}</h3>
          <button
            type="button"
            className="btn tiny"
            onClick={() => {
              setShowCreateContactModal(false);
              resetContactEditor();
              setContactModalError('');
              setView('entityContacts');
            }}
          >
            Close
          </button>
        </div>
        <form className="grid gap-5" onSubmit={submitCreateContact}>
          <div className="grid gap-3 md:grid-cols-2">
            <label className="grid gap-1 text-sm text-avcs-text md:col-span-2">Contact name
              <input
                className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                value={contactDetailsForm.name}
                onChange={(e) => setContactDetailsForm((prev) => ({ ...prev, name: e.target.value }))}
                required
              />
              <span className="text-xs text-avcs-muted">
                Stored on the contact record. A portal account is not required — a
                contact is a person to phone, and only needs an account if they
                have to log in.
              </span>
            </label>
            <label className="grid gap-1 text-sm text-avcs-text">Phone number
              <input className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={contactDetailsForm.phoneNo} onChange={(e) => { setContactDetailsForm((prev) => ({ ...prev, phoneNo: e.target.value })); setNewContactForm((prev) => ({ ...prev, phoneNo: e.target.value })); }} />
            </label>
            <label className="grid gap-1 text-sm text-avcs-text">Email address
              <input type="email" className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={contactDetailsForm.email} onChange={(e) => setContactDetailsForm((prev) => ({ ...prev, email: e.target.value }))} />
            </label>
          </div>

          <div className="grid gap-5 lg:grid-cols-2">
          <div className="rounded-xl border border-[#1e6bb824] bg-white p-4">
            <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
              <h4 className="text-sm font-semibold uppercase tracking-wide text-avcs-muted">
                Portal account <span className="normal-case font-normal">(optional)</span>
              </h4>
              {newContactForm.userId ? (
                <button
                  type="button"
                  className="btn tiny"
                  onClick={() => {
                    setSetPasswordTargetId(Number(newContactForm.userId));
                    setSetPasswordValue('');
                    setSetPasswordConfirm('');
                    setUserMgmtError('');
                    setUserMgmtSuccess('');
                  }}
                >
                  Reset password
                </button>
              ) : contactEditorMode !== 'newUser' ? (
                <button
                  type="button"
                  className="btn tiny primary"
                  onClick={() => {
                    const { firstName, lastName } = splitContactName(contactDetailsForm.name);
                    setContactEditorMode('newUser');
                    setNewContactUserForm((prev) => ({ ...prev, username: contactDetailsForm.username || contactDetailsForm.email, email: contactDetailsForm.email, firstName, lastName }));
                  }}
                >
                  Convert to user
                </button>
              ) : null}
            </div>
            <div className="grid gap-3">
              <label className="grid gap-1 text-sm text-avcs-text">Username
                <input className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={contactDetailsForm.username} onChange={(e) => setContactDetailsForm((prev) => ({ ...prev, username: e.target.value }))} disabled={contactEditorMode === 'existing' && Boolean(newContactForm.userId)} />
              </label>
            {contactEditorMode === 'existing' ? (
              <label className="grid gap-1 text-sm text-avcs-text">
                Linked user <span className="text-avcs-muted">(optional)</span>
                <select
                  className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                  value={newContactForm.userId}
                  onChange={(e) => {
                    const nextUser = adminUsers.find((row) => String(row.id) === e.target.value);
                    setNewContactForm((prev) => ({ ...prev, userId: e.target.value }));
                    if (nextUser) {
                      setContactDetailsForm((prev) => ({
                        ...prev,
                        name: [nextUser.first_name, nextUser.last_name].filter(Boolean).join(' ') || prev.name,
                        email: nextUser.email || prev.email,
                        username: nextUser.username || prev.username,
                      }));
                    }
                  }}
                >
                  <option value="">No linked user</option>
                  {adminUsers.map((row) => {
                    const fullName = [row.first_name, row.last_name].filter(Boolean).join(' ');
                    return <option key={row.id} value={row.id}>{row.username}{fullName ? ` - ${fullName}` : ''}{row.email ? ` (${row.email})` : ''}</option>;
                  })}
                </select>
                <span className="text-xs text-gray-400">
                  {selectedExistingUser ? `System ID ${selectedExistingUser.id}` : loadingUsers ? 'Loading users...' : 'Optionally link this contact to a user account, or leave as “No linked user”.'}
                </span>
              </label>
            ) : (
              <div className="grid gap-3">
                <p className="text-sm text-avcs-muted">The backend will email this contact an activation link so they can set their own password.</p>
                <label className="flex items-center gap-2 text-sm text-avcs-text md:col-span-2">
                  <input type="checkbox" checked={newContactUserForm.isStaff} onChange={(e) => setNewContactUserForm((prev) => ({ ...prev, isStaff: e.target.checked }))} />
                  Grant staff access
                </label>
              </div>
            )}
            </div>
          </div>

          <div className="rounded-xl border border-[#1e6bb824] bg-white p-4">
            <h4 className="mb-3 text-sm font-semibold uppercase tracking-wide text-avcs-muted">Entities</h4>
            {contactEntityLinks.length > 0 ? (
              <div className="grid gap-2">
                {contactEntityLinks.map((link, index) => {
                  const entity = entityDirectory.find((row) => row.id === link.entityId);
                  return (
                    <div key={`${link.id || 'new'}-${link.entityId}-${index}`} className="flex flex-wrap items-center justify-between gap-3 border-b border-[#1e6bb812] py-2 last:border-0">
                      <span className="text-sm font-medium text-avcs-text">{entity?.entityName || link.entityId}</span>
                      <label className="flex items-center gap-2 text-sm text-avcs-text">
                        <input type="checkbox" checked={link.isPrimary} onChange={(e) => setContactEntityLinks((prev) => prev.map((row, rowIndex) => rowIndex === index ? { ...row, isPrimary: e.target.checked } : row))} />
                        Primary contact
                      </label>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="text-sm text-avcs-muted">No entities linked yet.</p>
            )}
            <div className="mt-4 grid gap-3 md:grid-cols-[1fr_auto_auto] md:items-end">
              <label className="grid gap-1 text-sm text-avcs-text">Add entity
                <select className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={contactAddEntityId} onChange={(e) => setContactAddEntityId(e.target.value)}>
                  <option value="">Select entity...</option>
                  {availableAddEntities.map((entity) => <option key={entity.id} value={entity.id}>{entity.entityName}</option>)}
                </select>
              </label>
              <label className="flex items-center gap-2 pb-2 text-sm text-avcs-text">
                <input type="checkbox" checked={contactAddEntityPrimary} onChange={(e) => setContactAddEntityPrimary(e.target.checked)} />
                Primary
              </label>
              <button
                type="button"
                className="btn"
                disabled={!contactAddEntityId}
                onClick={() => {
                  if (!contactAddEntityId) return;
                  setContactEntityLinks((prev) => [...prev, { entityId: contactAddEntityId, isPrimary: contactAddEntityPrimary }]);
                  setContactEditorEntityId((prev) => prev || contactAddEntityId);
                  setContactAddEntityId('');
                  setContactAddEntityPrimary(false);
                }}
              >
                Add entity
              </button>
            </div>
          </div>

          </div>

          <button type="submit" className="btn primary" disabled={creatingContact || (contactEntityLinks.length === 0 && !contactAddEntityId)}>
            {creatingContact ? 'Saving...' : editingContactId ? 'Save contact' : contactEditorMode === 'newUser' ? 'Invite user and link contact' : 'Save contact'}
          </button>
        </form>
        {contactModalError && <p className="mt-3 text-sm text-red-600">{contactModalError}</p>}
      </div>
    );
  };

  const renderEntityForm = () => {
    const linkedContactUserIds = new Set(
      (editingEntityId ? entityDirectory.find((row) => row.id === editingEntityId)?.contacts || [] : [])
        .map((contact) => contact.userId)
        .filter(Boolean)
    );
    const contactSearchQuery = entityContactLinkQuery.trim().toLowerCase();
    const contactSuggestions = entityContactLinkUserId || !contactSearchQuery
      ? []
      : adminUsers
          .filter((row) => !linkedContactUserIds.has(String(row.id)))
          .filter((row) => {
            const fullName = [row.first_name, row.last_name].filter(Boolean).join(' ').toLowerCase();
            return (
              fullName.includes(contactSearchQuery) ||
              row.username.toLowerCase().includes(contactSearchQuery) ||
              (row.email || '').toLowerCase().includes(contactSearchQuery)
            );
          })
          .slice(0, 5);
    const selectedContactUser = entityContactLinkUserId
      ? adminUsers.find((row) => String(row.id) === entityContactLinkUserId)
      : undefined;

    const entityExistingGs1Codes = editingEntityId ? gs1Codes.filter((code) => code.entityId === editingEntityId) : [];
    const entityExistingGln = entityExistingGs1Codes.find((code) => code.gs1Type === 'GLN');
    const entityExistingGtins = entityExistingGs1Codes.filter((code) => code.gs1Type === 'GTIN');
    const entityWillHaveGln = Boolean(entityExistingGln) || entityGlnMode !== 'none';

    // ---- Tabbed entity view (existing entities only) -----------------------
    const isEditing = Boolean(editingEntityId);
    const currentEntity = isEditing ? entityDirectory.find((e) => e.id === editingEntityId) || null : null;
    const entityProfileContacts = isEditing ? (entityProfilesById[editingEntityId]?.contacts || []) : [];
    const entityContacts = entityProfileContacts.length ? entityProfileContacts : (currentEntity?.contacts || []);
    const speciesTitle = (code: string) => (code ? code.charAt(0) + code.slice(1).toLowerCase() : '—');

    // Deals where this entity is the primary producer, split by status.
    const entityActiveDeals = isEditing ? deals.filter((d) => d.primaryProducerId === editingEntityId && d.status === 'Active') : [];
    const entityCompletedDeals = isEditing ? deals.filter((d) => d.primaryProducerId === editingEntityId && d.status === 'Completed') : [];
    const dealNoById = new Map(deals.map((d) => [d.dealId, d.title] as const));
    const entityDealIdSet = new Set([...entityActiveDeals, ...entityCompletedDeals].map((d) => d.dealId));

    // Animals belonging to those deals (any status).
    const entityAnimals = isEditing ? allAnimals.filter((a) => a.deal && entityDealIdSet.has(String(a.deal))) : [];

    // Per-species lifecycle counts: "through platform" (not active) vs active.
    const SPECIES_ORDER = ['SHEEP', 'CATTLE', 'GOAT'];
    const speciesStats: Record<string, { active: number; through: number; total: number }> = {};
    entityAnimals.forEach((a) => {
      const sp = String(a.species || 'UNKNOWN').toUpperCase();
      const bucket = speciesStats[sp] || (speciesStats[sp] = { active: 0, through: 0, total: 0 });
      bucket.total += 1;
      if (String(a.status || '').toUpperCase() === 'ACTIVE') bucket.active += 1;
      else bucket.through += 1;
    });
    const speciesKeys = Object.keys(speciesStats).sort(
      (a, b) => (SPECIES_ORDER.indexOf(a) + 1 || 99) - (SPECIES_ORDER.indexOf(b) + 1 || 99),
    );
    const entityTotalActive = entityAnimals.filter((a) => String(a.status || '').toUpperCase() === 'ACTIVE').length;
    const entityTotalThrough = entityAnimals.length - entityTotalActive;

    // Animals tab: search + pagination over the entity's animals.
    const entityAnimalsQuery = entityAnimalsSearch.trim().toLowerCase();
    const entityAnimalRows = entityAnimals.map((a) => ({
      animal_id: a.id as string,
      eid: (a.eid_tag as string) || (a.vid as string) || '—',
      species: a.species ? speciesTitle(String(a.species)) : '—',
      status: (a.status as string) || '—',
      deal_no: dealNoById.get(String(a.deal)) || '—',
    }));
    const entityAnimalsFiltered = entityAnimalsQuery
      ? entityAnimalRows.filter((r) => [r.eid, r.species, r.status, r.deal_no].filter(Boolean).join(' ').toLowerCase().includes(entityAnimalsQuery))
      : entityAnimalRows;
    const ENTITY_ANIMAL_PAGE = 20;
    const entityAnimalsTotalPages = Math.max(1, Math.ceil(entityAnimalsFiltered.length / ENTITY_ANIMAL_PAGE));
    const entityAnimalsCurrentPage = Math.min(entityAnimalsPage, entityAnimalsTotalPages);
    const entityAnimalsPageRows = entityAnimalsFiltered.slice(
      (entityAnimalsCurrentPage - 1) * ENTITY_ANIMAL_PAGE,
      (entityAnimalsCurrentPage - 1) * ENTITY_ANIMAL_PAGE + ENTITY_ANIMAL_PAGE,
    );

    // Slaughter-data view for the Animals tab: all slaughter rows scoped to this
    // entity's deals, then filtered by the same search box.
    const entitySlaughterScoped = entitySlaughterRows.filter((r) => r.deal_id && entityDealIdSet.has(String(r.deal_id)));
    const entitySlaughterFiltered = entityAnimalsQuery
      ? entitySlaughterScoped.filter((r) =>
          [r.eid, r.vid, r.species, r.status, r.deal_no, ...Object.values(r.raw_data || {})]
            .filter((v) => v != null && v !== '')
            .join(' ')
            .toLowerCase()
            .includes(entityAnimalsQuery))
      : entitySlaughterScoped;

    const toggleEntityDeal = (id: string) =>
      setOpenEntityDealIds((prev) => {
        const next = new Set(prev);
        if (next.has(id)) next.delete(id); else next.add(id);
        return next;
      });

    // A collapsible (concertina) row for one deal.
    const DealAccordionRow = ({ deal }: { deal: Deal }) => {
      const open = openEntityDealIds.has(deal.dealId);
      return (
        <div className="overflow-hidden rounded-lg border border-[#1e6bb824]">
          <button
            type="button"
            className="flex w-full items-center justify-between gap-3 bg-[#fbfeff] px-3 py-2 text-left hover:bg-[#f1f7ff]"
            onClick={() => toggleEntityDeal(deal.dealId)}
            aria-expanded={open}
          >
            <span className="min-w-0">
              <span className="block truncate text-sm font-semibold text-avcs-text">{deal.title}</span>
              <span className="block truncate text-xs text-avcs-muted">
                {[deal.species ? speciesTitle(String(deal.species)) : '', deal.dealRefNo ? `Ref ${deal.dealRefNo}` : '']
                  .filter(Boolean)
                  .join(' · ') || '—'}
              </span>
            </span>
            <span className="flex shrink-0 items-center gap-2 text-xs text-avcs-muted">
              <span className="font-semibold text-avcs-text">{fmtNum(deal.headcount || 0)} head</span>
              <svg className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} viewBox="0 0 20 20" fill="none" aria-hidden>
                <path d="M5 7l5 5 5-5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </button>
          {open && (
            <div className="grid gap-2 border-t border-[#1e6bb814] px-3 py-3 text-sm sm:grid-cols-2">
              <div><span className="text-avcs-muted">Deal number: </span><span className="text-avcs-text">{deal.title}</span></div>
              <div><span className="text-avcs-muted">Reference: </span><span className="text-avcs-text">{deal.dealRefNo || '—'}</span></div>
              <div><span className="text-avcs-muted">Start date: </span><span className="text-avcs-text">{deal.startDate ? String(deal.startDate).split('T')[0] : '—'}</span></div>
              <div><span className="text-avcs-muted">Headcount: </span><span className="text-avcs-text">{fmtNum(deal.headcount || 0)}</span></div>
              <div className="sm:col-span-2 mt-1 flex flex-wrap gap-2">
                <button type="button" className="btn" onClick={() => { setSelectedDealId(deal.dealId); setView('dealSummary'); }}>Open deal</button>
                <button type="button" className="btn" onClick={() => { setAnimalListDealFilter(deal.dealId); setAnimalSearch(''); setView('animalList'); }}>View animals</button>
              </div>
            </div>
          )}
        </div>
      );
    };

    return (
    <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
      <div className="mb-5 flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="flex items-center gap-2 text-2xl font-semibold text-avcs-text">
            {editingEntityId ? (currentEntity?.entityName || newEntityForm.entityName || 'Edit entity') : 'New entity'}
            <InfoHint text={ENTITY_HELP_TEXT} />
          </h2>
          <p className="mt-1 text-sm text-avcs-muted">
            {editingEntityId
              ? [currentEntity?.entityType, currentEntity?.entityNo ? `No. ${currentEntity.entityNo}` : '', currentEntity?.valueChainName]
                  .filter(Boolean)
                  .join(' · ') || 'Update entity details, contacts, and history.'
              : 'Create an entity (farm, feedlot, abattoir, etc) and link it to a person.'}
          </p>
        </div>
        <div className="flex shrink-0 flex-wrap items-center gap-2">
          {editingEntityId && currentEntity && (
            <button
              type="button"
              className="btn primary"
              title={`Start a new deal with ${currentEntity.entityName} as the primary producer`}
              onClick={() => startNewDealForEntity(currentEntity)}
            >
              New deal for this entity
            </button>
          )}
          {editingEntityId && (
            <button
              type="button"
              className={DELETE_BTN}
              onClick={async () => {
                if (!(await requestConfirm({ title: 'Delete entity', message: `Delete entity "${newEntityForm.entityName || 'this entity'}"? This cannot be undone.`, confirmLabel: 'Delete', tone: 'danger' }))) return;
                try {
                  await deleteEntity(editingEntityId);
                  await loadEntityDirectory();
                  setEditingEntityId('');
                  setNewEntityForm(blankEntityForm());
                  setCreatedEntityContactTargetId('');
                  resetEntityContactLinkState();
                  setGs1CrudSuccess('Entity deleted.');
                  setView('entityCrud');
                } catch (error: any) {
                  setEntityModalError(parseApiError(error?.message) || 'Could not delete entity.');
                }
              }}
            >
              Delete entity
            </button>
          )}
          <button
            type="button"
            className="btn"
            onClick={() => {
              setEditingEntityId('');
              setEntityModalError('');
              setNewEntityForm(blankEntityForm());
              setCreatedEntityContactTargetId('');
              resetEntityContactLinkState();
              setView('entityCrud');
            }}
          >
            Back to entity list
          </button>
        </div>
      </div>

      {gs1CrudSuccess && <p className="mb-4 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-700">{gs1CrudSuccess}</p>}
      {createdEntityContactTargetId && (
        <div className="mb-4 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
          <h3 className="text-base font-semibold text-avcs-text">Link a contact</h3>
          <p className="mt-1 text-sm text-avcs-muted">Connect this entity to an existing user/contact or continue to create a new contact.</p>
          <div className="mt-4 flex flex-wrap gap-2">
            <button
              type="button"
              className="btn primary"
              onClick={() => openEntityContactFormForEntity(createdEntityContactTargetId, 'existing')}
            >
              Link existing contact
            </button>
            <button
              type="button"
              className="btn"
              onClick={() => openEntityContactFormForEntity(createdEntityContactTargetId, 'newUser')}
            >
              Create new contact
            </button>
            <button
              type="button"
              className="btn"
              onClick={() => {
                setCreatedEntityContactTargetId('');
                setView('entityCrud');
              }}
            >
              Back to entity list
            </button>
          </div>
        </div>
      )}

      {isEditing && (
        <div className="mb-4 flex flex-wrap gap-1 border-b border-[#1e6bb824]">
          {([
            ['history', 'History'],
            ['details', 'Details'],
            ['contacts', `Contacts${entityContacts.length ? ` (${entityContacts.length})` : ''}`],
            ['animals', `Animals${entityAnimals.length ? ` (${fmtNum(entityAnimals.length)})` : ''}`],
            ['documents', `Documents${entityDocs.length ? ` (${entityDocs.length})` : ''}`],
            ['gs1', `GS1 codes${entityExistingGs1Codes.length ? ` (${entityExistingGs1Codes.length})` : ''}`],
            ['integration', 'Virtual Routez'],
          ] as const).map(([key, label]) => (
            <button
              key={key}
              type="button"
              className={`-mb-px border-b-2 px-4 py-2 text-sm font-semibold transition ${entityTab === key ? 'border-[#1e6bb8] text-[#1e6bb8]' : 'border-transparent text-avcs-muted hover:text-avcs-text'}`}
              onClick={() => {
                setEntityTab(key);
                if (key === 'integration' && editingEntityId && !vrzOnboardingProfile && !vrzOnboardingProfileLoading) {
                  setVrzOnboardingProfileLoading(true);
                  fetchVrzEntityOnboardingProfile(editingEntityId)
                    .then(setVrzOnboardingProfile)
                    .catch(() => setVrzOnboardingProfile(null))
                    .finally(() => setVrzOnboardingProfileLoading(false));
                }
              }}
            >
              {label}
            </button>
          ))}
        </div>
      )}

      {isEditing && entityTab === 'history' && (
        <div className="grid gap-5">
          {allAnimalsLoading && entityAnimals.length === 0 ? (
            <p className="text-sm text-avcs-muted">Loading animal history…</p>
          ) : (
            <>
              <div className="grid gap-3 sm:grid-cols-2">
                <div className="rounded-2xl border border-[#1e6bb829] bg-[#f7fbff] p-5">
                  <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Through the platform</div>
                  <div className="mt-1 text-5xl font-bold leading-none text-avcs-text">{fmtNum(entityTotalThrough)}</div>
                  <div className="mt-1 text-xs text-avcs-muted">Completed / sold / deceased — no longer active</div>
                </div>
                <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-5">
                  <div className="text-xs font-semibold uppercase tracking-wide text-emerald-700/80">Currently active</div>
                  <div className="mt-1 text-5xl font-bold leading-none text-emerald-700">{fmtNum(entityTotalActive)}</div>
                  <div className="mt-1 text-xs text-emerald-700/70">Still moving through the supply chain program</div>
                </div>
              </div>

              {speciesKeys.length > 0 ? (
                <div>
                  <div className="mb-2 text-sm font-semibold uppercase tracking-wide text-avcs-muted">By species</div>
                  <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
                    {speciesKeys.map((sp) => (
                      <div key={sp} className="rounded-2xl border border-[#1e6bb829] bg-white p-5">
                        <div className="text-base font-semibold text-avcs-text">{speciesTitle(sp)}</div>
                        <div className="mt-3 flex items-end gap-6">
                          <div>
                            <div className="text-4xl font-bold leading-none text-avcs-text">{fmtNum(speciesStats[sp].through)}</div>
                            <div className="mt-1 text-xs text-avcs-muted">Through platform</div>
                          </div>
                          <div>
                            <div className="text-3xl font-bold leading-none text-emerald-600">{fmtNum(speciesStats[sp].active)}</div>
                            <div className="mt-1 text-xs text-avcs-muted">Active</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <p className="text-sm text-avcs-muted">No animals recorded for this entity's deals yet.</p>
              )}

              <div className="grid gap-4 lg:grid-cols-2">
                <div>
                  <div className="mb-2 text-sm font-semibold text-avcs-text">Active deals ({fmtNum(entityActiveDeals.length)})</div>
                  {entityActiveDeals.length === 0 ? (
                    <p className="text-sm text-avcs-muted">
                      No active deals for this entity.
                      {currentEntity && (
                        <>
                          {' '}
                          <button
                            type="button"
                            className="font-semibold text-[#1e6bb8] hover:underline"
                            onClick={() => startNewDealForEntity(currentEntity)}
                          >
                            Create one
                          </button>
                        </>
                      )}
                    </p>
                  ) : (
                    <div className="grid gap-2">
                      {entityActiveDeals.map((deal) => <DealAccordionRow key={deal.dealId} deal={deal} />)}
                    </div>
                  )}
                </div>
                <div>
                  <div className="mb-2 text-sm font-semibold text-avcs-text">Completed deals ({fmtNum(entityCompletedDeals.length)})</div>
                  {entityCompletedDeals.length === 0 ? (
                    <p className="text-sm text-avcs-muted">No completed deals for this entity.</p>
                  ) : (
                    <div className="grid gap-2">
                      {entityCompletedDeals.map((deal) => <DealAccordionRow key={deal.dealId} deal={deal} />)}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {(!isEditing || entityTab === 'details') && (
      <div className="rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
        {!isEditing && (
          <div className="mb-5 flex flex-wrap items-center gap-2">
            {ENTITY_WIZARD_STEPS.map((step, idx) => {
              const stepNum = (idx + 1) as 1 | 2 | 3 | 4;
              const active = entityWizardStep === stepNum;
              const done = entityWizardStep > stepNum;
              return (
                <React.Fragment key={step}>
                  <button
                    type="button"
                    className={`flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold transition ${
                      active
                        ? 'bg-avcs-primary text-white'
                        : done
                          ? 'cursor-pointer bg-[#e7f3ff] text-avcs-primary hover:bg-[#d8ecff]'
                          : 'cursor-default bg-[#f1f5f9] text-avcs-muted'
                    }`}
                    onClick={() => { if (done) setEntityWizardStep(stepNum); }}
                  >
                    <span
                      className={`flex h-5 w-5 items-center justify-center rounded-full text-[11px] ${
                        active ? 'bg-white/25' : done ? 'bg-avcs-primary/15' : 'bg-white'
                      }`}
                    >
                      {done ? '✓' : stepNum}
                    </span>
                    {step}
                  </button>
                  {idx < ENTITY_WIZARD_STEPS.length - 1 && <div className="h-px w-6 shrink-0 bg-[#1e6bb824]" />}
                </React.Fragment>
              );
            })}
          </div>
        )}
        <form className="grid gap-3 md:grid-cols-2" onSubmit={submitCreateEntity}>
          {(isEditing || entityWizardStep === 1) && (
          <div className="md:col-span-2 rounded-xl border border-[#1e6bb824] bg-[#13273f] px-4 py-3 text-white shadow-sm">
            <div className="text-xs font-semibold uppercase tracking-wide text-white/70">Entity number</div>
            <div className="mt-1 text-3xl font-bold leading-none tracking-normal">
              {editingEntityId ? (newEntityForm.entityNo || 'Not assigned') : (loadingNextEntityNo ? 'Loading next number...' : nextEntityNoPreview || 'Allocated on save')}
            </div>
            {!editingEntityId && <div className="mt-2 text-xs text-white/65">Assigned by backend on save. Preview may change if another entity is created first.</div>}
          </div>
          )}
          {(isEditing || entityWizardStep === 1) && (
          <>
          <label className="grid gap-1 text-sm text-avcs-text">Supply Chain Program
            <select className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={newEntityForm.valueChainId} onChange={(e) => setNewEntityForm((prev) => ({ ...prev, valueChainId: e.target.value }))}>
              <option value="">None — Deal Matrix (not in a Supply Chain Program)</option>
              {valueChainOptions.map((option) => (<option key={option.id} value={option.id}>{option.label}</option>))}
            </select>
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Entity type
            <select className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={newEntityForm.entityType} onChange={(e) => setNewEntityForm((prev) => ({ ...prev, entityType: e.target.value }))}>
              <option value="FARM">Farm</option>
              <option value="FEEDLOT">Feedlot</option>
              <option value="ABATTOIR">Abattoir</option>
              <option value="TRANSPORT">Transport</option>
              <option value="AGENT">Agent / trader</option>
              <option value="OTHER">Other</option>
              <option value="WOOL_PROCESSOR">Wool Processor</option>
            </select>
          </label>
          {newEntityForm.entityType === 'OTHER' && (
            <label className="grid gap-1 text-sm text-avcs-text">Specify type
              <input
                className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                placeholder="What kind of party is this?"
                value={newEntityForm.entityTypeOther}
                onChange={(e) => setNewEntityForm((prev) => ({ ...prev, entityTypeOther: e.target.value }))}
              />
            </label>
          )}
          <label className="grid gap-1 text-sm text-avcs-text">Entity name
            <input className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={newEntityForm.entityName} onChange={(e) => setNewEntityForm((prev) => ({ ...prev, entityName: e.target.value }))} required />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Registered business name <span className="text-avcs-muted">(if different from entity name)</span>
            <input
              className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
              placeholder="e.g. Cavalier Group (Pty) Ltd"
              value={newEntityForm.registeredBusinessName}
              onChange={(e) => setNewEntityForm((prev) => ({ ...prev, registeredBusinessName: e.target.value }))}
            />
          </label>
          {/* One checkbox stands in for the old three-way "Individual /
              Entity / Not established" select: ticked is a registered
              business, unticked is a private individual. It decides which
              identity document a deal will demand, and whether VAT is even a
              question -- an individual is not asked about VAT at all. */}
          <label className="flex items-center gap-2 text-sm text-avcs-text sm:col-span-2">
            <input
              type="checkbox"
              checked={newEntityForm.partyKind === 'ENTITY'}
              onChange={(e) => setNewEntityForm((prev) => ({
                ...prev,
                partyKind: e.target.checked ? 'ENTITY' : 'INDIVIDUAL',
                // VAT only applies to a business; clear it rather than submit
                // a value the form no longer shows.
                ...(e.target.checked ? {} : { vatRegistered: false, vatNumber: '' }),
              }))}
            />
            <span>Is a business? <span className="text-avcs-muted">(unticked = private individual)</span></span>
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">
            {newEntityForm.partyKind === 'ENTITY' ? 'Company registration number' : 'ID number'}
            <input
              className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
              autoComplete="off"
              value={newEntityForm.identityNumber}
              onChange={(e) => setNewEntityForm((prev) => ({ ...prev, identityNumber: e.target.value }))}
            />
            <span className="text-xs text-avcs-muted">
              {newEntityForm.partyKind === 'ENTITY'
                ? 'A deal with this party will require a CIPC registration document.'
                : 'A deal with this party will require an ID copy.'}
            </span>
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Farm name
            <input
              className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
              value={newEntityForm.farmName}
              onChange={(e) => setNewEntityForm((prev) => ({ ...prev, farmName: e.target.value }))}
            />
          </label>
          {newEntityForm.partyKind === 'ENTITY' && (
            <>
              <label className="flex items-center gap-2 text-sm text-avcs-text">
                <input
                  type="checkbox"
                  checked={newEntityForm.vatRegistered}
                  onChange={(e) => setNewEntityForm((prev) => ({ ...prev, vatRegistered: e.target.checked }))}
                />
                VAT registered
              </label>
              {/* The VAT number is only asked for once the party is VAT
                  registered — and that flag is also what makes the deal require a
                  VAT certificate. */}
              {newEntityForm.vatRegistered && (
                <label className="grid gap-1 text-sm text-avcs-text">VAT number
                  <input
                    className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                    inputMode="numeric"
                    autoComplete="off"
                    placeholder="e.g. 4123456789"
                    value={newEntityForm.vatNumber}
                    onChange={(e) => setNewEntityForm((prev) => ({ ...prev, vatNumber: e.target.value }))}
                  />
                  <span className="text-xs text-avcs-muted">A deal with this party will require a VAT certificate.</span>
                </label>
              )}
            </>
          )}
          <label className="flex items-center gap-2 text-sm text-avcs-text sm:col-span-2">
            <input
              type="checkbox"
              checked={Boolean(newEntityForm.wooliesProducer)}
              onChange={(e) => setNewEntityForm((prev) => ({ ...prev, wooliesProducer: e.target.checked }))}
            />
            <span>Woolies producer <span className="text-avcs-muted">(meat producer for Woolworths — drives dashboard availability notifications)</span></span>
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Cost per day <span className="text-avcs-muted">(per animal, rough holding cost)</span>
            <div className="flex items-center rounded-lg border border-[#1e6bb824] bg-white px-3 focus-within:border-[#1e6bb8]">
              <span className="text-sm text-avcs-muted">R</span>
              <input
                type="number"
                min="0"
                step="0.01"
                inputMode="decimal"
                placeholder="e.g. 12.50"
                className="w-full border-0 bg-transparent px-2 py-2 text-sm focus:outline-none"
                value={newEntityForm.costPerDay}
                onChange={(e) => setNewEntityForm((prev) => ({ ...prev, costPerDay: e.target.value }))}
              />
              <span className="whitespace-nowrap text-xs text-avcs-muted">/ animal / day</span>
            </div>
          </label>
          </>
          )}
          {(isEditing || entityWizardStep === 2) && (
          <>
          <label className="grid gap-1 text-sm text-avcs-text">District
            <input
              className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
              value={newEntityForm.district}
              onChange={(e) => setNewEntityForm((prev) => ({ ...prev, district: e.target.value }))}
            />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Province
            <select
              className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
              value={newEntityForm.province}
              onChange={(e) => setNewEntityForm((prev) => ({ ...prev, province: e.target.value }))}
            >
              <option value="">Select province...</option>
              {SA_PROVINCES.map((name) => (<option key={name} value={name}>{name}</option>))}
            </select>
          </label>
          </>
          )}
          {(isEditing || entityWizardStep === 4) && (
          <label className="flex items-center gap-2 text-sm text-avcs-text" title="A GLN certificate becomes a required document on this party's deals. Always required on an SCP deal.">
            <input
              type="checkbox"
              checked={newEntityForm.glnApplicable}
              onChange={(e) => setNewEntityForm((prev) => ({ ...prev, glnApplicable: e.target.checked }))}
            />
            GLN applicable
          </label>
          )}
          {(isEditing || entityWizardStep === 2) && (
          <>
          <label className="grid gap-1 text-sm text-avcs-text">Address line 1
            <input className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={newEntityForm.addressLine1} onChange={(e) => setNewEntityForm((prev) => ({ ...prev, addressLine1: e.target.value }))} />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Address line 2
            <input className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={newEntityForm.addressLine2} onChange={(e) => setNewEntityForm((prev) => ({ ...prev, addressLine2: e.target.value }))} />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">City
            <input className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={newEntityForm.city} onChange={(e) => setNewEntityForm((prev) => ({ ...prev, city: e.target.value }))} />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Postal code
            <input className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={newEntityForm.postalCode} onChange={(e) => setNewEntityForm((prev) => ({ ...prev, postalCode: e.target.value }))} />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Country
            <input className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={newEntityForm.country} onChange={(e) => setNewEntityForm((prev) => ({ ...prev, country: e.target.value }))} />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Latitude
            <input className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={newEntityForm.latitude} onChange={(e) => setNewEntityForm((prev) => ({ ...prev, latitude: e.target.value }))} />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Longitude
            <input className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={newEntityForm.longitude} onChange={(e) => setNewEntityForm((prev) => ({ ...prev, longitude: e.target.value }))} />
          </label>
          {/* `state` predates `district`/`province` and still holds free-form
              data on old rows -- kept editable so nothing already entered
              under this heading is silently hidden, but never asked of a
              brand new entity, which has nothing there yet. */}
          {(isEditing || Boolean(newEntityForm.state)) && (
          <label className="grid gap-1 text-sm text-avcs-text">State <span className="text-avcs-muted">(legacy — use Province above for new entities)</span>
            <select className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm" value={newEntityForm.state} onChange={(e) => setNewEntityForm((prev) => ({ ...prev, state: e.target.value }))}>
              <option value="">Select province...</option>
              {SA_PROVINCES.map((p) => <option key={p} value={p}>{p}</option>)}
            </select>
          </label>
          )}
          </>
          )}

          {!isEditing && entityWizardStep === 3 && (
          <div className="md:col-span-2 rounded-xl border border-[#1e6bb824] bg-white p-3">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div className="text-sm font-semibold text-avcs-text">Link a contact</div>
              <div className="flex gap-1 rounded-lg border border-[#1e6bb824] bg-[#fbfeff] p-0.5 text-xs font-semibold">
                <button
                  type="button"
                  className={`rounded-md px-2 py-1 ${entityContactLinkMode === 'search' ? 'bg-avcs-primary text-white' : 'text-avcs-muted'}`}
                  onClick={() => {
                    setEntityContactLinkMode('search');
                    setEntityNewContactForm({ firstName: '', lastName: '', email: '', phoneNo: '' });
                    setEntityNewContactCreateLogin(false);
                  }}
                >
                  Search existing
                </button>
                <button
                  type="button"
                  className={`rounded-md px-2 py-1 ${entityContactLinkMode === 'create' ? 'bg-avcs-primary text-white' : 'text-avcs-muted'}`}
                  onClick={() => {
                    setEntityContactLinkMode('create');
                    setEntityContactLinkUserId('');
                    setEntityContactLinkQuery('');
                  }}
                >
                  Create new
                </button>
              </div>
            </div>

            {entityContactLinkMode === 'search' ? (
              <>
                <p className="mt-1 text-xs text-avcs-muted">Search for an existing person by name, username, or email and select them to link to this entity.</p>
                {selectedContactUser ? (
                  <div className="mt-2 flex flex-wrap items-center justify-between gap-2 rounded-lg border border-[#1e6bb824] bg-[#f3faff] px-3 py-2 text-sm">
                    <span className="font-medium text-avcs-text">
                      {[selectedContactUser.first_name, selectedContactUser.last_name].filter(Boolean).join(' ') || selectedContactUser.username}
                      {selectedContactUser.email ? <span className="font-normal text-avcs-muted"> — {selectedContactUser.email}</span> : null}
                    </span>
                    <button
                      type="button"
                      className="btn tiny"
                      onClick={() => {
                        setEntityContactLinkUserId('');
                        setEntityContactLinkQuery('');
                      }}
                    >
                      Change
                    </button>
                  </div>
                ) : (
                  <div className="relative mt-2">
                    <input
                      className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                      placeholder={loadingUsers ? 'Loading people...' : 'Type a name, username, or email...'}
                      value={entityContactLinkQuery}
                      onChange={(e) => setEntityContactLinkQuery(e.target.value)}
                    />
                    {contactSuggestions.length > 0 && (
                      <div className="absolute z-10 mt-1 w-full rounded-lg border border-[#1e6bb824] bg-white shadow-lg">
                        {contactSuggestions.map((row) => {
                          const fullName = [row.first_name, row.last_name].filter(Boolean).join(' ');
                          return (
                            <button
                              key={row.id}
                              type="button"
                              className="block w-full px-3 py-2 text-left text-sm hover:bg-[#f3faff]"
                              onClick={() => {
                                setEntityContactLinkUserId(String(row.id));
                                setEntityContactLinkQuery(fullName || row.username);
                              }}
                            >
                              <span className="font-medium text-avcs-text">{fullName || row.username}</span>
                              {row.email ? <span className="text-avcs-muted"> — {row.email}</span> : null}
                            </button>
                          );
                        })}
                      </div>
                    )}
                    {contactSearchQuery && contactSuggestions.length === 0 && !loadingUsers && (
                      <div className="mt-1 text-xs text-avcs-muted">No matching people found.</div>
                    )}
                  </div>
                )}
              </>
            ) : (
              <>
                <p className="mt-1 text-xs text-avcs-muted">Add a new person and link them to this entity.</p>
                <div className="mt-2 grid gap-2 sm:grid-cols-2">
                  <input
                    className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                    placeholder="First name"
                    value={entityNewContactForm.firstName}
                    onChange={(e) => setEntityNewContactForm((prev) => ({ ...prev, firstName: e.target.value }))}
                  />
                  <input
                    className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                    placeholder="Last name"
                    value={entityNewContactForm.lastName}
                    onChange={(e) => setEntityNewContactForm((prev) => ({ ...prev, lastName: e.target.value }))}
                  />
                  <input
                    type="email"
                    className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                    placeholder="Email address"
                    value={entityNewContactForm.email}
                    onChange={(e) => setEntityNewContactForm((prev) => ({ ...prev, email: e.target.value }))}
                  />
                  <input
                    className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                    placeholder="Phone number"
                    value={entityNewContactForm.phoneNo}
                    onChange={(e) => setEntityNewContactForm((prev) => ({ ...prev, phoneNo: e.target.value }))}
                  />
                </div>
                <label className="mt-3 flex items-center gap-2 text-sm text-avcs-text">
                  <input type="checkbox" checked={entityNewContactCreateLogin} onChange={(e) => setEntityNewContactCreateLogin(e.target.checked)} />
                  Create new user
                </label>
                <p className="mt-1 text-xs text-avcs-muted">
                  {entityNewContactCreateLogin
                    ? 'They will be created as a normal user (not staff/admin) who can log in and set their own password.'
                    : 'They will only be added as a contact for this entity and will not be able to log in.'}
                </p>
              </>
            )}

            {(entityContactLinkMode === 'create' || selectedContactUser) && (
              <label className="mt-3 flex items-center gap-2 text-sm text-avcs-text">
                <input type="checkbox" checked={entityContactLinkPrimary} onChange={(e) => setEntityContactLinkPrimary(e.target.checked)} />
                Set as primary contact
              </label>
            )}
          </div>
          )}

          {(isEditing || entityWizardStep === 4) && (
          <div className="md:col-span-2 rounded-xl border border-[#1e6bb824] bg-white p-3">
            <div className="text-sm font-semibold text-avcs-text">GS1 codes</div>
            <p className="mt-1 text-xs text-avcs-muted">Allocate a GLN to identify this entity's location, and GTINs for the product types it handles.</p>

            {(entityExistingGln || entityExistingGtins.length > 0) && (
              <div className="mt-2 grid gap-1 rounded-lg border border-[#1e6bb824] bg-[#f3faff] px-3 py-2 text-sm">
                {entityExistingGln && (
                  <div><span className="font-medium text-avcs-text">GLN:</span> {entityExistingGln.gs1Code}</div>
                )}
                {entityExistingGtins.map((code) => (
                  <div key={code.id}>
                    <span className="font-medium text-avcs-text">GTIN:</span> {code.gs1Code}
                    {code.productTypeName ? ` — ${code.productTypeName}` : ''}
                  </div>
                ))}
              </div>
            )}

            {entityExistingGln ? (
              <p className="mt-3 text-xs text-avcs-muted">This entity already has a GLN allocated.</p>
            ) : (
              <div className="mt-3">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">GLN</span>
                  <div className="flex gap-1 rounded-lg border border-[#1e6bb824] bg-[#fbfeff] p-0.5 text-xs font-semibold">
                    <button
                      type="button"
                      className={`rounded-md px-2 py-1 ${entityGlnMode === 'none' ? 'bg-avcs-primary text-white' : 'text-avcs-muted'}`}
                      onClick={() => { setEntityGlnMode('none'); setEntityManualGlnCode(''); }}
                    >
                      None
                    </button>
                    <button
                      type="button"
                      className={`rounded-md px-2 py-1 ${entityGlnMode === 'allocate' ? 'bg-avcs-primary text-white' : 'text-avcs-muted'}`}
                      onClick={() => { setEntityGlnMode('allocate'); setEntityManualGlnCode(''); }}
                    >
                      Allocate from pool
                    </button>
                    <button
                      type="button"
                      className={`rounded-md px-2 py-1 ${entityGlnMode === 'manual' ? 'bg-avcs-primary text-white' : 'text-avcs-muted'}`}
                      onClick={() => setEntityGlnMode('manual')}
                    >
                      Customer already has one
                    </button>
                  </div>
                </div>
                {entityGlnMode === 'allocate' && (
                  <p className="mt-2 text-xs text-avcs-muted">The next available GLN from the pool will be allocated to this entity on save.</p>
                )}
                {entityGlnMode === 'manual' && (
                  <div className="mt-2">
                    <input
                      className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                      placeholder="Enter the customer-owned GLN code"
                      value={entityManualGlnCode}
                      onChange={(e) => setEntityManualGlnCode(e.target.value)}
                    />
                    <p className="mt-1 text-xs text-avcs-muted">Use this if the customer already owns a GLN issued directly by GS1.</p>
                  </div>
                )}
              </div>
            )}

            <div className="mt-4">
              <div className="flex items-center justify-between gap-2">
                <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">GTINs to allocate</div>
                <button
                  type="button"
                  className="btn tiny"
                  disabled={!entityWillHaveGln}
                  onClick={() => setEntityGtinAllocationsToAdd((prev) => [...prev, { mode: 'allocate', productTypeId: '', gs1Code: '' }])}
                >
                  + Add GTIN
                </button>
              </div>
              {!entityWillHaveGln && (
                <p className="mt-1 text-xs text-avcs-muted">Allocate a GLN first before adding GTINs.</p>
              )}
              {entityGtinAllocationsToAdd.map((row, index) => (
                <div key={index} className="mt-2 rounded-lg border border-[#1e6bb824] bg-[#fbfeff] p-2">
                  <div className="flex items-center gap-2">
                    <select
                      className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                      value={row.productTypeId}
                      onChange={(e) => setEntityGtinAllocationsToAdd((prev) => prev.map((r, i) => (i === index ? { ...r, productTypeId: e.target.value } : r)))}
                    >
                      <option value="">Select product type...</option>
                      {productTypeOptions.map((option) => (<option key={option.id} value={option.id}>{option.label}</option>))}
                    </select>
                    <button
                      type="button"
                      className={DELETE_BTN}
                      onClick={async () => { if (await requestConfirm({ title: 'Remove GTIN', message: 'Remove this GTIN allocation row?', confirmLabel: 'Remove', tone: 'danger' })) setEntityGtinAllocationsToAdd((prev) => prev.filter((_, i) => i !== index)); }}
                    >
                      Remove
                    </button>
                  </div>
                  <div className="mt-2 flex flex-wrap items-center gap-2">
                    <span className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">GTIN source</span>
                    <div className="flex gap-1 rounded-lg border border-[#1e6bb824] bg-white p-0.5 text-xs font-semibold">
                      <button
                        type="button"
                        className={`rounded-md px-2 py-1 ${row.mode === 'allocate' ? 'bg-avcs-primary text-white' : 'text-avcs-muted'}`}
                        onClick={() => setEntityGtinAllocationsToAdd((prev) => prev.map((r, i) => (i === index ? { ...r, mode: 'allocate', gs1Code: '' } : r)))}
                      >
                        Allocate from pool
                      </button>
                      <button
                        type="button"
                        className={`rounded-md px-2 py-1 ${row.mode === 'manual' ? 'bg-avcs-primary text-white' : 'text-avcs-muted'}`}
                        onClick={() => setEntityGtinAllocationsToAdd((prev) => prev.map((r, i) => (i === index ? { ...r, mode: 'manual' } : r)))}
                      >
                        Customer already has one
                      </button>
                    </div>
                  </div>
                  {row.mode === 'manual' && (
                    <div className="mt-2">
                      <input
                        className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                        placeholder="Enter the customer-owned GTIN code"
                        value={row.gs1Code}
                        onChange={(e) => setEntityGtinAllocationsToAdd((prev) => prev.map((r, i) => (i === index ? { ...r, gs1Code: e.target.value } : r)))}
                      />
                      <p className="mt-1 text-xs text-avcs-muted">Use this if the customer already owns a GTIN issued directly by GS1.</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          )}

          {/* Create-only: an existing entity manages its integrations from its
              own Virtual Routez tab, so this panel would just duplicate it there. */}
          {!isEditing && entityWizardStep === 4 && (
          <div className="md:col-span-2 rounded-xl border border-[#1e6bb824] bg-white p-3">
            <div className="text-sm font-semibold text-avcs-text">Integrations</div>
            <p className="mt-1 text-xs text-avcs-muted">
              Partner systems this entity should be connected to. Anything ticked here runs once the entity has been saved.
            </p>

            <div className="mt-3 grid gap-2">
              <label className="flex items-start gap-3 rounded-lg border border-[#1e6bb824] bg-[#fbfeff] px-3 py-2">
                <input
                  type="checkbox"
                  className="mt-0.5"
                  checked={entityRequestVrzOnboarding}
                  onChange={(e) => setEntityRequestVrzOnboarding(e.target.checked)}
                />
                <span className="grid gap-0.5 text-sm">
                  <span className="font-semibold text-avcs-text">Virtual Routez — request a new organisation</span>
                  <span className="text-xs text-avcs-muted">
                    Emails Virtual Routez this entity&rsquo;s details and a link where they submit its API key back.
                    Their side creates the organisation by hand; you can track it afterwards on the entity&rsquo;s Virtual Routez tab.
                  </span>
                </span>
              </label>

              <label className="flex items-start gap-3 rounded-lg border border-dashed border-[#1e6bb824] bg-[#fbfeff] px-3 py-2 opacity-70">
                <input type="checkbox" className="mt-0.5" disabled />
                <span className="grid gap-0.5 text-sm">
                  <span className="font-semibold text-avcs-text">Precision Farm</span>
                  <span className="text-xs text-avcs-muted">Not yet configurable per entity — coming soon.</span>
                </span>
              </label>

              {(() => {
                // The token lives on the primary contact user, so RMIS can only
                // be switched on when the Contacts step is actually going to set
                // one -- a new contact with an email, or an existing user linked
                // as primary.
                const rmisContactReady = entityContactLinkPrimary && (
                  entityContactLinkMode === 'create'
                    ? Boolean(entityNewContactForm.email.trim())
                    : Boolean(entityContactLinkUserId)
                );
                return (
                  <div className={`rounded-lg border border-[#1e6bb824] bg-[#fbfeff] px-3 py-2 ${rmisContactReady ? '' : 'opacity-70'}`}>
                    <label className="flex items-start gap-3">
                      <input
                        type="checkbox"
                        className="mt-0.5"
                        checked={entityRmisEnabled && rmisContactReady}
                        disabled={!rmisContactReady}
                        onChange={(e) => {
                          setEntityRmisEnabled(e.target.checked);
                          if (!e.target.checked) {
                            setEntityRmisTestToken('');
                            setEntityRmisProductionToken('');
                          }
                        }}
                      />
                      <span className="grid gap-0.5 text-sm">
                        <span className="font-semibold text-avcs-text">RMIS — participant token</span>
                        <span className="text-xs text-avcs-muted">
                          {rmisContactReady
                            ? 'Stored on the primary contact from the Contacts step; RMIS movements for this entity are authorised with it.'
                            : 'Set a primary contact in the Contacts step first — the token is stored on that person, not on the entity.'}
                        </span>
                      </span>
                    </label>
                    {entityRmisEnabled && rmisContactReady && (
                      <div className="mt-3 grid gap-2 sm:grid-cols-2">
                        <label className="grid gap-1 text-sm text-avcs-text">RMIS test token
                          <input
                            type="password"
                            className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                            autoComplete="off"
                            placeholder="Optional"
                            value={entityRmisTestToken}
                            onChange={(e) => setEntityRmisTestToken(e.target.value)}
                          />
                        </label>
                        <label className="grid gap-1 text-sm text-avcs-text">RMIS production token
                          <input
                            type="password"
                            className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                            autoComplete="off"
                            placeholder="Optional"
                            value={entityRmisProductionToken}
                            onChange={(e) => setEntityRmisProductionToken(e.target.value)}
                          />
                        </label>
                      </div>
                    )}
                  </div>
                );
              })()}
            </div>
          </div>
          )}

          <div className="md:col-span-2 flex items-center justify-between gap-2">
            {isEditing ? (
              <button type="submit" className="btn primary" disabled={creatingEntity}>
                {creatingEntity ? 'Saving...' : 'Save entity'}
              </button>
            ) : (
              <>
                <button
                  type="button"
                  className="btn"
                  disabled={entityWizardStep === 1}
                  onClick={() => setEntityWizardStep((step) => (Math.max(1, step - 1) as 1 | 2 | 3 | 4))}
                >
                  Back
                </button>
                {entityWizardStep < 4 ? (
                  <button
                    type="button"
                    className="btn primary"
                    disabled={entityWizardStep === 1 && !newEntityForm.entityName.trim()}
                    onClick={() => setEntityWizardStep((step) => (Math.min(4, step + 1) as 1 | 2 | 3 | 4))}
                  >
                    Continue
                  </button>
                ) : (
                  <button type="submit" className="btn primary" disabled={creatingEntity}>
                    {creatingEntity ? 'Saving...' : 'Create entity'}
                  </button>
                )}
              </>
            )}
          </div>
        </form>
        {entityModalError && <p className="mt-3 text-sm text-red-600">{entityModalError}</p>}
      </div>
      )}

      {isEditing && entityTab === 'contacts' && (
        <div className="rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
          <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
            <h3 className="text-lg font-semibold text-avcs-text">Contacts</h3>
            <div className="flex flex-wrap gap-2">
              <button type="button" className="btn" onClick={() => openEntityContactFormForEntity(editingEntityId, 'existing')}>Link existing contact</button>
              <button type="button" className="btn primary" onClick={() => openEntityContactFormForEntity(editingEntityId, 'newUser')}>Create new contact</button>
            </div>
          </div>
          {entityContacts.length === 0 ? (
            <p className="text-sm text-avcs-muted">No contacts linked to this entity yet. Use the buttons above to add one.</p>
          ) : (
            <div className="grid gap-2">
              {entityContacts.map((contact) => (
                <div key={contact.id} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-[#1e6bb824] bg-white px-3 py-2">
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 text-sm font-semibold text-avcs-text">
                      {contact.name || 'Unnamed contact'}
                      {contact.isPrimary && <span className="rounded-full bg-[#e8f4ff] px-2 py-0.5 text-[11px] font-semibold text-[#0f3b64]">Primary</span>}
                    </div>
                    <div className="text-xs text-avcs-muted">{[contact.email, contact.phoneNo].filter(Boolean).join(' · ') || 'No contact details'}</div>
                  </div>
                  <button
                    type="button"
                    className={DELETE_BTN}
                    onClick={async () => {
                      if (!(await requestConfirm({ title: 'Delete contact', message: `Remove ${contact.name || 'this contact'} from this entity? This cannot be undone.`, confirmLabel: 'Delete', tone: 'danger' }))) return;
                      try {
                        await deleteEntityContact(contact.id);
                        await loadEntityDirectory();
                        setGs1CrudSuccess('Contact deleted.');
                      } catch (error: any) {
                        setEntityModalError(parseApiError(error?.message) || 'Could not delete contact.');
                      }
                    }}
                  >
                    Delete
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {isEditing && entityTab === 'documents' && (() => {
        // The five party documents a deal asks for. Filed here once, a deal
        // whose seller or purchaser is this entity counts them automatically.
        const partyDocCodes = ['ID_COPY', 'CIPC', 'VAT_CERT', 'BANK_LETTER', 'GLN_CERT'];
        const docTypeChoices = dealDocumentTypeOptions.filter((option) => partyDocCodes.includes(option.code || ''));
        const add = async () => {
          if (!editingEntityId || !entityDocForm.file || !entityDocForm.documentType || entityDocUploading) return;
          setEntityDocUploading(true);
          setEntityDocsError('');
          try {
            await uploadEntityDocument({
              entityId: editingEntityId,
              documentType: entityDocForm.documentType,
              file: entityDocForm.file,
              dateOfDocument: entityDocForm.date,
              referenceNumber: entityDocForm.reference.trim(),
            });
            setEntityDocForm((f) => ({ ...f, file: null, reference: '' }));
            await reloadEntityDocs(editingEntityId);
          } catch (error: any) {
            setEntityDocsError(parseApiError(error?.message) || error?.message || 'Could not upload the document.');
          } finally {
            setEntityDocUploading(false);
          }
        };
        return (
          <div className="rounded-xl border border-[#1e6bb824] bg-white p-4">
            <h3 className="text-lg font-semibold text-avcs-text">Documents</h3>
            <p className="mt-1 text-xs text-avcs-muted">
              File each document once here. Any deal that uses this entity as seller or purchaser counts it
              automatically, so it is not uploaded again on every deal. A bank confirmation letter only counts
              while it is less than three months old at the deal date.
            </p>
            {entityDocsError && <div role="alert" className="mt-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{entityDocsError}</div>}
            {entityDocsLoading ? (
              <p className="mt-3 text-sm text-avcs-muted">Loading documents…</p>
            ) : entityDocs.length === 0 ? (
              <p className="mt-3 text-sm text-avcs-muted">No documents filed for this entity yet.</p>
            ) : (
              <div className="mt-3 overflow-x-auto">
                <table className="w-full min-w-[520px] text-left text-sm">
                  <thead>
                    <tr className="border-b border-[#1e6bb824] text-xs uppercase tracking-wide text-avcs-muted">
                      <th className="py-2 pr-3">Document</th>
                      <th className="py-2 pr-3">Date on document</th>
                      <th className="py-2 pr-3">Reference</th>
                      <th className="py-2 pr-3">File</th>
                      <th className="py-2" />
                    </tr>
                  </thead>
                  <tbody>
                    {entityDocs.map((doc) => (
                      <tr key={doc.id} className="border-b border-[#1e6bb812]">
                        <td className="py-2 pr-3 font-semibold text-avcs-text">{doc.documentTypeName}</td>
                        <td className="py-2 pr-3">{doc.dateOfDocument}</td>
                        <td className="py-2 pr-3">{doc.referenceNumber || '—'}</td>
                        <td className="py-2 pr-3">
                          {doc.fileUrl ? <a className="text-[#1e6bb8] underline" href={normalizeDocumentUrl(doc.fileUrl)} target="_blank" rel="noreferrer">Open</a> : '—'}
                        </td>
                        <td className="py-2 text-right">
                          <button
                            type="button"
                            className={DELETE_BTN}
                            onClick={async () => {
                              if (!(await requestConfirm({ title: 'Remove document', message: `Remove this ${doc.documentTypeName}? Deals that relied on it will show it as outstanding again.`, confirmLabel: 'Remove', tone: 'danger' }))) return;
                              try {
                                await deleteEntityDocument(doc.id);
                                if (editingEntityId) await reloadEntityDocs(editingEntityId);
                              } catch (error: any) {
                                setEntityDocsError(parseApiError(error?.message) || error?.message || 'Could not remove the document.');
                              }
                            }}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div className="mt-4 grid gap-3 rounded-lg border border-[#1e6bb824] bg-[#fbfeff] p-3 md:grid-cols-2">
              <p className="text-sm font-semibold text-avcs-text md:col-span-2">Add a document</p>
              <label className="grid gap-1 text-sm text-avcs-text">
                Document
                <select
                  className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                  value={entityDocForm.documentType}
                  onChange={(e) => setEntityDocForm((f) => ({ ...f, documentType: e.target.value }))}
                >
                  <option value="">Choose the document…</option>
                  {docTypeChoices.map((option) => (<option key={option.id} value={option.id}>{option.label}</option>))}
                </select>
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Date on the document
                <input type="date" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={entityDocForm.date} onChange={(e) => setEntityDocForm((f) => ({ ...f, date: e.target.value }))} />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Reference (optional)
                <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={entityDocForm.reference} onChange={(e) => setEntityDocForm((f) => ({ ...f, reference: e.target.value }))} />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                File
                <input key={entityDocs.length} type="file" className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2" onChange={(e) => setEntityDocForm((f) => ({ ...f, file: e.target.files?.[0] || null }))} />
              </label>
              <div className="md:col-span-2">
                <button type="button" className="btn primary" disabled={!entityDocForm.file || !entityDocForm.documentType || entityDocUploading} onClick={add}>
                  {entityDocUploading ? 'Uploading…' : 'Add document'}
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {isEditing && entityTab === 'gs1' && (
        <div className="rounded-xl border border-[#1e6bb824] bg-white p-4">
          <h3 className="text-lg font-semibold text-avcs-text">GS1 codes</h3>
          <p className="mt-1 text-xs text-avcs-muted">
            The GLN identifies this entity's location; each GTIN identifies a product it handles.
            Allocating or changing codes is done on the Details tab.
          </p>
          {loadingGs1Codes ? (
            <p className="mt-3 text-sm text-avcs-muted">Loading GS1 codes…</p>
          ) : gs1CodesError ? (
            <p role="alert" className="mt-3 text-sm text-[#6b1010]">{gs1CodesError}</p>
          ) : entityExistingGs1Codes.length === 0 ? (
            <p className="mt-3 text-sm text-avcs-muted">This entity has no GS1 codes yet.</p>
          ) : (
            <div className="mt-3 overflow-x-auto">
              <table className="w-full min-w-[520px] text-left text-sm">
                <thead>
                  <tr className="border-b border-[#1e6bb824] text-xs uppercase tracking-wide text-avcs-muted">
                    <th className="py-2 pr-3">Type</th>
                    <th className="py-2 pr-3">Code</th>
                    <th className="py-2 pr-3">Product type</th>
                    <th className="py-2 pr-3">Linked GLN</th>
                    <th className="py-2">Source</th>
                  </tr>
                </thead>
                <tbody>
                  {[...entityExistingGs1Codes]
                    .sort((a, b) => (a.gs1Type === b.gs1Type ? a.gs1Code.localeCompare(b.gs1Code) : a.gs1Type === 'GLN' ? -1 : 1))
                    .map((code) => (
                      <tr key={code.id} className="border-b border-[#1e6bb812]">
                        <td className="py-2 pr-3 font-semibold text-avcs-text">{code.gs1Type}</td>
                        <td className="py-2 pr-3 font-mono">{code.gs1Code}</td>
                        <td className="py-2 pr-3">{code.productTypeName || '—'}</td>
                        <td className="py-2 pr-3 font-mono">{code.associatedGlnCode || '—'}</td>
                        <td className="py-2">{code.source === 'CUSTOMER_OWNED' ? 'Customer owned' : code.source === 'POOL' ? 'AVCS pool' : (code.source || '—')}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {isEditing && entityTab === 'integration' && (
        <div className="grid gap-4">
          {/* Only an entity with no key of its own is still being onboarded.
              Once a key is saved this card goes away; the status badge and
              "Test connection" live on the card below, so they stay visible. */}
          {!vrzOnboardingProfileLoading && !vrzOnboardingProfile?.hasApiKey && (
          <div className="rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
            <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
              <h3 className="text-lg font-semibold text-avcs-text">New organisation onboarding</h3>
            </div>

            <p className="mb-3 text-sm text-avcs-muted">
              Virtual Routez organisation creation and API key issuing is done by hand on their side.
              Sending a request emails them this entity&rsquo;s details and a link where they submit the
              key back &mdash; no need to wait for a reply email to know it has landed.
            </p>

            <div className="mb-3 flex flex-wrap items-end gap-2">
              <div className="grid gap-1">
                <label className="text-sm font-semibold text-avcs-text" htmlFor="vrz-recipient-email">
                  Virtual Routez contact email (optional override)
                </label>
                <input
                  id="vrz-recipient-email"
                  className="w-72 max-w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                  placeholder="Uses the configured default contact if left blank"
                  value={vrzRecipientEmail}
                  onChange={(e) => setVrzRecipientEmail(e.target.value)}
                />
              </div>
              <button
                type="button"
                className="btn btn-primary"
                disabled={vrzOnboardingRequesting}
                onClick={async () => {
                  if (!editingEntityId) return;
                  if (!(await requestConfirm({
                    title: 'Request new organisation on Virtual Routez',
                    message: 'Email Virtual Routez staff this entity’s details and a link for them to submit its API key?',
                    confirmLabel: 'Send request',
                    tone: 'default',
                  }))) return;
                  setVrzOnboardingRequesting(true);
                  setVrzOnboardingError('');
                  setVrzOnboardingResult(null);
                  try {
                    const result = await requestVrzOnboarding(editingEntityId, {
                      recipientEmail: vrzRecipientEmail.trim() || undefined,
                    });
                    setVrzOnboardingResult(result);
                    setVrzOnboardingProfile(await fetchVrzEntityOnboardingProfile(editingEntityId));
                  } catch (error: any) {
                    setVrzOnboardingError(parseApiError(error?.message) || 'Could not request onboarding.');
                  } finally {
                    setVrzOnboardingRequesting(false);
                  }
                }}
              >
                {vrzOnboardingRequesting ? 'Requesting…' : 'Request new organisation'}
              </button>
            </div>

            {vrzOnboardingError && (
              <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{vrzOnboardingError}</div>
            )}

            {vrzOnboardingResult && (
              <div className={`mb-3 rounded-lg border px-3 py-3 text-sm ${vrzOnboardingResult.emailSent ? 'border-green-200 bg-green-50 text-green-800' : 'border-[#e6d5a8] bg-[#fdf6e3] text-[#6b4e10]'}`}>
                {vrzOnboardingResult.emailSent ? (
                  <>Emailed <span className="font-semibold">{vrzOnboardingResult.recipientEmail}</span> the onboarding link.</>
                ) : (
                  <>Could not send the email ({vrzOnboardingResult.emailError || 'unknown error'}) &mdash; share this link manually:</>
                )}
                <div className="mt-2 break-all font-mono text-xs">{vrzOnboardingResult.onboardingUrl}</div>
                <div className="mt-1 text-xs text-avcs-muted">
                  Expires {new Date(vrzOnboardingResult.linkExpiresAt).toLocaleDateString()}.
                </div>
              </div>
            )}
          </div>
          )}

          <div className="rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
          <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
            <div className="flex flex-wrap items-center gap-2">
              <h3 className="text-lg font-semibold text-avcs-text">Provisioning</h3>
              {vrzOnboardingProfileLoading && <span className="text-sm text-avcs-muted">Loading…</span>}
              {!vrzOnboardingProfileLoading && (() => {
                const status = vrzOnboardingProfile?.onboardingStatus || 'NOT_REQUESTED';
                const badge: Record<string, { label: string; className: string }> = {
                  NOT_REQUESTED: { label: 'Not connected', className: 'border-[#1e6bb824] bg-white text-avcs-muted' },
                  REQUESTED: { label: 'Requested from Virtual Routez', className: 'border-[#e6d5a8] bg-[#fdf6e3] text-[#6b4e10]' },
                  KEY_RECEIVED: { label: 'Key received — not verified', className: 'border-[#e6d5a8] bg-[#fdf6e3] text-[#6b4e10]' },
                  VERIFIED: { label: 'Verified', className: 'border-green-200 bg-green-50 text-green-800' },
                };
                const { label, className } = badge[status] || badge.NOT_REQUESTED;
                return <span className={`rounded-full border px-3 py-1 text-xs font-semibold ${className}`}>{label}</span>;
              })()}
            </div>
            <div className="flex flex-wrap gap-2">
            <button
              type="button"
              className="btn"
              disabled={vrzTesting || !vrzOnboardingProfile?.hasApiKey}
              title={!vrzOnboardingProfile?.hasApiKey ? 'No Virtual Routez API key configured for this entity yet' : undefined}
              onClick={async () => {
                if (!editingEntityId) return;
                setVrzTesting(true);
                setVrzTestResult(null);
                try {
                  const result = await testVrzConnection(editingEntityId);
                  setVrzTestResult(result);
                  setVrzOnboardingProfile(await fetchVrzEntityOnboardingProfile(editingEntityId));
                } catch (error: any) {
                  setVrzTestResult({ ok: false, message: parseApiError(error?.message) || 'Could not test the key.' });
                } finally {
                  setVrzTesting(false);
                }
              }}
            >
              {vrzTesting ? 'Testing…' : 'Test connection'}
            </button>
            <button
              type="button"
              className="btn"
              disabled={vrzPlanLoading}
              onClick={async () => {
                if (!editingEntityId) return;
                setVrzPlanLoading(true);
                setVrzPlanError('');
                setVrzResult(null);
                try {
                  setVrzPlan(await fetchVrzProvisionPlan(editingEntityId));
                } catch (error: any) {
                  setVrzPlan(null);
                  setVrzPlanError(parseApiError(error?.message) || 'Could not read the provisioning plan.');
                } finally {
                  setVrzPlanLoading(false);
                }
              }}
            >
              {vrzPlanLoading ? 'Checking…' : vrzPlan ? 'Re-check' : 'Check setup'}
            </button>
            </div>
          </div>

          <p className="mb-4 text-sm text-avcs-muted">
            The organisation, its workstation and its events are created on the Virtual
            Routez platform by their team from a template. This side holds the entity&rsquo;s
            API key and the event UIDs AVCS sends against &mdash; saving is safe to repeat,
            and an event UID you have set by hand is never overwritten.
          </p>

          {vrzTestResult && (
            <div className={`mb-4 rounded-lg border px-3 py-2 text-sm ${vrzTestResult.ok ? 'border-green-200 bg-green-50 text-green-800' : 'border-[#e6d5a8] bg-[#fdf6e3] text-[#6b4e10]'}`}>
              {vrzTestResult.ok ? 'The key works — Virtual Routez accepted the call.' : (vrzTestResult.message || 'Virtual Routez rejected this key.')}
            </div>
          )}

          {vrzPlanError && (
            <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{vrzPlanError}</div>
          )}

          {!vrzPlan && !vrzPlanLoading && !vrzPlanError && (
            <p className="text-sm text-avcs-muted">Choose &ldquo;Check setup&rdquo; to see what would be created.</p>
          )}

          {vrzPlan && !vrzPlan.provisionable && (
            <div className="rounded-lg border border-[#e6d5a8] bg-[#fdf6e3] px-3 py-2 text-sm text-[#6b4e10]">{vrzPlan.reason}</div>
          )}

          {vrzPlan && vrzPlan.provisionable && (
            <div className="grid gap-4">
              <div className="grid gap-2 sm:grid-cols-2">
                <div><span className="text-avcs-muted">Profile: </span><span className="text-avcs-text">{vrzPlan.profileExists ? 'Already exists' : 'Will be created'}</span></div>
                <div><span className="text-avcs-muted">Operator: </span><span className="text-avcs-text">{vrzPlan.personUid} {vrzPlan.contact ? `(${vrzPlan.contact})` : '— no contact on this entity'}</span></div>
                <div className="sm:col-span-2">
                  <span className="text-avcs-muted">Workstations: </span>
                  <span className="text-avcs-text">{(vrzPlan.workstations || []).join(', ') || '—'}</span>
                </div>
              </div>

              {(vrzPlan.eventUids || []).some((r) => r.status === 'differs') && (
                <div className="rounded-lg border border-[#e6d5a8] bg-[#fdf6e3] px-3 py-3 text-sm text-[#6b4e10]">
                  <span className="font-semibold">
                    {(vrzPlan.eventUids || []).filter((r) => r.status === 'differs').length} event UID(s) do not match the template.
                  </span>{' '}
                  Virtual Routez rejects an event whose UID it does not recognise, and until v2.8.17 those
                  rejections were recorded as successes &mdash; so these may look delivered when they were not.
                  Saving never overwrites a UID; use &ldquo;Realign&rdquo; below to adopt the template.
                </div>
              )}

              <div className="admin-table-scroll overflow-x-auto">
                <table className="min-w-full border-collapse">
                  <thead>
                    <tr>
                      {['Event', 'Configured now', 'Template says', 'Workstation', 'Status'].map((h) => (
                        <th key={h} className="whitespace-nowrap border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {(vrzPlan.eventUids || []).map((row) => (
                      <tr key={row.eventType} className={row.status === 'differs' ? 'bg-[#fdf6e3]' : undefined}>
                        <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.eventType}</td>
                        <td className={`border-b border-[#1e6bb814] px-3 py-2 font-mono text-sm ${row.status === 'differs' ? 'font-semibold text-[#6b4e10]' : 'text-avcs-text'}`}>
                          {row.currentEventUid || <span className="font-sans text-avcs-muted">— not set —</span>}
                        </td>
                        <td className="border-b border-[#1e6bb814] px-3 py-2 font-mono text-sm text-avcs-text">{row.eventUid}</td>
                        <td className="border-b border-[#1e6bb814] px-3 py-2 font-mono text-xs text-avcs-muted">{row.workstationUid}</td>
                        <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm">
                          {row.status === 'matches' && <span className="text-avcs-muted">Correct</span>}
                          {row.status === 'will_add' && <span className="font-semibold text-[#1e6bb8]">Will be added</span>}
                          {row.status === 'differs' && (
                            <span className="font-semibold text-[#6b4e10]">Does not match &mdash; rejected by Virtual Routez</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="grid gap-2 sm:max-w-md">
                <label className="text-sm font-semibold text-avcs-text" htmlFor="vrz-api-key">
                  Virtual Routez API key for this entity
                </label>
                <input
                  id="vrz-api-key"
                  className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
                  placeholder="Leave blank to keep the current key"
                  value={vrzApiKey}
                  onChange={(e) => setVrzApiKey(e.target.value)}
                />
                {vrzOnboardingProfile?.hasApiKey && (
                  <label className="flex items-center gap-2 text-xs text-avcs-muted">
                    <input
                      type="checkbox"
                      checked={vrzOverwriteKey}
                      onChange={(e) => setVrzOverwriteKey(e.target.checked)}
                    />
                    Replace the existing key (Virtual Routez has already issued one for this entity)
                  </label>
                )}
                <p className="text-xs text-avcs-muted">
                  Each participant is its own Virtual Routez tenant. Without this entity&rsquo;s own key
                  its events go to whichever tenant the system key belongs to, where its event UIDs
                  do not exist &mdash; and are rejected.
                </p>
              </div>

              <div className="flex flex-wrap gap-2">
                {/* AVCS never creates workstations or people on Virtual Routez
                    any more -- their side builds the organisation from a
                    template. This saves the key and the AVCS-side wiring only. */}
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={vrzProvisioning}
                  onClick={async () => {
                    if (!editingEntityId) return;
                    setVrzProvisioning(true);
                    setVrzPlanError('');
                    try {
                      const result = await provisionEntityOnVrz(editingEntityId, {
                        createRemote: false,
                        apiKey: vrzApiKey.trim() || undefined,
                        overwriteApiKey: vrzOverwriteKey,
                      });
                      setVrzResult(result);
                      setVrzApiKey('');
                      setVrzOverwriteKey(false);
                      setVrzPlan(await fetchVrzProvisionPlan(editingEntityId));
                      setVrzOnboardingProfile(await fetchVrzEntityOnboardingProfile(editingEntityId));
                    } catch (error: any) {
                      setVrzPlanError(parseApiError(error?.message) || 'Could not save the API key.');
                    } finally {
                      setVrzProvisioning(false);
                    }
                  }}
                >
                  {vrzProvisioning ? 'Saving…' : 'Save API key'}
                </button>
                {(vrzPlan.eventUids || []).some((r) => r.status === 'differs') && (
                  <button
                    type="button"
                    className="btn"
                    disabled={vrzProvisioning}
                    onClick={async () => {
                      if (!editingEntityId) return;
                      const differing = (vrzPlan.eventUids || []).filter((r) => r.status === 'differs');
                      if (!(await requestConfirm({
                        title: 'Realign event UIDs to the template',
                        // Overwrites data, so the danger tone is right -- but it
                        // is a realign, not a delete.
                        tone: 'danger',
                        confirmLabel: 'Realign',
                        message: `Overwrite ${differing.length} event UID(s) for "${vrzPlan.entity}"?\n\n${differing
                          .map((r) => `${r.eventType}: ${r.currentEventUid || '(blank)'} → ${r.eventUid}`)
                          .join('\n')}`,
                      }))) return;
                      setVrzProvisioning(true);
                      setVrzPlanError('');
                      try {
                        const result = await provisionEntityOnVrz(editingEntityId, {
                          createRemote: false,
                          realign: true,
                        });
                        setVrzResult(result);
                        setVrzPlan(await fetchVrzProvisionPlan(editingEntityId));
                      } catch (error: any) {
                        setVrzPlanError(parseApiError(error?.message) || 'Could not realign the event UIDs.');
                      } finally {
                        setVrzProvisioning(false);
                      }
                    }}
                  >
                    Realign {(vrzPlan.eventUids || []).filter((r) => r.status === 'differs').length} UID(s) to template
                  </button>
                )}
              </div>

              {vrzResult && (
                <div className={`rounded-lg border px-3 py-3 text-sm ${vrzResult.ok ? 'border-green-200 bg-green-50 text-green-800' : 'border-[#e6d5a8] bg-[#fdf6e3] text-[#6b4e10]'}`}>
                  <div className="mb-1 font-semibold">
                    {vrzResult.ok ? 'Done.' : 'Partly done — some steps did not complete.'}
                  </div>
                  <ul className="list-disc pl-5">
                    {vrzResult.steps.map((step) => (
                      <li key={step.step}>
                        <span className="font-medium">{step.step}</span>: {step.status} &mdash; {step.detail}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
          </div>
        </div>
      )}

      {isEditing && entityTab === 'animals' && (
        <div className="rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
          <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
            <h3 className="text-lg font-semibold text-avcs-text">Animals</h3>
            <span className="text-sm text-avcs-muted">
              {entityAnimalsMode === 'slaughter'
                ? (entitySlaughterLoading && entitySlaughterScoped.length === 0
                    ? 'Loading slaughter data…'
                    : `${fmtNum(entitySlaughterFiltered.length)}${entityAnimalsQuery ? ` of ${fmtNum(entitySlaughterScoped.length)}` : ''} animal${entitySlaughterFiltered.length === 1 ? '' : 's'} with slaughter data`)
                : (allAnimalsLoading && entityAnimals.length === 0
                    ? 'Loading animals…'
                    : `${fmtNum(entityAnimalsFiltered.length)}${entityAnimalsQuery ? ` of ${fmtNum(entityAnimals.length)}` : ''} animal${entityAnimalsFiltered.length === 1 ? '' : 's'}`)}
            </span>
          </div>
          <input
            className="mb-3 w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
            placeholder="Filter by EID, species, status or deal…"
            value={entityAnimalsSearch}
            onChange={(e) => { setEntityAnimalsSearch(e.target.value); setEntityAnimalsPage(1); }}
          />

          <div className="mb-3 inline-flex rounded-lg border border-[#1e6bb833] p-0.5 text-sm">
            <button
              type="button"
              className={`rounded-md px-3 py-1.5 font-medium transition ${entityAnimalsMode === 'standard' ? 'bg-[#1e6bb8] text-white' : 'text-avcs-muted hover:text-avcs-text'}`}
              onClick={() => setEntityAnimalsMode('standard')}
            >
              Standard
            </button>
            <button
              type="button"
              className={`rounded-md px-3 py-1.5 font-medium transition ${entityAnimalsMode === 'slaughter' ? 'bg-[#1e6bb8] text-white' : 'text-avcs-muted hover:text-avcs-text'}`}
              onClick={() => setEntityAnimalsMode('slaughter')}
            >
              Slaughter data
            </button>
          </div>

          {entityAnimalsMode === 'standard' && (
          <div className="admin-table-scroll tab-fill-scroll overflow-x-auto">
            <table className="min-w-full border-collapse">
              <thead>
                <tr>
                  {['EID', 'Species', 'Status', 'Deal'].map((h) => (
                    <th key={h} className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {entityAnimalsPageRows.map((row) => (
                  <tr key={row.animal_id} className="hover:bg-[#f8fbff]">
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm font-medium">
                      <button type="button" className="font-medium text-[#1e6bb8] hover:underline" onClick={() => openAnimalDetail(row.animal_id)}>{row.eid}</button>
                    </td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.species}</td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.status}</td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{row.deal_no}</td>
                  </tr>
                ))}
                {entityAnimalsFiltered.length === 0 && (
                  <tr>
                    <td colSpan={4} className="px-3 py-3 text-sm text-avcs-muted">
                      {allAnimalsLoading && entityAnimals.length === 0
                        ? 'Loading animals…'
                        : entityAnimals.length === 0
                          ? 'No animals recorded for this entity’s deals yet.'
                          : 'No animals match your filter.'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          )}

          {entityAnimalsMode === 'slaughter' && (
            entitySlaughterError ? (
              <div className="rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{entitySlaughterError}</div>
            ) : (
            <div className="admin-table-scroll slaughter-raw-scroll tab-fill-scroll overflow-x-auto">
              <table className="min-w-full border-collapse">
                <thead>
                  <tr>
                    {['Tag / EID', 'Species', 'Status', 'Deal', ...entitySlaughterColumns].map((h, i) => (
                      <th key={`${h}-${i}`} className="whitespace-nowrap border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {entitySlaughterFiltered.map((r) => (
                    <tr key={r.animal_id} className="hover:bg-[#f8fbff]">
                      <td className="whitespace-nowrap border-b border-[#1e6bb814] px-3 py-2 text-sm font-medium">
                        <button type="button" className="font-medium text-[#1e6bb8] hover:underline" onClick={() => openAnimalDetail(r.animal_id)}>{r.eid || r.vid || '—'}</button>
                      </td>
                      <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm capitalize text-avcs-text">{r.species ? String(r.species).toLowerCase() : '—'}</td>
                      <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{r.status || '—'}</td>
                      <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{r.deal_no || '—'}</td>
                      {entitySlaughterColumns.map((col) => {
                        const val = r.raw_data ? (r.raw_data as Record<string, unknown>)[col] : undefined;
                        const text = val == null || val === '' ? '—' : String(val);
                        return <td key={col} className="whitespace-nowrap border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{text}</td>;
                      })}
                    </tr>
                  ))}
                  {entitySlaughterFiltered.length === 0 && (
                    <tr>
                      <td colSpan={entitySlaughterColumns.length + 4} className="px-3 py-3 text-sm text-avcs-muted">
                        {entitySlaughterLoading
                          ? 'Loading slaughter data…'
                          : entitySlaughterScoped.length === 0
                            ? 'No abattoir-slaughter data for this entity’s animals yet.'
                            : 'No animals match your filter.'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            )
          )}

          {entityAnimalsMode === 'standard' && entityAnimalsTotalPages > 1 && (
            <div className="mt-3 flex flex-wrap items-center justify-end gap-2 text-sm text-avcs-muted">
              <button
                type="button"
                className="rounded-lg border border-[#1e6bb824] bg-white px-3 py-1.5 text-sm text-avcs-text disabled:opacity-40"
                disabled={entityAnimalsCurrentPage <= 1}
                onClick={() => setEntityAnimalsPage((p) => Math.max(1, p - 1))}
              >
                Previous
              </button>
              <span className="text-avcs-text">Page {entityAnimalsCurrentPage} of {entityAnimalsTotalPages}</span>
              <button
                type="button"
                className="rounded-lg border border-[#1e6bb824] bg-white px-3 py-1.5 text-sm text-avcs-text disabled:opacity-40"
                disabled={entityAnimalsCurrentPage >= entityAnimalsTotalPages}
                onClick={() => setEntityAnimalsPage((p) => Math.min(entityAnimalsTotalPages, p + 1))}
              >
                Next
              </button>
            </div>
          )}
        </div>
      )}
    </section>
    );
  };

  const renderEntityCrud = () => (
    <section className="flex flex-col rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
      <div className="mb-5 flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="flex items-center gap-2 text-2xl font-semibold text-avcs-text">
            Entities
            <InfoHint text={ENTITY_HELP_TEXT} />
          </h2>
          <p className="mt-1 text-sm text-avcs-muted">Create and manage farm entities and their contact persons.</p>
        </div>
        <button type="button" className="btn primary shrink-0" onClick={openNewEntityForm}>
          New entity
        </button>
      </div>

      <div className="flex min-h-0 flex-1 flex-col">
        <div className="mb-3 flex items-center justify-between gap-3">
          <h3 className="text-lg font-semibold text-avcs-text">Entity directory</h3>
          <span className="text-sm text-avcs-muted">{fmtNum(entityDirectory.length)} entities</span>
        </div>
        <div className="mb-3">
          <input
            type="search"
            placeholder="Search entities..."
            value={entitySearch}
            onChange={(e) => { setEntitySearch(e.target.value); setEntityDirectoryPage(1); }}
            className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm sm:w-80"
          />
        </div>
        {loadingEntityDirectory ? (
          <p className="text-sm text-avcs-muted">Loading entities...</p>
        ) : entityDirectory.length === 0 ? (
          <p className="text-sm text-avcs-muted">No entities found. Use &quot;New entity&quot; to create the first one.</p>
        ) : (
          (() => {
            const query = entitySearch.trim().toLowerCase();
            const filteredEntities = query
              ? entityDirectory.filter((entity) => {
                  const profileContacts = entityProfilesById[entity.id]?.contacts || [];
                  const contacts = profileContacts.length > 0 ? profileContacts : (entity.contacts || []);
                  return (
                    entity.entityName.toLowerCase().includes(query) ||
                    (entity.entityNo || '').toLowerCase().includes(query) ||
                    (entity.entityType || '').toLowerCase().includes(query) ||
                    (entity.valueChainName || '').toLowerCase().includes(query) ||
                    (entity.state || '').toLowerCase().includes(query) ||
                    contacts.some((contact) =>
                      contact.name.toLowerCase().includes(query) ||
                      (contact.email || '').toLowerCase().includes(query) ||
                      (contact.phoneNo || '').toLowerCase().includes(query)
                    )
                  );
                })
              : entityDirectory;

            if (filteredEntities.length === 0) {
              return <p className="text-sm text-avcs-muted">No entities match "{entitySearch}".</p>;
            }

            const ENTITY_PAGE_SIZE = 20;
            const totalEntityPages = Math.max(1, Math.ceil(filteredEntities.length / ENTITY_PAGE_SIZE));
            const currentEntityPage = Math.min(entityDirectoryPage, totalEntityPages);
            const pagedEntities = filteredEntities.slice(
              (currentEntityPage - 1) * ENTITY_PAGE_SIZE,
              currentEntityPage * ENTITY_PAGE_SIZE
            );

            return (
              <div className="flex min-h-0 flex-1 flex-col gap-3">
                <div className="admin-table-shell admin-table-scroll entity-table-scroll min-h-0 flex-1 overflow-x-auto">
                  <table className="min-w-full border-collapse">
                    <thead>
                      <tr>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Entity</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Type</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Supply Chain Program</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">Cost/day</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">GLN</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">GTINs</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Location</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Primary contact</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">Contacts</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">Active deals</th>
                        <th className="border-b border-[#1e6bb824] px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">Completed deals</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pagedEntities.map((entity) => {
                      const profileContacts = entityProfilesById[entity.id]?.contacts || [];
                      const contacts = profileContacts.length > 0 ? profileContacts : (entity.contacts || []);
                      const primaryContact = contacts.find((contact) => contact.isPrimary) || contacts[0];
                      const address = [entity.addressLine1, entity.addressLine2, entity.city, entity.state, entity.postalCode, entity.country].filter(Boolean).join(', ');
                      const entityGs1Codes = gs1CodesByEntity.get(entity.id);

                      return (
                        <tr key={entity.id}>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                            <button
                              type="button"
                              className="text-left font-medium text-[#1e6bb8] hover:underline"
                              onClick={() => openEditEntityForm(entity)}
                            >
                              {entity.entityName}
                            </button>
                            {entity.entityNo && <div className="text-xs text-avcs-muted">No: {entity.entityNo}</div>}
                          </td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                            <span className="rounded-full bg-[#e8f4ff] px-2 py-0.5 text-xs font-semibold text-[#0f3b64]">
                              {entity.entityType || 'Unspecified'}
                            </span>
                          </td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{entity.valueChainName || '—'}</td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-right text-sm text-avcs-text whitespace-nowrap">
                            {entity.costPerDay != null && entity.costPerDay !== ''
                              ? `R ${Number(entity.costPerDay).toFixed(2)}`
                              : '—'}
                          </td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                            {loadingGs1Codes ? 'Loading...' : (entityGs1Codes?.gln?.gs1Code || '—')}
                          </td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-right text-sm text-avcs-text">
                            {loadingGs1Codes ? '...' : fmtNum(entityGs1Codes?.gtinCount || 0)}
                          </td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                            <div className="max-w-xs text-avcs-text">{address || '-'}</div>
                            {(entity.latitude || entity.longitude) && (
                              <div className="text-xs text-avcs-muted">{[entity.latitude, entity.longitude].filter(Boolean).join(', ')}</div>
                            )}
                          </td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                            {primaryContact ? (
                              <div>
                                <div className="font-medium text-avcs-text">{primaryContact.name}</div>
                                <div className="text-xs text-avcs-muted">
                                  {[primaryContact.email, primaryContact.phoneNo].filter(Boolean).join(' · ') || 'No contact details'}
                                </div>
                              </div>
                            ) : (
                              '—'
                            )}
                          </td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-right text-sm text-avcs-text">{fmtNum(contacts.length)}</td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-right text-sm text-avcs-text">{fmtNum(dealCountsByEntity[entity.id]?.active || 0)}</td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-right text-sm text-avcs-text">{fmtNum(dealCountsByEntity[entity.id]?.completed || 0)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                </div>
                <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                  <div className="text-sm text-avcs-muted">Page {currentEntityPage} of {totalEntityPages}</div>
                  <div className="flex gap-2">
                    <button
                      className="btn"
                      type="button"
                      disabled={currentEntityPage <= 1}
                      onClick={() => setEntityDirectoryPage((p) => Math.max(1, p - 1))}
                    >
                      Previous
                    </button>
                    <button
                      className="btn"
                      type="button"
                      disabled={currentEntityPage >= totalEntityPages}
                      onClick={() => setEntityDirectoryPage((p) => Math.min(totalEntityPages, p + 1))}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            );
          })()
        )}
      </div>

      {gs1CrudError && <p className="mt-4 text-sm text-red-600">{gs1CrudError}</p>}
      {gs1CrudSuccess && <p className="mt-4 text-sm text-green-700">{gs1CrudSuccess}</p>}
    </section>
  );

  const renderEntityContacts = () => {
    const query = contactDirectorySearch.trim().toLowerCase();
    const contacts = entityDirectory.flatMap((entity) => {
      const storedProfileContacts = entityProfilesById[entity.id]?.contacts || [];
      const profileContacts = storedProfileContacts.length > 0 ? storedProfileContacts : (entity.contacts || []);
      return profileContacts.map((contact) => ({
        ...contact,
        entityId: entity.id,
        entityName: entity.entityName,
        entityNo: entity.entityNo || '',
      }));
    });
    const contactRows = Array.from(contacts.reduce((map, contact) => {
      const key = contact.userId
        ? `user:${contact.userId}`
        : `contact:${contact.email || contact.name}:${contact.phoneNo || ''}`.toLowerCase();
      const current = map.get(key) || {
        key,
        name: contact.name,
        email: contact.email || '',
        phoneNo: contact.phoneNo || '',
        userId: contact.userId || '',
        username: contact.username || '',
        links: [] as typeof contacts,
      };
      current.links.push(contact);
      if (!current.email && contact.email) current.email = contact.email;
      if (!current.phoneNo && contact.phoneNo) current.phoneNo = contact.phoneNo;
      if (!current.username && contact.username) current.username = contact.username;
      map.set(key, current);
      return map;
    }, new Map<string, {
      key: string;
      name: string;
      email: string;
      phoneNo: string;
      userId: string;
      username: string;
      links: typeof contacts;
    }>()).values()).sort((left, right) => left.name.localeCompare(right.name));
    const filteredContacts = query
      ? contactRows.filter((contact) =>
          contact.name.toLowerCase().includes(query) ||
          (contact.email || '').toLowerCase().includes(query) ||
          (contact.phoneNo || '').toLowerCase().includes(query) ||
          (contact.username || '').toLowerCase().includes(query) ||
          contact.links.some((link) =>
            link.entityName.toLowerCase().includes(query) ||
            link.entityNo.toLowerCase().includes(query)
          )
        )
      : contactRows;

    const openNewContactEditor = () => {
      resetContactEditor();
      setContactModalError('');
      setShowCreateContactModal(true);
      setView('entityContactForm');
    };

    const openEditContactEditor = (contact: typeof contacts[number]) => {
      const linkedRows = contacts
        .filter((row) => contact.userId ? row.userId === contact.userId : row.id === contact.id)
        .map((row) => ({ id: row.id, entityId: row.entityId, isPrimary: Boolean(row.isPrimary) }));
      const selectedUser = contact.userId ? adminUsers.find((row) => String(row.id) === String(contact.userId)) : undefined;
      setContactEditorEntityId(contact.entityId);
      setContactEditorMode('existing');
      setSelectedEntityContactId(contact.id);
      setEditingContactId(contact.id);
      setNewContactForm({ userId: contact.userId || '', phoneNo: contact.phoneNo || '', isPrimary: Boolean(contact.isPrimary) });
      setContactDetailsForm({
        name: selectedUser ? [selectedUser.first_name, selectedUser.last_name].filter(Boolean).join(' ') || contact.name : contact.name,
        phoneNo: contact.phoneNo || '',
        email: selectedUser?.email || contact.email || '',
        username: selectedUser?.username || contact.username || '',
      });
      setContactEntityLinks(linkedRows.length > 0 ? linkedRows : [{ id: contact.id, entityId: contact.entityId, isPrimary: Boolean(contact.isPrimary) }]);
      setContactAddEntityId('');
      setContactAddEntityPrimary(false);
      setNewContactUserForm({ username: '', email: '', firstName: '', lastName: '', password: '', confirmPassword: '', isStaff: false });
      setContactModalError('');
      setShowCreateContactModal(true);
      setView('entityContactForm');
    };

    const openConvertContactEditor = (contact: typeof contacts[number]) => {
      const [firstName = '', ...restName] = contact.name === 'Unnamed contact' ? [''] : contact.name.split(' ');
      setContactEditorEntityId(contact.entityId);
      setContactEditorMode('newUser');
      setSelectedEntityContactId(contact.id);
      setEditingContactId(contact.id);
      setNewContactForm({ userId: '', phoneNo: contact.phoneNo || '', isPrimary: Boolean(contact.isPrimary) });
      setContactDetailsForm({ name: contact.name, phoneNo: contact.phoneNo || '', email: contact.email || '', username: contact.email || '' });
      setContactEntityLinks([{ id: contact.id, entityId: contact.entityId, isPrimary: Boolean(contact.isPrimary) }]);
      setContactAddEntityId('');
      setContactAddEntityPrimary(false);
      setNewContactUserForm({
        username: contact.email || '',
        email: contact.email || '',
        firstName,
        lastName: restName.join(' '),
        password: '',
        confirmPassword: '',
        isStaff: false,
      });
      setContactModalError('');
      setShowCreateContactModal(true);
      setView('entityContactForm');
    };

    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">Contacts</h2>
            <p className="mt-1 text-sm text-avcs-muted">Manage entity contacts and connect them to user accounts.</p>
          </div>
          <div className="flex flex-wrap gap-2">
            <button type="button" className="btn" onClick={loadEntityDirectory}>Refresh</button>
            <button type="button" className="btn primary" onClick={openNewContactEditor}>Add contact</button>
          </div>
        </div>

        <div className="rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
          <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
            <h3 className="text-lg font-semibold text-avcs-text">Contact directory</h3>
            <input
              type="search"
              placeholder="Search contacts..."
              value={contactDirectorySearch}
              onChange={(e) => setContactDirectorySearch(e.target.value)}
              className="w-full rounded-lg border border-[#1e6bb824] bg-white px-3 py-1.5 text-sm sm:w-64"
            />
          </div>
          {loadingEntityDirectory ? (
            <p className="text-sm text-avcs-muted">Loading contacts...</p>
          ) : contactRows.length === 0 ? (
            <p className="text-sm text-avcs-muted">No contacts found. Add a contact to connect a user account to an entity.</p>
          ) : filteredContacts.length === 0 ? (
            <p className="text-sm text-avcs-muted">No contacts match "{contactDirectorySearch}".</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full min-w-[760px] border-collapse text-left text-sm">
                <thead>
                  <tr className="border-b border-[#1e6bb824] text-xs uppercase tracking-wide text-avcs-muted">
                    <th className="px-3 py-2 font-semibold">Contact</th>
                    <th className="px-3 py-2 font-semibold">Phone</th>
                    <th className="px-3 py-2 font-semibold">User</th>
                    <th className="px-3 py-2 font-semibold">Primary contact for</th>
                    <th className="px-3 py-2 text-right font-semibold">Entities</th>
                    <th className="px-3 py-2 text-right font-semibold">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredContacts.map((contact) => {
                    const primaryLinks = contact.links.filter((link) => link.isPrimary);
                    const primaryEntityLabels = primaryLinks.map((link) => link.entityName);
                    const editableLink = primaryLinks[0] || contact.links[0];
                    const uniqueEntityCount = new Set(contact.links.map((link) => link.entityId)).size;
                    return (
                      <tr key={contact.key} className="border-b border-[#1e6bb812] bg-white last:border-0">
                        <td className="px-3 py-3">
                          <div className="font-semibold text-avcs-text">{contact.name}</div>
                          {contact.email && <div className="text-xs text-avcs-muted">{contact.email}</div>}
                        </td>
                        <td className="px-3 py-3 text-avcs-muted">{contact.phoneNo || '-'}</td>
                        <td className="px-3 py-3">
                          {contact.userId ? (
                            <span className="rounded-full bg-[#e8f4ff] px-2 py-0.5 text-xs font-semibold text-[#0f3b64]">User #{contact.userId}</span>
                          ) : (
                            <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-700">Not a user</span>
                          )}
                        </td>
                        <td className="px-3 py-3">
                          {primaryEntityLabels.length > 0 ? (
                            <div className="grid gap-1">
                              {primaryEntityLabels.map((label) => (
                                <span key={label} className="text-sm text-avcs-text">{label}</span>
                              ))}
                            </div>
                          ) : (
                            <span className="text-xs text-avcs-muted">Not primary</span>
                          )}
                        </td>
                        <td className="px-3 py-3 text-right text-avcs-text">{fmtNum(uniqueEntityCount)}</td>
                        <td className="px-3 py-3">
                          <div className="flex justify-end gap-2">
                            <button type="button" className="btn tiny" onClick={() => openEditContactEditor(editableLink)}>Edit</button>
                            {contact.userId && (
                              <button
                                type="button"
                                className="btn tiny"
                                onClick={() => {
                                  setSetPasswordTargetId(Number(contact.userId));
                                  setSetPasswordValue('');
                                  setSetPasswordConfirm('');
                                  setUserMgmtError('');
                                  setUserMgmtSuccess('');
                                }}
                              >
                                Reset password
                              </button>
                            )}
                            {!contact.userId && (
                              <button type="button" className="btn tiny" onClick={() => openConvertContactEditor(editableLink)}>Convert</button>
                            )}
                            <button
                              type="button"
                              className={DELETE_BTN}
                              onClick={async () => {
                                if (!(await requestConfirm({ title: 'Delete contact', message: 'Delete this contact? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' }))) return;
                                try {
                                  await Promise.all(contact.links.map((link) => deleteEntityContact(link.id)));
                                  await loadEntityDirectory();
                                  setGs1CrudSuccess('Contact deleted.');
                                } catch (error: any) {
                                  setGs1CrudError(parseApiError(error?.message) || 'Could not delete contact.');
                                }
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
        {gs1CrudError && <p className="mt-4 text-sm text-red-600">{gs1CrudError}</p>}
        {gs1CrudSuccess && <p className="mt-4 text-sm text-green-700">{gs1CrudSuccess}</p>}
      </section>
    );
  };

  const renderEntityContactForm = () => (
    <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-2xl font-semibold text-avcs-text">{editingContactId ? 'Edit contact' : 'New contact'}</h2>
          <p className="mt-1 text-sm text-avcs-muted">Manage contact details, user invitation status and linked entities.</p>
        </div>
        <button
          type="button"
          className="btn"
          onClick={() => {
            setShowCreateContactModal(false);
            resetContactEditor();
            setContactModalError('');
            setView('entityContacts');
          }}
        >
          Back to contacts
        </button>
      </div>
      {showCreateContactModal ? (
        renderContactEditorPanel()
      ) : (
        <div className="rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4 text-sm text-avcs-muted">
          No contact selected.
        </div>
      )}
    </section>
  );

  const loadAdminUsers = async () => {
    setLoadingUsers(true);
    setUserMgmtError('');
    try {
      const users = await fetchAdminUsers();
      setAdminUsers(users);
      hasLoadedAdminUsersRef.current = true;
    } catch (err: any) {
      setUserMgmtError(err?.message || 'Failed to load users.');
    } finally {
      setLoadingUsers(false);
    }
  };

  const loadIntegrationSystems = async () => {
    setLoadingIntegrations(true);
    setIntegrationsError('');
    try {
      const systems = await fetchIntegrationSystems();
      setIntegrationSystems(systems);
    } catch (err: any) {
      setIntegrationsError(err?.message || 'Failed to load integrations.');
    } finally {
      setLoadingIntegrations(false);
    }
  };

  const loadAbattoirReceipts = async () => {
    setAbattoirLoading(true);
    setAbattoirError('');
    try {
      const data = await fetchAbattoirReceipts();
      setAbattoirReceipts(data);
    } catch (err: any) {
      setAbattoirReceipts(null);
      setAbattoirError(parseApiError(err?.message) || err?.message || 'Could not load abattoir receipts.');
    } finally {
      setAbattoirLoading(false);
    }
  };

  const patchIntegrationSystem = async (
    system: IntegrationSystemInfo,
    patch: IntegrationSystemPatch,
    successMessage?: string,
  ) => {
    setIntegrationSavingId(system.id);
    setIntegrationsError('');
    setIntegrationsSuccess('');
    try {
      const updated = await updateIntegrationSystem(system.id, patch);
      setIntegrationSystems((prev) => prev.map((s) => (s.id === updated.id ? updated : s)));
      const envLabel = updated.current_environment === 'PRODUCTION' ? 'Production' : 'Test';
      setIntegrationsSuccess(
        successMessage ??
          `"${updated.name}" is now ${updated.is_active ? 'ACTIVE' : 'INACTIVE'} (${envLabel}).`,
      );
      return updated;
    } catch (err: any) {
      setIntegrationsError(err?.message || 'Failed to update integration.');
      return null;
    } finally {
      setIntegrationSavingId('');
    }
  };

  const openIntegrationConfig = (system: IntegrationSystemInfo) => {
    setIntegrationsError('');
    setIntegrationsSuccess('');
    // Prefill the (non-secret) base URLs; key fields start blank — leaving a
    // key blank keeps the stored value, so we never round-trip the secret.
    setIntegrationConfigForm({
      testBaseUrl: system.test_base_url || '',
      productionBaseUrl: system.production_base_url || '',
      testApiKey: '',
      productionApiKey: '',
    });
    setIntegrationConfigId(system.id);
  };

  const saveIntegrationConfig = async (system: IntegrationSystemInfo) => {
    const form = integrationConfigForm;
    const patch: IntegrationSystemPatch = {
      test_base_url: form.testBaseUrl.trim() || null,
      production_base_url: form.productionBaseUrl.trim() || null,
    };
    // Only send a key when the admin actually typed one — a blank input means
    // "leave it as-is", not "clear it".
    if (form.testApiKey.trim()) patch.test_api_key = form.testApiKey.trim();
    if (form.productionApiKey.trim()) patch.production_api_key = form.productionApiKey.trim();

    const updated = await patchIntegrationSystem(
      system,
      patch,
      `Configuration saved for "${system.name}".`,
    );
    if (updated) {
      setIntegrationConfigId('');
      setIntegrationConfigForm({ testBaseUrl: '', productionBaseUrl: '', testApiKey: '', productionApiKey: '' });
    }
  };

  const handleSharedSetPassword = async () => {
    if (setPasswordTargetId === null) return;
    setUserMgmtError('');
    setUserMgmtSuccess('');
    if (!setPasswordValue) { setUserMgmtError('New password is required.'); return; }
    if (setPasswordValue !== setPasswordConfirm) { setUserMgmtError('Passwords do not match.'); return; }
    setSetPasswordSaving(true);
    try {
      await adminSetUserPassword(setPasswordTargetId, setPasswordValue);
      const target = adminUsers.find((u) => u.id === setPasswordTargetId);
      setUserMgmtSuccess(`Password updated for "${target?.username || setPasswordTargetId}".`);
      setSetPasswordTargetId(null);
      setSetPasswordValue('');
      setSetPasswordConfirm('');
    } catch (err: any) {
      setUserMgmtError(err?.message || 'Failed to set password.');
    } finally {
      setSetPasswordSaving(false);
    }
  };

  const renderSharedSetPasswordModal = () => {
    if (setPasswordTargetId === null || view === 'userManagement') return null;
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
        <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
          <h3 className="mb-1 text-base font-semibold text-avcs-text">
            Set password — {adminUsers.find((u) => u.id === setPasswordTargetId)?.username || setPasswordTargetId}
          </h3>
          <p className="mb-4 text-xs text-avcs-muted">The user will be required to change this password on next login.</p>
          <div className="grid gap-3">
            <label className="grid gap-1 text-xs font-medium text-avcs-muted">New password
              <input className="w-full rounded-lg border border-[#1e6bb830] bg-white px-3 py-2 text-sm text-avcs-text focus:border-avcs-blue focus:outline-none" type="password" value={setPasswordValue} onChange={(e) => setSetPasswordValue(e.target.value)} autoComplete="new-password" />
            </label>
            <label className="grid gap-1 text-xs font-medium text-avcs-muted">Confirm password
              <input className="w-full rounded-lg border border-[#1e6bb830] bg-white px-3 py-2 text-sm text-avcs-text focus:border-avcs-blue focus:outline-none" type="password" value={setPasswordConfirm} onChange={(e) => setSetPasswordConfirm(e.target.value)} autoComplete="new-password" />
            </label>
          </div>
          <div className="mt-5 flex justify-end gap-2">
            <button className="rounded-lg border border-[#1e6bb84d] bg-[#f7fbff] px-4 py-2 text-sm font-semibold text-[#0f3b64] transition hover:bg-white" onClick={() => { setSetPasswordTargetId(null); setSetPasswordValue(''); setSetPasswordConfirm(''); setUserMgmtError(''); }}>
              Cancel
            </button>
            <button className="rounded-lg bg-avcs-primary px-4 py-2 text-sm font-semibold text-white shadow transition hover:opacity-90 disabled:opacity-50" onClick={handleSharedSetPassword} disabled={setPasswordSaving}>
              {setPasswordSaving ? 'Saving...' : 'Set password'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderUserManagement = () => {
    if (loadingUsers && adminUsers.length === 0) {
      return <section className="rounded-2xl border border-[#1e6bb824] bg-white p-5 text-sm text-avcs-muted">Loading users…</section>;
    }

    const handleCreateUser = async () => {
      setUserMgmtError('');
      setUserMgmtSuccess('');
      if (!newUserForm.email.trim()) { setUserMgmtError('Email is required so the activation invite can be sent.'); return; }
      setNewUserSaving(true);
      try {
        const created = await createAdminUser({
          username: newUserForm.username.trim() || undefined,
          email: newUserForm.email.trim(),
          first_name: newUserForm.firstName.trim() || undefined,
          last_name: newUserForm.lastName.trim() || undefined,
          is_staff: newUserForm.isStaff,
          rmis_test_token: newUserForm.rmisTestToken.trim() || undefined,
          rmis_production_token: newUserForm.rmisProductionToken.trim() || undefined,
        });
        if (created.activation_email_sent === false) {
          setUserMgmtSuccess(`Account "${created.username || newUserForm.email}" was created, but the activation email was not sent. Use Resend invite.`);
        } else {
          setUserMgmtSuccess(`Invitation sent to "${created.email || newUserForm.email}".`);
        }
        setNewUserForm({ username: '', email: '', firstName: '', lastName: '', isStaff: false, rmisTestToken: '', rmisProductionToken: '' });
        setShowNewUserForm(false);
        await loadAdminUsers();
      } catch (err: any) {
        setUserMgmtError(err?.message || 'Failed to invite user.');
      } finally {
        setNewUserSaving(false);
      }
    };

    const handleResendInvite = async (user: UserSummary) => {
      setUserMgmtError('');
      setUserMgmtSuccess('');
      try {
        await adminSendActivation(user.id);
        setUserMgmtSuccess(`Activation invite sent to "${user.email || user.username}".`);
        await loadAdminUsers();
      } catch (err: any) {
        setUserMgmtError(err?.message || 'Failed to resend activation invite.');
      }
    };

    const handleSetPassword = async () => {
      if (setPasswordTargetId === null) return;
      setUserMgmtError('');
      setUserMgmtSuccess('');
      if (!setPasswordValue) { setUserMgmtError('New password is required.'); return; }
      if (setPasswordValue !== setPasswordConfirm) { setUserMgmtError('Passwords do not match.'); return; }
      setSetPasswordSaving(true);
      try {
        await adminSetUserPassword(setPasswordTargetId, setPasswordValue);
        const target = adminUsers.find((u) => u.id === setPasswordTargetId);
        setUserMgmtSuccess(`Password updated for "${target?.username || setPasswordTargetId}".`);
        setSetPasswordTargetId(null);
        setSetPasswordValue('');
        setSetPasswordConfirm('');
      } catch (err: any) {
        setUserMgmtError(err?.message || 'Failed to set password.');
      } finally {
        setSetPasswordSaving(false);
      }
    };

    const handleToggleActive = async (user: UserSummary) => {
      setUserMgmtError('');
      setUserMgmtSuccess('');
      try {
        await adminUpdateUser(user.id, { is_active: !user.is_active });
        setUserMgmtSuccess(`${user.username} ${!user.is_active ? 'activated' : 'deactivated'}.`);
        await loadAdminUsers();
      } catch (err: any) {
        setUserMgmtError(err?.message || 'Failed to update user.');
      }
    };

    const updateRmisTokenDraft = (userId: number, kind: 'test' | 'production', value: string) => {
      setRmisTokenDrafts((drafts) => ({
        ...drafts,
        [userId]: {
          test: drafts[userId]?.test || '',
          production: drafts[userId]?.production || '',
          [kind]: value,
        },
      }));
    };

    const handleSaveRmisToken = async (user: UserSummary, kind: 'test' | 'production') => {
      const token = (rmisTokenDrafts[user.id]?.[kind] || '').trim();
      if (!token) {
        setUserMgmtError(`Enter an RMIS ${kind} token before saving.`);
        setUserMgmtSuccess('');
        return;
      }
      const field = kind === 'test' ? 'rmis_test_token' : 'rmis_production_token';
      const label = kind === 'test' ? 'test' : 'production';
      setUserMgmtError('');
      setUserMgmtSuccess('');
      setRmisTokenSavingKey(`${user.id}:${kind}`);
      try {
        await adminUpdateUser(user.id, { [field]: token });
        setRmisTokenDrafts((drafts) => ({
          ...drafts,
          [user.id]: {
            test: kind === 'test' ? '' : drafts[user.id]?.test || '',
            production: kind === 'production' ? '' : drafts[user.id]?.production || '',
          },
        }));
        setUserMgmtSuccess(`RMIS ${label} token updated for "${user.username}".`);
        await loadAdminUsers();
      } catch (err: any) {
        setUserMgmtError(err?.message || `Failed to update RMIS ${label} token.`);
      } finally {
        setRmisTokenSavingKey('');
      }
    };

    const handleClearRmisToken = async (user: UserSummary, kind: 'test' | 'production') => {
      const field = kind === 'test' ? 'rmis_test_token' : 'rmis_production_token';
      const label = kind === 'test' ? 'test' : 'production';
      setUserMgmtError('');
      setUserMgmtSuccess('');
      setRmisTokenSavingKey(`${user.id}:${kind}:clear`);
      try {
        await adminUpdateUser(user.id, { [field]: '' });
        setRmisTokenDrafts((drafts) => ({
          ...drafts,
          [user.id]: {
            test: kind === 'test' ? '' : drafts[user.id]?.test || '',
            production: kind === 'production' ? '' : drafts[user.id]?.production || '',
          },
        }));
        setUserMgmtSuccess(`RMIS ${label} token cleared for "${user.username}".`);
        await loadAdminUsers();
      } catch (err: any) {
        setUserMgmtError(err?.message || `Failed to clear RMIS ${label} token.`);
      } finally {
        setRmisTokenSavingKey('');
      }
    };

    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white shadow-sm overflow-hidden flex flex-col" style={{ height: 'calc(100vh - 210px)' }}>
        <div className="mb-0 flex items-center justify-between gap-3 p-4 md:p-6">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">User management</h2>
            <p className="mt-1 text-sm text-avcs-muted">Invite users, resend pending invites and manage account access.</p>
          </div>
          <div className="flex gap-2">
            <button
              className="inline-flex items-center rounded-lg border border-[#1e6bb84d] bg-[#f7fbff] px-3 py-2 text-sm font-semibold text-[#0f3b64] transition hover:bg-white hover:shadow"
              onClick={loadAdminUsers}
            >
              Refresh
            </button>
            <button
              className="inline-flex items-center rounded-lg bg-avcs-primary px-4 py-2 text-sm font-semibold text-white shadow transition hover:opacity-90"
              onClick={() => { setShowNewUserForm((v) => !v); setUserMgmtError(''); setUserMgmtSuccess(''); }}
            >
              {showNewUserForm ? 'Cancel' : '+ Invite user'}
            </button>
          </div>
        </div>

        {/* Search bar */}
        <div className="px-4 pb-3 md:px-6">
          <input
            className="w-full rounded-lg border border-[#1e6bb830] bg-[#f8fbff] px-3 py-2 text-sm text-avcs-text placeholder-avcs-muted focus:border-avcs-primary focus:bg-white focus:outline-none"
            type="search"
            placeholder="Search by username, name or email…"
            value={userSearch}
            onChange={(e) => setUserSearch(e.target.value)}
          />
        </div>

        {userMgmtError && (
          <div className="mx-4 mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 md:mx-6">{userMgmtError}</div>
        )}
        {userMgmtSuccess && (
          <div className="mx-4 mb-4 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-700 md:mx-6">{userMgmtSuccess}</div>
        )}

        {/* New user form */}
        {showNewUserForm && (
          <div className="mx-4 mb-5 rounded-xl border border-[#1e6bb824] bg-[#f8fbff] p-4 md:mx-6">
            <h3 className="mb-1 text-sm font-semibold text-avcs-text">Invite user</h3>
            <p className="mb-3 text-xs text-avcs-muted">The backend will email an activation link. Admins do not set a temporary password.</p>
            <div className="grid gap-3 sm:grid-cols-2">
              <div>
                <label className="mb-1 block text-xs font-medium text-avcs-muted">Username</label>
                <input
                  className="w-full rounded-lg border border-[#1e6bb830] bg-white px-3 py-2 text-sm text-avcs-text focus:border-avcs-blue focus:outline-none"
                  value={newUserForm.username}
                  onChange={(e) => setNewUserForm((f) => ({ ...f, username: e.target.value }))}
                  placeholder="Optional; generated from email if blank"
                  autoComplete="off"
                />
              </div>
              <div>
                <label className="mb-1 block text-xs font-medium text-avcs-muted">Email *</label>
                <input
                  className="w-full rounded-lg border border-[#1e6bb830] bg-white px-3 py-2 text-sm text-avcs-text focus:border-avcs-blue focus:outline-none"
                  type="email"
                  value={newUserForm.email}
                  onChange={(e) => setNewUserForm((f) => ({ ...f, email: e.target.value }))}
                  placeholder="user@example.com"
                  autoComplete="off"
                />
              </div>
              <div>
                <label className="mb-1 block text-xs font-medium text-avcs-muted">First name</label>
                <input
                  className="w-full rounded-lg border border-[#1e6bb830] bg-white px-3 py-2 text-sm text-avcs-text focus:border-avcs-blue focus:outline-none"
                  value={newUserForm.firstName}
                  onChange={(e) => setNewUserForm((f) => ({ ...f, firstName: e.target.value }))}
                  placeholder="First"
                />
              </div>
              <div>
                <label className="mb-1 block text-xs font-medium text-avcs-muted">Last name</label>
                <input
                  className="w-full rounded-lg border border-[#1e6bb830] bg-white px-3 py-2 text-sm text-avcs-text focus:border-avcs-blue focus:outline-none"
                  value={newUserForm.lastName}
                  onChange={(e) => setNewUserForm((f) => ({ ...f, lastName: e.target.value }))}
                  placeholder="Last"
                />
              </div>
              <div>
                <label className="mb-1 block text-xs font-medium text-avcs-muted">RMIS Test Token</label>
                <input
                  className="w-full rounded-lg border border-[#1e6bb830] bg-white px-3 py-2 text-sm text-avcs-text focus:border-avcs-blue focus:outline-none"
                  type="password"
                  value={newUserForm.rmisTestToken}
                  onChange={(e) => setNewUserForm((f) => ({ ...f, rmisTestToken: e.target.value }))}
                  placeholder="Optional"
                  autoComplete="off"
                />
              </div>
              <div>
                <label className="mb-1 block text-xs font-medium text-avcs-muted">RMIS Production Token</label>
                <input
                  className="w-full rounded-lg border border-[#1e6bb830] bg-white px-3 py-2 text-sm text-avcs-text focus:border-avcs-blue focus:outline-none"
                  type="password"
                  value={newUserForm.rmisProductionToken}
                  onChange={(e) => setNewUserForm((f) => ({ ...f, rmisProductionToken: e.target.value }))}
                  placeholder="Optional"
                  autoComplete="off"
                />
              </div>
            </div>
            <label className="mt-3 flex items-center gap-2 text-sm text-avcs-text">
              <input
                type="checkbox"
                checked={newUserForm.isStaff}
                onChange={(e) => setNewUserForm((f) => ({ ...f, isStaff: e.target.checked }))}
                className="rounded border-gray-300"
              />
              Grant staff (admin) access
            </label>
            <div className="mt-4 flex justify-end">
              <button
                className="inline-flex items-center rounded-lg bg-avcs-primary px-5 py-2 text-sm font-semibold text-white shadow transition hover:opacity-90 disabled:opacity-50"
                onClick={handleCreateUser}
                disabled={newUserSaving}
              >
                {newUserSaving ? 'Sending…' : 'Send invite'}
              </button>
            </div>
          </div>
        )}

        {/* Set password modal */}
        {setPasswordTargetId !== null && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
            <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
              <h3 className="mb-1 text-base font-semibold text-avcs-text">
                Set password — {adminUsers.find((u) => u.id === setPasswordTargetId)?.username}
              </h3>
              <p className="mb-4 text-xs text-avcs-muted">The user will be required to change this password on next login.</p>
              <div className="grid gap-3">
                <div>
                  <label className="mb-1 block text-xs font-medium text-avcs-muted">New password</label>
                  <input
                    className="w-full rounded-lg border border-[#1e6bb830] bg-white px-3 py-2 text-sm text-avcs-text focus:border-avcs-blue focus:outline-none"
                    type="password"
                    value={setPasswordValue}
                    onChange={(e) => setSetPasswordValue(e.target.value)}
                    autoComplete="new-password"
                  />
                </div>
                <div>
                  <label className="mb-1 block text-xs font-medium text-avcs-muted">Confirm password</label>
                  <input
                    className="w-full rounded-lg border border-[#1e6bb830] bg-white px-3 py-2 text-sm text-avcs-text focus:border-avcs-blue focus:outline-none"
                    type="password"
                    value={setPasswordConfirm}
                    onChange={(e) => setSetPasswordConfirm(e.target.value)}
                    autoComplete="new-password"
                  />
                </div>
              </div>
              <div className="mt-5 flex justify-end gap-2">
                <button
                  className="rounded-lg border border-[#1e6bb84d] bg-[#f7fbff] px-4 py-2 text-sm font-semibold text-[#0f3b64] transition hover:bg-white"
                  onClick={() => { setSetPasswordTargetId(null); setSetPasswordValue(''); setSetPasswordConfirm(''); setUserMgmtError(''); }}
                >
                  Cancel
                </button>
                <button
                  className="rounded-lg bg-avcs-primary px-4 py-2 text-sm font-semibold text-white shadow transition hover:opacity-90 disabled:opacity-50"
                  onClick={handleSetPassword}
                  disabled={setPasswordSaving}
                >
                  {setPasswordSaving ? 'Saving…' : 'Set password'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* User list */}
        <div className="flex-1 min-h-0 overflow-y-auto border-t border-[#1e6bb824] mt-2">
          {(() => {
            const q = userSearch.trim().toLowerCase();
            const filtered = q
              ? adminUsers.filter((u) =>
                  u.username.toLowerCase().includes(q) ||
                  [u.first_name, u.last_name].filter(Boolean).join(' ').toLowerCase().includes(q) ||
                  (u.email || '').toLowerCase().includes(q)
                )
              : adminUsers;
            if (adminUsers.length === 0) {
              return (
                <div className="px-4 py-8 text-center text-sm text-avcs-muted">
                  {loadingUsers ? 'Loading…' : 'No users found. Click Refresh to load.'}
                </div>
              );
            }
            if (filtered.length === 0) {
              return (
                <div className="px-4 py-8 text-center text-sm text-avcs-muted">
                  No users match "{userSearch}".
                </div>
              );
            }
            return (
              <div className="divide-y divide-[#1e6bb812]">
                {filtered.map((user) => {
                  const fullName = [user.first_name, user.last_name].filter(Boolean).join(' ');
                  const tokenDraft = rmisTokenDrafts[user.id] || { test: '', production: '' };
                  const hasTestToken = Boolean(user.has_rmis_test_token);
                  const hasProductionToken = Boolean(user.has_rmis_production_token);
                  return (
                    <div key={user.id} className="flex flex-wrap items-center gap-3 bg-white px-4 py-3 hover:bg-[#f8fbff]">
                      {/* Identity */}
                      <div className="min-w-0 flex-1">
                        <div className="flex flex-wrap items-center gap-2">
                          <span className="text-sm font-medium text-avcs-text">{user.username}</span>
                          {user.activation_pending && (
                            <span className="inline-flex rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-700">Invite pending</span>
                          )}
                          {user.activation_email_sent === false && (
                            <span className="inline-flex rounded-full bg-red-100 px-2 py-0.5 text-xs font-semibold text-red-600">Invite not sent</span>
                          )}
                          {user.force_password_change && (
                            <span className="inline-flex rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-700">Temp PW</span>
                          )}
                          {fullName && <span className="text-sm text-avcs-muted">{fullName}</span>}
                          {user.is_superuser ? (
                            <span className="inline-flex rounded-full bg-purple-100 px-2 py-0.5 text-xs font-semibold text-purple-700">Superuser</span>
                          ) : user.is_staff ? (
                            <span className="inline-flex rounded-full bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-700">Staff</span>
                          ) : (
                            <span className="inline-flex rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-600">User</span>
                          )}
                          {user.is_active ? (
                            <span className="inline-flex rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-semibold text-emerald-700">Active</span>
                          ) : (
                            <span className="inline-flex rounded-full bg-red-100 px-2 py-0.5 text-xs font-semibold text-red-600">Inactive</span>
                          )}
                        </div>
                        {user.email && (
                          <div className="mt-0.5 truncate text-xs text-avcs-muted">{user.email}</div>
                        )}
                        <div className="mt-3 grid gap-2 lg:grid-cols-2">
                          {([
                            { kind: 'test' as const, label: 'RMIS Test Token', hasToken: hasTestToken },
                            { kind: 'production' as const, label: 'RMIS Production Token', hasToken: hasProductionToken },
                          ]).map(({ kind, label, hasToken }) => {
                            const saving = rmisTokenSavingKey === `${user.id}:${kind}`;
                            const clearing = rmisTokenSavingKey === `${user.id}:${kind}:clear`;
                            return (
                              <div key={kind} className="rounded-lg border border-[#1e6bb81a] bg-[#fbfeff] p-2">
                                <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
                                  <span className="text-xs font-semibold text-avcs-text">{label}</span>
                                  <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${hasToken ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-600'}`}>
                                    {hasToken ? 'Set' : 'Not set'}
                                  </span>
                                </div>
                                <div className="flex flex-wrap gap-2">
                                  <input
                                    className="min-w-[180px] flex-1 rounded-md border border-[#1e6bb830] bg-white px-2 py-1.5 text-xs text-avcs-text focus:border-avcs-blue focus:outline-none"
                                    type="password"
                                    value={tokenDraft[kind]}
                                    onChange={(e) => updateRmisTokenDraft(user.id, kind, e.target.value)}
                                    placeholder={hasToken ? 'Set/Replace token' : 'Set token'}
                                    autoComplete="off"
                                  />
                                  <button
                                    className="whitespace-nowrap rounded-md border border-[#1e6bb84d] bg-[#f7fbff] px-3 py-1.5 text-xs font-semibold text-[#0f3b64] transition hover:bg-white hover:shadow disabled:opacity-50"
                                    onClick={() => handleSaveRmisToken(user, kind)}
                                    disabled={saving || clearing}
                                  >
                                    {saving ? 'Saving...' : 'Set/Replace token'}
                                  </button>
                                  <button
                                    className="whitespace-nowrap rounded-md border border-red-200 bg-red-50 px-3 py-1.5 text-xs font-semibold text-red-700 transition hover:bg-red-100 hover:shadow disabled:opacity-50"
                                    onClick={() => handleClearRmisToken(user, kind)}
                                    disabled={!hasToken || saving || clearing}
                                  >
                                    {clearing ? 'Clearing...' : 'Clear token'}
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      {/* Actions */}
                      <div className="flex shrink-0 items-center gap-2">
                        {(user.activation_pending || user.activation_email_sent === false) && (
                          <button
                            className="whitespace-nowrap rounded-md border border-amber-200 bg-amber-50 px-3 py-1.5 text-xs font-semibold text-amber-800 transition hover:bg-amber-100 hover:shadow"
                            onClick={() => handleResendInvite(user)}
                          >
                            Resend invite
                          </button>
                        )}
                        <button
                          className="whitespace-nowrap rounded-md border border-[#1e6bb84d] bg-[#f7fbff] px-3 py-1.5 text-xs font-semibold text-[#0f3b64] transition hover:bg-white hover:shadow"
                          onClick={() => { setSetPasswordTargetId(user.id); setSetPasswordValue(''); setSetPasswordConfirm(''); setUserMgmtError(''); setUserMgmtSuccess(''); }}
                        >
                          Set password
                        </button>
                        {!user.is_superuser && (
                          <button
                            className={`whitespace-nowrap rounded-md border px-3 py-1.5 text-xs font-semibold transition hover:shadow ${user.is_active ? 'border-red-200 bg-red-50 text-red-700 hover:bg-red-100' : 'border-emerald-200 bg-emerald-50 text-emerald-700 hover:bg-emerald-100'}`}
                            onClick={() => handleToggleActive(user)}
                          >
                            {user.is_active ? 'Deactivate' : 'Activate'}
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })()}
        </div>
      </section>
    );
  };

  const renderValueChainCrud = () => {
    // The catalogue's defaults, used for a programme being created (which has
    // no server-resolved map yet) and to decide which rows are worth sending.
    const catalogueDefaults: Record<string, FieldRequirementState> = {};
    vcCatalogue.forEach((group) => group.entries.forEach((entry) => {
      catalogueDefaults[entry.key] = entry.default;
    }));
    const stateFor = (key: string): FieldRequirementState =>
      vcRequirements[key] ?? catalogueDefaults[key] ?? 'OPTIONAL';
    const setStateFor = (key: string, state: FieldRequirementState) =>
      setVcRequirements((prev) => ({ ...prev, [key]: state }));

    // Counted off the catalogue rather than off `vcRequirements`, so the
    // badge reflects what the programme actually demands — including the
    // rows still sitting on their default — rather than only what has been
    // touched in this editing session.
    const vcAllEntries = vcCatalogue.flatMap((group) => group.entries);
    const vcRequiredCount = vcAllEntries.filter((entry) => stateFor(entry.key) === 'REQUIRED').length;
    const vcHiddenCount = vcAllEntries.filter((entry) => stateFor(entry.key) === 'HIDDEN').length;

    const resetForm = () => {
      setValueChainForm({ name: '', isActive: true, description: '', isScp: false, defaultPurchaserId: '' });
      setVcRequirements({});
      setVcMatrixOpen(false);
      setEditingValueChainId(''); setValueChainCrudError(''); setValueChainCrudSuccess('');
    };
    const submitForm = async (e: React.FormEvent) => {
      e.preventDefault();
      if (!valueChainForm.name.trim()) { setValueChainCrudError('Name is required.'); return; }
      if (valueChainForm.defaultPurchaserId && !valueChainForm.isScp) {
        setValueChainCrudError('A default purchaser only applies to an AVCS SCP. Tick "Is an AVCS SCP" first.');
        return;
      }
      setSavingValueChain(true); setValueChainCrudError(''); setValueChainCrudSuccess('');
      try {
        // The working map is sent whole rather than filtered to changed rows.
        // Filtering to "differs from default" would silently fail to clear a
        // field the operator has just moved back TO the default — the key
        // would be dropped and the stored row would survive. The server
        // deletes a row whose state equals the default, so sending everything
        // is both simpler and the only correct version.
        const payload = {
          name: valueChainForm.name.trim(),
          isActive: valueChainForm.isActive,
          description: valueChainForm.description.trim(),
          isScp: valueChainForm.isScp,
          defaultPurchaserId: valueChainForm.isScp ? (valueChainForm.defaultPurchaserId || null) : null,
          fieldRequirements: vcRequirements,
        };
        if (editingValueChainId) {
          const updated = await updateValueChain(editingValueChainId, payload);
          setValueChains((prev) => prev.map((vc) => vc.id === editingValueChainId ? updated : vc));
          setValueChainCrudSuccess('Supply chain program updated.');
        } else {
          const created = await createValueChain(payload);
          setValueChains((prev) => [...prev, created]);
          setValueChainCrudSuccess('Supply chain program created.');
        }
        loadValueChainOptions();
        resetForm();
      } catch (err: any) { setValueChainCrudError(err?.message || 'Save failed.'); }
      finally { setSavingValueChain(false); }
    };
    const startEdit = (vc: ValueChainSummary) => {
      setValueChainForm({ name: vc.name, isActive: vc.isActive, description: vc.description, isScp: vc.isScp, defaultPurchaserId: vc.defaultPurchaserId || '' });
      // The server sends every key already resolved against the catalogue
      // defaults, so this is the complete picture with nothing to merge.
      setVcRequirements({ ...vc.fieldRequirements });
      setEditingValueChainId(vc.id); setValueChainCrudError(''); setValueChainCrudSuccess('');
      setTimeout(() => { valueChainNameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' }); valueChainNameRef.current?.focus(); }, 0);
    };
    const remove = async (id: string) => {
      setValueChainCrudError(''); setValueChainCrudSuccess('');
      try { await deleteValueChain(id); setValueChains((prev) => prev.filter((vc) => vc.id !== id)); loadValueChainOptions(); setValueChainCrudSuccess('Supply chain program deleted.'); }
      catch (err: any) { setValueChainCrudError(err?.message || 'Delete failed.'); }
    };
    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5 flex flex-col">
        <div className="admin-section-head mb-4 flex items-center justify-between gap-2">
          <h2 className="text-2xl font-semibold text-avcs-text">Supply Chain Programs</h2>
          {editingValueChainId && <button className="admin-inline-action btn" onClick={resetForm}>Cancel edit</button>}
        </div>
        {valueChainCrudError && <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{valueChainCrudError}</div>}
        {valueChainCrudSuccess && <div className="mb-3 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{valueChainCrudSuccess}</div>}
        <form className="mb-4 grid gap-3 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3 md:grid-cols-3" onSubmit={submitForm}>
          <label className="grid gap-1 text-sm text-avcs-text">
            Supply Chain Program name *
            <input ref={valueChainNameRef} className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={valueChainForm.name} onChange={(e) => setValueChainForm((f) => ({ ...f, name: e.target.value }))} placeholder="e.g. Kyto Program" />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text md:col-span-2">
            Description
            <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={valueChainForm.description} onChange={(e) => setValueChainForm((f) => ({ ...f, description: e.target.value }))} placeholder="Optional description" />
          </label>
          <label className="flex items-center gap-2 text-sm text-avcs-text">
            <input type="checkbox" checked={valueChainForm.isActive} onChange={(e) => setValueChainForm((f) => ({ ...f, isActive: e.target.checked }))} />
            Active
          </label>
          <label className="flex items-center gap-2 text-sm text-avcs-text" title="Makes this chain a selectable AVCS Supply Chain Program on the overview.">
            <input type="checkbox" checked={valueChainForm.isScp} onChange={(e) => setValueChainForm((f) => ({ ...f, isScp: e.target.checked }))} />
            Is an AVCS SCP
          </label>
          <label className="grid gap-1 text-sm text-avcs-text md:col-span-2">
            Default purchaser
            <select
              className="rounded-lg border border-[#1e6bb833] px-3 py-2 disabled:bg-[#f1f5f9] disabled:text-avcs-muted"
              value={valueChainForm.defaultPurchaserId}
              disabled={!valueChainForm.isScp}
              onChange={(e) => setValueChainForm((f) => ({ ...f, defaultPurchaserId: e.target.value }))}
            >
              <option value="">No default purchaser</option>
              {entityOptions.map((entity) => (
                <option key={entity.id} value={entity.id}>{entity.label}</option>
              ))}
            </select>
            <span className="text-xs text-avcs-muted">
              {valueChainForm.isScp
                ? 'Prepopulated onto every deal captured under this program.'
                : 'Only an AVCS SCP can prepopulate a purchaser — tick "Is an AVCS SCP" first.'}
            </span>
          </label>

          {/* The field matrix. Collapsed by default: it is a long list, and
              a programme that leaves everything on its default is a valid
              and common answer. */}
          <div className="md:col-span-3 rounded-xl border border-[#1e6bb824] bg-white">
            <button
              type="button"
              className="flex w-full items-center justify-between gap-2 px-3 py-2 text-left"
              onClick={() => setVcMatrixOpen((open) => !open)}
            >
              <span className="text-sm font-semibold text-avcs-text">
                Required fields and documents
                {vcRequiredCount > 0 && (
                  <span className="ml-2 rounded-full bg-[#1e6bb814] px-2 py-0.5 text-xs font-semibold text-[#0f3b64]">
                    {vcRequiredCount} required
                  </span>
                )}
                {vcHiddenCount > 0 && (
                  <span className="ml-2 rounded-full bg-[#f1f5f9] px-2 py-0.5 text-xs font-semibold text-avcs-muted">
                    {vcHiddenCount} not captured
                  </span>
                )}
              </span>
              <span className="text-xs font-semibold text-[#0f3b64]">{vcMatrixOpen ? 'Hide' : 'Show'}</span>
            </button>
            {vcMatrixOpen && (
              <div className="border-t border-[#1e6bb824] px-3 py-3">
                <p className="mb-3 text-xs text-avcs-muted">
                  Choose what every deal in this program must supply. <strong>Required</strong> stops
                  the deal being marked complete until it is filled in or uploaded.{' '}
                  <strong>Optional</strong> captures it without gating — for a document that means the
                  existing rule still applies, so it is asked for only when the deal's own details call
                  for it. <strong>Not captured</strong> drops it from the capture form entirely.
                </p>
                {vcCatalogueError && (
                  <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{vcCatalogueError}</div>
                )}
                {!vcCatalogueError && vcCatalogue.length === 0 && (
                  <p className="text-sm text-avcs-muted">Loading the field list…</p>
                )}
                <div className="grid gap-4">
                  {vcCatalogue.filter((group) => group.entries.length > 0).map((group) => (
                    <div key={group.key}>
                      <div className="mb-2 text-xs font-bold uppercase tracking-wide text-avcs-muted">{group.label}</div>
                      <div className="grid gap-1">
                        {group.entries.map((entry) => {
                          const current = stateFor(entry.key);
                          return (
                            <div key={entry.key} className="grid items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-[#f8fbff] md:grid-cols-[1fr_auto]">
                              <div className="min-w-0">
                                <span className="text-sm text-avcs-text">{entry.label}</span>
                                {entry.kind === 'DOCUMENT' && (
                                  <span className="ml-2 rounded bg-[#1e6bb80f] px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-[#0f3b64]">Upload</span>
                                )}
                                {entry.kind === 'RULE' && (
                                  <span className="ml-2 rounded bg-[#f5efe0] px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-[#7a5c17]">Rule</span>
                                )}
                                {entry.helpText && (
                                  <div className="text-xs text-avcs-muted">{entry.helpText}</div>
                                )}
                              </div>
                              <div className="flex shrink-0 gap-1">
                                {entry.states.map((state) => (
                                  <button
                                    key={state}
                                    type="button"
                                    aria-pressed={current === state}
                                    className={`rounded-md border px-2.5 py-1 text-xs font-semibold transition ${
                                      current === state
                                        ? 'border-[#1e6bb8] bg-[#1e6bb8] text-white'
                                        : 'border-[#1e6bb833] bg-white text-avcs-muted hover:bg-[#f7fbff]'
                                    }`}
                                    onClick={() => setStateFor(entry.key, state)}
                                  >
                                    {VC_STATE_LABELS[state]}
                                  </button>
                                ))}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="flex items-end">
            <button className="btn admin-submit-action" type="submit" disabled={savingValueChain}>{savingValueChain ? 'Saving…' : editingValueChainId ? 'Save supply chain program' : 'Create supply chain program'}</button>
          </div>
        </form>
        {loadingValueChains && <p className="text-sm text-avcs-muted">Loading…</p>}
        <div className="admin-table-scroll flex-1 min-h-0">
          <table className="min-w-full text-sm">
            <thead className="border-b border-[#1e6bb824] bg-[#f8fbff]">
              <tr>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Name</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Description</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Active</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">AVCS SCP</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Required fields</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#1e6bb812]">
              {valueChains.length === 0 && <tr><td colSpan={6} className="px-4 py-4 text-center text-avcs-muted">No value chains yet.</td></tr>}
              {valueChains.map((vc) => (
                <tr key={vc.id} className="bg-white hover:bg-[#f8fbff]">
                  <td className="px-4 py-2 font-medium text-avcs-text">{vc.name}</td>
                  <td className="px-4 py-2 text-avcs-muted">{vc.description || '—'}</td>
                  <td className="px-4 py-2 text-avcs-muted">{vc.isActive ? 'Yes' : 'No'}</td>
                  <td className="px-4 py-2 text-avcs-muted">{vc.isScp ? 'Yes' : '—'}</td>
                  <td className="px-4 py-2 text-avcs-muted">
                    {Object.values(vc.fieldRequirements).filter((state) => state === 'REQUIRED').length || '—'}
                  </td>
                  <td className="px-4 py-2"><div className="flex gap-2">
                    <button className="btn" onClick={() => startEdit(vc)}>Edit</button>
                    <button className={DELETE_BTN} onClick={async () => { if (await requestConfirm({ message: 'Delete this supply chain program? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) remove(vc.id); }}>Delete</button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    );
  };

  const renderProductTypeCrud = () => {
    const resetForm = () => { setProductTypeForm({ name: '' }); setEditingProductTypeId(''); setProductTypeCrudError(''); setProductTypeCrudSuccess(''); };
    const refreshProductTypeOptions = () => { fetchProductTypeOptions().then(setProductTypeOptions).catch(() => {}); };
    const submitForm = async (e: React.FormEvent) => {
      e.preventDefault();
      if (!productTypeForm.name.trim()) { setProductTypeCrudError('Name is required.'); return; }
      setSavingProductType(true); setProductTypeCrudError(''); setProductTypeCrudSuccess('');
      try {
        const payload = { name: productTypeForm.name.trim() };
        if (editingProductTypeId) {
          const updated = await updateProductType(editingProductTypeId, payload);
          setProductTypeList((prev) => prev.map((pt) => pt.id === editingProductTypeId ? updated : pt));
          setProductTypeCrudSuccess('Product type updated.');
        } else {
          const created = await createProductType(payload);
          setProductTypeList((prev) => [...prev, created]);
          setProductTypeCrudSuccess('Product type created.');
        }
        refreshProductTypeOptions();
        resetForm();
      } catch (err: any) { setProductTypeCrudError(err?.message || 'Save failed.'); }
      finally { setSavingProductType(false); }
    };
    const startEdit = (pt: ProductTypeSummary) => { setProductTypeForm({ name: pt.name }); setEditingProductTypeId(pt.id); setProductTypeCrudError(''); setProductTypeCrudSuccess(''); setTimeout(() => { productTypeNameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' }); productTypeNameRef.current?.focus(); }, 0); };
    const remove = async (id: string) => {
      setProductTypeCrudError(''); setProductTypeCrudSuccess('');
      try { await deleteProductType(id); setProductTypeList((prev) => prev.filter((pt) => pt.id !== id)); refreshProductTypeOptions(); setProductTypeCrudSuccess('Product type deleted.'); }
      catch (err: any) { setProductTypeCrudError(err?.message || 'Delete failed.'); }
    };
    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5 flex flex-col">
        <div className="admin-section-head mb-4 flex items-center justify-between gap-2">
          <h2 className="text-2xl font-semibold text-avcs-text">Product Types</h2>
          {editingProductTypeId && <button className="admin-inline-action btn" onClick={resetForm}>Cancel edit</button>}
        </div>
        <p className="mb-3 text-xs text-avcs-muted">Product types classify GTINs (e.g. Live Sheep, Sheep Carcass, Sheep Wool) when allocating or entering a GTIN for an entity.</p>
        {productTypeCrudError && <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{productTypeCrudError}</div>}
        {productTypeCrudSuccess && <div className="mb-3 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{productTypeCrudSuccess}</div>}
        <form className="mb-4 grid gap-3 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3 md:grid-cols-3" onSubmit={submitForm}>
          <label className="grid gap-1 text-sm text-avcs-text md:col-span-2">
            Product type name *
            <input ref={productTypeNameRef} className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={productTypeForm.name} onChange={(e) => setProductTypeForm((f) => ({ ...f, name: e.target.value }))} placeholder="e.g. Live Sheep" />
          </label>
          <div className="flex items-end">
            <button className="btn admin-submit-action" type="submit" disabled={savingProductType}>{savingProductType ? 'Saving…' : editingProductTypeId ? 'Save product type' : 'Create product type'}</button>
          </div>
        </form>
        {loadingProductTypeList && <p className="text-sm text-avcs-muted">Loading…</p>}
        <div className="admin-table-scroll flex-1 min-h-0">
          <table className="min-w-full text-sm">
            <thead className="border-b border-[#1e6bb824] bg-[#f8fbff]">
              <tr>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Name</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#1e6bb812]">
              {productTypeList.length === 0 && <tr><td colSpan={2} className="px-4 py-4 text-center text-avcs-muted">No product types yet.</td></tr>}
              {productTypeList.map((pt) => (
                <tr key={pt.id} className="bg-white hover:bg-[#f8fbff]">
                  <td className="px-4 py-2 font-medium text-avcs-text">{pt.name}</td>
                  <td className="px-4 py-2"><div className="flex gap-2">
                    <button className="btn" onClick={() => startEdit(pt)}>Edit</button>
                    <button className={DELETE_BTN} onClick={async () => { if (await requestConfirm({ message: 'Delete this product type? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) remove(pt.id); }}>Delete</button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    );
  };

  const renderBreedCrud = () => {
    const resetForm = () => { setBreedForm({ name: '', species: 'SHEEP' }); setEditingBreedId(''); setBreedCrudError(''); setBreedCrudSuccess(''); };
    const submitForm = async (e: React.FormEvent) => {
      e.preventDefault();
      if (!breedForm.name.trim()) { setBreedCrudError('Name is required.'); return; }
      setSavingBreed(true); setBreedCrudError(''); setBreedCrudSuccess('');
      try {
        if (editingBreedId) {
          const updated = await updateBreed(editingBreedId, { name: breedForm.name.trim(), species: breedForm.species });
          setBreeds((prev) => prev.map((b) => b.id === editingBreedId ? updated : b));
          setBreedCrudSuccess('Breed updated.');
        } else {
          const created = await createBreed({ name: breedForm.name.trim(), species: breedForm.species });
          setBreeds((prev) => [...prev, created]);
          setBreedCrudSuccess('Breed created.');
        }
        resetForm();
      } catch (err: any) { setBreedCrudError(err?.message || 'Save failed.'); }
      finally { setSavingBreed(false); }
    };
    const startEdit = (b: BreedSummary) => { setBreedForm({ name: b.name, species: b.species }); setEditingBreedId(b.id); setBreedCrudError(''); setBreedCrudSuccess(''); setTimeout(() => { breedNameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' }); breedNameRef.current?.focus(); }, 0); };
    const remove = async (id: string) => {
      setBreedCrudError(''); setBreedCrudSuccess('');
      try { await deleteBreed(id); setBreeds((prev) => prev.filter((b) => b.id !== id)); setBreedCrudSuccess('Breed deleted.'); }
      catch (err: any) { setBreedCrudError(err?.message || 'Delete failed.'); }
    };
    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5 flex flex-col">
        <div className="admin-section-head mb-4 flex items-center justify-between gap-2">
          <h2 className="text-2xl font-semibold text-avcs-text">Breeds</h2>
          {editingBreedId && <button className="admin-inline-action btn" onClick={resetForm}>Cancel edit</button>}
        </div>
        {breedCrudError && <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{breedCrudError}</div>}
        {breedCrudSuccess && <div className="mb-3 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{breedCrudSuccess}</div>}
        <form className="mb-4 grid gap-3 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3 md:grid-cols-3" onSubmit={submitForm}>
          <label className="grid gap-1 text-sm text-avcs-text">
            Breed name *
            <input ref={breedNameRef} className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={breedForm.name} onChange={(e) => setBreedForm((f) => ({ ...f, name: e.target.value }))} placeholder="e.g. Merino" />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">
            Species *
            <select className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={breedForm.species} onChange={(e) => setBreedForm((f) => ({ ...f, species: e.target.value as any }))}>
              <option value="SHEEP">Sheep</option>
              <option value="GOAT">Goat</option>
              <option value="CATTLE">Cattle</option>
            </select>
          </label>
          <div className="flex items-end">
            <button className="btn admin-submit-action" type="submit" disabled={savingBreed}>{savingBreed ? 'Saving…' : editingBreedId ? 'Save breed' : 'Create breed'}</button>
          </div>
        </form>
        {loadingBreeds && <p className="text-sm text-avcs-muted">Loading…</p>}
        <div className="admin-table-scroll flex-1 min-h-0">
          <table className="min-w-full text-sm">
            <thead className="border-b border-[#1e6bb824] bg-[#f8fbff]">
              <tr>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Name</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Species</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#1e6bb812]">
              {breeds.length === 0 && <tr><td colSpan={3} className="px-4 py-4 text-center text-avcs-muted">No breeds yet.</td></tr>}
              {breeds.map((b) => (
                <tr key={b.id} className="bg-white hover:bg-[#f8fbff]">
                  <td className="px-4 py-2 font-medium text-avcs-text">{b.name}</td>
                  <td className="px-4 py-2 text-avcs-muted">{b.species.charAt(0) + b.species.slice(1).toLowerCase()}</td>
                  <td className="px-4 py-2"><div className="flex gap-2">
                    <button className="btn" onClick={() => startEdit(b)}>Edit</button>
                    <button className={DELETE_BTN} onClick={async () => { if (await requestConfirm({ message: 'Delete this breed? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) remove(b.id); }}>Delete</button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    );
  };

  const renderMedicineCrud = () => {
    const resetForm = () => { setMedicineForm({ name: '', brandName: '', producer: '', withholdingPeriod: '', sku: '', stockQty: '' }); setEditingMedicineId(''); setMedicineCrudError(''); setMedicineCrudSuccess(''); };
    const submitForm = async (e: React.FormEvent) => {
      e.preventDefault();
      if (!medicineForm.name.trim()) { setMedicineCrudError('Name is required.'); return; }
      setSavingMedicine(true); setMedicineCrudError(''); setMedicineCrudSuccess('');
      const payload: Omit<MedicineSummary, 'id'> = {
        name: medicineForm.name.trim(), brandName: medicineForm.brandName.trim(),
        producer: medicineForm.producer.trim(),
        withholdingPeriod: Number(medicineForm.withholdingPeriod || 0), sku: medicineForm.sku.trim(),
        stockQty: Number(medicineForm.stockQty || 0),
      };
      try {
        if (editingMedicineId) {
          const updated = await updateMedicine(editingMedicineId, payload);
          setMedicines((prev) => prev.map((m) => m.id === editingMedicineId ? updated : m));
          setMedicineCrudSuccess('Medicine updated.');
        } else {
          const created = await createMedicine(payload);
          setMedicines((prev) => [...prev, created]);
          setMedicineCrudSuccess('Medicine created.');
        }
        resetForm();
      } catch (err: any) { setMedicineCrudError(err?.message || 'Save failed.'); }
      finally { setSavingMedicine(false); }
    };
    const startEdit = (m: MedicineSummary) => {
      setMedicineForm({ name: m.name, brandName: m.brandName, producer: m.producer, withholdingPeriod: String(m.withholdingPeriod), sku: m.sku, stockQty: String(m.stockQty) });
      setEditingMedicineId(m.id); setMedicineCrudError(''); setMedicineCrudSuccess('');
      setTimeout(() => { medicineNameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' }); medicineNameRef.current?.focus(); }, 0);
    };
    const remove = async (id: string) => {
      setMedicineCrudError(''); setMedicineCrudSuccess('');
      try { await deleteMedicine(id); setMedicines((prev) => prev.filter((m) => m.id !== id)); setMedicineCrudSuccess('Medicine deleted.'); }
      catch (err: any) { setMedicineCrudError(err?.message || 'Delete failed.'); }
    };
    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5 flex flex-col">
        <div className="admin-section-head mb-4 flex items-center justify-between gap-2">
          <h2 className="text-2xl font-semibold text-avcs-text">Medicines</h2>
          {editingMedicineId && <button className="admin-inline-action btn" onClick={resetForm}>Cancel edit</button>}
        </div>
        {medicineCrudError && <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{medicineCrudError}</div>}
        {medicineCrudSuccess && <div className="mb-3 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{medicineCrudSuccess}</div>}
        <form className="mb-4 grid gap-3 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3 md:grid-cols-2" onSubmit={submitForm}>
          <label className="grid gap-1 text-sm text-avcs-text">Name * <input ref={medicineNameRef} className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={medicineForm.name} onChange={(e) => setMedicineForm((f) => ({ ...f, name: e.target.value }))} /></label>
          <label className="grid gap-1 text-sm text-avcs-text">Brand name <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={medicineForm.brandName} onChange={(e) => setMedicineForm((f) => ({ ...f, brandName: e.target.value }))} /></label>
          <label className="grid gap-1 text-sm text-avcs-text">Producer <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={medicineForm.producer} onChange={(e) => setMedicineForm((f) => ({ ...f, producer: e.target.value }))} /></label>
          <label className="grid gap-1 text-sm text-avcs-text">SKU <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={medicineForm.sku} onChange={(e) => setMedicineForm((f) => ({ ...f, sku: e.target.value }))} /></label>
          <label className="grid gap-1 text-sm text-avcs-text">Withholding period (days) <input type="number" min={0} className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={medicineForm.withholdingPeriod} onChange={(e) => setMedicineForm((f) => ({ ...f, withholdingPeriod: e.target.value }))} /></label>
          <label className="grid gap-1 text-sm text-avcs-text">Stock qty (ml) <input type="number" min={0} step="0.01" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={medicineForm.stockQty} onChange={(e) => setMedicineForm((f) => ({ ...f, stockQty: e.target.value }))} /></label>
          <div className="md:col-span-2 flex gap-2">
            <button className="btn admin-submit-action" type="submit" disabled={savingMedicine}>{savingMedicine ? 'Saving…' : editingMedicineId ? 'Save medicine' : 'Create medicine'}</button>
          </div>
        </form>
        {loadingMedicines && <p className="text-sm text-avcs-muted">Loading…</p>}
        <div className="admin-table-scroll flex-1 min-h-0">
          <table className="min-w-full text-sm">
            <thead className="border-b border-[#1e6bb824] bg-[#f8fbff]">
              <tr>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Name</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Brand</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">W/H (days)</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Stock (ml)</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#1e6bb812]">
              {medicines.length === 0 && <tr><td colSpan={5} className="px-4 py-4 text-center text-avcs-muted">No medicines yet.</td></tr>}
              {medicines.map((m) => (
                <tr key={m.id} className="bg-white hover:bg-[#f8fbff]">
                  <td className="px-4 py-2 font-medium text-avcs-text">{m.name}</td>
                  <td className="px-4 py-2 text-avcs-muted">{m.brandName}</td>
                  <td className="px-4 py-2 text-avcs-muted">{m.withholdingPeriod}</td>
                  <td className="px-4 py-2 text-avcs-muted">{m.stockQty}</td>
                  <td className="px-4 py-2"><div className="flex gap-2">
                    <button className="btn" onClick={() => startEdit(m)}>Edit</button>
                    <button className={DELETE_BTN} onClick={async () => { if (await requestConfirm({ message: 'Delete this medicine? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) remove(m.id); }}>Delete</button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    );
  };

  const renderEquipmentAllocation = () => {
    const resetForm = () => { setEquipmentForm({ deviceType: 'XR5000', serialNumber: '', issueDate: '', returnDate: '', notes: '', isActive: true, cost: '', dealId: '' }); setEditingEquipmentId(''); setEquipmentCrudError(''); setEquipmentCrudSuccess(''); };
    const submitForm = async (e: React.FormEvent) => {
      e.preventDefault();
      if (!equipmentForm.serialNumber.trim()) { setEquipmentCrudError('Serial number is required.'); return; }
      if (!equipmentForm.issueDate) { setEquipmentCrudError('Issue date is required.'); return; }
      setSavingEquipment(true); setEquipmentCrudError(''); setEquipmentCrudSuccess('');
      const payload: Omit<EquipmentSummary, 'id'> = {
        deviceType: equipmentForm.deviceType, serialNumber: equipmentForm.serialNumber.trim(),
        issueDate: equipmentForm.issueDate, returnDate: equipmentForm.returnDate,
        notes: equipmentForm.notes, isActive: equipmentForm.isActive,
        cost: equipmentForm.cost ? Number(equipmentForm.cost) : null,
        dealId: equipmentForm.dealId || null,
      };
      try {
        if (editingEquipmentId) {
          const updated = await updateEquipment(editingEquipmentId, payload);
          setEquipmentList((prev) => prev.map((eq) => eq.id === editingEquipmentId ? updated : eq));
          setEquipmentCrudSuccess('Equipment updated.');
        } else {
          const created = await createEquipment(payload);
          setEquipmentList((prev) => [...prev, created]);
          setEquipmentCrudSuccess('Equipment created.');
        }
        resetForm();
      } catch (err: any) { setEquipmentCrudError(err?.message || 'Save failed.'); }
      finally { setSavingEquipment(false); }
    };
    const startEdit = (eq: EquipmentSummary) => {
      setEquipmentForm({ deviceType: eq.deviceType, serialNumber: eq.serialNumber, issueDate: eq.issueDate, returnDate: eq.returnDate, notes: eq.notes, isActive: eq.isActive, cost: eq.cost != null ? String(eq.cost) : '', dealId: eq.dealId || '' });
      setEditingEquipmentId(eq.id); setEquipmentCrudError(''); setEquipmentCrudSuccess('');
      setTimeout(() => { equipmentSerialRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' }); equipmentSerialRef.current?.focus(); }, 0);
    };
    const remove = async (id: string) => {
      setEquipmentCrudError(''); setEquipmentCrudSuccess('');
      try { await deleteEquipment(id); setEquipmentList((prev) => prev.filter((eq) => eq.id !== id)); setEquipmentCrudSuccess('Equipment deleted.'); }
      catch (err: any) { setEquipmentCrudError(err?.message || 'Delete failed.'); }
    };
    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5 flex flex-col">
        <div className="admin-section-head mb-4 flex items-center justify-between gap-2">
          <h2 className="text-2xl font-semibold text-avcs-text">Equipment allocation</h2>
          {editingEquipmentId && <button className="admin-inline-action btn" onClick={resetForm}>Cancel edit</button>}
        </div>
        {equipmentCrudError && <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{equipmentCrudError}</div>}
        {equipmentCrudSuccess && <div className="mb-3 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{equipmentCrudSuccess}</div>}
        <form className="mb-4 grid gap-3 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3 md:grid-cols-2" onSubmit={submitForm}>
          <label className="grid gap-1 text-sm text-avcs-text">
            Device type *
            <select className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={equipmentForm.deviceType} onChange={(e) => setEquipmentForm((f) => ({ ...f, deviceType: e.target.value }))}>
              <option value="XR5000">XR5000 Datamars Device</option>
              <option value="XRS2I">XRS2i Stick Reader</option>
            </select>
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Serial number * <input ref={equipmentSerialRef} className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={equipmentForm.serialNumber} onChange={(e) => setEquipmentForm((f) => ({ ...f, serialNumber: e.target.value }))} /></label>
          <label className="grid gap-1 text-sm text-avcs-text">Issue date * <input type="date" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={equipmentForm.issueDate} onChange={(e) => setEquipmentForm((f) => ({ ...f, issueDate: e.target.value }))} /></label>
          <label className="grid gap-1 text-sm text-avcs-text">Return date <input type="date" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={equipmentForm.returnDate} onChange={(e) => setEquipmentForm((f) => ({ ...f, returnDate: e.target.value }))} /></label>
          <label className="grid gap-1 text-sm text-avcs-text">
            Allocated deal
            <select className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={equipmentForm.dealId} onChange={(e) => setEquipmentForm((f) => ({ ...f, dealId: e.target.value }))}>
              <option value="">— Unallocated —</option>
              {deals.map((d) => <option key={d.dealId} value={d.dealId}>{d.title}</option>)}
            </select>
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Cost (R) <input type="number" min={0} step="0.01" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={equipmentForm.cost} onChange={(e) => setEquipmentForm((f) => ({ ...f, cost: e.target.value }))} /></label>
          <label className="grid gap-1 text-sm text-avcs-text md:col-span-2">Notes <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={equipmentForm.notes} onChange={(e) => setEquipmentForm((f) => ({ ...f, notes: e.target.value }))} /></label>
          <label className="flex items-center gap-2 text-sm text-avcs-text md:col-span-2">
            <input type="checkbox" checked={equipmentForm.isActive} onChange={(e) => setEquipmentForm((f) => ({ ...f, isActive: e.target.checked }))} className="rounded" />
            Active
          </label>
          <div className="md:col-span-2 flex gap-2">
            <button className="btn admin-submit-action" type="submit" disabled={savingEquipment}>{savingEquipment ? 'Saving…' : editingEquipmentId ? 'Save equipment' : 'Create equipment'}</button>
          </div>
        </form>
        {loadingEquipment && <p className="text-sm text-avcs-muted">Loading…</p>}
        <div className="admin-table-scroll flex-1 min-h-0">
          <table className="min-w-full text-sm">
            <thead className="border-b border-[#1e6bb824] bg-[#f8fbff]">
              <tr>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Device</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Serial</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Issued</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Deal</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Status</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#1e6bb812]">
              {equipmentList.length === 0 && <tr><td colSpan={6} className="px-4 py-4 text-center text-avcs-muted">No equipment yet.</td></tr>}
              {equipmentList.map((eq) => {
                const deal = deals.find((d) => d.dealId === eq.dealId);
                return (
                  <tr key={eq.id} className="bg-white hover:bg-[#f8fbff]">
                    <td className="px-4 py-2 font-medium text-avcs-text">{eq.deviceType}</td>
                    <td className="px-4 py-2 text-avcs-muted">{eq.serialNumber}</td>
                    <td className="px-4 py-2 text-avcs-muted">{eq.issueDate}</td>
                    <td className="px-4 py-2 text-avcs-muted">{deal?.title || (eq.dealId ? eq.dealId : '—')}</td>
                    <td className="px-4 py-2">
                      {eq.isActive ? <span className="inline-flex rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-semibold text-emerald-700">Active</span> : <span className="inline-flex rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-500">Returned</span>}
                    </td>
                    <td className="px-4 py-2"><div className="flex gap-2">
                      <button className="btn" onClick={() => startEdit(eq)}>Edit</button>
                      <button className={DELETE_BTN} onClick={async () => { if (await requestConfirm({ message: 'Delete this equipment allocation? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) remove(eq.id); }}>Delete</button>
                    </div></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </section>
    );
  };

  const renderWoolClassCrud = () => {
    const resetForm = () => { setWoolClassForm({ code: '', name: '', description: '' }); setEditingWoolClassId(''); setWoolClassCrudError(''); setWoolClassCrudSuccess(''); };
    const submitForm = async (e: React.FormEvent) => {
      e.preventDefault();
      if (!woolClassForm.code.trim() || !woolClassForm.name.trim()) { setWoolClassCrudError('Code and name are required.'); return; }
      setSavingWoolClass(true); setWoolClassCrudError(''); setWoolClassCrudSuccess('');
      try {
        if (editingWoolClassId) {
          const updated = await updateWoolClass(editingWoolClassId, { code: woolClassForm.code.trim(), name: woolClassForm.name.trim(), description: woolClassForm.description });
          setWoolClasses((prev) => prev.map((wc) => wc.id === editingWoolClassId ? updated : wc));
          setWoolClassCrudSuccess('Wool class updated.');
        } else {
          const created = await createWoolClass({ code: woolClassForm.code.trim(), name: woolClassForm.name.trim(), description: woolClassForm.description });
          setWoolClasses((prev) => [...prev, created]);
          setWoolClassCrudSuccess('Wool class created.');
        }
        resetForm();
      } catch (err: any) { setWoolClassCrudError(err?.message || 'Save failed.'); }
      finally { setSavingWoolClass(false); }
    };
    const startEdit = (wc: WoolClassSummary) => { setWoolClassForm({ code: wc.code, name: wc.name, description: wc.description }); setEditingWoolClassId(wc.id); setWoolClassCrudError(''); setWoolClassCrudSuccess(''); setTimeout(() => { woolCodeRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' }); woolCodeRef.current?.focus(); }, 0); };
    const remove = async (id: string) => {
      setWoolClassCrudError(''); setWoolClassCrudSuccess('');
      try { await deleteWoolClass(id); setWoolClasses((prev) => prev.filter((wc) => wc.id !== id)); setWoolClassCrudSuccess('Wool class deleted.'); }
      catch (err: any) { setWoolClassCrudError(err?.message || 'Delete failed.'); }
    };
    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5 flex flex-col">
        <div className="admin-section-head mb-4 flex items-center justify-between gap-2">
          <h2 className="text-2xl font-semibold text-avcs-text">Wool classes</h2>
          {editingWoolClassId && <button className="admin-inline-action btn" onClick={resetForm}>Cancel edit</button>}
        </div>
        {woolClassCrudError && <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{woolClassCrudError}</div>}
        {woolClassCrudSuccess && <div className="mb-3 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{woolClassCrudSuccess}</div>}
        <form className="mb-4 grid gap-3 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3 md:grid-cols-3" onSubmit={submitForm}>
          <label className="grid gap-1 text-sm text-avcs-text">Code * <input ref={woolCodeRef} className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={woolClassForm.code} onChange={(e) => setWoolClassForm((f) => ({ ...f, code: e.target.value }))} placeholder="e.g. A" /></label>
          <label className="grid gap-1 text-sm text-avcs-text">Name * <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={woolClassForm.name} onChange={(e) => setWoolClassForm((f) => ({ ...f, name: e.target.value }))} placeholder="e.g. Fine Merino" /></label>
          <label className="grid gap-1 text-sm text-avcs-text">Description <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={woolClassForm.description} onChange={(e) => setWoolClassForm((f) => ({ ...f, description: e.target.value }))} /></label>
          <div className="md:col-span-3 flex gap-2">
            <button className="btn admin-submit-action" type="submit" disabled={savingWoolClass}>{savingWoolClass ? 'Saving…' : editingWoolClassId ? 'Save class' : 'Create class'}</button>
          </div>
        </form>
        {loadingWoolClasses && <p className="text-sm text-avcs-muted">Loading…</p>}
        <div className="admin-table-scroll flex-1 min-h-0">
          <table className="min-w-full text-sm">
            <thead className="border-b border-[#1e6bb824] bg-[#f8fbff]">
              <tr>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Code</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Name</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Description</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#1e6bb812]">
              {woolClasses.length === 0 && <tr><td colSpan={4} className="px-4 py-4 text-center text-avcs-muted">No wool classes yet.</td></tr>}
              {woolClasses.map((wc) => (
                <tr key={wc.id} className="bg-white hover:bg-[#f8fbff]">
                  <td className="px-4 py-2 font-medium text-avcs-text">{wc.code}</td>
                  <td className="px-4 py-2 text-avcs-text">{wc.name}</td>
                  <td className="px-4 py-2 text-avcs-muted">{wc.description || '—'}</td>
                  <td className="px-4 py-2"><div className="flex gap-2">
                    <button className="btn" onClick={() => startEdit(wc)}>Edit</button>
                    <button className={DELETE_BTN} onClick={async () => { if (await requestConfirm({ message: 'Delete this wool class? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) remove(wc.id); }}>Delete</button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    );
  };

  const renderDocumentTypeCrud = () => {
    const resetForm = () => { setDocumentTypeForm({ name: '', code: '', description: '', allowedExtensions: 'pdf,jpg,jpeg,png', financeRecordType: '' }); setEditingDocumentTypeId(''); setDocumentTypeCrudError(''); setDocumentTypeCrudSuccess(''); };
    const submitForm = async (e: React.FormEvent) => {
      e.preventDefault();
      const name = documentTypeForm.name.trim();
      const extensions = documentTypeForm.allowedExtensions.split(',').map((x) => x.trim().replace(/^\./, '').toLowerCase()).filter(Boolean).join(',');
      if (!name) { setDocumentTypeCrudError('Name the document type.'); return; }
      if (!extensions) { setDocumentTypeCrudError('List at least one allowed file extension, e.g. pdf,jpg,png.'); return; }
      setSavingDocumentType(true); setDocumentTypeCrudError(''); setDocumentTypeCrudSuccess('');
      try {
        const input = { name, code: documentTypeForm.code, description: documentTypeForm.description.trim(), allowedExtensions: extensions, financeRecordType: documentTypeForm.financeRecordType };
        if (editingDocumentTypeId) {
          const updated = await updateDocumentType(editingDocumentTypeId, input);
          setDocumentTypes((prev) => prev.map((dt) => (dt.id === editingDocumentTypeId ? updated : dt)));
          setDocumentTypeCrudSuccess('Document type updated.');
        } else {
          const created = await createDocumentType(input);
          setDocumentTypes((prev) => [...prev, created].sort((a, b) => a.name.localeCompare(b.name)));
          setDocumentTypeCrudSuccess('Document type created — it is available in every document picker now.');
        }
        resetForm();
        // The document pickers read their own option list; refresh it so the
        // new or renamed type shows without a reload.
        fetchDealDocumentTypeOptions().then(setDealDocumentTypeOptions).catch(() => {});
      } catch (err: any) { setDocumentTypeCrudError(parseApiError(err?.message) || err?.message || 'Save failed.'); }
      finally { setSavingDocumentType(false); }
    };
    const startEdit = (dt: DocumentTypeRecord) => { setDocumentTypeForm({ name: dt.name, code: dt.code, description: dt.description, allowedExtensions: dt.allowedExtensions, financeRecordType: dt.financeRecordType }); setEditingDocumentTypeId(dt.id); setDocumentTypeCrudError(''); setDocumentTypeCrudSuccess(''); };
    const remove = async (dt: DocumentTypeRecord) => {
      setDocumentTypeCrudError(''); setDocumentTypeCrudSuccess('');
      try { await deleteDocumentType(dt.id); setDocumentTypes((prev) => prev.filter((x) => x.id !== dt.id)); setDocumentTypeCrudSuccess('Document type deleted.'); fetchDealDocumentTypeOptions().then(setDealDocumentTypeOptions).catch(() => {}); }
      catch (err: any) { setDocumentTypeCrudError(parseApiError(err?.message) || 'Could not delete — a type with documents filed under it is protected.'); }
    };
    const codeLabel = (code: string) => DOCUMENT_TYPE_CODES.find((c) => c.value === code)?.label || code;
    const takenCodes = new Set(documentTypes.filter((dt) => dt.code && dt.id !== editingDocumentTypeId).map((dt) => dt.code));
    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5 flex flex-col">
        <div className="admin-section-head mb-4 flex items-center justify-between gap-2">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">Document types</h2>
            <p className="mt-0.5 text-sm text-avcs-muted">The kinds of document that can be filed against a deal. A compliance code marks the one type that satisfies a required document; leave it blank for ordinary filing types.</p>
          </div>
          {editingDocumentTypeId && <button className="admin-inline-action btn" onClick={resetForm}>Cancel edit</button>}
        </div>
        {documentTypeCrudError && <div className="mb-3 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{documentTypeCrudError}</div>}
        {documentTypeCrudSuccess && <div className="mb-3 rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{documentTypeCrudSuccess}</div>}
        <form className="mb-4 grid gap-3 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3 md:grid-cols-2" onSubmit={submitForm}>
          <label className="grid gap-1 text-sm text-avcs-text">Name *
            <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={documentTypeForm.name} onChange={(e) => setDocumentTypeForm((f) => ({ ...f, name: e.target.value }))} placeholder="e.g. Slaughter sheet" />
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Compliance code
            <select className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2" value={documentTypeForm.code} onChange={(e) => setDocumentTypeForm((f) => ({ ...f, code: e.target.value }))}>
              {DOCUMENT_TYPE_CODES.map((c) => (
                <option key={c.value || 'none'} value={c.value} disabled={Boolean(c.value) && takenCodes.has(c.value)}>
                  {c.label}{c.value && takenCodes.has(c.value) ? ' — already assigned' : ''}
                </option>
              ))}
            </select>
            <span className="text-xs text-avcs-muted">Each code belongs to exactly one type; the completion checklist looks the type up by it.</span>
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Money on this document
            <select className="rounded-lg border border-[#1e6bb833] bg-white px-3 py-2" value={documentTypeForm.financeRecordType} onChange={(e) => setDocumentTypeForm((f) => ({ ...f, financeRecordType: e.target.value }))}>
              <option value="">— not set (a value is booked as a sale) —</option>
              <option value="NONE">No money — filing only (no value box)</option>
              <optgroup label="Income">
                {DEAL_FINANCE_TYPES.filter((t) => !t.isCost).map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
              </optgroup>
              <optgroup label="Costs">
                {DEAL_FINANCE_TYPES.filter((t) => t.isCost).map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
              </optgroup>
            </select>
            <span className="text-xs text-avcs-muted">Labels the value box on upload ("Feed cost" vs "Sale value") and decides the ledger row the value books.</span>
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Allowed file extensions *
            <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={documentTypeForm.allowedExtensions} onChange={(e) => setDocumentTypeForm((f) => ({ ...f, allowedExtensions: e.target.value }))} placeholder="pdf,jpg,jpeg,png" />
            <span className="text-xs text-avcs-muted">Comma separated, no dots.</span>
          </label>
          <label className="grid gap-1 text-sm text-avcs-text">Description
            <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={documentTypeForm.description} onChange={(e) => setDocumentTypeForm((f) => ({ ...f, description: e.target.value }))} placeholder="What this document is and who issues it" />
          </label>
          <div className="md:col-span-2 flex gap-2">
            <button className="btn admin-submit-action" type="submit" disabled={savingDocumentType}>{savingDocumentType ? 'Saving…' : editingDocumentTypeId ? 'Save document type' : 'Create document type'}</button>
          </div>
        </form>
        {loadingDocumentTypeRows && <p className="text-sm text-avcs-muted">Loading…</p>}
        <div className="admin-table-scroll flex-1 min-h-0">
          <table className="min-w-full text-sm">
            <thead className="border-b border-[#1e6bb824] bg-[#f8fbff]">
              <tr>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Name</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Compliance code</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Money</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Extensions</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Description</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#1e6bb812]">
              {!loadingDocumentTypeRows && documentTypes.length === 0 && <tr><td colSpan={6} className="px-4 py-4 text-center text-avcs-muted">No document types yet.</td></tr>}
              {documentTypes.map((dt) => (
                <tr key={dt.id} className="bg-white hover:bg-[#f8fbff]">
                  <td className="px-4 py-2 font-medium text-avcs-text">{dt.name}</td>
                  <td className="px-4 py-2 text-avcs-text">
                    {dt.code ? <span className="rounded border border-[#1e6bb824] bg-[#fbfeff] px-1.5 py-0.5 text-xs font-semibold text-[#0f3b64]" title={dt.code}>{codeLabel(dt.code)}</span> : <span className="text-avcs-muted">—</span>}
                  </td>
                  <td className="px-4 py-2 text-avcs-text">
                    {(() => {
                      if (dt.financeRecordType === 'NONE') return <span className="rounded border border-[#1e6bb824] bg-[#fbfeff] px-1.5 py-0.5 text-xs font-semibold text-avcs-muted">Filing only</span>;
                      const meta = DEAL_FINANCE_TYPES.find((t) => t.value === dt.financeRecordType);
                      return meta
                        ? <span className={`rounded px-1.5 py-0.5 text-xs font-semibold ${meta.isCost ? 'border border-[#e7bbb9] bg-[#fdf1ef] text-[#6b1010]' : 'border border-[#b9e7c9] bg-[#e7f8ee] text-[#106b38]'}`}>{meta.isCost ? 'Cost' : 'Income'} · {meta.label}</span>
                        : <span className="text-avcs-muted">— (sale)</span>;
                    })()}
                  </td>
                  <td className="px-4 py-2 font-mono text-xs text-avcs-muted">{dt.allowedExtensions || '—'}</td>
                  <td className="px-4 py-2 text-avcs-muted">{dt.description || '—'}</td>
                  <td className="px-4 py-2"><div className="flex gap-2">
                    <button className="btn" onClick={() => startEdit(dt)}>Edit</button>
                    <button className={DELETE_BTN} onClick={async () => { if (await requestConfirm({ title: 'Delete document type', message: `Delete "${dt.name}"? Types with documents filed under them cannot be deleted.`, confirmLabel: 'Delete', tone: 'danger' })) remove(dt); }}>Delete</button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    );
  };

  const renderWoolBales = () => {
    const resetBaleForm = () => {
      setWoolBaleForm({ baleWeight: '', cleanedWeight: '', tareWeight: '3', woolClassId: '', woolBreedId: '', notes: '' });
      setEditingWoolBaleId('');
      setWoolBaleError('');
      setWoolBaleSuccess('');
    };

    const loadBalesForSession = async (sessionId: string) => {
      if (!sessionId) { setWoolBalesForSession([]); return; }
      setLoadingWoolBales(true);
      try {
        const bales = await fetchWoolBales(sessionId);
        setWoolBalesForSession(bales);
      } catch { setWoolBalesForSession([]); }
      finally { setLoadingWoolBales(false); }
    };

    const submitBale = async (e: React.FormEvent) => {
      e.preventDefault();
      if (!woolBalesSessionId) {
        setWoolBaleError('Select a shearing session first.');
        return;
      }
      setSavingWoolBale(true);
      setWoolBaleError('');
      setWoolBaleSuccess('');
      try {
        const input = {
          session: woolBalesSessionId,
          bale_weight: woolBaleForm.baleWeight ? Number(woolBaleForm.baleWeight) : undefined,
          cleaned_weight: woolBaleForm.cleanedWeight ? Number(woolBaleForm.cleanedWeight) : undefined,
          tare_weight: woolBaleForm.tareWeight ? Number(woolBaleForm.tareWeight) : undefined,
          wool_class: woolBaleForm.woolClassId || undefined,
          wool_breed: woolBaleForm.woolBreedId || undefined,
          notes: woolBaleForm.notes.trim() || undefined,
        };
        if (editingWoolBaleId) {
          const updated = await updateWoolBale(editingWoolBaleId, input);
          setWoolBalesForSession((prev) => prev.map((b) => b.id === editingWoolBaleId ? updated : b));
          setWoolBaleSuccess('Bale updated.');
        } else {
          const created = await createWoolBale(input);
          setWoolBalesForSession((prev) => [...prev, created]);
          setWoolBaleSuccess(`Bale ${created.bale_number} added.`);
          // Reflect the session moving into "baling in progress".
          setWoolSessionsForDeal((prev) => prev.map((s) => s.id === woolBalesSessionId && s.baling_status === 'UNBALED' ? { ...s, baling_status: 'IN_PROGRESS' } : s));
        }
        resetBaleForm();
      } catch (err: any) {
        setWoolBaleError(err?.message || 'Save failed.');
      } finally {
        setSavingWoolBale(false);
      }
    };

    const startEditBale = (bale: WoolBaleSummary) => {
      setWoolBaleForm({
        baleWeight: bale.bale_weight != null ? String(bale.bale_weight) : '',
        cleanedWeight: bale.cleaned_weight != null ? String(bale.cleaned_weight) : '',
        tareWeight: bale.tare_weight != null ? String(bale.tare_weight) : '3',
        woolClassId: bale.wool_class || '',
        woolBreedId: bale.wool_breed || '',
        notes: bale.notes || '',
      });
      setEditingWoolBaleId(bale.id);
      setWoolBaleError('');
      setWoolBaleSuccess('');
    };

    const removeBale = async (id: string) => {
      setWoolBaleError('');
      setWoolBaleSuccess('');
      try {
        await deleteWoolBale(id);
        setWoolBalesForSession((prev) => prev.filter((b) => b.id !== id));
        setWoolBaleSuccess('Bale deleted.');
      } catch (err: any) {
        setWoolBaleError(err?.message || 'Delete failed.');
      }
    };

    const finishBalingSession = async () => {
      if (!woolBalesSessionId) return;
      if (woolBalesForSession.length === 0) {
        setWoolBaleError('Add at least one bale before finishing baling.');
        return;
      }
      setFinishingBaling(true);
      setWoolBaleError('');
      setWoolBaleSuccess('');
      try {
        const result = await finishBaling(woolBalesSessionId);
        setWoolSessionsForDeal((prev) => prev.map((s) => s.id === woolBalesSessionId ? { ...s, baling_status: 'BALED', baled_at: result.baled_at } : s));
        const vrz = (result as any).virtual_routez;
        const vrzNote = vrz?.status === 'SUCCESS'
          ? ' Sent to Virtual Routez.'
          : vrz?.status === 'FAILED'
            ? ' Virtual Routez delivery failed (see event history).'
            : vrz?.status === 'SKIPPED'
              ? ' (Virtual Routez not triggered.)'
              : '';
        setWoolBaleSuccess(`Baling finished for this session.${vrzNote}`);
      } catch (err: any) {
        setWoolBaleError(err?.message || 'Failed to finish baling.');
      } finally {
        setFinishingBaling(false);
      }
    };

    const openPrintSheet = async () => {
      if (!woolBalesSessionId) return;
      setLoadingBalePrint(true);
      setWoolBaleError('');
      try {
        const sheet = await fetchBalePrintSheet(woolBalesSessionId);
        setBalePrintSheet(sheet);
      } catch (err: any) {
        setWoolBaleError(err?.message || 'Failed to load print sheet.');
      } finally {
        setLoadingBalePrint(false);
      }
    };

    const selectedSession = woolSessionsForDeal.find((s) => s.id === woolBalesSessionId);
    const balingStatus = selectedSession?.baling_status;

    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5 flex flex-col gap-4">
        <div className="admin-section-head flex items-center justify-between gap-2">
          <h2 className="text-2xl font-semibold text-avcs-text">Wool bales</h2>
          {editingWoolBaleId && <button className="admin-inline-action btn" type="button" onClick={resetBaleForm}>Cancel edit</button>}
        </div>

        {woolBaleError && <div className="rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{woolBaleError}</div>}
        {woolBaleSuccess && <div className="rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{woolBaleSuccess}</div>}

        {/* Step 1 – pick an un-baled shearing session (its deal is derived from the session → EID → deal) */}
        <div className="grid gap-3 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3">
          <label className="grid gap-1 text-sm text-avcs-text">
            Shearing session
            <select
              className="rounded-lg border border-[#1e6bb833] px-3 py-2 bg-white"
              value={woolBalesSessionId}
              onChange={async (e) => {
                const id = e.target.value;
                setWoolBalesSessionId(id);
                resetBaleForm();
                await loadBalesForSession(id);
              }}
            >
              <option value="">— Select shearing session —</option>
              {woolSessionsForDeal.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.session_reference}{s.deal_no ? ` — Deal ${s.deal_no}` : ''}{s.start_date ? ` (${s.start_date})` : ''}
                </option>
              ))}
            </select>
            {woolSessionsForDeal.length === 0 && (
              <span className="text-xs text-avcs-muted">No un-baled shearing sessions. Upload a shear (Farm or Feedlot) to create one.</span>
            )}
          </label>
        </div>

        {/* Bale form */}
        {woolBalesSessionId && balingStatus !== 'BALED' && (
          <form className="grid gap-3 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3 md:grid-cols-3" onSubmit={submitBale}>
            <div className="md:col-span-3 text-sm font-semibold text-avcs-text">
              {editingWoolBaleId ? 'Edit bale' : 'Add bale'}{selectedSession ? ` — ${selectedSession.session_reference}` : ''}
              <span className="ml-2 font-normal text-avcs-muted">Bale batch number is assigned automatically.</span>
            </div>
            <label className="grid gap-1 text-sm text-avcs-text">
              Gross weight (kg)
              <input type="number" step="0.01" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={woolBaleForm.baleWeight} onChange={(e) => setWoolBaleForm((f) => ({ ...f, baleWeight: e.target.value }))} placeholder="e.g. 112" />
            </label>
            <label className="grid gap-1 text-sm text-avcs-text">
              Tare — bag + clips (kg)
              <input type="number" step="0.01" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={woolBaleForm.tareWeight} onChange={(e) => setWoolBaleForm((f) => ({ ...f, tareWeight: e.target.value }))} />
            </label>
            <label className="grid gap-1 text-sm text-avcs-text">
              Net weight (kg)
              <input type="number" step="0.01" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={woolBaleForm.cleanedWeight} onChange={(e) => setWoolBaleForm((f) => ({ ...f, cleanedWeight: e.target.value }))} placeholder={woolBaleForm.baleWeight && woolBaleForm.tareWeight ? `auto: ${(Number(woolBaleForm.baleWeight) - Number(woolBaleForm.tareWeight)).toFixed(2)}` : 'gross − tare'} />
            </label>
            <label className="grid gap-1 text-sm text-avcs-text">
              Wool class
              <select className="rounded-lg border border-[#1e6bb833] px-3 py-2 bg-white" value={woolBaleForm.woolClassId} onChange={(e) => setWoolBaleForm((f) => ({ ...f, woolClassId: e.target.value }))}>
                <option value="">— None —</option>
                {woolClasses.map((wc) => <option key={wc.id} value={wc.id}>{wc.code} — {wc.name}</option>)}
              </select>
            </label>
            <label className="grid gap-1 text-sm text-avcs-text">
              Breed
              <select className="rounded-lg border border-[#1e6bb833] px-3 py-2 bg-white" value={woolBaleForm.woolBreedId} onChange={(e) => setWoolBaleForm((f) => ({ ...f, woolBreedId: e.target.value }))}>
                <option value="">— Select breed —</option>
                {breeds.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
              </select>
            </label>
            <label className="grid gap-1 text-sm text-avcs-text">
              Notes
              <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={woolBaleForm.notes} onChange={(e) => setWoolBaleForm((f) => ({ ...f, notes: e.target.value }))} />
            </label>
            <div className="md:col-span-3 flex gap-2">
              <button className="btn admin-submit-action" type="submit" disabled={savingWoolBale}>{savingWoolBale ? 'Saving…' : editingWoolBaleId ? 'Save bale' : 'Add bale'}</button>
              {editingWoolBaleId && <button className="btn" type="button" onClick={resetBaleForm}>Cancel edit</button>}
            </div>
          </form>
        )}

        {/* Bales table + baling actions */}
        {woolBalesSessionId && (
          <div className="flex flex-col gap-3">
            {balingStatus && (
              <div className="flex flex-wrap items-center gap-2 text-sm">
                <span className="text-avcs-muted">Baling status:</span>
                <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${balingStatus === 'BALED' ? 'bg-[#e7f8ee] text-[#106b38]' : balingStatus === 'IN_PROGRESS' ? 'bg-[#fdf3e0] text-[#8a5a00]' : 'bg-[#eef2f6] text-[#4a5b6b]'}`}>
                  {balingStatus === 'BALED' ? 'Baled' : balingStatus === 'IN_PROGRESS' ? 'Baling in progress' : 'Not yet baled'}
                </span>
              </div>
            )}
            <div className="admin-table-scroll">
              {loadingWoolBales ? (
                <p className="text-sm text-avcs-muted">Loading bales…</p>
              ) : (
                <table className="min-w-full text-sm">
                  <thead className="border-b border-[#1e6bb824] bg-[#f8fbff]">
                    <tr>
                      <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Bale batch no</th>
                      <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Gross (kg)</th>
                      <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Net (kg)</th>
                      <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Class</th>
                      <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Breed</th>
                      <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Notes</th>
                      {balingStatus !== 'BALED' && <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#1e6bb812]">
                    {woolBalesForSession.length === 0 && (
                      <tr><td colSpan={7} className="px-4 py-4 text-center text-avcs-muted">No bales for this session yet.</td></tr>
                    )}
                    {woolBalesForSession.map((bale) => (
                      <tr key={bale.id} className={`bg-white hover:bg-[#f8fbff]${editingWoolBaleId === bale.id ? ' ring-1 ring-amber-300' : ''}`}>
                        <td className="px-4 py-2 font-medium text-avcs-text">{bale.bale_number}</td>
                        <td className="px-4 py-2 text-avcs-text">{bale.gross_weight != null ? bale.gross_weight : '—'}</td>
                        <td className="px-4 py-2 text-avcs-text">{bale.net_weight != null ? bale.net_weight : '—'}</td>
                        <td className="px-4 py-2 text-avcs-text">{bale.wool_class_code ? `${bale.wool_class_code}${bale.wool_class_name ? ` — ${bale.wool_class_name}` : ''}` : '—'}</td>
                        <td className="px-4 py-2 text-avcs-text">{bale.wool_breed_name || '—'}</td>
                        <td className="px-4 py-2 text-avcs-muted">{bale.notes || '—'}</td>
                        {balingStatus !== 'BALED' && (
                          <td className="px-4 py-2">
                            <div className="flex gap-2">
                              <button className="btn" type="button" onClick={() => startEditBale(bale)}>Edit</button>
                              <button className={DELETE_BTN} type="button" onClick={async () => { if (await requestConfirm({ message: 'Delete this bale? This cannot be undone.', confirmLabel: 'Delete', tone: 'danger' })) removeBale(bale.id); }}>Delete</button>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            <div className="flex flex-wrap gap-2">
              {balingStatus !== 'BALED' && (
                <button className="btn admin-submit-action" type="button" onClick={finishBalingSession} disabled={finishingBaling || woolBalesForSession.length === 0}>
                  {finishingBaling ? 'Finishing…' : 'Finish baling'}
                </button>
              )}
              <button className="btn" type="button" onClick={openPrintSheet} disabled={loadingBalePrint || woolBalesForSession.length === 0}>
                {loadingBalePrint ? 'Preparing…' : 'Print sheet'}
              </button>
            </div>
          </div>
        )}

        {balePrintSheet && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 60, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflow: 'auto', padding: '24px' }}>
            <div style={{ background: '#fff', borderRadius: '12px', maxWidth: '820px', width: '100%', padding: '20px' }}>
              <div className="flex items-center justify-between gap-2" style={{ marginBottom: '12px' }}>
                <h3 className="text-lg font-semibold text-avcs-text">Bale sheet preview</h3>
                <div className="flex gap-2">
                  <button className="btn admin-submit-action" type="button" onClick={() => printBaleSheetHtml(balePrintSheet)}>Print</button>
                  <button className="btn" type="button" onClick={() => setBalePrintSheet(null)}>Close</button>
                </div>
              </div>
              <div style={{ border: '1px solid #e4e9ef', borderRadius: '8px', overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: buildBaleSheetHtml(balePrintSheet) }} />
            </div>
          </div>
        )}
      </section>
    );
  };

  const renderDataSessionUpload = () => {
    const LOCATION_OPTIONS = [
      { value: 'FARM', label: 'Farm' },
      { value: 'FEED', label: 'Feedlot' },
      { value: 'ABAT', label: 'Abattoir' },
      { value: 'OTHER', label: 'Other' },
    ];

    const EVENT_TYPE_BY_LOCATION: Record<string, { value: string; label: string }[]> = {
      FARM: [
        { value: 'FARM_REG', label: 'Registration' },
        { value: 'FARM_REC', label: 'Receive' },
        { value: 'FARM_BIR', label: 'Birth' },
        { value: 'FARM_DIS', label: 'Dispatch' },
        { value: 'FARM_MOR', label: 'Mortality' },
        { value: 'FARM_WEI', label: 'Current Weight' },
        { value: 'FARM_SHE', label: 'Shear' },
        // Baling is captured via the guided Wool baling flow, not the CSV upload.
      ],
      FEED: [
        { value: 'FEED_REG', label: 'Registration' },
        { value: 'FEED_REC', label: 'Receive' },
        { value: 'FEED_DIS', label: 'Dispatch' },
        { value: 'FEED_MOR', label: 'Mortality' },
        { value: 'FEED_WEI', label: 'Current Weight' },
        { value: 'FEED_SHE', label: 'Shear' },
        { value: 'FEED_WOO', label: 'Wool Batch' },
        // Baling is captured via the guided Wool baling flow, not the CSV upload.
      ],
      ABAT: [
        { value: 'ABAT_REG', label: 'Registration' },
        { value: 'ABAT_REC', label: 'Receive' },
        { value: 'ABAT_DIS', label: 'Dispatch' },
        { value: 'ABAT_MOR', label: 'Mortality' },
        { value: 'ABAT_SLA', label: 'Slaughter' },
      ],
      OTHER: [
        { value: 'VACCINATION', label: 'Vaccination' },
        { value: 'WOOL_ANA', label: 'Wool Analysis' },
      ],
    };

    const ALL_EVENT_TYPES = LOCATION_OPTIONS.flatMap((location) =>
      (EVENT_TYPE_BY_LOCATION[location.value] ?? []).map((eventType) => ({
        ...eventType,
        locationValue: location.value,
        locationLabel: location.label,
      }))
    );
    const isDealRequired = DATA_SESSION_DEAL_REQUIRED_EVENT_TYPES.includes(dataSessionForm.eventType);
    const isVaccinationEvent = VACCINATION_EVENT_TYPES.includes(dataSessionForm.eventType);
    // Per-row ("long"/health-log) vaccination file: one medicine per animal
    // per row (a single "Vaccine / Medicine" column) rather than a column-group
    // per medicine. The backend ingests each row directly, so the manual
    // "apply these medicines to all animals" step is skipped for this shape.
    const isPerRowVaccination = isVaccinationEvent && draftPreview?.vaccination_layout === 'per_row';
    const vaccinationMedicines: string[] = Array.isArray(draftPreview?.vaccination_medicines)
      ? draftPreview.vaccination_medicines
      : [];
    // Category-driven form controls.
    const selectedCategory = dataSessionForm.category;
    const selectedCategoryMeta = EVENT_CATEGORY_META[selectedCategory] || null;
    const isMovementCategory = !!selectedCategoryMeta?.isMovement;
    const needsSpecies = !!selectedCategoryMeta?.needsSpecies;
    const isReceiveCategory = selectedCategory === 'RECEIVE';
    // Governing entity for the derived event type (source for dispatch, else destination).
    const governingUnitForType = selectedCategory === 'DISPATCH' ? sourceSelectedUnit : destSelectedUnit;
    const derivedTypeError = selectedCategory
      ? resolveEventTypeCode(selectedCategory, governingUnitForType?.entityType).error
      : '';
    // Step 1 of accepting a dispatch: fetch a dry-run preview of what would be
    // received (no file, no event created yet), populate the source, and open
    // the confirm step. The actual receive happens in confirmDispatchReceive.
    // `only` receives a single deal out of the consignment -- part of the load
    // arrived, or one deal is being handled separately.
    const openDispatchPreview = async (match: ExpectedReceiptMatch, only?: { dispatch_event_id: string; deal_no: string | null }) => {
      const rootId = only?.dispatch_event_id || match.dispatch_event_id;
      setLoadingDispatchPreviewId(rootId);
      setDataSessionError('');
      setDispatchAcceptResult(null);
      try {
        const ids = only
          ? [only.dispatch_event_id]
          : (match.deals && match.deals.length ? match.deals.map((d) => d.dispatch_event_id) : [match.dispatch_event_id]);
        const preview = await previewReceiveFromDispatch(rootId, {
          destinationEntityId: dataSessionForm.destEntityId || undefined,
          sample: 25,
          dispatchEventIds: ids,
        });
        // Populate the source from the dispatch so the form reflects the receive.
        if (preview.source_entity_id) {
          setDataSessionForm((f) => ({ ...f, sourceEntityId: preview.source_entity_id as string, species: preview.species || f.species }));
          const unit = entityDirectory.find((e) => e.id === preview.source_entity_id);
          if (unit) { setSourceSelectedUnit(unit); setSourceEntitySearch(''); }
        }
        setDispatchReceivePreview(preview);
        setDispatchPreviewMatch(only ? { ...match, deals: (match.deals || []).filter((d) => d.dispatch_event_id === only.dispatch_event_id) } : match);
      } catch (err: any) {
        setDataSessionError(err?.message || 'Could not load the dispatch preview.');
      } finally {
        setLoadingDispatchPreviewId(null);
      }
    };
    const cancelDispatchPreview = () => {
      setDispatchReceivePreview(null);
      setDispatchPreviewMatch(null);
      setDataSessionError('');
    };
    // Step 2: confirm and create the receive event(s) for the whole dispatch.
    const confirmDispatchReceive = async () => {
      const match = dispatchPreviewMatch;
      if (!match) return;
      setConfirmingDispatchReceive(true);
      setDataSessionError('');
      try {
        const consignmentIds = match.deals && match.deals.length
          ? match.deals.map((d) => d.dispatch_event_id)
          : [match.dispatch_event_id];
        const result = await receiveFromDispatch({
          dispatchEventId: consignmentIds[0],
          dispatchEventIds: consignmentIds,
          destinationEntityId: dataSessionForm.destEntityId || undefined,
        });
        setDispatchAcceptResult(result);
        setDataSessionSuccess(
          `Received ${result.received_count} of ${result.dispatched_count} animals${
            (result.deals_count ?? 0) > 1 ? ` across ${result.deals_count} deals` : ''
          }${result.unreceived.length ? ` — ${result.unreceived.length} not received` : ''}.`,
        );
        // A partial accept (one deal of a consignment) leaves the rest of the
        // load expected, so the card is trimmed rather than removed.
        const acceptedIds = new Set(
          (match.deals && match.deals.length ? match.deals : [{ dispatch_event_id: match.dispatch_event_id }])
            .map((d) => d.dispatch_event_id),
        );
        setExpectedDispatches((prev) => prev.flatMap((row) => {
          const rowDeals = row.deals && row.deals.length ? row.deals : null;
          if (!rowDeals) return acceptedIds.has(row.dispatch_event_id) ? [] : [row];
          const left = rowDeals.filter((d) => !acceptedIds.has(d.dispatch_event_id));
          if (left.length === rowDeals.length) return [row];
          if (left.length === 0) return [];
          return [{
            ...row,
            deals: left,
            deal_ids: left.map((d) => d.deal_id).filter(Boolean) as string[],
            deal_nos: left.map((d) => d.deal_no).filter(Boolean) as string[],
            deal_count: left.length,
            animal_count: left.reduce((sum, d) => sum + (d.animal_count || 0), 0),
            dispatch_event_id: left[0].dispatch_event_id,
          }];
        }));
        // The dispatch can span several deals — bust tracking cache for all of them.
        const affectedDealIds = match.deal_ids && match.deal_ids.length ? match.deal_ids : (match.deal_id ? [match.deal_id] : []);
        affectedDealIds.forEach((id) => { delete trackingCacheRef.current[id]; });
        setUploadCompletedCount((c) => c + 1);
        setDispatchReceivePreview(null);
        setDispatchPreviewMatch(null);
      } catch (err: any) {
        setDataSessionError(err?.message || 'Could not accept the dispatch.');
      } finally {
        setConfirmingDispatchReceive(false);
      }
    };
    const vaccinationFoundCount = vaccinationEntries.filter((row) => row.medicineName.trim()).length;
    const selectedUploadDeal = deals.find((d) => d.dealId === dataSessionDealId) || null;

    // --- Create-event confirmation summary values ---
    // Human label for the chosen event type.
    const confirmEventTypeLabel =
      ALL_EVENT_TYPES.find((opt) => opt.value === dataSessionForm.eventType)?.label
      || EVENT_TYPE_LABELS[dataSessionForm.eventType]
      || dataSessionForm.eventType
      || '—';
    // Look up an entity's GLN from the loaded GS1 codes (loaded lazily when the
    // confirm step opens). Returns '' when unknown / not yet loaded.
    const glnForEntity = (entityId: string) => {
      if (!entityId) return '';
      const code = gs1Codes.find(
        (c) => c.gs1Type === 'GLN' && String(c.entityId) === String(entityId),
      );
      return code?.gs1Code || '';
    };
    const confirmSourceName = sourceSelectedUnit?.entityName || '—';
    const confirmSourceGln = glnForEntity(dataSessionForm.sourceEntityId);
    const confirmSourceType = sourceSelectedUnit?.entityType || '';
    const confirmDestName = destSelectedUnit?.entityName || '—';
    const confirmDestGln = glnForEntity(dataSessionForm.destEntityId);
    const confirmDestType = destSelectedUnit?.entityType || '';
    // Entity type shown alongside the event type. It must follow the event's
    // GOVERNING entity — source for a dispatch, destination otherwise — mirroring
    // resolveEventTypeCode. Preferring the destination outright mislabels a
    // feedlot→abattoir dispatch (FEED_DIS) as "Dispatch ABATTOIR".
    const confirmPrimaryEntityType = governingUnitForType?.entityType || confirmDestType || confirmSourceType || '';
    const confirmFileName = dataSessionForm.file?.name || draftPreview?.original_filename || '—';
    // Number of animals in this event = rows in the uploaded file.
    const confirmAnimalCount = draftPreview?.row_count ?? draftPreview?.preview_rows?.length ?? 0;
    // Friendly species label (the species submitted with the draft, see the
    // draft FormData) — shown on the confirm headline.
    const confirmSpeciesLabel = dataSessionForm.species
      ? dataSessionForm.species.charAt(0) + dataSessionForm.species.slice(1).toLowerCase()
      : '';
    // Open the review step; make sure GLNs are available to display.
    const openCreateEventConfirm = () => {
      if (!hasLoadedGs1CodesRef.current) loadGs1Codes();
      setShowCreateEventConfirm(true);
    };
    const formatUploadDeal = (deal: Deal) => {
      const dealNo = deal.title || deal.dealRefNo || deal.dealId;
      const parts = [dealNo, deal.counterpart].filter((part) => part && part !== '—');
      const label = parts.join(' ');
      return deal.startDate ? `${label} · ${fmtDate(deal.startDate)}` : label;
    };
    const filteredDealOptions = (() => {
      const query = dataSessionDealSearch.trim().toLowerCase();
      const activeDeals = deals.filter((deal) => deal.status === 'Active');
      const source = query
        ? activeDeals.filter((deal) => formatUploadDeal(deal).toLowerCase().includes(query))
        : activeDeals;
      return source.slice(0, 5);
    })();

    const resetForm = () => {
      setDataSessionLocationFilter('');
      setDataSessionDealId('');
      setDataSessionForm({ sessionId: '', category: '', eventType: '', delimiter: ',', species: 'SHEEP', sourceEntityId: '', destEntityId: '', file: null });
      setDataSessionDealSearch('');
      setShowDataSessionDealDropdown(false);
      setSourceEntitySearch('');
      setDestEntitySearch('');
      setShowSourceDropdown(false);
      setShowDestDropdown(false);
      setDataSessionError('');
      setDataSessionSuccess('');
      setDataSessionResult(null);
      setRelinkResult(null);
      setUploadAuditEvents([]);
      setDataSessionFileKey((k) => k + 1);
      setUnprocessedAdminRows([]);
      setSourceSelectedUnit(null);
      setDestSelectedUnit(null);
      setSourceProductionUnits([]);
      setDestProductionUnits([]);
      setDraftSessionId(null);
      setDuplicateUpload(null);
      setDraftPreview(null);
      setDraftConfirmResult(null);
      setVaccinationStepOpen(false);
      setExpectedDispatches([]);
      setDispatchAcceptResult(null);
      setDispatchReceivePreview(null);
      setDispatchPreviewMatch(null);
    };

    const loadUnprocessed = async (dealId: string) => {
      if (!dealId) return;
      setLoadingUnprocessedAdmin(true);
      try {
        const rows = await fetchUnprocessedRecords(dealId);
        setUnprocessedAdminRows(rows);
      } catch {
        setUnprocessedAdminRows([]);
      } finally {
        setLoadingUnprocessedAdmin(false);
      }
    };

    const submitForm = async (e: React.FormEvent) => {
      e.preventDefault();
      const { sessionId, eventType, delimiter, species, sourceEntityId, destEntityId, file } = dataSessionForm;
      if (!file) {
        setDataSessionError('Please attach a CSV file before uploading.');
        return;
      }
      const dealIdForUpload = dataSessionDealId; // sent whenever one is picked; enforced only where the backend needs it
      // Non-movement events happen at a single entity (the destination); the
      // source is recorded as the same entity.
      const effectiveSourceId = isMovementCategory ? sourceEntityId : destEntityId;
      if ((isDealRequired && !dealIdForUpload) || !eventType || !destEntityId || (isMovementCategory && !sourceEntityId)) {
        setDataSessionError(
          isDealRequired && !dealIdForUpload
            ? 'A deal is required for registration, receive and slaughter events.'
            : !eventType
              ? 'Select an event and an entity so the event type can be determined.'
              : 'All required fields must be filled.',
        );
        return;
      }
      setSavingDataSession(true);
      setDataSessionError('');
      setDataSessionSuccess('');
      setDataSessionResult(null);
      setRelinkResult(null);
      try {
        const fd = new FormData();
        fd.append('file', file);
        fd.append('session_id', sessionId || file.name);
        if (dealIdForUpload) fd.append('deal_id', dealIdForUpload);
        fd.append('species', species);
        fd.append('event_type', eventType);
        fd.append('source_entity_id', effectiveSourceId);
        fd.append('destination_entity_id', destEntityId);
        // Prefer the delimiter detected by client-side CSV parsing over the form dropdown —
        // if the user didn't manually change it the dropdown may still show the default.
        const effectiveDelimiter = fileValidation?.detectedDelimiter || delimiter;
        fd.append('delimiter', effectiveDelimiter);
        const result = await createDataSession(fd);
        setDataSessionResult(result);
        setDataSessionSuccess(`Upload successful — ${result.row_count ?? 0} rows processed.`);
        // Clear the form inputs so it's ready for the next upload
        setDataSessionLocationFilter('');
        setDataSessionDealId('');
        setDataSessionForm({ sessionId: '', category: '', eventType: '', delimiter: ',', species: 'SHEEP', sourceEntityId: '', destEntityId: '', file: null });
        setDataSessionDealSearch('');
        setShowDataSessionDealDropdown(false);
        setSourceEntitySearch('');
        setDestEntitySearch('');
        setSourceSelectedUnit(null);
        setDestSelectedUnit(null);
        setSourceProductionUnits([]);
        setDestProductionUnits([]);
        setDataSessionFileKey((k) => k + 1);
        // Bust tracking cache so deal summary stats (mortality, alive, etc.) refresh
        if (dealIdForUpload) {
          delete trackingCacheRef.current[dealIdForUpload];
          await loadUnprocessed(dealIdForUpload);
          const events = await fetchDealEvents(dealIdForUpload).catch(() => []);
          setUploadAuditEvents(events);
        }
        setUploadCompletedCount((c) => c + 1);
      } catch (err: any) {
        setDataSessionError(err?.message || 'Upload failed.');
      } finally {
        setSavingDataSession(false);
      }
    };

    const submitDraft = async (e: React.FormEvent) => {
      e.preventDefault();
      const { sessionId, eventType, delimiter, species, sourceEntityId, destEntityId, file } = dataSessionForm;
      if (!file) {
        setDataSessionError('Please attach a CSV file before uploading.');
        return;
      }
      const dealIdForUpload = dataSessionDealId; // sent whenever one is picked; enforced only where the backend needs it
      const effectiveSourceId = isMovementCategory ? sourceEntityId : destEntityId;
      if ((isDealRequired && !dealIdForUpload) || !eventType || !destEntityId || (isMovementCategory && !sourceEntityId)) {
        setDataSessionError(
          isDealRequired && !dealIdForUpload
            ? 'A deal is required for registration, receive and slaughter events.'
            : !eventType
              ? 'Select an event and an entity so the event type can be determined.'
              : 'All required fields must be filled for the draft upload.',
        );
        return;
      }
      setSavingDataSession(true);
      setDataSessionError('');
      setDataSessionSuccess('');
      setDraftPreview(null);
      setDraftSessionId(null);
      setDuplicateUpload(null);
      setDraftConfirmResult(null);
      setVaccinationEntries([]);
      setVaccinationStepOpen(false);
      try {
        const fd = new FormData();
        fd.append('file', file);
        fd.append('session_id', sessionId || file.name);
        if (dealIdForUpload) fd.append('deal_id', dealIdForUpload);
        fd.append('species', species);
        fd.append('event_type', eventType);
        fd.append('source_entity_id', effectiveSourceId);
        fd.append('destination_entity_id', destEntityId);
        const effectiveDelimiter = fileValidation?.detectedDelimiter || delimiter;
        fd.append('delimiter', effectiveDelimiter);
        const draftResult = await createDraftDataSession(fd);
        setDraftSessionId(draftResult.id);
        setDuplicateUpload(draftResult.duplicate_of || null);
        setApplyAsDelta(false);
        setUserMappings({});
        // Immediately fetch preview and field mapping meta in parallel
        setLoadingDraftPreview(true);
        const [preview, meta] = await Promise.all([
          previewDraftDataSession(draftResult.id),
          fetchFieldMappingsMeta().catch(() => null),
        ]);
        setDraftPreview(preview);
        setDraftPreviewSummary(preview?.preview_summary ?? null);
        setFieldMappingsMeta(meta);
        if (VACCINATION_EVENT_TYPES.includes(eventType)) {
          if (preview?.vaccination_layout === 'per_row') {
            // Per-row (health-log) files carry one medicine per animal per row
            // and are ingested directly. Do NOT seed the manual entries — the
            // "apply to all animals" step is a wide-format concept and would
            // spray every medicine across every animal.
            setVaccinationEntries([]);
          } else {
            const seeded = aggregateVaccinationEntriesFromPreview(preview?.preview_rows ?? []);
            setVaccinationEntries(seeded.length > 0 ? seeded : [blankVaccinationEntryRow()]);
          }
        }
      } catch (err: any) {
        let message = err?.message || 'Draft upload failed.';
        try {
          const parsed = JSON.parse(message);
          if (Array.isArray(parsed?.missing) && parsed.missing.includes('deal_id')) {
            message = 'Preview could not be created because the backend draft endpoint currently requires a deal ID. The frontend only asks for a deal on registration events.';
          } else if (parsed?.detail) {
            message = parsed.detail;
          }
        } catch {
          // Keep the original API message when it is not JSON.
        }
        setDataSessionError(message);
      } finally {
        setSavingDataSession(false);
        setLoadingDraftPreview(false);
      }
    };

    const doConfirmDraft = async () => {
      if (!draftSessionId) return;
      setConfirmingDraft(true);
      setDataSessionError('');
      try {
        // Save any user-defined column → field mappings before processing
        const newMappingEntries = Object.entries(userMappings).filter(([, v]) => v);
        if (newMappingEntries.length > 0) {
          const results = await Promise.all(
            newMappingEntries.map(([source_field, target_field]) =>
              createFieldMapping({ event_type: dataSessionForm.eventType, source_field, target_field }).catch((e: any) => ({ error: e?.message || 'failed' }))
            )
          );
          const failed = results.filter((r: any) => r?.error);
          if (failed.length > 0) {
            setDataSessionError(`Failed to save ${failed.length} field mapping(s). Please try again.`);
            setConfirmingDraft(false);
            return;
          }
        }
        const previewEidCount = draftPreview?.preview_summary?.rows_with_eid;
        const entriesPayload: VaccinationEntryInput[] = VACCINATION_EVENT_TYPES.includes(dataSessionForm.eventType)
          ? vaccinationEntries
              .filter((row) => row.medicineName.trim())
              .map((row) => ({
                medicine_name: row.medicineName.trim(),
                is_antibiotic: Boolean(row.isAntibiotic),
                dosage: row.dosage.trim() || undefined,
                batch_number: row.batchNumber.trim() || undefined,
                cost: row.cost.trim() || undefined,
                batch_expiry_date: row.batchExpiryDate.trim() || undefined,
                withholding_end_date: row.withholdingEndDate.trim() || undefined,
                esi_date: row.esiDate.trim() || undefined,
              }))
          : [];
        const result = await confirmDraftDataSession(draftSessionId, entriesPayload, {
          attachAsRevision: applyAsDelta,
        });
        // If the backend returns 0/null for rows_with_eid, use the count from the preview dry-run
        if (!result.rows_with_eid && previewEidCount) {
          result.rows_with_eid = previewEidCount;
        }
        const confirmedDealId = dataSessionDealId;
        if (VACCINATION_EVENT_TYPES.includes(dataSessionForm.eventType) && draftSessionId) {
          const perRowNames: string[] = Array.from(new Set(
            ((draftPreview?.preview_rows ?? []) as any[]).flatMap((row: any) => (row?.vaccinations ?? []).map((v: any) => String(v?.medicine_name || '').trim())).filter(Boolean),
          ));
          const names = entriesPayload.length > 0 ? entriesPayload.map((e) => e.medicine_name) : perRowNames;
          setTreatmentInvoiceStep({
            sessionId: draftSessionId,
            animals: Number(result?.rows_linked ?? result?.linking_summary?.linked_rows ?? previewEidCount ?? 0),
            medicines: names,
          });
        }
        setDraftConfirmResult(result);
        setDataSessionSuccess(
          result?.revision?.attached_as_revision
            ? `Draft confirmed — ${result.row_count ?? 0} rows processed and applied to the existing event (revision ${result.revision.revision_number}).`
            : `Draft confirmed — ${result.row_count ?? 0} rows processed.`,
        );
        setDraftPreview(null);
        setDraftSessionId(null);
        setDuplicateUpload(null);
        setApplyAsDelta(false);
        setShowCreateEventConfirm(false);
        setVaccinationEntries([]);
        setVaccinationStepOpen(false);
        // Clear the form inputs ready for next upload (preserve draftConfirmResult for display)
        setDataSessionForm({ sessionId: '', category: '', eventType: '', delimiter: ',', species: 'SHEEP', sourceEntityId: '', destEntityId: '', file: null });
        setDataSessionLocationFilter('');
        setDataSessionDealId('');
        setDataSessionDealSearch('');
        setShowDataSessionDealDropdown(false);
        setSourceEntitySearch('');
        setDestEntitySearch('');
        setSourceSelectedUnit(null);
        setDestSelectedUnit(null);
        setSourceProductionUnits([]);
        setDestProductionUnits([]);
        setDataSessionFileKey((k) => k + 1);
        if (confirmedDealId) {
          delete trackingCacheRef.current[confirmedDealId];
          await loadUnprocessed(confirmedDealId);
          const events = await fetchDealEvents(confirmedDealId).catch(() => []);
          setUploadAuditEvents(events);
        }
        setUploadCompletedCount((c) => c + 1);
      } catch (err: any) {
        setDataSessionError(err?.message || 'Confirm failed.');
      } finally {
        setConfirmingDraft(false);
      }
    };

    const searchProductionUnits = (
      text: string,
      setResults: (r: any[]) => void,
      _setSearching: (v: boolean) => void,
    ) => {
      if (!text.trim()) { setResults([]); return; }
      const q = text.toLowerCase();
      const matches = entityDirectory
        .filter((e) => e.entityName?.toLowerCase().includes(q))
        .slice(0, 20);
      setResults(matches);
    };

    // EntityCombobox is defined at module level to prevent focus-loss on re-render.

    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5 flex flex-col gap-4 min-w-0">
        <div className="admin-section-head flex items-center justify-between gap-2">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">New Event</h2>
          </div>
          <div className="flex items-center gap-2">
            <button className="admin-inline-action btn" type="button" onClick={resetForm}>Reset</button>
          </div>
        </div>

        {/* One outcome panel, at the top, dismissable. "Draft confirmed" and
            "Upload complete" used to be two green boxes at opposite ends of
            the screen saying the same thing; the × resets the screen the way
            the Reset button does. */}
        {/* Invoice & cost — the step a confirmed vaccination upload still owes.
            One number off the invoice (cost per animal) is spread over the
            medicines given, written per animal, summed per administration and
            booked to the deal's ledger; the PDF is filed against the deal. */}
        {treatmentInvoiceStep && (
          <div className="rounded-xl border border-[#c8e6d4a0] bg-[#f7fdf9] p-4 min-w-0">
            <p className="text-lg font-semibold text-[#1a5c38]">
              Invoice &amp; cost — {treatmentInvoiceStep.medicines.length} medicine{treatmentInvoiceStep.medicines.length === 1 ? '' : 's'} applied to {fmtNum(treatmentInvoiceStep.animals)} animal{treatmentInvoiceStep.animals === 1 ? '' : 's'}
            </p>
            <p className="mt-1 text-xs text-avcs-muted">
              {treatmentInvoiceStep.medicines.join(' · ') || 'Medicines as recorded on the file'}. The cost per animal is split evenly across
              the medicines, recorded on every animal's treatment, and booked to the deal as a veterinary cost. Skip if the invoice
              is not in yet — the events are already saved.
            </p>
            {treatmentInvoiceError && <div className="mt-2 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{treatmentInvoiceError}</div>}
            <div className="mt-3 grid gap-3 md:grid-cols-3">
              <label className="grid gap-1 text-sm text-avcs-text">
                Cost per animal (R, ex VAT) *
                <input
                  type="number" min={0} step="0.01"
                  className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                  value={treatmentInvoiceForm.costPerAnimal}
                  onChange={(e) => setTreatmentInvoiceForm((prev) => ({ ...prev, costPerAnimal: e.target.value }))}
                />
                {treatmentInvoiceForm.costPerAnimal && Number(treatmentInvoiceForm.costPerAnimal) >= 0 && (
                  <span className="text-xs text-avcs-muted">
                    Deal cost: R {(Number(treatmentInvoiceForm.costPerAnimal) * treatmentInvoiceStep.animals).toFixed(2)}
                  </span>
                )}
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Invoice number
                <input className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={treatmentInvoiceForm.referenceNumber} onChange={(e) => setTreatmentInvoiceForm((prev) => ({ ...prev, referenceNumber: e.target.value }))} />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Invoice date
                <input type="date" className="rounded-lg border border-[#1e6bb833] px-3 py-2" value={treatmentInvoiceForm.invoiceDate} onChange={(e) => setTreatmentInvoiceForm((prev) => ({ ...prev, invoiceDate: e.target.value }))} />
              </label>
              <div className="grid gap-1 text-sm text-avcs-text md:col-span-3">
                Invoice (PDF) <span className="text-avcs-muted">(optional — filed against the deal)</span>
                <FileDropzone file={treatmentInvoiceForm.file} onFileChange={(file: File | null) => setTreatmentInvoiceForm((prev) => ({ ...prev, file }))} acceptedExtensions={['pdf', 'jpg', 'jpeg', 'png']} />
              </div>
            </div>
            <div className="mt-3 flex flex-wrap items-center gap-2">
              <button
                type="button"
                className="btn primary"
                disabled={savingTreatmentInvoice || treatmentInvoiceForm.costPerAnimal === '' || Number(treatmentInvoiceForm.costPerAnimal) < 0}
                onClick={async () => {
                  if (!treatmentInvoiceStep) return;
                  setSavingTreatmentInvoice(true);
                  setTreatmentInvoiceError('');
                  try {
                    const result = await submitTreatmentInvoice(treatmentInvoiceStep.sessionId, {
                      costPerAnimal: treatmentInvoiceForm.costPerAnimal,
                      referenceNumber: treatmentInvoiceForm.referenceNumber.trim() || undefined,
                      invoiceDate: treatmentInvoiceForm.invoiceDate || undefined,
                      file: treatmentInvoiceForm.file,
                    });
                    if (result.deal_id) delete trackingCacheRef.current[result.deal_id];
                    finishTreatmentInvoiceStep(
                      `Medicines captured for ${fmtNum(result.animals)} animals — R ${result.total} booked to the deal as a veterinary cost`
                      + (result.document_id ? ', invoice filed.' : result.document_skipped ? '. The invoice was not filed: seed the INVOICE document type first.' : '.'),
                    );
                  } catch (err: any) {
                    setTreatmentInvoiceError(parseApiError(err?.message) || err?.message || 'Could not save the cost.');
                  } finally {
                    setSavingTreatmentInvoice(false);
                  }
                }}
              >
                {savingTreatmentInvoice ? 'Saving…' : 'Save cost & invoice'}
              </button>
              <button type="button" className="btn" disabled={savingTreatmentInvoice} onClick={() => finishTreatmentInvoiceStep(dataSessionSuccess || 'Medicines captured. No cost recorded yet.')}>
                Skip for now
              </button>
            </div>
          </div>
        )}

        {(dataSessionError || dataSessionSuccess || draftConfirmResult || dataSessionResult) && (
          <div className="relative grid gap-2">
            <button
              type="button"
              className="absolute right-2 top-2 z-10 inline-flex h-7 w-7 items-center justify-center rounded-full border border-[#1e6bb824] bg-white text-base leading-none text-avcs-muted hover:bg-[#f1f7ff] hover:text-avcs-text"
              aria-label="Dismiss and reset"
              title="Dismiss and reset"
              onClick={resetForm}
            >
              ×
            </button>
            {dataSessionError && (
              <div className="rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 pr-10 text-sm text-[#6b1010]">{dataSessionError}</div>
            )}
            {(dataSessionSuccess || draftConfirmResult || dataSessionResult) && (
              <div className="rounded-xl border border-[#c8e6d4] bg-[#f4fbf7] p-4 pr-10 text-sm flex flex-col gap-2">
                <p className="font-medium text-[#1a5c38]">
                  {dataSessionSuccess || 'Upload complete — data has been saved.'}
                </p>

                {draftConfirmResult && (
                  <>
                    <div className="flex flex-wrap gap-x-6 gap-y-1 text-sm">
                      <span className="text-avcs-muted">Rows processed: <span className="font-medium text-avcs-text">{draftConfirmResult.row_count ?? '—'}</span></span>
                      <span className="text-avcs-muted">Animals matched: <span className="font-medium text-avcs-text">{draftConfirmResult.rows_linked ?? '—'}</span></span>
                      <span className="text-avcs-muted">With EID: <span className="font-medium text-avcs-text">{(draftConfirmResult.rows_with_eid || draftConfirmResult.linking_summary?.rows_with_eid || draftPreviewSummary?.rows_with_eid) ?? '—'}</span></span>
                      {(draftConfirmResult.rows_unlinked ?? 0) > 0 && (
                        <span className="text-avcs-muted">Skipped (no match): <span className="font-medium text-[#92400e]">{draftConfirmResult.rows_unlinked}</span></span>
                      )}
                      {draftConfirmResult.data_quality_grade && (
                        <span className="text-avcs-muted">
                          Data quality:{' '}
                          <span className={`inline-flex rounded-full border px-2 py-0.5 text-xs font-semibold ${DATA_QUALITY_BADGE[draftConfirmResult.data_quality_grade]?.cls || ''}`}>
                            {DATA_QUALITY_BADGE[draftConfirmResult.data_quality_grade]?.label || draftConfirmResult.data_quality_grade}
                          </span>{' '}
                          <span className="font-medium text-avcs-text">{draftConfirmResult.data_quality_score ?? '—'}/100</span>
                        </span>
                      )}
                    </div>
                    {(draftConfirmResult.rows_unlinked ?? 0) > 0 && (
                      // Previously a dead end: the count was reported and the user had
                      // to go find the rows. An unmatched row is usually a scanned EID
                      // for an animal registered without one, so offer the fix here.
                      <div className="flex flex-wrap items-center gap-2">
                        <p className="text-xs text-[#92400e]">
                          {draftConfirmResult.rows_unlinked} row{draftConfirmResult.rows_unlinked === 1 ? '' : 's'} could not be matched to an animal.
                        </p>
                        {draftConfirmResult.deal_id && (
                          <button
                            type="button"
                            className="rounded-md border border-[#e8c9a6] bg-white px-2 py-1 text-xs font-semibold text-[#8a4b12] hover:bg-[#fdf3e7]"
                            onClick={() => openReconcileQueue(String(draftConfirmResult.deal_id))}
                          >
                            Reconcile {draftConfirmResult.rows_unlinked === 1 ? 'it' : 'them'} now
                          </button>
                        )}
                      </div>
                    )}
                    {(draftConfirmResult.data_quality_breakdown?.field_mapping?.unmapped_fields?.length ?? 0) > 0 && (
                      <p className="text-xs text-avcs-muted">
                        Unrecognized columns: {draftConfirmResult.data_quality_breakdown.field_mapping.unmapped_fields.join(', ')}
                      </p>
                    )}
                  </>
                )}

                {dataSessionResult && (() => {
                  const r = relinkResult ?? dataSessionResult;
                  // Regular upload response nests counts under linking_summary; relink result has them at top level.
                  const rowsLinked = r.rows_linked ?? r.linking_summary?.linked_rows;
                  const rowsWithEid = r.rows_with_eid ?? r.linking_summary?.rows_with_eid;
                  const rowsUnlinked = r.rows_unlinked ?? r.linking_summary?.unlinked_rows ?? 0;
                  const qualityGrade = r.data_quality_grade;
                  const qualityScore = r.data_quality_score;
                  const unmappedFields = r.data_quality_breakdown?.field_mapping?.unmapped_fields ?? [];
                  return (
                    <>
                      <div className="flex flex-wrap gap-x-6 gap-y-1 text-sm">
                        <span className="text-avcs-muted">Rows processed: <span className="font-medium text-avcs-text">{dataSessionResult.row_count ?? '—'}</span></span>
                        <span className="text-avcs-muted">Animals matched{relinkResult ? ' (after re-link)' : ''}: <span className="font-medium text-avcs-text">{rowsLinked ?? '—'}</span></span>
                        <span className="text-avcs-muted">With EID: <span className="font-medium text-avcs-text">{rowsWithEid ?? '—'}</span></span>
                        {rowsUnlinked > 0 && (
                          <span className="text-avcs-muted">Skipped (no match): <span className="font-medium text-[#92400e]">{rowsUnlinked}</span></span>
                        )}
                        {qualityGrade && (
                          <span className="text-avcs-muted">
                            Data quality:{' '}
                            <span className={`inline-flex rounded-full border px-2 py-0.5 text-xs font-semibold ${DATA_QUALITY_BADGE[qualityGrade]?.cls || ''}`}>
                              {DATA_QUALITY_BADGE[qualityGrade]?.label || qualityGrade}
                            </span>{' '}
                            <span className="font-medium text-avcs-text">{qualityScore ?? '—'}/100</span>
                          </span>
                        )}
                      </div>
                      {rowsUnlinked > 0 && (
                        <p className="text-xs text-[#92400e]">{rowsUnlinked} row{rowsUnlinked === 1 ? '' : 's'} could not be matched to an animal and were skipped.</p>
                      )}
                      {unmappedFields.length > 0 && (
                        <p className="text-xs text-avcs-muted">Unrecognized columns: {unmappedFields.join(', ')}</p>
                      )}
                      {dataSessionResult.wool_session_id && (
                        <div className="flex flex-wrap items-center gap-2 pt-1">
                          <span className="text-avcs-muted">Shearing session <span className="font-medium text-avcs-text">{dataSessionResult.wool_session_reference}</span> created.</span>
                          <button
                            className="btn admin-submit-action"
                            type="button"
                            onClick={() => {
                              setPendingBalingSessionId(dataSessionResult.wool_session_id);
                              setView('woolBales');
                            }}
                          >
                            Start baling for this session
                          </button>
                        </div>
                      )}
                    </>
                  );
                })()}
              </div>
            )}
          </div>
        )}

        {!loadingDraftPreview && !draftPreview && (
        <form className="grid gap-4 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4 md:grid-cols-2" onSubmit={submitDraft}>

          <label className="grid gap-1 text-sm text-avcs-text md:col-span-2">
            Event *
            <select
              className="rounded-lg border border-[#1e6bb833] px-3 py-2 bg-white"
              value={dataSessionForm.category}
              onChange={(e) => {
                const category = e.target.value;
                setDataSessionForm((f) => ({ ...f, category }));
                setDataSessionResult(null);
                setDraftConfirmResult(null);
                setDataSessionSuccess('');
                setUploadAuditEvents([]);
                setDispatchAcceptResult(null);
                // A capture opened from a deal keeps that deal whatever the event; only a
                // free-standing form clears the deal for events that do not need one.
                if (category !== 'REGISTER' && !captureModalDeal) {
                  setDataSessionDealId('');
                  setDataSessionDealSearch('');
                  setShowDataSessionDealDropdown(false);
                }
              }}
            >
              <option value="">— Select event —</option>
              {EVENT_CATEGORY_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
            {derivedTypeError && <span className="text-xs text-[#6b1010]">{derivedTypeError}</span>}
            {dataSessionForm.eventType && !derivedTypeError && (
              <span className="text-xs text-avcs-muted">
                Recorded as {EVENT_TYPE_LABELS[dataSessionForm.eventType] || dataSessionForm.eventType}
              </span>
            )}
          </label>

          {/* Description / session_id */}
          <label className="grid gap-1 text-sm text-avcs-text md:col-span-2">
            Event Description <span className="text-avcs-muted">(optional — defaults to file name)</span>
            <input
              className="rounded-lg border border-[#1e6bb833] px-3 py-2"
              value={dataSessionForm.sessionId}
              onChange={(e) => setDataSessionForm((f) => ({ ...f, sessionId: e.target.value }))}
              placeholder="e.g. BJG Farm Dispatch April 2025"
            />
          </label>

          {/* Species — only captured at registration; other events inherit each
              animal's registered species. */}
          {needsSpecies && (
          <label className="grid gap-1 text-sm text-avcs-text md:col-span-2">
            Species *
            <select
              className="rounded-lg border border-[#1e6bb833] px-3 py-2 bg-white"
              value={dataSessionForm.species}
              onChange={(e) => setDataSessionForm((f) => ({ ...f, species: e.target.value }))}
            >
              <option value="SHEEP">Sheep</option>
              <option value="CATTLE">Cattle</option>
              <option value="GOAT">Goat</option>
            </select>
          </label>
          )}

          {/* Entity inputs + expected-receipt matching, ordered by category:
              • Dispatch → Source, then Destination
              • Receive  → Destination, then the expected dispatches, then Source (manual fallback)
              • Non-movement → a single (destination) entity the event happened at */}
          {selectedCategory && (() => {
            const sourceField = (
              <EntityCombobox
                label="Source Entity"
                selectedUnit={sourceSelectedUnit}
                searchValue={sourceEntitySearch}
                onSearchChange={(v) => {
                  setSourceEntitySearch(v);
                  setShowSourceDropdown(true);
                  if (sourceSearchTimerRef.current) clearTimeout(sourceSearchTimerRef.current);
                  sourceSearchTimerRef.current = setTimeout(() => searchProductionUnits(v, setSourceProductionUnits, setSourceSearching), 350);
                }}
                results={sourceProductionUnits}
                showDropdown={showSourceDropdown}
                onFocus={() => setShowSourceDropdown(true)}
                onBlur={() => setTimeout(() => setShowSourceDropdown(false), 150)}
                onSelect={(unit) => {
                  setDataSessionForm((f) => ({ ...f, sourceEntityId: unit.id || '' }));
                  setSourceSelectedUnit(unit);
                  setSourceEntitySearch('');
                  setShowSourceDropdown(false);
                }}
                onClear={() => {
                  setDataSessionForm((f) => ({ ...f, sourceEntityId: '' }));
                  setSourceSelectedUnit(null);
                  setSourceEntitySearch('');
                  setSourceProductionUnits([]);
                }}
                showEntityType
              />
            );

            const destField = (
              <EntityCombobox
                label={isMovementCategory ? 'Destination Entity' : 'Entity'}
                selectedUnit={destSelectedUnit}
                searchValue={destEntitySearch}
                onSearchChange={(v) => {
                  setDestEntitySearch(v);
                  setShowDestDropdown(true);
                  if (destSearchTimerRef.current) clearTimeout(destSearchTimerRef.current);
                  destSearchTimerRef.current = setTimeout(() => searchProductionUnits(v, setDestProductionUnits, setDestSearching), 350);
                }}
                results={destProductionUnits}
                showDropdown={showDestDropdown}
                onFocus={() => setShowDestDropdown(true)}
                onBlur={() => setTimeout(() => setShowDestDropdown(false), 150)}
                onSelect={(unit) => {
                  setDataSessionForm((f) => ({ ...f, destEntityId: unit.id || '' }));
                  setDestSelectedUnit(unit);
                  setDestEntitySearch('');
                  setShowDestDropdown(false);
                }}
                onClear={() => {
                  setDataSessionForm((f) => ({ ...f, destEntityId: '' }));
                  setDestSelectedUnit(null);
                  setDestEntitySearch('');
                  setDestProductionUnits([]);
                }}
                showEntityType
              />
            );

            // One card per dispatch event (grouped by dispatch, not by deal).
            const expectedPanel = (isReceiveCategory && dataSessionForm.destEntityId) ? (
              <div className="md:col-span-2 rounded-lg border border-[#1e6bb833] bg-[#f8fbff] p-3 text-sm">
                <div className="mb-2 font-semibold text-avcs-text">Expected receipts</div>
                {dispatchReceivePreview ? (
                  // Confirm-before-create step: what would be received, no file.
                  <div className="grid gap-2 rounded-md border border-[#1e6bb833] bg-white px-3 py-3">
                    <div className="font-semibold text-avcs-text">
                      Review receipt — {dispatchReceivePreview.total_count} animal{dispatchReceivePreview.total_count === 1 ? '' : 's'} will be received
                    </div>
                    <div className="text-sm text-avcs-text">
                      {(dispatchReceivePreview.source_entity_name || '?')} → {(dispatchReceivePreview.destination_entity_name || '?')}
                      {dispatchReceivePreview.species ? ` · ${dispatchReceivePreview.species}` : ''}
                    </div>
                    {dispatchReceivePreview.deals.length > 0 && (
                      <div className="text-xs text-avcs-muted">
                        {dispatchReceivePreview.deals.length > 1
                          ? `${dispatchReceivePreview.deals.length} deals: `
                          : 'Deal: '}
                        {dispatchReceivePreview.deals.map((d) => `${d.deal_no ?? '—'} (${d.count})`).join(', ')}
                      </div>
                    )}
                    {dispatchReceivePreview.animals.length > 0 && (
                      <div className="min-w-0">
                        {dispatchReceivePreview.total_count > dispatchReceivePreview.sample_count && (
                          <p className="text-xs text-avcs-muted mb-1">Showing first {dispatchReceivePreview.sample_count} of {dispatchReceivePreview.total_count} animals.</p>
                        )}
                        <div className="overflow-x-auto">
                          <table className="min-w-max text-xs border-collapse">
                            <thead>
                              <tr className="bg-[#eef5fc]">
                                <th className="border border-[#1e6bb824] px-2 py-1 text-left font-semibold text-avcs-text whitespace-nowrap">#</th>
                                <th className="border border-[#1e6bb824] px-2 py-1 text-left font-semibold text-avcs-text whitespace-nowrap">EID</th>
                                <th className="border border-[#1e6bb824] px-2 py-1 text-left font-semibold text-avcs-text whitespace-nowrap">VID</th>
                                {dispatchReceivePreview.deals.length > 1 && (
                                  <th className="border border-[#1e6bb824] px-2 py-1 text-left font-semibold text-avcs-text whitespace-nowrap">Deal</th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {dispatchReceivePreview.animals.map((a, i) => (
                                <tr key={a.id} className="even:bg-[#fbfdff]">
                                  <td className="border border-[#1e6bb824] px-2 py-1 text-avcs-muted">{i + 1}</td>
                                  <td className="border border-[#1e6bb824] px-2 py-1 text-avcs-text whitespace-nowrap">{a.eid || '—'}</td>
                                  <td className="border border-[#1e6bb824] px-2 py-1 text-avcs-text whitespace-nowrap">{a.vid || '—'}</td>
                                  {dispatchReceivePreview.deals.length > 1 && (
                                    <td className="border border-[#1e6bb824] px-2 py-1 text-avcs-muted whitespace-nowrap">{a.deal_no || '—'}</td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    <div className="mt-1 flex flex-wrap gap-2">
                      <button
                        type="button"
                        className="btn admin-submit-action"
                        disabled={confirmingDispatchReceive}
                        onClick={confirmDispatchReceive}
                      >
                        {confirmingDispatchReceive
                          ? 'Creating receive event…'
                          : `Confirm & receive ${dispatchReceivePreview.total_count} animal${dispatchReceivePreview.total_count === 1 ? '' : 's'} →`}
                      </button>
                      <button type="button" className="btn admin-inline-action" disabled={confirmingDispatchReceive} onClick={cancelDispatchPreview}>
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : loadingExpectedDispatches ? (
                  <span className="text-avcs-muted">Looking for matching dispatches…</span>
                ) : expectedDispatches.length === 0 ? (
                  <span className="text-avcs-muted">No open dispatches match this destination — set the source below and upload a file instead.</span>
                ) : (
                  <div className="grid gap-2">
                    <span className="text-avcs-muted">
                      One card per load that left, whatever it arrived as. Accepting it books a receipt for each
                      deal on board. Take one deal on its own when only part of the load turned up.
                    </span>
                    {expectedDispatches.map((match) => {
                      const rows = match.deals && match.deals.length
                        ? match.deals
                        : [{
                            deal_id: match.deal_id, deal_no: match.deal_no,
                            animal_count: match.animal_count, dispatch_event_id: match.dispatch_event_id,
                            data_session_id: match.data_session_id, source_filename: null,
                          }];
                      const busy = loadingDispatchPreviewId === match.dispatch_event_id;
                      return (
                        <div key={match.dispatch_event_id} className="rounded-md border border-[#1e6bb824] bg-white px-3 py-2">
                          <div className="flex flex-wrap items-start justify-between gap-2">
                            <div className="min-w-0">
                              <div className="font-medium text-avcs-text">
                                {(match.source_entity_name || '?')} → {(match.destination_entity_name || '?')}
                                {match.event_date ? ` · ${fmtDate(match.event_date)}` : ''}
                              </div>
                              <div className="text-xs text-avcs-muted">
                                {match.species || '?'} · {fmtNum(match.animal_count)} animal{match.animal_count === 1 ? '' : 's'}
                                {rows.length > 1 ? ` · ${rows.length} deals on board` : ''}
                              </div>
                            </div>
                            <button
                              type="button"
                              className="admin-inline-action btn"
                              disabled={busy}
                              onClick={() => openDispatchPreview(match)}
                            >
                              {busy ? 'Loading…' : rows.length > 1 ? `Accept all ${rows.length} deals` : 'Accept animals'}
                            </button>
                          </div>
                          {/* The load, deal by deal. Each line is receivable on
                              its own, so a part-arrival does not force the
                              operator to accept animals that are not there. */}
                          <ul className="mt-2 grid gap-1 border-t border-[#1e6bb814] pt-2">
                            {rows.map((row) => {
                              const rowBusy = loadingDispatchPreviewId === row.dispatch_event_id;
                              return (
                                <li key={row.dispatch_event_id} className="flex flex-wrap items-center justify-between gap-2 text-xs">
                                  <span className="min-w-0 text-avcs-text">
                                    <span className="font-medium">{row.deal_no || '—'}</span>
                                    <span className="text-avcs-muted"> · {fmtNum(row.animal_count)} animal{row.animal_count === 1 ? '' : 's'}</span>
                                    {row.source_filename && <span className="text-avcs-muted"> · {row.source_filename}</span>}
                                  </span>
                                  {rows.length > 1 && (
                                    <button
                                      type="button"
                                      className="rounded-md border border-[#1e6bb824] bg-white px-2 py-0.5 text-[11px] font-semibold text-avcs-text hover:bg-[#f1f7ff] disabled:opacity-50"
                                      disabled={rowBusy || busy}
                                      title={`Receive only ${row.deal_no || 'this deal'}`}
                                      onClick={() => openDispatchPreview(match, { dispatch_event_id: row.dispatch_event_id, deal_no: row.deal_no })}
                                    >
                                      {rowBusy ? 'Loading…' : 'This deal only'}
                                    </button>
                                  )}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      );
                    })}
                  </div>
                )}
                {dispatchAcceptResult && (
                  <div className="mt-2 rounded-md border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-[#106b38]">
                    Received {dispatchAcceptResult.received_count} of {dispatchAcceptResult.dispatched_count} animals.
                    {dispatchAcceptResult.unreceived.length > 0 && (
                      <div className="mt-1 text-[#7b4a18]">
                        Not received ({dispatchAcceptResult.unreceived.length}): {dispatchAcceptResult.unreceived
                          .map((a) => a.eid || a.vid || a.id).slice(0, 20).join(', ')}
                        {dispatchAcceptResult.unreceived.length > 20 ? '…' : ''}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : null;

            if (selectedCategory === 'DISPATCH') {
              return <>{sourceField}{destField}</>;
            }
            if (isReceiveCategory) {
              return (
                <>
                  {destField}
                  {expectedPanel}
                  <div className="md:col-span-2 text-xs text-avcs-muted">Or set the source manually and upload a file:</div>
                  {sourceField}
                </>
              );
            }
            // Non-movement: a single entity (rendered as the destination field).
            return destField;
          })()}

          {/* Deal sits directly under the entity it belongs to: it only appears
              for registration events, so anywhere higher leaves a field that
              pops in and out above the rest of the form. */}
          {/* Always offered: a deal on a weigh, shear or vaccination file scopes
              the event to that deal's animals. Required where the backend needs
              it to place new animals (registration, receive, slaughter). */}
          {(
            <DealCombobox
              label={isDealRequired ? 'Deal *' : 'Deal (optional)'}
              selectedDeal={selectedUploadDeal}
              searchValue={dataSessionDealSearch}
              results={filteredDealOptions}
              showDropdown={showDataSessionDealDropdown}
              onSearchChange={(value) => {
                setDataSessionDealSearch(value);
                setShowDataSessionDealDropdown(true);
              }}
              onFocus={() => setShowDataSessionDealDropdown(true)}
              onBlur={() => setTimeout(() => setShowDataSessionDealDropdown(false), 150)}
              onSelect={(deal) => {
                setDataSessionDealId(deal.dealId);
                setDataSessionDealSearch('');
                setShowDataSessionDealDropdown(false);
                setDataSessionResult(null);
                setDraftConfirmResult(null);
                setDataSessionSuccess('');
                setUploadAuditEvents([]);
              }}
              onClear={() => {
                setDataSessionDealId('');
                setDataSessionDealSearch('');
                setShowDataSessionDealDropdown(false);
                setUploadAuditEvents([]);
              }}
              formatDeal={formatUploadDeal}
            />
          )}

          {/* File upload */}
          <label className="grid gap-1 text-sm text-avcs-text md:col-span-2">
            Data file *
            <input
              key={dataSessionFileKey}
              type="file"
              accept=".csv,.txt"
              className="cursor-pointer rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm text-[#315d86] transition-colors duration-150 hover:border-[#1e6bb866] hover:bg-[#f0f7ff] hover:shadow-[0_0_0_3px_rgba(30,107,184,0.07)] file:cursor-pointer file:mr-3 file:rounded-md file:border-0 file:bg-[#e8f4ff] file:px-3 file:py-1.5 file:text-xs file:font-semibold file:text-[#0f3b64] file:transition-colors file:duration-150 file:hover:bg-[#cce2f8]"
              onChange={(e) => setDataSessionForm((f) => ({ ...f, file: e.target.files?.[0] ?? null }))}
            />
          </label>

          {/* File validation result */}
          {fileValidation && (
            <div className={`md:col-span-2 min-w-0 rounded-lg border p-3 text-sm ${
              fileValidation.status === 'validating' ? 'border-[#1e6bb833] bg-[#f8fbff] text-avcs-muted' :
              fileValidation.status === 'ok'         ? 'border-[#b9e7c9] bg-[#e7f8ee] text-[#106b38]' :
              fileValidation.status === 'warning'    ? 'border-[#ecd1b9] bg-[#fff7ef] text-[#7b4a18]' :
                                                       'border-[#e7bbb9] bg-[#f8eae7] text-[#6b1010]'
            }`}>
              {fileValidation.status === 'validating' ? (
                <span className="text-avcs-muted">Checking file…</span>
              ) : (
                <div className="grid gap-2">
                  <div className="flex flex-wrap items-center gap-2 font-semibold">
                    {fileValidation.status === 'ok'      && <span>✔ File looks good</span>}
                    {fileValidation.status === 'warning' && <span>⚠ File has warnings</span>}
                    {fileValidation.status === 'error'   && <span>✕ Required columns missing</span>}
                    <span className="font-normal text-xs opacity-70">
                      {fileValidation.totalRows} row{fileValidation.totalRows !== 1 ? 's' : ''} · {fileValidation.detectedDelimiter === ',' ? 'Comma' : 'Semicolon'} delimiter · {fileValidation.parsedHeaders.length} column{fileValidation.parsedHeaders.length !== 1 ? 's' : ''}
                    </span>
                  </div>

                  {fileValidation.missingRequired.length > 0 && (
                    <div>
                      <div className="font-medium mb-1">Missing required columns:</div>
                      <ul className="grid gap-0.5 pl-3 list-disc list-inside">
                        {fileValidation.missingRequired.map((m) => (
                          <li key={m.key} className="text-xs">
                            <span className="font-semibold">{m.description}</span>
                            {m.acceptedNames && <span className="opacity-70"> — accepted names: {m.acceptedNames}</span>}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {fileValidation.missingRecommended.length > 0 && (
                    <div>
                      <div className="font-medium mb-1">Missing recommended columns:</div>
                      <ul className="grid gap-0.5 pl-3 list-disc list-inside">
                        {fileValidation.missingRecommended.map((m) => (
                          <li key={m.key} className="text-xs opacity-90">
                            <span className="font-semibold">{m.description}</span>
                            {m.acceptedNames && <span className="opacity-70"> — accepted names: {m.acceptedNames}</span>}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {fileValidation.blankIdentifierRows > 0 && (
                    <div className="text-xs">⚠ {fileValidation.blankIdentifierRows} row{fileValidation.blankIdentifierRows !== 1 ? 's' : ''} sampled have no EID / identifier value</div>
                  )}

                  {fileValidation.crossDealEids.length > 0 && (
                    <div className="rounded border border-[#e7bbb9] bg-[#f8eae7] text-[#6b1010] px-2.5 py-2 text-xs">
                      <div className="font-semibold mb-1">
                        ✕ {fileValidation.crossDealEids.length} EID{fileValidation.crossDealEids.length !== 1 ? 's' : ''} already linked to another deal
                      </div>
                      <ul className="grid gap-0.5 pl-3 list-disc list-inside">
                        {fileValidation.crossDealEids.slice(0, 10).map((e) => (
                          <li key={e.eid}>
                            <span className="font-medium">{e.eid}</span>
                            <span className="opacity-70"> — {e.deal_no}</span>
                          </li>
                        ))}
                        {fileValidation.crossDealEids.length > 10 && (
                          <li className="opacity-70">…and {fileValidation.crossDealEids.length - 10} more</li>
                        )}
                      </ul>
                    </div>
                  )}

                  {fileValidation.parsedHeaders.length > 0 && (
                    <div className="text-xs opacity-70 break-all">Columns detected: {fileValidation.parsedHeaders.join(', ')}</div>
                  )}
                </div>
              )}
            </div>
          )}

          <div className="md:col-span-2 flex gap-2">
            <button className="btn admin-submit-action" type="submit" disabled={savingDataSession || fileValidation?.eidCheckPending === true || (fileValidation?.crossDealEids?.length ?? 0) > 0}>
              {savingDataSession
                ? 'Preparing preview…'
                : fileValidation?.eidCheckPending ? 'Checking EIDs…'
                : (fileValidation?.crossDealEids?.length ?? 0) > 0 ? 'EID conflict — cannot upload'
                : fileValidation?.status === 'error'
                  ? 'Preview anyway'
                  : 'Preview'}
            </button>
          </div>
        </form>
        )}

        {/* Draft preview panel */}
        {(loadingDraftPreview || draftPreview) && !draftConfirmResult && (
          <div className="rounded-xl border border-[#d4a02060] bg-[#fffbf0] p-4 flex flex-col gap-3 min-w-0">
            {/* Once the operator is happy with the preview the confirmation is a
                screen of its own, not a block under the table. */}
            <div className={showCreateEventConfirm ? 'hidden' : 'contents'}>
            <div className="flex items-center justify-between">
              <h3 className="font-semibold text-[#7b4a18]">Draft preview — {draftPreview ? `${draftPreview.row_count ?? 0} rows · review before processing` : 'review before processing'}</h3>
              {draftPreview && !confirmingDraft && (
                <button
                  className="text-xs text-avcs-muted underline"
                  type="button"
                  onClick={() => { setDraftPreview(null); setDraftSessionId(null); setDuplicateUpload(null); setUserMappings({}); setVaccinationEntries([]); setVaccinationStepOpen(false); }}
                >
                  Discard draft
                </button>
              )}
            </div>
            {duplicateUpload && (() => {
              const isExact = duplicateUpload.match === 'exact_content';
              const diff = duplicateUpload.row_diff || null;
              const priorMeta = [
                duplicateUpload.event_type,
                duplicateUpload.deal_no ? `deal ${duplicateUpload.deal_no}` : null,
                duplicateUpload.uploaded_at ? `uploaded ${fmtDate(duplicateUpload.uploaded_at)}` : null,
                duplicateUpload.status,
              ].filter(Boolean).join(' · ');
              return (
                <div className="rounded-lg border border-[#e0a800] bg-[#fff3cd] px-3 py-2.5 text-sm text-[#6b4e00]">
                  <div className="flex items-start gap-2">
                    <span aria-hidden="true">⚠️</span>
                    <div className="min-w-0 w-full">
                      <p className="font-semibold">
                        {isExact
                          ? 'This exact file was already uploaded.'
                          : 'An event like this was already uploaded.'}
                      </p>
                      <p className="mt-0.5 break-words text-xs">
                        {duplicateUpload.original_filename ? <><span className="font-mono">{duplicateUpload.original_filename}</span>{' · '}</> : null}
                        {priorMeta}
                      </p>
                      {diff && (
                        <p className="mt-1 text-xs">
                          Compared to it, this file has{' '}
                          <span className="font-semibold">{diff.new ?? 0} new</span>,{' '}
                          <span className="font-semibold">{diff.changed ?? 0} changed</span>,{' '}
                          <span className="font-semibold">{diff.removed ?? 0} removed</span> and{' '}
                          <span className="font-semibold">{diff.unchanged ?? 0} unchanged</span> row(s).
                        </p>
                      )}
                      {isExact ? (
                        <p className="mt-1 text-xs">
                          Confirming will attach it to the existing event as a new revision — no duplicate event is created.
                        </p>
                      ) : (
                        <div className="mt-2 grid gap-1.5">
                          <label className="flex items-start gap-2 text-xs cursor-pointer">
                            <input
                              type="radio"
                              name="delta-choice"
                              className="mt-0.5"
                              checked={!applyAsDelta}
                              onChange={() => setApplyAsDelta(false)}
                            />
                            <span><span className="font-semibold">Create a separate event</span> — record this as its own event (default).</span>
                          </label>
                          <label className="flex items-start gap-2 text-xs cursor-pointer">
                            <input
                              type="radio"
                              name="delta-choice"
                              className="mt-0.5"
                              checked={applyAsDelta}
                              onChange={() => setApplyAsDelta(true)}
                            />
                            <span><span className="font-semibold">Apply as a delta</span> — attach to the existing event; only new/changed rows are added, and rows dropped here are voided.</span>
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })()}
            </div>
            {loadingDraftPreview ? (
              <p className="text-sm text-avcs-muted">Loading preview…</p>
            ) : draftPreview && (
              <div className="grid gap-4 text-sm min-w-0">
              <div className={showCreateEventConfirm ? 'hidden' : 'contents'}>
                {!(isVaccinationEvent && vaccinationStepOpen) && (
                <>
                {/* Top stats row */}
                <div className="flex flex-wrap gap-x-6 gap-y-1 text-sm border-b border-[#e8d08060] pb-3">
                  <span className="text-avcs-muted">Total rows: <span className="font-medium text-avcs-text">{draftPreview.row_count ?? '—'}</span></span>
                  <span className="text-avcs-muted">With EID: <span className="font-medium text-avcs-text">{draftPreview.preview_summary?.rows_with_eid ?? '—'}</span></span>
                  {(() => {
                    const missing = draftPreview.preview_summary?.blank_identifier_rows ?? draftPreview.preview_summary?.rows_skipped_no_identifier ?? 0;
                    return missing > 0
                      ? <span className="text-avcs-muted">No animal ID: <span className="font-medium text-[#92400e]">{missing} (will be skipped)</span></span>
                      : null;
                  })()}
                </div>
                {/* What will happen summary */}
                {draftPreview.write_estimates && Object.keys(draftPreview.write_estimates).length > 0 && (() => {
                  const e = draftPreview.write_estimates;
                  const items = [
                    { label: 'New animals to register', value: e.animals_would_create ?? 0 },
                    { label: 'Existing animals to update', value: e.animals_would_update ?? 0 },
                    { label: "Rows that won't match any animal", value: e.rows_would_fail_linking ?? 0, warn: true },
                  ];
                  return (
                    <div className="text-sm">
                      <p className="text-xs font-medium text-avcs-muted uppercase tracking-wide mb-2">If you confirm, this will</p>
                      <ul className="grid gap-1.5">
                        {items.map(({ label, value, warn }) => value > 0 ? (
                          <li key={label} className="flex items-center gap-2">
                            <span className={`text-xs font-semibold w-7 text-right tabular-nums ${
                              warn ? 'text-[#92400e]' : 'text-avcs-text'
                            }`}>{value}</span>
                            <span className={`text-xs ${warn ? 'text-[#92400e]' : 'text-avcs-muted'}`}>{label}{warn ? ' — these will be skipped' : ''}</span>
                          </li>
                        ) : null)}
                      </ul>
                    </div>
                  );
                })()}
                {Array.isArray(draftPreview.preview_rows) && draftPreview.preview_rows.length > 0 && (() => {
                  const previewRowCount = draftPreview.preview_rows.length;
                  const totalRowCount = draftPreview.row_count ?? previewRowCount;
                  // Strip BOM (\ufeff) from column names — backend uses utf-8 not utf-8-sig so
                  // the first column in raw_data may carry a BOM that matched_field_row doesn't.
                  const rawDataKeys = Object.keys(draftPreview.preview_rows[0]?.raw_data ?? {});
                  const stripBom = (s: string) => s.replace(/^\ufeff/, '');
                  // Keep a mapping from display name → original raw key for data access
                  const colMeta = rawDataKeys.map((rawKey) => ({ rawKey, col: stripBom(rawKey) }));
                  const fieldMap: Record<string, string> = draftPreview.matched_field_row ?? {};
                  // Columns that are handled as vaccination data — identified by checking whether
                  // any medicine name from the preview vaccinations appears in the column name.
                  const vaccineMedicineNames: string[] = Array.from(new Set(
                    (draftPreview.preview_rows as any[])
                      .flatMap((row: any) => (row.vaccinations ?? []).map((v: any) => (v.medicine_name ?? '').toLowerCase()))
                      .filter(Boolean)
                  ));
                  const isVaccinationColumn = (col: string) => {
                    const low = col.toLowerCase();
                    if (vaccineMedicineNames.some((name) => low.includes(name))) return true;
                    // Per-row (health-log) layout: the medicine names live in the
                    // cells, not the headers, so recognise the fixed set of
                    // long-format vaccination columns by name instead.
                    if (isPerRowVaccination && PER_ROW_VACCINATION_COLUMN_NAMES.has(normVaxHeader(col))) return true;
                    return false;
                  };
                  return (
                    <div className="min-w-0">
                      {totalRowCount > previewRowCount && (
                        <p className="text-xs text-avcs-muted mb-1">Showing first {previewRowCount} of {totalRowCount} rows.</p>
                      )}
                      <div className="overflow-x-auto">
                      <table className="min-w-max text-xs border-collapse">
                        <thead>
                          <tr className="bg-[#fff7e0]">
                            <th className="border border-[#e8d08060] px-2 py-1 text-left font-semibold text-[#7b4a18] whitespace-nowrap">#</th>
                            {colMeta.map(({ col }) => (
                              <th key={col} className="border border-[#e8d08060] px-2 py-1 text-left font-semibold text-[#7b4a18] whitespace-nowrap">{col}</th>
                            ))}
                            <th className="border border-[#e8d08060] px-2 py-1 text-left font-semibold text-[#7b4a18] whitespace-nowrap">Errors</th>
                          </tr>
                          <tr className="bg-[#fdf3d0]">
                            <td className="border border-[#e8d08060] px-2 py-1 text-[#a07030] italic whitespace-nowrap">Maps to</td>
                            {colMeta.map(({ col }) => {
                              const dbField = fieldMap[col];
                              if (dbField) {
                                return (
                                  <td key={col} className="border border-[#e8d08060] px-2 py-1 italic whitespace-nowrap text-[#106b38]">
                                    {dbField}
                                  </td>
                                );
                              }
                              // Column is handled as vaccination data — no need to remap
                              if (isVaccinationColumn(col)) {
                                return (
                                  <td key={col} className="border border-[#e8d08060] px-2 py-1 italic whitespace-nowrap text-[#106b38]">
                                    vaccination ✓
                                  </td>
                                );
                              }
                              // Unrecognised — show a dropdown so the user can assign a target field
                              const targetFields = fieldMappingsMeta?.target_fields ?? [];
                              return (
                                <td key={col} className="border border-[#e8d08060] px-2 py-1 whitespace-nowrap">
                                  {targetFields.length > 0 ? (
                                    <select
                                      className="text-xs border border-[#d4a02080] rounded px-1 py-0.5 bg-white text-[#7b4a18]"
                                      value={userMappings[col] ?? ''}
                                      onChange={(e) => setUserMappings((m) => ({ ...m, [col]: e.target.value }))}
                                    >
                                      <option value="">— not recognised —</option>
                                      {targetFields.map((f) => (
                                        <option key={f.value} value={f.value}>{f.label}</option>
                                      ))}
                                    </select>
                                  ) : (
                                    <span className="italic text-[#b45309]">not recognised</span>
                                  )}
                                </td>
                              );
                            })}
                            <td className="border border-[#e8d08060] px-2 py-1" />
                          </tr>
                        </thead>
                        <tbody>
                          {draftPreview.preview_rows.map((row: any, i: number) => (
                            <tr key={i} className="even:bg-[#fffdf5]">
                              <td className="border border-[#e8d08060] px-2 py-1 text-avcs-muted">{row.row_number ?? i + 1}</td>
                              {colMeta.map(({ rawKey, col }) => (
                                <td key={col} className="border border-[#e8d08060] px-2 py-1 text-avcs-text whitespace-nowrap">{row.raw_data?.[rawKey] ?? '—'}</td>
                              ))}
                              <td className="border border-[#e8d08060] px-2 py-1 text-red-500">{Array.isArray(row.processing_errors) ? row.processing_errors.join('; ') : (row.processing_errors || '')}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      </div>
                    </div>
                  );
                })()}
                </>
                )}
                {isPerRowVaccination && (
                  <div className="rounded-xl border border-[#c8e6d4a0] bg-[#f7fdf9] p-3 min-w-0">
                    <p className="text-xs font-semibold text-[#1a5c38] mb-1">
                      Medicines detected
                    </p>
                    <p className="text-xs text-avcs-muted mb-2">
                      This file records one medicine per animal per row (the “Vaccine / Medicine” column).
                      Each row is imported as its own treatment automatically — no need to add medicines by hand.
                    </p>
                    {vaccinationMedicines.length > 0 ? (
                      <div className="flex flex-wrap gap-1.5">
                        {vaccinationMedicines.map((m) => (
                          <span key={m} className="inline-block rounded-full border border-[#1e6bb833] bg-white px-2 py-0.5 text-xs text-[#1a5c38]">
                            {m}
                          </span>
                        ))}
                      </div>
                    ) : (
                      <p className="text-xs text-avcs-muted italic">
                        No medicines found in the “Vaccine / Medicine” column.
                      </p>
                    )}
                  </div>
                )}
                {isVaccinationEvent && !isPerRowVaccination && vaccinationStepOpen && (
                  <div className="rounded-xl border border-[#c8e6d4a0] bg-[#f7fdf9] p-3 min-w-0">
                    <p className="text-xs font-semibold text-[#1a5c38] mb-1">
                      Add medicines
                    </p>
                    <p className="text-xs text-avcs-muted mb-3">
                      {vaccinationFoundCount > 0
                        ? `${vaccinationFoundCount} vaccination${vaccinationFoundCount === 1 ? '' : 's'} found in the uploaded file — review below, edit as needed, or add more.`
                        : 'No vaccination columns were found in the uploaded file — add each medicine given in this event.'}
                    </p>
                    <div className="grid gap-2">
                      {vaccinationEntries.map((row, i) => (
                        <div key={i} className="grid gap-2 sm:grid-cols-[1.4fr_0.8fr_0.8fr_1fr_auto_auto] items-end rounded-lg border border-[#c8e6d460] bg-white p-2">
                          <label className="grid gap-1 text-xs text-avcs-text">
                            Medicine
                            <input
                              className="rounded-lg border border-[#1e6bb833] px-2 py-1.5 text-sm"
                              placeholder="e.g. Duplocillin"
                              value={row.medicineName}
                              onChange={(e) => setVaccinationEntries((prev) => prev.map((r, idx) => idx === i ? { ...r, medicineName: e.target.value } : r))}
                            />
                          </label>
                          <label className="grid gap-1 text-xs text-avcs-text">
                            Dosage
                            <input
                              className="rounded-lg border border-[#1e6bb833] px-2 py-1.5 text-sm"
                              value={row.dosage}
                              onChange={(e) => setVaccinationEntries((prev) => prev.map((r, idx) => idx === i ? { ...r, dosage: e.target.value } : r))}
                            />
                          </label>
                          <label className="grid gap-1 text-xs text-avcs-text">
                            Cost per animal (R)
                            <input
                              type="number"
                              min={0}
                              step="0.01"
                              className="rounded-lg border border-[#1e6bb833] px-2 py-1.5 text-sm"
                              value={row.cost}
                              onChange={(e) => setVaccinationEntries((prev) => prev.map((r, idx) => idx === i ? { ...r, cost: e.target.value } : r))}
                            />
                          </label>
                          <label className="grid gap-1 text-xs text-avcs-text">
                            Batch
                            <input
                              className="rounded-lg border border-[#1e6bb833] px-2 py-1.5 text-sm"
                              value={row.batchNumber}
                              onChange={(e) => setVaccinationEntries((prev) => prev.map((r, idx) => idx === i ? { ...r, batchNumber: e.target.value } : r))}
                            />
                          </label>
                          <label className="flex min-h-[38px] items-center gap-1.5 whitespace-nowrap text-xs text-avcs-text" title="Ticked once, remembered on the product; the deal's health declaration reads 'treated with antibiotics' from it.">
                            <input
                              type="checkbox"
                              checked={row.isAntibiotic}
                              onChange={(e) => setVaccinationEntries((prev) => prev.map((r, idx) => idx === i ? { ...r, isAntibiotic: e.target.checked } : r))}
                            />
                            Antibiotic
                          </label>
                          <button
                            type="button"
                            className={`${DELETE_BTN} justify-self-end`}
                            aria-label="Remove medicine"
                            onClick={async () => { if (await requestConfirm({ title: 'Remove medicine', message: 'Remove this medicine row?', confirmLabel: 'Remove', tone: 'danger' })) setVaccinationEntries((prev) => prev.filter((_, idx) => idx !== i)); }}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                    <button
                      type="button"
                      className="btn admin-inline-action mt-2"
                      onClick={() => setVaccinationEntries((prev) => [...prev, blankVaccinationEntryRow()])}
                    >
                      + Add medicine
                    </button>
                  </div>
                )}
                {isVaccinationEvent && !isPerRowVaccination && !vaccinationStepOpen && vaccinationFoundCount > 0 && (() => {
                  const animalsInFile = Number(draftPreviewSummary?.rows_with_eid ?? draftPreviewSummary?.total_rows ?? draftPreview?.preview_summary?.total_rows ?? 0);
                  const found = vaccinationEntries.filter((row) => row.medicineName.trim());
                  return (
                    <div className="rounded-xl border border-[#c8e6d4a0] bg-[#f7fdf9] p-4 min-w-0">
                      <p className="text-lg font-semibold text-[#1a5c38]">
                        {found.length} medicine{found.length === 1 ? '' : 's'} found — {found.length === 1 ? 'it' : 'they'} will be applied to {fmtNum(animalsInFile)} animal{animalsInFile === 1 ? '' : 's'}.
                      </p>
                      <p className="mt-1 text-xs text-avcs-muted">
                        Each animal gets its own treatment record per medicine. Tick the antibiotics; the deal's
                        health declaration reads "treated with antibiotics" from that.
                      </p>
                      <div className="mt-3 flex flex-wrap gap-2">
                        {vaccinationEntries.map((row, i) => row.medicineName.trim() ? (
                          <label key={i} className={`flex cursor-pointer items-center gap-2 rounded-full border px-3 py-1.5 text-sm ${row.isAntibiotic ? 'border-[#e8c9a6] bg-[#fff7ef] text-[#7b4a18]' : 'border-[#c8e6d4] bg-white text-avcs-text'}`}>
                            <span className="font-medium">{row.medicineName}</span>
                            {row.dosage && <span className="text-xs text-avcs-muted">{row.dosage} dose</span>}
                            <input
                              type="checkbox"
                              checked={row.isAntibiotic}
                              onChange={(e) => setVaccinationEntries((prev) => prev.map((r, idx) => idx === i ? { ...r, isAntibiotic: e.target.checked } : r))}
                            />
                            <span className="text-xs">Antibiotic</span>
                          </label>
                        ) : null)}
                      </div>
                      <div className="mt-3 flex flex-wrap gap-2">
                        <button className="btn primary" type="button" disabled={confirmingDraft} onClick={openCreateEventConfirm}>
                          Proceed →
                        </button>
                        <button
                          className="btn admin-inline-action"
                          type="button"
                          title="A medicine given that the file does not carry — opens the medicine rows with a blank one added"
                          onClick={() => { setVaccinationEntries((prev) => [...prev, blankVaccinationEntryRow()]); setVaccinationStepOpen(true); }}
                        >
                          + Add medicine
                        </button>
                        <button className="btn admin-inline-action" type="button" onClick={() => setVaccinationStepOpen(true)}>
                          Edit medicines
                        </button>
                      </div>
                    </div>
                  );
                })()}
                <div className="flex gap-2 mt-1">
                  {isVaccinationEvent && !isPerRowVaccination && !vaccinationStepOpen && vaccinationFoundCount === 0 ? (
                    <button
                      className="btn admin-submit-action"
                      type="button"
                      onClick={() => setVaccinationStepOpen(true)}
                    >
                      Add medicine
                    </button>
                  ) : isVaccinationEvent && !isPerRowVaccination && !vaccinationStepOpen ? null : (
                    <button
                      className="btn admin-submit-action"
                      type="button"
                      disabled={confirmingDraft}
                      onClick={openCreateEventConfirm}
                    >
                      Confirm & process →
                    </button>
                  )}
                  {isVaccinationEvent && !isPerRowVaccination && vaccinationStepOpen && (
                    <button
                      className="btn admin-inline-action"
                      type="button"
                      disabled={confirmingDraft}
                      onClick={() => setVaccinationStepOpen(false)}
                    >
                      ← Back
                    </button>
                  )}
                  <button
                    className="btn admin-inline-action"
                    type="button"
                    disabled={confirmingDraft}
                    onClick={() => { setDraftPreview(null); setDraftSessionId(null); setDuplicateUpload(null); setUserMappings({}); setDataSessionError(''); setVaccinationEntries([]); setVaccinationStepOpen(false); setShowCreateEventConfirm(false); }}
                  >
                    Discard
                  </button>
                </div>

                </div>

                {/* Create-event review — part of the screen, not a modal. It is
                    the last step of the capture, and a dialog over the top hid
                    the very details the operator is being asked to check
                    against. */}
                {showCreateEventConfirm && (
                  <section
                    className="mt-4 overflow-hidden rounded-2xl border border-[#1e6bb833] bg-white"
                    aria-label="Create event confirmation"
                  >
                    <div className="flex flex-col">
                      <div className="flex items-start justify-between gap-3 border-b border-[#1e6bb824] bg-[#f8fbff] px-5 py-3">
                        <div className="min-w-0">
                          <h3 className="text-lg font-semibold text-avcs-text">Create event</h3>
                          <p className="text-sm text-avcs-muted">Review the details below, then create the event.</p>
                        </div>
                      </div>

                      <div className="flex flex-col gap-5 px-5 py-5">
                        {/* Prominent animal count */}
                        <div className="rounded-xl border border-[#1e6bb833] bg-[#eef6ff] px-4 py-6 text-center">
                          <div className="text-6xl font-extrabold leading-none text-[#0f3b64] tabular-nums">
                            {Number(confirmAnimalCount).toLocaleString()}
                          </div>
                          <div className="mt-2 text-sm font-semibold uppercase tracking-wide text-[#315d86]">
                            {confirmSpeciesLabel ? `${confirmSpeciesLabel} ` : ''}
                            {confirmAnimalCount === 1 ? 'record will be created' : 'records will be created'}
                          </div>
                        </div>

                        {/* Details */}
                        <dl className="grid gap-x-4 gap-y-3 text-sm sm:grid-cols-[9rem_minmax(0,1fr)]">
                          <dt className="text-avcs-muted">Event type</dt>
                          <dd className="font-semibold text-avcs-text">
                            {confirmEventTypeLabel}
                            {confirmPrimaryEntityType && (
                              <span className="ml-2 rounded bg-[#1e6bb814] px-1.5 py-0.5 align-middle text-[10px] font-semibold uppercase tracking-wide text-[#154f89]">
                                {confirmPrimaryEntityType}
                              </span>
                            )}
                          </dd>

                          <dt className="text-avcs-muted">Source entity</dt>
                          <dd className="text-avcs-text">
                            <span className="font-medium">{confirmSourceName}</span>
                            {confirmSourceType && (
                              <span className="ml-2 rounded bg-[#1e6bb814] px-1.5 py-0.5 align-middle text-[10px] font-semibold uppercase tracking-wide text-[#154f89]">
                                {confirmSourceType}
                              </span>
                            )}
                            <div className="font-mono text-xs text-avcs-muted">{confirmSourceGln ? `GLN ${confirmSourceGln}` : 'No GLN on file'}</div>
                          </dd>

                          <dt className="text-avcs-muted">Destination entity</dt>
                          <dd className="text-avcs-text">
                            <span className="font-medium">{confirmDestName}</span>
                            {confirmDestType && (
                              <span className="ml-2 rounded bg-[#1e6bb814] px-1.5 py-0.5 align-middle text-[10px] font-semibold uppercase tracking-wide text-[#154f89]">
                                {confirmDestType}
                              </span>
                            )}
                            <div className="font-mono text-xs text-avcs-muted">{confirmDestGln ? `GLN ${confirmDestGln}` : 'No GLN on file'}</div>
                          </dd>

                          <dt className="text-avcs-muted">Uploaded file</dt>
                          <dd className="font-mono text-xs text-avcs-text break-all">{confirmFileName}</dd>
                        </dl>

                        {dataSessionError && (
                          <p className="rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{dataSessionError}</p>
                        )}
                      </div>

                      <div className="flex flex-wrap justify-end gap-2 border-t border-[#1e6bb824] px-5 py-3">
                        <button
                          type="button"
                          className="btn admin-inline-action"
                          disabled={confirmingDraft}
                          onClick={() => setShowCreateEventConfirm(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn admin-submit-action"
                          disabled={confirmingDraft}
                          onClick={doConfirmDraft}
                        >
                          {confirmingDraft ? 'Creating…' : 'Create event'}
                        </button>
                      </div>
                    </div>
                  </section>
                )}
              </div>
            )}
          </div>
        )}

        {/* The upload outcome (counts, quality, unmatched rows, wool session)
            now renders in the dismissable panel at the top of this screen. */}

        {/* Audit trail — shown after a successful upload */}
        {uploadAuditEvents.length > 0 && (() => {
          const EVENT_TYPE_LABELS: Record<string, string> = {
            FARM_DIS: 'Farm dispatch',
            FARM_REC: 'Farm receive',
            FEED_DIS: 'Feedlot dispatch',
            FEED_REC: 'Feedlot receive',
            ABAT_REC: 'Abattoir receive',
            FARM_BIR: 'Farm birth',
            FARM_REG: 'Farm registration',
            FEED_REG: 'Feedlot registration',
            ABAT_REG: 'Abattoir registration',
            FARM_SHE: 'Farm shear',
            FEED_SHE: 'Feedlot shear',
            FARM_MOR: 'Farm mortality',
            FEED_MOR: 'Feedlot mortality',
            ABAT_MOR: 'Abattoir mortality',
            FARM_WEI: 'Farm weigh',
            FEED_WEI: 'Feedlot weigh',
            ABAT_SLA: 'Abattoir slaughter',
            FEED_WOO: 'Wool batch',
            FARM_BAL: 'Farm bale',
            FEED_BAL: 'Feedlot bale',
            VACCINATION: 'Vaccination',
            WOOL_ANA: 'Wool analysis',
          };
          const RMIS_BADGE: Record<string, { label: string; cls: string }> = {
            SENT:    { label: 'Synced', cls: 'bg-[#e7f8ee] text-[#106b38] border-[#b9e7c9]' },
            FAILED:  { label: 'Failed', cls: 'bg-[#f8eae7] text-[#6b1010] border-[#e7bbb9]' },
            SKIPPED: { label: 'Skipped', cls: 'bg-[#fff7ef] text-[#7b4a18] border-[#ecd1b9]' },
            PENDING: { label: 'Pending', cls: 'bg-[#e8f4ff] text-[#0f3b64] border-[#1e6bb833]' },
          };
          return (
            <div className="rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
              <h3 className="text-base font-semibold text-avcs-text">Audit trail</h3>
              <p className="mt-1 text-xs text-avcs-muted">All movement events for this deal. RMIS sync status is shown where the Primary Producer is a party to the movement.</p>
              <div className="admin-table-scroll mt-3 overflow-x-auto">
                <table className="min-w-full border-collapse text-sm">
                  <thead>
                    <tr>
                      <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Event</th>
                      <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Type</th>
                      <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">From → To</th>
                      <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Date</th>
                      <th className="border-b border-[#1e6bb824] px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">Animals</th>
                      <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">RMIS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {uploadAuditEvents.map((evt: any) => {
                      const feedRec = uploadAuditEvents.find((e: any) => e.event_type === 'FEED_REC');
                      const rmis = evt.event_type === 'FARM_DIS' ? (feedRec?.rmis ?? null) : evt.event_type !== 'FEED_REC' ? evt.rmis : null;
                      const badge = rmis?.status ? RMIS_BADGE[rmis.status] : null;
                      const from = evt.source_entity_name || '—';
                      const to = evt.destination_entity_name || '—';
                      const date = evt.event_date ? String(evt.event_date).split('T')[0] : fmtDate(evt.created_at);
                      return (
                        <tr key={evt.id}>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-xs text-avcs-muted">#{evt.id}</td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-avcs-text">
                            {EVENT_TYPE_LABELS[evt.event_type] || evt.event_type || '—'}
                          </td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-avcs-text">
                            {from === '—' && to === '—' ? '—' : `${from} → ${to}`}
                          </td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-avcs-muted">{date || '—'}</td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2 text-right text-avcs-text">
                            {evt.animal_count != null ? fmtNum(Number(evt.animal_count)) : '—'}
                          </td>
                          <td className="border-b border-[#1e6bb814] px-3 py-2">
                            {!rmis ? (
                              <span className="text-xs text-avcs-muted">N/A</span>
                            ) : badge ? (
                              <div>
                                <span className={`inline-flex rounded-full border px-2 py-0.5 text-xs font-semibold ${badge.cls}`}>
                                  {badge.label}
                                </span>
                                {rmis.last_attempt_at && (
                                  <div className="mt-0.5 text-xs text-avcs-muted">{String(rmis.last_attempt_at).split('T')[0]}</div>
                                )}
                              </div>
                            ) : (
                              <span className="text-xs text-avcs-muted">—</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })()}

      </section>
    );
  };

  /**
   * Open the rows behind an event, or behind one specific revision of it.
   *
   * Defaults to the CURRENT revision. `evt.data_session` is the revision root
   * and is never re-pointed, so reading it showed revision 1's rows under a
   * heading that claimed to be the event's data.
   */
  const openEventRawData = async (evt: any, revisionSessionId?: string) => {
    const sessionId = revisionSessionId || eventCurrentSessionId(evt);
    if (!sessionId) return;
    setEventRawDataEvent(evt);  // kept so the modal can re-fetch after a link
    const eventLabel = EVENT_TYPE_LABELS[evt.event_type || ''] || evt.event_type || 'Event';
    const revisions: any[] = Array.isArray(evt?.revisions) ? evt.revisions : [];
    const shown = revisions.find((r) => String(r.data_session) === String(sessionId));
    const isCurrent = shown ? Boolean(shown.is_current) : true;
    // Only the current revision's stored file is on the event.
    const fileUrl = isCurrent ? (normalizeDocumentUrl(evt.source_file) || undefined) : undefined;
    const revision = revisions.length > 1
      ? {
        number: shown?.revision_number ?? evt?.revision_number ?? 1,
        count: evt?.revision_count ?? revisions.length,
        isCurrent,
        uploadedAt: shown?.uploaded_at ?? null,
      }
      : null;
    setEventRawData({
      loading: true,
      error: '',
      filename: shown?.original_filename || evt.source_filename || '',
      fileUrl,
      eventLabel,
      session: null,
      rows: [],
      count: 0,
      limit: 0,
      revision,
    });
    try {
      const data = await fetchSessionRawRows(String(sessionId));
      setEventRawData({
        loading: false,
        error: '',
        filename: data.session?.original_filename || evt.source_filename || '',
        fileUrl,
        eventLabel,
        session: data.session,
        rows: data.results,
        count: data.count,
        limit: data.limit,
        revision,
      });
    } catch (error: any) {
      setEventRawData((prev) =>
        prev
          ? { ...prev, loading: false, error: parseApiError(error?.message) || error?.message || 'Could not load raw data.' }
          : prev,
      );
    }
  };

  const renderEventHistory = () => {
    const query = eventHistorySearch.trim().toLowerCase();
    const filteredRows = eventHistoryRows.filter((evt: any) => {
      const deal = evt.deal as Deal | undefined;
      const fields = [
        evt.id,
        EVENT_TYPE_LABELS[evt.event_type] || evt.event_type,
        deal?.title,
        deal?.dealRefNo,
        deal?.counterpart,
        evt.source_entity_name,
        evt.destination_entity_name,
        evt.event_date,
        evt.created_at,
        evt.animal_count,
        evt.species,
        evt.rmis?.status,
        evt.virtual_routez?.latest_call?.status,
        evt.virtual_routez?.payload_status,
        evt.source_filename,
        evt.data_quality_grade,
        evt.created_by?.full_name,
        evt.created_by?.username,
      ];
      return fields.some((value) => String(value ?? '').toLowerCase().includes(query));
    });

    const EVENT_HISTORY_PAGE_SIZE = 10;
    const totalEventPages = Math.max(1, Math.ceil(filteredRows.length / EVENT_HISTORY_PAGE_SIZE));
    const currentEventPage = Math.min(eventHistoryPage, totalEventPages);
    const pagedRows = filteredRows.slice(
      (currentEventPage - 1) * EVENT_HISTORY_PAGE_SIZE,
      currentEventPage * EVENT_HISTORY_PAGE_SIZE
    );

    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5 flex flex-col gap-4 min-w-0">
        <div className="admin-section-head flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">Event history</h2>
            <p className="text-sm text-avcs-muted">Events are shown newest first across all loaded deals.</p>
          </div>
          <div className="flex flex-wrap gap-2">
            <button className="btn whitespace-nowrap" onClick={openAddEventForm}>+ Add receive event</button>
            <button className="btn primary whitespace-nowrap" onClick={() => setView('dataSessionUpload')}>New event</button>
          </div>
        </div>

        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <label className="grid gap-1 text-sm text-avcs-text md:min-w-80">
            Search events
            <input
              className="rounded-lg border border-[#1e6bb833] px-3 py-2"
              placeholder="Search deal, event, entity, status..."
              value={eventHistorySearch}
              onChange={(event) => { setEventHistorySearch(event.target.value); setEventHistoryPage(1); }}
            />
          </label>
          <div className="text-sm text-avcs-muted">
            {loadingEventHistory ? 'Loading events...' : `${fmtNum(filteredRows.length)} of ${fmtNum(eventHistoryRows.length)} events`}
          </div>
        </div>

        {eventHistoryError && <div className="text-sm text-[#6b1010]">{eventHistoryError}</div>}
        {eventActionError && <div className="rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{eventActionError}</div>}
        {eventActionSuccess && <div className="rounded-lg border border-[#b9e7c9] bg-[#e7f8ee] px-3 py-2 text-sm text-[#106b38]">{eventActionSuccess}</div>}

        {showAddEventForm && (
          <div className="rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
            <div className="mb-3 flex items-center justify-between gap-2">
              <h3 className="text-base font-semibold text-avcs-text">Add receive event</h3>
              <button className="admin-inline-action btn" type="button" onClick={cancelAddEvent}>Cancel</button>
            </div>
            <p className="mb-3 text-xs text-avcs-muted">
              Adds a missing receive event to a deal — e.g. an abattoir-receive for animals that were only captured at slaughter — so a transport journey has an event to link to. No animal records or statuses change.
            </p>
            <div className="grid gap-3 md:grid-cols-2">
              <label className="grid gap-1 text-sm text-avcs-text">
                Deal (required)
                <select
                  className="rounded-lg border border-[#1e6bb833] px-3 py-2 bg-white"
                  value={addEventForm.dealId}
                  onChange={(e) => setAddEventForm((f) => ({ ...f, dealId: e.target.value }))}
                >
                  <option value="">Select deal…</option>
                  {deals.map((d) => (
                    <option key={d.dealId} value={d.dealId}>{[d.title, d.counterpart].filter(Boolean).join(' — ')}</option>
                  ))}
                </select>
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Event type (required)
                <select
                  className="rounded-lg border border-[#1e6bb833] px-3 py-2 bg-white"
                  value={addEventForm.eventTypeCode}
                  onChange={(e) => setAddEventForm((f) => ({ ...f, eventTypeCode: e.target.value }))}
                >
                  <option value="ABAT_REC">{EVENT_TYPE_LABELS.ABAT_REC}</option>
                  <option value="FEED_REC">{EVENT_TYPE_LABELS.FEED_REC}</option>
                  <option value="FARM_REC">{EVENT_TYPE_LABELS.FARM_REC}</option>
                </select>
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Event date
                <input
                  type="date"
                  className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                  value={addEventForm.eventDate}
                  onChange={(e) => setAddEventForm((f) => ({ ...f, eventDate: e.target.value }))}
                />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Animal count
                <input
                  type="number"
                  min={0}
                  className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                  value={addEventForm.animalCount}
                  onChange={(e) => setAddEventForm((f) => ({ ...f, animalCount: e.target.value }))}
                />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Species (required)
                <select
                  className="rounded-lg border border-[#1e6bb833] px-3 py-2 bg-white"
                  value={addEventForm.species}
                  onChange={(e) => setAddEventForm((f) => ({ ...f, species: e.target.value }))}
                >
                  <option value="">—</option>
                  <option value="SHEEP">Sheep</option>
                  <option value="CATTLE">Cattle</option>
                  <option value="GOAT">Goat</option>
                </select>
              </label>
              <EntityCombobox
                label="Source entity (e.g. feedlot)"
                selectedUnit={addEventSourceUnit}
                searchValue={addEventSourceSearch}
                results={addEventSourceSearch.trim()
                  ? entityDirectory.filter((e) => e.entityName?.toLowerCase().includes(addEventSourceSearch.toLowerCase())).slice(0, 20)
                  : []}
                showDropdown={showAddEventSourceDropdown}
                onSearchChange={(v) => { setAddEventSourceSearch(v); setShowAddEventSourceDropdown(true); }}
                onFocus={() => setShowAddEventSourceDropdown(true)}
                onBlur={() => setTimeout(() => setShowAddEventSourceDropdown(false), 150)}
                onSelect={(unit) => {
                  setAddEventForm((f) => ({ ...f, sourceEntityId: unit.id || '' }));
                  setAddEventSourceUnit(unit);
                  setAddEventSourceSearch('');
                  setShowAddEventSourceDropdown(false);
                }}
                onClear={() => {
                  setAddEventForm((f) => ({ ...f, sourceEntityId: '' }));
                  setAddEventSourceUnit(null);
                  setAddEventSourceSearch('');
                }}
              />
              <EntityCombobox
                label="Destination entity (e.g. abattoir)"
                selectedUnit={addEventDestUnit}
                searchValue={addEventDestSearch}
                results={addEventDestSearch.trim()
                  ? entityDirectory.filter((e) => e.entityName?.toLowerCase().includes(addEventDestSearch.toLowerCase())).slice(0, 20)
                  : []}
                showDropdown={showAddEventDestDropdown}
                onSearchChange={(v) => { setAddEventDestSearch(v); setShowAddEventDestDropdown(true); }}
                onFocus={() => setShowAddEventDestDropdown(true)}
                onBlur={() => setTimeout(() => setShowAddEventDestDropdown(false), 150)}
                onSelect={(unit) => {
                  setAddEventForm((f) => ({ ...f, destinationEntityId: unit.id || '' }));
                  setAddEventDestUnit(unit);
                  setAddEventDestSearch('');
                  setShowAddEventDestDropdown(false);
                }}
                onClear={() => {
                  setAddEventForm((f) => ({ ...f, destinationEntityId: '' }));
                  setAddEventDestUnit(null);
                  setAddEventDestSearch('');
                }}
              />
            </div>
            <div className="mt-3 flex gap-2">
              <button className="btn admin-submit-action" type="button" disabled={savingAddEvent} onClick={submitAddEvent}>
                {savingAddEvent ? 'Adding…' : 'Add event'}
              </button>
            </div>
          </div>
        )}

        {editingEventId && (
          <div className="rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-4">
            <div className="mb-3 flex items-center justify-between gap-2">
              <h3 className="text-base font-semibold text-avcs-text">Edit event #{editingEventId}</h3>
              <button className="admin-inline-action btn" type="button" onClick={cancelEditEvent}>Cancel</button>
            </div>
            <div className="grid gap-3 md:grid-cols-2">
              <label className="grid gap-1 text-sm text-avcs-text">
                Event date
                <input
                  type="date"
                  className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                  value={eventEditForm.eventDate}
                  onChange={(e) => setEventEditForm((f) => ({ ...f, eventDate: e.target.value }))}
                />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Animal count
                <input
                  type="number"
                  min={0}
                  className="rounded-lg border border-[#1e6bb833] px-3 py-2"
                  value={eventEditForm.animalCount}
                  onChange={(e) => setEventEditForm((f) => ({ ...f, animalCount: e.target.value }))}
                />
              </label>
              <label className="grid gap-1 text-sm text-avcs-text">
                Species
                <select
                  className="rounded-lg border border-[#1e6bb833] px-3 py-2 bg-white"
                  value={eventEditForm.species}
                  onChange={(e) => setEventEditForm((f) => ({ ...f, species: e.target.value }))}
                >
                  <option value="">—</option>
                  <option value="SHEEP">Sheep</option>
                  <option value="CATTLE">Cattle</option>
                  <option value="GOAT">Goat</option>
                </select>
              </label>
              <EntityCombobox
                label="Source entity"
                selectedUnit={eventEditSourceUnit}
                searchValue={eventEditSourceSearch}
                results={eventEditSourceSearch.trim()
                  ? entityDirectory.filter((e) => e.entityName?.toLowerCase().includes(eventEditSourceSearch.toLowerCase())).slice(0, 20)
                  : []}
                showDropdown={showEventEditSourceDropdown}
                onSearchChange={(v) => { setEventEditSourceSearch(v); setShowEventEditSourceDropdown(true); }}
                onFocus={() => setShowEventEditSourceDropdown(true)}
                onBlur={() => setTimeout(() => setShowEventEditSourceDropdown(false), 150)}
                onSelect={(unit) => {
                  setEventEditForm((f) => ({ ...f, sourceEntityId: unit.id || '' }));
                  setEventEditSourceUnit(unit);
                  setEventEditSourceSearch('');
                  setShowEventEditSourceDropdown(false);
                }}
                onClear={() => {
                  setEventEditForm((f) => ({ ...f, sourceEntityId: '' }));
                  setEventEditSourceUnit(null);
                  setEventEditSourceSearch('');
                }}
              />
              <EntityCombobox
                label="Destination entity"
                selectedUnit={eventEditDestUnit}
                searchValue={eventEditDestSearch}
                results={eventEditDestSearch.trim()
                  ? entityDirectory.filter((e) => e.entityName?.toLowerCase().includes(eventEditDestSearch.toLowerCase())).slice(0, 20)
                  : []}
                showDropdown={showEventEditDestDropdown}
                onSearchChange={(v) => { setEventEditDestSearch(v); setShowEventEditDestDropdown(true); }}
                onFocus={() => setShowEventEditDestDropdown(true)}
                onBlur={() => setTimeout(() => setShowEventEditDestDropdown(false), 150)}
                onSelect={(unit) => {
                  setEventEditForm((f) => ({ ...f, destinationEntityId: unit.id || '' }));
                  setEventEditDestUnit(unit);
                  setEventEditDestSearch('');
                  setShowEventEditDestDropdown(false);
                }}
                onClear={() => {
                  setEventEditForm((f) => ({ ...f, destinationEntityId: '' }));
                  setEventEditDestUnit(null);
                  setEventEditDestSearch('');
                }}
              />
            </div>
            <div className="mt-3 flex gap-2">
              <button className="btn admin-submit-action" type="button" disabled={savingEventEdit} onClick={saveEventEdit}>
                {savingEventEdit ? 'Saving…' : 'Save changes'}
              </button>
            </div>
          </div>
        )}

        <div className="admin-table-shell admin-table-scroll event-history-table-scroll overflow-x-auto">
          <table className="min-w-full border-collapse">
            <thead>
              <tr>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Event Date</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Event</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Destination</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">Animals</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">RMIS</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Virtual Routez</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Quality</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">File</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Created</th>
                <th className="border-b border-[#1e6bb824] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Actions</th>
              </tr>
            </thead>
            <tbody>
              {pagedRows.map((evt: any) => {
                const deal = evt.deal as Deal | undefined;
                const rmis = evt.rmis;
                const badge = rmis?.status ? RMIS_BADGE[rmis.status] : null;
                const virtualRoutez = evt.virtual_routez;
                const virtualRoutezBadge = virtualRoutez?.latest_call?.status ? VIRTUAL_ROUTEZ_BADGE[virtualRoutez.latest_call.status] : null;
                const to = evt.destination_entity_name || '—';
                const createdByName = evt.created_by?.full_name || evt.created_by?.username || null;
                return (
                  <tr key={`${deal?.dealId || 'deal'}-${evt.id}`}>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">{fmtDate(evt.event_date)}</td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                      <div className="font-medium">
                        {EVENT_TYPE_LABELS[evt.event_type] || evt.event_type || '—'}
                        {DATA_SESSION_REGISTRATION_EVENT_TYPES.includes(evt.event_type) && deal?.title && (
                          <span className="font-normal text-avcs-muted"> ({deal.title})</span>
                        )}
                      </div>
                      <div className="text-xs text-avcs-muted">#{evt.id || '—'}</div>
                      {evt.vaccination_detail && (
                        <div className="mt-1 rounded-md bg-[#f3f7fb] px-2 py-1 text-xs text-avcs-text">
                          <div className="font-semibold">
                            {evt.vaccination_detail.medicine?.name || evt.vaccination_detail.vaccination_type_display || 'Vaccination'}
                          </div>
                          <div className="text-avcs-muted">
                            {[
                              evt.vaccination_detail.batch_number && `Batch ${evt.vaccination_detail.batch_number}`,
                              evt.vaccination_detail.dosage && `Dose ${evt.vaccination_detail.dosage}`,
                              evt.vaccination_detail.total_cost != null && `R ${evt.vaccination_detail.total_cost}`,
                            ].filter(Boolean).join(' · ') || '—'}
                          </div>
                          {evt.vaccination_detail.withholding_end_date && (
                            <div className="text-avcs-muted">WHP until {fmtDate(evt.vaccination_detail.withholding_end_date)}</div>
                          )}
                        </div>
                      )}
                    </td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                      <div>{to}</div>
                      {evt.destination_gln && (
                        <div className="text-xs text-avcs-muted">GLN {evt.destination_gln}</div>
                      )}
                    </td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-right text-sm text-avcs-text">
                      {evt.animal_count != null ? fmtNum(Number(evt.animal_count)) : '—'}
                      {evt.species && (
                        <div className="text-xs font-normal capitalize text-avcs-muted">{String(evt.species).toLowerCase()}</div>
                      )}
                    </td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm">
                      {!rmis ? (
                        <span className="text-xs text-avcs-muted">N/A</span>
                      ) : badge ? (
                        <div>
                          <span className={`inline-flex rounded-full border px-2 py-0.5 text-xs font-semibold ${badge.cls}`}>
                            {badge.label}
                          </span>
                          {rmis.last_attempt_at && (
                            <div className="mt-0.5 text-xs text-avcs-muted">{String(rmis.last_attempt_at).split('T')[0]}</div>
                          )}
                        </div>
                      ) : (
                        <span className="text-xs text-avcs-muted">{rmis.status || '—'}</span>
                      )}
                    </td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm">
                      {!virtualRoutez ? (
                        <span className="text-xs text-avcs-muted">N/A</span>
                      ) : virtualRoutezBadge ? (
                        <div>
                          <span className={`inline-flex rounded-full border px-2 py-0.5 text-xs font-semibold ${virtualRoutezBadge.cls}`}>
                            {virtualRoutezBadge.label}
                          </span>
                          {virtualRoutez.latest_call?.response_timestamp && (
                            <div className="mt-0.5 text-xs text-avcs-muted">{String(virtualRoutez.latest_call.response_timestamp).split('T')[0]}</div>
                          )}
                        </div>
                      ) : (
                        <span className="text-xs text-avcs-muted">{virtualRoutez.payload_status || '—'}</span>
                      )}
                    </td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm">
                      {evt.data_quality_grade ? (
                        <div>
                          <span
                            className={`inline-flex rounded-full border px-2 py-0.5 text-xs font-semibold ${DATA_QUALITY_BADGE[evt.data_quality_grade]?.cls || ''}`}
                            title={`Data quality score: ${evt.data_quality_score ?? '—'}/100`}
                          >
                            {DATA_QUALITY_BADGE[evt.data_quality_grade]?.label || evt.data_quality_grade}
                          </span>
                          <div className="mt-0.5 text-xs text-avcs-muted">{evt.data_quality_score ?? '—'}/100</div>
                        </div>
                      ) : (
                        <span className="text-xs text-avcs-muted">N/A</span>
                      )}
                    </td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-text">
                      {evt.source_file ? (
                        <a href={evt.source_file} target="_blank" rel="noopener noreferrer" className="text-[#1e6bb8] underline">
                          {evt.source_filename || 'View file'}
                        </a>
                      ) : '—'}
                    </td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2 text-sm text-avcs-muted">
                      {fmtDate(evt.created_at)}
                      {createdByName && <div className="text-xs">by {createdByName}</div>}
                    </td>
                    <td className="border-b border-[#1e6bb814] px-3 py-2">
                      <div className="flex gap-2">
                        <button className="btn" type="button" onClick={() => startEditEvent(evt)}>Edit</button>
                        {evt.data_session && (
                          <button
                            className="btn"
                            type="button"
                            onClick={() => openEventRawData(evt)}
                            title="View all raw uploaded rows from the file this event came from"
                          >
                            View raw data
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
              {!loadingEventHistory && filteredRows.length === 0 && (
                <tr>
                  <td className="px-3 py-6 text-center text-sm text-avcs-muted" colSpan={10}>
                    {eventHistorySearch.trim() ? 'No events match your search.' : 'No events found yet.'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {filteredRows.length > 0 && (
          <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
            <div className="text-sm text-avcs-muted">Page {currentEventPage} of {totalEventPages}</div>
            <div className="flex gap-2">
              <button
                className="btn"
                type="button"
                disabled={currentEventPage <= 1}
                onClick={() => setEventHistoryPage((p) => Math.max(1, p - 1))}
              >
                Previous
              </button>
              <button
                className="btn"
                type="button"
                disabled={currentEventPage >= totalEventPages}
                onClick={() => setEventHistoryPage((p) => Math.min(totalEventPages, p + 1))}
              >
                Next
              </button>
            </div>
          </div>
        )}

        {eventRawData && (
          <RawDataModal
            state={eventRawData}
            onClose={() => { setEventRawData(null); setEventRawDataEvent(null); }}
            onReload={() => eventRawDataEvent && openEventRawData(eventRawDataEvent)}
          />
        )}
      </section>
    );
  };

  // Hoisted out of renderUnprocessedRecords so the upload screen can send the
  // user straight into reconciliation with the list already loaded.
  const loadUnprocessed = async (dealId: string) => {
    if (!dealId) return;
    setLoadingUnprocessedAdmin(true);
    try {
      const rows = await fetchUnprocessedRecords(dealId);
      setUnprocessedAdminRows(rows);
    } catch {
      setUnprocessedAdminRows([]);
    } finally {
      setLoadingUnprocessedAdmin(false);
    }
  };

  /** Jump from anywhere into the deal's unmatched-row queue, pre-loaded. */
  const openReconcileQueue = (dealId: string) => {
    if (!dealId) return;
    setUnprocessedDealId(dealId);
    setUnprocessedAdminRows([]);
    loadUnprocessed(dealId);
    setView('unprocessedRecords');
  };

  const renderUnprocessedRecords = () => {

    const printUnprocessed = () => {
      const currentDeal = deals.find((d) => d.dealId === unprocessedDealId);
      const rows = unprocessedAdminRows.map((row: any, idx: number) => `
        <tr>
          <td>${row.row_number ?? idx + 1}</td>
          <td>${row.eid || '—'}</td>
          <td>${row.vid || '—'}</td>
          <td>${row.deal_link_status || '—'}</td>
          <td>${row.original_filename || row.session_id || '—'}</td>
          <td>${Array.isArray(row.processing_errors) ? row.processing_errors.join('; ') : (row.processing_errors || '—')}</td>
        </tr>`).join('');
      const html = `<!DOCTYPE html><html><head>
        <title>Unprocessed Records${currentDeal ? ' — ' + currentDeal.title : ''}</title>
        <style>
          body { font-family: sans-serif; font-size: 13px; padding: 20px; }
          h2 { margin-bottom: 4px; } p { margin: 0 0 16px; color: #666; }
          table { width: 100%; border-collapse: collapse; }
          th { background: #f0f7ff; text-align: left; padding: 8px 12px; font-size: 11px; text-transform: uppercase; letter-spacing: .05em; border-bottom: 2px solid #cde; }
          td { padding: 8px 12px; border-bottom: 1px solid #e8f0f8; }
          @media print { body { padding: 0; } }
        </style>
      </head><body>
        <h2>Unprocessed Records</h2>
        ${currentDeal ? '<p>Deal: ' + currentDeal.title + '</p>' : ''}
        <table>
          <thead><tr><th>Row #</th><th>EID</th><th>VID</th><th>Deal link status</th><th>Session</th><th>Errors</th></tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </body></html>`;
      const iframe = document.createElement('iframe');
      iframe.style.cssText = 'position:fixed;width:0;height:0;border:0;visibility:hidden;';
      document.body.appendChild(iframe);
      const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
      if (!iframeDoc) { document.body.removeChild(iframe); return; }
      iframeDoc.open();
      iframeDoc.write(html);
      iframeDoc.close();
      iframe.onload = () => {
        iframe.contentWindow?.print();
        setTimeout(() => document.body.removeChild(iframe), 1000);
      };
    };

    return (
      <section className="flex flex-col gap-5 rounded-2xl border border-[#1e6bb824] bg-white p-5">
        <div>
          <h2 className="text-xl font-bold text-avcs-text">Unprocessed Records</h2>
          <p className="mt-1 text-sm text-avcs-muted">View raw data rows that have not yet been processed, by deal.</p>
        </div>

        {/* Deal selector */}
        <label className="grid max-w-sm gap-1 text-sm font-medium text-avcs-text">
          Deal
          <select
            className="rounded-lg border border-[#1e6bb833] px-3 py-2 text-sm text-avcs-text focus:border-[#1e6bb8] focus:outline-none"
            value={unprocessedDealId}
            onChange={(e) => {
              const id = e.target.value;
              setUnprocessedDealId(id);
              setUnprocessedAdminRows([]);
              if (id) loadUnprocessed(id);
            }}
          >
            <option value="">— select a deal —</option>
            {deals.map((d) => (
              <option key={d.dealId} value={d.dealId}>{d.title}</option>
            ))}
          </select>
        </label>

        {/* Action row */}
        {unprocessedDealId && (
          <div className="flex flex-wrap items-center gap-2">
            <button
              className="btn admin-inline-action"
              type="button"
              disabled={loadingUnprocessedAdmin}
              onClick={() => loadUnprocessed(unprocessedDealId)}
            >
              {loadingUnprocessedAdmin ? 'Loading…' : 'Refresh'}
            </button>
            <button
              className="btn admin-inline-action"
              type="button"
              disabled={unprocessedAdminRows.length === 0}
              onClick={printUnprocessed}
            >
              Print / Save PDF
            </button>
            <button
              className="btn admin-inline-action"
              type="button"
              disabled={relinkingSession || unprocessedAdminRows.length === 0}
              onClick={async () => {
                // Collect unique session UUIDs from the unprocessed rows
                const sessionIds = [...new Set(
                  unprocessedAdminRows
                    .map((r: any) => r.data_session_id)
                    .filter(Boolean)
                )] as string[];
                if (!sessionIds.length) return;
                setRelinkingSession(true);
                try {
                  for (const sid of sessionIds) {
                    await relinkDataSession(sid).catch(() => {});
                  }
                  await loadUnprocessed(unprocessedDealId);
                } finally {
                  setRelinkingSession(false);
                }
              }}
            >
              {relinkingSession ? 'Re-linking…' : 'Re-link animals to deal'}
            </button>
          </div>
        )}

        {/* Table */}
        {!unprocessedDealId ? (
          <p className="text-sm text-avcs-muted">Select a deal above to load its unprocessed records.</p>
        ) : loadingUnprocessedAdmin ? (
          <p className="text-sm text-avcs-muted">Loading…</p>
        ) : (
          <div className="admin-table-scroll">
            <table className="min-w-full text-sm">
              <thead className="border-b border-[#1e6bb824] bg-[#f8fbff]">
                <tr>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Row #</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">EID</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">VID</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Deal link status</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Session</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Errors</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">
                    <span className="sr-only">Actions</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#1e6bb812]">
                {unprocessedAdminRows.length === 0 ? (
                  <tr><td colSpan={7} className="px-4 py-4 text-center text-avcs-muted">No unprocessed records found for this deal.</td></tr>
                ) : (
                  unprocessedAdminRows.map((row: any, idx: number) => (
                    <tr key={row.id ?? idx} className="bg-white transition-colors hover:bg-[#deeeff]">
                      <td className="px-4 py-2 text-avcs-muted">{row.row_number ?? idx + 1}</td>
                      <td className="px-4 py-2 font-mono text-xs text-avcs-text">{row.eid || '—'}</td>
                      <td className="px-4 py-2 font-mono text-xs text-avcs-text">{row.vid || '—'}</td>
                      <td className="px-4 py-2">
                        {row.deal_link_status
                          ? <span className="inline-flex rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700">{row.deal_link_status}</span>
                          : <span className="text-avcs-muted">—</span>}
                      </td>
                      <td className="px-4 py-2 text-xs text-avcs-muted">{row.original_filename || row.session_id || '—'}</td>
                      <td className="px-4 py-2 text-xs text-avcs-muted">{Array.isArray(row.processing_errors) ? row.processing_errors.join('; ') : (row.processing_errors || '—')}</td>
                      <td className="px-4 py-2">
                        {/* Only a row carrying an EID can be assigned to an
                            un-tagged animal; without one there is nothing to link. */}
                        {row.eid && row.deal_link_status !== 'LINKED' ? (
                          <button
                            type="button"
                            className="rounded-md border border-[#1e6bb833] px-2 py-0.5 text-xs font-semibold text-[#1e6bb8] hover:bg-[#eef5ff]"
                            onClick={() => setLinkingUnprocessedRow(row)}
                          >
                            Link to animal
                          </button>
                        ) : null}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Reconcile one unprocessed row against an un-tagged animal. */}
        {linkingUnprocessedRow && (
          <div
            className="fixed inset-0 z-[120] flex items-center justify-center bg-[#0b223a66] px-4 py-8"
            onClick={() => setLinkingUnprocessedRow(null)}
          >
            <div
              className="flex max-h-full w-full max-w-3xl flex-col overflow-hidden rounded-2xl border border-[#1e6bb824] bg-white shadow-xl"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-start justify-between gap-3 border-b border-[#1e6bb824] px-4 py-3">
                <div className="min-w-0">
                  <h3 className="text-lg font-semibold text-avcs-text">Link EID to an animal</h3>
                  <p className="truncate text-sm text-avcs-muted">
                    Assign this row's scanned EID to an animal registered without one.
                  </p>
                </div>
                <button
                  type="button"
                  className="text-2xl leading-none text-avcs-muted hover:text-[#6b1010]"
                  onClick={() => setLinkingUnprocessedRow(null)}
                  aria-label="Close"
                >×</button>
              </div>
              <div className="overflow-auto p-4">
                <LinkEidPanel
                  row={linkingUnprocessedRow}
                  onCancel={() => setLinkingUnprocessedRow(null)}
                  onLinked={() => {
                    setLinkingUnprocessedRow(null);
                    if (unprocessedDealId) loadUnprocessed(unprocessedDealId);
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </section>
    );
  };

  const renderUnlinkedAnimals = () => {
    const loadUnlinked = async (opts?: { hasEid?: boolean; search?: string }) => {
      setLoadingUnlinkedAnimals(true);
      setUnlinkedAnimalsError(false);
      try {
        const r = await fetchUnlinkedAnimals({
          hasEid: opts?.hasEid ?? unlinkedOnlyWithEid,
          search: opts?.search ?? unlinkedSearch,
        });
        setUnlinkedAnimals(r.results);
      } catch {
        setUnlinkedAnimalsError(true);
        setUnlinkedAnimals([]);
      } finally {
        setLoadingUnlinkedAnimals(false);
      }
    };

    return (
      <section className="flex flex-col gap-5 rounded-2xl border border-[#1e6bb824] bg-white p-5">
        <div>
          <h2 className="text-xl font-bold text-avcs-text">Unlinked animals</h2>
          <p className="mt-1 text-sm text-avcs-muted">
            Animals not attached to any deal — usually bare stubs created when a
            non-registration file (e.g. a feedlot weigh-in) was uploaded for an
            animal that was never registered to a deal. Re-run the animal's
            registration, or attach it to a deal, to resolve it.
          </p>
        </div>

        {/* Controls */}
        <div className="flex flex-wrap items-center gap-3">
          <label className="flex items-center gap-2 text-sm font-medium text-avcs-text">
            <input
              type="checkbox"
              checked={unlinkedOnlyWithEid}
              onChange={(e) => {
                const next = e.target.checked;
                setUnlinkedOnlyWithEid(next);
                loadUnlinked({ hasEid: next });
              }}
            />
            Only animals with an EID
          </label>
          <input
            type="search"
            className="rounded-lg border border-[#1e6bb833] px-3 py-2 text-sm text-avcs-text focus:border-[#1e6bb8] focus:outline-none"
            placeholder="Search EID / VID / other ID"
            value={unlinkedSearch}
            onChange={(e) => setUnlinkedSearch(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') loadUnlinked(); }}
          />
          <button
            className="btn admin-inline-action"
            type="button"
            disabled={loadingUnlinkedAnimals}
            onClick={() => loadUnlinked()}
          >
            {loadingUnlinkedAnimals ? 'Loading…' : 'Search'}
          </button>
        </div>

        {/* Table */}
        {loadingUnlinkedAnimals ? (
          <p className="text-sm text-avcs-muted">Loading…</p>
        ) : unlinkedAnimalsError ? (
          <div className="flex items-center gap-3">
            <p className="text-sm text-red-600">Failed to load unlinked animals.</p>
            <button className="btn admin-inline-action" type="button" onClick={() => loadUnlinked()}>Retry</button>
          </div>
        ) : (
          <div className="admin-table-scroll">
            <table className="min-w-full text-sm">
              <thead className="border-b border-[#1e6bb824] bg-[#f8fbff]">
                <tr>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">EID</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">VID</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Species</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Current location</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">GLN</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Status</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Last updated</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#1e6bb812]">
                {unlinkedAnimals.length === 0 ? (
                  <tr><td colSpan={7} className="px-4 py-4 text-center text-avcs-muted">No unlinked animals found.</td></tr>
                ) : (
                  unlinkedAnimals.map((row: any, idx: number) => (
                    <tr key={row.id ?? idx} className="bg-white transition-colors hover:bg-[#deeeff]">
                      <td className="px-4 py-2 font-mono text-xs text-avcs-text">
                        {row.eid
                          ? (row.id != null
                              ? (
                                <button
                                  type="button"
                                  onClick={() => openAnimalDetail(String(row.id))}
                                  className="text-avcs-primary underline decoration-dotted underline-offset-2 hover:decoration-solid"
                                  title="View animal detail"
                                >{row.eid}</button>
                              )
                              : row.eid)
                          : '—'}
                      </td>
                      <td className="px-4 py-2 font-mono text-xs text-avcs-text">{row.vid || '—'}</td>
                      <td className="px-4 py-2 text-avcs-text">{row.species || '—'}</td>
                      <td className="px-4 py-2 text-avcs-muted">{row.current_entity || '—'}</td>
                      <td className="px-4 py-2 font-mono text-xs text-avcs-muted">{row.current_gln || '—'}</td>
                      <td className="px-4 py-2 text-avcs-muted">{row.status || '—'}</td>
                      <td className="px-4 py-2 text-xs text-avcs-muted">{row.updated_at ? new Date(row.updated_at).toLocaleDateString() : '—'}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            {unlinkedAnimals.length > 0 && (
              <p className="mt-2 text-xs text-avcs-muted">{unlinkedAnimals.length} animal(s).</p>
            )}
          </div>
        )}
      </section>
    );
  };

  const renderCostReports = () => {
    const isLoading = loadingCostReports || loadingDealAdminReport;

    const loadReport = async (overrideDealId?: string) => {
      const dealId = (overrideDealId !== undefined ? overrideDealId : costReportsDealId) || undefined;
      setLoadingCostReports(true);
      setLoadingDealAdminReport(true);
      setDealAdminReport(null);
      setCostReports([]);
      try {
        const [rows, report] = await Promise.allSettled([
          fetchDealCostReports(dealId ? { dealId } : undefined),
          dealId ? fetchDealAdminReport(dealId) : Promise.resolve(null),
        ]);
        setCostReports(rows.status === 'fulfilled' ? rows.value : []);
        if (report.status === 'fulfilled') setDealAdminReport(report.value);
        else setDealAdminReport({ error: (report.reason as any)?.message || 'Failed to load report.' });
      } finally {
        setLoadingCostReports(false);
        setLoadingDealAdminReport(false);
      }
    };

    const SOURCE_LABELS: Record<string, string> = {
      deal_finance_expenses: 'Deal finance expenses',
      animal_purchase_cost: 'Animal purchase',
      animal_data_processing_cost: 'Data processing',
      eid_tag_cost: 'EID tag',
      feed_consumption_cost: 'Feed consumption',
      feedlot_finance_cost: 'Feedlot finance',
      feedlot_daily_cost_estimate: 'Feedlot daily cost (est.)',
      vaccination_cost: 'Vaccination',
      deal_vaccination_cost: 'Deal vaccination',
      shearing_cost: 'Shearing',
      equipment_cost: 'Equipment',
      transport_cost: 'Transport',
    };

    const c = dealAdminReport?.costs ?? {};
    const sources = c.sources ?? {};
    const sourcesActive = Object.entries(sources)
      .filter(([, v]) => v != null && Number(v) > 0)
      .sort(([, a], [, b]) => Number(b) - Number(a)) as [string, number][];
    const totalFromSources = sourcesActive.reduce((s, [, v]) => s + Number(v), 0);
    const allSpeciesBlank = costReports.every((r: any) => !r.species);

    return (
      <section className="flex flex-col gap-6 rounded-2xl border border-[#1e6bb824] bg-white p-6">
        {/* Header */}
        <div>
          <h2 className="text-xl font-bold text-avcs-text">Cost Reports</h2>
          <p className="mt-1 text-sm text-avcs-muted">Animal and deal cost summaries</p>
        </div>

        {/* Controls */}
        <div className="flex flex-wrap items-end gap-3">
          <label className="grid gap-1 text-sm font-medium text-avcs-text">
            Filter by deal
            <select
              className="rounded-lg border border-[#1e6bb833] px-3 py-2 text-sm text-avcs-text focus:border-[#1e6bb8] focus:outline-none min-w-[220px]"
              value={costReportsDealId}
              onChange={(e) => {
                const newValue = e.target.value;
                setCostReportsDealId(newValue);
                setCostReports([]);
                setDealAdminReport(null);
                loadReport(newValue);
              }}
            >
              <option value="">— all deals —</option>
              {deals.map((d) => (
                <option key={d.dealId} value={d.dealId}>{d.title}</option>
              ))}
            </select>
          </label>
        </div>

        {/* Empty prompt */}
        {!isLoading && costReports.length === 0 && !dealAdminReport && (
          <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-[#1e6bb830] py-14 text-center">
            <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-[#eff6ff]">
              <svg className="h-5 w-5 text-[#1e6bb8]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <p className="text-sm font-medium text-avcs-text">No report loaded</p>
            <p className="mt-1 text-xs text-avcs-muted">Select a deal above to view cost data.</p>
          </div>
        )}

        {/* Loading state */}
        {isLoading && (
          <div className="flex items-center gap-2 py-2 text-sm text-avcs-muted">
            <svg className="h-4 w-4 animate-spin text-[#1e6bb8]" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
            </svg>
            Loading report…
          </div>
        )}

        {/* Admin report error */}
        {!isLoading && dealAdminReport?.error && (
          <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700">{dealAdminReport.error}</div>
        )}

        {/* Summary tiles */}
        {!isLoading && dealAdminReport && !dealAdminReport.error && (
          <div className="grid gap-4">
            <div className="grid gap-3 sm:grid-cols-2">
              {/* Total costs tile */}
              <div className="rounded-xl border border-[#1e6bb820] bg-[#eff6ff] p-5">
                <div className="text-xs font-semibold uppercase tracking-wide text-[#1e6bb8]">Total costs</div>
                <div className="mt-2 text-3xl font-bold tracking-tight text-avcs-text">
                  {c.total_cost != null ? `R ${Number(c.total_cost).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '—'}
                </div>
                {c.animal_count != null && (
                  <div className="mt-1.5 text-xs text-avcs-muted">{Number(c.animal_count).toLocaleString()} animal{c.animal_count !== 1 ? 's' : ''}</div>
                )}
              </div>
              {/* Cost / animal tile */}
              <div className="rounded-xl border border-[#d1fae520] bg-[#f0fdf4] p-5">
                <div className="text-xs font-semibold uppercase tracking-wide text-[#16a34a]">Cost / animal</div>
                <div className="mt-2 text-3xl font-bold tracking-tight text-avcs-text">
                  {c.per_animal_cost != null ? `R ${Number(c.per_animal_cost).toFixed(2)}` : '—'}
                </div>
                {c.total_cost != null && c.animal_count != null && (
                  <div className="mt-1.5 text-xs text-avcs-muted">across {sourcesActive.length} cost categor{sourcesActive.length !== 1 ? 'ies' : 'y'}</div>
                )}
              </div>
            </div>

            {/* Cost breakdown with proportion bars */}
            {sourcesActive.length > 0 && (
              <div className="rounded-xl border border-[#1e6bb824] bg-white p-5">
                <h3 className="mb-4 text-sm font-semibold text-avcs-text">Cost breakdown</h3>
                <div className="flex flex-col gap-3.5">
                  {sourcesActive.map(([key, val]) => {
                    const pct = totalFromSources > 0 ? (Number(val) / totalFromSources) * 100 : 0;
                    return (
                      <div key={key}>
                        <div className="flex items-baseline justify-between gap-2">
                          <span className="text-sm text-avcs-muted">{SOURCE_LABELS[key] || key}</span>
                          <span className="shrink-0 text-sm font-semibold text-avcs-text">
                            R {Number(val).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </span>
                        </div>
                        <div className="mt-1.5 flex items-center gap-2">
                          <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-[#e2eef8]">
                            <div className="h-full rounded-full bg-[#1e6bb8] transition-all duration-500" style={{ width: `${pct}%` }} />
                          </div>
                          <span className="w-9 shrink-0 text-right text-xs text-avcs-muted">{pct.toFixed(0)}%</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Per-deal rows table */}
        {!isLoading && costReports.length > 0 && (
          <div className="overflow-x-auto rounded-xl border border-[#1e6bb824]">
            <table className="min-w-full text-sm">
              <thead className="border-b border-[#1e6bb824] bg-[#f8fbff]">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Deal</th>
                  {!allSpeciesBlank && (
                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-avcs-muted">Species</th>
                  )}
                  <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">Animals</th>
                  <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">Total cost</th>
                  <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wide text-avcs-muted">Cost / animal</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#1e6bb812] bg-white">
                {costReports.map((row: any, idx: number) => {
                  const animalCount = row.animal_count ?? (costReportsDealId ? c.animal_count : null);
                  return (
                    <tr key={row.id ?? idx} className="hover:bg-[#f5f9ff] transition-colors">
                      <td className="px-4 py-3 font-medium text-avcs-text">{row.deal_no || row.deal || '—'}</td>
                      {!allSpeciesBlank && (
                        <td className="px-4 py-3 text-avcs-muted">{row.species || '—'}</td>
                      )}
                      <td className="px-4 py-3 text-right text-avcs-muted">
                        {animalCount != null ? Number(animalCount).toLocaleString() : '—'}
                      </td>
                      <td className="px-4 py-3 text-right font-semibold text-avcs-text">
                        {row.total_cost != null ? `R ${Number(row.total_cost).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '—'}
                      </td>
                      <td className="px-4 py-3 text-right">
                        {row.per_animal_cost != null
                          ? <span className="font-medium text-[#1e6bb8]">R {Number(row.per_animal_cost).toFixed(2)}</span>
                          : '—'}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </section>
    );
  };

  const openMortalityTrend = () => {
    setShowMortalityTrend(true);
    if (mortalityTrend || loadingMortalityTrend) return;
    setLoadingMortalityTrend(true);
    fetchMortalityTimeseries()
      .then((data) => setMortalityTrend(data))
      .catch(() => setMortalityTrend({ series: [], total: 0 }))
      .finally(() => setLoadingMortalityTrend(false));
  };

  // All-time month-on-month mortality bar chart. Mirrors the weight-gain chart's
  // visual language (blue palette, soft gridlines) but uses bars since each
  // month is a discrete count.
  const renderMortalityChart = (series: MortalityTimeseries['series']) => {
    if (!series || series.length === 0) {
      return (
        <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-[#1e6bb833] bg-[#f8fbff] px-4 py-12 text-center">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#9db2c6" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M3 3v18h18" /><rect x="7" y="12" width="3" height="6" /><rect x="13" y="8" width="3" height="10" />
          </svg>
          <p className="mt-2 text-sm text-avcs-muted">No mortalities recorded yet.</p>
        </div>
      );
    }

    const W = 720;
    const H = 300;
    const padL = 40;
    const padR = 18;
    const padT = 24;
    const padB = 54;
    const plotW = W - padL - padR;
    const plotH = H - padT - padB;

    const counts = series.map((p) => p.count);
    const rawMax = Math.max(...counts, 1);
    // Round the domain up to a "nice" ceiling so gridlines land on round numbers.
    const domMax = (() => {
      const mag = Math.pow(10, Math.floor(Math.log10(rawMax)));
      const step = mag <= 1 ? 1 : mag / 2;
      return Math.ceil(rawMax / step) * step || 1;
    })();
    const n = series.length;

    const ticks = 4;
    const gridY = Array.from({ length: ticks + 1 }, (_, i) => (domMax * i) / ticks);
    const yAt = (v: number) => padT + plotH - (v / domMax) * plotH;

    const slot = plotW / n;
    const barW = Math.max(2, Math.min(38, slot * 0.62));
    const xCenter = (i: number) => padL + slot * i + slot / 2;

    // Thin out x-axis labels when months get crowded; always show first & last.
    const labelEvery = Math.max(1, Math.ceil(n / 12));
    const fmtMonth = (ym: string) => {
      const [y, m] = ym.split('-').map(Number);
      if (!y || !m) return ym;
      return new Date(y, m - 1, 1).toLocaleDateString('en-ZA', { month: 'short', year: '2-digit' });
    };

    return (
      <div className="rounded-xl border border-[#1e6bb824] bg-white p-3 shadow-sm">
        <svg viewBox={`0 0 ${W} ${H}`} className="w-full" style={{ height: 'auto' }} role="img" aria-label="Mortalities per month over time">
          <defs>
            <linearGradient id="mortBar" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#c0392b" stopOpacity="0.95" />
              <stop offset="100%" stopColor="#e0776c" stopOpacity="0.85" />
            </linearGradient>
          </defs>

          {/* Horizontal gridlines + y-axis labels */}
          {gridY.map((v, i) => {
            const y = yAt(v);
            return (
              <g key={`grid-${i}`}>
                <line x1={padL} y1={y} x2={W - padR} y2={y} stroke="#eef2f6" strokeWidth="1" />
                <text x={padL - 8} y={y + 3} textAnchor="end" fontSize="10" fill="#9aa8b4">{Math.round(v)}</text>
              </g>
            );
          })}

          {/* Bars + value labels */}
          {series.map((p, i) => {
            const cx = xCenter(i);
            const y = yAt(p.count);
            const h = padT + plotH - y;
            return (
              <g key={p.month}>
                {p.count > 0 && (
                  <rect x={cx - barW / 2} y={y} width={barW} height={Math.max(0, h)} rx="2.5" fill="url(#mortBar)" />
                )}
                {p.count > 0 && (
                  <text x={cx} y={y - 5} textAnchor="middle" fontSize="10" fontWeight="700" fill="#8e2c22">{p.count}</text>
                )}
              </g>
            );
          })}

          {/* Baseline */}
          <line x1={padL} y1={padT + plotH} x2={W - padR} y2={padT + plotH} stroke="#d6dee6" strokeWidth="1" />

          {/* X-axis month labels */}
          {series.map((p, i) => {
            const show = i === 0 || i === n - 1 || i % labelEvery === 0;
            if (!show) return null;
            const anchor = i === 0 ? 'start' : i === n - 1 ? 'end' : 'middle';
            return (
              <text
                key={`xl-${p.month}`}
                x={xCenter(i)}
                y={H - 30}
                textAnchor={anchor}
                fontSize="9.5"
                fill="#7a8794"
                transform={n > 8 ? `rotate(-40 ${xCenter(i)} ${H - 30})` : undefined}
              >
                {fmtMonth(p.month)}
              </text>
            );
          })}
        </svg>
      </div>
    );
  };

  const renderScpAnalysis = () => {
    const summary = scpAnalysis;
    const totals = summary?.totals;
    const isLoss = (totals?.margin ?? 0) < 0;
    const scpLabel =
      scpAnalysisScp === DASHBOARD_SCP_ALL ? 'all supply chain programmes'
      : scpAnalysisScp === DASHBOARD_SCP_MATRIX ? 'Deal Matrix'
      : (valueChainOptions.find((o) => o.id === scpAnalysisScp)?.label || 'the selected programme');
    const card = (label: string, value: string, sub?: string, tone: 'cost' | 'income' | 'neutral' = 'neutral') => (
      <div key={label} className="rounded-xl border border-[#1e6bb829] bg-white p-4">
        <div className="tile-label">{label}</div>
        <div className={`tile-value ${tone === 'income' ? 'text-[#106b38]' : ''}`}>{value}</div>
        {sub && <div className="mt-1 text-xs text-avcs-muted">{sub}</div>}
      </div>
    );
    return (
      <section className="rounded-2xl border border-[#1e6bb824] bg-white p-4 shadow-sm md:p-5">
        <div className="admin-section-head mb-4 flex flex-wrap items-start justify-between gap-3">
          <div className="max-w-3xl">
            <h2 className="text-2xl font-semibold text-avcs-text">Supply Chain Programme Analysis</h2>
            <p className="mt-0.5 text-sm text-avcs-muted">
              Costs, income and margin pooled across the deals that started in the period, for one programme
              or all. Closed deals are included: a period is judged on everything it started.
            </p>
          </div>
        </div>

        {/* Filter bar, in the dashboard's register so the two read as one family. */}
        <div className="mb-5 flex flex-wrap items-end gap-4 rounded-xl border border-[#1e6bb824] bg-[#f8fbff] p-4">
          <label className="grid gap-1.5">
            <span className="text-xs font-bold uppercase tracking-wide text-avcs-muted">Supply Chain Program</span>
            <select
              className="min-w-64 rounded-lg border-2 border-[#1e6bb84d] bg-white px-4 py-3 text-lg font-semibold text-avcs-text"
              value={scpAnalysisScp}
              onChange={(event) => setScpAnalysisScp(event.target.value)}
            >
              <option value={DASHBOARD_SCP_ALL}>All SCPs</option>
              <option value={DASHBOARD_SCP_MATRIX}>Deal Matrix</option>
              {valueChainOptions.map((chain) => (
                <option key={chain.id} value={chain.id}>{chain.label}</option>
              ))}
            </select>
          </label>
          <label className="grid gap-1.5">
            <span className="text-xs font-bold uppercase tracking-wide text-avcs-muted">Deals started from</span>
            <input
              type="date"
              className="rounded-lg border-2 border-[#1e6bb84d] bg-white px-4 py-3 text-lg text-avcs-text"
              value={scpAnalysisFrom}
              max={scpAnalysisTo || undefined}
              onChange={(event) => setScpAnalysisFrom(event.target.value)}
            />
          </label>
          <label className="grid gap-1.5">
            <span className="text-xs font-bold uppercase tracking-wide text-avcs-muted">To</span>
            <input
              type="date"
              className="rounded-lg border-2 border-[#1e6bb84d] bg-white px-4 py-3 text-lg text-avcs-text"
              value={scpAnalysisTo}
              min={scpAnalysisFrom || undefined}
              onChange={(event) => setScpAnalysisTo(event.target.value)}
            />
          </label>
          <div className="pb-3 text-sm text-avcs-muted">
            {scpAnalysisLoading
              ? 'Loading…'
              : summary
                ? `${fmtNum(summary.dealCount)} deal${summary.dealCount === 1 ? '' : 's'} · ${fmtNum(summary.animalCount)} animals · ${scpLabel}`
                : ''}
          </div>
        </div>

        {scpAnalysisError && (
          <div className="mb-4 rounded-lg border border-[#e7bbb9] bg-[#f8eae7] px-3 py-2 text-sm text-[#6b1010]">{scpAnalysisError}</div>
        )}

        <div className="mb-4 flex items-center gap-1 border-b border-[#1e6bb824]">
          {([['overview', 'Overview'], ['margin', 'Margin analysis']] as const).map(([key, label]) => (
            <button
              key={key}
              type="button"
              className={`-mb-px border-b-2 px-3 py-2 text-sm font-semibold transition ${
                scpAnalysisTab === key ? 'border-[#1e6bb8] text-[#1e6bb8]' : 'border-transparent text-avcs-muted hover:text-avcs-text'
              }`}
              aria-current={scpAnalysisTab === key ? 'page' : undefined}
              onClick={() => setScpAnalysisTab(key)}
            >
              {label}
            </button>
          ))}
        </div>

        {scpAnalysisTab === 'overview' && summary && totals && (
          <>
            <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-5">
              {card('Cost total', fmtRand(totals.cost), `across ${fmtNum(summary.animalCount)} animals`, 'cost')}
              {card('Cost per animal', fmtRand(totals.costPerAnimal), undefined, 'cost')}
              {card('Income total', fmtRand(totals.income), 'booked so far', 'income')}
              {card('Income per animal', fmtRand(totals.incomePerAnimal), undefined, 'income')}
              <div className={`rounded-xl border p-4 ${isLoss ? 'border-[#e7bbb9] bg-[#fdf1ef]' : 'border-[#b9e7c9] bg-[#f0faf4]'}`}>
                <div className="tile-label">{isLoss ? 'Loss' : 'Margin'}</div>
                <div className={`tile-value ${isLoss ? 'text-[#6b1010]' : 'text-[#106b38]'}`}>{fmtRand(totals.margin)}</div>
                <div className="mt-1 text-xs text-avcs-muted">
                  {fmtRand(totals.marginPerAnimal)} per animal{totals.marginPercent !== null ? ` · ${fmtDecimal(totals.marginPercent, 1)}% of income` : ''}
                </div>
              </div>
            </div>
        {summary && summary.deals.length > 0 && (
          <div className="admin-table-scroll mt-4 overflow-x-auto border border-[#1e6bb824] bg-white">
            <table className="w-full min-w-[960px] border-collapse text-sm">
              <thead>
                <tr className="border-b border-[#1e6bb824] bg-[#fbfeff] text-left text-xs uppercase tracking-wide text-avcs-muted">
                  <th className="px-3 py-2 font-semibold">Deal</th>
                  <th className="px-3 py-2 font-semibold">Producer</th>
                  <th className="px-3 py-2 text-right font-semibold">Animals</th>
                  <th className="px-3 py-2 text-right font-semibold">ADG</th>
                  <th className="px-3 py-2 text-right font-semibold">FCR</th>
                  <th className="px-3 py-2 text-right font-semibold">Dressing</th>
                  <th className="px-3 py-2 text-right font-semibold">Feed / animal</th>
                  <th className="px-3 py-2 text-right font-semibold">Wool / animal</th>
                  <th className="px-3 py-2 text-right font-semibold">Income / animal</th>
                  <th className="px-3 py-2 text-right font-semibold">Margin / animal</th>
                  <th className="px-3 py-2" />
                </tr>
              </thead>
              <tbody>
                {summary.deals.map((row) => {
                  const rowLoss = row.margin < 0;
                  return (
                    <tr key={row.dealId} className="border-b border-[#1e6bb814] text-avcs-text">
                      <td className="px-3 py-2 font-semibold">
                        {row.dealNo}
                        {row.status !== 'ACTIVE' && (
                          <span className="ml-2 rounded-full border border-[#1e6bb833] bg-[#e8f4ff] px-2 py-0.5 text-[11px] font-semibold text-[#0f3b64]">Closed</span>
                        )}
                      </td>
                      <td className="px-3 py-2 text-avcs-muted">{row.primaryProducer || '—'}</td>
                      <td className="px-3 py-2 text-right tabular-nums">{fmtNum(row.animalCount)}</td>
                      <td className="px-3 py-2 text-right tabular-nums">{fmtDecimal(row.avgAdgKg, 3)}</td>
                      <td className="px-3 py-2 text-right tabular-nums">
                        {row.fcr !== null ? fmtDecimal(row.fcr, 2) : row.fcrEstimated !== null ? <>{fmtDecimal(row.fcrEstimated, 2)} <span className="text-amber-500">(est.)</span></> : '—'}
                      </td>
                      <td className="px-3 py-2 text-right tabular-nums">{row.dressingPercentage !== null ? `${fmtDecimal(row.dressingPercentage, 1)}%` : '—'}</td>
                      <td className="px-3 py-2 text-right tabular-nums">{fmtRand(row.feedCostPerAnimal)}</td>
                      <td className="px-3 py-2 text-right tabular-nums">{fmtRand(row.woolIncomePerAnimal)}</td>
                      <td className="px-3 py-2 text-right tabular-nums">{fmtRand(row.incomePerAnimal)}</td>
                      <td className={`px-3 py-2 text-right font-semibold tabular-nums ${rowLoss ? 'text-[#6b1010]' : 'text-[#106b38]'}`}>{fmtRand(row.marginPerAnimal)}</td>
                      <td className="px-3 py-2 text-right">
                        <button type="button" className="btn" onClick={() => { setSelectedDealId(row.dealId); setView('dealSummary'); }}>Open deal</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
            {summary.deals.length === 0 && (
              <p className="mt-3 text-sm text-avcs-muted">No deals started in this period for {scpLabel}.</p>
            )}
          </>
        )}

        {scpAnalysisTab === 'margin' && summary && (
          summary.dealCount === 0
            ? <p className="text-sm text-avcs-muted">No deals started in this period for {scpLabel}.</p>
            : <CostModelView model={summary} />
        )}
      </section>
    );
  };

  const renderPerformanceReport = () => {
    const loadPerformanceReport = async (dealId: string) => {
      if (!dealId) { setPerfReport(null); return; }
      setLoadingPerfReport(true);
      setPerfReport(null);

      // Start tracking fetch in the background immediately (uses cache if available).
      const trackingPromise: Promise<any> = trackingCacheRef.current[dealId]
        ? Promise.resolve(trackingCacheRef.current[dealId])
        : fetchTracking(dealId)
            .then((t: any) => { trackingCacheRef.current[dealId] = t; return t; })
            .catch(() => null);

      try {
        // Show admin report as soon as it arrives — don't block on tracking.
        const report = await fetchDealAdminReport(dealId);
        const r = report ?? { error: 'Failed to load report.' };
        setPerfReport(r);
        setLoadingPerfReport(false);

        // Silently enrich with tracking data once it resolves (fills in ADG if
        // missing). FCR — both measured and the estimated fallback — already
        // comes straight from admin-report's own `performance` payload, so no
        // client-side calculation is needed here.
        if (r && !r.error) {
          trackingPromise.then((trackingValue: any) => {
            if (!trackingValue) return;
            const localPerf = trackingValue?.feedlotPerformance ?? null;
            const perf = r.performance ?? {};

            if ((!perf.avg_adg || Number(perf.avg_adg) === 0) && localPerf?.avg_adg && Number(localPerf.avg_adg) > 0) {
              r.performance = { ...perf, avg_adg: localPerf.avg_adg };
              setPerfReport({ ...r });
            }
          }).catch(() => { /* tracking supplement failed silently */ });
        }
      } catch (err: any) {
        setPerfReport({ error: err?.message || 'Failed to load report.' });
        setLoadingPerfReport(false);
      }
    };

    const showingAggregate = !perfReportDealId;
    const p = showingAggregate
      ? {
          slaughter_percentage: perfReportAggregate?.dressing_percentage ?? perfReportAggregate?.slaughter_percentage ?? null,
          slaughter_sample_size: perfReportAggregate?.slaughter_record_count ?? null,
          avg_adg: perfReportAggregate?.avg_adg ?? null,
          fcr: perfReportAggregate?.fcr ?? null,
          fcr_estimated: perfReportAggregate?.fcr_estimated ?? null,
          avg_days_in_feedlot: perfReportAggregate?.avg_feedlot_days ?? perfReportAggregate?.avg_days_in_feedlot ?? null,
          daily_feedlot_cost_per_animal: perfReportAggregate?.daily_feedlot_cost_per_animal ?? null,
          avg_feedlot_cost_per_animal: perfReportAggregate?.avg_feedlot_cost_per_animal ?? null,
        }
      : (perfReport?.performance ?? {});
    const isLoadingMetrics = showingAggregate ? loadingPerfReportAggregate : loadingPerfReport;
    const hasMetrics = showingAggregate ? !!perfReportAggregate : !!perfReport;
    const fmt = (v: any, d = 2) => v != null ? Number(v).toFixed(d) : '—';

    const selectedPerfDeal = deals.find((d) => d.dealId === perfReportDealId) || null;
    const formatPerfDeal = (deal: Deal) => {
      const dealNo = deal.title || deal.dealRefNo || deal.dealId;
      return [dealNo, deal.counterpart].filter((part) => part && part !== '—').join(' ');
    };
    const filteredPerfDealOptions = (() => {
      const query = perfReportDealSearch.trim().toLowerCase();
      const source = query
        ? deals.filter((deal) => formatPerfDeal(deal).toLowerCase().includes(query))
        : deals;
      return source.slice(0, 5);
    })();

    // Per-animal breakdown: free-text filtered (across id, producer, deal,
    // value chain, feedlot) then paged.
    const animalSearchQuery = perfReportAnimalSearch.trim().toLowerCase();
    const filteredPerfAnimals = animalSearchQuery
      ? perfReportAnimals.filter((a) =>
          [
            a.eid_tag,
            a.vid,
            a.primary_producer_name,
            a.deal_no,
            a.deal_reference_no,
            a.value_chain_name,
            a.entity_name,
          ]
            .filter(Boolean)
            .some((field) => String(field).toLowerCase().includes(animalSearchQuery)),
        )
      : perfReportAnimals;
    const perfAnimalTotalPages = Math.max(
      1,
      Math.ceil(filteredPerfAnimals.length / PERF_REPORT_ANIMAL_PAGE_SIZE),
    );
    const perfAnimalPage = Math.min(perfReportAnimalPage, perfAnimalTotalPages);
    const perfAnimalPageStart = (perfAnimalPage - 1) * PERF_REPORT_ANIMAL_PAGE_SIZE;
    const pagedPerfAnimals = filteredPerfAnimals.slice(
      perfAnimalPageStart,
      perfAnimalPageStart + PERF_REPORT_ANIMAL_PAGE_SIZE,
    );
    const perfPct = (v: any, d = 1) => (v != null ? `${Number(v).toFixed(d)}%` : '—');

    // Export the animals table (every row matching the current search, not just
    // the visible page) to a spreadsheet. Numeric columns are exported as real
    // numbers so they can be sorted/summed in Excel.
    const exportPerfAnimals = () => {
      const num = (v: any, d: number) =>
        v != null && v !== '' && !Number.isNaN(Number(v)) ? Number(Number(v).toFixed(d)) : '';
      const headers = [
        'Animal', 'Primary producer', 'Deal', 'Supply Chain Program', 'Feedlot',
        'Feedlot entered', 'Feedlot departed',
        'First weight (kg)', 'Last weight (kg)',
        'Days in feedlot', 'ADG (kg/day)',
        'FCR', 'Est. FCR', 'Est. feed consumed (kg)', 'Dressing %',
      ];
      const rows = filteredPerfAnimals.map((a) => [
        a.eid_tag || a.vid || '',
        a.primary_producer_name || '',
        a.deal_no || a.deal_reference_no || '',
        a.value_chain_name || '',
        a.entity_name || '',
        a.feedlot_entered_date || '',
        a.feedlot_departed_date || '',
        num(a.first_weight_kg, 1),
        num(a.last_weight_kg, 1),
        num(a.days_in_feedlot, 0),
        num(a.adg_kg_per_day, 3),
        num(a.fcr, 2),
        num(a.fcr_estimated, 2),
        num(a.estimated_feed_kg, 1),
        num(a.dressing_percentage, 1),
      ]);
      const scope = showingAggregate
        ? 'all-deals'
        : (selectedPerfDeal?.title || selectedPerfDeal?.dealId || 'report');
      const stamp = new Date().toISOString().slice(0, 10);
      const safeScope = String(scope).replace(/[^\w.-]+/g, '-');
      downloadTableAsCsv(`performance-report-${safeScope}-${stamp}.csv`, headers, rows);
    };

    // Mortality rate = all-time deceased animals ÷ all animals ever entered.
    // Sourced from the system-wide stats card so it stays consistent with the
    // dashboard's lifetime counters (both exclude soft-deleted animals).
    const totalEntered = systemStats?.animals.entered ?? null;
    const totalMortalities = systemStats?.animals.mortalities ?? null;
    const mortalityRate =
      totalEntered != null && totalMortalities != null && totalEntered > 0
        ? (totalMortalities / totalEntered) * 100
        : null;

    // Drilldown screen: month-on-month mortalities for all time. Replaces the
    // report body so the usual performance details are hidden while viewing it.
    if (showMortalityTrend) {
      return (
        <section className="flex flex-col gap-6 rounded-2xl border border-[#1e6bb824] bg-white p-6">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <h2 className="text-xl font-bold text-avcs-text">Mortalities over time</h2>
              <p className="mt-1 text-sm text-avcs-muted">All-time mortalities recorded per month across every deal</p>
            </div>
            <button className="btn" onClick={() => setShowMortalityTrend(false)}>← Back to performance report</button>
          </div>

          <div className="grid gap-3 sm:grid-cols-3">
            <div className="rounded-xl border border-[#c0392b20] bg-[#fdf3f2] p-5">
              <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Total mortalities</div>
              <div className="mt-2 text-3xl font-bold tracking-tight text-[#8e2c22]">
                {totalMortalities != null ? fmtNum(totalMortalities) : (mortalityTrend ? fmtNum(mortalityTrend.total) : '—')}
              </div>
            </div>
            <div className="rounded-xl border border-[#1e6bb820] bg-[#f8fbff] p-5">
              <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Animals entered</div>
              <div className="mt-2 text-3xl font-bold tracking-tight text-avcs-text">
                {totalEntered != null ? fmtNum(totalEntered) : '—'}
              </div>
            </div>
            <div className="rounded-xl border border-[#1e6bb820] bg-[#f8fbff] p-5">
              <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Mortality rate</div>
              <div className="mt-2 text-3xl font-bold tracking-tight text-avcs-text">
                {mortalityRate != null ? `${mortalityRate.toFixed(1)}%` : '—'}
              </div>
            </div>
          </div>

          {loadingMortalityTrend ? (
            <div className="flex items-center gap-2 py-2 text-sm text-avcs-muted">
              <svg className="h-4 w-4 animate-spin text-[#1e6bb8]" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
              </svg>
              Loading mortality trend…
            </div>
          ) : (
            renderMortalityChart(mortalityTrend?.series ?? [])
          )}
        </section>
      );
    }

    return (
      <section className="flex flex-col gap-6 rounded-2xl border border-[#1e6bb824] bg-white p-6">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <h2 className="text-xl font-bold text-avcs-text">Performance Report</h2>
            <p className="mt-1 text-sm text-avcs-muted">Dressing percentage, ADG, FCR and feedlot days by deal</p>
          </div>
          <button
            type="button"
            className="btn primary inline-flex items-center gap-1.5 whitespace-nowrap"
            onClick={exportPerfAnimals}
            disabled={filteredPerfAnimals.length === 0}
            title={filteredPerfAnimals.length === 0
              ? 'No animals to export yet'
              : 'Export the animals table (all rows matching the current search) to a spreadsheet'}
          >
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M8 1.5v8m0 0L5 6.5m3 3 3-3" />
              <path d="M2.5 11v2a1.5 1.5 0 0 0 1.5 1.5h8a1.5 1.5 0 0 0 1.5-1.5v-2" />
            </svg>
            Export to Excel{filteredPerfAnimals.length ? ` (${filteredPerfAnimals.length})` : ''}
          </button>
        </div>

        {/* Mortality rate — clickable card that drills into the all-time trend */}
        <button
          type="button"
          onClick={openMortalityTrend}
          className="group flex items-center justify-between gap-4 rounded-xl border border-[#c0392b24] bg-[#fdf3f2] p-5 text-left transition hover:border-[#c0392b55] hover:shadow-sm"
        >
          <div>
            <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Mortality rate (all time)</div>
            <div className="mt-2 flex items-baseline gap-3">
              <span className="text-3xl font-bold tracking-tight text-[#8e2c22]">
                {mortalityRate != null ? `${mortalityRate.toFixed(1)}%` : '—'}
              </span>
              {totalMortalities != null && totalEntered != null && (
                <span className="text-sm text-avcs-muted">
                  {fmtNum(totalMortalities)} of {fmtNum(totalEntered)} animals entered
                </span>
              )}
            </div>
            <div className="mt-1.5 text-xs font-medium text-[#c0392b]">View month-on-month trend →</div>
          </div>
          <svg className="h-6 w-6 flex-shrink-0 text-[#c0392b] transition group-hover:translate-x-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>

        <div className="text-sm font-medium text-avcs-text">
          {showingAggregate ? 'Showing: all deals (aggregate)' : `Showing: ${formatPerfDeal(selectedPerfDeal!)}`}
        </div>

        {/* Deal selector */}
        <div className="flex flex-wrap items-end gap-3">
          <div className="min-w-[280px]">
            <DealCombobox
              label="Select deal *"
              selectedDeal={selectedPerfDeal}
              searchValue={perfReportDealSearch}
              results={filteredPerfDealOptions}
              showDropdown={showPerfReportDealDropdown}
              onSearchChange={(value) => {
                setPerfReportDealSearch(value);
                setShowPerfReportDealDropdown(true);
              }}
              onFocus={() => setShowPerfReportDealDropdown(true)}
              onBlur={() => setTimeout(() => setShowPerfReportDealDropdown(false), 150)}
              onSelect={(deal) => {
                setPerfReportDealId(deal.dealId);
                setPerfReportDealSearch('');
                setShowPerfReportDealDropdown(false);
                setPerfReport(null);
                loadPerformanceReport(deal.dealId);
              }}
              onClear={() => {
                setPerfReportDealId('');
                setPerfReportDealSearch('');
                setShowPerfReportDealDropdown(false);
                setPerfReport(null);
              }}
              formatDeal={formatPerfDeal}
            />
          </div>
          <label className="grid gap-1 text-sm text-avcs-text">
            <span className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Supply Chain Program</span>
            <select
              className="min-w-[220px] rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
              value={perfReportValueChainId}
              onChange={(e) => setPerfReportValueChainId(e.target.value)}
            >
              <option value="">All supply chain programs</option>
              {valueChainOptions.map((option) => (
                <option key={option.id} value={option.id}>{option.label}</option>
              ))}
            </select>
          </label>
        </div>

        {isLoadingMetrics && (
          <div className="flex items-center gap-2 py-2 text-sm text-avcs-muted">
            <svg className="h-4 w-4 animate-spin text-[#1e6bb8]" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
            </svg>
            Loading report…
          </div>
        )}

        {!isLoadingMetrics && !hasMetrics && (
          <p className="text-sm text-avcs-muted">
            {showingAggregate ? 'No performance data available yet.' : 'Select a deal above to view performance data.'}
          </p>
        )}

        {!showingAggregate && perfReport?.error && (
          <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700">{perfReport.error}</div>
        )}

        {!isLoadingMetrics && hasMetrics && (showingAggregate || !perfReport?.error) && (
          <div className="flex flex-col gap-5">
            {/* Primary metrics */}
            <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
              <div className="flex flex-col rounded-xl border border-[#1e6bb820] bg-[#f8fbff] p-5">
                <div className="min-h-[2.5rem] text-xs font-semibold uppercase tracking-wide text-avcs-muted">Dressing %</div>
                <div className="mt-2 text-3xl font-bold tracking-tight text-avcs-text">
                  {p.slaughter_percentage != null ? `${fmt(p.slaughter_percentage, 1)}%` : '—'}
                </div>
                <div className="mt-1.5 text-xs text-avcs-muted">
                  {p.slaughter_sample_size != null ? `${p.slaughter_sample_size} slaughter record${p.slaughter_sample_size !== 1 ? 's' : ''}` : 'Hot carcass weight ratio'}
                </div>
              </div>
              <div className="flex flex-col rounded-xl border border-[#1e6bb820] bg-[#f8fbff] p-5">
                <div className="min-h-[2.5rem] text-xs font-semibold uppercase tracking-wide text-avcs-muted">ADG</div>
                <div className="mt-2 text-3xl font-bold tracking-tight text-avcs-text">
                  {p.avg_adg != null ? fmt(p.avg_adg, 3) : '—'}
                </div>
                <div className="mt-1.5 text-xs text-avcs-muted">kg / day avg daily gain</div>
              </div>
              <div className="flex flex-col rounded-xl border border-[#1e6bb820] bg-[#f8fbff] p-5">
                <div className="min-h-[2.5rem] text-xs font-semibold uppercase tracking-wide text-avcs-muted">
                  FCR{p.fcr == null && p.fcr_estimated != null && <span className="text-amber-500"> (est.)</span>}
                </div>
                <div className="mt-2 text-3xl font-bold tracking-tight text-avcs-text">
                  {p.fcr != null ? fmt(p.fcr, 2) : p.fcr_estimated != null ? fmt(p.fcr_estimated, 2) : '—'}
                </div>
                <div className="mt-1.5 text-xs text-avcs-muted">
                  {p.fcr == null && p.fcr_estimated != null ? 'Est. from body weight' : 'Feed : gain ratio'}
                </div>
              </div>
              <div className="flex flex-col rounded-xl border border-[#1e6bb820] bg-[#f8fbff] p-5">
                <div className="min-h-[2.5rem] text-xs font-semibold uppercase tracking-wide text-avcs-muted">Avg days in feedlot</div>
                <div className="mt-2 text-3xl font-bold tracking-tight text-avcs-text">
                  {p.avg_days_in_feedlot != null ? fmt(p.avg_days_in_feedlot, 0) : '—'}
                </div>
                <div className="mt-1.5 text-xs text-avcs-muted">days on feed</div>
              </div>
            </div>

            {/* Feedlot cost metrics */}
            {(p.daily_feedlot_cost_per_animal != null || p.avg_feedlot_cost_per_animal != null) && (
              <div className="grid gap-3 sm:grid-cols-2">
                {p.daily_feedlot_cost_per_animal != null && (
                  <div className="rounded-xl border border-[#1e6bb829] bg-[#f8fbff] p-5">
                    <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Daily feedlot cost / animal</div>
                    <div className="mt-2 text-2xl font-bold tracking-tight text-avcs-text">R {fmt(p.daily_feedlot_cost_per_animal)}</div>
                  </div>
                )}
                {p.avg_feedlot_cost_per_animal != null && (
                  <div className="rounded-xl border border-[#1e6bb829] bg-[#f8fbff] p-5">
                    <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Avg feedlot cost / animal</div>
                    <div className="mt-2 text-2xl font-bold tracking-tight text-avcs-text">R {fmt(p.avg_feedlot_cost_per_animal)}</div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* Per-animal breakdown: which animals feed the cards above */}
        <div className="flex flex-col gap-3 border-t border-[#1e6bb814] pt-5">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <h3 className="text-lg font-semibold text-avcs-text">Animals in this report</h3>
              <p className="mt-0.5 text-xs text-avcs-muted">
                Every animal aggregated in the cards above, with its primary producer, deal and individual performance.
              </p>
            </div>
            <input
              type="text"
              value={perfReportAnimalSearch}
              onChange={(e) => {
                setPerfReportAnimalSearch(e.target.value);
                setPerfReportAnimalPage(1);
              }}
              placeholder="Search EID, producer, deal, supply chain program…"
              className="min-w-[260px] rounded-lg border border-[#1e6bb824] bg-white px-3 py-2 text-sm"
            />
          </div>

          {loadingPerfReportAnimals ? (
            <div className="flex items-center gap-2 py-2 text-sm text-avcs-muted">
              <svg className="h-4 w-4 animate-spin text-[#1e6bb8]" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
              </svg>
              Loading animals…
            </div>
          ) : filteredPerfAnimals.length === 0 ? (
            <p className="text-sm text-avcs-muted">
              {perfReportAnimals.length === 0
                ? 'No animals contribute to this report yet.'
                : 'No animals match your search.'}
            </p>
          ) : (
            <>
              <div className="overflow-x-auto rounded-xl border border-[#1e6bb814]">
                <table className="min-w-full text-left text-sm">
                  <thead className="bg-[#f8fbff] text-xs font-semibold uppercase tracking-wide text-avcs-muted">
                    <tr>
                      <th className="px-3 py-2">Animal</th>
                      <th className="px-3 py-2">Primary producer</th>
                      <th className="px-3 py-2">Deal</th>
                      <th className="px-3 py-2">Supply Chain Program</th>
                      <th className="px-3 py-2">Feedlot</th>
                      <th className="px-3 py-2 text-right">Days in feedlot</th>
                      <th className="px-3 py-2 text-right">ADG</th>
                      <th className="px-3 py-2 text-right">FCR</th>
                      <th className="px-3 py-2 text-right">Est. FCR</th>
                      <th className="px-3 py-2 text-right">Dressing %</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#1e6bb814]">
                    {pagedPerfAnimals.map((a) => (
                      <tr key={a.animal_id} className="text-avcs-text">
                        <td className="px-3 py-2 font-medium">{a.eid_tag || a.vid || '—'}</td>
                        <td className="px-3 py-2">{a.primary_producer_name || '—'}</td>
                        <td className="px-3 py-2">{a.deal_no || a.deal_reference_no || '—'}</td>
                        <td className="px-3 py-2">{a.value_chain_name || '—'}</td>
                        <td className="px-3 py-2">{a.entity_name || '—'}</td>
                        <td className="px-3 py-2 text-right">{a.days_in_feedlot != null ? fmt(a.days_in_feedlot, 0) : '—'}</td>
                        <td className="px-3 py-2 text-right">{a.adg_kg_per_day != null ? fmt(a.adg_kg_per_day, 3) : '—'}</td>
                        <td className="px-3 py-2 text-right">{a.fcr != null ? fmt(a.fcr, 2) : '—'}</td>
                        <td className="px-3 py-2 text-right">{a.fcr_estimated != null ? <span title="Estimated from assumed feed intake (≈4.5% of body weight/day)">{fmt(a.fcr_estimated, 2)}<span className="ml-0.5 text-[10px] font-normal text-avcs-muted">est</span></span> : '—'}</td>
                        <td className="px-3 py-2 text-right">{perfPct(a.dressing_percentage)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="flex flex-wrap items-center justify-between gap-3 text-sm text-avcs-muted">
                <span>
                  Showing {perfAnimalPageStart + 1}–{Math.min(perfAnimalPageStart + PERF_REPORT_ANIMAL_PAGE_SIZE, filteredPerfAnimals.length)} of {filteredPerfAnimals.length} animals
                </span>
                {perfAnimalTotalPages > 1 && (
                  <div className="flex items-center gap-2">
                    <button
                      type="button"
                      className="rounded-lg border border-[#1e6bb824] bg-white px-3 py-1.5 text-sm text-avcs-text disabled:opacity-40"
                      disabled={perfAnimalPage <= 1}
                      onClick={() => setPerfReportAnimalPage((prev) => Math.max(1, prev - 1))}
                    >
                      Previous
                    </button>
                    <span className="text-avcs-text">Page {perfAnimalPage} of {perfAnimalTotalPages}</span>
                    <button
                      type="button"
                      className="rounded-lg border border-[#1e6bb824] bg-white px-3 py-1.5 text-sm text-avcs-text disabled:opacity-40"
                      disabled={perfAnimalPage >= perfAnimalTotalPages}
                      onClick={() => setPerfReportAnimalPage((prev) => Math.min(perfAnimalTotalPages, prev + 1))}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </section>
    );
  };

  const renderIntegrations = () => {
    return (
      <section className="space-y-5">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <h2 className="text-xl font-bold tracking-tight text-avcs-text">Integrations</h2>
            <p className="mt-1 max-w-2xl text-sm text-avcs-muted">
              Control whether each external integration is live in this environment. An
              inactive integration makes no outbound calls, regardless of other configuration.
              Staging and production are separate databases, so a flag set here applies only to
              this environment — activate an integration in staging while building, and in
              production only when you are ready to go live.
            </p>
          </div>
          <button className="btn" onClick={() => setView('dashboard')}>← Back to dashboard</button>
        </div>

        {integrationsError && (
          <div className="rounded-xl border border-[#c0392b33] bg-[#fdf0ef] px-4 py-3 text-sm text-[#8e2c22]">
            {integrationsError}
          </div>
        )}
        {integrationsSuccess && (
          <div className="rounded-xl border border-[#1e8b4d33] bg-[#eefaf1] px-4 py-3 text-sm text-[#1e6b3d]">
            {integrationsSuccess}
          </div>
        )}

        {loadingIntegrations ? (
          <div className="rounded-2xl border border-[#1e6bb824] bg-white p-5 text-sm text-avcs-muted">
            Loading integrations…
          </div>
        ) : integrationSystems.length === 0 ? (
          <div className="rounded-2xl border border-[#1e6bb824] bg-white p-5 text-sm text-avcs-muted">
            No integration systems are configured yet.
          </div>
        ) : (
          <div className="grid gap-4">
            {integrationSystems.map((sys) => {
              const saving = integrationSavingId === sys.id;
              const envKeyConfigured =
                sys.current_environment === 'PRODUCTION'
                  ? sys.has_production_api_key
                  : sys.has_test_api_key;
              const configuring = integrationConfigId === sys.id;
              return (
                <div
                  key={sys.id}
                  className="flex flex-col gap-4 rounded-2xl border border-[#1e6bb824] bg-white p-5"
                >
                  <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                    <div className="min-w-0">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="text-base font-semibold text-avcs-text">{sys.name}</span>
                        <span
                          className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${
                            sys.is_live
                              ? 'bg-[#eefaf1] text-[#1e6b3d]'
                              : 'bg-[#f3f4f6] text-avcs-muted'
                          }`}
                        >
                          {sys.is_live ? '● Live' : '○ Inactive'}
                        </span>
                        <span className="rounded-full bg-[#eef4fb] px-2.5 py-0.5 text-xs font-semibold text-[#1e6bb8]">
                          {sys.current_environment === 'PRODUCTION' ? 'Production API' : 'Test API'}
                        </span>
                      </div>
                      <div className="mt-1 text-xs text-avcs-muted">
                        {sys.base_url ? sys.base_url : 'No base URL configured for the selected environment'}
                        {!envKeyConfigured && (
                          <span className="ml-1 text-[#b7791f]">· API key not configured for this environment</span>
                        )}
                      </div>
                    </div>

                    <div className="flex flex-shrink-0 flex-wrap items-center gap-3">
                      <label className="flex items-center gap-2 text-sm text-avcs-text">
                        <span className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Mode</span>
                        <select
                          className="rounded-lg border border-[#1e6bb833] bg-white px-2 py-1.5 text-sm"
                          value={sys.current_environment}
                          disabled={saving}
                          onChange={(e) =>
                            patchIntegrationSystem(sys, {
                              current_environment: e.target.value as IntegrationEnvironment,
                            })
                          }
                        >
                          <option value="TEST">Test</option>
                          <option value="PRODUCTION">Production</option>
                        </select>
                      </label>
                      <button
                        className="btn"
                        disabled={saving}
                        onClick={() => (configuring ? setIntegrationConfigId('') : openIntegrationConfig(sys))}
                      >
                        {configuring ? 'Close' : 'Configure keys'}
                      </button>
                      <button
                        className={sys.is_active ? 'btn' : 'btn primary'}
                        disabled={saving}
                        onClick={() => patchIntegrationSystem(sys, { is_active: !sys.is_active })}
                      >
                        {saving ? 'Saving…' : sys.is_active ? 'Deactivate' : 'Activate'}
                      </button>
                    </div>
                  </div>

                  {configuring && (
                    <div className="rounded-xl border border-[#1e6bb820] bg-[#f8fbff] p-4">
                      <p className="mb-3 text-xs text-avcs-muted">
                        Set the endpoint URL and API key for each environment. The active
                        <strong> Mode</strong> above decides which pair is used. Keys are write-only —
                        leave a key field blank to keep the existing one; type a new value to replace it.
                      </p>
                      <div className="grid gap-4 sm:grid-cols-2">
                        <div className="space-y-2">
                          <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Test environment</div>
                          <input
                            className="w-full rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                            placeholder="Test base URL (e.g. https://test.partner.com/api/)"
                            value={integrationConfigForm.testBaseUrl}
                            onChange={(e) =>
                              setIntegrationConfigForm((f) => ({ ...f, testBaseUrl: e.target.value }))
                            }
                          />
                          <input
                            type="password"
                            autoComplete="new-password"
                            className="w-full rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                            placeholder={sys.has_test_api_key ? '•••••••• (configured — type to replace)' : 'Test API key (not set)'}
                            value={integrationConfigForm.testApiKey}
                            onChange={(e) =>
                              setIntegrationConfigForm((f) => ({ ...f, testApiKey: e.target.value }))
                            }
                          />
                        </div>
                        <div className="space-y-2">
                          <div className="text-xs font-semibold uppercase tracking-wide text-avcs-muted">Production environment</div>
                          <input
                            className="w-full rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                            placeholder="Production base URL (e.g. https://api.partner.com/)"
                            value={integrationConfigForm.productionBaseUrl}
                            onChange={(e) =>
                              setIntegrationConfigForm((f) => ({ ...f, productionBaseUrl: e.target.value }))
                            }
                          />
                          <input
                            type="password"
                            autoComplete="new-password"
                            className="w-full rounded-lg border border-[#1e6bb833] bg-white px-3 py-2 text-sm"
                            placeholder={sys.has_production_api_key ? '•••••••• (configured — type to replace)' : 'Production API key (not set)'}
                            value={integrationConfigForm.productionApiKey}
                            onChange={(e) =>
                              setIntegrationConfigForm((f) => ({ ...f, productionApiKey: e.target.value }))
                            }
                          />
                        </div>
                      </div>
                      <div className="mt-4 flex items-center gap-3">
                        <button className="btn primary" disabled={saving} onClick={() => saveIntegrationConfig(sys)}>
                          {saving ? 'Saving…' : 'Save configuration'}
                        </button>
                        <button className="btn" disabled={saving} onClick={() => setIntegrationConfigId('')}>
                          Cancel
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </section>
    );
  };

  const loadSchedules = async () => {
    setScheduleErr('');
    try {
      setSchedules(await fetchProductionSchedules());
    } catch (error: any) {
      setScheduleErr(parseApiError(error?.message) || 'Could not load schedules.');
    }
  };

  // Shared growth-schedule ("animal estimates") editor. Rendered both as its own
  // menu item (Reports → Animal estimates) and embedded in the Availability
  // forecast page.
  const renderScheduleEditor = () => {
    const draftFor = (s: ProductionScheduleTemplate) => scheduleDrafts[s.id] || {};
    const setDraft = (id: string, patch: Partial<ProductionScheduleUpsertInput>) =>
      setScheduleDrafts((prev) => ({ ...prev, [id]: { ...prev[id], ...patch } }));

    const saveSchedule = async (s: ProductionScheduleTemplate) => {
      setScheduleErr('');
      setScheduleMsg('');
      try {
        await updateProductionSchedule(s.id, draftFor(s));
        setScheduleDrafts((prev) => { const next = { ...prev }; delete next[s.id]; return next; });
        setScheduleMsg(`${s.species} schedule saved.`);
        await loadSchedules();
      } catch (error: any) {
        setScheduleErr(parseApiError(error?.message) || 'Could not save schedule.');
      }
    };

    return (
      <div className="rounded-xl border border-[#1e6bb81a] bg-[#f8fafc] p-4">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <h3 className="text-lg font-semibold text-avcs-text">Growth schedules</h3>
          <button type="button" className="btn" onClick={loadSchedules}>
            {schedules.length ? 'Reload schedules' : 'Load schedules'}
          </button>
        </div>
        <p className="mt-1 text-sm text-avcs-muted">
          Day offsets that drive the projection: birth → weaning → feedlot entry → slaughter → available.
          Optional target live weight and dressing % enable the carcass-weight estimate.
        </p>
        {scheduleMsg && <div className="mt-2 text-sm text-green-700">{scheduleMsg}</div>}
        {scheduleErr && <div className="mt-2 text-sm text-red-700">{scheduleErr}</div>}
        {schedules.length > 0 && (
          <div className="mt-3 overflow-x-auto">
            <table className="w-full min-w-[820px] border-collapse text-sm">
              <thead>
                <tr className="border-b border-[#1e6bb824] text-left text-avcs-muted">
                  <th className="py-2 pr-3">Species</th>
                  <th className="py-2 pr-3">Weaning days</th>
                  <th className="py-2 pr-3">Post-weaning</th>
                  <th className="py-2 pr-3">Feedlot days</th>
                  <th className="py-2 pr-3">Buffer</th>
                  <th className="py-2 pr-3">Total</th>
                  <th className="py-2 pr-3">Target slaughter wt (kg)</th>
                  <th className="py-2 pr-3">Dressing %</th>
                  <th className="py-2 pr-3"></th>
                </tr>
              </thead>
              <tbody>
                {schedules.map((s) => {
                  const d = draftFor(s);
                  const numField = (key: keyof ProductionScheduleUpsertInput, value: any) => (
                    <input
                      type="number"
                      className="w-20 rounded border border-[#1e6bb833] px-1.5 py-1"
                      value={(d[key] as any) ?? value ?? ''}
                      onChange={(e) => setDraft(s.id, { [key]: e.target.value === '' ? null : Number(e.target.value) } as any)}
                    />
                  );
                  const dirty = Object.keys(d).length > 0;
                  return (
                    <tr key={s.id} className="border-b border-[#1e6bb81a]">
                      <td className="py-2 pr-3 font-medium text-avcs-text">{s.species}</td>
                      <td className="py-2 pr-3">{numField('weaning_days', s.weaning_days)}</td>
                      <td className="py-2 pr-3">{numField('post_weaning_days', s.post_weaning_days)}</td>
                      <td className="py-2 pr-3">{numField('feedlot_days', s.feedlot_days)}</td>
                      <td className="py-2 pr-3">{numField('processing_buffer_days', s.processing_buffer_days)}</td>
                      <td className="py-2 pr-3 text-avcs-muted">{s.total_days_to_available}d</td>
                      <td className="py-2 pr-3">
                        <input
                          type="number"
                          className="w-24 rounded border border-[#1e6bb833] px-1.5 py-1"
                          value={(d.target_live_weight_kg as any) ?? s.target_live_weight_kg ?? ''}
                          onChange={(e) => setDraft(s.id, { target_live_weight_kg: e.target.value === '' ? null : e.target.value })}
                        />
                      </td>
                      <td className="py-2 pr-3">
                        <input
                          type="number"
                          className="w-20 rounded border border-[#1e6bb833] px-1.5 py-1"
                          value={(d.dressing_percentage as any) ?? s.dressing_percentage ?? ''}
                          onChange={(e) => setDraft(s.id, { dressing_percentage: e.target.value === '' ? null : e.target.value })}
                        />
                      </td>
                      <td className="py-2 pr-3">
                        <button type="button" className="btn btn-primary" disabled={!dirty} onClick={() => saveSchedule(s)}>Save</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  const renderProductionSchedules = () => (
    <section className="flex flex-col gap-5 rounded-2xl border border-[#1e6bb824] bg-white p-5 md:p-6">
      <div>
        <h2 className="text-2xl font-semibold text-avcs-text">Animal estimates (growth schedules)</h2>
        <p className="mt-1 max-w-2xl text-sm text-avcs-muted">
          Per-species day offsets that power the availability forecast and Woolies stage report. Edit a
          value and click Save. Changes apply immediately to every forecast.
        </p>
      </div>
      {renderScheduleEditor()}
    </section>
  );

  const renderAbattoirSlaughter = () => {
    const todayIso = new Date().toISOString().slice(0, 10);
    const receipts = abattoirReceipts?.receipts ?? [];

    const keyFor = (r: AbattoirReceipt) => r.receipt_key;
    const defaultDateFor = (r: AbattoirReceipt) => r.receive_date || todayIso;
    // ONE blank shape, used by both the read and the write. They were written
    // out twice and drifted: the write path's copy had no `dressing`, so the
    // first keystroke on a receipt stored a draft without that key and
    // `draft.dressing.trim()` threw "Cannot read properties of undefined"
    // the moment Slaughter was pressed.
    const blankDraft = (r: AbattoirReceipt) => ({
      batch: '', ccm: '', date: defaultDateFor(r), dressing: '',
    });
    const draftFor = (r: AbattoirReceipt) => ({ ...blankDraft(r), ...(abattoirDrafts[keyFor(r)] ?? {}) });
    const setDraft = (
      r: AbattoirReceipt,
      patch: Partial<{ batch: string; ccm: string; date: string; dressing: string }>,
    ) => {
      const key = keyFor(r);
      setAbattoirDrafts((d) => ({
        ...d,
        [key]: { ...blankDraft(r), ...(d[key] ?? {}), ...patch },
      }));
    };

    const submit = async (receipt: AbattoirReceipt) => {
      const key = keyFor(receipt);
      const draft = draftFor(receipt);
      setAbattoirMsg('');
      if (!receipt.abattoir_entity_id) {
        setAbattoirError('This receipt is missing its abattoir link and can’t be slaughtered here.');
        return;
      }
      const awaitingIds = receipt.animals.filter((a) => a.awaiting).map((a) => a.id);
      if (awaitingIds.length === 0) {
        setAbattoirError('This receipt has no animals awaiting slaughter.');
        return;
      }
      if (!(draft.batch || '').trim()) {
        setAbattoirError('Enter a slaughter batch number first.');
        return;
      }
      const ccm = Number(draft.ccm);
      if (!Number.isFinite(ccm) || ccm <= 0) {
        setAbattoirError('Enter an average CCM greater than 0.');
        return;
      }
      const receivedOn = receipt.receive_date ? ` received ${receipt.receive_date}` : '';
      const goAhead = await confirmDialog({
        title: `Slaughter ${awaitingIds.length} animal(s) on this receipt?`,
        message: (
          <>
            {`At ${receipt.abattoir_entity_name ?? 'the abattoir'}${receivedOn}, batch "${(draft.batch || '').trim()}", average CCM ${ccm} kg. `}
            Each animal is set to slaughtered and a slaughter event is recorded.
          </>
        ),
        confirmLabel: `Slaughter ${awaitingIds.length}`,
      });
      if (!goAhead) return;
      setAbattoirSubmitting(key);
      setAbattoirError('');
      try {
        const res = await markBatchSlaughtered({
          deal_id: receipt.deal_id ?? '',
          abattoir_entity_id: receipt.abattoir_entity_id,
          slaughter_batch: (draft.batch || '').trim(),
          average_ccm: ccm,
          slaughter_date: draft.date || undefined,
          animal_ids: awaitingIds,
          batch_dressing_percent: (draft.dressing || '').trim() || undefined,
        });
        const dressing =
          res.average_dressing_percentage != null ? `${res.average_dressing_percentage}%` : '—';
        const acrossDeals = (res.deals_count ?? 1) > 1 ? ` across ${res.deals_count} deals` : '';
        let msg = `Slaughter event created for ${res.animals_marked} animal(s) in batch ${res.slaughter_batch}${acrossDeals}. ${res.batch_live_mass ? `Dressing ${dressing}, from the abattoir's batch figure.` : `Estimated average dressing ${dressing} from each animal's last weigh — enter the sheet's Slaughter % to use the abattoir's figure.`}`;
        if (res.animals_without_live_weight > 0) {
          msg += ` ${res.animals_without_live_weight} animal(s) had no recorded live weight, so their dressing % counted as 0 — check their weigh data.`;
        }
        setAbattoirMsg(msg);
        setAbattoirDrafts((d) => {
          const next = { ...d };
          delete next[key];
          return next;
        });
        await loadAbattoirReceipts();
      } catch (err: any) {
        setAbattoirError(parseApiError(err?.message) || err?.message || 'Could not create slaughter event.');
      } finally {
        setAbattoirSubmitting(null);
      }
    };

    return (
      <section className="flex flex-col gap-5 rounded-2xl border border-[#1e6bb824] bg-white p-5 md:p-6">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <h2 className="text-2xl font-semibold text-avcs-text">Abattoir slaughter</h2>
            <p className="mt-1 max-w-3xl text-sm text-avcs-muted">
              Abattoir <strong>receipts</strong> (receive events at an abattoir) with animals still
              awaiting slaughter — one card per physical receipt (a consolidated dispatch received
              across several deals shows as a single receipt, not one per deal). Use this when the
              abattoir slaughtered a receipt but didn't record each animal's EID: enter the{' '}
              <strong>slaughter batch number</strong> and the batch's <strong>average CCM</strong>{' '}
              (cold carcass mass), and a slaughter event is created for the animals still awaiting on
              that receipt, each with an estimated dressing % (average CCM ÷ that animal's last known
              live weight). A partly-processed receipt stays listed until every animal on it has been
              slaughtered. The slaughter date defaults to the receive date — adjust it if the kill
              happened later.
            </p>
          </div>
          <button
            type="button"
            className="btn"
            onClick={loadAbattoirReceipts}
            disabled={abattoirLoading}
          >
            {abattoirLoading ? 'Loading…' : 'Refresh'}
          </button>
        </div>

        {abattoirError && (
          <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-2 text-sm text-red-700">
            {abattoirError}
          </div>
        )}
        {abattoirMsg && (
          <div className="rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm text-emerald-800">
            {abattoirMsg}
          </div>
        )}

        <div className="mb-4 rounded-xl border border-[#1e6bb824] bg-[#fbfeff] p-3">
          <div className="text-sm font-semibold text-avcs-text">Correct a batch's live mass</div>
          <p className="mt-0.5 text-xs text-avcs-muted">
            A slaughter recorded without the sheet's figure divides each carcass by the animal's last feedlot weigh, which overstates dressing. Enter the abattoir's batch Slaughter % (or its live mass and carcass total) to re-derive every live weight in the batch.
          </p>
          <form
            className="mt-2 grid gap-3 sm:grid-cols-2 md:grid-cols-5 md:items-end"
            onSubmit={async (e) => {
              e.preventDefault();
              if (!liveMassForm.batch.trim() || (!liveMassForm.dressing && !liveMassForm.liveMass)) {
                setAbattoirError('Enter the batch number and either the sheet dressing % or the live mass.');
                return;
              }
              setLiveMassBusy(true);
              setAbattoirError('');
              try {
                const preview = await applyBatchLiveMass({
                  slaughter_batch: liveMassForm.batch.trim(),
                  dressing_percent: liveMassForm.dressing || undefined,
                  live_mass_kg: liveMassForm.liveMass || undefined,
                  carcass_mass_kg: liveMassForm.carcassMass || undefined,
                  dry_run: true,
                });
                const ok = await confirmDialog({
                  title: `Re-derive ${preview.records_updated} live weight(s) in batch ${preview.slaughter_batch}?`,
                  message: `Across ${preview.deals.join(', ') || 'no deal'}. Dressing moves from ${preview.dressing_before ?? '—'}% to ${preview.dressing_percent}%.`,
                  confirmLabel: 'Apply',
                });
                if (!ok) return;
                const res = await applyBatchLiveMass({
                  slaughter_batch: liveMassForm.batch.trim(),
                  dressing_percent: liveMassForm.dressing || undefined,
                  live_mass_kg: liveMassForm.liveMass || undefined,
                  carcass_mass_kg: liveMassForm.carcassMass || undefined,
                });
                setAbattoirMsg(`Batch ${res.slaughter_batch}: ${res.records_updated} live weight(s) re-derived at ${res.dressing_percent}% dressing (was ${res.dressing_before ?? '—'}%).${res.records_without_ccm ? ` ${res.records_without_ccm} record(s) had no CCM and were left alone.` : ''}`);
                setLiveMassForm({ batch: '', dressing: '', liveMass: '', carcassMass: '' });
              } catch (err: any) {
                setAbattoirError(parseApiError(err?.message) || err?.message || 'Could not apply the batch live mass.');
              } finally {
                setLiveMassBusy(false);
              }
            }}
          >
            <label className="flex flex-col gap-1 text-sm">
              <span className="font-medium text-avcs-muted">Batch number</span>
              <input type="text" className="rounded border border-[#1e6bb833] px-2 py-1.5" value={liveMassForm.batch} onChange={(e) => setLiveMassForm((f) => ({ ...f, batch: e.target.value }))} />
            </label>
            <label className="flex flex-col gap-1 text-sm">
              <span className="font-medium text-avcs-muted">Sheet dressing %</span>
              <input type="number" min={20} max={80} step="0.01" className="rounded border border-[#1e6bb833] px-2 py-1.5" value={liveMassForm.dressing} placeholder="e.g. 48.07" onChange={(e) => setLiveMassForm((f) => ({ ...f, dressing: e.target.value }))} />
            </label>
            <label className="flex flex-col gap-1 text-sm">
              <span className="font-medium text-avcs-muted">or live mass (kg)</span>
              <input type="number" min={0} step="0.1" className="rounded border border-[#1e6bb833] px-2 py-1.5" value={liveMassForm.liveMass} placeholder="e.g. 5545" onChange={(e) => setLiveMassForm((f) => ({ ...f, liveMass: e.target.value }))} />
            </label>
            <label className="flex flex-col gap-1 text-sm">
              <span className="font-medium text-avcs-muted">Sheet carcass total (kg)</span>
              <input type="number" min={0} step="0.1" className="rounded border border-[#1e6bb833] px-2 py-1.5" value={liveMassForm.carcassMass} placeholder="e.g. 2665.0" onChange={(e) => setLiveMassForm((f) => ({ ...f, carcassMass: e.target.value }))} />
            </label>
            <button type="submit" className="btn btn-primary" disabled={liveMassBusy}>{liveMassBusy ? 'Working…' : 'Preview and apply'}</button>
          </form>
        </div>

        {abattoirLoading && !abattoirReceipts ? (
          <p className="text-sm text-avcs-muted">Loading abattoir receipts…</p>
        ) : receipts.length === 0 ? (
          <p className="rounded-xl border border-[#1e6bb81a] bg-[#f8fafc] px-4 py-6 text-center text-sm text-avcs-muted">
            No abattoir receipts have animals waiting to be slaughtered.
          </p>
        ) : (
          <div className="flex flex-col gap-4">
            <p className="text-sm text-avcs-muted">
              {abattoirReceipts?.total_awaiting} animal(s) awaiting slaughter across {receipts.length}{' '}
              receipt(s)
              {abattoirReceipts?.as_of_date ? ` · as of ${abattoirReceipts.as_of_date}` : ''}.
            </p>
            {receipts.map((receipt) => {
              const key = keyFor(receipt);
              const draft = draftFor(receipt);
              const busy = abattoirSubmitting === key;
              return (
                <div
                  key={key}
                  className="rounded-xl border border-[#1e6bb81a] bg-[#f8fafc] p-4"
                >
                  <div className="flex flex-wrap items-baseline justify-between gap-2">
                    <div>
                      <h3 className="text-lg font-semibold text-avcs-text">
                        {receipt.abattoir_entity_name ?? 'Abattoir'}
                        {receipt.receive_date ? (
                          <span className="ml-2 text-sm font-normal text-avcs-muted">
                            received {receipt.receive_date}
                          </span>
                        ) : null}
                      </h3>
                      {receipt.deals.length > 1 ? (
                        <>
                          <div className="text-sm text-avcs-muted">
                            {receipt.deals.length} deals · {receipt.species ?? '—'}
                            {receipt.source_entity_name ? ` · from ${receipt.source_entity_name}` : ''}
                            {receipt.session_label ? ` · ${receipt.session_label}` : ''}
                          </div>
                          <div className="mt-1 flex flex-wrap gap-x-3 gap-y-0.5 text-xs text-avcs-muted">
                            {receipt.deals.map((d) => (
                              <span key={d.deal_id ?? d.deal_no ?? Math.random()}>
                                {d.deal_no ?? 'Unlinked deal'}
                                {d.primary_producer_name ? ` · ${d.primary_producer_name}` : ''} ({d.awaiting_count})
                              </span>
                            ))}
                          </div>
                        </>
                      ) : (
                        <div className="text-sm text-avcs-muted">
                          {receipt.deal_no ?? 'Unlinked deal'} · {receipt.primary_producer_name ?? '—'}{' '}
                          · {receipt.species ?? '—'}
                          {receipt.source_entity_name ? ` · from ${receipt.source_entity_name}` : ''}
                          {receipt.session_label ? ` · ${receipt.session_label}` : ''}
                        </div>
                      )}
                    </div>
                    <span className="text-sm text-avcs-muted">
                      {receipt.awaiting_count} awaiting
                      {receipt.slaughtered_count > 0
                        ? ` · ${receipt.slaughtered_count} already slaughtered`
                        : ''}
                      {' · '}
                      {receipt.total_count} in receipt
                    </span>
                  </div>

                  <div className="mt-3 flex flex-col gap-3 rounded-lg border border-[#1e6bb81a] bg-white p-3 md:flex-row md:items-end md:justify-between">
                    <div className="text-sm">
                      <div className="font-medium text-avcs-text">
                        {receipt.awaiting_count} animal(s) awaiting slaughter
                      </div>
                      {receipt.slaughtered_count > 0 ? (
                        <div className="text-avcs-muted">
                          {receipt.slaughtered_count} of {receipt.total_count} on this receipt already slaughtered.
                        </div>
                      ) : null}
                    </div>
                    <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-5 md:items-end">
                      <label className="flex flex-col gap-1 text-sm">
                        <span className="font-medium text-avcs-muted">Batch number</span>
                        <input
                          type="text"
                          className="rounded border border-[#1e6bb833] px-2 py-1.5"
                          value={draft.batch}
                          placeholder="e.g. SB-2026-07"
                          onChange={(e) => setDraft(receipt, { batch: e.target.value })}
                        />
                      </label>
                      <label className="flex flex-col gap-1 text-sm">
                        <span className="font-medium text-avcs-muted">Average CCM (kg)</span>
                        <input
                          type="number"
                          min={0}
                          step="0.1"
                          className="rounded border border-[#1e6bb833] px-2 py-1.5"
                          value={draft.ccm}
                          placeholder="e.g. 22.5"
                          onChange={(e) => setDraft(receipt, { ccm: e.target.value })}
                        />
                      </label>
                      <label className="flex flex-col gap-1 text-sm">
                        <span className="font-medium text-avcs-muted">Slaughter date</span>
                        <input
                          type="date"
                          className="rounded border border-[#1e6bb833] px-2 py-1.5"
                          value={draft.date}
                          onChange={(e) => setDraft(receipt, { date: e.target.value })}
                        />
                      </label>
                      <label className="flex flex-col gap-1 text-sm">
                        <span className="font-medium text-avcs-muted">Sheet dressing % <span className="font-normal">(optional)</span></span>
                        <input
                          type="number"
                          min={20}
                          max={80}
                          step="0.01"
                          className="rounded border border-[#1e6bb833] px-2 py-1.5"
                          value={draft.dressing}
                          placeholder="e.g. 48.07"
                          title="The abattoir's batch Slaughter % — derives each live weight so dressing reads what the abattoir measured"
                          onChange={(e) => setDraft(receipt, { dressing: e.target.value })}
                        />
                      </label>
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={busy}
                        onClick={() => submit(receipt)}
                      >
                        {busy ? 'Creating…' : `Slaughter ${receipt.awaiting_count}`}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>
    );
  };

  const renderAvailabilityForecast = () => {
    const runForecast = async () => {
      setForecastLoading(true);
      setForecastError('');
      try {
        const bufferDays = forecastFilters.bufferDays.trim()
          ? Number(forecastFilters.bufferDays)
          : undefined;
        const data = await fetchAvailabilityForecast({
          species: forecastFilters.species || undefined,
          valueChainId: forecastFilters.valueChainId || undefined,
          dealId: forecastFilters.dealId || undefined,
          bufferDays: Number.isFinite(bufferDays as number) ? (bufferDays as number) : undefined,
          includeSlaughtered: forecastFilters.includeSlaughtered,
          includeAnimals: true,
        });
        setForecast(data);
      } catch (error: any) {
        setForecast(null);
        setForecastError(parseApiError(error?.message) || error?.message || 'Could not load forecast.');
      } finally {
        setForecastLoading(false);
      }
    };

    const monthLabel = (m: string) => {
      const [y, mo] = m.split('-');
      const d = new Date(Number(y), Number(mo) - 1, 1);
      return d.toLocaleDateString('en-ZA', { month: 'short', year: 'numeric' });
    };
    const maxCount = Math.max(1, ...(forecast?.timeline.map((b) => b.animal_count) ?? [1]));
    const fmt1 = (v: number | null | undefined) => (v != null ? Number(v).toFixed(1) : '—');
    const basisLabel: Record<string, string> = {
      actual_slaughter: 'Slaughtered (actual)',
      actual_feedlot: 'In feedlot (measured)',
      projected_from_dob: 'Projected from birth',
      insufficient_data: 'No birth date / events',
      no_template: 'No species schedule',
    };

    return (
      <section className="flex flex-col gap-5 rounded-2xl border border-[#1e6bb824] bg-white p-5 md:p-6">
        <div>
          <h2 className="text-2xl font-semibold text-avcs-text">Availability forecast</h2>
          <p className="mt-1 max-w-2xl text-sm text-avcs-muted">
            Predicts when each animal's meat becomes available downstream (after the abattoir), so a
            retailer or butcher can plan supply. Estimates anchor on real feedlot/slaughter events
            where they exist, otherwise project forward from birth using the species growth schedule.
          </p>
        </div>

        {/* Filters */}
        <div className="grid gap-3 rounded-xl border border-[#1e6bb81a] bg-[#f8fafc] p-4 md:grid-cols-5">
          <label className="flex flex-col gap-1 text-sm">
            <span className="font-medium text-avcs-muted">Species</span>
            <select
              className="rounded border border-[#1e6bb833] px-2 py-1.5"
              value={forecastFilters.species}
              onChange={(e) => setForecastFilters((f) => ({ ...f, species: e.target.value }))}
            >
              <option value="">All species</option>
              <option value="SHEEP">Sheep</option>
              <option value="GOAT">Goat</option>
              <option value="CATTLE">Cattle</option>
            </select>
          </label>
          <label className="flex flex-col gap-1 text-sm">
            <span className="font-medium text-avcs-muted">Supply Chain Program</span>
            <select
              className="rounded border border-[#1e6bb833] px-2 py-1.5"
              value={forecastFilters.valueChainId}
              onChange={(e) => setForecastFilters((f) => ({ ...f, valueChainId: e.target.value }))}
            >
              <option value="">All supply chain programs</option>
              {valueChains.map((vc) => (
                <option key={vc.id} value={vc.id}>{vc.name}</option>
              ))}
            </select>
          </label>
          <label className="flex flex-col gap-1 text-sm">
            <span className="font-medium text-avcs-muted">Deal</span>
            <select
              className="rounded border border-[#1e6bb833] px-2 py-1.5"
              value={forecastFilters.dealId}
              onChange={(e) => setForecastFilters((f) => ({ ...f, dealId: e.target.value }))}
            >
              <option value="">All deals</option>
              {deals.map((d) => (
                <option key={d.dealId} value={d.dealId}>{d.title || d.dealRefNo || d.dealId}</option>
              ))}
            </select>
          </label>
          <label className="flex flex-col gap-1 text-sm">
            <span className="font-medium text-avcs-muted">Buffer days (override)</span>
            <input
              type="number"
              min={0}
              placeholder="schedule default"
              className="rounded border border-[#1e6bb833] px-2 py-1.5"
              value={forecastFilters.bufferDays}
              onChange={(e) => setForecastFilters((f) => ({ ...f, bufferDays: e.target.value }))}
            />
          </label>
          <div className="flex flex-col justify-end gap-2">
            <label className="flex items-center gap-2 text-sm text-avcs-muted">
              <input
                type="checkbox"
                checked={forecastFilters.includeSlaughtered}
                onChange={(e) => setForecastFilters((f) => ({ ...f, includeSlaughtered: e.target.checked }))}
              />
              Include already-slaughtered
            </label>
            <button type="button" className="btn btn-primary" onClick={runForecast} disabled={forecastLoading}>
              {forecastLoading ? 'Loading…' : 'Run forecast'}
            </button>
          </div>
        </div>

        {forecastError && <div className="rounded border border-red-300 bg-red-50 p-3 text-sm text-red-700">{forecastError}</div>}

        {forecast && (
          <>
            {/* Summary cards */}
            <div className="grid gap-4 md:grid-cols-4">
              <div className="border border-[#1e6bb824] bg-white p-5">
                <div className="text-4xl font-bold leading-none text-avcs-text">{fmtNum(forecast.forecastable_animals)}</div>
                <div className="mt-3 text-sm font-semibold uppercase tracking-wide text-avcs-muted">Animals forecast</div>
              </div>
              <div className="border border-[#1e6bb824] bg-white p-5">
                <div className="text-4xl font-bold leading-none text-avcs-text">
                  {forecast.estimated_total_carcass_weight_kg != null ? `${fmtNum(Math.round(forecast.estimated_total_carcass_weight_kg))} kg` : '—'}
                </div>
                <div className="mt-3 text-sm font-semibold uppercase tracking-wide text-avcs-muted">Est. carcass weight</div>
              </div>
              <div className="border border-[#1e6bb824] bg-white p-5">
                <div className="text-4xl font-bold leading-none text-avcs-text">{fmtNum(forecast.unschedulable_animals)}</div>
                <div className="mt-3 text-sm font-semibold uppercase tracking-wide text-avcs-muted">Not schedulable</div>
              </div>
              <div className="border border-[#1e6bb824] bg-white p-5">
                <div className="text-sm text-avcs-muted">As of {forecast.as_of_date}</div>
                {forecast.species_without_templates.length > 0 && (
                  <div className="mt-2 text-xs text-amber-700">
                    No schedule for: {forecast.species_without_templates.join(', ')}
                  </div>
                )}
              </div>
            </div>

            {/* Monthly timeline */}
            <div>
              <h3 className="mb-2 text-lg font-semibold text-avcs-text">Availability by month</h3>
              {forecast.timeline.length === 0 ? (
                <div className="rounded border border-[#1e6bb81a] bg-[#f8fafc] p-4 text-sm text-avcs-muted">
                  No animals could be scheduled for the current filters.
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full min-w-[560px] border-collapse text-sm">
                    <thead>
                      <tr className="border-b border-[#1e6bb824] text-left text-avcs-muted">
                        <th className="py-2 pr-3">Month</th>
                        <th className="py-2 pr-3">Animals</th>
                        <th className="py-2 pr-3 w-1/2">Volume</th>
                        <th className="py-2 pr-3">Est. carcass (kg)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {forecast.timeline.map((b) => (
                        <tr key={b.month} className="border-b border-[#1e6bb81a]">
                          <td className="py-2 pr-3 font-medium text-avcs-text">{monthLabel(b.month)}</td>
                          <td className="py-2 pr-3 font-semibold text-avcs-text">{fmtNum(b.animal_count)}</td>
                          <td className="py-2 pr-3">
                            <div className="h-3 rounded bg-[#1e6bb81a]">
                              <div
                                className="h-3 rounded bg-avcs-primary"
                                style={{ width: `${Math.round((b.animal_count / maxCount) * 100)}%`, backgroundColor: '#1e6bb8' }}
                              />
                            </div>
                          </td>
                          <td className="py-2 pr-3 text-avcs-text">{b.estimated_carcass_weight_kg != null ? fmtNum(Math.round(b.estimated_carcass_weight_kg)) : '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* Per-animal drilldown */}
            {forecast.animals && forecast.animals.length > 0 && (
              <div>
                <button
                  type="button"
                  className="btn"
                  onClick={() => setForecastShowAnimals((v) => !v)}
                >
                  {forecastShowAnimals ? 'Hide' : 'Show'} per-animal detail ({forecast.animals.length})
                </button>
                {forecastShowAnimals && (
                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full min-w-[720px] border-collapse text-sm">
                      <thead>
                        <tr className="border-b border-[#1e6bb824] text-left text-avcs-muted">
                          <th className="py-2 pr-3">Animal</th>
                          <th className="py-2 pr-3">Species</th>
                          <th className="py-2 pr-3">Deal</th>
                          <th className="py-2 pr-3">Available</th>
                          <th className="py-2 pr-3">Days out</th>
                          <th className="py-2 pr-3">Basis</th>
                        </tr>
                      </thead>
                      <tbody>
                        {forecast.animals.slice(0, 500).map((a) => (
                          <tr key={a.animal_id} className="border-b border-[#1e6bb81a]">
                            <td className="py-2 pr-3 text-avcs-text">{a.eid_tag || a.vid || a.animal_id.slice(0, 8)}</td>
                            <td className="py-2 pr-3 text-avcs-muted">{a.species}</td>
                            <td className="py-2 pr-3 text-avcs-muted">{a.deal_no || '—'}</td>
                            <td className="py-2 pr-3 text-avcs-text">{a.available_date || '—'}</td>
                            <td className="py-2 pr-3 text-avcs-muted">{a.days_until_available != null ? a.days_until_available : '—'}</td>
                            <td className="py-2 pr-3 text-avcs-muted">{basisLabel[a.basis] || a.basis}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {forecast.animals.length > 500 && (
                      <div className="mt-2 text-xs text-avcs-muted">Showing first 500 of {forecast.animals.length} animals.</div>
                    )}
                  </div>
                )}
              </div>
            )}
          </>
        )}

      </section>
    );
  };

  const renderWooliesStageForecast = () => {
    const STAGE_LABELS: Record<string, string> = {
      pre_weaning: 'Pre-weaning',
      growing: 'Backgrounding',
      in_feedlot: 'In feedlot',
      slaughter_ready: 'Slaughter-ready',
      available: 'Available',
    };
    const stages = wooliesStage?.stages ?? Object.keys(STAGE_LABELS);

    const runStageForecast = async () => {
      setWooliesStageLoading(true);
      setWooliesStageError('');
      try {
        const data = await fetchWooliesStageForecast({
          months: wooliesStageMonths,
          species: wooliesStageSpecies || undefined,
          includeAnimals: true,
        });
        setWooliesStage(data);
        setWooliesStageShowAnimals(false);  // start on the summary
        setWooliesAnimalsPage(1);
      } catch (error: any) {
        setWooliesStage(null);
        setWooliesStageError(parseApiError(error?.message) || error?.message || 'Could not load stage forecast.');
      } finally {
        setWooliesStageLoading(false);
      }
    };

    const monthLabel = (m: string) => {
      const [y, mo] = m.split('-');
      return new Date(Number(y), Number(mo) - 1, 1).toLocaleDateString('en-ZA', { month: 'short', year: 'numeric' });
    };

    return (
      <section className="flex flex-col gap-5 rounded-2xl border border-[#1e6bb824] bg-white p-5 md:p-6">
        <div>
          <h2 className="text-2xl font-semibold text-avcs-text">Woolies stage forecast</h2>
          <p className="mt-1 max-w-2xl text-sm text-avcs-muted">
            Month-by-month projection of where every Woolies producer's animals sit in the supply chain program
            (pre-weaning → growing → in feedlot → slaughter-ready → available), broken down by species,
            snapshot at the 1st of each month.
          </p>
        </div>

        <div className="flex flex-wrap items-end gap-3 rounded-xl border border-[#1e6bb81a] bg-[#f8fafc] p-4">
          <label className="flex flex-col gap-1 text-sm">
            <span className="font-medium text-avcs-muted">Species</span>
            <select
              className="rounded border border-[#1e6bb833] px-2 py-1.5"
              value={wooliesStageSpecies}
              onChange={(e) => setWooliesStageSpecies(e.target.value)}
            >
              <option value="">All species</option>
              <option value="SHEEP">Sheep</option>
              <option value="GOAT">Goat</option>
              <option value="CATTLE">Cattle</option>
            </select>
          </label>
          <label className="flex flex-col gap-1 text-sm">
            <span className="font-medium text-avcs-muted">Months ahead</span>
            <input
              type="number"
              min={1}
              max={60}
              className="w-24 rounded border border-[#1e6bb833] px-2 py-1.5"
              value={wooliesStageMonths}
              onChange={(e) => setWooliesStageMonths(Math.max(1, Number(e.target.value) || 12))}
            />
          </label>
          <button type="button" className="btn btn-primary" onClick={runStageForecast} disabled={wooliesStageLoading}>
            {wooliesStageLoading ? 'Loading…' : 'Run report'}
          </button>
        </div>

        {wooliesStageError && <div className="rounded border border-red-300 bg-red-50 p-3 text-sm text-red-700">{wooliesStageError}</div>}

        {wooliesStage && (
          <>
            <div className="text-sm text-avcs-muted">
              {fmtNum(wooliesStage.total_animals)} animals across Woolies producers · as of {wooliesStage.as_of_date}
              {wooliesStage.unschedulable_animals > 0 && <> · {fmtNum(wooliesStage.unschedulable_animals)} not schedulable</>}
              {wooliesStage.species_without_templates.length > 0 && (
                <span className="text-amber-700"> · no schedule for: {wooliesStage.species_without_templates.join(', ')}</span>
              )}
            </div>

            {wooliesStage.total_animals === 0 ? (
              <div className="rounded border border-[#1e6bb81a] bg-[#f8fafc] p-4 text-sm text-avcs-muted">
                No animals found for Woolies producers. Flag a producer entity as "Woolies producer" and register animals against its deals.
              </div>
            ) : (
              <>
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <span className="text-sm font-semibold text-avcs-text">
                    {wooliesStageShowAnimals ? `Animal list (${fmtNum(wooliesStage.animals?.length ?? 0)})` : 'Monthly summary'}
                  </span>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => { setWooliesStageShowAnimals((v) => !v); setWooliesAnimalsPage(1); }}
                  >
                    {wooliesStageShowAnimals ? '← Back to summary' : 'View animals →'}
                  </button>
                </div>

                {!wooliesStageShowAnimals && (
                <div className="overflow-x-auto">
                <table className="w-full min-w-[760px] border-collapse text-sm">
                  <thead>
                    <tr className="border-b border-[#1e6bb824] text-left text-avcs-muted">
                      <th className="py-2 pr-3">Month</th>
                      <th className="py-2 pr-3">Species</th>
                      {stages.map((s) => <th key={s} className="py-2 pr-3 text-right">{STAGE_LABELS[s] || s}</th>)}
                      <th className="py-2 pr-3 text-right">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {wooliesStage.timeline.map((row) => {
                      const speciesKeys = Object.keys(row.by_species);
                      const rows: JSX.Element[] = [];
                      speciesKeys.forEach((sp, idx) => {
                        const counts = row.by_species[sp];
                        const spTotal = stages.reduce((sum, s) => sum + (counts[s] || 0), 0);
                        rows.push(
                          <tr key={`${row.month}-${sp}`} className="border-b border-[#1e6bb81a]">
                            <td className="py-1.5 pr-3 font-medium text-avcs-text">{idx === 0 ? monthLabel(row.month) : ''}</td>
                            <td className="py-1.5 pr-3 text-avcs-muted">{sp.charAt(0) + sp.slice(1).toLowerCase()}</td>
                            {stages.map((s) => <td key={s} className="py-1.5 pr-3 text-right text-avcs-text">{counts[s] ? fmtNum(counts[s]) : '·'}</td>)}
                            <td className="py-1.5 pr-3 text-right font-semibold text-avcs-text">{fmtNum(spTotal)}</td>
                          </tr>
                        );
                      });
                      if (speciesKeys.length === 0) {
                        rows.push(
                          <tr key={`${row.month}-empty`} className="border-b border-[#1e6bb81a]">
                            <td className="py-1.5 pr-3 font-medium text-avcs-text">{monthLabel(row.month)}</td>
                            <td className="py-1.5 pr-3 text-avcs-muted" colSpan={stages.length + 2}>—</td>
                          </tr>
                        );
                      } else if (speciesKeys.length > 1) {
                        rows.push(
                          <tr key={`${row.month}-total`} className="border-b border-[#1e6bb824] bg-[#f8fafc]">
                            <td className="py-1.5 pr-3"></td>
                            <td className="py-1.5 pr-3 text-xs font-semibold uppercase tracking-wide text-avcs-muted">Total</td>
                            {stages.map((s) => <td key={s} className="py-1.5 pr-3 text-right font-semibold text-avcs-text">{row.totals[s] ? fmtNum(row.totals[s]) : '·'}</td>)}
                            <td className="py-1.5 pr-3 text-right font-bold text-avcs-text">{fmtNum(row.total_animals)}</td>
                          </tr>
                        );
                      }
                      return rows;
                    })}
                  </tbody>
                </table>
                </div>
                )}

                {wooliesStageShowAnimals && wooliesStage.animals && (
                  <div>
                    <p className="mb-3 text-sm text-avcs-muted">
                      Every upcoming animal with its estimated slaughter date. Sorted soonest first;
                      "actual" means the date is anchored on a real feedlot/abattoir event, "projected" on the growth schedule.
                    </p>
                    {(() => {
                      const all = wooliesStage.animals!;
                      const totalPages = Math.max(1, Math.ceil(all.length / WOOLIES_ANIMALS_PAGE_SIZE));
                      const page = Math.min(wooliesAnimalsPage, totalPages);
                      const start = (page - 1) * WOOLIES_ANIMALS_PAGE_SIZE;
                      const pageRows = all.slice(start, start + WOOLIES_ANIMALS_PAGE_SIZE);
                      return (
                        <>
                          <div className="overflow-x-auto">
                            <table className="w-full min-w-[820px] border-collapse text-sm">
                              <thead>
                                <tr className="border-b border-[#1e6bb824] text-left text-avcs-muted">
                                  <th className="py-2 pr-3">EID / VID</th>
                                  <th className="py-2 pr-3">Species</th>
                                  <th className="py-2 pr-3">Deal</th>
                                  <th className="py-2 pr-3">Producer</th>
                                  <th className="py-2 pr-3">DOB</th>
                                  <th className="py-2 pr-3">Current stage</th>
                                  <th className="py-2 pr-3">Est. slaughter date</th>
                                  <th className="py-2 pr-3">Est. available</th>
                                </tr>
                              </thead>
                              <tbody>
                                {pageRows.map((a) => (
                                  <tr key={a.animal_id} className="border-b border-[#1e6bb81a]">
                                    <td className="py-1.5 pr-3 font-medium text-avcs-text">{a.eid_tag || a.vid || '—'}</td>
                                    <td className="py-1.5 pr-3 text-avcs-muted">{a.species.charAt(0) + a.species.slice(1).toLowerCase()}</td>
                                    <td className="py-1.5 pr-3 text-avcs-muted">{a.deal_no || '—'}</td>
                                    <td className="py-1.5 pr-3 text-avcs-muted">{a.producer_name || '—'}</td>
                                    <td className="py-1.5 pr-3 text-avcs-muted">{a.dob || '—'}</td>
                                    <td className="py-1.5 pr-3 text-avcs-muted">
                                      {a.current_stage ? (STAGE_LABELS[a.current_stage] || a.current_stage) : '—'}
                                    </td>
                                    <td className="py-1.5 pr-3 text-avcs-text">
                                      {a.estimated_slaughter_date || '—'}
                                      {a.slaughter_basis && (
                                        <span className="ml-1 text-xs text-avcs-muted">({a.slaughter_basis})</span>
                                      )}
                                    </td>
                                    <td className="py-1.5 pr-3 text-avcs-muted">{a.estimated_available_date || '—'}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="mt-3 flex flex-wrap items-center justify-between gap-2 text-sm">
                            <span className="text-avcs-muted">
                              Showing {fmtNum(start + 1)}–{fmtNum(start + pageRows.length)} of {fmtNum(all.length)}
                            </span>
                            <div className="flex items-center gap-2">
                              <button type="button" className="btn" disabled={page <= 1} onClick={() => setWooliesAnimalsPage(page - 1)}>← Prev</button>
                              <span className="text-avcs-muted">Page {page} of {totalPages}</span>
                              <button type="button" className="btn" disabled={page >= totalPages} onClick={() => setWooliesAnimalsPage(page + 1)}>Next →</button>
                            </div>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                )}
              </>
            )}
          </>
        )}
      </section>
    );
  };

  const renderMainContent = () => {
    if (loadingDeals) {
      return <section className="rounded-2xl border border-[#1e6bb824] bg-white p-5 text-sm text-avcs-muted">Loading admin data…</section>;
    }

    if (view === 'dashboard') return renderDashboard();
    if (view === 'dealList') return renderDealList();
    if (view === 'dealSummary') return renderDealSummary();
    if (view === 'dealCreate') return renderNewDealFlow();
    if (view === 'documentsList') return renderDocumentsList();
    if (view === 'documentUpload') return renderDocumentUpload();
    if (view === 'documentSearch') return renderDocumentSearch();
    if (view === 'feedCrud') return renderFeedCrud();
    if (view === 'sharedCosts') return <SharedFeedlotCosts />;
    if (view === 'addFeed') return renderAddFeed();
    if (view === 'addWool') return renderAddWool();
    if (view === 'animalList') return renderAnimalList();
    if (view === 'animalRegister') return renderAnimalRegister();
    if (view === 'gs1Gln') return renderGs1Codes('GLN');
    if (view === 'gs1Gtin') return renderGs1Codes('GTIN');
    if (view === 'entityCrud') return renderEntityCrud();
    if (view === 'entityForm') return renderEntityForm();
    if (view === 'entityContacts') return renderEntityContacts();
    if (view === 'entityContactForm') return renderEntityContactForm();
    if (view === 'userManagement') return renderUserManagement();
    if (view === 'integrations') return renderIntegrations();
    if (view === 'fieldMappings') return <FieldMappingsAdmin requestConfirm={requestConfirm} />;
    if (view.startsWith('rmisAtp')) return <RmisAtpConsole view={view} />;
    if (view === 'uatConsole') return <UatConsole
      onOpenDeal={(dealId) => { setSelectedDealId(dealId); setView('dealSummary'); }}
      onOpenDocuments={(dealId) => { setDocumentForm((prev) => ({ ...prev, dealId })); setView('documentUpload'); }}
    />;
    if (view === 'breedCrud') return renderBreedCrud();
    if (view === 'valueChainCrud') return renderValueChainCrud();
    if (view === 'productTypeCrud') return renderProductTypeCrud();
    if (view === 'medicineCrud') return renderMedicineCrud();
    if (view === 'equipmentAllocation') return renderEquipmentAllocation();
    if (view === 'woolClassCrud') return renderWoolClassCrud();
    if (view === 'documentTypeCrud') return renderDocumentTypeCrud();
    if (view === 'woolBales') return renderWoolBales();
    if (view === 'dataSessionUpload') return renderDataSessionUpload();
    if (view === 'eventHistory') return renderEventHistory();
    if (view === 'abattoirSlaughter') return renderAbattoirSlaughter();
    if (view === 'unprocessedRecords') return renderUnprocessedRecords();
    if (view === 'unlinkedAnimals') return renderUnlinkedAnimals();
    if (view === 'needsReview') return renderNeedsReview();
    if (view === 'journeyHistory') return renderJourneyHistory();
    if (view === 'transportJourneys') return renderTransportJourneys();
    if (view === 'weighbridgeHistory') return renderWeighbridgeHistory();
    if (view === 'weighbridgeNew') return renderWeighbridgeNew();
    if (view === 'courierManagement') return renderCourierManagement();
    if (view === 'costReports') return renderCostReports();
    if (view === 'scpAnalysis') return renderScpAnalysis();
    if (view === 'performanceReport') return renderPerformanceReport();
    if (view === 'availabilityForecast') return renderAvailabilityForecast();
    if (view === 'wooliesStageForecast') return renderWooliesStageForecast();
    if (view === 'productionSchedules') return renderProductionSchedules();
    if (view === 'animalCrud') return renderAnimalCrud();
    // Unknown view — return to dashboard rather than silently rendering a random screen
    return renderDashboard();
  };

  return (
    <main className="admin-screen">
      {ingestInFlight && (
        <div
          className="fixed inset-x-0 top-0 z-[200] flex items-center justify-center gap-2 bg-[#0f3b64] px-4 py-2 text-center text-sm font-medium text-white shadow-lg"
          role="status"
          aria-live="polite"
        >
          <svg className="animate-spin flex-shrink-0" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.3" strokeWidth="3" />
            <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
          </svg>
          {confirmingDraft
            ? 'Creating records — this keeps running even if you move to another screen. Please keep this tab open until it finishes.'
            : 'Uploading data — please keep this tab open…'}
        </div>
      )}
      <header className="page-header mb-5 rounded-2xl border border-[#1e6bb824] bg-white p-4 md:p-5">
        <div className="flex items-center gap-3">
          <button
            className="admin-hamburger lg:hidden"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open navigation menu"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
              <line x1="2" y1="4.5" x2="16" y2="4.5"/>
              <line x1="2" y1="9" x2="16" y2="9"/>
              <line x1="2" y1="13.5" x2="16" y2="13.5"/>
            </svg>
          </button>
          <div className="admin-header-title">
            <h1>Admin Operations</h1>
            <p>| AVCS data management platform</p>
          </div>
        </div>
        <button
          className="ml-auto flex-shrink-0 inline-flex items-center gap-2 rounded-lg border border-[#1e6bb84d] bg-[#f7fbff] px-3 py-2 text-sm font-semibold text-[#0f3b64] transition hover:-translate-y-px hover:bg-white hover:shadow"
          onClick={logout}
        >
          <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M6 14H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3"/>
            <polyline points="10 11 13 8 10 5"/>
            <line x1="13" y1="8" x2="6" y2="8"/>
          </svg>
          Sign out
        </button>
      </header>

      {sidebarOpen && (
        <div
          className="admin-sidebar-backdrop"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      <div className="admin-shell grid gap-4 lg:grid-cols-[260px_minmax(0,1fr)]">
        <aside className={`admin-menu rounded-2xl border border-[#1e6bb824] bg-white shadow-sm${sidebarOpen ? ' admin-menu-open' : ''}`}>
          <nav className="admin-menu-nav p-3">
            <div className="admin-menu-list grid gap-2">
              {menuGroups.map((group) => {
                const isOpen = openGroups.has(group.heading);
                return (
                  <div key={group.heading} className="admin-menu-group">
                    <div className="admin-menu-heading-wrap">
                      <button
                        className={`admin-menu-heading${group.helpText ? ' has-hint' : ''}`}
                        onClick={() => {
                          setOpenGroups((prev) => {
                            const next = new Set(prev);
                            if (next.has(group.heading)) next.delete(group.heading);
                            else next.add(group.heading);
                            return next;
                          });
                        }}
                        aria-expanded={isOpen}
                      >
                        <span className="admin-menu-heading-icon">
                          {NAV_ICONS[group.heading]}
                        </span>
                        <span className="text-left">{group.heading}</span>
                        {group.helpText && (
                          <span className="admin-menu-heading-hint">
                            <InfoHint text={group.helpText} />
                          </span>
                        )}
                        <span className="flex-1" aria-hidden="true" />
                        <span className={`admin-menu-chevron${isOpen ? ' is-open' : ''}`}>
                          <svg width="11" height="11" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <polyline points="2 4 6 8 10 4"/>
                          </svg>
                        </span>
                      </button>
                    </div>
                    {isOpen && (
                      <div className="admin-menu-sublist">
                        {group.items.map((item) => {
                          const openMenuItem = () => {
                            setActiveMenuItemId(item.id);
                            if (item.id === 'deals-create') {
                              resetNewDealFlow();
                            }
                            if (item.id === 'entity-contact-new') {
                              resetContactEditor();
                              setShowCreateContactModal(true);
                              setContactModalError('');
                            }
                            if (item.id === 'entity-new') {
                              setEditingEntityId('');
                              setEntityModalError('');
                              setGs1CrudSuccess('');
                              setCreatedEntityContactTargetId('');
                              setNextEntityNoPreview('');
                              setNewEntityForm(blankEntityForm());
                            }
                            if (item.key === 'dashboard') {
                              refreshDashboardData();
                            }
                            if (item.key === 'animalList') {
                              setAnimalListDealFilter(null);
                            }
                            setView(item.key);
                            setSidebarOpen(false);
                          };
                          const linkClassName = `admin-menu-link${activeMenuItemId === item.id ? ' is-active' : ''}`;

                          if (item.helpText) {
                            return (
                              <div key={item.id} className="admin-menu-link-row">
                                <button
                                  type="button"
                                  className={`${linkClassName} admin-menu-link-inline`}
                                  onClick={openMenuItem}
                                >
                                  {item.label}
                                  {/* A queue nobody can see is a queue nobody works. */}
                                  {Boolean(item.count) && (
                                    <span className="ml-1.5 inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-red-600 px-1.5 py-0.5 text-[11px] font-semibold leading-none text-white">
                                      {item.count}
                                    </span>
                                  )}
                                </button>
                                <InfoHint text={item.helpText} />
                              </div>
                            );
                          }

                          return (
                            <button
                              key={item.id}
                              type="button"
                              className={linkClassName}
                              onClick={openMenuItem}
                            >
                              {item.label}
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </nav>

          <div className="admin-menu-footer">
            <div className="admin-menu-user-info">
              <div className="admin-menu-avatar">
                {user?.username?.[0]?.toUpperCase() ?? 'A'}
              </div>
              <span className="admin-menu-username">{user?.username ?? 'Admin'}</span>
            </div>
            <button
              className="admin-menu-signout-btn"
              onClick={logout}
              title="Sign out"
              aria-label="Sign out"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M6 14H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3"/>
                <polyline points="10 11 13 8 10 5"/>
                <line x1="13" y1="8" x2="6" y2="8"/>
              </svg>
            </button>
          </div>
        </aside>

        <div className="admin-main grid gap-4 min-w-0 grid-cols-[minmax(0,1fr)]">
          {renderMainContent()}
        </div>
      </div>
      {renderSharedSetPasswordModal()}
      {renderCourierModal()}
    </main>
  );
};
